import { getCurrentInstance as Nl, defineComponent as Y, computed as m, openBlock as i, createElementBlock as g, unref as u, normalizeStyle as Ie, normalizeClass as W, createElementVNode as C, inject as pt, createBlock as R, renderSlot as L, createVNode as j, ref as N, provide as Dt, toRef as Ze, resolveDynamicComponent as Pe, mergeProps as Ke, withCtx as B, createCommentVNode as A, createTextVNode as me, toDisplayString as le, Fragment as he, renderList as De, watch as Se, onBeforeUnmount as ct, useId as ha, toValue as Ne, nextTick as Ye, useModel as vt, mergeModels as Xe, watchEffect as Fl, useSlots as mt, createStaticVNode as Nt, withModifiers as Fe, withKeys as sa, onScopeDispose as Un, withDirectives as ra, vShow as xa, h as na, createSlots as it, onMounted as tt, reactive as Na, onUnmounted as Fa, isRef as xo, normalizeProps as Mt, guardReactiveProps as Kt, Teleport as Eo, Transition as Ra, render as jr, useAttrs as bi, getCurrentScope as Hu, onBeforeUpdate as Nu, shallowReactive as Fu, shallowRef as Ku, vModelText as ki, readonly as Kl, triggerRef as zn, resolveComponent as Yl, isVNode as Yu, Comment as _i, Text as Ci, TransitionGroup as ju, useTemplateRef as Wu, markRaw as Uu } from "vue";
function xi(e) {
  var t, n, a = "";
  if (typeof e == "string" || typeof e == "number") a += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = xi(e[t])) && (a && (a += " "), a += n);
  } else for (n in e) e[n] && (a && (a += " "), a += n);
  return a;
}
function qu() {
  for (var e, t, n = 0, a = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = xi(e)) && (a && (a += " "), a += t);
  return a;
}
const Wr = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Ur = qu, ze = (e, t) => (n) => {
  var a;
  if (t?.variants == null) return Ur(e, n?.class, n?.className);
  const { variants: o, defaultVariants: l } = t, r = Object.keys(o).map((p) => {
    const d = n?.[p], f = l?.[p];
    if (d === null) return null;
    const h = Wr(d) || Wr(f);
    return o[p][h];
  }), c = n && Object.entries(n).reduce((p, d) => {
    let [f, h] = d;
    return h === void 0 || (p[f] = h), p;
  }, {}), s = t == null || (a = t.compoundVariants) === null || a === void 0 ? void 0 : a.reduce((p, d) => {
    let { class: f, className: h, ...$ } = d;
    return Object.entries($).every((y) => {
      let [w, v] = y;
      return Array.isArray(v) ? v.includes({
        ...l,
        ...c
      }[w]) : {
        ...l,
        ...c
      }[w] === v;
    }) ? [
      ...p,
      f,
      h
    ] : p;
  }, []);
  return Ur(e, r, s, n?.class, n?.className);
}, Zu = { closeAlert: "Close alert" }, Gu = { cancel: "Cancel", apply: "Apply", clear: "Clear", save: "Save" }, Xu = { previousMonth: "Previous month", month: "Month", year: "Year", nextMonth: "Next month", confirm: "Confirm", openCalendar: "Open calendar", increaseHour: "Increase hour", decreaseHour: "Decrease hour", increaseMinute: "Increase minute", decreaseMinute: "Decrease minute", hour: "Hour", monthYear: "{month} {year}", minute: "Min", openDatePicker: "Open date picker", closeDatePicker: "Close date picker", months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], weekdaysShort: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"], weekdaysShortSun: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"] }, Qu = { hideSection: "Hide section" }, Ju = { retry: "Retry", chartColor: "Chart color", keyEvents: "Key events", chartSeriesEditor: "Chart series editor", deleteChartSeries: "Delete chart series", fill: "Fill", chartView: "Chart view", line: "Line", smooth: "Smooth", bar: "Bar", viewIcon: "{view} chart", colorSwatch: "Chart color {index}", openKeyEvent: "Open {label} key event from {time}", configureLegendItem: "Configure {label}", noData: "No chart data available" }, ed = { remove: "Remove" }, td = { noDataAvailable: "No data available", expandRow: "Expand row", dragToResize: "Drag to resize", dragToResizeAutoFit: "Drag to resize · double-click to auto-fit", selectionCount: "{count} selected", selectAllCount: "Select all ({count})" }, ad = { select: "Select", selectDate: "Select date", nextDay: "Next day", next7Days: "Next 7 days", next30Days: "Next 30 days", nextYear: "Next year" }, nd = { unsavedChanges: "Unsaved changes", yourChangesWillBeLostIfYouLeave: "Your changes will be lost if you leave.", leaveWithoutSaving: "Leave without saving", stay: "Stay", closeDialog: "Close dialog", resizeDialog: "Resize dialog", confirm: "Confirm", fullscreen: "Fullscreen", exitFullscreen: "Exit fullscreen", saveFailedTitle: "Could not save", saveFailedBody: "Check for warnings or errors and try again." }, od = { selectItems: "Select items", noOptionsFound: "No options found", copyRow: "Copy row", copyRows: "Copy rows", copyRowsCount: "Copy {count} rows" }, ld = { fullRow: "Full row", halfRow: "Half row", thirdOfARow: "Third of a row", quarterOfARow: "Quarter of a row", layoutPresets: "Layout presets", preset: { stack: "One per row", halves: "Two per row", thirds: "Three per row", quarters: "Four per row" }, moveItem: "Move {item}", rowsFor: "Rows for {item}", columnsFor: "Columns for {item}", presetFor: "{preset} for {item}", showItem: "Show {item}", removeItem: "Remove {item}" }, rd = { noItems: "No items", somethingWentWrong: "Something went wrong" }, sd = { previousPage: "Previous page", nextPage: "Next page", range: "{start}-{end} of {total}" }, id = { openMenu: "Open menu" }, cd = { goBack: "Go back", closeSidebar: "Close sidebar" }, ud = { header: "Header", loader: "Loader", toolbar: "Toolbar", body: "Body", footer: "Footer", bottomBar: "BottomBar" }, dd = { loading: "Loading" }, pd = { changeStatus: "Change status" }, fd = { clearAll: "Clear all", addATag: "Add a tag", createOption: '+ Create "{value}"' }, hd = { timezone: "Timezone", selectAll: "Select all", deselectAll: "Deselect all", primeTime: "Prime time", weekdays: "Weekdays", weekends: "Weekends", businessHours: "Business hours", nightHours: "Night hours", utc11SamoaPagoPago: "UTC-11 — Samoa, Pago Pago", utc10HonoluluTahiti: "UTC-10 — Honolulu, Tahiti", utc9AnchorageJuneau: "UTC-9 — Anchorage, Juneau", utc8LosAngelesVancouverSeattle: "UTC-8 — Los Angeles, Vancouver, Seattle", utc7DenverPhoenixCalgary: "UTC-7 — Denver, Phoenix, Calgary", utc6ChicagoDallasMexicoCity: "UTC-6 — Chicago, Dallas, Mexico City", utc5NewYorkTorontoLima: "UTC-5 — New York, Toronto, Lima", utc4HalifaxSantiagoCaracas: "UTC-4 — Halifax, Santiago, Caracas", utc3SOPauloBuenosAiresMontevideo: "UTC-3 — São Paulo, Buenos Aires, Montevideo", utc2MidAtlanticSouthGeorgia: "UTC-2 — Mid-Atlantic, South Georgia", utc1AzoresCapeVerde: "UTC-1 — Azores, Cape Verde", utc0LondonDublinLisbon: "UTC+0 — London, Dublin, Lisbon", utc1ParisBerlinWarsaw: "UTC+1 — Paris, Berlin, Warsaw", utc2HelsinkiTallinnKyiv: "UTC+2 — Helsinki, Tallinn, Kyiv", utc3MoscowIstanbulRiyadh: "UTC+3 — Moscow, Istanbul, Riyadh", utc4DubaiBakuTbilisi: "UTC+4 — Dubai, Baku, Tbilisi", utc5KarachiTashkentIslamabad: "UTC+5 — Karachi, Tashkent, Islamabad", utc530MumbaiDelhiKolkata: "UTC+5:30 — Mumbai, Delhi, Kolkata", utc6DhakaAlmatyOmsk: "UTC+6 — Dhaka, Almaty, Omsk", utc7BangkokJakartaHanoi: "UTC+7 — Bangkok, Jakarta, Hanoi", utc8BeijingSingaporeHongKong: "UTC+8 — Beijing, Singapore, Hong Kong", utc9TokyoSeoulOsaka: "UTC+9 — Tokyo, Seoul, Osaka", utc10SydneyMelbourneBrisbane: "UTC+10 — Sydney, Melbourne, Brisbane", utc11NoumeaHoniaraMagadan: "UTC+11 — Noumea, Honiara, Magadan", utc12AucklandWellingtonSuva: "UTC+12 — Auckland, Wellington, Suva", days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"] }, vd = { delete: "Delete" }, md = { save: "Save" }, gd = { chartSettings: "Chart settings", addChartSeries: "Add chart series", metrics: "Metrics", leftAxis: "Left axis", rightAxis: "Right axis", metric: "Metric", color: "Color", dimension: "Dimension", rendererFailed: "Chart renderer failed" }, yd = { searchSelectedItems: "Search selected items", noSelectedItemsFound: "No selected items found" }, wd = { discardChange: "Discard change", continueEditing: "Continue editing", moreActions: "More actions", columnSettings: "Column Settings", add: "Add", editRow: "Edit row", failedToLoadData: "Failed to load data", noData: "No data", validationErrorPlain: "Validation error", validationErrorForField: "Validation error: {field}", crossFieldSuffix: "{message} (field: {field})", columnPosition: "{column} position", searchColumns: "Search columns", noColumnsFound: "No columns found" }, bd = { leaveAsIsIWillFixItMyself: "Leave as is — I will fix it myself", manualKeepCurrentValue: "Manual: keep current value", useNearestValidValue: "Use nearest valid value", resizeSiblingsProportionally: "Resize siblings proportionally", raiseDirectParent: "Raise direct parent", raiseTopParent: "Raise top parent", useMinimumValues: "Use minimum values", useMaxPossibleValue: "Use max possible value", noValidResolutionOptions: "No valid resolution options", resolutionValue: "Resolution value", value: "Value", preview: "Preview", resolution: "Resolution", matchLeftToRight: "Match left to right", matchRightToLeft: "Match right to left", setSiblingsToAuto: "Set siblings to auto", invalidValueFor: "Invalid value for {column}", fillMissingValues: "Fill missing {column} values", copyColumnTo: "Copy {from} to {to}", copyRightToLeft: "Copy right column to left", copyLeftToRight: "Copy left column to right", clearColumn: "Clear {column}", clearLeftColumn: "Clear left column", clearRightColumn: "Clear right column", resizeChildrenEvenly: "Resize children evenly", setChildrenToAuto: "Set children to auto", forceApply: "Force apply", previewName: "Name", previewBefore: "Before", previewAfter: "After", previewColumnBefore: "{column} before", previewColumnAfter: "{column} after", haltGeneric: "Resolution is required for this edit", hiddenIssues: "+{count} more", childrenTotalExceeds: "{column} children total exceeds {parent}", childrenTotalExceedsValues: "{column} children total {total} exceeds {parent} {parentValue}", sourceBelowChildrenTotal: "{column} source {source} is below current children total {total}", valueRequiredBySibling: "{column} is required because another row has a value", lockedCellsPreventRecalc: "{column} has locked cells that prevent recalculation{row}", modeConflict: "{column} cannot apply this value in the current calculator mode{row}" }, kd = { moveColumn: "Move {column} column", columnVisibility: "{column} visibility" }, _d = { selectPlaceholder: "Select...", searchPlaceholder: "Search...", noResults: "No results found" }, Cd = { label: "Navigation", collapse: "Collapse menu", expand: "Expand menu", pin: "Pin menu", unpin: "Unpin menu" }, xd = { clearValue: "Clear value", notSet: "Not set", empty: "Empty" }, $d = { filter: "Filter", filters: "Filters", clearAll: "Clear all", include: "Include", exclude: "Exclude", selectedCount: "Selected: {count}" }, Sd = { selectAll: "Select all", clear: "Clear", expandAll: "Expand all", collapseAll: "Collapse all", showFlat: "Show flat", showTree: "Show tree", noResults: "No results" }, Md = { scrollToPrevious: "Scroll to previous", scrollToNext: "Scroll to next", scrollUp: "Scroll up", scrollDown: "Scroll down" }, Dd = { moreActions: "More actions" }, Td = { validationHint: "Check the highlighted fields below and try again.", submit: "Submit" }, Bd = { show: "Show results", pause: "Pause filter", back: "Back to filters", fields: "Filter fields", selected: "Selected elements", presets: "Presets", empty: "No selected elements.", search: "Search {field}", clearGroup: "Clear {field}", more: "More ({count})", less: "Less", apply: "Apply filters", invalidRange: "{field}: minimum must not exceed maximum." }, zd = { columnMenu: "Column menu", copyError: "Unable to copy this selection. Select a rectangle or matching rows or columns.", copied: "Selection copied", selectedCount: "Cells selected: {count}", sortAscending: "Sort ascending", sortDescending: "Sort descending", selectColumn: "Select column" }, Ad = {
  alert: Zu,
  common: Gu,
  calendar: Xu,
  card: Qu,
  chart: Ju,
  chip: ed,
  dataTable: td,
  datePicker: ad,
  dialog: nd,
  editableCell: od,
  editableLayout: ld,
  list: rd,
  pagination: sd,
  popover: id,
  sidebar: cd,
  smartLayout: ud,
  spinningLoader: dd,
  statusChanger: pd,
  tagsInput: fd,
  weekScheduler: hd,
  composables: vd,
  features: md,
  smartChart: gd,
  smartControl: yd,
  smartTable: wd,
  smart: bd,
  table: kd,
  select: _d,
  navigationDrawer: Cd,
  smartCell: xd,
  smartFilter: $d,
  treeControl: Sd,
  scroller: Md,
  pageLayout: Dd,
  smartForm: Td,
  smartFilterPanel: Bd,
  tableRange: zd
}, Ld = { closeAlert: "Закрыть уведомление" }, Ed = { cancel: "Отмена", apply: "Применить", clear: "Очистить", save: "Сохранить" }, Id = { previousMonth: "Предыдущий месяц", month: "Месяц", year: "Год", nextMonth: "Следующий месяц", confirm: "Подтвердить", openCalendar: "Открыть календарь", increaseHour: "Увеличить час", decreaseHour: "Уменьшить час", increaseMinute: "Увеличить минуту", decreaseMinute: "Уменьшить минуту", hour: "Час", monthYear: "{month} {year}", minute: "Мин", openDatePicker: "Открыть календарь", closeDatePicker: "Закрыть календарь", months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"], weekdaysShort: ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"], weekdaysShortSun: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"] }, Rd = { hideSection: "Свернуть раздел" }, Pd = { retry: "Повторить", chartColor: "Цвет графика", keyEvents: "Ключевые события", chartSeriesEditor: "Редактор рядов графика", deleteChartSeries: "Удалить ряд графика", fill: "Заливка", chartView: "Вид графика", line: "Линия", smooth: "Сглаженная", bar: "Столбцы", viewIcon: "График: {view}", colorSwatch: "Цвет графика {index}", openKeyEvent: "Открыть ключевое событие {label} от {time}", configureLegendItem: "Настроить {label}", noData: "Нет данных для графика" }, Od = { remove: "Убрать" }, Vd = { noDataAvailable: "Данных нет", expandRow: "Развернуть строку", dragToResize: "Потяните, чтобы изменить ширину", dragToResizeAutoFit: "Потяните, чтобы изменить ширину · двойной клик — по содержимому", selectionCount: "Выбрано: {count}", selectAllCount: "Выбрать все ({count})" }, Hd = { select: "Выбрать", selectDate: "Выберите дату", nextDay: "Следующий день", next7Days: "Ближайшие 7 дней", next30Days: "Ближайшие 30 дней", nextYear: "Следующий год" }, Nd = { unsavedChanges: "Несохранённые изменения", yourChangesWillBeLostIfYouLeave: "Если уйти, изменения будут потеряны.", leaveWithoutSaving: "Уйти без сохранения", stay: "Остаться", closeDialog: "Закрыть диалог", resizeDialog: "Изменить размер диалога", confirm: "Подтвердить", fullscreen: "Во весь экран", exitFullscreen: "Выйти из полноэкранного режима", saveFailedTitle: "Не удалось сохранить", saveFailedBody: "Проверьте предупреждения и ошибки и попробуйте снова." }, Fd = { selectItems: "Выберите элементы", noOptionsFound: "Ничего не найдено", copyRow: "Копировать строку", copyRows: "Копировать строки", copyRowsCount: "Копировать строк: {count}" }, Kd = { fullRow: "Вся строка", halfRow: "Половина строки", thirdOfARow: "Треть строки", quarterOfARow: "Четверть строки", layoutPresets: "Пресеты раскладки", preset: { stack: "По одной в ряд", halves: "По две в ряд", thirds: "По три в ряд", quarters: "По четыре в ряд" }, moveItem: "Переместить {item}", rowsFor: "Строки для {item}", columnsFor: "Колонки для {item}", presetFor: "{preset} для {item}", showItem: "Показать {item}", removeItem: "Убрать {item}" }, Yd = { noItems: "Пусто", somethingWentWrong: "Что-то пошло не так" }, jd = { previousPage: "Предыдущая страница", nextPage: "Следующая страница", range: "{start}-{end} из {total}" }, Wd = { openMenu: "Открыть меню" }, Ud = { goBack: "Назад", closeSidebar: "Закрыть панель" }, qd = { header: "Шапка", loader: "Загрузка", toolbar: "Панель инструментов", body: "Содержимое", footer: "Подвал", bottomBar: "Нижняя панель" }, Zd = { loading: "Загрузка" }, Gd = { changeStatus: "Изменить статус" }, Xd = { clearAll: "Очистить всё", addATag: "Добавить тег", createOption: "+ Создать «{value}»" }, Qd = { timezone: "Часовой пояс", selectAll: "Выбрать всё", deselectAll: "Снять выбор", primeTime: "Прайм-тайм", weekdays: "Будни", weekends: "Выходные", businessHours: "Рабочие часы", nightHours: "Ночные часы", utc11SamoaPagoPago: "UTC-11 — Самоа, Паго-Паго", utc10HonoluluTahiti: "UTC-10 — Гонолулу, Таити", utc9AnchorageJuneau: "UTC-9 — Анкоридж, Джуно", utc8LosAngelesVancouverSeattle: "UTC-8 — Лос-Анджелес, Ванкувер, Сиэтл", utc7DenverPhoenixCalgary: "UTC-7 — Денвер, Финикс, Калгари", utc6ChicagoDallasMexicoCity: "UTC-6 — Чикаго, Даллас, Мехико", utc5NewYorkTorontoLima: "UTC-5 — Нью-Йорк, Торонто, Лима", utc4HalifaxSantiagoCaracas: "UTC-4 — Галифакс, Сантьяго, Каракас", utc3SOPauloBuenosAiresMontevideo: "UTC-3 — Сан-Паулу, Буэнос-Айрес, Монтевидео", utc2MidAtlanticSouthGeorgia: "UTC-2 — Срединная Атлантика, Южная Георгия", utc1AzoresCapeVerde: "UTC-1 — Азорские о-ва, Кабо-Верде", utc0LondonDublinLisbon: "UTC+0 — Лондон, Дублин, Лиссабон", utc1ParisBerlinWarsaw: "UTC+1 — Париж, Берлин, Варшава", utc2HelsinkiTallinnKyiv: "UTC+2 — Хельсинки, Таллин, Киев", utc3MoscowIstanbulRiyadh: "UTC+3 — Москва, Стамбул, Эр-Рияд", utc4DubaiBakuTbilisi: "UTC+4 — Дубай, Баку, Тбилиси", utc5KarachiTashkentIslamabad: "UTC+5 — Карачи, Ташкент, Исламабад", utc530MumbaiDelhiKolkata: "UTC+5:30 — Мумбаи, Дели, Калькутта", utc6DhakaAlmatyOmsk: "UTC+6 — Дакка, Алматы, Омск", utc7BangkokJakartaHanoi: "UTC+7 — Бангкок, Джакарта, Ханой", utc8BeijingSingaporeHongKong: "UTC+8 — Пекин, Сингапур, Гонконг", utc9TokyoSeoulOsaka: "UTC+9 — Токио, Сеул, Осака", utc10SydneyMelbourneBrisbane: "UTC+10 — Сидней, Мельбурн, Брисбен", utc11NoumeaHoniaraMagadan: "UTC+11 — Нумеа, Хониара, Магадан", utc12AucklandWellingtonSuva: "UTC+12 — Окленд, Веллингтон, Сува", days: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"], daysShort: ["Вс", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"] }, Jd = { delete: "Удалить" }, e1 = { save: "Сохранить" }, t1 = { chartSettings: "Настройки графика", addChartSeries: "Добавить ряд", metrics: "Метрики", leftAxis: "Левая ось", rightAxis: "Правая ось", metric: "Метрика", color: "Цвет", dimension: "Измерение", rendererFailed: "Не удалось построить график" }, a1 = { searchSelectedItems: "Поиск по выбранному", noSelectedItemsFound: "Среди выбранного ничего не найдено" }, n1 = { discardChange: "Отменить изменение", continueEditing: "Продолжить редактирование", moreActions: "Ещё действия", columnSettings: "Настройки колонок", add: "Добавить", editRow: "Редактировать строку", failedToLoadData: "Не удалось загрузить данные", noData: "Данных нет", validationErrorPlain: "Ошибка проверки", validationErrorForField: "Ошибка проверки: {field}", crossFieldSuffix: "{message} (поле: {field})", columnPosition: "Позиция колонки {column}", searchColumns: "Поиск по колонкам", noColumnsFound: "Колонки не найдены" }, o1 = { leaveAsIsIWillFixItMyself: "Оставить как есть — исправлю сам", manualKeepCurrentValue: "Вручную: оставить текущее значение", useNearestValidValue: "Взять ближайшее допустимое значение", resizeSiblingsProportionally: "Пропорционально пересчитать соседние", raiseDirectParent: "Поднять прямого родителя", raiseTopParent: "Поднять верхнего родителя", useMinimumValues: "Взять минимальные значения", useMaxPossibleValue: "Взять максимально возможное значение", noValidResolutionOptions: "Подходящих вариантов нет", resolutionValue: "Значение разрешения", value: "Значение", preview: "Превью", resolution: "Разрешение", matchLeftToRight: "Выровнять слева направо", matchRightToLeft: "Выровнять справа налево", setSiblingsToAuto: "Соседние — в авто", invalidValueFor: "Некорректное значение в «{column}»", fillMissingValues: "Заполнить пропуски в «{column}»", copyColumnTo: "Скопировать «{from}» в «{to}»", copyRightToLeft: "Скопировать правую колонку в левую", copyLeftToRight: "Скопировать левую колонку в правую", clearColumn: "Очистить «{column}»", clearLeftColumn: "Очистить левую колонку", clearRightColumn: "Очистить правую колонку", resizeChildrenEvenly: "Распределить по дочерним поровну", setChildrenToAuto: "Дочерним значение «авто»", forceApply: "Применить принудительно", previewName: "Название", previewBefore: "Было", previewAfter: "Стало", previewColumnBefore: "«{column}» до", previewColumnAfter: "«{column}» после", haltGeneric: "Для этого изменения нужно разрешить конфликт", hiddenIssues: "ещё {count}", childrenTotalExceeds: "«{column}»: сумма по дочерним превышает «{parent}»", childrenTotalExceedsValues: "«{column}»: сумма по дочерним {total} превышает «{parent}» {parentValue}", sourceBelowChildrenTotal: "«{column}»: исходное значение {source} меньше текущей суммы по дочерним {total}", valueRequiredBySibling: "«{column}» обязательно: в другой строке значение заполнено", lockedCellsPreventRecalc: "«{column}»: есть закреплённые ячейки, пересчёт невозможен{row}", modeConflict: "«{column}»: это значение нельзя применить в текущем режиме калькулятора{row}" }, l1 = { moveColumn: "Переместить колонку «{column}»", columnVisibility: "Видимость колонки «{column}»" }, r1 = { selectPlaceholder: "Выберите…", searchPlaceholder: "Поиск…", noResults: "Ничего не найдено" }, s1 = { label: "Навигация", collapse: "Свернуть меню", expand: "Раскрыть меню", pin: "Закрепить меню", unpin: "Открепить меню" }, i1 = { clearValue: "Очистить значение", notSet: "Не задано", empty: "Пусто" }, c1 = { filter: "Фильтр", filters: "Фильтры", clearAll: "Очистить всё", include: "Включить", exclude: "Исключить", selectedCount: "Выбрано: {count}" }, u1 = { selectAll: "Выбрать всё", clear: "Очистить", expandAll: "Развернуть всё", collapseAll: "Свернуть всё", showFlat: "Списком", showTree: "Деревом", noResults: "Ничего не найдено" }, d1 = { scrollToPrevious: "К предыдущему", scrollToNext: "К следующему", scrollUp: "Вверх", scrollDown: "Вниз" }, p1 = { moreActions: "Ещё действия" }, f1 = { validationHint: "Проверьте выделенные поля ниже и попробуйте снова.", submit: "Отправить" }, h1 = { show: "Показывать результаты", pause: "Приостановить фильтр", back: "Назад к фильтрам", fields: "Поля фильтра", selected: "Выбранные элементы", presets: "Пресеты", empty: "Нет выбранных элементов.", search: "Поиск: {field}", clearGroup: "Очистить {field}", more: "Ещё ({count})", less: "Свернуть", apply: "Применить фильтры", invalidRange: "{field}: минимум не должен превышать максимум." }, v1 = { columnMenu: "Меню колонки", copyError: "Не удалось скопировать выделение. Выберите прямоугольник либо строки или колонки с одинаковыми границами.", copied: "Выделение скопировано", selectedCount: "Выделено ячеек: {count}", sortAscending: "По возрастанию", sortDescending: "По убыванию", selectColumn: "Выделить колонку" }, m1 = {
  alert: Ld,
  common: Ed,
  calendar: Id,
  card: Rd,
  chart: Pd,
  chip: Od,
  dataTable: Vd,
  datePicker: Hd,
  dialog: Nd,
  editableCell: Fd,
  editableLayout: Kd,
  list: Yd,
  pagination: jd,
  popover: Wd,
  sidebar: Ud,
  smartLayout: qd,
  spinningLoader: Zd,
  statusChanger: Gd,
  tagsInput: Xd,
  weekScheduler: Qd,
  composables: Jd,
  features: e1,
  smartChart: t1,
  smartControl: a1,
  smartTable: n1,
  smart: o1,
  table: l1,
  select: r1,
  navigationDrawer: s1,
  smartCell: i1,
  smartFilter: c1,
  treeControl: u1,
  scroller: d1,
  pageLayout: p1,
  smartForm: f1,
  smartFilterPanel: h1,
  tableRange: v1
}, eM = { en: Ad, ru: m1 }, qr = (e, t) => t === void 0 ? e : e.replace(/\{(\w+)\}/g, (n, a) => a in t ? String(t[a]) : n);
let $i;
const tM = (e) => {
  $i = e;
}, Le = () => {
  const e = Nl()?.appContext.config.globalProperties.$t, t = typeof e == "function" ? e : void 0;
  return (n, a, o) => {
    const l = t ?? $i;
    if (l === void 0)
      return qr(a, o);
    const r = l(n, o ?? {});
    return r === n ? qr(a, o) : r;
  };
}, g1 = ze("hp-spinning-loader", {
  variants: {
    size: {
      1: "hp-spinning-loader--size-1",
      2: "hp-spinning-loader--size-2",
      3: "hp-spinning-loader--size-3",
      4: "hp-spinning-loader--size-4",
      5: "hp-spinning-loader--size-5"
    }
  },
  defaultVariants: {
    size: "2"
  }
}), y1 = ["data-theme", "aria-label"], Io = /* @__PURE__ */ Y({
  __name: "SpinningLoader",
  props: {
    size: { default: "2" },
    customSize: { default: void 0 },
    color: { default: void 0 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = Le(), n = e, a = m(
      () => g1({
        size: n.size,
        class: n.class
      })
    ), o = m(() => {
      if (n.customSize === void 0)
        return;
      const l = typeof n.customSize == "number" ? `${n.customSize}px` : n.customSize;
      return { width: l, height: l };
    });
    return (l, r) => (i(), g("svg", {
      class: W(a.value),
      style: Ie(o.value),
      "data-theme": e.color,
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      role: "status",
      "aria-label": u(t)("ui.spinningLoader.loading", "Loading")
    }, [...r[0] || (r[0] = [
      C("circle", {
        class: "hp-spinning-loader__circle",
        cx: "10",
        cy: "10",
        r: "8",
        stroke: "currentColor",
        "stroke-linecap": "round"
      }, null, -1)
    ])], 14, y1));
  }
}), jl = /* @__PURE__ */ Symbol("hp-button-context"), Pa = /* @__PURE__ */ Y({
  __name: "ButtonPrefix",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = pt(jl, null), a = m(() => n?.loading.value ?? !1), o = m(() => n?.loaderSize.value ?? "2"), l = ze(["hp-button__icon", "hp-button__prefix"]), r = m(() => l({ class: t.class }));
    return (c, s) => (i(), g("span", {
      class: W(r.value)
    }, [
      a.value ? (i(), R(Io, {
        key: 0,
        size: o.value
      }, null, 8, ["size"])) : L(c.$slots, "default", { key: 1 })
    ], 2));
  }
}), w1 = /* @__PURE__ */ Y({
  __name: "ButtonSpinner",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = pt(jl, null), a = m(() => n?.loaderSize.value ?? "2"), o = ze(["hp-button__icon", "hp-button__suffix", "hp-button__icon--spinner"]), l = m(() => o({ class: t.class }));
    return (r, c) => (i(), g("span", {
      class: W(l.value)
    }, [
      j(Io, { size: a.value }, null, 8, ["size"])
    ], 2));
  }
}), b1 = /* @__PURE__ */ Y({
  __name: "ButtonSuffix",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = ze(["hp-button__icon", "hp-button__suffix"]), a = m(() => n({ class: t.class }));
    return (o, l) => (i(), g("span", {
      class: W(a.value)
    }, [
      L(o.$slots, "default")
    ], 2));
  }
}), Ae = /* @__PURE__ */ Y({
  inheritAttrs: !1,
  __name: "Button",
  props: {
    as: { default: "button" },
    type: { default: "button" },
    variant: { default: "filled" },
    color: { default: void 0 },
    size: { default: "5" },
    prefix: { default: void 0 },
    suffix: { default: void 0 },
    icon: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    square: { type: Boolean, default: !1 },
    radius: { default: void 0 },
    class: { default: void 0 }
  },
  setup(e, { expose: t }) {
    const n = e, a = N(null), o = m(() => n.prefix ?? n.icon), l = ze("hp-button", {
      variants: {
        variant: {
          filled: "hp-button--filled",
          soft: "hp-button--soft",
          outline: "hp-button--outline",
          surface: "hp-button--surface",
          "soft-outlined": "hp-button--soft-outlined",
          "on-filled": "hp-button--on-filled",
          blank: "hp-button--blank"
        },
        size: {
          1: "hp-button--size-1 hp-icon--size-2",
          2: "hp-button--size-2 hp-icon--size-2",
          3: "hp-button--size-3 hp-icon--size-2",
          4: "hp-button--size-4 hp-icon--size-3",
          5: "hp-button--size-5 hp-icon--size-3"
        },
        disabled: { true: "hp-button--disabled" },
        loading: { true: "hp-button--loading" },
        square: { true: "hp-button--square" },
        radius: {
          none: "hp-button--radius-none",
          small: "hp-button--radius-small",
          big: "hp-button--radius-big",
          full: "hp-button--radius-full"
        }
      },
      defaultVariants: { variant: "filled", size: "5" }
    }), r = m(
      () => l({
        variant: n.variant,
        size: n.size,
        disabled: n.disabled,
        loading: n.loading,
        square: n.square,
        radius: n.radius,
        class: n.class
      })
    ), c = m(
      () => n.size === "4" || n.size === "5" ? "3" : "2"
    );
    return Dt(jl, {
      loading: Ze(n, "loading"),
      loaderSize: c,
      size: Ze(n, "size")
    }), t({ buttonRef: a }), (s, p) => (i(), R(Pe(e.as), Ke({
      ref_key: "buttonRef",
      ref: a,
      class: r.value,
      "data-theme": e.color,
      disabled: e.disabled || e.loading,
      type: e.type,
      "aria-busy": e.loading
    }, s.$attrs), {
      default: B(() => [
        o.value ? (i(), R(Pa, { key: 0 }, {
          default: B(() => [
            (i(), R(Pe(o.value)))
          ]),
          _: 1
        })) : A("", !0),
        L(s.$slots, "default"),
        e.suffix ? (i(), R(b1, { key: 1 }, {
          default: B(() => [
            (i(), R(Pe(e.suffix)))
          ]),
          _: 1
        })) : A("", !0),
        e.loading && !o.value && !e.suffix ? (i(), R(w1, { key: 2 })) : A("", !0)
      ]),
      _: 3
    }, 16, ["class", "data-theme", "disabled", "type", "aria-busy"]));
  }
}), $a = /* @__PURE__ */ Y({
  __name: "ButtonText",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = ze("hp-button__text"), a = m(() => n({ class: t.class }));
    return (o, l) => (i(), g("span", {
      class: W(a.value)
    }, [
      L(o.$slots, "default")
    ], 2));
  }
}), se = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [a, o] of t)
    n[a] = o;
  return n;
}, k1 = {}, _1 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function C1(e, t) {
  return i(), g("svg", _1, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M5 5L15 15",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M15 5L5 15",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const zt = /* @__PURE__ */ se(k1, [["render", C1]]), Si = /* @__PURE__ */ Symbol("hp-alert-size"), Wl = ze("", {
  variants: {
    size: {
      1: "hp-fs-1",
      2: "hp-fs-2",
      3: "hp-fs-3",
      4: "hp-fs-4",
      5: "hp-fs-5",
      6: "hp-fs-6",
      7: "hp-fs-7",
      8: "hp-fs-8",
      9: "hp-fs-9",
      10: "hp-fs-10"
    },
    weight: {
      normal: "hp-fw-normal",
      medium: "hp-fw-medium",
      semibold: "hp-fw-semibold",
      bold: "hp-fw-bold"
    },
    variant: {
      surface: "hp-color-surface",
      medium: "hp-color-medium",
      soft: "hp-color-soft",
      accent: "hp-color-accent",
      contrast: "hp-color-contrast",
      inherit: "hp-color-inherit"
    },
    font: {
      base: "hp-ff-base",
      mono: "hp-ff-mono"
    },
    lineHeight: {
      1: "hp-lh-1",
      2: "hp-lh-2",
      3: "hp-lh-3",
      4: "hp-lh-4",
      5: "hp-lh-5",
      6: "hp-lh-6",
      7: "hp-lh-7"
    },
    align: {
      left: "hp-ta-left",
      center: "hp-ta-center",
      right: "hp-ta-right"
    },
    wrap: {
      pretty: "hp-wrap-pretty",
      balance: "hp-wrap-balance",
      nowrap: "hp-wrap-nowrap"
    },
    truncate: {
      true: "hp-truncate",
      false: ""
    },
    cursor: {
      pointer: "hp-cursor-pointer",
      default: "hp-cursor-default",
      "not-allowed": "hp-cursor-not-allowed"
    },
    link: {
      true: "hp-link",
      false: ""
    },
    linkColor: {
      accent: "",
      inherit: "hp-link--inherit"
    }
  }
}), $n = /* @__PURE__ */ Y({
  __name: "Heading",
  props: {
    as: {},
    size: { default: "7" },
    weight: { default: "bold" },
    variant: { default: "inherit" },
    color: {},
    font: {},
    truncate: { type: Boolean, default: !1 },
    align: {},
    wrap: {},
    lineHeight: {},
    cursor: {},
    class: {}
  },
  setup(e) {
    const t = e, n = {
      10: "h1",
      9: "h1",
      8: "h2",
      7: "h2",
      6: "h3",
      5: "h4",
      4: "h5",
      3: "h6",
      2: "h6",
      1: "h6"
    }, a = m(() => t.as ?? n[t.size ?? "7"]), o = m(() => [
      Wl({
        size: t.size,
        weight: t.weight,
        variant: t.variant,
        font: t.font,
        lineHeight: t.lineHeight,
        align: t.align,
        wrap: t.wrap,
        truncate: t.truncate,
        cursor: t.cursor
      }),
      t.class
    ]);
    return (l, r) => (i(), R(Pe(a.value), {
      class: W(o.value),
      "data-theme": e.color
    }, {
      default: B(() => [
        L(l.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "data-theme"]));
  }
}), at = /* @__PURE__ */ Y({
  __name: "Text",
  props: {
    as: { default: "span" },
    size: {},
    weight: {},
    variant: {},
    color: {},
    font: {},
    truncate: { type: Boolean, default: !1 },
    align: {},
    wrap: {},
    lineHeight: {},
    cursor: {},
    link: { type: Boolean },
    linkColor: {},
    class: {}
  },
  setup(e) {
    const t = e, n = m(() => [
      Wl({
        size: t.size,
        weight: t.weight,
        variant: t.variant,
        font: t.font,
        lineHeight: t.lineHeight,
        align: t.align,
        wrap: t.wrap,
        truncate: t.truncate,
        cursor: t.cursor,
        link: t.link,
        linkColor: t.link ? t.linkColor : void 0
      }),
      t.class
    ]);
    return (a, o) => (i(), R(Pe(t.as), {
      class: W(n.value),
      "data-theme": e.color
    }, {
      default: B(() => [
        L(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "data-theme"]));
  }
}), x1 = /* @__PURE__ */ Y({
  __name: "AlertDescription",
  setup(e) {
    return (t, n) => (i(), R(u(at), {
      as: "p",
      size: "3",
      class: "hp-alert__description"
    }, {
      default: B(() => [
        L(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Mi = /* @__PURE__ */ Y({
  __name: "AlertTitle",
  setup(e) {
    const t = pt(Si, N("3")), n = m(() => ({ 1: "2", 2: "3", 3: "5" })[t.value ?? "3"]);
    return (a, o) => (i(), R(u(at), {
      as: "p",
      size: n.value,
      weight: "medium",
      class: "hp-alert__title"
    }, {
      default: B(() => [
        L(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["size"]));
  }
}), $1 = ["data-theme"], S1 = {
  key: 0,
  class: "hp-alert__icon-wrapper"
}, M1 = { class: "hp-alert__icon" }, D1 = { class: "hp-alert__content" }, T1 = {
  key: 1,
  class: "hp-alert__actions"
}, qn = /* @__PURE__ */ Y({
  __name: "Alert",
  props: {
    size: { default: "2" },
    variant: { default: "filled" },
    color: { default: void 0 },
    title: { default: "" },
    description: { default: "" },
    showIcon: { type: Boolean, default: !0 },
    icon: { default: void 0 },
    showClose: { type: Boolean, default: !0 },
    shadow: { type: Boolean, default: !1 },
    radius: { default: void 0 },
    class: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = Le(), a = e, o = t;
    Dt(
      Si,
      m(() => a.size ?? "3")
    );
    const l = ze("hp-alert", {
      variants: {
        variant: {
          filled: "hp-alert--filled",
          soft: "hp-alert--soft",
          outline: "hp-alert--outline",
          surface: "hp-alert--surface",
          "soft-outlined": "hp-alert--soft-outlined",
          blank: "hp-alert--blank"
        },
        size: {
          1: "hp-alert--size-1",
          2: "hp-alert--size-2",
          3: "hp-alert--size-3"
        },
        shadow: {
          true: "hp-alert--shadow",
          false: ""
        },
        radius: {
          none: "hp-alert--radius-none",
          small: "hp-alert--radius-small",
          big: "hp-alert--radius-big",
          full: "hp-alert--radius-full"
        },
        hasIcon: {
          true: "",
          false: "hp-alert--no-icon"
        }
      },
      defaultVariants: {
        variant: "filled",
        size: "3",
        shadow: !1,
        hasIcon: !0
      }
    }), r = m(() => [
      l({
        variant: a.variant,
        size: a.size,
        shadow: a.shadow,
        radius: a.radius,
        hasIcon: a.showIcon
      }),
      a.class
    ]), c = m(() => a.variant === "filled" ? "filled" : "soft"), s = () => {
      o("close");
    };
    return (p, d) => (i(), g("div", {
      class: W(r.value),
      "data-theme": e.color,
      role: "alert"
    }, [
      e.showIcon ? (i(), g("div", S1, [
        C("div", M1, [
          e.icon ? (i(), R(Pe(e.icon), { key: 0 })) : (i(), R(zt, { key: 1 }))
        ])
      ])) : A("", !0),
      C("div", D1, [
        e.title ? (i(), R(Mi, { key: 0 }, {
          default: B(() => [
            me(le(e.title), 1)
          ]),
          _: 1
        })) : A("", !0),
        e.description && e.size === "3" ? (i(), R(x1, { key: 1 }, {
          default: B(() => [
            me(le(e.description), 1)
          ]),
          _: 1
        })) : A("", !0),
        L(p.$slots, "default")
      ]),
      p.$slots.actions ? (i(), g("div", T1, [
        L(p.$slots, "actions")
      ])) : A("", !0),
      e.showClose ? (i(), R(u(Ae), {
        key: 2,
        variant: c.value,
        size: "1",
        square: "",
        icon: zt,
        class: "hp-alert__close",
        "aria-label": u(n)("ui.alert.closeAlert", "Close alert"),
        onClick: s
      }, null, 8, ["variant", "aria-label"])) : A("", !0)
    ], 10, $1));
  }
}), B1 = {}, z1 = { class: "hp-alert__actions" };
function A1(e, t) {
  return i(), g("div", z1, [
    L(e.$slots, "default")
  ]);
}
const L1 = /* @__PURE__ */ se(B1, [["render", A1]]), aM = /* @__PURE__ */ Y({
  __name: "AlphabetIndex",
  props: {
    modelValue: {},
    available: {},
    includeNumeric: { type: Boolean, default: !0 },
    availableOnly: { type: Boolean },
    orientation: { default: "horizontal" },
    size: {},
    variant: {},
    activeVariant: {},
    color: {},
    activeColor: {},
    availableColor: {},
    radius: {},
    scrollTarget: { default: void 0 },
    class: {}
  },
  emits: ["update:modelValue", "select"],
  setup(e, { emit: t }) {
    const n = [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z"
    ], a = e, o = t, l = m(
      () => a.includeNumeric ? ["#", ...n] : [...n]
    ), r = m(() => a.available == null ? null : a.available instanceof Set ? a.available : new Set(a.available)), c = m(() => a.availableOnly && r.value ? l.value.filter((y) => r.value.has(y)) : l.value), s = m(() => [
      "hp-alphabet-index",
      `hp-alphabet-index--${a.orientation ?? "horizontal"}`,
      a.class
    ]), p = (y) => {
      const w = r.value;
      return w == null || w.has(y);
    }, d = (y) => y === a.modelValue && a.activeColor ? a.activeColor : a.availableColor && p(y) ? a.availableColor : a.color, f = () => {
      const y = a.scrollTarget;
      return y ? y instanceof HTMLElement ? y : y?.$el ?? null : null;
    }, h = (y) => {
      const w = f();
      if (!w)
        return;
      const v = w.querySelector(`[data-letter="${y}"]`);
      if (!v)
        return;
      const x = v.getBoundingClientRect().top - w.getBoundingClientRect().top + w.scrollTop;
      w.scrollTo({ top: x, behavior: "instant" });
    }, $ = (y, w) => {
      p(y) && (o("update:modelValue", y), o("select", y, w), h(y));
    };
    return (y, w) => (i(), g("div", {
      class: W(s.value)
    }, [
      (i(!0), g(he, null, De(c.value, (v) => (i(), R(u(Ae), {
        key: v,
        size: a.size ?? "1",
        variant: v === a.modelValue ? a.activeVariant ?? "soft" : a.variant ?? "blank",
        color: d(v),
        square: "",
        radius: a.radius ?? "full",
        disabled: !p(v),
        onClick: (x) => $(v, x)
      }, {
        default: B(() => [
          j(u($a), null, {
            default: B(() => [
              me(le(v), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1032, ["size", "variant", "color", "radius", "disabled", "onClick"]))), 128))
    ], 2));
  }
}), Di = /* @__PURE__ */ Symbol("Anchor"), Ti = () => {
  const e = pt(Di);
  if (!e)
    throw new Error("Anchor compound components must be used within <Anchor>");
  return e;
}, E1 = (e, t) => {
  const n = Number(e.dataset.anchorOrder || 0), a = document.querySelectorAll("[popover]:popover-open");
  for (const o of a)
    if (Number(o.dataset.anchorOrder || 0) > n && o.contains(t))
      return !0;
  return !1;
}, Ul = (e) => {
  const t = e.closeOnClickOutside ?? !0, n = e.closeOnEscape ?? !0, a = e.ignoreAnchorClicks ?? !0, o = () => {
    e.close(), e.onClose?.();
  }, l = (s) => {
    const p = e.contentRef.value;
    if (!p)
      return;
    const d = s.composedPath()[0];
    if (d && !(a && e.anchorRef.value?.contains(d)) && !p.contains(d) && !E1(p, d)) {
      s.stopPropagation(), s.preventDefault();
      try {
        p.hidePopover();
      } catch {
      }
      o();
    }
  }, r = (s) => {
    n && s.key === "Escape" && (s.preventDefault(), o());
  }, c = () => {
    window.removeEventListener("pointerdown", l, !0), window.removeEventListener("keydown", r);
  };
  Se(e.isOpen, (s) => {
    s ? requestAnimationFrame(() => {
      c(), t && window.addEventListener("pointerdown", l, !0), window.addEventListener("keydown", r);
    }) : c();
  }), ct(() => {
    c();
  });
}, I1 = 200, R1 = 100, Bi = (e) => {
  const t = e.showDelay ?? I1, n = e.hideDelay ?? R1;
  let a, o;
  const l = () => {
    a !== void 0 && (clearTimeout(a), a = void 0), o !== void 0 && (clearTimeout(o), o = void 0);
  }, r = () => {
    l(), a = setTimeout(() => {
      e.open();
    }, t);
  }, c = () => {
    a !== void 0 && (clearTimeout(a), a = void 0), o = setTimeout(() => {
      e.close();
    }, n);
  }, s = () => {
    o !== void 0 && (clearTimeout(o), o = void 0);
  }, p = () => {
    r();
  }, d = () => {
    c();
  }, f = () => {
    r();
  }, h = () => {
    c();
  }, $ = () => {
    l(), e.close();
  }, y = () => {
    s();
  }, w = () => {
    e.close();
  };
  return ct(() => {
    l();
  }), {
    onTriggerMouseEnter: p,
    onTriggerMouseLeave: d,
    onTriggerFocus: f,
    onTriggerBlur: h,
    onTriggerClick: $,
    onContentMouseEnter: y,
    onContentMouseLeave: w
  };
}, ql = (e) => {
  if (getComputedStyle(e).display === "contents") {
    const t = e.firstElementChild;
    if (t instanceof HTMLElement)
      return ql(t);
  }
  return e;
};
let P1 = 0;
const _l = /* @__PURE__ */ new Set(), O1 = (e) => {
  for (const t of _l)
    e && t.content.contains(e) || t.close();
}, zi = (e) => {
  const t = String(ha()).replace(/:/g, "-"), n = `--anchor-${t}`, a = `anchor-content-${t}`, o = N(null), l = N(null), r = e.isOpen ?? N(!1), c = e.placement ?? "bottom-start", s = () => {
    r.value = !0;
  }, p = () => {
    r.value = !1;
  }, d = () => {
    r.value = !r.value;
  }, f = m(() => {
    const b = ["hp-anchor", `hp-anchor--${e.type}`];
    return e.variant && b.push(`hp-anchor--${e.variant}`), e.matchWidth && b.push("hp-anchor--match-width"), b.join(" ");
  }), h = e.type === "popover" || e.type === "menu";
  let $ = null, y = null;
  const w = () => {
    $ && (_l.delete($), $ = null);
  }, v = (b, k) => {
    h && (w(), O1(k)), k && ql(k).style.setProperty("anchor-name", n), b.style.setProperty("position-anchor", n), b.dataset.placement = Ne(c), b.dataset.anchorOrder = String(++P1), b.id = a;
    try {
      b.showPopover();
    } catch {
    }
    y = b, h && ($ = { type: e.type, content: b, close: p }, _l.add($));
  }, x = () => {
    w(), y = null;
    try {
      l.value?.hidePopover();
    } catch {
    }
  };
  return Se(r, (b) => {
    if (b) {
      const k = l.value;
      if (k === null || k === y)
        return;
      v(k, o.value);
    } else
      x();
  }), Se(l, (b) => {
    b !== null && r.value && b !== y && v(b, o.value);
  }), ct(() => {
    w();
    try {
      l.value?.hidePopover();
    } catch {
    }
  }), {
    anchorRef: o,
    contentRef: l,
    contentId: a,
    isOpen: r,
    open: s,
    close: p,
    toggle: d,
    contentClass: f
  };
}, Zl = (e) => {
  let t = null;
  const n = Se(e, (a) => {
    if (a)
      t = document.activeElement;
    else if (t) {
      const o = t;
      t = null, requestAnimationFrame(() => o.focus());
    }
  });
  ct(() => {
    n(), t = null;
  });
}, Cl = [
  'input:not([disabled]):not([type="hidden"])',
  "textarea:not([disabled])",
  "select:not([disabled])",
  "button:not([disabled])",
  '[tabindex]:not([tabindex="-1"])',
  "a[href]"
].join(", "), V1 = (e) => Array.from(e.querySelectorAll(Cl)), Gl = (e, t, n) => {
  let a;
  const o = () => !n || n.value, l = (s) => {
    if (!o() || s.key !== "Tab")
      return;
    const p = e.value;
    if (!p)
      return;
    const d = V1(p);
    if (d.length === 0) {
      s.preventDefault();
      return;
    }
    const f = d[0], h = d[d.length - 1], $ = document.activeElement, [y, w] = s.shiftKey ? [f, h] : [h, f];
    ($ === y || !p.contains($)) && (s.preventDefault(), w.focus());
  }, r = () => {
    if (!o())
      return;
    const s = e.value;
    if (!s)
      return;
    const p = s.querySelector("[data-autofocus]");
    if (p) {
      const d = p.matches(Cl) ? p : p.querySelector(Cl);
      if (d) {
        d.focus();
        return;
      }
    }
    s.focus();
  }, c = Se(t, async (s) => {
    s ? (await Ye(), a = requestAnimationFrame(() => r()), document.addEventListener("keydown", l)) : document.removeEventListener("keydown", l);
  });
  ct(() => {
    c(), a !== void 0 && cancelAnimationFrame(a), document.removeEventListener("keydown", l);
  });
}, Xt = /* @__PURE__ */ Y({
  __name: "Anchor",
  props: /* @__PURE__ */ Xe({
    type: {},
    variant: { default: void 0 },
    placement: { default: void 0 },
    matchWidth: { type: Boolean, default: !1 },
    closeOnClickOutside: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    ignoreAnchorClicks: { type: Boolean, default: !0 },
    focusTrap: { type: Boolean, default: void 0 },
    focusReturn: { type: Boolean, default: void 0 },
    showDelay: { default: 200 },
    hideDelay: { default: 100 }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["close"], ["update:open"]),
  setup(e, { expose: t, emit: n }) {
    const a = e, o = n, l = vt(e, "open"), r = a.type === "tooltip", c = a.type === "menu", s = a.focusTrap ?? !r, p = a.focusReturn ?? !r, d = a.variant ?? (r ? void 0 : "surface"), f = a.placement ?? (c ? "bottom-end" : "bottom-start"), h = zi({
      type: a.type,
      variant: d,
      placement: f,
      isOpen: l,
      matchWidth: a.matchWidth
    });
    r || Ul({
      contentRef: h.contentRef,
      anchorRef: h.anchorRef,
      isOpen: h.isOpen,
      close: h.close,
      onClose: () => o("close"),
      closeOnClickOutside: a.closeOnClickOutside,
      closeOnEscape: a.closeOnEscape,
      ignoreAnchorClicks: a.ignoreAnchorClicks
    }), s && Gl(h.contentRef, h.isOpen), p && Zl(h.isOpen);
    const $ = r ? Bi({
      triggerRef: h.anchorRef,
      contentRef: h.contentRef,
      isOpen: h.isOpen,
      open: h.open,
      close: h.close,
      showDelay: a.showDelay,
      hideDelay: a.hideDelay
    }) : void 0;
    return Dt(Di, {
      type: a.type,
      variant: d,
      placement: f,
      focusTrap: s,
      contentClass: h.contentClass,
      contentId: h.contentId,
      anchorRef: h.anchorRef,
      contentRef: h.contentRef,
      isOpen: h.isOpen,
      open: h.open,
      close: h.close,
      toggle: h.toggle,
      tooltipEvents: $
    }), t({
      open: h.open,
      close: h.close,
      toggle: h.toggle
    }), (y, w) => L(y.$slots, "default");
  }
}), H1 = ze("", {
  variants: {
    display: {
      block: "",
      flex: "hp-anchor--display-flex",
      grid: "hp-anchor--display-grid"
    }
  },
  defaultVariants: {
    display: "block"
  }
}), N1 = ["id", "role", "aria-modal"], Qt = /* @__PURE__ */ Y({
  __name: "AnchorContent",
  props: {
    class: { default: void 0 },
    style: { type: [Boolean, null, String, Object, Array], default: void 0 },
    lazy: { type: Boolean, default: !0 },
    display: { default: "block" }
  },
  setup(e) {
    const t = e, n = Ti(), a = n.type === "tooltip", o = N(null);
    return Fl(() => {
      n.contentRef.value = o.value;
    }), (l, r) => (i(), g("div", Ke({
      ref_key: "contentEl",
      ref: o,
      id: u(n).contentId,
      popover: "manual",
      class: [u(n).contentClass.value, u(H1)({ display: t.display }), t.class],
      style: t.style,
      role: a ? "tooltip" : "dialog",
      "aria-modal": u(n).focusTrap ? "true" : void 0
    }, a && u(n).tooltipEvents ? {
      onMouseenter: u(n).tooltipEvents.onContentMouseEnter,
      onMouseleave: u(n).tooltipEvents.onContentMouseLeave
    } : {}), [
      !t.lazy || u(n).isOpen.value ? L(l.$slots, "default", { key: 0 }) : A("", !0)
    ], 16, N1));
  }
}), F1 = ["aria-describedby"], Jt = /* @__PURE__ */ Y({
  __name: "AnchorTrigger",
  setup(e) {
    const t = Ti(), n = t.type === "tooltip", a = N(null);
    Fl(() => {
      t.anchorRef.value = a.value;
    });
    const o = m(
      () => n && t.isOpen.value ? t.contentId : void 0
    );
    return (l, r) => (i(), g("span", Ke({
      ref_key: "triggerEl",
      ref: a,
      class: "hp-anchor-trigger",
      "aria-describedby": o.value
    }, n && u(t).tooltipEvents ? {
      onMouseenter: u(t).tooltipEvents.onTriggerMouseEnter,
      onMouseleave: u(t).tooltipEvents.onTriggerMouseLeave,
      onFocus: u(t).tooltipEvents.onTriggerFocus,
      onBlur: u(t).tooltipEvents.onTriggerBlur,
      onClick: u(t).tooltipEvents.onTriggerClick
    } : {}), [
      L(l.$slots, "default", {
        isOpen: u(t).isOpen.value,
        open: u(t).open,
        close: u(t).close,
        toggle: u(t).toggle
      })
    ], 16, F1));
  }
}), K1 = ze("hp-avatar", {
  variants: {
    variant: {
      filled: "hp-avatar--filled",
      soft: "hp-avatar--soft",
      outline: "hp-avatar--outline",
      surface: "hp-avatar--surface",
      blank: "hp-avatar--blank"
    },
    size: {
      1: "hp-avatar--size-1 hp-icon--size-1",
      2: "hp-avatar--size-2 hp-icon--size-2",
      3: "hp-avatar--size-3 hp-icon--size-2",
      4: "hp-avatar--size-4 hp-icon--size-3",
      5: "hp-avatar--size-5 hp-icon--size-3"
    },
    radius: {
      none: "hp-avatar--radius-none",
      small: "hp-avatar--radius-small",
      big: "hp-avatar--radius-big",
      full: "hp-avatar--radius-full"
    }
  },
  defaultVariants: {
    variant: "filled",
    size: "3",
    radius: "full"
  }
}), Zo = ["red", "blue", "green", "yellow", "orange", "purple", "dark-blue"], Y1 = (e) => {
  const t = e.trim();
  if (t.length === 0)
    return "";
  const n = t.split(/[\s-]+/).filter(Boolean), a = n[0];
  if (n.length === 1)
    return (a ?? "").slice(0, 2).toUpperCase();
  const o = n[n.length - 1];
  return ((a ?? "").charAt(0) + (o ?? "").charAt(0)).toUpperCase();
}, j1 = (e) => {
  let t = 0;
  for (let n = 0; n < e.length; n++)
    t += e.charCodeAt(n);
  return Zo[t % Zo.length] ?? Zo[0];
}, W1 = (e) => {
  const t = m(() => Y1(Ne(e))), n = m(() => j1(Ne(e)));
  return { initials: t, color: n };
}, U1 = ["src", "alt"], q1 = /* @__PURE__ */ Y({
  __name: "AvatarImage",
  props: {
    src: {},
    alt: { default: "" }
  },
  setup(e, { expose: t }) {
    const n = e, a = N(!1);
    return Se(() => n.src, () => {
      a.value = !1;
    }), t({ hasError: a }), (o, l) => a.value ? A("", !0) : (i(), g("img", {
      key: 0,
      class: "hp-avatar__image",
      src: e.src,
      alt: e.alt,
      onError: l[0] || (l[0] = (r) => a.value = !0)
    }, null, 40, U1));
  }
}), Z1 = ["data-theme"], G1 = {
  key: 1,
  class: "hp-avatar__icon"
}, X1 = {
  key: 2,
  class: "hp-avatar__initials"
}, Q1 = {
  key: 3,
  class: "hp-avatar__content"
}, J1 = /* @__PURE__ */ Y({
  __name: "Avatar",
  props: {
    variant: { default: "filled" },
    size: { default: "3" },
    name: {},
    icon: {},
    color: {},
    radius: { default: "full" },
    class: {}
  },
  setup(e) {
    const t = e, n = mt(), { initials: a, color: o } = W1(
      m(() => t.name ?? "")
    ), l = m(() => t.color ? t.color : t.name ? o.value : "default"), r = m(() => {
      const s = n.default?.({});
      return s ? s.some((p) => p.type === q1) : !1;
    }), c = m(
      () => K1({
        variant: t.variant,
        size: t.size,
        radius: t.radius,
        class: t.class
      })
    );
    return (s, p) => (i(), g("span", {
      class: W(c.value),
      "data-theme": l.value
    }, [
      r.value ? L(s.$slots, "default", { key: 0 }) : e.icon ? (i(), g("span", G1, [
        (i(), R(Pe(e.icon)))
      ])) : e.name ? (i(), g("span", X1, le(u(a)), 1)) : (i(), g("span", Q1, [
        L(s.$slots, "default")
      ]))
    ], 10, Z1));
  }
}), Ai = /* @__PURE__ */ Symbol("hp-badge-context"), ep = /* @__PURE__ */ Y({
  __name: "BadgePrefix",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = pt(Ai, null), a = m(() => n?.loading.value ?? !1), o = m(() => n?.loaderSize.value ?? "2"), l = ze(["hp-badge__icon", "hp-badge__prefix"]), r = m(() => l({ class: t.class }));
    return (c, s) => (i(), g("span", {
      class: W(r.value)
    }, [
      a.value ? (i(), R(Io, {
        key: 0,
        size: o.value
      }, null, 8, ["size"])) : L(c.$slots, "default", { key: 1 })
    ], 2));
  }
}), tp = /* @__PURE__ */ Y({
  __name: "BadgeSuffix",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = ze(["hp-badge__icon", "hp-badge__suffix"]), a = m(() => n({ class: t.class }));
    return (o, l) => (i(), g("span", {
      class: W(a.value)
    }, [
      L(o.$slots, "default")
    ], 2));
  }
}), ap = { class: "hp-badge__text" }, Rt = /* @__PURE__ */ Y({
  __name: "Badge",
  props: {
    variant: { default: "filled" },
    size: { default: "3" },
    color: { default: void 0 },
    interactive: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    square: { type: Boolean, default: !1 },
    radius: { default: void 0 },
    iconSize: { default: void 0 },
    prefix: { default: void 0 },
    suffix: { default: void 0 },
    icon: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    truncate: { type: Boolean, default: !1 },
    maxWidth: { default: void 0 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = m(() => t.prefix ?? t.icon), a = ze("hp-badge", {
      variants: {
        variant: {
          filled: "hp-badge--filled",
          soft: "hp-badge--soft",
          outline: "hp-badge--outline",
          surface: "hp-badge--surface",
          "soft-outlined": "hp-badge--soft-outlined",
          blank: "hp-badge--blank"
        },
        size: {
          1: "hp-badge--size-1",
          2: "hp-badge--size-2",
          3: "hp-badge--size-3",
          4: "hp-badge--size-4",
          5: "hp-badge--size-5"
        },
        loading: { true: "hp-badge--loading" },
        disabled: { true: "hp-badge--disabled" },
        truncate: { true: "hp-badge--truncate" },
        square: { true: "hp-badge--square" },
        radius: {
          none: "hp-badge--radius-none",
          small: "hp-badge--radius-small",
          big: "hp-badge--radius-big",
          full: "hp-badge--radius-full"
        }
      },
      defaultVariants: { variant: "filled", size: "3" }
    }), o = {
      1: "1",
      2: "2",
      3: "2",
      4: "2",
      5: "3"
    }, l = m(() => t.iconSize ?? o[t.size]), r = m(() => [
      a({
        variant: t.variant,
        size: t.size,
        loading: t.loading,
        disabled: t.disabled,
        truncate: t.truncate,
        square: t.square,
        radius: t.radius,
        class: t.class
      }),
      `hp-icon--size-${l.value}`
    ]), c = m(() => t.maxWidth == null ? void 0 : { maxWidth: typeof t.maxWidth == "number" ? `${t.maxWidth}px` : t.maxWidth }), s = m(
      () => t.size === "1" || t.size === "2" ? "1" : "2"
    );
    return Dt(Ai, {
      loading: Ze(t, "loading"),
      loaderSize: s,
      size: Ze(t, "size")
    }), (p, d) => (i(), R(Pe(e.interactive ? "button" : "span"), {
      class: W(r.value),
      style: Ie(c.value),
      "data-theme": e.color,
      type: e.interactive ? "button" : void 0,
      disabled: e.interactive && (e.disabled || e.loading) ? !0 : void 0,
      "aria-busy": e.interactive && e.loading ? !0 : void 0
    }, {
      default: B(() => [
        n.value ? (i(), R(ep, { key: 0 }, {
          default: B(() => [
            (i(), R(Pe(n.value)))
          ]),
          _: 1
        })) : A("", !0),
        C("span", ap, [
          L(p.$slots, "default")
        ]),
        e.suffix ? (i(), R(tp, { key: 1 }, {
          default: B(() => [
            (i(), R(Pe(e.suffix)))
          ]),
          _: 1
        })) : A("", !0)
      ]),
      _: 3
    }, 8, ["class", "style", "data-theme", "type", "disabled", "aria-busy"]));
  }
}), nM = /* @__PURE__ */ Y({
  __name: "BadgeText",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = ze("hp-badge__text"), a = m(() => n({ class: t.class }));
    return (o, l) => (i(), g("span", {
      class: W(a.value)
    }, [
      L(o.$slots, "default")
    ], 2));
  }
}), np = ze("hp-breadcrumbs", {
  variants: {
    size: {
      1: "hp-breadcrumbs--size-1",
      2: "hp-breadcrumbs--size-2",
      3: "hp-breadcrumbs--size-3"
    }
  },
  defaultVariants: { size: "2" }
}), op = {}, lp = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid meet",
  style: { display: "block", "aspect-ratio": "1/1" }
};
function rp(e, t) {
  return i(), g("svg", lp, [...t[0] || (t[0] = [
    C("path", {
      d: "M7.5 5L12.5 10L7.5 15",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Ka = /* @__PURE__ */ se(op, [["render", rp]]), sp = ze("hp-skeleton", {
  variants: {
    variant: {
      text: "hp-skeleton--text",
      box: "hp-skeleton--box",
      circle: "hp-skeleton--circle",
      button: "hp-skeleton--button",
      input: "hp-skeleton--input"
    },
    size: {
      1: "hp-skeleton--size-1",
      2: "hp-skeleton--size-2",
      3: "hp-skeleton--size-3",
      4: "hp-skeleton--size-4",
      5: "hp-skeleton--size-5"
    },
    radius: {
      none: "hp-skeleton--radius-none",
      small: "hp-skeleton--radius-small",
      big: "hp-skeleton--radius-big",
      full: "hp-skeleton--radius-full"
    },
    animation: {
      none: "",
      pulse: "hp-skeleton--pulse"
    },
    textSize: {
      1: "hp-fs-1",
      2: "hp-fs-2",
      3: "hp-fs-3",
      4: "hp-fs-4",
      5: "hp-fs-5",
      6: "hp-fs-6",
      7: "hp-fs-7",
      8: "hp-fs-8",
      9: "hp-fs-9",
      10: "hp-fs-10"
    },
    textLineHeight: {
      1: "hp-lh-1",
      2: "hp-lh-2",
      3: "hp-lh-3",
      4: "hp-lh-4",
      5: "hp-lh-5",
      6: "hp-lh-6",
      7: "hp-lh-7"
    }
  },
  defaultVariants: {
    variant: "text",
    animation: "none"
  }
}), Xl = /* @__PURE__ */ Y({
  __name: "Skeleton",
  props: {
    variant: { default: "text" },
    size: { default: void 0 },
    width: { default: "100%" },
    height: { default: void 0 },
    circleSize: { default: "24px" },
    textSize: { default: void 0 },
    textLineHeight: { default: void 0 },
    lines: { default: 1 },
    radius: { default: void 0 },
    animation: { default: "none" },
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = (c) => {
      if (c !== void 0)
        return typeof c == "number" ? `${c}px` : c;
    }, a = m(
      () => sp({
        variant: t.variant,
        size: t.size,
        radius: t.radius,
        animation: t.animation,
        textSize: t.textSize,
        textLineHeight: t.textLineHeight,
        class: t.class
      })
    ), o = m(() => t.variant === "text" && t.lines > 1), l = m(() => {
      if (t.variant === "circle") {
        const p = n(t.circleSize) ?? "24px";
        return { width: p, height: p, minHeight: p };
      }
      const c = {
        width: n(t.width) ?? "100%"
      }, s = n(t.height);
      return s !== void 0 && (c.height = s, c.minHeight = s), c;
    }), r = (c) => {
      const p = {
        width: c === t.lines ? "60%" : n(t.width) ?? "100%"
      }, d = n(t.height);
      return d !== void 0 && (p.height = d, p.minHeight = d), p;
    };
    return (c, s) => o.value ? (i(), g("div", {
      key: 0,
      class: W(["hp-skeleton-group", t.class]),
      "aria-hidden": "true"
    }, [
      (i(!0), g(he, null, De(e.lines, (p) => (i(), g("div", {
        key: p,
        class: W(a.value),
        style: Ie(r(p))
      }, null, 6))), 128))
    ], 2)) : (i(), g("div", {
      key: 1,
      class: W(a.value),
      style: Ie(l.value),
      "aria-hidden": "true"
    }, null, 6));
  }
}), ip = ["data-theme"], oM = /* @__PURE__ */ Y({
  __name: "Breadcrumbs",
  props: {
    items: {},
    loading: { type: Boolean, default: !1 },
    size: { default: "2" },
    textSize: { default: void 0 },
    color: { default: void 0 },
    separatorIcon: { default: void 0 },
    itemMaxWidth: { default: void 0 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = {
      1: "2",
      2: "3",
      3: "4"
    }, a = m(
      () => t.textSize ?? n[t.size]
    ), o = m(() => t.separatorIcon ?? Ka), l = m(
      () => t.itemMaxWidth ? { "--hp-breadcrumbs-item-max-width": t.itemMaxWidth } : void 0
    ), r = m(() => np({ size: t.size, class: t.class }));
    return (c, s) => (i(), g("div", {
      class: W(r.value),
      "data-theme": e.color,
      style: Ie(l.value)
    }, [
      e.loading ? (i(), R(Xl, {
        key: 0,
        width: "120px"
      })) : (i(!0), g(he, { key: 1 }, De(e.items, (p, d) => (i(), g(he, { key: d }, [
        d > 0 ? (i(), R(Pe(o.value), {
          key: 0,
          class: "hp-breadcrumbs__sep"
        })) : A("", !0),
        j(at, Ke({
          as: p.to ? "router-link" : "span",
          size: a.value,
          weight: d === 0 || !p.to ? "medium" : void 0,
          variant: d === 0 || p.to ? "medium" : void 0,
          link: !!p.to,
          truncate: "",
          class: "hp-breadcrumbs__item"
        }, { ref_for: !0 }, p.to ? { to: p.to } : {}), {
          default: B(() => [
            me(le(p.label), 1)
          ]),
          _: 2
        }, 1040, ["as", "size", "weight", "variant", "link"])
      ], 64))), 128))
    ], 14, ip));
  }
}), cp = {}, up = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid meet",
  style: { display: "block", "aspect-ratio": "1/1" }
};
function dp(e, t) {
  return i(), g("svg", up, [...t[0] || (t[0] = [
    C("path", {
      d: "M14 9L10.7071 12.2929C10.3166 12.6834 9.68342 12.6834 9.29289 12.2929L6 9",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Sn = /* @__PURE__ */ se(cp, [["render", dp]]), Ql = /* @__PURE__ */ Symbol("MenuSize"), pp = ["data-theme"], Li = /* @__PURE__ */ Y({
  __name: "Menu",
  props: {
    bordered: { type: Boolean, default: !1 },
    size: { default: "3" },
    color: { default: void 0 }
  },
  setup(e) {
    return Dt(Ql, Ze(e, "size")), (n, a) => (i(), g("div", {
      class: W(["hp-menu", e.bordered && "hp-menu--bordered"]),
      "data-theme": e.color
    }, [
      L(n.$slots, "default")
    ], 10, pp));
  }
}), Ei = /* @__PURE__ */ Y({
  __name: "MenuDivider",
  props: {
    label: {}
  },
  setup(e) {
    return (t, n) => (i(), g("div", {
      class: W(["hp-menu-divider", e.label && "hp-menu-divider--labeled"])
    }, [
      L(t.$slots, "default", {}, () => [
        me(le(e.label), 1)
      ])
    ], 2));
  }
}), fp = ze("hp-menu-header", {
  variants: {
    size: {
      1: "hp-menu-header--size-1",
      2: "hp-menu-header--size-2",
      3: "hp-menu-header--size-3",
      4: "hp-menu-header--size-4"
    }
  },
  defaultVariants: { size: "3" }
}), hp = /* @__PURE__ */ Y({
  __name: "MenuHeader",
  props: {
    label: { default: void 0 },
    size: { default: void 0 }
  },
  setup(e) {
    const t = e, n = pt(Ql, void 0), a = m(() => t.size ?? n?.value ?? "3"), o = {
      1: "1",
      2: "1",
      3: "2",
      4: "3"
    }, l = m(
      () => o[a.value]
    ), r = m(() => fp({ size: a.value }));
    return (c, s) => (i(), g("div", {
      class: W(r.value)
    }, [
      j(at, {
        size: l.value,
        weight: "semibold"
      }, {
        default: B(() => [
          L(c.$slots, "default", {}, () => [
            me(le(e.label), 1)
          ])
        ]),
        _: 3
      }, 8, ["size"])
    ], 2));
  }
}), vp = {}, mp = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function gp(e, t) {
  return i(), g("svg", mp, [...t[0] || (t[0] = [
    Nt('<path class="hp-icon" d="M7.5 13.5C8.32843 13.5 9 14.1716 9 15C9 15.8284 8.32843 16.5 7.5 16.5C6.67157 16.5 6 15.8284 6 15C6 14.1716 6.67157 13.5 7.5 13.5Z" fill="var(--icon-fill, var(--icon-color, currentColor))"></path><path class="hp-icon" d="M7.5 8.5C8.32843 8.5 9 9.17157 9 10C9 10.8284 8.32843 11.5 7.5 11.5C6.67157 11.5 6 10.8284 6 10C6 9.17157 6.67157 8.5 7.5 8.5Z" fill="var(--icon-fill, var(--icon-color, currentColor))"></path><path class="hp-icon" d="M7.5 3.5C8.32843 3.5 9 4.17157 9 5C9 5.82843 8.32843 6.5 7.5 6.5C6.67157 6.5 6 5.82843 6 5C6 4.17157 6.67157 3.5 7.5 3.5Z" fill="var(--icon-fill, var(--icon-color, currentColor))"></path><path class="hp-icon" d="M12 13.5C12.8284 13.5 13.5 14.1716 13.5 15C13.5 15.8284 12.8284 16.5 12 16.5C11.1716 16.5 10.5 15.8284 10.5 15C10.5 14.1716 11.1716 13.5 12 13.5Z" fill="var(--icon-fill, var(--icon-color, currentColor))"></path><path class="hp-icon" d="M12 8.5C12.8284 8.5 13.5 9.17157 13.5 10C13.5 10.8284 12.8284 11.5 12 11.5C11.1716 11.5 10.5 10.8284 10.5 10C10.5 9.17157 11.1716 8.5 12 8.5Z" fill="var(--icon-fill, var(--icon-color, currentColor))"></path><path class="hp-icon" d="M12 3.5C12.8284 3.5 13.5 4.17157 13.5 5C13.5 5.82843 12.8284 6.5 12 6.5C11.1716 6.5 10.5 5.82843 10.5 5C10.5 4.17157 11.1716 3.5 12 3.5Z" fill="var(--icon-fill, var(--icon-color, currentColor))"></path>', 6)
  ])]);
}
const Jl = /* @__PURE__ */ se(vp, [["render", gp]]), yp = /* @__PURE__ */ Y({
  __name: "ChipPrefix",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = ze(["hp-chip__icon", "hp-chip__prefix"]), a = m(() => n({ class: t.class }));
    return (o, l) => (i(), g("span", {
      class: W(a.value)
    }, [
      L(o.$slots, "default")
    ], 2));
  }
}), wp = /* @__PURE__ */ Y({
  __name: "ChipSuffix",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = ze(["hp-chip__icon", "hp-chip__suffix"]), a = m(() => n({ class: t.class }));
    return (o, l) => (i(), g("span", {
      class: W(a.value)
    }, [
      L(o.$slots, "default")
    ], 2));
  }
}), bp = ["data-theme"], kp = {
  key: 0,
  class: "hp-chip__drag-handle",
  "aria-hidden": "true"
}, _p = { class: "hp-chip__text" }, Cp = ["aria-label", "disabled", "tabindex"], Ht = /* @__PURE__ */ Y({
  __name: "Chip",
  props: {
    variant: { default: "filled" },
    size: { default: "3" },
    color: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    square: { type: Boolean, default: !1 },
    radius: { default: void 0 },
    iconSize: { default: void 0 },
    active: { type: Boolean, default: !1 },
    rotateIcon: { type: Boolean, default: !1 },
    dismissible: { type: Boolean, default: !1 },
    dismissTabindex: { default: void 0 },
    draggable: { type: Boolean, default: !1 },
    prefix: { default: void 0 },
    suffix: { default: void 0 },
    icon: { default: void 0 },
    clickable: { type: Boolean, default: !1 },
    hoverControls: { type: Boolean, default: !1 },
    wrap: { type: Boolean, default: !1 },
    truncate: { type: Boolean, default: !1 },
    maxWidth: { default: void 0 },
    class: { default: void 0 }
  },
  emits: ["dismiss"],
  setup(e, { emit: t }) {
    const n = Le(), a = e, o = t, l = m(() => a.prefix ?? a.icon), r = ze("hp-chip", {
      variants: {
        variant: {
          filled: "hp-chip--filled",
          soft: "hp-chip--soft",
          outline: "hp-chip--outline",
          surface: "hp-chip--surface",
          "soft-outlined": "hp-chip--soft-outlined",
          blank: "hp-chip--blank"
        },
        size: {
          1: "hp-chip--size-1",
          2: "hp-chip--size-2",
          3: "hp-chip--size-3",
          4: "hp-chip--size-4",
          5: "hp-chip--size-5"
        },
        active: { true: "hp-chip--active" },
        rotateIcon: { true: "hp-chip--rotate-icon" },
        disabled: { true: "hp-chip--disabled" },
        dismissible: { true: "hp-chip--dismissible" },
        draggable: { true: "hp-chip--draggable" },
        clickable: { true: "hp-chip--clickable" },
        hoverControls: { true: "hp-chip--hover-controls" },
        wrap: { true: "hp-chip--wrap" },
        truncate: { true: "hp-chip--truncate" },
        square: { true: "hp-chip--square" },
        radius: {
          none: "hp-chip--radius-none",
          small: "hp-chip--radius-small",
          big: "hp-chip--radius-big",
          full: "hp-chip--radius-full"
        }
      },
      defaultVariants: { variant: "filled", size: "3" }
    }), c = {
      1: "1",
      2: "2",
      3: "2",
      4: "3",
      5: "3"
    }, s = m(() => a.iconSize ?? c[a.size]), p = m(() => [
      r({
        variant: a.variant,
        size: a.size,
        active: a.active,
        rotateIcon: a.rotateIcon,
        disabled: a.disabled,
        dismissible: a.dismissible,
        draggable: a.draggable,
        clickable: a.clickable,
        hoverControls: a.hoverControls,
        wrap: a.wrap,
        truncate: a.truncate,
        square: a.square,
        radius: a.radius,
        class: a.class
      }),
      `hp-icon--size-${s.value}`
    ]), d = m(() => a.maxWidth == null ? void 0 : { maxWidth: typeof a.maxWidth == "number" ? `${a.maxWidth}px` : a.maxWidth }), f = () => {
      a.disabled || o("dismiss");
    };
    return (h, $) => (i(), g("span", {
      class: W(p.value),
      style: Ie(d.value),
      "data-theme": e.color
    }, [
      e.draggable ? (i(), g("span", kp, [
        j(Jl)
      ])) : A("", !0),
      l.value ? (i(), R(yp, { key: 1 }, {
        default: B(() => [
          (i(), R(Pe(l.value)))
        ]),
        _: 1
      })) : A("", !0),
      C("span", _p, [
        L(h.$slots, "default")
      ]),
      e.suffix ? (i(), R(wp, { key: 2 }, {
        default: B(() => [
          (i(), R(Pe(e.suffix)))
        ]),
        _: 1
      })) : A("", !0),
      e.dismissible ? (i(), g("button", {
        key: 3,
        type: "button",
        class: "hp-chip__close",
        "aria-label": u(n)("ui.chip.remove", "Remove"),
        disabled: e.disabled,
        tabindex: e.dismissTabindex,
        onClick: Fe(f, ["stop"])
      }, [
        j(zt)
      ], 8, Cp)) : A("", !0)
    ], 14, bp));
  }
}), lM = /* @__PURE__ */ Y({
  __name: "ChipText",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = ze("hp-chip__text"), a = m(() => n({ class: t.class }));
    return (o, l) => (i(), g("span", {
      class: W(a.value)
    }, [
      L(o.$slots, "default")
    ], 2));
  }
}), xp = ze("", {
  variants: {
    maxWidth: {
      1: "hp-tooltip--max-w-1",
      2: "hp-tooltip--max-w-2",
      3: "hp-tooltip--max-w-3",
      4: "hp-tooltip--max-w-4",
      5: "hp-tooltip--max-w-5",
      6: "hp-tooltip--max-w-6",
      7: "hp-tooltip--max-w-7"
    },
    nowrap: {
      true: "hp-tooltip--nowrap",
      false: "hp-tooltip--wrap"
    }
  }
}), $p = 100, Sp = 250, Ro = /* @__PURE__ */ Y({
  __name: "Tooltip",
  props: {
    class: { default: void 0 },
    text: { default: void 0 },
    variant: { default: "dark" },
    placement: { default: "top-start" },
    showDelay: { default: 200 },
    hideDelay: { default: void 0 },
    maxWidth: { default: void 0 },
    nowrap: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    contentClass: { default: void 0 }
  },
  setup(e) {
    const t = e, n = m(
      () => t.variant === "dark" ? void 0 : t.variant
    ), a = m(() => t.hideDelay !== void 0 ? t.hideDelay : t.variant === "dark" ? $p : Sp), o = m(
      () => xp({
        maxWidth: t.maxWidth,
        nowrap: t.nowrap,
        class: t.contentClass
      })
    );
    return (l, r) => e.disabled ? L(l.$slots, "default", { key: 0 }) : (i(), R(u(Xt), {
      key: 1,
      type: "tooltip",
      variant: n.value,
      placement: e.placement,
      "show-delay": e.showDelay,
      "hide-delay": a.value
    }, {
      default: B(() => [
        j(u(Jt), {
          class: W(t.class)
        }, {
          default: B(() => [
            L(l.$slots, "default")
          ]),
          _: 3
        }, 8, ["class"]),
        j(u(Qt), {
          class: W(o.value)
        }, {
          default: B(() => [
            L(l.$slots, "content", {}, () => [
              me(le(e.text), 1)
            ])
          ]),
          _: 3
        }, 8, ["class"])
      ]),
      _: 3
    }, 8, ["variant", "placement", "show-delay", "hide-delay"]));
  }
}), Nn = /* @__PURE__ */ Y({
  __name: "LabelBadgeChip",
  props: {
    badge: {}
  },
  setup(e) {
    const t = e, n = () => {
      t.badge?.onClick?.();
    };
    return (a, o) => e.badge ? (i(), R(Ro, {
      key: 0,
      text: e.badge.tooltip,
      disabled: !e.badge.tooltip
    }, {
      default: B(() => [
        j(u(Ht), {
          class: "hp-label-badge",
          size: "1",
          variant: "soft",
          color: e.badge.color,
          radius: e.badge.round ? "full" : void 0,
          square: e.badge.round,
          clickable: e.badge.onClick !== void 0,
          role: e.badge.onClick ? "button" : void 0,
          tabindex: e.badge.onClick ? 0 : void 0,
          "aria-label": e.badge.onClick ? e.badge.ariaLabel : void 0,
          onClick: n,
          onKeydown: [
            sa(Fe(n, ["prevent"]), ["enter"]),
            sa(Fe(n, ["prevent"]), ["space"])
          ]
        }, {
          default: B(() => [
            me(le(e.badge.text), 1)
          ]),
          _: 1
        }, 8, ["color", "radius", "square", "clickable", "role", "tabindex", "aria-label", "onKeydown"])
      ]),
      _: 1
    }, 8, ["text", "disabled"])) : A("", !0);
  }
}), Zn = /* @__PURE__ */ Y({
  __name: "FieldLabel",
  props: {
    as: { default: "span" }
  },
  setup(e) {
    return (t, n) => (i(), R(u(at), {
      as: e.as,
      size: "2",
      weight: "normal",
      variant: "medium",
      "line-height": "5",
      class: "hp-field-label"
    }, {
      default: B(() => [
        L(t.$slots, "default")
      ]),
      _: 3
    }, 8, ["as"]));
  }
}), Mp = ["data-theme"], Dp = ["checked", "aria-label", "name", "value", "disabled", "aria-readonly"], Tp = { class: "hp-switch__track" }, Bp = { class: "hp-switch__thumb" }, zp = /* @__PURE__ */ Y({
  __name: "Switch",
  props: /* @__PURE__ */ Xe({
    icon: {},
    ariaLabel: {},
    variant: { default: "surface" },
    size: { default: "3" },
    labelPosition: { default: "right" },
    disabled: { type: Boolean, default: !1 },
    readOnly: { type: Boolean, default: !1 },
    label: { default: void 0 },
    name: { default: void 0 },
    value: { default: void 0 },
    color: { default: void 0 },
    class: { default: void 0 }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["change"], ["update:modelValue"]),
  setup(e, { expose: t, emit: n }) {
    const a = e, o = n, l = vt(e, "modelValue"), r = mt(), c = N(null), s = m(() => l.value), p = m(() => a.label || r.default), d = ze("hp-switch", {
      variants: {
        variant: {
          filled: "hp-switch--filled",
          soft: "hp-switch--soft",
          outline: "hp-switch--outline",
          surface: "hp-switch--surface"
        },
        size: {
          1: "hp-switch--size-1",
          2: "hp-switch--size-2",
          3: "hp-switch--size-3",
          4: "hp-switch--size-4",
          5: "hp-switch--size-5"
        },
        labelPosition: {
          left: "hp-switch--label-left",
          right: ""
        },
        disabled: {
          true: "hp-switch--disabled"
        },
        readOnly: {
          true: "hp-switch--readonly"
        },
        checked: {
          true: "hp-switch--checked"
        }
      },
      defaultVariants: {
        variant: "surface",
        size: "3",
        labelPosition: "right"
      }
    }), f = m(
      () => d({
        variant: a.variant,
        size: a.size,
        labelPosition: a.labelPosition,
        disabled: a.disabled,
        readOnly: a.readOnly,
        checked: s.value,
        class: a.class
      })
    ), h = (y) => {
      a.readOnly && y.preventDefault();
    }, $ = (y) => {
      const w = y.target;
      l.value = w.checked, o("change", y);
    };
    return t({
      inputRef: c
    }), (y, w) => (i(), g("label", {
      class: W(f.value),
      "data-theme": e.color
    }, [
      C("input", {
        ref_key: "inputRef",
        ref: c,
        type: "checkbox",
        class: "hp-switch__input",
        checked: s.value,
        "aria-label": e.ariaLabel,
        name: e.name,
        value: e.value,
        disabled: e.disabled,
        "aria-readonly": e.readOnly || void 0,
        onClick: h,
        onChange: $
      }, null, 40, Dp),
      C("span", Tp, [
        C("span", Bp, [
          e.icon ? (i(), R(Pe(e.icon), {
            key: 0,
            class: "hp-switch__icon hp-icon--size-1",
            "aria-hidden": "true"
          })) : A("", !0)
        ])
      ]),
      p.value ? (i(), R(u(Zn), {
        key: 0,
        class: "hp-switch__label"
      }, {
        default: B(() => [
          L(y.$slots, "default", {}, () => [
            me(le(e.label), 1)
          ], !0)
        ]),
        _: 3
      })) : A("", !0)
    ], 10, Mp));
  }
}), $o = /* @__PURE__ */ se(zp, [["__scopeId", "data-v-668e91b5"]]), Ap = ["data-theme"], Lp = /* @__PURE__ */ Y({
  __name: "MenuIcon",
  props: {
    color: { default: void 0 },
    size: { default: void 0 }
  },
  setup(e) {
    return (t, n) => (i(), g("span", {
      class: W(["hp-menu-item__icon", e.size && `hp-menu-item__icon--size-${e.size === "2" ? "2-half" : Number(e.size) > 2 ? Number(e.size) - 1 : e.size}`]),
      "data-theme": e.color
    }, [
      L(t.$slots, "default")
    ], 10, Ap));
  }
}), Ii = ze("hp-menu-item", {
  variants: {
    size: {
      1: "hp-menu-item--size-1 hp-icon--size-1",
      2: "hp-menu-item--size-2 hp-icon--size-1",
      3: "hp-menu-item--size-3 hp-icon--size-2",
      4: "hp-menu-item--size-4 hp-icon--size-3"
    },
    variant: {
      default: "",
      danger: "hp-menu-item--danger"
    },
    disabled: {
      true: "hp-menu-item--disabled"
    },
    selected: {
      true: "hp-menu-item--selected"
    }
  },
  defaultVariants: { size: "3", variant: "default" }
}), Ep = {
  key: 1,
  class: "hp-menu-item__prefix"
}, Ip = {
  key: 2,
  inert: !0,
  class: "hp-menu-item__switch",
  "aria-hidden": "true"
}, Rp = {
  key: 3,
  class: "hp-menu-item__suffix"
}, Oa = /* @__PURE__ */ Y({
  __name: "MenuItem",
  props: {
    label: { default: void 0 },
    labelBadge: { default: void 0 },
    icon: { default: void 0 },
    iconColor: { default: void 0 },
    iconSize: { default: void 0 },
    prefix: { default: void 0 },
    suffix: { default: void 0 },
    badge: { default: void 0 },
    badgeColor: { default: void 0 },
    badgeVariant: { default: "filled" },
    badgeSize: { default: "1" },
    variant: { default: "default" },
    disabled: { type: Boolean, default: !1 },
    selected: { type: Boolean, default: !1 },
    tooltip: { default: void 0 },
    toggle: { default: void 0 },
    size: { default: void 0 },
    weight: { default: "medium" }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = mt(), l = () => !!o.default, r = pt(Ql, void 0), c = m(() => n.size ?? r?.value ?? "3"), s = m(() => !!n.toggle), p = m(() => n.selected || (n.toggle?.value ?? !1)), d = m(() => s.value ? "div" : "button"), f = {
      1: "1",
      2: "1",
      3: "1",
      4: "2"
    }, h = m(
      () => f[c.value]
    ), $ = {
      1: "2",
      2: "2",
      3: "3",
      4: "4"
    }, y = m(
      () => $[c.value]
    ), w = m(
      () => Ii({
        size: c.value,
        variant: n.variant,
        disabled: n.disabled,
        selected: p.value
      })
    ), v = m(() => !!n.icon || !!o.icon), x = m(() => !!n.prefix || !!o.prefix), b = m(() => !!n.suffix || !!o.suffix), k = () => {
      if (!n.disabled) {
        if (n.toggle) {
          n.toggle.onChange(!n.toggle.value);
          return;
        }
        a("click");
      }
    }, _ = (T) => {
      s.value && (T.key === " " || T.key === "Enter") && (T.preventDefault(), k());
    };
    return (T, S) => (i(), R(Pe(d.value), {
      type: s.value ? void 0 : "button",
      role: s.value ? "menuitemcheckbox" : void 0,
      "aria-checked": s.value ? e.toggle?.value : void 0,
      "aria-disabled": s.value && e.disabled ? !0 : void 0,
      tabindex: s.value ? e.disabled ? -1 : 0 : void 0,
      disabled: !s.value && e.disabled ? !0 : void 0,
      class: W(w.value),
      title: e.tooltip,
      onClick: k,
      onKeydown: _
    }, {
      default: B(() => [
        l() ? L(T.$slots, "default", { key: 0 }) : (i(), g(he, { key: 1 }, [
          v.value ? (i(), R(Lp, {
            key: 0,
            color: e.iconColor,
            size: e.iconSize
          }, {
            default: B(() => [
              L(T.$slots, "icon", {}, () => [
                e.icon ? (i(), R(Pe(e.icon), { key: 0 })) : A("", !0)
              ])
            ]),
            _: 3
          }, 8, ["color", "size"])) : A("", !0),
          x.value ? (i(), g("span", Ep, [
            L(T.$slots, "prefix", {}, () => [
              e.prefix ? (i(), R(Pe(e.prefix), { key: 0 })) : A("", !0)
            ])
          ])) : A("", !0),
          j(at, {
            size: y.value,
            weight: e.weight,
            class: "hp-menu-item__label"
          }, {
            default: B(() => [
              me(le(e.label), 1)
            ]),
            _: 1
          }, 8, ["size", "weight"]),
          j(Nn, { badge: e.labelBadge }, null, 8, ["badge"]),
          e.toggle ? (i(), g("span", Ip, [
            j($o, {
              "model-value": e.toggle.value,
              disabled: e.disabled,
              size: h.value,
              variant: e.toggle.value ? "filled" : "outline",
              color: e.toggle.value ? "green" : void 0
            }, null, 8, ["model-value", "disabled", "size", "variant", "color"])
          ])) : b.value ? (i(), g("span", Rp, [
            L(T.$slots, "suffix", {}, () => [
              e.suffix ? (i(), R(Pe(e.suffix), { key: 0 })) : A("", !0)
            ])
          ])) : e.badge && e.badgeColor ? (i(), R(Rt, {
            key: 4,
            size: e.badgeSize,
            variant: e.badgeVariant,
            color: e.badgeColor,
            class: "hp-menu-item__suffix"
          }, {
            default: B(() => [
              me(le(e.badge), 1)
            ]),
            _: 1
          }, 8, ["size", "variant", "color"])) : e.badge ? (i(), R(at, {
            key: 5,
            size: "2",
            variant: "soft",
            class: "hp-menu-item__suffix"
          }, {
            default: B(() => [
              me(le(e.badge), 1)
            ]),
            _: 1
          })) : A("", !0)
        ], 64))
      ]),
      _: 3
    }, 40, ["type", "role", "aria-checked", "aria-disabled", "tabindex", "disabled", "class", "title"]));
  }
}), Pp = { class: "hp-button-menu" }, Op = {
  key: 0,
  class: "hp-button-menu__divider"
}, So = /* @__PURE__ */ Y({
  inheritAttrs: !1,
  __name: "ButtonMenu",
  props: {
    type: { default: "button" },
    variant: { default: "outline" },
    color: { default: void 0 },
    size: { default: "3" },
    prefix: { default: void 0 },
    suffix: { default: void 0 },
    icon: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    square: { type: Boolean, default: void 0 },
    radius: { default: void 0 },
    items: {},
    label: { default: void 0 },
    header: { default: void 0 },
    chevron: { type: Boolean, default: void 0 },
    chevronVariant: {},
    chevronColor: {},
    placement: { default: "bottom-start" },
    menuSize: { default: void 0 },
    menuColor: { default: void 0 },
    menuWidth: { default: void 0 },
    itemSize: { default: "2" },
    ariaLabel: { default: void 0 },
    mainAction: { type: Function, default: void 0 },
    mainAriaPressed: { type: Boolean, default: void 0 },
    menuAriaLabel: { default: void 0 },
    open: { type: Boolean, default: void 0 }
  },
  emits: ["update:open"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = m(() => n.chevron ?? !!n.label), l = m(() => !n.label && !!n.icon), r = m(() => n.square ?? l.value), c = N(!1), s = m({
      get: () => n.open ?? c.value,
      set: (h) => {
        n.open === void 0 && (c.value = h), a("update:open", h);
      }
    }), p = () => {
      n.disabled || (s.value = !s.value);
    }, d = () => {
      if (!n.disabled) {
        if (n.mainAction !== void 0) {
          n.mainAction();
          return;
        }
        p();
      }
    }, f = (h) => {
      if (!(h.disabled || h.toggle))
        return s.value = !1, h.onClick?.();
    };
    return (h, $) => (i(), R(Xt, {
      open: s.value,
      "onUpdate:open": $[0] || ($[0] = (y) => s.value = y),
      type: "menu",
      placement: e.placement
    }, {
      default: B(() => [
        j(Jt, null, {
          default: B(() => [
            C("div", Pp, [
              j(Ae, {
                type: e.type,
                variant: e.variant,
                size: e.size,
                color: e.color,
                radius: e.radius,
                prefix: e.prefix,
                suffix: e.suffix,
                icon: e.icon,
                square: r.value,
                disabled: e.disabled,
                loading: e.loading,
                "aria-label": e.ariaLabel,
                "aria-pressed": e.mainAriaPressed,
                class: W(o.value ? "hp-button-menu__main" : void 0),
                onClick: d
              }, {
                default: B(() => [
                  L(h.$slots, "default", {}, () => [
                    l.value ? A("", !0) : (i(), R($a, { key: 0 }, {
                      default: B(() => [
                        me(le(e.label), 1)
                      ]),
                      _: 1
                    }))
                  ])
                ]),
                _: 3
              }, 8, ["type", "variant", "size", "color", "radius", "prefix", "suffix", "icon", "square", "disabled", "loading", "aria-label", "aria-pressed", "class"]),
              o.value ? (i(), g("span", Op)) : A("", !0),
              o.value ? (i(), R(Ae, {
                key: 1,
                variant: e.chevronVariant ?? e.variant,
                size: e.size,
                color: e.chevronColor ?? e.color,
                disabled: e.disabled,
                square: "",
                class: "hp-button-menu__chevron",
                "aria-label": e.menuAriaLabel,
                "aria-expanded": s.value,
                "aria-haspopup": h.$slots.dropdown ? "dialog" : "menu",
                onClick: p
              }, {
                default: B(() => [
                  j(Pa, null, {
                    default: B(() => [
                      j(Sn, {
                        class: W(["hp-button-menu__chevron-icon", { "hp-button-menu__chevron-icon--open": s.value }])
                      }, null, 8, ["class"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["variant", "size", "color", "disabled", "aria-label", "aria-expanded", "aria-haspopup"])) : A("", !0)
            ])
          ]),
          _: 3
        }),
        j(Qt, {
          "data-theme": e.menuColor,
          class: W(e.menuSize && `hp-button-menu__dropdown--size-${e.menuSize}`),
          style: Ie(e.menuWidth ? { width: e.menuWidth } : void 0)
        }, {
          default: B(() => [
            h.$slots.dropdown ? L(h.$slots, "dropdown", {
              key: 0,
              close: () => s.value = !1
            }) : (i(), R(Li, {
              key: 1,
              bordered: "",
              size: e.itemSize,
              color: e.menuColor
            }, {
              default: B(() => [
                e.header ? (i(), R(hp, {
                  key: 0,
                  label: e.header
                }, null, 8, ["label"])) : A("", !0),
                (i(!0), g(he, null, De(e.items, (y, w) => (i(), g(he, { key: w }, [
                  y.divider ? (i(), R(Ei, { key: 0 })) : A("", !0),
                  j(Oa, {
                    label: y.label,
                    "label-badge": y.labelBadge,
                    icon: y.icon,
                    "icon-color": y.iconColor,
                    prefix: y.prefix,
                    suffix: y.suffix,
                    badge: y.badge,
                    variant: y.variant,
                    disabled: y.disabled,
                    selected: y.selected,
                    tooltip: y.tooltip,
                    toggle: y.toggle,
                    weight: y.weight,
                    onClick: (v) => f(y)
                  }, null, 8, ["label", "label-badge", "icon", "icon-color", "prefix", "suffix", "badge", "variant", "disabled", "selected", "tooltip", "toggle", "weight", "onClick"])
                ], 64))), 128))
              ]),
              _: 1
            }, 8, ["size", "color"]))
          ]),
          _: 3
        }, 8, ["data-theme", "class", "style"])
      ]),
      _: 3
    }, 8, ["open", "placement"]));
  }
}), Vp = { class: "hp-cal__actions" }, Hp = { class: "hp-cal__actions-buttons" }, Ri = /* @__PURE__ */ Y({
  __name: "DateActions",
  props: {
    canApply: { type: Boolean, default: !0 },
    cancelLabel: { default: void 0 },
    confirmLabel: { default: void 0 }
  },
  emits: ["cancel", "apply"],
  setup(e, { emit: t }) {
    const n = e, a = Le(), o = m(() => n.cancelLabel ?? a("ui.common.cancel", "Cancel")), l = m(() => n.confirmLabel ?? a("ui.common.apply", "Apply")), r = t;
    return (c, s) => (i(), g("div", Vp, [
      L(c.$slots, "extra"),
      C("div", Hp, [
        L(c.$slots, "cancel", {}, () => [
          j(u(Ae), {
            variant: "outline",
            size: "2",
            onClick: s[0] || (s[0] = (p) => r("cancel"))
          }, {
            default: B(() => [
              me(le(o.value), 1)
            ]),
            _: 1
          })
        ]),
        L(c.$slots, "confirm", {}, () => [
          j(u(Ae), {
            variant: "filled",
            size: "2",
            disabled: !e.canApply,
            onClick: s[1] || (s[1] = (p) => r("apply"))
          }, {
            default: B(() => [
              me(le(l.value), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ]));
  }
}), Pi = 6048e5, Np = 864e5, er = 6e4, Po = 36e5, Fp = 1e3, Zr = /* @__PURE__ */ Symbol.for("constructDateFrom");
function lt(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Zr in e ? e[Zr](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function He(e, t) {
  return lt(t || e, e);
}
function At(e, t, n) {
  const a = He(e, n?.in);
  return isNaN(t) ? lt(n?.in || e, NaN) : (t && a.setDate(a.getDate() + t), a);
}
function Pt(e, t, n) {
  const a = He(e, n?.in);
  if (isNaN(t)) return lt(e, NaN);
  if (!t)
    return a;
  const o = a.getDate(), l = lt(e, a.getTime());
  l.setMonth(a.getMonth() + t + 1, 0);
  const r = l.getDate();
  return o >= r ? l : (a.setFullYear(
    l.getFullYear(),
    l.getMonth(),
    o
  ), a);
}
function Oi(e, t, n) {
  const {
    years: a = 0,
    months: o = 0,
    weeks: l = 0,
    days: r = 0,
    hours: c = 0,
    minutes: s = 0,
    seconds: p = 0
  } = t, d = He(e, n?.in), f = o || a ? Pt(d, o + a * 12) : d, h = r || l ? At(f, r + l * 7) : f, $ = s + c * 60, w = (p + $ * 60) * 1e3;
  return lt(e, +h + w);
}
function Kp(e, t, n) {
  return lt(e, +He(e) + t);
}
function Yp(e, t, n) {
  return Kp(e, t * Po);
}
let jp = {};
function nn() {
  return jp;
}
function qt(e, t) {
  const n = nn(), a = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = He(e, t?.in), l = o.getDay(), r = (l < a ? 7 : 0) + l - a;
  return o.setDate(o.getDate() - r), o.setHours(0, 0, 0, 0), o;
}
function wn(e, t) {
  return qt(e, { ...t, weekStartsOn: 1 });
}
function Vi(e, t) {
  const n = He(e, t?.in), a = n.getFullYear(), o = lt(n, 0);
  o.setFullYear(a + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const l = wn(o), r = lt(n, 0);
  r.setFullYear(a, 0, 4), r.setHours(0, 0, 0, 0);
  const c = wn(r);
  return n.getTime() >= l.getTime() ? a + 1 : n.getTime() >= c.getTime() ? a : a - 1;
}
function Mo(e) {
  const t = He(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function on(e, ...t) {
  const n = lt.bind(
    null,
    t.find((a) => typeof a == "object")
  );
  return t.map(n);
}
function $t(e, t) {
  const n = He(e, t?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Hi(e, t, n) {
  const [a, o] = on(
    n?.in,
    e,
    t
  ), l = $t(a), r = $t(o), c = +l - Mo(l), s = +r - Mo(r);
  return Math.round((c - s) / Np);
}
function Wp(e, t) {
  const n = Vi(e, t), a = lt(e, 0);
  return a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0), wn(a);
}
function Up(e, t, n) {
  return Pt(e, t * 3, n);
}
function tr(e, t, n) {
  return Pt(e, t * 12, n);
}
function Gr(e, t) {
  const n = +He(e) - +He(t);
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function qp(e, t, n) {
  const [a, o] = on(
    n?.in,
    e,
    t
  );
  return +$t(a) == +$t(o);
}
function Ni(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Ut(e) {
  return !(!Ni(e) && typeof e != "number" || isNaN(+He(e)));
}
function Xr(e, t) {
  const n = He(e, t?.in);
  return Math.trunc(n.getMonth() / 3) + 1;
}
function Zp(e, t, n) {
  const [a, o] = on(
    n?.in,
    e,
    t
  );
  return a.getFullYear() - o.getFullYear();
}
function Qr(e, t) {
  const n = He(e, t?.in), a = n.getMonth();
  return n.setFullYear(n.getFullYear(), a + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Gp(e, t, n) {
  const [a, o] = on(
    n?.in,
    e,
    t
  ), l = Gr(a, o), r = Math.abs(Zp(a, o));
  a.setFullYear(1584), o.setFullYear(1584);
  const c = Gr(a, o) === -l, s = l * (r - +c);
  return s === 0 ? 0 : s;
}
function Fi(e, t) {
  const [n, a] = on(e, t.start, t.end);
  return { start: n, end: a };
}
function ar(e, t) {
  const { start: n, end: a } = Fi(t?.in, e);
  let o = +n > +a;
  const l = o ? +n : +a, r = o ? a : n;
  r.setHours(0, 0, 0, 0);
  let c = 1;
  const s = [];
  for (; +r <= l; )
    s.push(lt(n, r)), r.setDate(r.getDate() + c), r.setHours(0, 0, 0, 0);
  return o ? s.reverse() : s;
}
function Za(e, t) {
  const n = He(e, t?.in), a = n.getMonth(), o = a - a % 3;
  return n.setMonth(o, 1), n.setHours(0, 0, 0, 0), n;
}
function Xp(e, t) {
  const { start: n, end: a } = Fi(t?.in, e);
  let o = +n > +a;
  const l = o ? +Za(n) : +Za(a);
  let r = Za(o ? a : n), c = 1;
  const s = [];
  for (; +r <= l; )
    s.push(lt(n, r)), r = Up(r, c);
  return o ? s.reverse() : s;
}
function Xa(e, t) {
  const n = He(e, t?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function Ki(e, t) {
  const n = He(e, t?.in), a = n.getFullYear();
  return n.setFullYear(a + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function hn(e, t) {
  const n = He(e, t?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function nr(e, t) {
  const n = nn(), a = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = He(e, t?.in), l = o.getDay(), r = (l < a ? -7 : 0) + 6 - (l - a);
  return o.setDate(o.getDate() + r), o.setHours(23, 59, 59, 999), o;
}
function Jr(e, t) {
  const n = He(e, t?.in), a = n.getMonth(), o = a - a % 3 + 3;
  return n.setMonth(o, 0), n.setHours(23, 59, 59, 999), n;
}
const Qp = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Jp = (e, t, n) => {
  let a;
  const o = Qp[e];
  return typeof o == "string" ? a = o : t === 1 ? a = o.one : a = o.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
function Go(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const ef = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, tf = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, af = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, nf = {
  date: Go({
    formats: ef,
    defaultWidth: "full"
  }),
  time: Go({
    formats: tf,
    defaultWidth: "full"
  }),
  dateTime: Go({
    formats: af,
    defaultWidth: "full"
  })
}, of = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, lf = (e, t, n, a) => of[e];
function An(e) {
  return (t, n) => {
    const a = n?.context ? String(n.context) : "standalone";
    let o;
    if (a === "formatting" && e.formattingValues) {
      const r = e.defaultFormattingWidth || e.defaultWidth, c = n?.width ? String(n.width) : r;
      o = e.formattingValues[c] || e.formattingValues[r];
    } else {
      const r = e.defaultWidth, c = n?.width ? String(n.width) : e.defaultWidth;
      o = e.values[c] || e.values[r];
    }
    const l = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[l];
  };
}
const rf = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, sf = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, cf = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, uf = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, df = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, pf = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ff = (e, t) => {
  const n = Number(e), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, hf = {
  ordinalNumber: ff,
  era: An({
    values: rf,
    defaultWidth: "wide"
  }),
  quarter: An({
    values: sf,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: An({
    values: cf,
    defaultWidth: "wide"
  }),
  day: An({
    values: uf,
    defaultWidth: "wide"
  }),
  dayPeriod: An({
    values: df,
    defaultWidth: "wide",
    formattingValues: pf,
    defaultFormattingWidth: "wide"
  })
};
function Ln(e) {
  return (t, n = {}) => {
    const a = n.width, o = a && e.matchPatterns[a] || e.matchPatterns[e.defaultMatchWidth], l = t.match(o);
    if (!l)
      return null;
    const r = l[0], c = a && e.parsePatterns[a] || e.parsePatterns[e.defaultParseWidth], s = Array.isArray(c) ? mf(c, (f) => f.test(r)) : (
      // [TODO] -- I challenge you to fix the type
      vf(c, (f) => f.test(r))
    );
    let p;
    p = e.valueCallback ? e.valueCallback(s) : s, p = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(p)
    ) : p;
    const d = t.slice(r.length);
    return { value: p, rest: d };
  };
}
function vf(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function mf(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function gf(e) {
  return (t, n = {}) => {
    const a = t.match(e.matchPattern);
    if (!a) return null;
    const o = a[0], l = t.match(e.parsePattern);
    if (!l) return null;
    let r = e.valueCallback ? e.valueCallback(l[0]) : l[0];
    r = n.valueCallback ? n.valueCallback(r) : r;
    const c = t.slice(o.length);
    return { value: r, rest: c };
  };
}
const yf = /^(\d+)(th|st|nd|rd)?/i, wf = /\d+/i, bf = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, kf = {
  any: [/^b/i, /^(a|c)/i]
}, _f = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Cf = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, xf = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, $f = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Sf = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Mf = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Df = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Tf = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Bf = {
  ordinalNumber: gf({
    matchPattern: yf,
    parsePattern: wf,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ln({
    matchPatterns: bf,
    defaultMatchWidth: "wide",
    parsePatterns: kf,
    defaultParseWidth: "any"
  }),
  quarter: Ln({
    matchPatterns: _f,
    defaultMatchWidth: "wide",
    parsePatterns: Cf,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ln({
    matchPatterns: xf,
    defaultMatchWidth: "wide",
    parsePatterns: $f,
    defaultParseWidth: "any"
  }),
  day: Ln({
    matchPatterns: Sf,
    defaultMatchWidth: "wide",
    parsePatterns: Mf,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ln({
    matchPatterns: Df,
    defaultMatchWidth: "any",
    parsePatterns: Tf,
    defaultParseWidth: "any"
  })
}, Yi = {
  code: "en-US",
  formatDistance: Jp,
  formatLong: nf,
  formatRelative: lf,
  localize: hf,
  match: Bf,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function zf(e, t) {
  const n = He(e, t?.in);
  return Hi(n, hn(n)) + 1;
}
function or(e, t) {
  const n = He(e, t?.in), a = +wn(n) - +Wp(n);
  return Math.round(a / Pi) + 1;
}
function lr(e, t) {
  const n = He(e, t?.in), a = n.getFullYear(), o = nn(), l = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, r = lt(t?.in || e, 0);
  r.setFullYear(a + 1, 0, l), r.setHours(0, 0, 0, 0);
  const c = qt(r, t), s = lt(t?.in || e, 0);
  s.setFullYear(a, 0, l), s.setHours(0, 0, 0, 0);
  const p = qt(s, t);
  return +n >= +c ? a + 1 : +n >= +p ? a : a - 1;
}
function Af(e, t) {
  const n = nn(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, o = lr(e, t), l = lt(t?.in || e, 0);
  return l.setFullYear(o, 0, a), l.setHours(0, 0, 0, 0), qt(l, t);
}
function rr(e, t) {
  const n = He(e, t?.in), a = +qt(n, t) - +Af(n, t);
  return Math.round(a / Pi) + 1;
}
function rt(e, t) {
  const n = e < 0 ? "-" : "", a = Math.abs(e).toString().padStart(t, "0");
  return n + a;
}
const Ba = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), a = n > 0 ? n : 1 - n;
    return rt(t === "yy" ? a % 100 : a, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : rt(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return rt(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return rt(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return rt(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return rt(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return rt(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, a = e.getMilliseconds(), o = Math.trunc(
      a * Math.pow(10, n - 3)
    );
    return rt(o, t.length);
  }
}, sn = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, es = {
  // Era
  G: function(e, t, n) {
    const a = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(a, { width: "narrow" });
      default:
        return n.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const a = e.getFullYear(), o = a > 0 ? a : 1 - a;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return Ba.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, a) {
    const o = lr(e, a), l = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const r = l % 100;
      return rt(r, 2);
    }
    return t === "Yo" ? n.ordinalNumber(l, { unit: "year" }) : rt(l, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Vi(e);
    return rt(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return rt(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(a);
      // 01, 02, 03, 04
      case "QQ":
        return rt(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const a = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(a);
      // 01, 02, 03, 04
      case "qq":
        return rt(a, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const a = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Ba.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const a = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(a + 1);
      // 01, 02, ..., 12
      case "LL":
        return rt(a + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, a) {
    const o = rr(e, a);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : rt(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const a = or(e);
    return t === "Io" ? n.ordinalNumber(a, { unit: "week" }) : rt(a, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Ba.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const a = zf(e);
    return t === "Do" ? n.ordinalNumber(a, { unit: "dayOfYear" }) : rt(a, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const a = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, a) {
    const o = e.getDay(), l = (o - a.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(l);
      // Padded numerical value
      case "ee":
        return rt(l, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(l, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, a) {
    const o = e.getDay(), l = (o - a.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(l);
      // Padded numerical value
      case "cc":
        return rt(l, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(l, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const a = e.getDay(), o = a === 0 ? 7 : a;
    switch (t) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return rt(o, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const a = e.getHours();
    let o;
    switch (a === 12 ? o = sn.noon : a === 0 ? o = sn.midnight : o = a / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const a = e.getHours();
    let o;
    switch (a >= 17 ? o = sn.evening : a >= 12 ? o = sn.afternoon : a >= 4 ? o = sn.morning : o = sn.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let a = e.getHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, { unit: "hour" });
    }
    return Ba.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Ba.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const a = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(a, { unit: "hour" }) : rt(a, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let a = e.getHours();
    return a === 0 && (a = 24), t === "ko" ? n.ordinalNumber(a, { unit: "hour" }) : rt(a, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Ba.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Ba.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Ba.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const a = e.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return as(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return qa(a);
      // Hours and minutes with `:` delimiter
      default:
        return qa(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return as(a);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return qa(a);
      // Hours and minutes with `:` delimiter
      default:
        return qa(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ts(a, ":");
      default:
        return "GMT" + qa(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const a = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + ts(a, ":");
      default:
        return "GMT" + qa(a, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const a = Math.trunc(+e / 1e3);
    return rt(a, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return rt(+e, t.length);
  }
};
function ts(e, t = "") {
  const n = e > 0 ? "-" : "+", a = Math.abs(e), o = Math.trunc(a / 60), l = a % 60;
  return l === 0 ? n + String(o) : n + String(o) + t + rt(l, 2);
}
function as(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + rt(Math.abs(e) / 60, 2) : qa(e, t);
}
function qa(e, t = "") {
  const n = e > 0 ? "-" : "+", a = Math.abs(e), o = rt(Math.trunc(a / 60), 2), l = rt(a % 60, 2);
  return n + o + t + l;
}
const ns = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    default:
      return t.date({ width: "full" });
  }
}, ji = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    default:
      return t.time({ width: "full" });
  }
}, Lf = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], a = n[1], o = n[2];
  if (!o)
    return ns(e, t);
  let l;
  switch (a) {
    case "P":
      l = t.dateTime({ width: "short" });
      break;
    case "PP":
      l = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      l = t.dateTime({ width: "long" });
      break;
    default:
      l = t.dateTime({ width: "full" });
      break;
  }
  return l.replace("{{date}}", ns(a, t)).replace("{{time}}", ji(o, t));
}, xl = {
  p: ji,
  P: Lf
}, Ef = /^D+$/, If = /^Y+$/, Rf = ["D", "DD", "YY", "YYYY"];
function Wi(e) {
  return Ef.test(e);
}
function Ui(e) {
  return If.test(e);
}
function $l(e, t, n) {
  const a = Pf(e, t, n);
  if (console.warn(a), Rf.includes(e)) throw new RangeError(a);
}
function Pf(e, t, n) {
  const a = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${a} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Of = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Vf = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Hf = /^'([^]*?)'?$/, Nf = /''/g, Ff = /[a-zA-Z]/;
function yt(e, t, n) {
  const a = nn(), o = n?.locale ?? a.locale ?? Yi, l = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? a.firstWeekContainsDate ?? a.locale?.options?.firstWeekContainsDate ?? 1, r = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? a.weekStartsOn ?? a.locale?.options?.weekStartsOn ?? 0, c = He(e, n?.in);
  if (!Ut(c))
    throw new RangeError("Invalid time value");
  let s = t.match(Vf).map((d) => {
    const f = d[0];
    if (f === "p" || f === "P") {
      const h = xl[f];
      return h(d, o.formatLong);
    }
    return d;
  }).join("").match(Of).map((d) => {
    if (d === "''")
      return { isToken: !1, value: "'" };
    const f = d[0];
    if (f === "'")
      return { isToken: !1, value: Kf(d) };
    if (es[f])
      return { isToken: !0, value: d };
    if (f.match(Ff))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + f + "`"
      );
    return { isToken: !1, value: d };
  });
  o.localize.preprocessor && (s = o.localize.preprocessor(c, s));
  const p = {
    firstWeekContainsDate: l,
    weekStartsOn: r,
    locale: o
  };
  return s.map((d) => {
    if (!d.isToken) return d.value;
    const f = d.value;
    (!n?.useAdditionalWeekYearTokens && Ui(f) || !n?.useAdditionalDayOfYearTokens && Wi(f)) && $l(f, t, String(e));
    const h = es[f[0]];
    return h(c, f, o.localize, p);
  }).join("");
}
function Kf(e) {
  const t = e.match(Hf);
  return t ? t[1].replace(Nf, "'") : e;
}
function Yf(e, t) {
  return He(e, t?.in).getDay();
}
function jf(e, t) {
  const n = He(e, t?.in), a = n.getFullYear(), o = n.getMonth(), l = lt(n, 0);
  return l.setFullYear(a, o + 1, 0), l.setHours(0, 0, 0, 0), l.getDate();
}
function Wf() {
  return Object.assign({}, nn());
}
function Sa(e, t) {
  return He(e, t?.in).getHours();
}
function Uf(e, t) {
  const n = He(e, t?.in).getDay();
  return n === 0 ? 7 : n;
}
function Va(e, t) {
  return He(e, t?.in).getMinutes();
}
function Qe(e, t) {
  return He(e, t?.in).getMonth();
}
function bn(e) {
  return He(e).getSeconds();
}
function je(e, t) {
  return He(e, t?.in).getFullYear();
}
function va(e, t) {
  return +He(e) > +He(t);
}
function ma(e, t) {
  return +He(e) < +He(t);
}
function pn(e, t) {
  return +He(e) == +He(t);
}
function qf(e, t) {
  const n = Zf(t) ? new t(0) : lt(t, 0);
  return n.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), n.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), n;
}
function Zf(e) {
  return typeof e == "function" && e.prototype?.constructor === e;
}
const Gf = 10;
class qi {
  subPriority = 0;
  validate(t, n) {
    return !0;
  }
}
class Xf extends qi {
  constructor(t, n, a, o, l) {
    super(), this.value = t, this.validateValue = n, this.setValue = a, this.priority = o, l && (this.subPriority = l);
  }
  validate(t, n) {
    return this.validateValue(t, this.value, n);
  }
  set(t, n, a) {
    return this.setValue(t, n, this.value, a);
  }
}
class Qf extends qi {
  priority = Gf;
  subPriority = -1;
  constructor(t, n) {
    super(), this.context = t || ((a) => lt(n, a));
  }
  set(t, n) {
    return n.timestampIsSet ? t : lt(t, qf(t, this.context));
  }
}
class nt {
  run(t, n, a, o) {
    const l = this.parse(t, n, a, o);
    return l ? {
      setter: new Xf(
        l.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: l.rest
    } : null;
  }
  validate(t, n, a) {
    return !0;
  }
}
class Jf extends nt {
  priority = 140;
  parse(t, n, a) {
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return a.era(t, { width: "abbreviated" }) || a.era(t, { width: "narrow" });
      // A, B
      case "GGGGG":
        return a.era(t, { width: "narrow" });
      default:
        return a.era(t, { width: "wide" }) || a.era(t, { width: "abbreviated" }) || a.era(t, { width: "narrow" });
    }
  }
  set(t, n, a) {
    return n.era = a, t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = ["R", "u", "t", "T"];
}
const _t = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, pa = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Ct(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function ht(e, t) {
  const n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function fa(e, t) {
  const n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  const a = n[1] === "+" ? 1 : -1, o = n[2] ? parseInt(n[2], 10) : 0, l = n[3] ? parseInt(n[3], 10) : 0, r = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: a * (o * Po + l * er + r * Fp),
    rest: t.slice(n[0].length)
  };
}
function Zi(e) {
  return ht(_t.anyDigitsSigned, e);
}
function wt(e, t) {
  switch (e) {
    case 1:
      return ht(_t.singleDigit, t);
    case 2:
      return ht(_t.twoDigits, t);
    case 3:
      return ht(_t.threeDigits, t);
    case 4:
      return ht(_t.fourDigits, t);
    default:
      return ht(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function Do(e, t) {
  switch (e) {
    case 1:
      return ht(_t.singleDigitSigned, t);
    case 2:
      return ht(_t.twoDigitsSigned, t);
    case 3:
      return ht(_t.threeDigitsSigned, t);
    case 4:
      return ht(_t.fourDigitsSigned, t);
    default:
      return ht(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function sr(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    default:
      return 0;
  }
}
function Gi(e, t) {
  const n = t > 0, a = n ? t : 1 - t;
  let o;
  if (a <= 50)
    o = e || 100;
  else {
    const l = a + 50, r = Math.trunc(l / 100) * 100, c = e >= l % 100;
    o = e + r - (c ? 100 : 0);
  }
  return n ? o : 1 - o;
}
function Xi(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class eh extends nt {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];
  parse(t, n, a) {
    const o = (l) => ({
      year: l,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return Ct(wt(4, t), o);
      case "yo":
        return Ct(
          a.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return Ct(wt(n.length, t), o);
    }
  }
  validate(t, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(t, n, a) {
    const o = t.getFullYear();
    if (a.isTwoDigitYear) {
      const r = Gi(
        a.year,
        o
      );
      return t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const l = !("era" in n) || n.era === 1 ? a.year : 1 - a.year;
    return t.setFullYear(l, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class th extends nt {
  priority = 130;
  parse(t, n, a) {
    const o = (l) => ({
      year: l,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return Ct(wt(4, t), o);
      case "Yo":
        return Ct(
          a.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return Ct(wt(n.length, t), o);
    }
  }
  validate(t, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(t, n, a, o) {
    const l = lr(t, o);
    if (a.isTwoDigitYear) {
      const c = Gi(
        a.year,
        l
      );
      return t.setFullYear(
        c,
        0,
        o.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), qt(t, o);
    }
    const r = !("era" in n) || n.era === 1 ? a.year : 1 - a.year;
    return t.setFullYear(r, 0, o.firstWeekContainsDate), t.setHours(0, 0, 0, 0), qt(t, o);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
class ah extends nt {
  priority = 130;
  parse(t, n) {
    return Do(n === "R" ? 4 : n.length, t);
  }
  set(t, n, a) {
    const o = lt(t, 0);
    return o.setFullYear(a, 0, 4), o.setHours(0, 0, 0, 0), wn(o);
  }
  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
class nh extends nt {
  priority = 130;
  parse(t, n) {
    return Do(n === "u" ? 4 : n.length, t);
  }
  set(t, n, a) {
    return t.setFullYear(a, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}
class oh extends nt {
  priority = 120;
  parse(t, n, a) {
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return wt(n.length, t);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return a.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return a.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return a.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return a.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || a.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 4;
  }
  set(t, n, a) {
    return t.setMonth((a - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class lh extends nt {
  priority = 120;
  parse(t, n, a) {
    switch (n) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return wt(n.length, t);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return a.ordinalNumber(t, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return a.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return a.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return a.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || a.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 4;
  }
  set(t, n, a) {
    return t.setMonth((a - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class rh extends nt {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
  priority = 110;
  parse(t, n, a) {
    const o = (l) => l - 1;
    switch (n) {
      // 1, 2, ..., 12
      case "M":
        return Ct(
          ht(_t.month, t),
          o
        );
      // 01, 02, ..., 12
      case "MM":
        return Ct(wt(2, t), o);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return Ct(
          a.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return a.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.month(t, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return a.month(t, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return a.month(t, { width: "wide", context: "formatting" }) || a.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, a) {
    return t.setMonth(a, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class sh extends nt {
  priority = 110;
  parse(t, n, a) {
    const o = (l) => l - 1;
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return Ct(
          ht(_t.month, t),
          o
        );
      // 01, 02, ..., 12
      case "LL":
        return Ct(wt(2, t), o);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return Ct(
          a.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return a.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.month(t, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return a.month(t, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return a.month(t, { width: "wide", context: "standalone" }) || a.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, a) {
    return t.setMonth(a, 1), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function ih(e, t, n) {
  const a = He(e, n?.in), o = rr(a, n) - t;
  return a.setDate(a.getDate() - o * 7), He(a, n?.in);
}
class ch extends nt {
  priority = 100;
  parse(t, n, a) {
    switch (n) {
      case "w":
        return ht(_t.week, t);
      case "wo":
        return a.ordinalNumber(t, { unit: "week" });
      default:
        return wt(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 53;
  }
  set(t, n, a, o) {
    return qt(ih(t, a, o), o);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
function uh(e, t, n) {
  const a = He(e, n?.in), o = or(a, n) - t;
  return a.setDate(a.getDate() - o * 7), a;
}
class dh extends nt {
  priority = 100;
  parse(t, n, a) {
    switch (n) {
      case "I":
        return ht(_t.week, t);
      case "Io":
        return a.ordinalNumber(t, { unit: "week" });
      default:
        return wt(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 53;
  }
  set(t, n, a) {
    return wn(uh(t, a));
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
const ph = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], fh = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class hh extends nt {
  priority = 90;
  subPriority = 1;
  parse(t, n, a) {
    switch (n) {
      case "d":
        return ht(_t.date, t);
      case "do":
        return a.ordinalNumber(t, { unit: "date" });
      default:
        return wt(n.length, t);
    }
  }
  validate(t, n) {
    const a = t.getFullYear(), o = Xi(a), l = t.getMonth();
    return o ? n >= 1 && n <= fh[l] : n >= 1 && n <= ph[l];
  }
  set(t, n, a) {
    return t.setDate(a), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class vh extends nt {
  priority = 90;
  subpriority = 1;
  parse(t, n, a) {
    switch (n) {
      case "D":
      case "DD":
        return ht(_t.dayOfYear, t);
      case "Do":
        return a.ordinalNumber(t, { unit: "date" });
      default:
        return wt(n.length, t);
    }
  }
  validate(t, n) {
    const a = t.getFullYear();
    return Xi(a) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(t, n, a) {
    return t.setMonth(0, a), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function ir(e, t, n) {
  const a = nn(), o = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? a.weekStartsOn ?? a.locale?.options?.weekStartsOn ?? 0, l = He(e, n?.in), r = l.getDay(), s = (t % 7 + 7) % 7, p = 7 - o, d = t < 0 || t > 6 ? t - (r + p) % 7 : (s + p) % 7 - (r + p) % 7;
  return At(l, d, n);
}
class mh extends nt {
  priority = 90;
  parse(t, n, a) {
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return a.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return a.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
      default:
        return a.day(t, { width: "wide", context: "formatting" }) || a.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, a, o) {
    return t = ir(t, a, o), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}
class gh extends nt {
  priority = 90;
  parse(t, n, a, o) {
    const l = (r) => {
      const c = Math.floor((r - 1) / 7) * 7;
      return (r + o.weekStartsOn + 6) % 7 + c;
    };
    switch (n) {
      // 3
      case "e":
      case "ee":
        return Ct(wt(n.length, t), l);
      // 3rd
      case "eo":
        return Ct(
          a.ordinalNumber(t, {
            unit: "day"
          }),
          l
        );
      // Tue
      case "eee":
        return a.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return a.day(t, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
      default:
        return a.day(t, { width: "wide", context: "formatting" }) || a.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.day(t, { width: "short", context: "formatting" }) || a.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, a, o) {
    return t = ir(t, a, o), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T"
  ];
}
class yh extends nt {
  priority = 90;
  parse(t, n, a, o) {
    const l = (r) => {
      const c = Math.floor((r - 1) / 7) * 7;
      return (r + o.weekStartsOn + 6) % 7 + c;
    };
    switch (n) {
      // 3
      case "c":
      case "cc":
        return Ct(wt(n.length, t), l);
      // 3rd
      case "co":
        return Ct(
          a.ordinalNumber(t, {
            unit: "day"
          }),
          l
        );
      // Tue
      case "ccc":
        return a.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.day(t, { width: "short", context: "standalone" }) || a.day(t, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return a.day(t, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return a.day(t, { width: "short", context: "standalone" }) || a.day(t, { width: "narrow", context: "standalone" });
      default:
        return a.day(t, { width: "wide", context: "standalone" }) || a.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || a.day(t, { width: "short", context: "standalone" }) || a.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, a, o) {
    return t = ir(t, a, o), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T"
  ];
}
function wh(e, t, n) {
  const a = He(e, n?.in), o = Uf(a, n), l = t - o;
  return At(a, l, n);
}
class bh extends nt {
  priority = 90;
  parse(t, n, a) {
    const o = (l) => l === 0 ? 7 : l;
    switch (n) {
      // 2
      case "i":
      case "ii":
        return wt(n.length, t);
      // 2nd
      case "io":
        return a.ordinalNumber(t, { unit: "day" });
      // Tue
      case "iii":
        return Ct(
          a.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      // T
      case "iiiii":
        return Ct(
          a.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      // Tu
      case "iiiiii":
        return Ct(
          a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      default:
        return Ct(
          a.day(t, {
            width: "wide",
            context: "formatting"
          }) || a.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || a.day(t, {
            width: "short",
            context: "formatting"
          }) || a.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 7;
  }
  set(t, n, a) {
    return t = wh(t, a), t.setHours(0, 0, 0, 0), t;
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T"
  ];
}
class kh extends nt {
  priority = 80;
  parse(t, n, a) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return a.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, a) {
    return t.setHours(sr(a), 0, 0, 0), t;
  }
  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}
class _h extends nt {
  priority = 80;
  parse(t, n, a) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return a.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, a) {
    return t.setHours(sr(a), 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}
class Ch extends nt {
  priority = 80;
  parse(t, n, a) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return a.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || a.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, a) {
    return t.setHours(sr(a), 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "b", "t", "T"];
}
class xh extends nt {
  priority = 70;
  parse(t, n, a) {
    switch (n) {
      case "h":
        return ht(_t.hour12h, t);
      case "ho":
        return a.ordinalNumber(t, { unit: "hour" });
      default:
        return wt(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 12;
  }
  set(t, n, a) {
    const o = t.getHours() >= 12;
    return o && a < 12 ? t.setHours(a + 12, 0, 0, 0) : !o && a === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(a, 0, 0, 0), t;
  }
  incompatibleTokens = ["H", "K", "k", "t", "T"];
}
class $h extends nt {
  priority = 70;
  parse(t, n, a) {
    switch (n) {
      case "H":
        return ht(_t.hour23h, t);
      case "Ho":
        return a.ordinalNumber(t, { unit: "hour" });
      default:
        return wt(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 23;
  }
  set(t, n, a) {
    return t.setHours(a, 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}
class Sh extends nt {
  priority = 70;
  parse(t, n, a) {
    switch (n) {
      case "K":
        return ht(_t.hour11h, t);
      case "Ko":
        return a.ordinalNumber(t, { unit: "hour" });
      default:
        return wt(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, a) {
    return t.getHours() >= 12 && a < 12 ? t.setHours(a + 12, 0, 0, 0) : t.setHours(a, 0, 0, 0), t;
  }
  incompatibleTokens = ["h", "H", "k", "t", "T"];
}
class Mh extends nt {
  priority = 70;
  parse(t, n, a) {
    switch (n) {
      case "k":
        return ht(_t.hour24h, t);
      case "ko":
        return a.ordinalNumber(t, { unit: "hour" });
      default:
        return wt(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 24;
  }
  set(t, n, a) {
    const o = a <= 24 ? a % 24 : a;
    return t.setHours(o, 0, 0, 0), t;
  }
  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}
class Dh extends nt {
  priority = 60;
  parse(t, n, a) {
    switch (n) {
      case "m":
        return ht(_t.minute, t);
      case "mo":
        return a.ordinalNumber(t, { unit: "minute" });
      default:
        return wt(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 59;
  }
  set(t, n, a) {
    return t.setMinutes(a, 0, 0), t;
  }
  incompatibleTokens = ["t", "T"];
}
class Th extends nt {
  priority = 50;
  parse(t, n, a) {
    switch (n) {
      case "s":
        return ht(_t.second, t);
      case "so":
        return a.ordinalNumber(t, { unit: "second" });
      default:
        return wt(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 59;
  }
  set(t, n, a) {
    return t.setSeconds(a, 0), t;
  }
  incompatibleTokens = ["t", "T"];
}
class Bh extends nt {
  priority = 30;
  parse(t, n) {
    const a = (o) => Math.trunc(o * Math.pow(10, -n.length + 3));
    return Ct(wt(n.length, t), a);
  }
  set(t, n, a) {
    return t.setMilliseconds(a), t;
  }
  incompatibleTokens = ["t", "T"];
}
class zh extends nt {
  priority = 10;
  parse(t, n) {
    switch (n) {
      case "X":
        return fa(
          pa.basicOptionalMinutes,
          t
        );
      case "XX":
        return fa(pa.basic, t);
      case "XXXX":
        return fa(
          pa.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return fa(
          pa.extendedOptionalSeconds,
          t
        );
      default:
        return fa(pa.extended, t);
    }
  }
  set(t, n, a) {
    return n.timestampIsSet ? t : lt(
      t,
      t.getTime() - Mo(t) - a
    );
  }
  incompatibleTokens = ["t", "T", "x"];
}
class Ah extends nt {
  priority = 10;
  parse(t, n) {
    switch (n) {
      case "x":
        return fa(
          pa.basicOptionalMinutes,
          t
        );
      case "xx":
        return fa(pa.basic, t);
      case "xxxx":
        return fa(
          pa.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return fa(
          pa.extendedOptionalSeconds,
          t
        );
      default:
        return fa(pa.extended, t);
    }
  }
  set(t, n, a) {
    return n.timestampIsSet ? t : lt(
      t,
      t.getTime() - Mo(t) - a
    );
  }
  incompatibleTokens = ["t", "T", "X"];
}
class Lh extends nt {
  priority = 40;
  parse(t) {
    return Zi(t);
  }
  set(t, n, a) {
    return [lt(t, a * 1e3), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
class Eh extends nt {
  priority = 20;
  parse(t) {
    return Zi(t);
  }
  set(t, n, a) {
    return [lt(t, a), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
const Ih = {
  G: new Jf(),
  y: new eh(),
  Y: new th(),
  R: new ah(),
  u: new nh(),
  Q: new oh(),
  q: new lh(),
  M: new rh(),
  L: new sh(),
  w: new ch(),
  I: new dh(),
  d: new hh(),
  D: new vh(),
  E: new mh(),
  e: new gh(),
  c: new yh(),
  i: new bh(),
  a: new kh(),
  b: new _h(),
  B: new Ch(),
  h: new xh(),
  H: new $h(),
  K: new Sh(),
  k: new Mh(),
  m: new Dh(),
  s: new Th(),
  S: new Bh(),
  X: new zh(),
  x: new Ah(),
  t: new Lh(),
  T: new Eh()
}, Rh = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ph = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Oh = /^'([^]*?)'?$/, Vh = /''/g, Hh = /\S/, Nh = /[a-zA-Z]/;
function kn(e, t, n, a) {
  const o = () => lt(a?.in || n, NaN), l = Wf(), r = a?.locale ?? l.locale ?? Yi, c = a?.firstWeekContainsDate ?? a?.locale?.options?.firstWeekContainsDate ?? l.firstWeekContainsDate ?? l.locale?.options?.firstWeekContainsDate ?? 1, s = a?.weekStartsOn ?? a?.locale?.options?.weekStartsOn ?? l.weekStartsOn ?? l.locale?.options?.weekStartsOn ?? 0;
  if (!t)
    return e ? o() : He(n, a?.in);
  const p = {
    firstWeekContainsDate: c,
    weekStartsOn: s,
    locale: r
  }, d = [new Qf(a?.in, n)], f = t.match(Ph).map((v) => {
    const x = v[0];
    if (x in xl) {
      const b = xl[x];
      return b(v, r.formatLong);
    }
    return v;
  }).join("").match(Rh), h = [];
  for (let v of f) {
    !a?.useAdditionalWeekYearTokens && Ui(v) && $l(v, t, e), !a?.useAdditionalDayOfYearTokens && Wi(v) && $l(v, t, e);
    const x = v[0], b = Ih[x];
    if (b) {
      const { incompatibleTokens: k } = b;
      if (Array.isArray(k)) {
        const T = h.find(
          (S) => k.includes(S.token) || S.token === x
        );
        if (T)
          throw new RangeError(
            `The format string mustn't contain \`${T.fullToken}\` and \`${v}\` at the same time`
          );
      } else if (b.incompatibleTokens === "*" && h.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${v}\` and any other token at the same time`
        );
      h.push({ token: x, fullToken: v });
      const _ = b.run(
        e,
        v,
        r.match,
        p
      );
      if (!_)
        return o();
      d.push(_.setter), e = _.rest;
    } else {
      if (x.match(Nh))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + x + "`"
        );
      if (v === "''" ? v = "'" : x === "'" && (v = Fh(v)), e.indexOf(v) === 0)
        e = e.slice(v.length);
      else
        return o();
    }
  }
  if (e.length > 0 && Hh.test(e))
    return o();
  const $ = d.map((v) => v.priority).sort((v, x) => x - v).filter((v, x, b) => b.indexOf(v) === x).map(
    (v) => d.filter((x) => x.priority === v).sort((x, b) => b.subPriority - x.subPriority)
  ).map((v) => v[0]);
  let y = He(n, a?.in);
  if (isNaN(+y)) return o();
  const w = {};
  for (const v of $) {
    if (!v.validate(y, p))
      return o();
    const x = v.set(y, w, p);
    Array.isArray(x) ? (y = x[0], Object.assign(w, x[1])) : y = x;
  }
  return y;
}
function Fh(e) {
  return e.match(Oh)[1].replace(Vh, "'");
}
function wo(e, t, n) {
  const [a, o] = on(
    n?.in,
    e,
    t
  );
  return a.getFullYear() === o.getFullYear() && a.getMonth() === o.getMonth();
}
function os(e, t, n) {
  const [a, o] = on(
    n?.in,
    e,
    t
  );
  return +Za(a) == +Za(o);
}
function Fn(e, t, n) {
  return At(e, -t, n);
}
function Kh(e, t) {
  const n = () => lt(t?.in, NaN), o = Uh(e);
  let l;
  if (o.date) {
    const p = qh(o.date, 2);
    l = Zh(p.restDateString, p.year);
  }
  if (!l || isNaN(+l)) return n();
  const r = +l;
  let c = 0, s;
  if (o.time && (c = Gh(o.time), isNaN(c)))
    return n();
  if (o.timezone) {
    if (s = Xh(o.timezone), isNaN(s)) return n();
  } else {
    const p = new Date(r + c), d = He(0, t?.in);
    return d.setFullYear(
      p.getUTCFullYear(),
      p.getUTCMonth(),
      p.getUTCDate()
    ), d.setHours(
      p.getUTCHours(),
      p.getUTCMinutes(),
      p.getUTCSeconds(),
      p.getUTCMilliseconds()
    ), d;
  }
  return He(r + c + s, t?.in);
}
const ro = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Yh = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, jh = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, Wh = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Uh(e) {
  const t = {}, n = e.split(ro.dateTimeDelimiter);
  let a;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? a = n[0] : (t.date = n[0], a = n[1], ro.timeZoneDelimiter.test(t.date) && (t.date = e.split(ro.timeZoneDelimiter)[0], a = e.substr(
    t.date.length,
    e.length
  ))), a) {
    const o = ro.timezone.exec(a);
    o ? (t.time = a.replace(o[1], ""), t.timezone = o[1]) : t.time = a;
  }
  return t;
}
function qh(e, t) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"
  ), a = e.match(n);
  if (!a) return { year: NaN, restDateString: "" };
  const o = a[1] ? parseInt(a[1]) : null, l = a[2] ? parseInt(a[2]) : null;
  return {
    year: l === null ? o : l * 100,
    restDateString: e.slice((a[1] || a[2]).length)
  };
}
function Zh(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  const n = e.match(Yh);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const a = !!n[4], o = En(n[1]), l = En(n[2]) - 1, r = En(n[3]), c = En(n[4]), s = En(n[5]) - 1;
  if (a)
    return av(t, c, s) ? Qh(t, c, s) : /* @__PURE__ */ new Date(NaN);
  {
    const p = /* @__PURE__ */ new Date(0);
    return !ev(t, l, r) || !tv(t, o) ? /* @__PURE__ */ new Date(NaN) : (p.setUTCFullYear(t, l, Math.max(o, r)), p);
  }
}
function En(e) {
  return e ? parseInt(e) : 1;
}
function Gh(e) {
  const t = e.match(jh);
  if (!t) return NaN;
  const n = Xo(t[1]), a = Xo(t[2]), o = Xo(t[3]);
  return nv(n, a, o) ? n * Po + a * er + o * 1e3 : NaN;
}
function Xo(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function Xh(e) {
  if (e === "Z") return 0;
  const t = e.match(Wh);
  if (!t) return 0;
  const n = t[1] === "+" ? -1 : 1, a = parseInt(t[2]), o = t[3] && parseInt(t[3]) || 0;
  return ov(a, o) ? n * (a * Po + o * er) : NaN;
}
function Qh(e, t, n) {
  const a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(e, 0, 4);
  const o = a.getUTCDay() || 7, l = (t - 1) * 7 + n + 1 - o;
  return a.setUTCDate(a.getUTCDate() + l), a;
}
const Jh = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Qi(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function ev(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (Jh[t] || (Qi(e) ? 29 : 28));
}
function tv(e, t) {
  return t >= 1 && t <= (Qi(e) ? 366 : 365);
}
function av(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function nv(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function ov(e, t) {
  return t >= 0 && t <= 59;
}
function Ji(e, t, n) {
  const a = He(e, n?.in), o = a.getFullYear(), l = a.getDate(), r = lt(e, 0);
  r.setFullYear(o, t, 15), r.setHours(0, 0, 0, 0);
  const c = jf(r);
  return a.setMonth(t, Math.min(l, c)), a;
}
function st(e, t, n) {
  let a = He(e, n?.in);
  return isNaN(+a) ? lt(e, NaN) : (t.year != null && a.setFullYear(t.year), t.month != null && (a = Ji(a, t.month)), t.date != null && a.setDate(t.date), t.hours != null && a.setHours(t.hours), t.minutes != null && a.setMinutes(t.minutes), t.seconds != null && a.setSeconds(t.seconds), t.milliseconds != null && a.setMilliseconds(t.milliseconds), a);
}
function lv(e, t, n) {
  const a = He(e, n?.in);
  return a.setHours(t), a;
}
function ec(e, t, n) {
  const a = He(e, n?.in);
  return a.setMilliseconds(t), a;
}
function rv(e, t, n) {
  const a = He(e, n?.in);
  return a.setMinutes(t), a;
}
function tc(e, t, n) {
  const a = He(e, n?.in);
  return a.setSeconds(t), a;
}
function oa(e, t, n) {
  const a = He(e, n?.in);
  return isNaN(+a) ? lt(e, NaN) : (a.setFullYear(t), a);
}
function Ha(e, t, n) {
  return Pt(e, -t, n);
}
function sv(e, t, n) {
  const {
    years: a = 0,
    months: o = 0,
    weeks: l = 0,
    days: r = 0,
    hours: c = 0,
    minutes: s = 0,
    seconds: p = 0
  } = t, d = Ha(e, o + a * 12, n), f = Fn(d, r + l * 7, n), h = s + c * 60, y = (p + h * 60) * 1e3;
  return lt(e, +f - y);
}
function ac(e, t, n) {
  return tr(e, -t, n);
}
const iv = {}, cv = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid meet",
  style: { display: "block", "aspect-ratio": "1/1" }
};
function uv(e, t) {
  return i(), g("svg", cv, [...t[0] || (t[0] = [
    C("path", {
      d: "M12.5 15L7.5 10L12.5 5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Oo = /* @__PURE__ */ se(iv, [["render", uv]]), dv = (e) => {
  const t = Le(), n = m(() => u(e.weekStartsOn) ?? 1), a = () => $t(/* @__PURE__ */ new Date()), o = m(
    () => qt(Xa(e.viewDate.value), { weekStartsOn: n.value })
  ), l = m(() => {
    const $ = u(e.minDate), y = u(e.maxDate), w = $ ? $t($) : null, v = y ? $t(y) : null, x = u(e.isDateNotAllowed), b = a(), k = e.viewDate.value, _ = At(o.value, 41), S = ar({ start: o.value, end: _ }).map((E) => {
      const F = (w ? ma(E, w) : !1) || (v ? va(E, v) : !1), H = x ? x(E) : !1;
      return {
        date: E,
        day: E.getDate(),
        isCurrentMonth: wo(E, k),
        isToday: qp(E, b),
        isDisabled: F || H,
        isNotAllowed: H,
        key: `${E.getFullYear()}-${String(E.getMonth() + 1).padStart(2, "0")}-${String(E.getDate()).padStart(2, "0")}`
      };
    }), M = [];
    for (let E = 0; E < S.length; E += 7)
      M.push(S.slice(E, E + 7));
    return M;
  }), r = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"], c = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"], s = m(
    () => n.value === 1 ? r.map(($, y) => t(`ui.calendar.weekdaysShort[${y}]`, $)) : c.map(($, y) => t(`ui.calendar.weekdaysShortSun[${y}]`, $))
  ), p = m(
    () => t(`ui.calendar.months[${e.viewDate.value.getMonth()}]`, yt(e.viewDate.value, "MMMM"))
  ), d = m(() => e.viewDate.value.getFullYear()), f = m(() => {
    const $ = u(e.minDate);
    if (!$)
      return !0;
    const y = Qr(At(Xa(e.viewDate.value), -1));
    return !ma(y, $t($));
  }), h = m(() => {
    const $ = u(e.maxDate);
    if (!$)
      return !0;
    const y = At(Qr(e.viewDate.value), 1);
    return !va(y, $t($));
  });
  return { weeks: l, weekdayLabels: s, monthLabel: p, year: d, canGoPrev: f, canGoNext: h };
}, ls = (e) => yt(e, "yyyy-MM-dd"), pv = {
  ArrowLeft: (e) => Fn(e, 1),
  ArrowRight: (e) => At(e, 1),
  ArrowUp: (e) => Fn(e, 7),
  ArrowDown: (e) => At(e, 7),
  Home: (e, t) => qt(e, { weekStartsOn: t }),
  End: (e, t) => nr(e, { weekStartsOn: t }),
  PageUp: (e) => Ha(e, 1),
  PageDown: (e) => Pt(e, 1)
}, fv = /* @__PURE__ */ new Set(["Enter", " "]), hv = (e) => {
  const t = N(null), n = m(() => {
    const d = Ne(e.selected);
    return d instanceof Date ? [$t(d)] : Array.isArray(d) ? [$t(d[0]), $t(d[1])] : [];
  }), a = m(() => {
    const d = e.viewDate.value, f = n.value.find(($) => wo($, d));
    if (f)
      return f;
    const h = e.today ? $t(e.today) : $t(/* @__PURE__ */ new Date());
    return wo(h, d) ? h : Xa(d);
  }), o = m(() => t.value ?? a.value), l = m(() => ls(o.value)), r = (d) => {
    e.gridRef.value?.querySelector(`[data-date="${d}"]`)?.focus();
  }, c = async (d) => {
    const f = $t(d);
    t.value = f, wo(f, e.viewDate.value) || e.goToDate(f), await Ye(), r(ls(f));
  }, s = () => {
    const d = l.value;
    for (const f of e.weeks.value)
      for (const h of f)
        if (h.key === d) {
          if (h.isDisabled && !h.isNotAllowed)
            return;
          e.onPick(h.date);
          return;
        }
  };
  return { focusedKey: l, handleKeydown: (d) => {
    const f = pv[d.key], h = fv.has(d.key);
    if (!(!f && !h)) {
      if (d.preventDefault(), d.stopPropagation(), f) {
        const $ = Ne(e.weekStartsOn) ?? 1;
        return c(f(o.value, $));
      }
      s();
    }
  } };
}, vv = (e = {}) => {
  const t = N(e.initialDate ? Xa(e.initialDate) : Xa(/* @__PURE__ */ new Date()));
  return { viewDate: t, prevMonth: () => {
    t.value = Ha(t.value, 1);
  }, nextMonth: () => {
    t.value = Pt(t.value, 1);
  }, goToDate: (l) => {
    const r = Xa(l), c = t.value;
    c.getFullYear() === r.getFullYear() && c.getMonth() === r.getMonth() || (t.value = r);
  } };
}, ya = (e) => yt(e, "yyyy-MM-dd"), rs = (e, t, n) => {
  const a = /* @__PURE__ */ new Set();
  for (const o of e)
    for (const l of o)
      l.key >= t && l.key <= n && a.add(l.key);
  return a;
}, so = /* @__PURE__ */ new Set(), mv = (e) => {
  const t = m(() => {
    const p = Ne(e.selected);
    return p instanceof Date ? /* @__PURE__ */ new Set([ya(p)]) : so;
  }), n = m(() => Ne(e.pendingStart) != null), a = m(() => {
    if (n.value)
      return null;
    const p = Ne(e.selected);
    return Array.isArray(p) ? ya(p[0]) : null;
  }), o = m(() => {
    if (n.value)
      return null;
    const p = Ne(e.selected);
    return Array.isArray(p) ? ya(p[1]) : null;
  }), l = m(() => {
    if (n.value)
      return so;
    const p = a.value, d = o.value;
    return !p || !d ? so : rs(Ne(e.weeks), p, d);
  }), r = m(() => {
    const p = Ne(e.pendingStart), d = Ne(e.hoveredDate);
    if (!p || !d)
      return so;
    const f = ya(p), h = ya(d), [$, y] = f <= h ? [f, h] : [h, f];
    return rs(Ne(e.weeks), $, y);
  }), c = m(() => {
    const p = Ne(e.pendingStart), d = Ne(e.hoveredDate);
    if (!p || !d)
      return null;
    const f = ya(p), h = ya(d);
    return f <= h ? f : h;
  }), s = m(() => {
    const p = Ne(e.pendingStart), d = Ne(e.hoveredDate);
    if (!p || !d)
      return null;
    const f = ya(p), h = ya(d);
    return f <= h ? h : f;
  });
  return { selected: t, rangeStart: a, rangeEnd: o, inRange: l, hoverRange: r, hoverStart: c, hoverEnd: s };
}, gv = ["disabled", "aria-selected", "aria-disabled", "aria-current", "tabindex", "data-autofocus", "data-date"], yv = /* @__PURE__ */ Y({
  __name: "DateCalendarCell",
  props: {
    day: {},
    isSelected: { type: Boolean },
    isRangeStart: { type: Boolean },
    isRangeEnd: { type: Boolean },
    isInRange: { type: Boolean },
    isHoverPreview: { type: Boolean },
    isHoverStart: { type: Boolean },
    isHoverEnd: { type: Boolean },
    isFocused: { type: Boolean }
  },
  emits: ["click", "hover"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = m(() => n.day.isDisabled && !n.day.isNotAllowed), l = m(() => [
      "hp-cal__cell-wrap",
      {
        "hp-cal__cell-wrap--in-range": n.isInRange,
        "hp-cal__cell-wrap--hover": n.isHoverPreview,
        "hp-cal__cell-wrap--range-start": n.isRangeStart,
        "hp-cal__cell-wrap--range-end": n.isRangeEnd,
        "hp-cal__cell-wrap--hover-start": n.isHoverStart,
        "hp-cal__cell-wrap--hover-end": n.isHoverEnd
      }
    ]), r = m(() => [
      "hp-cal__cell",
      {
        "hp-cal__cell--today": n.day.isToday,
        "hp-cal__cell--selected": n.isSelected,
        "hp-cal__cell--range-start": n.isRangeStart,
        "hp-cal__cell--range-end": n.isRangeEnd,
        "hp-cal__cell--hover-start": n.isHoverStart,
        "hp-cal__cell--hover-end": n.isHoverEnd,
        "hp-cal__cell--outside": !n.day.isCurrentMonth,
        "hp-cal__cell--disabled": o.value,
        "hp-cal__cell--not-allowed": n.day.isNotAllowed
      }
    ]), c = () => {
      o.value || a("click", n.day.date);
    }, s = () => {
      n.day.isDisabled || a("hover", n.day.date);
    };
    return (p, d) => (i(), g("div", {
      class: W(l.value)
    }, [
      C("button", {
        type: "button",
        class: W(r.value),
        disabled: o.value,
        "aria-selected": e.isSelected || e.isRangeStart || e.isRangeEnd,
        "aria-disabled": e.day.isDisabled,
        "aria-current": e.day.isToday ? "date" : void 0,
        tabindex: e.isFocused ? 0 : -1,
        "data-autofocus": e.isFocused ? "" : void 0,
        "data-date": e.day.key,
        role: "gridcell",
        onClick: c,
        onMouseenter: s
      }, le(e.day.day), 43, gv)
    ], 2));
  }
}), wv = { class: "hp-cal__panel" }, bv = { class: "hp-cal__header" }, kv = ["disabled", "aria-label"], _v = {
  key: 1,
  class: "hp-cal__nav-spacer"
}, Cv = { class: "hp-cal__title" }, xv = ["aria-label", "value"], $v = ["value"], Sv = ["aria-label", "value", "min", "max"], Mv = ["disabled", "aria-label"], Dv = {
  key: 3,
  class: "hp-cal__nav-spacer"
}, Tv = {
  class: "hp-cal__weekdays",
  role: "row"
}, Bv = ["aria-label"], zv = 366, Sl = /* @__PURE__ */ Y({
  __name: "DateCalendar",
  props: {
    initialDate: { default: void 0 },
    showPrev: { type: Boolean, default: !0 },
    showNext: { type: Boolean, default: !0 },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    weekStartsOn: { default: 1 },
    selected: { default: null },
    hoveredDate: { default: null },
    pendingStart: { default: null },
    monthOffset: {},
    isDateNotAllowed: { type: Function, default: void 0 }
  },
  emits: ["dayClick", "dayHover"],
  setup(e, { expose: t, emit: n }) {
    const a = Le(), o = e, l = n, r = vv({ initialDate: o.initialDate }), c = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], s = m(() => c.map((S, M) => a(`ui.calendar.months[${M}]`, S))), p = m(() => r.viewDate.value.getMonth()), d = m(() => r.viewDate.value.getFullYear()), f = m(() => o.minDate?.getFullYear() ?? 1900), h = m(() => o.maxDate?.getFullYear() ?? 2099), $ = (S) => {
      const M = parseInt(S.target.value, 10);
      if (Number.isNaN(M))
        return;
      const E = new Date(r.viewDate.value);
      E.setMonth(M), r.goToDate(E);
    }, y = (S) => {
      const M = S.target, E = parseInt(M.value, 10);
      if (Number.isNaN(E)) {
        M.value = String(d.value);
        return;
      }
      const F = Math.min(h.value, Math.max(f.value, E));
      M.value = String(F);
      const H = new Date(r.viewDate.value);
      H.setFullYear(F), r.goToDate(H);
    };
    Se(() => o.selected, (S) => {
      const M = o.monthOffset ?? 0;
      if (!S) {
        r.goToDate(Pt(o.initialDate ?? /* @__PURE__ */ new Date(), M));
        return;
      }
      if (S instanceof Date) {
        r.goToDate(Pt(S, M));
        return;
      }
      if (Array.isArray(S)) {
        const [E, F] = S;
        if (M === 0)
          r.goToDate(E);
        else {
          const H = E.getFullYear() === F.getFullYear() && E.getMonth() === F.getMonth();
          r.goToDate(H ? Pt(E, 1) : F);
        }
      }
    }, { immediate: !0 });
    const w = dv({
      viewDate: r.viewDate,
      minDate: Ze(o, "minDate"),
      maxDate: Ze(o, "maxDate"),
      weekStartsOn: Ze(o, "weekStartsOn"),
      isDateNotAllowed: Ze(o, "isDateNotAllowed")
    }), v = mv({
      selected: Ze(o, "selected"),
      hoveredDate: Ze(o, "hoveredDate"),
      pendingStart: Ze(o, "pendingStart"),
      weeks: w.weeks
    }), x = (S) => !!(o.minDate && ma(S, $t(o.minDate)) || o.maxDate && va(S, $t(o.maxDate))), b = (S) => {
      let M = $t(S);
      for (let E = 0; E < zv; E++) {
        if (!x(M) && !(o.isDateNotAllowed?.(M) ?? !1))
          return M;
        M = Fn(M, 1);
      }
      return null;
    }, k = (S) => {
      if (o.isDateNotAllowed?.(S)) {
        const M = b(S);
        M && l("dayClick", M);
        return;
      }
      l("dayClick", S);
    }, _ = N(null), T = hv({
      viewDate: r.viewDate,
      weeks: w.weeks,
      selected: Ze(o, "selected"),
      weekStartsOn: Ze(o, "weekStartsOn"),
      gridRef: _,
      goToDate: r.goToDate,
      onPick: k
    });
    return t({
      viewDate: m(() => r.viewDate.value),
      prevMonth: r.prevMonth,
      nextMonth: r.nextMonth,
      goToDate: r.goToDate,
      weeks: w.weeks
    }), (S, M) => (i(), g("div", wv, [
      C("div", bv, [
        e.showPrev ? (i(), g("button", {
          key: 0,
          type: "button",
          class: "hp-cal__nav",
          disabled: !u(w).canGoPrev.value,
          "aria-label": u(a)("ui.calendar.previousMonth", "Previous month"),
          onClick: M[0] || (M[0] = (E) => u(r).prevMonth())
        }, [
          j(Oo, { class: "hp-cal__nav-icon" })
        ], 8, kv)) : (i(), g("span", _v)),
        C("div", Cv, [
          C("select", {
            class: "hp-cal__title-select",
            "aria-label": u(a)("ui.calendar.month", "Month"),
            value: p.value,
            onChange: $
          }, [
            (i(!0), g(he, null, De(s.value, (E, F) => (i(), g("option", {
              key: F,
              value: F
            }, le(E), 9, $v))), 128))
          ], 40, xv),
          C("input", {
            class: "hp-cal__title-year",
            type: "number",
            inputmode: "numeric",
            "aria-label": u(a)("ui.calendar.year", "Year"),
            value: d.value,
            min: f.value,
            max: h.value,
            onChange: y,
            onBlur: y
          }, null, 40, Sv)
        ]),
        e.showNext ? (i(), g("button", {
          key: 2,
          type: "button",
          class: "hp-cal__nav",
          disabled: !u(w).canGoNext.value,
          "aria-label": u(a)("ui.calendar.nextMonth", "Next month"),
          onClick: M[1] || (M[1] = (E) => u(r).nextMonth())
        }, [
          j(Ka, { class: "hp-cal__nav-icon" })
        ], 8, Mv)) : (i(), g("span", Dv))
      ]),
      C("div", Tv, [
        (i(!0), g(he, null, De(u(w).weekdayLabels.value, (E) => (i(), g("span", {
          key: E,
          class: "hp-cal__weekday",
          role: "columnheader"
        }, le(E), 1))), 128))
      ]),
      C("div", {
        ref_key: "gridRef",
        ref: _,
        class: "hp-cal__grid",
        role: "grid",
        "aria-label": u(a)("ui.calendar.monthYear", "{month} {year}", { month: u(w).monthLabel.value, year: u(w).year.value }),
        onKeydown: M[3] || (M[3] = //@ts-ignore
        (...E) => u(T).handleKeydown && u(T).handleKeydown(...E))
      }, [
        (i(!0), g(he, null, De(u(w).weeks.value, (E, F) => (i(), g("div", {
          key: F,
          class: "hp-cal__row",
          role: "row"
        }, [
          (i(!0), g(he, null, De(E, (H) => (i(), R(yv, {
            key: H.key,
            day: H,
            "is-selected": u(v).selected.value.has(H.key),
            "is-range-start": u(v).rangeStart.value === H.key,
            "is-range-end": u(v).rangeEnd.value === H.key,
            "is-in-range": u(v).inRange.value.has(H.key),
            "is-hover-preview": u(v).hoverRange.value.has(H.key),
            "is-hover-start": u(v).hoverStart.value === H.key,
            "is-hover-end": u(v).hoverEnd.value === H.key,
            "is-focused": H.key === u(T).focusedKey.value,
            onClick: k,
            onHover: M[2] || (M[2] = (te) => l("dayHover", te))
          }, null, 8, ["day", "is-selected", "is-range-start", "is-range-end", "is-in-range", "is-hover-preview", "is-hover-start", "is-hover-end", "is-focused"]))), 128))
        ]))), 128))
      ], 40, Bv)
    ]));
  }
}), Ml = (e) => {
  e.preventDefault(), e.stopPropagation();
}, Gn = (e) => {
  const { isOpen: t, close: n, refocus: a } = e;
  return { handleEscape: (r) => {
    t.value && (Ml(r), n(), a?.());
  }, handleTab: (r) => {
    t.value && (r.stopPropagation(), t.value = !1);
  }, consume: Ml };
}, cr = /* @__PURE__ */ Symbol("DateDropdown"), nc = /* @__PURE__ */ Y({
  __name: "DateDropdown",
  props: /* @__PURE__ */ Xe({
    ariaLabel: { default: void 0 }
  }, {
    isOpen: { type: Boolean, default: !1 },
    isOpenModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["close"], ["update:isOpen"]),
  setup(e, { expose: t, emit: n }) {
    const a = n, o = vt(e, "isOpen"), l = N(null), r = () => {
      l.value?.toggle();
    }, c = () => {
      l.value?.open();
    }, s = () => {
      l.value?.close();
    };
    Dt(cr, {
      toggle: r,
      isOpen: o
    });
    const { handleEscape: p } = Gn({
      isOpen: o,
      close: () => {
        s(), a("close");
      }
    });
    return t({
      open: c,
      close: s,
      toggle: r,
      isOpen: m(() => o.value)
    }), (d, f) => (i(), R(Xt, {
      ref_key: "anchorRef",
      ref: l,
      open: o.value,
      "onUpdate:open": f[0] || (f[0] = (h) => o.value = h),
      type: "popover",
      placement: "bottom-start",
      onClose: f[1] || (f[1] = (h) => a("close"))
    }, {
      default: B(() => [
        j(Jt, {
          class: "hp-cal__anchor",
          onKeydown: sa(u(p), ["escape"])
        }, {
          default: B(() => [
            L(d.$slots, "trigger")
          ]),
          _: 3
        }, 8, ["onKeydown"]),
        j(Qt, {
          class: "hp-cal__dropdown",
          onKeydown: sa(u(p), ["escape"])
        }, {
          default: B(() => [
            L(d.$slots, "default")
          ]),
          _: 3
        }, 8, ["onKeydown"])
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), Av = /^[1-7]$/, bo = (e) => typeof e == "string" && Av.test(e), Lv = (e) => typeof e == "number", Qo = (e) => {
  if (e !== void 0)
    return Lv(e) ? `${e}px` : bo(e) ? `var(--input-w-${e})` : e;
}, Xn = (e) => {
  const t = m(() => ({
    width: bo(e.width) ? e.width : void 0,
    minWidth: bo(e.minWidth) ? e.minWidth : void 0,
    maxWidth: bo(e.maxWidth) ? e.maxWidth : void 0
  })), n = m(() => {
    const a = {}, o = Qo(e.width);
    o && (a["--hp-input-width"] = o);
    const l = Qo(e.minWidth);
    l && (a["--hp-input-min-width"] = l);
    const r = Qo(e.maxWidth);
    return r && (a["--hp-input-max-width"] = r), Object.keys(a).length > 0 ? a : void 0;
  });
  return { cvaSizing: t, styleVars: n };
}, Qn = {
  variant: {
    filled: "hp-input--filled",
    soft: "hp-input--soft",
    outline: "hp-input--outline",
    surface: "hp-input--surface",
    "soft-outlined": "hp-input--outline hp-input--soft-outlined",
    blank: "hp-input--blank",
    underlined: "hp-input--underlined",
    // Cell mode — shared flush class. No own SCSS in Input.scss; the
    // primitive just applies `.hp-cell-primitive` from styles/_cell-primitives.
    cell: "hp-cell-primitive"
  },
  size: {
    1: "hp-input--size-1 hp-icon--size-2",
    2: "hp-input--size-2 hp-icon--size-2",
    3: "hp-input--size-3 hp-icon--size-2",
    4: "hp-input--size-4 hp-icon--size-3",
    5: "hp-input--size-5 hp-icon--size-3"
  },
  disabled: { true: "hp-input--disabled" },
  readOnly: { true: "hp-input--readonly" },
  invalid: { true: "hp-input--invalid" },
  loading: { true: "hp-input--loading" },
  radius: {
    none: "hp-input--radius-none",
    small: "hp-input--radius-small",
    big: "hp-input--radius-big",
    full: "hp-input--radius-full"
  },
  align: {
    left: "hp-input--align-left",
    center: "hp-input--align-center",
    right: "hp-input--align-right"
  },
  width: {
    1: "hp-input--w-1",
    2: "hp-input--w-2",
    3: "hp-input--w-3",
    4: "hp-input--w-4",
    5: "hp-input--w-5",
    6: "hp-input--w-6",
    7: "hp-input--w-7"
  },
  minWidth: {
    1: "hp-input--min-w-1",
    2: "hp-input--min-w-2",
    3: "hp-input--min-w-3",
    4: "hp-input--min-w-4",
    5: "hp-input--min-w-5",
    6: "hp-input--min-w-6",
    7: "hp-input--min-w-7"
  },
  maxWidth: {
    1: "hp-input--max-w-1",
    2: "hp-input--max-w-2",
    3: "hp-input--max-w-3",
    4: "hp-input--max-w-4",
    5: "hp-input--max-w-5",
    6: "hp-input--max-w-6",
    7: "hp-input--max-w-7"
  }
}, Jn = {
  variant: "filled",
  size: "3"
}, Ev = ze("hp-input", {
  variants: Qn,
  defaultVariants: Jn
}), Iv = {}, Rv = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Pv(e, t) {
  return i(), g("svg", Rv, [...t[0] || (t[0] = [
    Nt('<path class="hp-icon" d="M3 10.5002C3 8.00785 3 6.7617 3.5359 5.8335C3.88697 5.22542 4.39192 4.72047 5 4.3694C5.9282 3.8335 7.17436 3.8335 9.66667 3.8335H11.3333C13.8256 3.8335 15.0718 3.8335 16 4.3694C16.6081 4.72047 17.113 5.22542 17.4641 5.8335C18 6.7617 18 8.00785 18 10.5002C18 12.9925 18 14.2386 17.4641 15.1668C17.113 15.7749 16.6081 16.2799 16 16.6309C15.0718 17.1668 13.8256 17.1668 11.3333 17.1668H9.66667C7.17436 17.1668 5.9282 17.1668 5 16.6309C4.39192 16.2799 3.88697 15.7749 3.5359 15.1668C3 14.2386 3 12.9925 3 10.5002Z" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M3 8H18" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M8.5 11.5833L10.5 13.5833L12.5 11.5833" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M7.16663 3V4.66667" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M13.8334 3V4.66667" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const ur = /* @__PURE__ */ se(Iv, [["render", Pv]]), Ov = {}, Vv = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Hv(e, t) {
  return i(), g("svg", Vv, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M6 11.2477L7.876 13.0612C8.19552 13.3701 8.71357 13.3701 9.03309 13.0612L15 7.29291",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const eo = /* @__PURE__ */ se(Ov, [["render", Hv]]), dr = {
  DD: [1, 31, 2],
  MM: [1, 12, 2],
  YY: [0, 99, 2],
  YYYY: [1900, 2099, 4],
  HH: [0, 23, 2],
  hh: [1, 12, 2],
  mm: [0, 59, 2],
  ss: [0, 59, 2]
}, ss = /DD|MM|YYYY|YY|HH|hh|mm|ss|AA/g, Nv = /* @__PURE__ */ new Set(["HH", "hh", "mm", "ss"]), Fv = (e) => {
  const t = [], n = [], a = [], o = [];
  let l = 0, r = 0, c = 0;
  for (; c < e.length; )
    if (e[c] === "{") {
      const d = e.indexOf("}", c);
      if (d === -1) {
        console.warn(`[parseTemplate] Missing closing brace in template: "${e}"`);
        break;
      }
      const f = e.slice(c + 1, d), h = t.length;
      let $ = 0;
      ss.lastIndex = 0;
      let y;
      for (; (y = ss.exec(f)) !== null; ) {
        if (y.index > $) {
          const b = f.slice($, y.index);
          n.push({ text: b, start: l, end: l + b.length }), l += b.length;
        }
        const v = y[0], x = v.length;
        t.push({
          token: v,
          start: l,
          end: l + x,
          length: x,
          group: r
        }), l += x, $ = y.index + v.length;
      }
      if ($ < f.length) {
        const v = f.slice($);
        n.push({ text: v, start: l, end: l + v.length }), l += v.length;
      }
      const w = f.replace(/DD/g, "dd").replace(/\bYYYY\b/g, "yyyy").replace(/\bYY\b/g, "yy").replace(/\bMM\b/g, "MM").replace(/\bHH\b/g, "HH").replace(/\bhh\b/g, "hh").replace(/\bmm\b/g, "mm").replace(/\bss\b/g, "ss");
      a.push(w), o.push([h, t.length - 1]), r++, c = d + 1;
    } else {
      let d = e.indexOf("{", c);
      d === -1 && (d = e.length);
      const f = e.slice(c, d);
      n.push({ text: f, start: l, end: l + f.length }), l += f.length, c = d;
    }
  t.length === 0 && console.warn(`[parseTemplate] No segments found in template: "${e}"`);
  let s = "";
  const p = [
    ...t.map((d) => ({ type: "seg", start: d.start, text: d.token })),
    ...n.map((d) => ({ type: "static", start: d.start, text: d.text }))
  ].sort((d, f) => d.start - f.start);
  for (const d of p)
    s += d.text;
  return {
    segments: t,
    statics: n,
    totalLength: l,
    mask: s,
    groupFormats: a,
    groups: o
  };
}, wa = (e, t) => {
  const n = [...t.mask];
  for (let a = 0; a < t.segments.length; a++) {
    const o = t.segments[a], l = e[a] ?? "";
    for (let r = 0; r < o.length; r++)
      r < l.length && (n[o.start + r] = l[r]);
  }
  return n.join("");
}, oc = (e, t) => {
  const [n, a] = e.groups[t];
  for (let o = n; o <= a; o++)
    if (!Nv.has(e.segments[o].token))
      return !1;
  return !0;
}, Kv = (e, t, n) => {
  if (!e)
    return [];
  const a = [];
  for (let o = 0; o < e.length; o++) {
    const l = e[o], r = t[o], c = n?.has(o) ?? !1;
    if (/\d/.test(l))
      a.push({ char: l, cls: c ? "hp-date-field__char--error" : "hp-date-field__char--typed" });
    else if (r && /[A-Za-z]/.test(l))
      a.push({ char: l, cls: "hp-date-field__char--mask" });
    else {
      const s = o > 0 && /\d/.test(e[o - 1]), p = o < e.length - 1 && /\d/.test(e[o + 1]);
      a.push({
        char: l,
        cls: s && p ? "hp-date-field__char--typed" : "hp-date-field__char--mask"
      });
    }
  }
  return a;
}, is = (e) => {
  let t = -1;
  const n = [];
  for (let a = 0; a < e.groups.length; a++)
    oc(e, a) || t++, n.push(Math.max(0, t));
  return n;
}, lc = (e, t) => {
  const n = dr[e];
  if (!n)
    return !0;
  const [a, o] = n, l = parseInt(t, 10);
  if (t.length === e.length)
    return l >= a && l <= o;
  if (e.length <= 2)
    return !0;
  const r = l * Math.pow(10, e.length - t.length);
  return r + Math.pow(10, e.length - t.length) - 1 >= a && r <= o;
}, Yv = (e, t) => {
  const n = dr[e];
  if (!n)
    return t;
  const [a, o, l] = n, r = parseInt(t, 10), c = Math.min(o, Math.max(a, r));
  return String(c).padStart(l, "0");
}, jv = (e, t, n) => {
  const a = e.getLayout(), o = a.segments[e.activeSegment.value];
  if (!o)
    return;
  const l = dr[o.token];
  if (!l)
    return;
  const [r, c, s] = l, p = e.segmentDigits.value[e.activeSegment.value] ?? "";
  let d;
  if (p.length < o.length) {
    const h = /* @__PURE__ */ new Date();
    d = ({
      DD: h.getDate(),
      MM: h.getMonth() + 1,
      YY: h.getFullYear() % 100,
      YYYY: h.getFullYear(),
      HH: h.getHours(),
      hh: (h.getHours() + 11) % 12 + 1,
      mm: h.getMinutes(),
      ss: h.getSeconds()
    }[o.token] ?? (n > 0 ? r : c)) + n;
  } else
    d = parseInt(p, 10) + n;
  d > c && (d = r), d < r && (d = c);
  const f = [...e.segmentDigits.value];
  f[e.activeSegment.value] = String(d).padStart(s, "0"), e.segmentDigits.value = f, e.displayValue.value = wa(f, a), t.value = e.displayValue.value, e.selectSegment(t, e.activeSegment.value), e.tryComplete();
}, Wv = (e, t, n) => {
  const a = n.target, o = e.getLayout();
  if (n.key === "Tab") {
    const l = a.selectionStart ?? 0, r = e.segmentAtPos(l), c = n.shiftKey ? r - 1 : r + 1;
    c >= 0 && c < o.segments.length && (n.preventDefault(), e.selectSegment(a, c));
    return;
  }
  if (n.key === "ArrowLeft" || n.key === "ArrowRight") {
    n.preventDefault();
    const l = a.selectionStart ?? 0, r = e.segmentAtPos(l), c = o.groups.find(([f, h]) => r >= f && r <= h);
    if (!c)
      return;
    const [s, p] = c, d = n.key === "ArrowLeft" ? r - 1 : r + 1;
    d >= s && d <= p && e.selectSegment(a, d);
    return;
  }
  if (n.key === "ArrowUp" || n.key === "ArrowDown") {
    n.preventDefault();
    const l = n.key === "ArrowUp" ? 1 : -1, r = a.selectionStart ?? 0;
    e.activeSegment.value = e.segmentAtPos(r), (!n.repeat || !t.value) && (t.value = requestAnimationFrame(() => {
      t.value = 0, jv(e, a, l);
    }));
    return;
  }
  if (n.key === "Backspace") {
    n.preventDefault();
    const l = a.selectionStart ?? 0, r = a.selectionEnd ?? l, c = e.segmentAtPos(l), s = o.segments[c];
    if (!s)
      return;
    if (r > l) {
      const d = [...e.segmentDigits.value];
      d[c] = "", e.segmentDigits.value = d, e.displayValue.value = wa(d, o), a.value = e.displayValue.value, e.activeSegment.value = c, a.setSelectionRange(s.start, s.start);
      return;
    }
    const p = l - s.start;
    if (p > 0) {
      const d = e.segmentDigits.value[c] ?? "";
      if (d.length === s.length) {
        const f = [...d];
        let h = p - 1;
        for (; h >= 0 && f[h] === s.token[h]; )
          h--;
        if (h >= 0) {
          f[h] = s.token[h];
          const $ = f.every((w, v) => w === s.token[v]), y = [...e.segmentDigits.value];
          y[c] = $ ? "" : f.join(""), e.segmentDigits.value = y, e.displayValue.value = wa(y, o), a.value = e.displayValue.value, a.setSelectionRange(s.start + h, s.start + h);
        } else if (c > 0) {
          const $ = o.segments[c - 1];
          a.setSelectionRange($.end, $.end), e.activeSegment.value = c - 1;
        }
      } else {
        const f = [...e.segmentDigits.value];
        f[c] = "", e.segmentDigits.value = f, e.displayValue.value = wa(f, o), a.value = e.displayValue.value, a.setSelectionRange(s.start, s.start);
      }
    } else if (c > 0) {
      const d = o.segments[c - 1];
      a.setSelectionRange(d.end, d.end), e.activeSegment.value = c - 1;
    }
    return;
  }
  if (n.key === "Delete") {
    n.preventDefault();
    const l = a.selectionStart ?? 0, r = a.selectionEnd ?? l, c = e.segmentAtPos(l), s = o.segments[c];
    if (!s)
      return;
    if (r > l) {
      const d = [...e.segmentDigits.value];
      d[c] = "", e.segmentDigits.value = d, e.displayValue.value = wa(d, o), a.value = e.displayValue.value, e.activeSegment.value = c, a.setSelectionRange(s.start, s.start);
      return;
    }
    const p = l - s.start;
    if (p < s.length) {
      const d = e.segmentDigits.value[c] ?? "";
      if (d.length === s.length) {
        const f = [...d];
        let h = p;
        for (; h < s.length && f[h] === s.token[h]; )
          h++;
        if (h < s.length) {
          f[h] = s.token[h];
          const $ = f.every((w, v) => w === s.token[v]), y = [...e.segmentDigits.value];
          y[c] = $ ? "" : f.join(""), e.segmentDigits.value = y, e.displayValue.value = wa(y, o), a.value = e.displayValue.value, a.setSelectionRange(l, l);
        }
      }
    } else c < o.segments.length - 1 && (e.selectSegment(a, c + 1), e.activeSegment.value = c + 1);
    return;
  }
  if (/^\d$/.test(n.key)) {
    n.preventDefault();
    const l = a.selectionStart ?? 0, r = e.segmentAtPos(l), c = o.segments[r];
    if (!c)
      return;
    e.activeSegment.value = r;
    const s = Math.min(l - c.start, c.length - 1), p = e.segmentDigits.value[r] ?? c.token, d = [...p.length === c.length ? p : c.token];
    d[s] = n.key;
    const f = d.join(""), h = [...e.segmentDigits.value], $ = f.replace(/\D/g, "");
    $.length === c.length ? h[r] = Yv(c.token, $) : h[r] = f, e.segmentDigits.value = h, e.displayValue.value = wa(h, o), a.value = e.displayValue.value;
    const y = c.start + s + 1;
    y >= c.end && r < o.segments.length - 1 ? (e.selectSegment(a, r + 1), e.tryComplete()) : (a.setSelectionRange(Math.min(y, c.end), Math.min(y, c.end)), $.length === c.length && e.tryComplete());
    return;
  }
  n.key.length === 1 && !n.ctrlKey && !n.metaKey && n.preventDefault();
}, Uv = (e, t) => {
  t.preventDefault();
  const n = t.target, a = e.getLayout(), o = t.clipboardData?.getData("text") ?? "";
  if (a.groups.length === 1) {
    const r = kn(o.trim(), a.groupFormats[0], /* @__PURE__ */ new Date());
    if (Ut(r)) {
      e.onComplete(r);
      return;
    }
  }
  const l = o.replace(/\D/g, "");
  if (l.length === 0) {
    e.isInvalid.value = !0;
    return;
  }
  if (l.length > 0) {
    const r = [...e.segmentDigits.value];
    let c = 0;
    for (let s = 0; s < a.segments.length && c < l.length; s++) {
      const p = a.segments[s], d = l.slice(c, c + p.length);
      if (d.length === p.length && lc(p.token, d))
        r[s] = d, c += p.length;
      else
        break;
    }
    e.segmentDigits.value = r, e.displayValue.value = wa(r, a), n.value = e.displayValue.value, e.selectSegment(n, e.activeSegment.value), e.tryComplete();
  }
}, qv = (e) => {
  const t = { value: 0 };
  return {
    handleKeydown(n) {
      Wv(e, t, n);
    },
    handlePaste(n) {
      Uv(e, n);
    },
    dispose() {
      t.value && (cancelAnimationFrame(t.value), t.value = 0);
    }
  };
}, Zv = (e) => {
  const t = N(""), n = N(0), a = N([]), o = N(!1), l = m(() => Fv(u(e.template))), r = () => l.value, c = N(!1), s = () => {
    if (c.value)
      return;
    const b = r(), k = e.modelValue.value;
    if (!k) {
      a.value = b.segments.map(() => ""), t.value = b.mask;
      return;
    }
    const _ = Array.isArray(k) ? k : [k];
    if (_.length === 0)
      return;
    const T = [], S = is(b);
    for (let M = 0; M < b.groups.length; M++) {
      const [E, F] = b.groups[M], H = S[M] ?? 0, te = _[Math.min(H, _.length - 1)], ie = yt(te, b.groupFormats[M]);
      let ee = 0;
      for (let O = E; O <= F; O++) {
        const z = b.segments[O], D = ie.slice(ee, ee + z.length);
        if (T[O] = D.replace(/\D/g, ""), ee += z.length, O < F) {
          const Z = b.segments[O + 1].start - z.end;
          ee += Z;
        }
      }
    }
    a.value = T, t.value = wa(T, b);
  };
  Se(e.modelValue, s, { immediate: !0 }), Se(() => u(e.template), s);
  const p = (b, k) => {
    const T = r().segments[k];
    T && (n.value = k, b.setSelectionRange(T.start, T.end));
  }, d = (b) => {
    const k = r();
    for (let _ = k.segments.length - 1; _ >= 0; _--)
      if (b >= k.segments[_].start)
        return _;
    return 0;
  }, h = qv({
    getLayout: r,
    segmentDigits: a,
    displayValue: t,
    activeSegment: n,
    isInvalid: o,
    selectSegment: p,
    segmentAtPos: d,
    tryComplete: () => {
      const b = r(), k = a.value;
      if (!b.segments.every((H, te) => (k[te] ?? "").length === H.length)) {
        o.value = !1;
        return;
      }
      const T = e.modelValue.value, M = (Array.isArray(T) ? T : T instanceof Date ? [T] : [/* @__PURE__ */ new Date()]).map((H) => new Date(H)), E = is(b);
      for (let H = 0; H < b.groups.length; H++) {
        const [te, ie] = b.groups[H], ee = E[H];
        let O = "";
        for (let Z = te; Z <= ie; Z++) {
          if (Z > te) {
            const J = b.segments[Z - 1], re = b.segments[Z];
            O += b.mask.slice(J.end, re.start);
          }
          O += k[Z] ?? "";
        }
        const z = M[ee] ?? /* @__PURE__ */ new Date(), D = kn(O, b.groupFormats[H], z);
        if (!Ut(D)) {
          o.value = !0;
          return;
        }
        const P = M[ee] ?? /* @__PURE__ */ new Date();
        oc(b, H) ? M[ee] = new Date(
          P.getFullYear(),
          P.getMonth(),
          P.getDate(),
          D.getHours(),
          D.getMinutes(),
          D.getSeconds()
        ) : M[ee] = new Date(
          D.getFullYear(),
          D.getMonth(),
          D.getDate(),
          P.getHours(),
          P.getMinutes(),
          P.getSeconds()
        );
      }
      o.value = !1, E[E.length - 1] + 1 >= 2 && M.length >= 2 ? e.onComplete?.([M[0], M[1]]) : e.onComplete?.(M[0]);
    },
    onComplete: (b) => e.onComplete?.(b)
  });
  Un(() => {
    h.dispose(), y !== null && (cancelAnimationFrame(y), y = null);
  });
  const $ = (b) => {
    b.preventDefault();
    const k = b.target;
    if (!t.value)
      return;
    const _ = r(), T = k.selectionStart ?? 0, S = d(T), M = _.segments[S];
    if (!M)
      return;
    const [E, F] = _.groups[M.group], H = _.segments[E], te = _.segments[F];
    k.setSelectionRange(H.start, te.end);
  };
  let y = null;
  const w = (b) => {
    if (c.value = !0, b?.target) {
      const k = b.target;
      y = requestAnimationFrame(() => {
        y = null;
        const _ = k.selectionStart ?? 0, T = d(_);
        p(k, T);
      });
    }
  }, v = () => {
    c.value = !1, h.dispose(), s();
  }, x = m(() => {
    const b = r(), k = /* @__PURE__ */ new Set();
    for (let _ = 0; _ < b.segments.length; _++) {
      const T = b.segments[_], S = a.value[_] ?? "";
      if (S.length === T.length && S.replace(/\D/g, "").length === T.length && !lc(T.token, S))
        for (let M = T.start; M < T.end; M++)
          k.add(M);
    }
    return k;
  });
  return {
    displayValue: t,
    activeSegment: n,
    segmentDigits: a,
    handleDblclick: $,
    handleKeydown: h.handleKeydown,
    handlePaste: h.handlePaste,
    isInvalid: o,
    errorPositions: x,
    handleFocus: w,
    handleBlur: v,
    selectSegment: p,
    syncFromModel: s
  };
}, Gv = ["data-theme"], Xv = {
  key: 0,
  class: "hp-input__icon hp-input__icon--prefix"
}, Qv = ["size", "value", "disabled", "readonly", "aria-invalid"], Jv = {
  class: "hp-date-field__overlay",
  "aria-hidden": "true"
}, em = {
  key: 1,
  class: "hp-input__icon hp-input__icon--suffix"
}, tm = {
  key: 2,
  class: "hp-input__icon hp-input__icon--suffix"
}, am = {
  key: 3,
  class: "hp-input__icon hp-input__icon--suffix"
}, Dl = /* @__PURE__ */ Y({
  __name: "DateField",
  props: /* @__PURE__ */ Xe({
    variant: { default: "filled" },
    size: { default: "3" },
    color: { default: void 0 },
    radius: { default: void 0 },
    placeholder: { default: void 0 },
    align: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    readOnly: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 },
    width: { default: void 0 },
    minWidth: { default: void 0 },
    maxWidth: { default: void 0 },
    class: { default: void 0 },
    prefix: { default: void 0 },
    suffix: { default: void 0 },
    template: {},
    clearable: { type: Boolean, default: !1 },
    confirm: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    showDropdownTrigger: { type: Boolean, default: !0 }
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["complete", "clear", "enter", "blur"], ["update:modelValue"]),
  setup(e, { expose: t, emit: n }) {
    const a = Le(), o = e, l = vt(e, "modelValue"), r = pt(cr, null), c = n, s = N(null), p = N(null), d = m(() => o.confirm && p.value !== null), f = () => {
      p.value !== null && (l.value = p.value, c("complete", p.value), p.value = null);
    }, h = Zv({
      template: m(() => o.template),
      modelValue: l,
      onComplete: (ie) => {
        o.confirm ? p.value = ie : (l.value = ie, c("complete", ie));
      },
      onClear: () => {
        l.value = null, p.value = null, c("clear");
      }
    }), $ = ze("hp-input hp-date-field", {
      variants: Qn,
      defaultVariants: Jn
    }), y = m(() => o.invalid || h.isInvalid.value), { cvaSizing: w, styleVars: v } = Xn(o), x = m(
      () => $({
        variant: o.variant,
        size: o.size,
        disabled: o.disabled,
        readOnly: o.readOnly,
        loading: o.loading,
        radius: o.radius,
        align: o.align,
        invalid: y.value,
        width: w.value.width,
        minWidth: w.value.minWidth,
        maxWidth: w.value.maxWidth,
        class: o.class
      }) + (o.fullWidth ? " hp-date-field--full-width" : "")
    ), b = m(() => v.value), k = m(() => o.template.replace(/[{}]/g, "").length), _ = m(() => o.fullWidth ? { width: "auto" } : { width: `${k.value}ch` }), T = m(() => o.placeholder ?? o.template.replace(/[{}]/g, "")), S = m(() => l.value !== null), M = m(
      () => Kv(h.displayValue.value, T.value, h.errorPositions.value)
    ), E = (ie) => {
      h.handleFocus(ie);
    }, F = (ie) => {
      if (ie.key === "Enter") {
        d.value && f(), c("enter", l.value);
        return;
      }
      if (!(ie.key === "Escape" && r?.isOpen.value === !0)) {
        if (ie.key === "Escape" && d.value) {
          Ml(ie), p.value = null, h.syncFromModel();
          return;
        }
        if (ie.key === "Escape") {
          s.value?.blur();
          return;
        }
        h.handleKeydown(ie);
      }
    }, H = () => {
      h.handleBlur(), c("blur", l.value);
    }, te = () => {
      l.value = null, h.syncFromModel(), c("clear"), s.value?.focus();
    };
    return t({
      inputRef: s,
      focus: () => s.value?.focus(),
      blur: () => s.value?.blur(),
      clear: te
    }), (ie, ee) => (i(), g("div", {
      class: W(x.value),
      style: Ie(b.value),
      "data-theme": e.color
    }, [
      ie.$slots.prefix || e.prefix ? (i(), g("span", Xv, [
        L(ie.$slots, "prefix", {}, () => [
          e.prefix ? (i(), R(Pe(e.prefix), { key: 0 })) : A("", !0)
        ])
      ])) : A("", !0),
      C("div", {
        class: "hp-date-field__body",
        style: Ie(_.value)
      }, [
        C("input", {
          ref_key: "inputRef",
          ref: s,
          class: "hp-input__field hp-date-field__input",
          size: k.value,
          value: u(h).displayValue.value,
          disabled: e.disabled,
          readonly: e.readOnly,
          "aria-invalid": y.value || void 0,
          autocomplete: "off",
          onDblclick: ee[0] || (ee[0] = (O) => u(h).handleDblclick(O)),
          onKeydown: F,
          onBeforeinput: ee[1] || (ee[1] = Fe(() => {
          }, ["prevent"])),
          onPaste: ee[2] || (ee[2] = (O) => u(h).handlePaste(O)),
          onFocus: E,
          onBlur: H
        }, null, 40, Qv),
        C("span", Jv, [
          (i(!0), g(he, null, De(M.value, (O, z) => (i(), g("span", {
            key: z,
            class: W(O.cls)
          }, le(O.char), 3))), 128))
        ])
      ], 4),
      d.value ? (i(), g("span", em, [
        j(Rt, {
          variant: "soft",
          size: "1",
          square: "",
          icon: eo,
          class: "hp-date-field__confirm",
          "aria-label": u(a)("ui.calendar.confirm", "Confirm"),
          onClick: Fe(f, ["stop"])
        }, null, 8, ["aria-label"])
      ])) : A("", !0),
      e.clearable && S.value && !d.value ? (i(), g("span", tm, [
        j(Rt, {
          variant: "soft",
          size: "1",
          square: "",
          icon: zt,
          class: "hp-input__clear hp-date-field__clear",
          "aria-label": u(a)("ui.common.clear", "Clear"),
          onClick: Fe(te, ["stop"])
        }, null, 8, ["aria-label"])
      ])) : A("", !0),
      ie.$slots.suffix || e.suffix || u(r) && e.showDropdownTrigger ? (i(), g("span", am, [
        L(ie.$slots, "suffix", {}, () => [
          e.suffix ? (i(), R(Pe(e.suffix), { key: 0 })) : u(r) && e.showDropdownTrigger ? (i(), R(Ae, {
            key: 1,
            icon: ur,
            variant: "blank",
            size: "1",
            square: "",
            "aria-label": u(a)("ui.calendar.openCalendar", "Open calendar"),
            class: "hp-date-field__trigger",
            onClick: Fe(u(r).toggle, ["stop"])
          }, null, 8, ["aria-label", "onClick"])) : A("", !0)
        ])
      ])) : A("", !0)
    ], 14, Gv));
  }
}), nm = {
  scroll: "scrollLeft",
  client: "clientWidth",
  size: "scrollWidth",
  coord: "clientX"
}, om = {
  scroll: "scrollTop",
  client: "clientHeight",
  size: "scrollHeight",
  coord: "clientY"
}, lm = 5, cs = 1, rm = (e, t, n) => {
  const a = n === "x" ? nm : om, o = N(!0), l = N(!0), r = N(!1), c = () => {
    const k = e.value;
    if (!k)
      return;
    const _ = k[a.scroll], T = k[a.client], S = k[a.size];
    r.value = S > T, o.value = _ <= cs, l.value = _ + T >= S - cs;
  }, s = () => {
    c();
  };
  let p = null, d = null, f = null;
  const h = () => {
    d && e.value && e.value.removeEventListener("click", d, !0), d = null;
  }, $ = () => {
    h();
    const k = e.value;
    if (!k)
      return;
    const _ = (T) => {
      T.stopPropagation(), T.preventDefault(), h();
    };
    d = _, k.addEventListener("click", _, !0);
  }, y = (k) => {
    if (!r.value || k.pointerType === "mouse" && k.button !== 0)
      return;
    const _ = e.value;
    _ && (f = {
      pointerId: k.pointerId,
      startCoord: k[a.coord],
      startScroll: _[a.scroll],
      distance: 0,
      dragged: !1
    });
  }, w = (k) => {
    if (!f || f.pointerId !== k.pointerId)
      return;
    const _ = e.value;
    if (!_)
      return;
    const T = f.startCoord - k[a.coord], S = f.startScroll + T;
    if (_[a.scroll] = S, f.distance = Math.abs(T), !f.dragged && f.distance >= lm) {
      f.dragged = !0;
      try {
        _.setPointerCapture(k.pointerId);
      } catch {
      }
      _.dataset.hpDragging = "true";
    }
  }, v = (k) => {
    if (!f || f.pointerId !== k.pointerId)
      return;
    const _ = e.value;
    if (_) {
      try {
        _.releasePointerCapture(k.pointerId);
      } catch {
      }
      delete _.dataset.hpDragging;
    }
    f.dragged && $(), f = null;
  }, x = (k) => {
    k.addEventListener("scroll", s, { passive: !0 }), k.addEventListener("pointerdown", y), k.addEventListener("pointermove", w), k.addEventListener("pointerup", v), k.addEventListener("pointercancel", v);
  }, b = (k) => {
    k.removeEventListener("scroll", s), k.removeEventListener("pointerdown", y), k.removeEventListener("pointermove", w), k.removeEventListener("pointerup", v), k.removeEventListener("pointercancel", v);
  };
  return Se(
    e,
    (k, _) => {
      _ && b(_), k && (x(k), c());
    },
    { immediate: !0 }
  ), Se(
    [e, t],
    ([k, _]) => {
      if (p?.disconnect(), p = null, !(!k || !_)) {
        if (typeof ResizeObserver > "u") {
          c();
          return;
        }
        p = new ResizeObserver(() => c()), p.observe(k), p.observe(_), c();
      }
    },
    { immediate: !0 }
  ), Un(() => {
    p?.disconnect(), p = null, h();
    const k = e.value;
    k && (b(k), delete k.dataset.hpDragging), f = null;
  }), { atStart: o, atEnd: l, isOverflowing: r };
}, sm = {}, im = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid meet",
  style: { display: "block", "aspect-ratio": "1/1" }
};
function cm(e, t) {
  return i(), g("svg", im, [...t[0] || (t[0] = [
    C("path", {
      d: "M15 7.5L10 12.5L5 7.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const en = /* @__PURE__ */ se(sm, [["render", cm]]), um = {}, dm = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid meet",
  style: { display: "block", "aspect-ratio": "1/1" }
};
function pm(e, t) {
  return i(), g("svg", dm, [...t[0] || (t[0] = [
    C("path", {
      d: "M15 12.5L10 7.5L5 12.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Tl = /* @__PURE__ */ se(um, [["render", pm]]), fm = ze("hp-scroller-wrap", {
  variants: {
    direction: {
      horizontal: "hp-scroller-wrap--horizontal",
      vertical: "hp-scroller-wrap--vertical"
    }
  },
  defaultVariants: { direction: "horizontal" }
}), hm = ze("hp-scroller", {
  variants: {
    direction: {
      horizontal: "hp-scroller--horizontal",
      vertical: "hp-scroller--vertical"
    },
    atStart: { true: "is-start" },
    atEnd: { true: "is-end" }
  },
  defaultVariants: { direction: "horizontal" }
}), vm = ze("hp-scroller__track", {
  variants: {
    direction: {
      horizontal: "hp-scroller__track--horizontal",
      vertical: "hp-scroller__track--vertical"
    }
  },
  defaultVariants: { direction: "horizontal" }
}), mm = { class: "hp-scroller__arrow hp-scroller__arrow--start" }, gm = { class: "hp-scroller__arrow hp-scroller__arrow--end" }, us = 0.8, rc = /* @__PURE__ */ Y({
  __name: "Scroller",
  props: {
    direction: { default: "horizontal" },
    class: { default: void 0 },
    showArrows: { type: Boolean, default: !0 },
    arrowSize: { default: "1" },
    arrowVariant: { default: "surface" }
  },
  setup(e) {
    const t = Le(), n = e, a = N(null), o = N(null), { atStart: l, atEnd: r, isOverflowing: c } = rm(
      a,
      o,
      n.direction === "horizontal" ? "x" : "y"
    ), s = m(() => [
      fm({ direction: n.direction }),
      n.class
    ]), p = m(
      () => hm({
        direction: n.direction,
        atStart: l.value,
        atEnd: r.value
      })
    ), d = m(() => vm({ direction: n.direction })), f = m(
      () => n.direction === "horizontal" ? Oo : Tl
    ), h = m(
      () => n.direction === "horizontal" ? Ka : en
    ), $ = m(
      () => n.direction === "horizontal" ? t("ui.scroller.scrollToPrevious", "Scroll to previous") : t("ui.scroller.scrollUp", "Scroll up")
    ), y = m(
      () => n.direction === "horizontal" ? t("ui.scroller.scrollToNext", "Scroll to next") : t("ui.scroller.scrollDown", "Scroll down")
    ), w = (v) => {
      const x = a.value;
      x && (n.direction === "horizontal" ? x.scrollBy({ left: v * x.clientWidth * us, behavior: "smooth" }) : x.scrollBy({ top: v * x.clientHeight * us, behavior: "smooth" }));
    };
    return (v, x) => (i(), g("div", {
      class: W(s.value)
    }, [
      C("div", {
        ref_key: "rootRef",
        ref: a,
        class: W(p.value),
        tabindex: "0"
      }, [
        C("div", {
          ref: (b) => o.value = b,
          class: W(d.value)
        }, [
          L(v.$slots, "default")
        ], 2)
      ], 2),
      ra(C("div", mm, [
        j(u(Ae), {
          variant: n.arrowVariant,
          size: n.arrowSize,
          square: "",
          icon: f.value,
          "aria-label": $.value,
          onClick: x[0] || (x[0] = (b) => w(-1))
        }, null, 8, ["variant", "size", "icon", "aria-label"])
      ], 512), [
        [xa, n.showArrows && u(c) && !u(l)]
      ]),
      ra(C("div", gm, [
        j(u(Ae), {
          variant: n.arrowVariant,
          size: n.arrowSize,
          square: "",
          icon: h.value,
          "aria-label": y.value,
          onClick: x[1] || (x[1] = (b) => w(1))
        }, null, 8, ["variant", "size", "icon", "aria-label"])
      ], 512), [
        [xa, n.showArrows && u(c) && !u(r)]
      ])
    ], 2));
  }
}), ym = { class: "hp-cal__presets" }, wm = /* @__PURE__ */ Y({
  __name: "DatePresets",
  props: {
    presets: {}
  },
  emits: ["select"],
  setup(e, { emit: t }) {
    const n = t;
    return (a, o) => e.presets.length > 0 ? (i(), R(u(rc), {
      key: 0,
      "show-arrows": !1,
      class: "hp-cal__presets-scroller"
    }, {
      default: B(() => [
        C("div", ym, [
          (i(!0), g(he, null, De(e.presets, (l) => (i(), R(u(Ae), {
            key: l.label,
            variant: "outline",
            size: "1",
            radius: "full",
            onClick: (r) => n("select", l.value)
          }, {
            default: B(() => [
              me(le(l.label), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]))), 128))
        ])
      ]),
      _: 1
    })) : A("", !0);
  }
}), bm = /* @__PURE__ */ new Set(["script", "style", "template"]), km = (e) => e.replaceAll("&", "&amp;").replaceAll("<", "&lt;").replaceAll(">", "&gt;").replaceAll('"', "&quot;"), _m = (e) => e.replace(/`([^`\n]+)`/g, (t, n) => `<code>${km(n)}</code>`), Cm = (e) => {
  if (!e)
    return;
  const t = e.trim();
  if (t.startsWith("/") || t.startsWith("#") || /^https?:\/\//i.test(t))
    return t;
}, On = (e) => Array.from(e.childNodes).flatMap((t) => $m(t)), xm = (e) => {
  const t = e.tagName.toLowerCase();
  return bm.has(t) ? [] : t === "br" ? [{ kind: "br" }] : t === "code" ? [{ kind: "code", value: e.textContent ?? "" }] : t === "strong" || t === "b" ? [{ kind: "strong", children: On(e) }] : t === "em" || t === "i" ? [{ kind: "em", children: On(e) }] : t === "a" ? [{ kind: "link", href: Cm(e.getAttribute("href")), children: On(e) }] : On(e);
}, $m = (e) => e.nodeType === Node.TEXT_NODE ? e.textContent ? [{ kind: "text", value: e.textContent }] : [] : e instanceof Element ? xm(e) : [], Sm = /`[^`\n]+`|<\/?(?:br|code|strong|b|em|i|a)\b/i, Mm = (e) => {
  if (!Sm.test(e))
    return e ? [{ kind: "text", value: e }] : [];
  const t = document.createElement("template");
  return t.innerHTML = _m(e), On(t.content);
}, ko = (e) => e.map((t) => {
  switch (t.kind) {
    case "text":
      return t.value;
    case "code":
      return na(at, { as: "code", font: "mono", variant: "accent" }, () => t.value);
    case "strong":
      return na("strong", {}, ko(t.children));
    case "em":
      return na("em", {}, ko(t.children));
    case "br":
      return na("br");
    case "link":
      return na(
        at,
        {
          as: "a",
          link: !0,
          ...t.href ? { href: t.href, rel: "noopener noreferrer" } : {}
        },
        () => ko(t.children)
      );
  }
}), sc = Y({
  name: "HintContent",
  props: {
    content: { type: String, default: "" },
    class: { type: String, default: void 0 }
  },
  setup: (e) => () => na("span", { class: ["hp-hint-content", e.class] }, ko(Mm(e.content)))
}), ic = /* @__PURE__ */ Symbol("HoverCard"), cc = () => {
  const e = pt(ic);
  if (!e)
    throw new Error("HoverCard compound components must be used within <HoverCard>");
  return e;
}, pr = /* @__PURE__ */ Y({
  __name: "HoverCard",
  props: {
    placement: { default: "bottom-start" },
    size: { default: "2" },
    delay: { default: 200 },
    hideDelay: { default: 150 },
    color: { default: void 0 }
  },
  setup(e, { expose: t }) {
    const n = e, a = N(!1), o = zi({
      type: "popover",
      variant: "surface",
      placement: n.placement,
      isOpen: a
    });
    Ul({
      contentRef: o.contentRef,
      anchorRef: o.anchorRef,
      isOpen: o.isOpen,
      close: o.close,
      closeOnClickOutside: !0,
      closeOnEscape: !0,
      ignoreAnchorClicks: !0
    });
    const l = Bi({
      triggerRef: o.anchorRef,
      contentRef: o.contentRef,
      isOpen: o.isOpen,
      open: o.open,
      close: o.close,
      showDelay: n.delay,
      hideDelay: n.hideDelay
    });
    return Dt(ic, {
      triggerRef: o.anchorRef,
      size: n.size,
      color: n.color,
      contentRef: o.contentRef,
      contentClass: o.contentClass,
      isOpen: o.isOpen,
      hoverEvents: l
    }), t({
      open: o.open,
      close: o.close,
      isOpen: o.isOpen
    }), (r, c) => L(r.$slots, "default");
  }
}), Dm = ze("hp-hover-card-content", {
  variants: {
    size: {
      1: "hp-hover-card-content--size-1",
      2: "hp-hover-card-content--size-2",
      3: "hp-hover-card-content--size-3",
      4: "hp-hover-card-content--size-4",
      5: "hp-hover-card-content--size-5",
      6: "hp-hover-card-content--size-6",
      7: "hp-hover-card-content--size-7"
    }
  },
  defaultVariants: {
    size: "2"
  }
}), Tm = ["data-theme"], fr = /* @__PURE__ */ Y({
  __name: "HoverCardContent",
  props: {
    class: {}
  },
  setup(e) {
    const t = e, { contentRef: n, contentClass: a, size: o, color: l, hoverEvents: r } = cc(), c = m(() => Dm({ size: o }));
    return (s, p) => (i(), g("div", {
      ref_key: "contentRef",
      ref: n,
      popover: "manual",
      role: "dialog",
      "aria-modal": "false",
      class: W([u(a), c.value, t.class]),
      "data-theme": u(l),
      onMouseenter: p[0] || (p[0] = //@ts-ignore
      (...d) => u(r).onContentMouseEnter && u(r).onContentMouseEnter(...d)),
      onMouseleave: p[1] || (p[1] = //@ts-ignore
      (...d) => u(r).onContentMouseLeave && u(r).onContentMouseLeave(...d))
    }, [
      L(s.$slots, "default")
    ], 42, Tm));
  }
}), hr = /* @__PURE__ */ Y({
  __name: "HoverCardTrigger",
  setup(e) {
    const { triggerRef: t, hoverEvents: n } = cc();
    return (a, o) => (i(), g("span", {
      ref_key: "triggerRef",
      ref: t,
      class: "hp-hover-card-trigger",
      onMouseenter: o[0] || (o[0] = //@ts-ignore
      (...l) => u(n).onTriggerMouseEnter && u(n).onTriggerMouseEnter(...l)),
      onMouseleave: o[1] || (o[1] = //@ts-ignore
      (...l) => u(n).onTriggerMouseLeave && u(n).onTriggerMouseLeave(...l)),
      onFocus: o[2] || (o[2] = //@ts-ignore
      (...l) => u(n).onTriggerFocus && u(n).onTriggerFocus(...l)),
      onBlur: o[3] || (o[3] = //@ts-ignore
      (...l) => u(n).onTriggerBlur && u(n).onTriggerBlur(...l)),
      onClick: o[4] || (o[4] = //@ts-ignore
      (...l) => u(n).onTriggerClick && u(n).onTriggerClick(...l))
    }, [
      L(a.$slots, "default")
    ], 544));
  }
}), Bm = {}, zm = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Am(e, t) {
  return i(), g("svg", zm, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M6.3999 7.00358C6.64186 6.33555 7.11944 5.77224 7.74805 5.41342C8.37667 5.05461 9.11575 4.92345 9.83439 5.04317C10.553 5.16289 11.2049 5.52576 11.6744 6.06753C12.144 6.60929 12.401 7.29497 12.3999 8.00313C12.3999 10.0022 9.31242 11.0018 9.31242 11.0018",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M9.39474 15H9.40504",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Lm = /* @__PURE__ */ se(Bm, [["render", Am]]), Bl = /* @__PURE__ */ Y({
  __name: "InfoBadge",
  props: {
    variant: { default: "soft" },
    size: { default: "1" },
    color: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    square: { type: Boolean, default: !0 },
    radius: { default: "full" },
    iconSize: { default: void 0 },
    active: { type: Boolean, default: !1 },
    rotateIcon: { type: Boolean },
    dismissible: { type: Boolean, default: !1 },
    dismissTabindex: { default: void 0 },
    draggable: { type: Boolean, default: !1 },
    prefix: { default: void 0 },
    suffix: { default: void 0 },
    icon: { default: void 0 },
    clickable: { type: Boolean, default: !1 },
    hoverControls: { type: Boolean, default: !1 },
    wrap: { type: Boolean, default: !1 },
    truncate: { type: Boolean, default: !1 },
    maxWidth: { default: void 0 },
    class: { default: void 0 },
    content: { default: void 0 },
    placement: { default: "top-end" },
    popoverSize: { default: "1" },
    delay: { default: 150 },
    contentClass: { default: void 0 }
  },
  setup(e) {
    const t = e, n = m(() => t.icon ?? Lm);
    return (a, o) => (i(), R(pr, {
      placement: e.placement,
      size: e.popoverSize,
      delay: e.delay,
      color: e.color
    }, {
      default: B(() => [
        j(hr, null, {
          default: B(() => [
            j(u(Ht), {
              variant: e.variant,
              size: e.size,
              color: e.color,
              disabled: e.disabled,
              square: e.square,
              radius: e.radius,
              "icon-size": e.iconSize,
              active: e.active,
              dismissible: e.dismissible,
              "dismiss-tabindex": e.dismissTabindex,
              draggable: e.draggable,
              prefix: e.prefix,
              suffix: e.suffix,
              icon: n.value,
              clickable: e.clickable,
              "hover-controls": e.hoverControls,
              wrap: e.wrap,
              truncate: e.truncate,
              "max-width": e.maxWidth,
              class: W(["hp-info-badge", a.$props.class].filter(Boolean).join(" "))
            }, null, 8, ["variant", "size", "color", "disabled", "square", "radius", "icon-size", "active", "dismissible", "dismiss-tabindex", "draggable", "prefix", "suffix", "icon", "clickable", "hover-controls", "wrap", "truncate", "max-width", "class"])
          ]),
          _: 1
        }),
        j(fr, {
          class: W(["hp-hover-card-content--padded", e.contentClass].filter(Boolean).join(" "))
        }, {
          default: B(() => [
            a.$slots.default ? L(a.$slots, "default", { key: 0 }) : (i(), R(u(sc), {
              key: 1,
              content: e.content
            }, null, 8, ["content"]))
          ]),
          _: 3
        }, 8, ["class"])
      ]),
      _: 3
    }, 8, ["placement", "size", "delay", "color"]));
  }
}), uc = /* @__PURE__ */ Symbol("inputGroupSize"), ds = /* @__PURE__ */ Y({
  __name: "InputGroup",
  props: {
    spanCols: {},
    spanRows: {},
    size: { default: "2" },
    required: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    dirty: { type: Boolean, default: !1 },
    alignToLabelled: { type: Boolean, default: !1 },
    controlHeight: { default: "2" },
    class: {}
  },
  setup(e) {
    const t = e;
    Dt(uc, m(() => t.size));
    const n = ze("hp-input-group", {
      variants: {
        size: {
          1: "hp-input-group--size-1",
          2: "hp-input-group--size-2",
          3: "hp-input-group--size-3"
        },
        alignToLabelled: { true: "hp-input-group--align-to-labelled" },
        required: { true: "hp-input-group--required" },
        invalid: { true: "hp-input-group--invalid" },
        disabled: { true: "hp-input-group--disabled" },
        dirty: { true: "hp-input-group--dirty" }
      },
      defaultVariants: {
        size: "2"
      }
    }), a = m(() => [
      n({
        size: t.size,
        alignToLabelled: t.alignToLabelled,
        required: t.required,
        invalid: t.invalid,
        disabled: t.disabled,
        dirty: t.dirty
      }),
      t.class
    ]), o = m(() => {
      const l = {};
      return t.alignToLabelled && (l["--hp-input-group-control-height"] = `var(--input-size-${t.controlHeight}-height)`), t.spanCols && (l["grid-column"] = t.spanCols === "full" ? "1 / -1" : `span ${t.spanCols}`), t.spanRows && (l["grid-row"] = t.spanRows === "full" ? "1 / -1" : `span ${t.spanRows}`), Object.keys(l).length > 0 ? l : void 0;
    });
    return (l, r) => (i(), g("div", {
      class: W(a.value),
      style: Ie(o.value)
    }, [
      e.alignToLabelled ? (i(), R(u(Zn), {
        key: 0,
        class: "hp-input-group__label hp-input-group__label--reserved",
        "aria-hidden": "true"
      })) : A("", !0),
      L(l.$slots, "default")
    ], 6));
  }
}), rM = /* @__PURE__ */ Y({
  __name: "InputGroupError",
  setup(e) {
    const t = pt(uc, N("2")), n = m(() => ({ 1: "1", 2: "1", 3: "2" })[t.value]);
    return (a, o) => (i(), R(u(at), {
      as: "p",
      size: n.value,
      color: "red",
      variant: "surface",
      class: "hp-input-group__error"
    }, {
      default: B(() => [
        L(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["size"]));
  }
}), ps = /* @__PURE__ */ Y({
  __name: "InputGroupLabel",
  setup(e) {
    return (t, n) => (i(), R(u(Zn), {
      as: "label",
      class: "hp-input-group__label"
    }, {
      default: B(() => [
        L(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), Em = (e, t) => ma(e, t) ? [e, t] : [t, e], Im = (e) => {
  const t = N("idle"), n = N(null), a = N(null), o = (c) => {
    const s = $t(c);
    if (t.value === "idle") {
      n.value = s, t.value = "selecting-end";
      return;
    }
    t.value === "selecting-end" && n.value && (e.onSelect(Em(n.value, s)), r());
  }, l = (c) => {
    t.value === "selecting-end" && (a.value = $t(c));
  }, r = () => {
    t.value = "idle", n.value = null, a.value = null;
  };
  return { phase: t, pendingStart: n, hoveredDate: a, handleDayClick: o, handleDayHover: l, reset: r };
}, Rm = {
  class: "hp-cal__summary",
  role: "status",
  "aria-live": "polite"
}, Pm = { key: 0 }, Om = {
  key: 1,
  class: "hp-cal__summary--empty"
}, Vm = /* @__PURE__ */ Y({
  __name: "DateSummary",
  props: {
    value: {},
    dateFormat: { default: void 0 },
    placeholder: { default: "–" }
  },
  setup(e) {
    const t = e, n = m(() => t.dateFormat ?? "dd.MM.yyyy"), a = m(() => {
      if (!t.value)
        return "";
      if (t.value instanceof Date)
        return Ut(t.value) ? yt(t.value, n.value) : "";
      if (Array.isArray(t.value)) {
        const [o, l] = t.value;
        return !Ut(o) || !Ut(l) ? "" : `${yt(o, n.value)} – ${yt(l, n.value)}`;
      }
      return "";
    });
    return (o, l) => (i(), g("div", Rm, [
      L(o.$slots, "default", { text: a.value }, () => [
        a.value ? (i(), g("span", Pm, le(a.value), 1)) : (i(), g("span", Om, le(e.placeholder), 1))
      ])
    ]));
  }
}), Hm = { class: "hp-cal__time" }, Nm = { class: "hp-cal__time-group" }, Fm = { class: "hp-cal__time-label" }, Km = { class: "hp-cal__time-spinner" }, Ym = ["aria-label"], jm = ["value"], Wm = ["aria-label"], Um = { class: "hp-cal__time-group" }, qm = { class: "hp-cal__time-label" }, Zm = { class: "hp-cal__time-spinner" }, Gm = ["aria-label"], Xm = ["value"], Qm = ["aria-label"], zl = /* @__PURE__ */ Y({
  __name: "DateTimeSpinner",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = Le(), a = e, o = t, l = m(
      () => String(a.modelValue.getHours()).padStart(2, "0")
    ), r = m(
      () => String(a.modelValue.getMinutes()).padStart(2, "0")
    ), c = (v) => {
      const x = new Date(a.modelValue);
      x.setHours((x.getHours() + v + 24) % 24), o("update:modelValue", x);
    }, s = (v) => {
      const x = new Date(a.modelValue);
      x.setMinutes((x.getMinutes() + v + 60) % 60), o("update:modelValue", x);
    }, p = (v) => {
      const x = v.replace(/\D/g, "").slice(0, 2);
      if (x === "")
        return;
      const b = Math.min(23, Math.max(0, parseInt(x, 10))), k = new Date(a.modelValue);
      k.setHours(b), o("update:modelValue", k);
    }, d = (v) => {
      const x = v.replace(/\D/g, "").slice(0, 2);
      if (x === "")
        return;
      const b = Math.min(59, Math.max(0, parseInt(x, 10))), k = new Date(a.modelValue);
      k.setMinutes(b), o("update:modelValue", k);
    }, f = (v) => {
      const x = v.target;
      x.value.length === 2 && p(x.value);
    }, h = (v) => {
      const x = v.target;
      x.value.length === 2 && d(x.value);
    }, $ = (v) => {
      p(v.target.value);
    }, y = (v) => {
      d(v.target.value);
    }, w = (v) => {
      v.target.select();
    };
    return (v, x) => (i(), g("div", Hm, [
      C("div", Nm, [
        C("span", Fm, le(u(n)("ui.calendar.hour", "Hour")), 1),
        C("div", Km, [
          C("button", {
            type: "button",
            class: "hp-cal__time-btn",
            "aria-label": u(n)("ui.calendar.increaseHour", "Increase hour"),
            onClick: x[0] || (x[0] = (b) => c(1))
          }, [
            j(Tl, { class: "hp-cal__time-btn-icon" })
          ], 8, Ym),
          C("input", {
            class: "hp-cal__time-input",
            inputmode: "numeric",
            maxlength: "2",
            value: l.value,
            onInput: f,
            onBlur: $,
            onFocus: w
          }, null, 40, jm),
          C("button", {
            type: "button",
            class: "hp-cal__time-btn",
            "aria-label": u(n)("ui.calendar.decreaseHour", "Decrease hour"),
            onClick: x[1] || (x[1] = (b) => c(-1))
          }, [
            j(en, { class: "hp-cal__time-btn-icon" })
          ], 8, Wm)
        ])
      ]),
      x[4] || (x[4] = C("span", { class: "hp-cal__time-sep" }, ":", -1)),
      C("div", Um, [
        C("span", qm, le(u(n)("ui.calendar.minute", "Min")), 1),
        C("div", Zm, [
          C("button", {
            type: "button",
            class: "hp-cal__time-btn",
            "aria-label": u(n)("ui.calendar.increaseMinute", "Increase minute"),
            onClick: x[2] || (x[2] = (b) => s(1))
          }, [
            j(Tl, { class: "hp-cal__time-btn-icon" })
          ], 8, Gm),
          C("input", {
            class: "hp-cal__time-input",
            inputmode: "numeric",
            maxlength: "2",
            value: r.value,
            onInput: h,
            onBlur: y,
            onFocus: w
          }, null, 40, Xm),
          C("button", {
            type: "button",
            class: "hp-cal__time-btn",
            "aria-label": u(n)("ui.calendar.decreaseMinute", "Decrease minute"),
            onClick: x[3] || (x[3] = (b) => s(-1))
          }, [
            j(en, { class: "hp-cal__time-btn-icon" })
          ], 8, Qm)
        ])
      ])
    ]));
  }
}), Jm = { class: "hp-cal hp-cal--range" }, e0 = { class: "hp-cal__panels" }, t0 = {
  key: 1,
  class: "hp-cal__time-columns"
}, sM = /* @__PURE__ */ Y({
  __name: "DateRangePicker",
  props: /* @__PURE__ */ Xe({
    template: { default: void 0 },
    summaryFormat: { default: void 0 },
    presets: { default: () => [] },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    initialDate: { default: void 0 },
    isDateNotAllowed: { type: Function, default: void 0 },
    variant: { default: "filled" },
    size: { default: "3" },
    radius: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    clearable: { type: Boolean, default: !1 },
    joined: { type: Boolean, default: !1 },
    startLabel: { default: void 0 },
    endLabel: { default: void 0 },
    startHint: { default: void 0 },
    endHint: { default: void 0 },
    labelPlacement: { default: "stacked" },
    withTime: { type: Boolean, default: !1 },
    defaultTimes: { type: Function, default: void 0 }
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["apply", "clear", "focus", "blur"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, a = vt(e, "modelValue"), o = t, l = m(() => n.template ?? (n.withTime ? "{DD.MM.YYYY} {HH:mm}" : "{DD.MM.YYYY}")), r = m(() => n.size === "1" || n.size === "2" ? n.size : "3"), c = m(() => [
      "hp-date-range-picker__trigger",
      {
        "hp-date-range-picker__trigger--joined": n.joined,
        "hp-date-range-picker__trigger--labels-inline": !n.joined && n.labelPlacement === "inline"
      },
      n.joined ? Ev({
        variant: n.variant,
        size: n.size,
        disabled: n.disabled
      }) : void 0
    ]), s = N(!1), p = N(null), d = () => n.defaultTimes?.() ?? [/* @__PURE__ */ new Date(), /* @__PURE__ */ new Date()], f = a.value ? null : d(), h = N(a.value?.[0] ? new Date(a.value[0]) : f?.[0] ?? /* @__PURE__ */ new Date()), $ = N(a.value?.[1] ? new Date(a.value[1]) : f?.[1] ?? /* @__PURE__ */ new Date()), y = N(a.value?.[0] ?? null), w = N(a.value?.[1] ?? null);
    Se(a, (H) => {
      y.value = H?.[0] ?? null, w.value = H?.[1] ?? null, H && (h.value = new Date(H[0]), $.value = new Date(H[1]));
    }), Se(s, (H) => {
      if (H && a.value === null) {
        const [te, ie] = d();
        h.value = te, $.value = ie;
      }
    });
    const v = Im({
      onSelect: (H) => {
        p.value = H;
      }
    }), x = () => {
      p.value = null, v.reset(), s.value = !1;
    }, b = (H) => {
      p.value = H, n.withTime && (h.value = new Date(H[0]), $.value = new Date(H[1]));
    }, k = () => {
      x();
    }, _ = (H, te) => {
      const ie = new Date(H);
      return ie.setHours(te.getHours(), te.getMinutes(), 0, 0), ie;
    }, T = m(() => {
      if (!n.withTime || !a.value)
        return !1;
      const [H, te] = a.value;
      return h.value.getHours() !== H.getHours() || h.value.getMinutes() !== H.getMinutes() || $.value.getHours() !== te.getHours() || $.value.getMinutes() !== te.getMinutes();
    }), S = m(() => p.value !== null || T.value), M = () => {
      if (p.value) {
        const H = n.withTime ? [_(p.value[0], h.value), _(p.value[1], $.value)] : p.value;
        a.value = H, o("apply", H);
      } else if (n.withTime && T.value && a.value) {
        const H = [
          _(a.value[0], h.value),
          _(a.value[1], $.value)
        ];
        a.value = H, o("apply", H);
      }
      x();
    }, E = () => {
      y.value instanceof Date && w.value instanceof Date && (a.value = [y.value, w.value]);
    }, F = () => {
      a.value = null, o("clear");
    };
    return (H, te) => (i(), R(nc, {
      "is-open": s.value,
      "onUpdate:isOpen": te[4] || (te[4] = (ie) => s.value = ie),
      onClose: x
    }, {
      trigger: B(() => [
        C("div", {
          class: W(c.value)
        }, [
          j(u(ds), { size: r.value }, {
            default: B(() => [
              !e.joined && e.startLabel ? (i(), R(u(ps), { key: 0 }, {
                default: B(() => [
                  me(le(e.startLabel) + " ", 1),
                  e.startHint ? (i(), R(Bl, {
                    key: 0,
                    content: e.startHint,
                    size: "1",
                    "popover-size": "1"
                  }, null, 8, ["content"])) : A("", !0)
                ]),
                _: 1
              })) : A("", !0),
              j(Dl, {
                modelValue: y.value,
                "onUpdate:modelValue": te[0] || (te[0] = (ie) => y.value = ie),
                template: l.value,
                variant: e.joined ? "blank" : e.variant,
                size: e.size,
                radius: e.radius,
                disabled: e.disabled,
                clearable: e.clearable,
                "show-dropdown-trigger": !e.joined,
                onComplete: E,
                onClear: F
              }, null, 8, ["modelValue", "template", "variant", "size", "radius", "disabled", "clearable", "show-dropdown-trigger"])
            ]),
            _: 1
          }, 8, ["size"]),
          e.joined || !e.startLabel && !e.endLabel ? (i(), g("span", {
            key: 0,
            class: W(["hp-date-range-picker__sep", { "hp-date-range-picker__sep--joined": e.joined }]),
            "aria-hidden": "true"
          }, " – ", 2)) : A("", !0),
          j(u(ds), { size: r.value }, {
            default: B(() => [
              !e.joined && e.endLabel ? (i(), R(u(ps), { key: 0 }, {
                default: B(() => [
                  me(le(e.endLabel) + " ", 1),
                  e.endHint ? (i(), R(Bl, {
                    key: 0,
                    content: e.endHint,
                    size: "1",
                    "popover-size": "1"
                  }, null, 8, ["content"])) : A("", !0)
                ]),
                _: 1
              })) : A("", !0),
              j(Dl, {
                modelValue: w.value,
                "onUpdate:modelValue": te[1] || (te[1] = (ie) => w.value = ie),
                template: l.value,
                variant: e.joined ? "blank" : e.variant,
                size: e.size,
                radius: e.radius,
                disabled: e.disabled,
                clearable: e.clearable,
                onComplete: E,
                onClear: F
              }, null, 8, ["modelValue", "template", "variant", "size", "radius", "disabled", "clearable"])
            ]),
            _: 1
          }, 8, ["size"])
        ], 2)
      ]),
      default: B(() => [
        C("div", Jm, [
          j(Vm, {
            value: p.value ?? a.value,
            "date-format": e.summaryFormat
          }, null, 8, ["value", "date-format"]),
          e.presets.length > 0 ? (i(), R(wm, {
            key: 0,
            presets: e.presets,
            onSelect: b
          }, null, 8, ["presets"])) : A("", !0),
          C("div", e0, [
            j(Sl, {
              selected: p.value ?? a.value,
              "initial-date": e.initialDate,
              "min-date": e.minDate,
              "max-date": e.maxDate,
              "is-date-not-allowed": e.isDateNotAllowed,
              "month-offset": 0,
              "hovered-date": u(v).hoveredDate.value,
              "pending-start": u(v).pendingStart.value,
              onDayClick: u(v).handleDayClick,
              onDayHover: u(v).handleDayHover
            }, null, 8, ["selected", "initial-date", "min-date", "max-date", "is-date-not-allowed", "hovered-date", "pending-start", "onDayClick", "onDayHover"]),
            j(Sl, {
              selected: p.value ?? a.value,
              "initial-date": e.initialDate,
              "min-date": e.minDate,
              "max-date": e.maxDate,
              "is-date-not-allowed": e.isDateNotAllowed,
              "month-offset": 1,
              "hovered-date": u(v).hoveredDate.value,
              "pending-start": u(v).pendingStart.value,
              onDayClick: u(v).handleDayClick,
              onDayHover: u(v).handleDayHover
            }, null, 8, ["selected", "initial-date", "min-date", "max-date", "is-date-not-allowed", "hovered-date", "pending-start", "onDayClick", "onDayHover"])
          ]),
          e.withTime ? (i(), g("div", t0, [
            j(zl, {
              modelValue: h.value,
              "onUpdate:modelValue": te[2] || (te[2] = (ie) => h.value = ie)
            }, null, 8, ["modelValue"]),
            j(zl, {
              modelValue: $.value,
              "onUpdate:modelValue": te[3] || (te[3] = (ie) => $.value = ie)
            }, null, 8, ["modelValue"])
          ])) : A("", !0),
          j(Ri, {
            "can-apply": S.value,
            onCancel: k,
            onApply: M
          }, null, 8, ["can-apply"])
        ])
      ]),
      _: 1
    }, 8, ["is-open"]));
  }
}), a0 = { class: "hp-cal hp-cal--single" }, n0 = {
  key: 0,
  class: "hp-cal__time"
}, iM = /* @__PURE__ */ Y({
  __name: "DateSinglePicker",
  props: /* @__PURE__ */ Xe({
    template: { default: void 0 },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    initialDate: { default: void 0 },
    isDateNotAllowed: { type: Function, default: void 0 },
    variant: { default: "filled" },
    size: { default: "3" },
    color: { default: void 0 },
    radius: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    clearable: { type: Boolean, default: !1 },
    placeholder: { default: void 0 },
    fullWidth: { type: Boolean, default: !1 },
    withTime: { type: Boolean, default: !1 }
  }, {
    modelValue: { default: null },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["apply", "clear"], ["update:modelValue"]),
  setup(e, { expose: t, emit: n }) {
    const a = e, o = vt(e, "modelValue"), l = n, r = m(
      () => a.template ?? (a.withTime ? "{DD.MM.YYYY} {HH:mm}" : "{DD.MM.YYYY}")
    ), c = N(!1), s = N(null), p = N(o.value ? new Date(o.value) : /* @__PURE__ */ new Date()), d = N(o.value);
    Se(o, (k) => {
      d.value = k, k && (p.value = new Date(k));
    });
    const f = (k, _) => {
      const T = new Date(k);
      return T.setHours(_.getHours(), _.getMinutes(), 0, 0), T;
    }, h = () => {
      s.value = null, c.value = !1;
    }, $ = (k) => {
      if (a.withTime) {
        s.value = k;
        return;
      }
      o.value = k, l("apply", k), c.value = !1;
    }, y = m(() => s.value ? !0 : a.withTime && o.value ? p.value.getHours() !== o.value.getHours() || p.value.getMinutes() !== o.value.getMinutes() : !1), w = () => {
      const k = s.value ?? o.value;
      if (!k) {
        h();
        return;
      }
      const _ = a.withTime ? f(k, p.value) : k;
      o.value = _, l("apply", _), h();
    }, v = () => {
      h();
    }, x = () => {
      d.value instanceof Date && (o.value = d.value);
    }, b = () => {
      o.value = null, l("clear");
    };
    return t({
      open: () => {
        c.value = !0;
      },
      close: h,
      toggle: () => {
        c.value ? h() : c.value = !0;
      }
    }), (k, _) => (i(), R(nc, {
      "is-open": c.value,
      "onUpdate:isOpen": _[2] || (_[2] = (T) => c.value = T),
      onClose: h
    }, {
      trigger: B(() => [
        j(Dl, {
          modelValue: d.value,
          "onUpdate:modelValue": _[0] || (_[0] = (T) => d.value = T),
          template: r.value,
          variant: e.variant,
          size: e.size,
          color: e.color,
          radius: e.radius,
          disabled: e.disabled,
          clearable: e.clearable,
          placeholder: e.placeholder,
          "full-width": e.fullWidth,
          onComplete: x,
          onClear: b
        }, null, 8, ["modelValue", "template", "variant", "size", "color", "radius", "disabled", "clearable", "placeholder", "full-width"])
      ]),
      default: B(() => [
        C("div", a0, [
          j(Sl, {
            selected: s.value ?? o.value,
            "initial-date": e.initialDate,
            "min-date": e.minDate,
            "max-date": e.maxDate,
            "is-date-not-allowed": e.isDateNotAllowed,
            onDayClick: $
          }, null, 8, ["selected", "initial-date", "min-date", "max-date", "is-date-not-allowed"]),
          e.withTime ? (i(), g("div", n0, [
            j(zl, {
              modelValue: p.value,
              "onUpdate:modelValue": _[1] || (_[1] = (T) => p.value = T)
            }, null, 8, ["modelValue"])
          ])) : A("", !0),
          e.withTime ? (i(), R(Ri, {
            key: 1,
            "can-apply": y.value,
            onCancel: v,
            onApply: w
          }, null, 8, ["can-apply"])) : A("", !0)
        ])
      ]),
      _: 1
    }, 8, ["is-open"]));
  }
}), cM = /* @__PURE__ */ Y({
  __name: "DateTrigger",
  props: {
    isOpen: { type: Boolean, default: void 0 },
    disabled: { type: Boolean, default: !1 },
    size: { default: "1" }
  },
  emits: ["toggle"],
  setup(e, { emit: t }) {
    const n = Le(), a = e, o = t, l = pt(cr, null), r = m(() => a.isOpen ?? l?.isOpen.value ?? !1), c = () => {
      l?.toggle(), o("toggle");
    };
    return (s, p) => (i(), R(Ae, {
      variant: r.value ? "filled" : "soft",
      size: e.size,
      square: "",
      icon: ur,
      disabled: e.disabled,
      "aria-label": r.value ? u(n)("ui.calendar.closeDatePicker", "Close date picker") : u(n)("ui.calendar.openDatePicker", "Open date picker"),
      "aria-expanded": r.value,
      class: "hp-cal__trigger",
      onClick: c
    }, {
      default: B(() => [
        L(s.$slots, "default")
      ]),
      _: 3
    }, 8, ["variant", "size", "disabled", "aria-label", "aria-expanded"]));
  }
}), fs = /* @__PURE__ */ new Map(), To = (e, t) => {
  if (e === "local")
    return -t.getTimezoneOffset();
  if (e === "UTC")
    return 0;
  try {
    let n = fs.get(e);
    n || (n = new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "shortOffset"
    }), fs.set(e, n));
    const o = n.formatToParts(t).find((l) => l.type === "timeZoneName");
    if (o) {
      const l = RegExp(/GMT([+-]?)(\d{1,2})(?::(\d{2}))?/).exec(o.value);
      if (l) {
        const r = l[1] === "-" ? -1 : 1, c = parseInt(l[2], 10), s = parseInt(l[3] ?? "0", 10);
        return r * (c * 60 + s);
      }
    }
  } catch {
    console.warn(`[useTimezoneDisplay] Invalid timezone: "${e}"`);
  }
  return 0;
}, hs = (e) => {
  const t = e >= 0 ? "+" : "-", n = Math.abs(e), a = String(Math.floor(n / 60)).padStart(2, "0"), o = String(n % 60).padStart(2, "0");
  return `${t}${a}:${o}`;
}, dc = (e) => {
  const t = () => u(e.timezone), n = () => {
    const l = e.referenceDate?.value;
    return l instanceof Date ? l : /* @__PURE__ */ new Date();
  }, a = m(() => {
    const l = t();
    if (l === "UTC")
      return "UTC";
    const r = l === "local" ? -(/* @__PURE__ */ new Date()).getTimezoneOffset() : To(l, n());
    return hs(r);
  }), o = m(() => {
    const l = t(), r = l === "local" ? -(/* @__PURE__ */ new Date()).getTimezoneOffset() : To(l, n());
    return hs(r);
  });
  return { timezoneLabel: a, timezoneOffset: o };
}, o0 = { class: "hp-date-zone" }, uM = /* @__PURE__ */ Y({
  __name: "DateZone",
  props: {
    timezone: { default: "local" },
    format: { default: "offset" }
  },
  setup(e) {
    const t = e, { timezoneLabel: n, timezoneOffset: a } = dc({
      timezone: m(() => t.timezone)
    }), o = Intl.DateTimeFormat().resolvedOptions().timeZone, l = m(() => t.format === "short" ? t.timezone === "UTC" ? "UTC" : n.value : t.format === "name" ? t.timezone === "local" ? o : t.timezone : a.value);
    return (r, c) => (i(), g("span", o0, [
      L(r.$slots, "default", {
        label: u(n),
        offset: u(a)
      }, () => [
        me(le(l.value), 1)
      ])
    ]));
  }
}), io = (e, t) => {
  if (t === "local")
    return e;
  const n = -e.getTimezoneOffset(), o = (To(t, e) - n) * 6e4;
  return new Date(e.getTime() + o);
}, vs = (e, t) => {
  if (t === "local")
    return e;
  const n = -e.getTimezoneOffset(), o = (To(t, e) - n) * 6e4;
  return new Date(e.getTime() - o);
}, Jo = (e, t) => t === "iso" ? e.toISOString() : t === "timestamp" ? String(e.getTime()) : yt(e, t), l0 = (e, t) => {
  if (t === "iso") {
    const a = Kh(e);
    return Ut(a) ? a : null;
  }
  if (t === "timestamp") {
    const a = Number(e);
    if (Number.isNaN(a))
      return null;
    const o = new Date(a);
    return Ut(o) ? o : null;
  }
  const n = kn(e, t, /* @__PURE__ */ new Date());
  return Ut(n) ? n : null;
}, dM = (e) => {
  const t = () => u(e.outputFormat) ?? "iso", n = () => u(e.timezone) ?? "local", a = m(() => n()), o = m(() => {
    const p = e.modelValue.value;
    return p ? Array.isArray(p) ? p[0] : p : null;
  }), { timezoneLabel: l, timezoneOffset: r } = dc({
    timezone: a,
    referenceDate: o
  });
  return {
    formattedValue: m(() => {
      const p = e.modelValue.value, d = t(), f = n();
      return p ? Array.isArray(p) ? [Jo(io(p[0], f), d), Jo(io(p[1], f), d)] : Jo(io(p, f), d) : null;
    }),
    timezoneLabel: l,
    timezoneOffset: r,
    parseOutputValue: (p) => {
      const d = t(), f = n(), h = l0(p, d);
      return h ? vs(h, f) : null;
    },
    toTimezone: (p) => io(p, n()),
    fromTimezone: (p) => vs(p, n())
  };
}, r0 = ["data-theme"], s0 = /* @__PURE__ */ Y({
  __name: "Card",
  props: {
    variant: { default: "surface" },
    color: {},
    shadow: { type: Boolean, default: !1 },
    noBorder: { type: Boolean, default: !1 },
    interactive: { type: Boolean, default: !1 },
    maxHeight: {},
    class: {}
  },
  setup(e) {
    const t = e, n = ze("hp-card", {
      variants: {
        variant: {
          surface: "hp-card--surface",
          soft: "hp-card--soft",
          transparent: "hp-card--transparent"
        },
        shadow: {
          true: "hp-card--shadow",
          false: ""
        },
        interactive: {
          true: "hp-card--interactive",
          false: ""
        },
        scrollable: {
          true: "hp-card--scrollable",
          false: ""
        },
        noBorder: {
          true: "hp-card--no-border",
          false: ""
        }
      },
      defaultVariants: {
        variant: "surface",
        shadow: !1,
        interactive: !1,
        scrollable: !1,
        noBorder: !1
      }
    }), a = m(() => [
      n({
        variant: t.variant,
        shadow: t.shadow,
        interactive: t.interactive,
        scrollable: !!t.maxHeight,
        noBorder: t.noBorder
      }),
      t.class
    ]), o = m(
      () => t.maxHeight ? { "--card-max-height": t.maxHeight } : void 0
    );
    return (l, r) => (i(), g("div", {
      class: W(a.value),
      style: Ie(o.value),
      "data-theme": e.color
    }, [
      L(l.$slots, "default")
    ], 14, r0));
  }
}), i0 = /* @__PURE__ */ Y({
  __name: "CardBody",
  props: {
    noPadding: { type: Boolean, default: !1 },
    scrollable: { type: Boolean, default: !1 },
    class: {}
  },
  setup(e) {
    const t = e, n = ze("hp-card__body", {
      variants: {
        noPadding: {
          true: "hp-card__body--no-padding",
          false: ""
        },
        scrollable: {
          true: "hp-card__body--scrollable",
          false: ""
        }
      },
      defaultVariants: {
        noPadding: !1,
        scrollable: !1
      }
    }), a = m(() => [
      n({ noPadding: t.noPadding, scrollable: t.scrollable }),
      t.class
    ]);
    return (o, l) => (i(), g("div", {
      class: W(a.value)
    }, [
      L(o.$slots, "default")
    ], 2));
  }
}), pM = /* @__PURE__ */ Y({
  __name: "CardDescription",
  setup(e) {
    return (t, n) => (i(), R(u(at), {
      size: "1",
      variant: "soft",
      class: "hp-card__description"
    }, {
      default: B(() => [
        L(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), c0 = /* @__PURE__ */ Y({
  __name: "CardEmpty",
  props: {
    label: {},
    class: {}
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), g("div", {
      class: W(["hp-card__empty", t.class])
    }, [
      L(n.$slots, "default", {}, () => [
        e.label ? (i(), R(u(at), {
          key: 0,
          size: "3",
          variant: "soft"
        }, {
          default: B(() => [
            me(le(e.label), 1)
          ]),
          _: 1
        })) : A("", !0)
      ])
    ], 2));
  }
}), u0 = /* @__PURE__ */ Y({
  __name: "CardFooter",
  props: {
    divider: { type: Boolean, default: !0 },
    class: {}
  },
  setup(e) {
    const t = e, n = m(() => [
      "hp-card__footer",
      { "hp-card__footer--no-divider": !t.divider },
      t.class
    ]);
    return (a, o) => (i(), g("div", {
      class: W(n.value)
    }, [
      L(a.$slots, "default")
    ], 2));
  }
}), fM = /* @__PURE__ */ Y({
  __name: "CardGrid",
  props: {
    minWidth: { default: "320px" },
    class: {}
  },
  setup(e) {
    const t = e, n = m(() => ({
      "--card-grid-min-width": t.minWidth
    }));
    return (a, o) => (i(), g("div", {
      class: W(["hp-card-grid", t.class]),
      style: Ie(n.value)
    }, [
      L(a.$slots, "default")
    ], 6));
  }
}), d0 = ["data-theme"], ms = /* @__PURE__ */ Y({
  __name: "CardHeaderIcon",
  props: {
    icon: { default: void 0 },
    color: { default: void 0 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = m(() => ["hp-card__header-icon", t.class].filter(Boolean).join(" "));
    return (a, o) => (i(), g("div", {
      class: W(n.value),
      "data-theme": e.color
    }, [
      e.icon ? (i(), R(Pe(e.icon), { key: 0 })) : L(a.$slots, "default", { key: 1 })
    ], 10, d0));
  }
}), p0 = { class: "hp-card__header-left" }, f0 = /* @__PURE__ */ Y({
  __name: "CardHeader",
  props: {
    icon: {},
    iconColor: {},
    divider: { type: Boolean, default: !0 },
    tone: {},
    showClose: { type: Boolean, default: !1 },
    class: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = Le(), a = e, o = t, l = mt(), r = m(() => !!(l.content || l.actions)), c = ze("hp-card__header", {
      variants: {
        tone: {
          dirty: "hp-card__header--tone-dirty"
        }
      }
    }), s = m(() => [
      c({ tone: a.tone }),
      {
        "hp-card__header--no-divider": !a.divider,
        "hp-card__header--grid": r.value
      },
      a.class
    ]);
    return (p, d) => (i(), g("div", {
      class: W(s.value)
    }, [
      r.value ? (i(), g(he, { key: 0 }, [
        C("div", p0, [
          a.icon ? (i(), R(ms, {
            key: 0,
            icon: a.icon,
            color: a.iconColor
          }, null, 8, ["icon", "color"])) : A("", !0),
          L(p.$slots, "default")
        ]),
        L(p.$slots, "content"),
        L(p.$slots, "actions")
      ], 64)) : (i(), g(he, { key: 1 }, [
        a.icon ? (i(), R(ms, {
          key: 0,
          icon: a.icon,
          color: a.iconColor
        }, null, 8, ["icon", "color"])) : A("", !0),
        L(p.$slots, "default")
      ], 64)),
      a.showClose ? (i(), R(Ae, {
        key: 2,
        class: "hp-card__header-close",
        variant: "blank",
        size: "1",
        square: "",
        radius: "full",
        icon: zt,
        "aria-label": u(n)("ui.card.hideSection", "Hide section"),
        title: u(n)("ui.card.hideSection", "Hide section"),
        onClick: d[0] || (d[0] = (f) => o("close"))
      }, null, 8, ["aria-label", "title"])) : A("", !0)
    ], 2));
  }
}), h0 = /* @__PURE__ */ Y({
  __name: "CardHeaderActions",
  props: {
    class: {}
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), g("div", {
      class: W(["hp-card__actions", t.class])
    }, [
      L(n.$slots, "default")
    ], 2));
  }
}), hM = /* @__PURE__ */ Y({
  __name: "CardHeaderContent",
  props: {
    class: {}
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), g("div", {
      class: W(["hp-card__header-content", t.class])
    }, [
      L(n.$slots, "default")
    ], 2));
  }
}), vM = /* @__PURE__ */ Y({
  __name: "CardHeaderSecondary",
  props: {
    background: { default: "default" },
    customColor: {},
    divider: { type: Boolean, default: !0 },
    noPadding: { type: Boolean, default: !1 },
    class: {}
  },
  setup(e) {
    const t = e, n = m(() => [
      "hp-card__header-secondary",
      `hp-card__header-secondary--${t.background}`,
      { "hp-card__header-secondary--no-divider": !t.divider },
      { "hp-card__header-secondary--no-padding": t.noPadding },
      t.class
    ]), a = m(
      () => t.background === "custom" && t.customColor ? { backgroundColor: t.customColor } : void 0
    );
    return (o, l) => (i(), g("div", {
      class: W(n.value),
      style: Ie(a.value)
    }, [
      L(o.$slots, "default")
    ], 6));
  }
}), v0 = ["data-theme"], Mn = /* @__PURE__ */ Y({
  __name: "HorizontalLoader",
  props: {
    loading: { type: Boolean, default: !0 },
    color: { default: void 0 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (n, a) => e.loading ? (i(), g("div", {
      key: 0,
      class: W(["hp-horizontal-loader", t.class]),
      "data-theme": e.color
    }, [...a[0] || (a[0] = [
      C("div", { class: "hp-horizontal-loader__bar" }, null, -1)
    ])], 10, v0)) : A("", !0);
  }
}), m0 = /* @__PURE__ */ Y({
  __name: "CardLoader",
  props: {
    loading: { type: Boolean, default: !0 },
    reserveFooter: { type: Boolean, default: !1 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), g(he, null, [
      j(u(Mn), {
        loading: e.loading,
        class: W(t.class)
      }, null, 8, ["loading", "class"]),
      e.loading && e.reserveFooter ? (i(), R(u0, {
        key: 0,
        class: "hp-card__loading-footer",
        divider: !1,
        "aria-hidden": "true"
      })) : A("", !0)
    ], 64));
  }
}), g0 = {}, y0 = { class: "hp-card__separator" };
function w0(e, t) {
  return i(), g("div", y0);
}
const mM = /* @__PURE__ */ se(g0, [["render", w0]]), b0 = /* @__PURE__ */ Y({
  __name: "CardTitle",
  props: {
    truncate: { type: Boolean, default: !1 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = m(() => ["hp-card__title", t.class].filter(Boolean).join(" "));
    return (a, o) => (i(), R(u($n), {
      size: "5",
      weight: "semibold",
      truncate: t.truncate,
      class: W(n.value)
    }, {
      default: B(() => [
        L(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["truncate", "class"]));
  }
}), k0 = { class: "hp-centered-content__body" }, gM = /* @__PURE__ */ Y({
  __name: "CenteredContent",
  props: {
    maxWidth: { default: "4" }
  },
  setup(e) {
    const t = e, n = ze("hp-centered-content", {
      variants: {
        maxWidth: {
          1: "hp-centered-content--width-1",
          2: "hp-centered-content--width-2",
          3: "hp-centered-content--width-3",
          4: "hp-centered-content--width-4",
          5: "hp-centered-content--width-5",
          6: "hp-centered-content--width-6",
          7: "hp-centered-content--width-7"
        }
      }
    }), a = m(() => n({ maxWidth: t.maxWidth }));
    return (o, l) => (i(), g("div", {
      class: W(a.value)
    }, [
      C("div", k0, [
        L(o.$slots, "default")
      ])
    ], 2));
  }
}), yM = /* @__PURE__ */ Y({
  __name: "ChartCard",
  props: {
    title: {},
    icon: { default: void 0 },
    showClose: { type: Boolean, default: !1 },
    state: { default: "ready" },
    message: { default: void 0 },
    retry: {}
  },
  emits: ["close", "retry"],
  setup(e, { emit: t }) {
    const n = Le(), a = e, o = m(() => a.message ?? n("ui.chart.noData", "No chart data available")), l = t, r = () => {
      a.retry?.(), l("retry");
    };
    return (c, s) => (i(), R(u(s0), { class: "hp-chart-card" }, {
      default: B(() => [
        j(u(f0), {
          icon: e.icon,
          "show-close": e.showClose,
          onClose: s[0] || (s[0] = (p) => l("close"))
        }, it({
          default: B(() => [
            j(u(b0), null, {
              default: B(() => [
                me(le(e.title), 1)
              ]),
              _: 1
            })
          ]),
          _: 2
        }, [
          c.$slots.actions ? {
            name: "actions",
            fn: B(() => [
              j(u(h0), null, {
                default: B(() => [
                  L(c.$slots, "actions")
                ]),
                _: 3
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["icon", "show-close"]),
        j(u(m0), {
          loading: e.state === "loading"
        }, null, 8, ["loading"]),
        j(u(i0), null, {
          default: B(() => [
            e.state !== "loading" ? L(c.$slots, "legend", { key: 0 }) : A("", !0),
            e.state === "empty" ? (i(), R(u(c0), {
              key: 1,
              label: o.value
            }, null, 8, ["label"])) : e.state === "error" ? (i(), R(u(qn), {
              key: 2,
              size: "1",
              color: "red",
              variant: "soft",
              "show-close": !1
            }, it({
              default: B(() => [
                j(u(Mi), null, {
                  default: B(() => [
                    me(le(o.value), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, [
              e.retry ? {
                name: "actions",
                fn: B(() => [
                  j(u(L1), null, {
                    default: B(() => [
                      j(u(Ae), {
                        size: "1",
                        onClick: r
                      }, {
                        default: B(() => [
                          me(le(u(n)("ui.chart.retry", "Retry")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1024)) : e.state !== "loading" ? L(c.$slots, "default", { key: 3 }) : A("", !0)
          ]),
          _: 3
        })
      ]),
      _: 3
    }));
  }
}), _0 = ["aria-label"], C0 = ["aria-label", "aria-pressed", "data-chart-color-index", "onClick"], wM = /* @__PURE__ */ Y({
  __name: "ChartColorSwatches",
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = [0, 1, 2, 3, 4, 5, 6, 7], a = t, o = Le();
    return (l, r) => (i(), g("div", {
      class: "hp-chart-color-swatches",
      role: "group",
      "aria-label": u(o)("ui.chart.chartColor", "Chart color")
    }, [
      (i(), g(he, null, De(n, (c) => C("button", {
        key: c,
        type: "button",
        class: W(["hp-chart-color-swatch", `hp-chart-color-swatch--${c + 1}`]),
        "aria-label": u(o)("ui.chart.colorSwatch", "Chart color {index}", { index: c + 1 }),
        "aria-pressed": e.modelValue === c,
        "data-chart-color-index": c,
        onClick: (s) => a("update:modelValue", c)
      }, null, 10, C0)), 64))
    ], 8, _0));
  }
}), x0 = ["aria-label"], $0 = { class: "hp-chart-key-event-popover__header" }, bM = /* @__PURE__ */ Y({
  __name: "ChartKeyEventsOverlay",
  props: {
    markers: {}
  },
  setup(e) {
    const t = Le(), n = (o, l) => ({
      left: `${String(o)}%`,
      "--chart-key-event-offset-x": `${String(l)}px`
    }), a = {
      "--chart-key-event-guide-opacity": "0.32",
      "--chart-key-event-guide-width": "1px",
      "--chart-key-event-guide-active-width": "1.5px"
    };
    return (o, l) => e.markers.length > 0 ? (i(), g("div", {
      key: 0,
      class: "hp-chart-key-events",
      style: a,
      "aria-label": u(t)("ui.chart.keyEvents", "Key events")
    }, [
      (i(!0), g(he, null, De(e.markers, (r) => (i(), R(u(Xt), {
        key: r.id,
        type: "popover",
        placement: "bottom-start"
      }, {
        default: B(() => [
          j(u(Jt), {
            class: "hp-chart-key-event",
            style: Ie(n(r.leftPercent, r.offsetX)),
            "data-key-event": r.id
          }, {
            default: B((c) => [
              l[0] || (l[0] = C("span", {
                class: "hp-chart-key-event__line",
                "aria-hidden": "true"
              }, null, -1)),
              j(u(Ro), {
                class: "hp-chart-key-event__tooltip",
                text: `${r.label} · ${r.timeLabel}`,
                placement: "top-start",
                disabled: c.isOpen,
                nowrap: ""
              }, {
                default: B(() => [
                  j(u(Ae), {
                    class: "hp-chart-key-event__button",
                    icon: r.icon,
                    color: r.color,
                    size: "1",
                    variant: "filled",
                    radius: "full",
                    square: "",
                    "aria-label": u(t)("ui.chart.openKeyEvent", "Open {label} key event from {time}", { label: r.label, time: r.timeLabel }),
                    onClick: Fe(c.toggle, ["stop"])
                  }, null, 8, ["icon", "color", "aria-label", "onClick"])
                ]),
                _: 2
              }, 1032, ["text", "disabled"])
            ]),
            _: 2
          }, 1032, ["style", "data-key-event"]),
          j(u(Qt), { class: "hp-chart-key-event-popover" }, {
            default: B(() => [
              C("div", $0, [
                j(u(Rt), {
                  color: r.color,
                  variant: "soft-outlined",
                  size: "2"
                }, {
                  default: B(() => [
                    me(le(r.label), 1)
                  ]),
                  _: 2
                }, 1032, ["color"]),
                j(u(at), {
                  size: "2",
                  variant: "soft"
                }, {
                  default: B(() => [
                    me(le(r.timeLabel), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              (i(!0), g(he, null, De(r.details, (c, s) => (i(), R(u(at), {
                key: s,
                size: "2",
                variant: s === 0 ? void 0 : "soft"
              }, {
                default: B(() => [
                  me(le(c), 1)
                ]),
                _: 2
              }, 1032, ["variant"]))), 128))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024))), 128))
    ], 8, x0)) : A("", !0);
  }
}), kM = /* @__PURE__ */ Y({
  __name: "ChartLegend",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), g("div", {
      class: W(["hp-chart-legend", "hp-chart-legend--centered", t.class])
    }, [
      L(n.$slots, "default")
    ], 2));
  }
}), S0 = {}, M0 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function D0(e, t) {
  return i(), g("svg", M0, [...t[0] || (t[0] = [
    C("path", {
      d: "M2.75 13.75L7.25 8.75L10.5 11L17.25 4.75V16.25H2.75V13.75Z",
      fill: "var(--icon-fill, var(--icon-color, currentColor))",
      "fill-opacity": "0.2"
    }, null, -1),
    C("path", {
      d: "M2.75 13.75L7.25 8.75L10.5 11L17.25 4.75",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const T0 = /* @__PURE__ */ se(S0, [["render", D0]]), B0 = {}, z0 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function A0(e, t) {
  return i(), g("svg", z0, [...t[0] || (t[0] = [
    C("rect", {
      x: "3.25",
      y: "10.25",
      width: "2.5",
      height: "6.5",
      rx: "0.75",
      fill: "var(--icon-fill, var(--icon-color, currentColor))"
    }, null, -1),
    C("rect", {
      x: "8.75",
      y: "3.25",
      width: "2.5",
      height: "13.5",
      rx: "0.75",
      fill: "var(--icon-fill, var(--icon-color, currentColor))"
    }, null, -1),
    C("rect", {
      x: "14.25",
      y: "7.25",
      width: "2.5",
      height: "9.5",
      rx: "0.75",
      fill: "var(--icon-fill, var(--icon-color, currentColor))"
    }, null, -1)
  ])]);
}
const pc = /* @__PURE__ */ se(B0, [["render", A0]]), L0 = {}, E0 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function I0(e, t) {
  return i(), g("svg", E0, [...t[0] || (t[0] = [
    C("path", {
      d: "M2.75 13.75L7.25 8.75L10.5 11L17.25 4.75",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const fc = /* @__PURE__ */ se(L0, [["render", I0]]), R0 = {}, P0 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function O0(e, t) {
  return i(), g("svg", P0, [...t[0] || (t[0] = [
    C("path", {
      d: "M2.75 13.75C4.75 13.75 5.25 8.75 7.25 8.75C9.25 8.75 8.5 11 10.5 11C12.5 11 14.25 4.75 17.25 4.75",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const hc = /* @__PURE__ */ se(R0, [["render", O0]]), V0 = ["data-enabled"], H0 = ["data-theme"], N0 = { class: "hp-chart-legend-item__editor" }, _M = /* @__PURE__ */ Y({
  __name: "ChartLegendItem",
  props: {
    label: {},
    configureLabel: { default: void 0 },
    view: { default: "line" },
    filled: { type: Boolean },
    icon: { default: void 0 },
    iconLabel: { default: void 0 },
    enabled: { type: Boolean, default: !0 },
    color: { default: "blue" },
    disabled: { type: Boolean, default: !1 },
    editorOpen: { type: Boolean, default: void 0 }
  },
  emits: ["toggle", "update:enabled", "configure", "update:editorOpen"],
  setup(e, { emit: t }) {
    const n = Le(), a = e, o = t, l = m(() => a.enabled), r = N(!1), c = m({
      get: () => a.editorOpen ?? r.value,
      set: (h) => {
        a.editorOpen === void 0 && (r.value = h), o("update:editorOpen", h);
      }
    }), s = m(() => l.value ? a.color : "default"), p = m(() => a.view === "bar" ? pc : a.filled === !0 ? T0 : a.view === "smooth" ? hc : fc), d = () => {
      if (a.disabled)
        return;
      const h = !l.value;
      o("update:enabled", h), o("toggle", h);
    }, f = (h) => {
      c.value = h, h && o("configure");
    };
    return (h, $) => (i(), g("div", {
      class: "hp-chart-legend-item",
      "data-enabled": l.value
    }, [
      j(u(So), {
        label: e.label,
        items: [],
        variant: "outline",
        size: "2",
        disabled: e.disabled,
        "main-action": d,
        "main-aria-pressed": l.value,
        "menu-aria-label": u(n)("ui.chart.configureLegendItem", "Configure {label}", { label: e.configureLabel ?? e.label }),
        open: c.value,
        "menu-width": "320px",
        "onUpdate:open": f
      }, {
        dropdown: B(() => [
          C("div", N0, [
            L(h.$slots, "editor")
          ])
        ]),
        default: B(() => [
          C("span", {
            class: "hp-chart-legend-item__marker",
            "data-theme": s.value,
            "data-chart-marker": ""
          }, null, 8, H0),
          e.icon ? (i(), R(Pe(e.icon), {
            key: 0,
            class: "hp-chart-legend-item__metric hp-chart-legend-item__metric--small",
            "aria-label": e.iconLabel
          }, null, 8, ["aria-label"])) : (i(), R(Pe(p.value), {
            key: 1,
            class: "hp-chart-legend-item__view",
            "aria-label": u(n)("ui.chart.viewIcon", "{view} chart", { view: e.view })
          }, null, 8, ["aria-label"])),
          C("span", {
            class: W(["hp-chart-legend-item__label", { "hp-color-medium": !l.value }]),
            "data-chart-label": ""
          }, le(e.label), 3)
        ]),
        _: 3
      }, 8, ["label", "disabled", "main-aria-pressed", "menu-aria-label", "open"])
    ], 8, V0));
  }
}), F0 = ze("hp-divider", {
  variants: {
    orientation: {
      horizontal: "hp-divider--horizontal",
      vertical: "hp-divider--vertical"
    },
    insetX: {
      0: "mx-0",
      1: "mx-1",
      2: "mx-2",
      3: "mx-3",
      4: "mx-4",
      5: "mx-5",
      6: "mx-6",
      7: "mx-7",
      8: "mx-8"
    },
    insetY: {
      0: "my-0",
      1: "my-1",
      2: "my-2",
      3: "my-3",
      4: "my-4",
      5: "my-5",
      6: "my-6",
      7: "my-7",
      8: "my-8"
    }
  },
  defaultVariants: {
    orientation: "horizontal"
  }
}), K0 = ["data-theme", "aria-orientation", "aria-label"], vr = /* @__PURE__ */ Y({
  name: "Divider",
  __name: "Divider",
  props: {
    class: { default: void 0 },
    orientation: { default: "horizontal" },
    inset: { default: "2" },
    color: { default: void 0 },
    label: { default: void 0 }
  },
  setup(e) {
    const t = e, n = m(() => t.orientation), a = m(() => [
      F0({
        orientation: t.orientation,
        insetX: t.orientation === "vertical" ? t.inset : void 0,
        insetY: t.orientation === "horizontal" ? t.inset : void 0
      }),
      t.class
    ]);
    return (o, l) => (i(), g("div", {
      class: W(a.value),
      "data-theme": e.color,
      role: "separator",
      "aria-orientation": n.value,
      "aria-label": e.label
    }, null, 10, K0));
  }
}), Y0 = {}, j0 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function W0(e, t) {
  return i(), g("svg", j0, [...t[0] || (t[0] = [
    C("path", {
      d: "M16.75 8C16.75 7.58579 16.4142 7.25 16 7.25C15.5858 7.25 15.25 7.58579 15.25 8H16H16.75ZM4.75 8C4.75 7.58579 4.41421 7.25 4 7.25C3.58579 7.25 3.25 7.58579 3.25 8H4H4.75ZM4.87868 16.1213L4.34835 16.6517L4.34835 16.6517L4.87868 16.1213ZM15.1213 16.1213L15.6517 16.6517L15.6517 16.6517L15.1213 16.1213ZM7.25 5C7.25 5.41421 7.58579 5.75 8 5.75C8.41421 5.75 8.75 5.41421 8.75 5H8H7.25ZM8 4L7.25 4V4H8ZM12 4H11.25H12ZM11.25 5C11.25 5.41421 11.5858 5.75 12 5.75C12.4142 5.75 12.75 5.41421 12.75 5H12H11.25ZM3 4.25C2.58579 4.25 2.25 4.58579 2.25 5C2.25 5.41421 2.58579 5.75 3 5.75V5V4.25ZM17 5.75C17.4142 5.75 17.75 5.41421 17.75 5C17.75 4.58579 17.4142 4.25 17 4.25V5V5.75ZM8.75 9C8.75 8.58579 8.41421 8.25 8 8.25C7.58579 8.25 7.25 8.58579 7.25 9H8H8.75ZM7.25 13C7.25 13.4142 7.58579 13.75 8 13.75C8.41421 13.75 8.75 13.4142 8.75 13H8H7.25ZM12.75 9C12.75 8.58579 12.4142 8.25 12 8.25C11.5858 8.25 11.25 8.58579 11.25 9H12H12.75ZM11.25 13C11.25 13.4142 11.5858 13.75 12 13.75C12.4142 13.75 12.75 13.4142 12.75 13H12H11.25ZM16 8H15.25V11H16H16.75V8H16ZM4 11H4.75V8H4H3.25V11H4ZM10 17V16.25C8.56458 16.25 7.56347 16.2484 6.80812 16.1469C6.07434 16.0482 5.68577 15.8678 5.40901 15.591L4.87868 16.1213L4.34835 16.6517C4.95027 17.2536 5.70814 17.5125 6.60825 17.6335C7.48678 17.7516 8.60699 17.75 10 17.75V17ZM4 11H3.25C3.25 12.393 3.24841 13.5132 3.36652 14.3918C3.48754 15.2919 3.74643 16.0497 4.34835 16.6517L4.87868 16.1213L5.40901 15.591C5.13225 15.3142 4.9518 14.9257 4.85315 14.1919C4.75159 13.4365 4.75 12.4354 4.75 11H4ZM16 11H15.25C15.25 12.4354 15.2484 13.4365 15.1469 14.1919C15.0482 14.9257 14.8678 15.3142 14.591 15.591L15.1213 16.1213L15.6517 16.6517C16.2536 16.0497 16.5125 15.2919 16.6335 14.3918C16.7516 13.5132 16.75 12.393 16.75 11H16ZM10 17V17.75C11.393 17.75 12.5132 17.7516 13.3918 17.6335C14.2919 17.5125 15.0497 17.2536 15.6517 16.6517L15.1213 16.1213L14.591 15.591C14.3142 15.8678 13.9257 16.0482 13.1919 16.1469C12.4365 16.2484 11.4354 16.25 10 16.25V17ZM8 5H8.75V4H8H7.25V5H8ZM12 4H11.25V5H12H12.75V4H12ZM10 2V2.75C10.6904 2.75 11.25 3.30964 11.25 4H12H12.75C12.75 2.48122 11.5188 1.25 10 1.25V2ZM8 4H8.75C8.75 3.30964 9.30964 2.75 10 2.75V2V1.25C8.48122 1.25 7.25 2.48122 7.25 4L8 4ZM3 5V5.75H17V5V4.25H3V5ZM8 9H7.25L7.25 13H8H8.75L8.75 9H8ZM12 9H11.25V13H12H12.75V9H12Z",
      fill: "var(--icon-fill, var(--icon-color, currentColor))"
    }, null, -1)
  ])]);
}
const U0 = /* @__PURE__ */ se(Y0, [["render", W0]]), gs = ["line", "smooth", "bar"], q0 = ["aria-label"], Z0 = /* @__PURE__ */ Y({
  __name: "ChartViewSelector",
  props: {
    modelValue: { default: "line" },
    disabled: { type: Boolean, default: !1 },
    views: { default: () => gs }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = Le(), a = {
      line: fc,
      smooth: hc,
      bar: pc
    }, o = {
      line: ["ui.chart.line", "Line"],
      smooth: ["ui.chart.smooth", "Smooth"],
      bar: ["ui.chart.bar", "Bar"]
    }, l = e, r = t, c = m(
      () => gs.filter((s) => l.views.includes(s)).map((s) => ({
        value: s,
        label: n(o[s][0], o[s][1]),
        icon: a[s]
      }))
    );
    return (s, p) => (i(), g("div", {
      class: "hp-chart-view-selector",
      role: "group",
      "aria-label": u(n)("ui.chart.chartView", "Chart view")
    }, [
      (i(!0), g(he, null, De(c.value, (d) => (i(), R(u(Ae), {
        key: d.value,
        variant: d.value === l.modelValue ? "soft" : "blank",
        size: "3",
        icon: d.icon,
        disabled: l.disabled,
        "aria-pressed": d.value === l.modelValue,
        "data-chart-view": d.value,
        onClick: (f) => r("update:modelValue", d.value)
      }, {
        default: B(() => [
          me(le(d.label), 1)
        ]),
        _: 2
      }, 1032, ["variant", "icon", "disabled", "aria-pressed", "data-chart-view", "onClick"]))), 128))
    ], 8, q0));
  }
}), G0 = ["aria-label"], X0 = {
  class: "hp-chart-series-editor__field",
  "data-chart-editor-view": ""
}, Q0 = { class: "hp-chart-series-editor__field" }, J0 = { class: "hp-chart-series-editor__field" }, eg = {
  key: 0,
  class: "hp-chart-series-editor__field"
}, tg = {
  class: "hp-chart-series-editor__footer",
  "data-chart-editor-footer": ""
}, CM = /* @__PURE__ */ Y({
  __name: "ChartSeriesEditorLayout",
  props: {
    removable: { type: Boolean, default: !1 },
    view: { default: "line" },
    views: { default: void 0 },
    filled: { type: Boolean, default: !1 }
  },
  emits: ["update:view", "update:filled", "delete", "cancel", "apply"],
  setup(e, { emit: t }) {
    const n = Le(), a = t;
    return (o, l) => (i(), g("section", {
      class: "hp-chart-series-editor",
      "aria-label": u(n)("ui.chart.chartSeriesEditor", "Chart series editor")
    }, [
      C("div", X0, [
        j(Z0, {
          "model-value": e.view,
          views: e.views,
          "onUpdate:modelValue": l[0] || (l[0] = (r) => a("update:view", r))
        }, null, 8, ["model-value", "views"]),
        e.view !== "bar" ? (i(), R(u($o), {
          key: 0,
          class: "hp-chart-series-editor__fill",
          size: "2",
          "model-value": e.filled,
          "data-chart-editor-fill": "",
          "onUpdate:modelValue": l[1] || (l[1] = (r) => a("update:filled", r))
        }, {
          default: B(() => [
            me(le(u(n)("ui.chart.fill", "Fill")), 1)
          ]),
          _: 1
        }, 8, ["model-value"])) : A("", !0)
      ]),
      C("div", Q0, [
        L(o.$slots, "metric")
      ]),
      C("div", J0, [
        L(o.$slots, "dimension")
      ]),
      o.$slots.color ? (i(), g("div", eg, [
        L(o.$slots, "color")
      ])) : A("", !0),
      j(u(vr), { inset: "0" }),
      C("footer", tg, [
        e.removable ? (i(), R(u(Ae), {
          key: 0,
          class: "hp-chart-series-editor__delete",
          icon: U0,
          variant: "outline",
          size: "2",
          square: "",
          "aria-label": u(n)("ui.chart.deleteChartSeries", "Delete chart series"),
          onClick: l[2] || (l[2] = (r) => a("delete"))
        }, null, 8, ["aria-label"])) : A("", !0),
        j(u(Ae), {
          variant: "outline",
          size: "2",
          onClick: l[3] || (l[3] = (r) => a("cancel"))
        }, {
          default: B(() => [
            me(le(u(n)("ui.common.cancel", "Cancel")), 1)
          ]),
          _: 1
        }),
        j(u(Ae), {
          size: "2",
          onClick: l[4] || (l[4] = (r) => a("apply"))
        }, {
          default: B(() => [
            me(le(u(n)("ui.common.apply", "Apply")), 1)
          ]),
          _: 1
        })
      ])
    ], 8, G0));
  }
}), ag = {}, ng = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function og(e, t) {
  return i(), g("svg", ng, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M4.99998 10H15",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const lg = /* @__PURE__ */ se(ag, [["render", og]]), rg = ["data-theme"], sg = ["checked", "name", "value", "disabled"], ig = {
  key: 0,
  class: "hp-checkbox__icon"
}, cg = /* @__PURE__ */ Y({
  __name: "Checkbox",
  props: /* @__PURE__ */ Xe({
    modelValue: { type: Boolean },
    indeterminate: { type: Boolean, default: !1 },
    variant: { default: "outline" },
    size: { default: "3" },
    disabled: { type: Boolean, default: !1 },
    label: { default: void 0 },
    name: { default: void 0 },
    value: { default: void 0 },
    color: { default: void 0 },
    class: { default: void 0 }
  }, {
    modelValue: { type: Boolean, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["change"], ["update:modelValue"]),
  setup(e, { expose: t, emit: n }) {
    const a = e, o = vt(e, "modelValue"), l = n, r = mt(), c = N(null);
    Se(
      () => a.indeterminate,
      (v) => {
        c.value && (c.value.indeterminate = v);
      },
      { immediate: !0 }
    ), Se(c, (v) => {
      v && (v.indeterminate = a.indeterminate);
    });
    const s = m(() => a.indeterminate), p = m(() => o.value && !a.indeterminate), d = m(() => s.value || p.value), f = m(() => a.label || r.default), h = ze("hp-checkbox", {
      variants: {
        variant: {
          filled: "hp-checkbox--filled",
          soft: "hp-checkbox--soft",
          outline: "hp-checkbox--outline",
          surface: "hp-checkbox--surface"
        },
        size: {
          1: "hp-checkbox--size-1",
          2: "hp-checkbox--size-2",
          3: "hp-checkbox--size-3",
          4: "hp-checkbox--size-4",
          5: "hp-checkbox--size-5"
        },
        disabled: {
          true: "hp-checkbox--disabled"
        }
      },
      defaultVariants: {
        variant: "outline",
        size: "3"
      }
    }), $ = m(
      () => h({
        variant: a.variant,
        size: a.size,
        disabled: a.disabled,
        class: a.class
      })
    ), y = m(() => "hp-checkbox__box"), w = (v) => {
      const x = v.target;
      o.value = x.checked, l("change", v);
    };
    return t({
      inputRef: c
    }), (v, x) => (i(), g("label", {
      class: W($.value),
      "data-theme": e.color
    }, [
      C("input", {
        ref_key: "inputRef",
        ref: c,
        type: "checkbox",
        class: "hp-checkbox__input",
        checked: o.value,
        name: e.name,
        value: e.value,
        disabled: e.disabled,
        onChange: w
      }, null, 40, sg),
      C("span", {
        class: W(y.value)
      }, [
        d.value ? (i(), g("span", ig, [
          s.value ? (i(), R(lg, { key: 0 })) : p.value ? (i(), R(eo, { key: 1 })) : A("", !0)
        ])) : A("", !0)
      ], 2),
      f.value ? (i(), R(u(Zn), {
        key: 0,
        class: "hp-checkbox__label"
      }, {
        default: B(() => [
          L(v.$slots, "default", {}, () => [
            me(le(e.label), 1)
          ], !0)
        ]),
        _: 3
      })) : A("", !0)
    ], 10, rg));
  }
}), ln = /* @__PURE__ */ se(cg, [["__scopeId", "data-v-b33cee53"]]), ug = 10, dg = 2, xM = /* @__PURE__ */ Y({
  __name: "ChipList",
  props: {
    items: {},
    maxVisible: { default: ug },
    maxRows: { default: dg },
    size: { default: "3" },
    gap: { default: void 0 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = ze("hp-chip-list", {
      variants: {
        size: {
          1: "hp-chip-list--size-1",
          2: "hp-chip-list--size-2",
          3: "hp-chip-list--size-3",
          4: "hp-chip-list--size-4",
          5: "hp-chip-list--size-5"
        }
      },
      defaultVariants: { size: "3" }
    }), n = e, a = N(!1), o = () => {
      a.value = !a.value;
    }, l = m(() => {
      const s = n.maxVisible, p = n.items, d = a.value, h = p.length > s ? Math.max(0, s - 1) : s, $ = d ? p : p.slice(0, h), y = d ? Math.max(0, p.length - s) : p.length - $.length;
      return { visibleItems: $, hiddenCount: y };
    }), r = m(() => {
      const s = a.value ? "hp-chip-list--expanded" : void 0;
      return [t({ size: n.size }), s, n.class];
    }), c = m(() => {
      const s = {
        "--hp-chip-list-max-rows": String(n.maxRows)
      };
      return n.gap && (s["--hp-chip-list-gap"] = n.gap), s;
    });
    return (s, p) => (i(), g("div", {
      class: W(r.value),
      style: Ie(c.value)
    }, [
      (i(!0), g(he, null, De(l.value.visibleItems, (d, f) => L(s.$slots, "default", {
        key: f,
        item: d,
        index: f
      })), 128)),
      l.value.hiddenCount > 0 ? L(s.$slots, "more", {
        key: 0,
        hiddenCount: l.value.hiddenCount,
        expanded: a.value,
        toggle: o
      }, () => [
        j(u(Ht), {
          variant: "soft",
          size: n.size,
          clickable: "",
          dismissible: !1,
          onClick: o
        }, {
          default: B(() => [
            me(le(a.value ? "View less" : `View more (${l.value.hiddenCount})`), 1)
          ]),
          _: 1
        }, 8, ["size"])
      ]) : A("", !0)
    ], 6));
  }
}), $M = /* @__PURE__ */ Y({
  __name: "ChipWrap",
  props: {
    gap: { default: void 0 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = m(() => {
      if (t.gap)
        return { "--hp-chip-wrap-gap": t.gap };
    });
    return (a, o) => (i(), g("div", {
      class: W(["hp-chip-wrap", t.class]),
      style: Ie(n.value)
    }, [
      L(a.$slots, "default")
    ], 6));
  }
}), pg = {}, fg = { class: "hp-data-table__actions-right" };
function hg(e, t) {
  return i(), g("div", fg, [
    L(e.$slots, "default")
  ]);
}
const SM = /* @__PURE__ */ se(pg, [["render", hg]]), vg = { class: "hp-data-table__td hp-data-table__td--expand" }, mg = /* @__PURE__ */ Y({
  __name: "DataTableExpandToggle",
  props: {
    isExpanded: { type: Boolean },
    hasChildren: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e) {
    const t = Le();
    return (n, a) => (i(), g("td", vg, [
      e.hasChildren ? (i(), R(Ae, {
        key: 0,
        variant: "blank",
        size: "2",
        radius: "full",
        "aria-label": u(t)("ui.dataTable.expandRow", "Expand row"),
        onClick: a[0] || (a[0] = Fe((o) => n.$emit("toggle"), ["stop"]))
      }, {
        default: B(() => [
          j(Pa, null, {
            default: B(() => [
              e.isExpanded ? (i(), R(en, {
                key: 1,
                class: "hp-data-table__expand-icon"
              })) : (i(), R(Ka, {
                key: 0,
                class: "hp-data-table__expand-icon"
              }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["aria-label"])) : A("", !0)
    ]));
  }
}), gg = (e) => ({
  getColumnStyle: e.getColumnStyle,
  getStickyStyle: e.getStickyStyle,
  getStickyClass: e.getStickyClass
}), _n = (e, t, n) => ({
  class: {
    [`hp-data-table__td--${e.align}`]: !!e.align,
    "hp-data-table__td--mono": !!e.mono,
    "hp-data-table__td--nowrap": !!e.nowrap,
    "hp-data-table__td--truncate": !!e.truncate,
    "hp-data-table__cell--mobile-width": !!e.mobileWidth,
    ...n.getStickyClass(t)
  },
  style: {
    ...n.getColumnStyle(e),
    ...n.getStickyStyle(t) ?? {}
  }
}), yg = {
  key: 0,
  class: "hp-data-table__td hp-data-table__td--checkbox hp-data-table__td--checkbox-sticky"
}, wg = {
  key: 0,
  class: "hp-data-table__td hp-data-table__td--spacer"
}, bg = ["title"], kg = {
  key: 2,
  class: "hp-data-table__td hp-data-table__td--spacer"
}, _g = /* @__PURE__ */ Y({
  __name: "DataTableDataRow",
  props: {
    row: {},
    columns: {},
    selectable: { type: Boolean },
    expandable: { type: Boolean },
    isRowSelected: { type: Boolean },
    isExpanded: { type: Boolean },
    hasChildren: { type: Boolean },
    clickable: { type: Boolean },
    hoverable: { type: Boolean },
    cellAttrs: { type: Function },
    rowAttrs: {},
    rowState: {},
    cellGeometry: {},
    spacerIndex: {}
  },
  emits: ["rowClick", "toggleRow", "toggleExpand"],
  setup(e) {
    const t = (n, a) => {
      if (!(n.key !== "name" && n.label !== "Name"))
        return typeof a == "string" ? a.trim().length > 0 ? a : void 0 : typeof a == "number" ? String(a) : void 0;
    };
    return (n, a) => (i(), g("tr", Ke({
      class: ["hp-data-table__row", {
        "hp-data-table__row--selected": e.isRowSelected || e.rowState?.selected,
        "hp-data-table__row--expanded": e.isExpanded,
        "hp-data-table__row--clickable": e.clickable,
        "hp-data-table__row--hoverable": e.hoverable,
        "hp-data-table__row--dirty": e.rowState?.dirty,
        "hp-data-table__row--error": e.rowState?.error,
        "hp-data-table__row--warning": e.rowState?.warning
      }]
    }, e.rowAttrs, {
      onClick: a[3] || (a[3] = (o) => n.$emit("rowClick"))
    }), [
      e.selectable ? (i(), g("td", yg, [
        j(ln, {
          "model-value": e.isRowSelected,
          variant: "surface",
          size: "2",
          onClick: a[0] || (a[0] = Fe(() => {
          }, ["stop"])),
          "onUpdate:modelValue": a[1] || (a[1] = (o) => n.$emit("toggleRow"))
        }, null, 8, ["model-value"])
      ])) : A("", !0),
      e.expandable ? (i(), R(mg, {
        key: 1,
        "is-expanded": e.isExpanded,
        "has-children": e.hasChildren,
        onToggle: a[2] || (a[2] = (o) => n.$emit("toggleExpand"))
      }, null, 8, ["is-expanded", "has-children"])) : A("", !0),
      (i(!0), g(he, null, De(e.columns, (o, l) => (i(), g(he, {
        key: o.key
      }, [
        l === e.spacerIndex ? (i(), g("td", wg)) : A("", !0),
        C("td", Ke({
          class: ["hp-data-table__td", u(_n)(o, l, e.cellGeometry).class],
          style: u(_n)(o, l, e.cellGeometry).style,
          title: t(o, e.row[o.key])
        }, { ref_for: !0 }, e.cellAttrs?.(e.row, o)), [
          L(n.$slots, `cell-${o.key}`, {
            row: e.row,
            value: e.row[o.key]
          }, () => [
            me(le(e.row[o.key]), 1)
          ])
        ], 16, bg)
      ], 64))), 128)),
      e.spacerIndex === e.columns.length ? (i(), g("td", kg)) : A("", !0)
    ], 16));
  }
}), Cg = { class: "hp-data-table__empty-row" }, xg = ["colspan"], $g = /* @__PURE__ */ Y({
  __name: "DataTableEmptyRow",
  props: {
    columnCount: {}
  },
  setup(e) {
    const t = Le();
    return (n, a) => (i(), g("tr", Cg, [
      C("td", {
        colspan: e.columnCount,
        class: "hp-data-table__empty"
      }, [
        L(n.$slots, "default", {}, () => [
          me(le(u(t)("ui.dataTable.noDataAvailable", "No data available")), 1)
        ])
      ], 8, xg)
    ]));
  }
}), MM = /* @__PURE__ */ Y({
  __name: "DataTableHeaderMenu",
  props: {
    items: {},
    disabled: { type: Boolean },
    ariaLabel: {}
  },
  setup(e) {
    const t = mt(), n = Le();
    return (a, o) => (i(), R(u(So), {
      items: e.items,
      icon: t.trigger ? void 0 : Sn,
      variant: "blank",
      size: "1",
      "item-size": "2",
      "menu-width": "200px",
      disabled: e.disabled,
      placement: "bottom-end",
      "aria-label": e.ariaLabel ?? u(n)("ui.tableRange.columnMenu", "Column menu")
    }, it({ _: 2 }, [
      t.trigger ? {
        name: "default",
        fn: B(() => [
          L(a.$slots, "trigger")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["items", "icon", "disabled", "aria-label"]));
  }
}), Sg = {
  key: 0,
  class: "hp-data-table__td hp-data-table__td--checkbox hp-data-table__td--checkbox-sticky"
}, Mg = {
  key: 1,
  class: "hp-data-table__td hp-data-table__td--expand"
}, Dg = {
  key: 0,
  class: "hp-data-table__td hp-data-table__td--spacer"
}, Tg = {
  key: 2,
  class: "hp-data-table__td hp-data-table__td--spacer"
}, Bg = 5, zg = /* @__PURE__ */ Y({
  __name: "DataTableSkeletonRows",
  props: {
    columns: {},
    selectable: { type: Boolean },
    expandable: { type: Boolean },
    cellGeometry: {},
    skeletonRows: {},
    spacerIndex: {}
  },
  setup(e) {
    const t = e, n = m(() => t.skeletonRows ?? Bg), a = (o) => o % 3 === 0 ? "75%" : o % 3 === 1 ? "60%" : "85%";
    return (o, l) => (i(!0), g(he, null, De(n.value, (r) => (i(), g("tr", {
      key: `skeleton-${r}`,
      class: "hp-data-table__row hp-data-table__row--skeleton"
    }, [
      e.selectable ? (i(), g("td", Sg, [
        j(ln, {
          "model-value": !1,
          variant: "surface",
          size: "2",
          disabled: ""
        })
      ])) : A("", !0),
      e.expandable ? (i(), g("td", Mg)) : A("", !0),
      (i(!0), g(he, null, De(e.columns, (c, s) => (i(), g(he, {
        key: c.key
      }, [
        s === e.spacerIndex ? (i(), g("td", Dg)) : A("", !0),
        C("td", {
          class: W(["hp-data-table__td", u(_n)(c, s, e.cellGeometry).class]),
          style: Ie(u(_n)(c, s, e.cellGeometry).style)
        }, [
          j(Xl, {
            width: c.width ? "80%" : a(s)
          }, null, 8, ["width"])
        ], 6)
      ], 64))), 128)),
      e.spacerIndex === e.columns.length ? (i(), g("td", Tg)) : A("", !0)
    ]))), 128));
  }
}), Ag = { class: "hp-data-table__row hp-data-table__summary-row" }, Lg = {
  key: 0,
  class: "hp-data-table__td hp-data-table__td--checkbox hp-data-table__td--checkbox-sticky"
}, Eg = {
  key: 1,
  class: "hp-data-table__td hp-data-table__td--expand"
}, Ig = {
  key: 0,
  class: "hp-data-table__td hp-data-table__td--spacer"
}, Rg = {
  key: 2,
  class: "hp-data-table__td hp-data-table__td--spacer"
}, Pg = /* @__PURE__ */ Y({
  __name: "DataTableSummaryRow",
  props: {
    columns: {},
    cellGeometry: {},
    spacerIndex: {},
    selectable: { type: Boolean },
    expandable: { type: Boolean },
    cellAttrs: { type: Function },
    values: {}
  },
  setup(e) {
    return (t, n) => (i(), g("tr", Ag, [
      e.selectable ? (i(), g("td", Lg)) : A("", !0),
      e.expandable ? (i(), g("td", Eg)) : A("", !0),
      (i(!0), g(he, null, De(e.columns, (a, o) => (i(), g(he, {
        key: a.key
      }, [
        o === e.spacerIndex ? (i(), g("td", Ig)) : A("", !0),
        C("td", Ke({ ref_for: !0 }, e.cellAttrs?.(a), {
          class: ["hp-data-table__td", u(_n)(a, o, e.cellGeometry).class],
          style: u(_n)(a, o, e.cellGeometry).style
        }), le(e.values[a.key] ?? ""), 17)
      ], 64))), 128)),
      e.spacerIndex === e.columns.length ? (i(), g("td", Rg)) : A("", !0)
    ]));
  }
}), DM = /* @__PURE__ */ se(Pg, [["__scopeId", "data-v-0d5bf3f2"]]), Gt = (e, t) => String(e[t]), Og = (e) => {
  const { rowKey: t, emit: n, isRowExpandable: a } = e, o = N(/* @__PURE__ */ new Set());
  return {
    toggleExpand: (s) => {
      const p = Gt(s, t.value), d = new Set(o.value);
      d.has(p) ? d.delete(p) : (d.add(p), n("row-expand", s)), o.value = d;
    },
    isExpanded: (s) => o.value.has(Gt(s, t.value)),
    hasChildren: (s) => {
      const p = a?.value;
      if (p !== void 0)
        return p(s);
      if (!("children" in s))
        return !1;
      const { children: d } = s;
      return Array.isArray(d) && d.length > 0;
    }
  };
}, ys = Object.freeze({}), Vg = (e) => {
  const { rowKey: t, columns: n, selectable: a, expandable: o, clickable: l, resizable: r, rowAttrs: c, isRowExpandable: s, emit: p } = e, { toggleExpand: d, isExpanded: f, hasChildren: h } = Og({
    rowKey: t,
    emit: p,
    isRowExpandable: s
  }), $ = (v) => {
    l.value && p("row-click", v);
  }, y = (v) => c.value ? c.value(v) ?? ys : ys, w = m(
    () => n.value.length + (a.value ? 1 : 0) + (o.value ? 1 : 0) + (r.value ? 1 : 0)
  );
  return Object.freeze({
    toggleExpand: d,
    isExpanded: f,
    hasChildren: h,
    handleRowClick: $,
    getRowAttributes: y,
    columnCount: w
  });
}, Hg = 50, Ng = 4, Fg = (e) => {
  if (!e)
    return;
  const t = /^\s*(\d+(?:\.\d+)?)px\s*$/.exec(e);
  return t?.[1] === void 0 ? void 0 : Number(t[1]);
}, Kg = (e) => Math.max(Hg, e.minWidth ?? 0, Fg(e.width) ?? 0), Yg = () => {
  const e = document.createElement("div");
  return e.style.cssText = [
    "position:fixed",
    "top:-10000px",
    "left:-10000px",
    "visibility:hidden",
    "display:inline-block",
    "white-space:nowrap",
    "max-width:none",
    "min-width:0"
  ].join(";"), e;
}, jg = (e) => {
  const t = Yg();
  document.body.appendChild(t);
  let n = 0;
  for (const a of e) {
    const o = getComputedStyle(a);
    t.style.font = o.font, t.style.padding = o.padding, t.style.boxSizing = o.boxSizing, t.textContent = "";
    for (const r of Array.from(a.childNodes))
      t.appendChild(r.cloneNode(!0));
    const l = t.getBoundingClientRect().width;
    l > n && (n = l);
  }
  return t.remove(), n;
}, Wg = (e) => {
  if (!e)
    return 0;
  const t = e.querySelector(".hp-data-table__td--checkbox") !== null, n = e.querySelector(".hp-data-table__td--expand") !== null;
  return Number(t) + Number(n);
}, Ug = (e, t, n) => {
  const a = t.value.find((r) => r.key === e);
  if (!a || a.resizable === !1)
    return null;
  const o = n.value;
  if (!o)
    return null;
  const l = t.value.findIndex((r) => r.key === e);
  return l < 0 ? null : { col: a, wrapperEl: o, colIndex: l };
}, qg = (e, t, n) => {
  const a = Array.from(e.querySelectorAll(".hp-data-table__row")), o = Wg(a[0]), l = e.querySelector(`.hp-data-table__th[data-col-key="${t}"]`), r = [];
  l && r.push(l);
  for (const c of a) {
    const s = c.children[o + n];
    s && r.push(s);
  }
  return r;
}, Zg = (e) => {
  const { wrapperRef: t, columns: n, enabled: a, onBeforeAutoFit: o, onAutoFit: l } = e;
  return { autoFitColumn: (c) => {
    if (!a.value)
      return;
    const s = Ug(c, n, t);
    if (!s)
      return;
    o?.();
    const p = qg(s.wrapperEl, c, s.colIndex), d = jg(p), f = Kg(s.col), h = s.col.maxWidth ?? 1 / 0, $ = Math.min(h, Math.max(f, d + Ng));
    l(c, $);
  } };
}, Gg = (...e) => {
  let t = 0;
  return { lock: () => {
    t++, t === 1 && e.forEach((o) => document.body.classList.add(o));
  }, unlock: () => {
    t = Math.max(0, t - 1), t === 0 && e.forEach((o) => document.body.classList.remove(o));
  } };
}, ws = /* @__PURE__ */ new Map(), Vo = (e) => {
  const t = ws.get(e);
  if (t !== void 0)
    return t;
  const n = Gg(e);
  return ws.set(e, n), n;
}, mr = ({ onMove: e, onCleanup: t, label: n = "drag" }) => {
  let a = !1;
  const o = () => {
    a || (a = !0, document.removeEventListener("mousemove", l), document.removeEventListener("mouseup", r), t?.());
  }, l = (c) => {
    try {
      e(c);
    } catch (s) {
      o(), console.warn(`[${n}] drag error:`, s);
    }
  }, r = () => {
    o();
  };
  return document.addEventListener("mousemove", l), document.addEventListener("mouseup", r), o;
}, vc = (e) => {
  const t = e.querySelector(".hp-data-table__table");
  return t ? Array.from(t.querySelectorAll("thead tr .hp-data-table__th[data-col-key]")) : [];
}, Xg = 50, Qg = 100, Jg = "hp-data-table-resizing", { lock: ey, unlock: ty } = Vo(Jg), bs = (e) => {
  const t = {};
  return e.width && (t.width = e.width), e.mobileWidth && (t["--hp-data-table-mobile-width"] = e.mobileWidth), e.minWidth && (t.minWidth = `${e.minWidth}px`), e.maxWidth && (t.maxWidth = `${e.maxWidth}px`), t;
}, ay = (e) => {
  const { wrapperRef: t, columns: n, enabled: a, locked: o, getHeaders: l } = e, r = () => a.value || (o?.value ?? !1), c = () => {
    const _ = {};
    for (const T of n.value) {
      const S = e.initialWidths?.value?.[T.key];
      T.resizable !== !1 && S !== void 0 && Number.isFinite(S) && S > 0 && (_[T.key] = S);
    }
    return _;
  }, s = N(c()), p = N(Object.keys(s.value).length > 0), d = N(!1), f = N(null), h = N(null), $ = () => {
    if (p.value)
      return;
    const _ = t.value;
    if (!_)
      return;
    const T = l ? l(_) : vc(_), S = {};
    n.value.forEach((M, E) => {
      if (M.resizable === !1)
        return;
      const F = T[E];
      F && (S[M.key] = F.getBoundingClientRect().width);
    }), s.value = S, p.value = !0;
  }, y = (_) => a.value ? _.resizable ?? !0 : !1, w = (_, T) => {
    if (!a.value)
      return;
    const S = n.value.find((M) => M.key === T);
    !S || !y(S) || (_.preventDefault(), _.stopPropagation(), f.value = {
      key: T,
      startX: _.clientX,
      // Sentinel: real startWidth resolved on first mousemove after snapshot.
      startWidth: Number.NaN
    }, ey(), h.value = mr({
      label: "DataTable",
      onMove: (M) => {
        if (!f.value)
          return;
        if (!d.value) {
          $();
          const D = s.value[f.value.key] ?? Qg;
          f.value = { ...f.value, startWidth: D }, d.value = !0;
        }
        const { key: E, startX: F, startWidth: H } = f.value, te = n.value.find((D) => D.key === E), ie = te?.minWidth ?? Xg, ee = te?.maxWidth ?? 1 / 0, O = M.clientX - F, z = Math.min(ee, Math.max(ie, H + O));
        s.value = { ...s.value, [E]: z };
      },
      onCleanup: () => {
        const M = d.value;
        f.value = null, ty(), d.value = !1, M && e.onResizeEnd?.(s.value);
        const E = t.value;
        if (!E)
          return;
        const F = (H) => {
          H.stopImmediatePropagation();
        };
        E.addEventListener("click", F, { capture: !0, once: !0 }), setTimeout(() => {
          E.removeEventListener("click", F, { capture: !0 });
        }, 0);
      }
    }));
  }, v = (_, T) => {
    a.value && (s.value = { ...s.value, [_]: T }, e.onResizeEnd?.(s.value));
  }, x = (_) => {
    if (!r())
      return _.width ? { width: _.width } : {};
    if (_.resizable === !1)
      return bs(_);
    const T = s.value[_.key];
    if (T !== void 0) {
      const S = `${T}px`;
      return { width: S, minWidth: S, maxWidth: S };
    }
    return bs(_);
  }, b = (_) => JSON.stringify(_.map((T) => T.key).sort((T, S) => T.localeCompare(S)));
  let k = b(n.value);
  return Se(n, (_) => {
    if (!r())
      return;
    const T = b(_);
    T !== k && (k = T, s.value = c(), p.value = Object.keys(s.value).length > 0);
  }), e.initialWidths !== void 0 && Se(e.initialWidths, () => {
    s.value = c(), p.value = Object.keys(s.value).length > 0;
  }), ct(() => {
    h.value?.();
  }), {
    columnWidthMap: s,
    hasResized: p,
    isResizing: d,
    getColumnStyle: x,
    canResize: y,
    onResizeStart: w,
    snapshotColumnWidths: $,
    setColumnWidth: v
  };
}, ny = (e) => {
  const { wrapperRef: t, columns: n, enabled: a, locked: o, onResizeEnd: l } = e, r = ay({
    wrapperRef: t,
    columns: n,
    enabled: a,
    initialWidths: e.initialWidths,
    locked: o,
    onResizeEnd: l
  }), c = Zg({
    wrapperRef: t,
    columns: n,
    enabled: a,
    // Snapshot every column to its current rendered width before measuring so
    // siblings stay put while the target column grows/shrinks.
    onBeforeAutoFit: r.snapshotColumnWidths,
    // Write the measured width through the same pipeline the drag uses so
    // the `onResizeEnd` callback fires and storage persistence kicks in.
    onAutoFit: r.setColumnWidth
  });
  return { ...r, ...c };
}, mc = /* @__PURE__ */ Symbol("DataTableSelection"), oy = () => {
  const e = pt(mc);
  if (!e)
    throw new Error("DataTable selection components must be used within <DataTable>");
  return e;
}, ly = (e) => {
  const { data: t, rowKey: n, selectedKeys: a, singleSelect: o, emit: l } = e, r = m(() => a.value !== void 0), c = N(/* @__PURE__ */ new Set()), s = m(() => r.value ? new Set(a.value) : c.value), p = m(
    () => t.value.length > 0 && t.value.every((_) => s.value.has(Gt(_, n.value)))
  ), d = m(() => s.value.size > 0 && !p.value), f = (_) => {
    r.value ? l("update:selected-keys", Array.from(_)) : c.value = _;
    const T = t.value.filter((S) => _.has(Gt(S, n.value)));
    l("selection-change", T);
  }, h = () => {
    if (p.value) {
      const _ = new Set(s.value);
      t.value.forEach((T) => _.delete(Gt(T, n.value))), f(_);
    } else {
      const _ = new Set(s.value);
      t.value.forEach((T) => _.add(Gt(T, n.value))), f(_);
    }
  }, $ = (_) => {
    const T = Gt(_, n.value), S = new Set(s.value);
    S.has(T) ? S.delete(T) : (o.value && S.clear(), S.add(T)), f(S);
  }, y = (_) => s.value.has(Gt(_, n.value)), w = () => t.value.filter((_) => s.value.has(Gt(_, n.value))), v = () => {
    const _ = /* @__PURE__ */ new Set();
    t.value.forEach((T) => _.add(Gt(T, n.value))), f(_);
  }, x = () => {
    f(/* @__PURE__ */ new Set());
  }, b = m(() => {
    const _ = /* @__PURE__ */ new Set();
    for (const T of t.value)
      _.add(Gt(T, n.value));
    return _;
  }), k = m(() => [...b.value].sort((_, T) => _.localeCompare(T)).join("\0"));
  return Se(k, () => {
    if (r.value)
      return;
    const _ = /* @__PURE__ */ new Set();
    for (const T of c.value)
      b.value.has(T) && _.add(T);
    _.size !== c.value.size && (c.value = _);
  }), {
    selectedRows: s,
    allSelected: p,
    someSelected: d,
    toggleAll: h,
    toggleRow: $,
    isRowSelected: y,
    getSelectedRows: w,
    selectAllRows: v,
    clearAllRows: x
  };
}, ry = (e) => {
  const { data: t, rowKey: n, selectedKeys: a, singleSelect: o, emit: l, sortedData: r } = e, {
    selectedRows: c,
    allSelected: s,
    someSelected: p,
    toggleAll: d,
    toggleRow: f,
    isRowSelected: h,
    getSelectedRows: $,
    selectAllRows: y,
    clearAllRows: w
  } = ly({ data: t, rowKey: n, selectedKeys: a, singleSelect: o, emit: l });
  return Dt(mc, {
    count: m(() => c.value.size),
    totalCount: m(() => t.value.length),
    allSelected: s,
    singleSelect: o,
    getSelected: $,
    // getSelectedKeys() iterates sortedData so keys are returned in display order.
    getSelectedKeys: () => r.value.map((v) => Gt(v, n.value)).filter((v) => c.value.has(v)),
    selectAll: y,
    clearAll: w
  }), Object.freeze({
    selectedRows: c,
    allSelected: s,
    someSelected: p,
    toggleAll: d,
    toggleRow: f,
    isRowSelected: h,
    getSelectedRows: $,
    selectAllRows: y,
    clearAllRows: w
  });
}, In = { number: 0, boolean: 1, string: 2, date: 3, object: 4 }, ks = (e) => typeof e == "number" ? In.number : typeof e == "boolean" ? In.boolean : typeof e == "string" ? In.string : e instanceof Date ? In.date : In.object, sy = (e, t) => Number.isNaN(e) && Number.isNaN(t) ? 0 : Number.isNaN(e) ? 1 : Number.isNaN(t) || e < t ? -1 : e > t ? 1 : 0, iy = (e, t) => {
  try {
    return JSON.stringify(e).localeCompare(JSON.stringify(t));
  } catch {
    return 0;
  }
}, _s = (e) => e ? 1 : 0, cy = (e, t) => {
  if (typeof e == "number")
    return sy(e, t);
  if (typeof e == "boolean") {
    const n = _s(e), a = _s(t);
    return n < a ? -1 : n > a ? 1 : 0;
  }
  if (typeof e == "string")
    return e.localeCompare(t);
  if (e instanceof Date) {
    const n = e.getTime(), a = t.getTime();
    return n < a ? -1 : n > a ? 1 : 0;
  }
  return iy(e, t);
}, uy = (e, t) => {
  const n = e == null, a = t == null;
  if (n && a)
    return 0;
  if (n)
    return 1;
  if (a)
    return -1;
  const o = ks(e), l = ks(t);
  return o !== l ? o - l : cy(e, t);
}, dy = (e) => {
  const { data: t, disabled: n, emit: a, mode: o } = e, l = e.sortKey ?? N(null), r = e.sortDirection ?? N(null), c = (p) => {
    n?.value || (l.value === p ? r.value === "asc" ? r.value = "desc" : r.value === "desc" ? (r.value = null, l.value = null) : r.value = "asc" : (l.value = p, r.value = "asc"), a("sort-change", p, r.value));
  }, s = m(() => {
    if (o === "server")
      return t.value;
    const p = l.value;
    return !p || !r.value ? t.value : [...t.value].sort((d, f) => {
      const h = d[p], $ = f[p], y = uy(h, $), w = h == null, v = $ == null;
      return w || v ? y : y * (r.value === "asc" ? 1 : -1);
    });
  });
  return {
    sortKey: l,
    sortDirection: r,
    sort: c,
    sortedData: s
  };
}, py = (e) => {
  const { data: t, disabled: n, emit: a, sortKey: o, sortDirection: l, mode: r } = e;
  return dy({ data: t, disabled: n, emit: a, sortKey: o, sortDirection: l, mode: r });
}, Al = () => {
}, el = (e) => {
  console.error("[runDetached] Unhandled promise rejection:", e);
}, Kn = (e, t = el) => {
  e.catch((n) => {
    try {
      t(n);
    } catch (a) {
      el(n), el(a);
    }
  });
}, gc = (e) => {
  if (typeof e != "object" || e === null || Array.isArray(e))
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}, fy = (e, t, n) => {
  const a = [];
  let o = 0;
  for (let s = 0; s < t; s++)
    a.push(o), o += e[s] ?? 0;
  const l = e.slice(e.length - n), r = [];
  let c = 0;
  for (let s = l.length - 1; s >= 0; s--)
    r.push(c), c += l[s] ?? 0;
  return r.reverse(), { left: a, right: r };
}, hy = (e) => {
  const { wrapperRef: t, columns: n, data: a, stickyStart: o, stickyEnd: l, getHeaders: r, leadingFixedOffset: c } = e, s = N({ left: [], right: [] }), p = N(null), d = m(() => o.value > 0 || l.value > 0), f = () => {
    if (!d.value || !t.value)
      return;
    const w = r ? r(t.value) : vc(t.value);
    if (w.length === 0)
      return;
    const v = w.map((x) => x.getBoundingClientRect().width);
    s.value = fy(v, o.value, l.value);
  }, h = () => {
    d.value && Kn(Ye(() => f()));
  }, $ = (w) => {
    if (!d.value)
      return;
    const v = o.value, x = l.value, b = n.value.length;
    if (w < v && s.value.left[w] !== void 0) {
      const _ = c?.value ?? 0;
      return {
        position: "sticky",
        left: `${(s.value.left[w] ?? 0) + _}px`,
        zIndex: "10"
      };
    }
    const k = w - (b - x);
    if (k >= 0 && s.value.right[k] !== void 0)
      return {
        position: "sticky",
        right: `${s.value.right[k]}px`,
        zIndex: "10"
      };
  }, y = (w) => {
    if (!d.value)
      return {};
    const v = o.value, x = l.value, b = n.value.length;
    return {
      "hp-data-table__cell--sticky": w < v || w >= b - x,
      "hp-data-table__cell--sticky-start-last": w === v - 1,
      "hp-data-table__cell--sticky-end-first": w === b - x
    };
  };
  return tt(() => {
    window.addEventListener("resize", h), typeof ResizeObserver < "u" && t.value && (p.value = new ResizeObserver(() => {
      h();
    }), p.value.observe(t.value));
  }), ct(() => {
    window.removeEventListener("resize", h), p.value?.disconnect(), p.value = null;
  }), Se(
    [n, a, o, l],
    () => {
      h();
    },
    { immediate: !0, flush: "post" }
  ), Se(d, (w) => {
    if (!w) {
      s.value = { left: [], right: [] };
      return;
    }
    h();
  }), { getStickyStyle: $, getStickyClass: y };
}, vy = (e) => {
  const { wrapperRef: t, columns: n, data: a, stickyStart: o, stickyEnd: l, getHeaders: r, leadingFixedOffset: c } = e;
  return hy({ wrapperRef: t, columns: n, data: a, stickyStart: o, stickyEnd: l, getHeaders: r, leadingFixedOffset: c });
}, my = (e) => {
  const t = m(() => e.data), n = m(() => e.rowKey ?? "id"), a = m(
    () => e.columnOrder === void 0 ? e.columns : e.columnOrder.order(e.columns)
  ), o = m(() => e.selectable ?? !1), l = m(() => e.expandable ?? !1), r = m(() => e.stickyStart ?? 0), c = m(() => e.stickyEnd ?? 0);
  return { data: t, rowKey: n, columns: a, selectable: o, expandable: l, stickyStart: r, stickyEnd: c };
}, gy = (e, t, n) => {
  const { wrapperRef: a } = n, { data: o, rowKey: l, columns: r, selectable: c, expandable: s, stickyStart: p, stickyEnd: d } = my(e), f = ny({
    wrapperRef: a,
    columns: r,
    enabled: m(() => e.resizable ?? !1),
    initialWidths: m(() => e.initialColumnWidths),
    locked: m(() => e.lockColumnWidths ?? !1),
    onResizeEnd: (de) => t("column-resize", de)
  }), h = m(() => e.sortKey !== void 0 || e.sortDirection !== void 0), $ = N(e.sortKey ?? null), y = N(e.sortDirection ?? null);
  Se(
    () => e.sortKey,
    (de) => {
      de !== void 0 && de !== $.value && ($.value = de);
    }
  ), Se(
    () => e.sortDirection,
    (de) => {
      de !== void 0 && de !== y.value && (y.value = de);
    }
  ), Se($, (de) => {
    h.value && de !== (e.sortKey ?? null) && t("update:sort-key", de);
  }), Se(y, (de) => {
    h.value && de !== (e.sortDirection ?? null) && t("update:sort-direction", de);
  });
  const { sortKey: w, sortDirection: v, sort: x, sortedData: b } = py({
    data: o,
    emit: t,
    sortKey: h.value ? $ : void 0,
    sortDirection: h.value ? y : void 0,
    mode: e.sortMode
  }), {
    selectedRows: k,
    allSelected: _,
    someSelected: T,
    toggleAll: S,
    toggleRow: M,
    isRowSelected: E,
    getSelectedRows: F,
    selectAllRows: H,
    clearAllRows: te
  } = ry({
    data: o,
    rowKey: l,
    selectedKeys: m(() => e.selectedKeys),
    singleSelect: m(() => e.singleSelect ?? !1),
    emit: t,
    sortedData: b
  }), { toggleExpand: ie, isExpanded: ee, hasChildren: O, handleRowClick: z, getRowAttributes: D, columnCount: P } = Vg({
    rowKey: l,
    columns: r,
    selectable: c,
    expandable: s,
    clickable: m(() => e.clickable !== !1),
    resizable: m(() => e.resizable === !0),
    rowAttrs: m(() => e.rowAttrs),
    isRowExpandable: m(() => e.isRowExpandable),
    emit: t
  }), Z = 48, J = 36, re = m(() => {
    let de = 0;
    return c.value && (de += Z), s.value && (de += J), de;
  }), { getStickyStyle: U, getStickyClass: ge } = vy({
    wrapperRef: a,
    columns: r,
    data: o,
    stickyStart: p,
    stickyEnd: d,
    leadingFixedOffset: re
  }), K = gg({
    getColumnStyle: f.getColumnStyle,
    getStickyStyle: U,
    getStickyClass: ge
  }), { hasResized: pe, isResizing: ae, getColumnStyle: Ce, canResize: q, onResizeStart: I, autoFitColumn: oe, snapshotColumnWidths: be } = f;
  return Object.freeze({
    // Derived props (stable computed refs with defaults applied)
    columns: r,
    selectable: c,
    expandable: s,
    // Resize (public surface; columnWidthMap stays internal)
    hasResized: pe,
    isResizing: ae,
    getColumnStyle: Ce,
    canResize: q,
    onResizeStart: I,
    autoFitColumn: oe,
    snapshotColumnWidths: be,
    // Sort
    sortKey: w,
    sortDirection: v,
    sort: x,
    sortedData: b,
    // Selection
    selectedRows: k,
    allSelected: _,
    someSelected: T,
    toggleAll: S,
    toggleRow: M,
    isRowSelected: E,
    getSelectedRows: F,
    selectAllRows: H,
    clearAllRows: te,
    // Expansion
    toggleExpand: ie,
    isExpanded: ee,
    hasChildren: O,
    handleRowClick: z,
    getRowAttributes: D,
    columnCount: P,
    // Cell geometry
    cellGeometry: K
  });
}, yy = { class: "hp-data-table__expanded-row" }, wy = ["colspan"], by = /* @__PURE__ */ Y({
  __name: "DataTableExpandedRow",
  props: {
    columnCount: {}
  },
  setup(e) {
    return (t, n) => (i(), g("tr", yy, [
      C("td", {
        colspan: e.columnCount,
        class: "hp-data-table__expanded-content"
      }, [
        L(t.$slots, "default")
      ], 8, wy)
    ]));
  }
}), ky = { class: "hp-data-table__selection-count" }, _y = /* @__PURE__ */ Y({
  __name: "DataTableSelection",
  setup(e) {
    const t = Le(), { count: n, totalCount: a, allSelected: o, singleSelect: l, selectAll: r, clearAll: c } = oy();
    return (s, p) => (i(), g(he, null, [
      C("span", ky, le(u(t)("ui.dataTable.selectionCount", "{count} selected", { count: u(n) })), 1),
      p[0] || (p[0] = C("div", { class: "hp-data-table__selection-divider" }, null, -1)),
      !u(o) && !u(l) ? (i(), R(Ae, {
        key: 0,
        variant: "outline",
        size: "1",
        icon: eo,
        onClick: u(r)
      }, {
        default: B(() => [
          j($a, null, {
            default: B(() => [
              me(le(u(t)("ui.dataTable.selectAllCount", "Select all ({count})", { count: u(a) })), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"])) : A("", !0),
      j(Ae, {
        variant: "outline",
        size: "1",
        icon: zt,
        onClick: u(c)
      }, {
        default: B(() => [
          j($a, null, {
            default: B(() => [
              me(le(u(t)("ui.common.clear", "Clear")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClick"])
    ], 64));
  }
}), Cy = {}, xy = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function $y(e, t) {
  return i(), g("svg", xy, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M5 8.50003L10 3.50003L15 8.50003",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10 17.5V4.50003",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Sy = /* @__PURE__ */ se(Cy, [["render", $y]]), My = {
  key: 1,
  class: "hp-data-table__th-label"
}, Dy = { class: "hp-data-table__th-label hp-data-table__th-label--hinted" }, Ty = 600, By = /* @__PURE__ */ Y({
  __name: "DataTableHeaderLabel",
  props: {
    label: {},
    tooltip: {},
    labelBadge: {},
    labelBadgePlacement: { default: "start" }
  },
  setup(e) {
    return (t, n) => (i(), g(he, null, [
      e.labelBadgePlacement === "start" ? (i(), R(Nn, {
        key: 0,
        badge: e.labelBadge
      }, null, 8, ["badge"])) : A("", !0),
      e.tooltip ? (i(), R(pr, {
        key: 2,
        size: "1",
        placement: "top-start",
        delay: Ty
      }, {
        default: B(() => [
          j(hr, null, {
            default: B(() => [
              C("span", Dy, le(e.label), 1)
            ]),
            _: 1
          }),
          j(fr, { class: "hp-hover-card-content--padded" }, {
            default: B(() => [
              j(u(sc), { content: e.tooltip }, null, 8, ["content"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })) : (i(), g("span", My, le(e.label), 1)),
      e.labelBadgePlacement === "end" ? (i(), R(Nn, {
        key: 3,
        badge: e.labelBadge
      }, null, 8, ["badge"])) : A("", !0)
    ], 64));
  }
}), zy = 5, co = 12, Ay = ({
  wrapperRef: e,
  columns: t,
  controller: n
}) => {
  const a = N(!1), o = N(""), l = N(null), r = N("before");
  let c = null, s = null, p = !1, d = !1, f = null, h = null;
  const $ = (D) => {
    const P = n.value;
    return P !== void 0 && D.reorderable !== !1 && (P.canMove(D.key, -1) || P.canMove(D.key, 1));
  }, y = () => {
    document.removeEventListener("pointermove", E), document.removeEventListener("pointerup", F), document.removeEventListener("pointercancel", H), f = null, d = !1;
  }, w = () => {
    y(), h?.cancel(), h = null, s?.remove(), s = null, c = null, p = !1, a.value = !1, l.value = null;
  }, v = (D, P, Z) => {
    const J = document.createElement("div");
    J.className = "hp-data-table__drag-preview", Z === "pointer" && J.classList.add("hp-data-table__drag-preview--pointer");
    const re = D.querySelector("svg")?.cloneNode(!0);
    re instanceof SVGElement && (re.setAttribute("aria-hidden", "true"), J.append(re));
    const U = document.createElement("span");
    return U.className = "hp-data-table__drag-preview-label", U.textContent = P.label, J.append(U), document.body.append(J), J;
  }, x = (D) => {
    const P = D.currentTarget;
    if (!(P instanceof HTMLElement))
      return "before";
    const Z = P.getBoundingClientRect();
    return D.clientX < Z.left + Z.width / 2 ? "before" : "after";
  }, b = (D, P) => {
    if (d) {
      D.preventDefault();
      return;
    }
    if (!$(P) || D.dataTransfer === null) {
      D.preventDefault();
      return;
    }
    w(), c = P.key, p = !0, a.value = !0, D.dataTransfer.effectAllowed = "move", D.dataTransfer.setData("text/plain", P.key);
    const Z = D.currentTarget;
    if (!(Z instanceof HTMLElement)) {
      w(), D.preventDefault();
      return;
    }
    s = v(Z, P, "native"), D.dataTransfer.setDragImage(s, co, co), D.stopPropagation();
  }, k = (D, P) => {
    !a.value || !$(P) || (l.value = P.key, r.value = x(D), D.dataTransfer !== null && (D.dataTransfer.dropEffect = "move"), D.preventDefault());
  }, _ = () => {
    const D = c, P = l.value, Z = r.value;
    w(), D !== null && P !== null && n.value?.move(D, P, Z);
  }, T = (D, P, Z) => D.width <= 0 || P < D.left || P > D.right ? !1 : Z >= D.top && Z <= D.bottom, S = (D, P) => {
    const Z = e.value;
    if (Z === null)
      return null;
    for (const J of Array.from(Z.querySelectorAll("th[data-col-key]"))) {
      const re = J.dataset.colKey;
      if (re === void 0)
        continue;
      const U = t.value.find((K) => K.key === re);
      if (U === void 0 || !$(U))
        continue;
      const ge = J.getBoundingClientRect();
      if (T(ge, D, P))
        return { key: re, placement: D < ge.left + ge.width / 2 ? "before" : "after" };
    }
    return null;
  }, M = (D, P) => {
    s === null || typeof s.animate != "function" || (h?.cancel(), h = s.animate(
      [
        {
          transform: `translate3d(${D + co}px, ${P + co}px, 0)`
        }
      ],
      { duration: 0, fill: "forwards" }
    ));
  }, E = (D) => {
    const P = f;
    if (P === null || D.pointerId !== P.pointerId || p || !d && Math.hypot(D.clientX - P.startX, D.clientY - P.startY) < zy)
      return;
    d || (d = !0, c = P.key, a.value = !0, s = v(P.source, P.column, "pointer")), M(D.clientX, D.clientY);
    const Z = S(D.clientX, D.clientY);
    l.value = Z?.key ?? null, r.value = Z?.placement ?? "before", D.preventDefault(), D.stopPropagation();
  }, F = (D) => {
    f === null || D.pointerId !== f.pointerId || (d ? _() : w());
  }, H = (D) => {
    f !== null && D.pointerId === f.pointerId && w();
  }, te = (D, P) => {
    const Z = D.currentTarget;
    D.button !== 0 || !(Z instanceof HTMLElement) || !$(P) || (w(), f = {
      key: P.key,
      column: P,
      source: Z,
      pointerId: D.pointerId,
      startX: D.clientX,
      startY: D.clientY
    }, document.addEventListener("pointermove", E, { passive: !1 }), document.addEventListener("pointerup", F), document.addEventListener("pointercancel", H));
  }, ie = (D, P) => {
    k(D, P), _(), D.preventDefault(), D.stopPropagation();
  }, ee = (D) => {
    Ye(() => {
      const P = e.value?.querySelectorAll("[data-col-reorder-key]") ?? [];
      Array.from(P).find((Z) => Z.dataset.colReorderKey === D)?.focus();
    }).catch(() => {
    });
  }, O = (D, P) => {
    let Z = null;
    D.key === "ArrowLeft" ? Z = -1 : D.key === "ArrowRight" && (Z = 1), !(Z === null || !n.value?.canMove(P.key, Z)) && (D.preventDefault(), D.stopPropagation(), n.value.moveBy(P.key, Z), ee(P.key), Ye(() => {
      const J = t.value.filter((U) => U.reorderable !== !1), re = J.findIndex((U) => U.key === P.key);
      re >= 0 && (o.value = `${P.label} column moved to position ${re + 1} of ${J.length}`);
    }).catch(() => {
    }));
  }, z = (D) => ({
    "hp-data-table__th--drop-before": a.value && l.value === D && r.value === "before",
    "hp-data-table__th--drop-after": a.value && l.value === D && r.value === "after"
  });
  return Se(
    () => [t.value.map((D) => D.key).join("|"), n.value?.orderKeys.value.join("|")],
    () => {
      c !== null && w();
    }
  ), ct(w), {
    dragging: a,
    announcement: o,
    canReorder: $,
    getDropClass: z,
    onDragStart: b,
    onDragOver: k,
    onDrop: ie,
    /**
     * `dragend` fires for a cancel as well as for a drop — Escape, or a release outside any drop
     * zone — and the two are told apart only by `dropEffect`. Committing unconditionally moved
     * the column on a cancelled drag and persisted it.
     */
    onDragEnd: (D) => {
      if (p) {
        if (D?.dataTransfer?.dropEffect === "none") {
          w();
          return;
        }
        _();
      }
    },
    onPointerDown: te,
    onKeydown: O
  };
}, Ly = {
  key: 0,
  class: "hp-data-table__selection-actions"
}, Ey = { class: "hp-data-table__table" }, Iy = { class: "hp-data-table__thead" }, Ry = {
  key: 0,
  class: "hp-data-table__th hp-data-table__th--checkbox hp-data-table__th--checkbox-sticky"
}, Py = {
  key: 1,
  class: "hp-data-table__th hp-data-table__th--expand"
}, Oy = {
  key: 0,
  class: "hp-data-table__th hp-data-table__th--spacer"
}, Vy = ["data-col-key", "onDragover", "onDrop", "onClick", "onDblclick"], Hy = { class: "hp-data-table__th-content" }, Ny = ["aria-label", "data-col-reorder-key", "onDragstart", "onPointerdown", "onKeydown"], Fy = {
  key: 1,
  class: "hp-data-table__sort-indicator"
}, Ky = ["title", "onMousedown", "onDblclick"], Yy = {
  key: 2,
  class: "hp-data-table__th hp-data-table__th--spacer"
}, jy = { class: "hp-data-table__tbody" }, Wy = { key: 0 }, Uy = {
  key: 0,
  class: "hp-data-table__empty-container"
}, qy = { class: "hp-data-table__empty" }, Zy = {
  key: 1,
  class: "hp-data-table__footer"
}, Gy = {
  class: "hp-data-table__reorder-announcement",
  "aria-live": "polite"
}, Xy = 300, TM = /* @__PURE__ */ Y({
  inheritAttrs: !1,
  __name: "DataTable",
  props: {
    columns: {},
    data: {},
    size: { default: "2" },
    boxed: { type: Boolean, default: !1 },
    roundedBottom: { type: Boolean },
    bordered: { type: Boolean, default: !1 },
    horizontalLines: { type: Boolean, default: !0 },
    verticalLines: { type: Boolean, default: !1 },
    clickable: { type: Boolean, default: !0 },
    hoverable: { type: Boolean, default: !0 },
    rowMinHeight: { default: "2" },
    rowKey: { default: "id" },
    rowAttrs: { type: Function, default: void 0 },
    cellAttrs: {},
    headerDoubleClick: {},
    rowStates: { default: void 0 },
    selectable: { type: Boolean, default: !1 },
    showSelectionActions: { type: Boolean, default: !0 },
    singleSelect: { type: Boolean, default: !1 },
    selectedKeys: { default: void 0 },
    expandable: { type: Boolean, default: !1 },
    isRowExpandable: { type: Function, default: void 0 },
    loading: { type: Boolean, default: !1 },
    loadingBar: { default: "refetch" },
    skeletonRows: { default: void 0 },
    emptyPlacement: { default: "row" },
    fillHeight: { type: Boolean },
    resizable: { type: Boolean, default: !1 },
    initialColumnWidths: {},
    autoFitOnDoubleClick: { type: Boolean, default: !0 },
    lockColumnWidths: { type: Boolean, default: !1 },
    columnOrder: { default: void 0 },
    sortKey: { default: void 0 },
    sortDirection: { default: void 0 },
    sortMode: { default: void 0 },
    bg: { default: void 0 },
    stickyStart: { default: 0 },
    stickyEnd: { default: 0 },
    stickyEndSpacer: { type: Boolean, default: !0 },
    stickyHeader: { type: Boolean, default: !0 },
    stickyHeaderScroll: { default: "self" },
    stickyHeaderMaxHeight: { default: void 0 }
  },
  emits: ["row-click", "row-expand", "selection-change", "update:selected-keys", "sort-change", "update:sort-key", "update:sort-direction", "column-resize"],
  setup(e, { emit: t }) {
    const n = Le(), a = mt(), o = e, l = t, r = N(null), c = N(!1), s = N(!1);
    let p = null, d = null;
    const f = () => {
      const Te = p;
      Te && (c.value = Te.scrollLeft > 0, s.value = Te.scrollLeft + Te.clientWidth < Te.scrollWidth - 1);
    }, h = (Te) => {
      const $e = Te.querySelector(".hp-data-table__wrapper");
      if ($e) {
        if (p = $e, $e.addEventListener("scroll", f, { passive: !0 }), typeof ResizeObserver < "u") {
          d = new ResizeObserver(f), d.observe($e);
          const Be = $e.querySelector("table");
          Be && d.observe(Be);
        }
        f();
      }
    };
    tt(() => {
      r.value && h(r.value);
    }), ct(() => {
      p?.removeEventListener("scroll", f), d?.disconnect(), d = null, p = null;
    });
    const {
      columns: $,
      selectable: y,
      expandable: w,
      hasResized: v,
      isResizing: x,
      getColumnStyle: b,
      canResize: k,
      onResizeStart: _,
      autoFitColumn: T,
      snapshotColumnWidths: S,
      sortKey: M,
      sortDirection: E,
      sort: F,
      sortedData: H,
      selectedRows: te,
      allSelected: ie,
      someSelected: ee,
      toggleAll: O,
      toggleRow: z,
      isRowSelected: D,
      toggleExpand: P,
      isExpanded: Z,
      hasChildren: J,
      handleRowClick: re,
      getRowAttributes: U,
      columnCount: ge,
      cellGeometry: K
    } = gy(o, l, { wrapperRef: r });
    let pe;
    const ae = () => {
      clearTimeout(pe), pe = void 0;
    }, Ce = (Te) => Te.target instanceof Element && !!Te.target.closest('button, a, input, [role="button"], [data-range-ignore]'), q = (Te, $e) => {
      Ce($e) || (ae(), Te.sortable && (!o.headerDoubleClick || $e.detail === 0 ? F(Te.key) : $e.detail === 1 && (pe = setTimeout(() => {
        !o.loading && $.value.some((Be) => Be.key === Te.key && Be.sortable) && F(Te.key);
      }, Xy))));
    }, I = (Te, $e) => {
      !o.headerDoubleClick || Ce($e) || (ae(), $e.preventDefault(), o.headerDoubleClick(Te, $e));
    };
    Se(() => o.headerDoubleClick, ae), ct(ae);
    const oe = K.getStickyClass, be = K.getStickyStyle, de = { hasResized: v, getColumnStyle: b, canResize: k, onResizeStart: _, autoFitColumn: T }, X = Ay({
      wrapperRef: r,
      columns: $,
      controller: m(() => o.columnOrder)
    });
    let ne = !1;
    Se(
      () => o.lockColumnWidths,
      (Te) => {
        !Te || ne || (ne = !0, S(), Ye(() => S()));
      },
      { immediate: !0 }
    ), Se($, () => {
      o.lockColumnWidths && Ye(() => S());
    });
    const ve = (Te) => {
      if (!o.rowStates)
        return;
      const $e = String(Te[o.rowKey]);
      return o.rowStates[$e];
    }, V = m(() => [
      `hp-data-table--size-${o.size}`,
      `hp-data-table--row-min-height-${o.rowMinHeight}`,
      {
        "hp-data-table--has-selection": te.value.size > 0,
        "hp-data-table--boxed": o.boxed,
        "hp-data-table--fill-height": o.fillHeight && o.stickyHeaderScroll !== "parent",
        "hp-data-table--rounded-bottom": o.roundedBottom,
        "hp-data-table--bordered": o.bordered,
        "hp-data-table--no-horizontal-lines": !o.horizontalLines,
        "hp-data-table--vertical-lines": o.verticalLines,
        "hp-data-table--resizable-enabled": o.resizable,
        "hp-data-table--resizable": o.resizable && de.hasResized.value,
        "hp-data-table--resizing": o.resizable && x.value,
        "hp-data-table--reordering": X.dragging.value,
        // Fixed-layout engagement driven by the width-lock latch, independent of `resizable`.
        "hp-data-table--width-locked": o.lockColumnWidths && de.hasResized.value,
        "hp-data-table--sticky-header": o.stickyHeader,
        "hp-data-table--sticky-header-parent": o.stickyHeader && o.stickyHeaderScroll === "parent",
        // Scroll-conditional shadow gates (see DataTable.scss sticky shadow rules).
        "hp-data-table--scrolled-start": c.value,
        "hp-data-table--scrolled-end": s.value
      }
    ]), xe = m(() => o.bg ? { "--hp-data-table-bg": o.bg } : void 0), ce = m(() => !o.resizable || o.stickyEndSpacer === !1 ? null : $.value.length - (o.stickyEnd ?? 0));
    return (Te, $e) => (i(), g("div", {
      class: W(["hp-data-table", V.value]),
      ref_key: "tableWrapperRef",
      ref: r,
      style: Ie(xe.value)
    }, [
      e.showSelectionActions && e.selectable && u(te).size > 0 ? (i(), g("div", Ly, [
        j(rc, {
          class: "hp-data-table__selection-scroller",
          "arrow-size": "1"
        }, {
          default: B(() => [
            j(_y),
            L(Te.$slots, "default")
          ]),
          _: 3
        })
      ])) : A("", !0),
      C("div", {
        class: "hp-data-table__wrapper",
        style: Ie(e.stickyHeader && e.stickyHeaderMaxHeight ? { "--sticky-max-height": e.stickyHeaderMaxHeight } : void 0)
      }, [
        j(Mn, {
          loading: e.loading && (e.loadingBar === "always" || u(H).length > 0),
          class: "hp-data-table__loader"
        }, null, 8, ["loading"]),
        C("table", Ey, [
          C("thead", Iy, [
            C("tr", null, [
              e.selectable ? (i(), g("th", Ry, [
                e.singleSelect ? A("", !0) : (i(), R(ln, {
                  key: 0,
                  "model-value": u(ie),
                  indeterminate: u(ee),
                  variant: "surface",
                  size: "2",
                  "onUpdate:modelValue": u(O)
                }, null, 8, ["model-value", "indeterminate", "onUpdate:modelValue"]))
              ])) : A("", !0),
              e.expandable ? (i(), g("th", Py)) : A("", !0),
              (i(!0), g(he, null, De(u($), (Be, Ue) => (i(), g(he, {
                key: Be.key
              }, [
                Ue === ce.value ? (i(), g("th", Oy)) : A("", !0),
                C("th", {
                  class: W(["hp-data-table__th", {
                    "hp-data-table__th--sortable": Be.sortable,
                    [`hp-data-table__th--${Be.align}`]: Be.align,
                    "hp-data-table__cell--mobile-width": !!Be.mobileWidth,
                    ...u(X).getDropClass(Be.key),
                    ...u(oe)(Ue)
                  }]),
                  "data-col-key": Be.key,
                  style: Ie({ ...de.getColumnStyle(Be), ...u(be)(Ue) }),
                  onDragover: (qe) => u(X).onDragOver(qe, Be),
                  onDrop: (qe) => u(X).onDrop(qe, Be),
                  onClick: (qe) => q(Be, qe),
                  onDblclick: (qe) => I(Be, qe)
                }, [
                  C("span", Hy, [
                    u(X).canReorder(Be) ? (i(), g("button", {
                      key: 0,
                      type: "button",
                      draggable: "true",
                      class: "hp-data-table__reorder-handle",
                      "aria-label": u(n)("ui.table.moveColumn", "Move {column} column", { column: Be.label }),
                      "data-col-reorder-key": Be.key,
                      onDragstart: (qe) => u(X).onDragStart(qe, Be),
                      onDragend: $e[0] || ($e[0] = //@ts-ignore
                      (...qe) => u(X).onDragEnd && u(X).onDragEnd(...qe)),
                      onPointerdown: (qe) => u(X).onPointerDown(qe, Be),
                      onKeydown: (qe) => u(X).onKeydown(qe, Be),
                      onClick: $e[1] || ($e[1] = Fe(() => {
                      }, ["stop"]))
                    }, [
                      j(Jl)
                    ], 40, Ny)) : A("", !0),
                    L(Te.$slots, `header-${Be.key}`, { column: Be }, () => [
                      j(By, {
                        label: Be.label,
                        tooltip: Be.tooltip,
                        "label-badge": Be.labelBadge,
                        "label-badge-placement": Be.labelBadgePlacement
                      }, null, 8, ["label", "tooltip", "label-badge", "label-badge-placement"])
                    ]),
                    Be.sortable && u(M) === Be.key ? (i(), g("span", Fy, [
                      C("span", {
                        class: W(["hp-data-table__sort-arrow", { "hp-data-table__sort-arrow--desc": u(E) === "desc" }])
                      }, [
                        j(Sy)
                      ], 2)
                    ])) : A("", !0)
                  ]),
                  de.canResize(Be) ? (i(), g("div", {
                    key: 0,
                    class: "hp-data-table__resize-handle",
                    title: e.autoFitOnDoubleClick ? u(n)("ui.dataTable.dragToResizeAutoFit", "Drag to resize · double-click to auto-fit") : u(n)("ui.dataTable.dragToResize", "Drag to resize"),
                    onMousedown: (qe) => de.onResizeStart(qe, Be.key),
                    onDblclick: Fe((qe) => e.autoFitOnDoubleClick && de.autoFitColumn(Be.key), ["stop"]),
                    onClick: $e[2] || ($e[2] = Fe(() => {
                    }, ["stop"]))
                  }, null, 40, Ky)) : A("", !0)
                ], 46, Vy)
              ], 64))), 128)),
              ce.value === u($).length ? (i(), g("th", Yy)) : A("", !0)
            ])
          ]),
          C("tbody", jy, [
            u(H).length > 0 ? (i(!0), g(he, { key: 0 }, De(u(H), (Be) => (i(), g(he, {
              key: Be[e.rowKey]
            }, [
              j(_g, {
                row: Be,
                columns: u($),
                selectable: u(y),
                expandable: u(w),
                "is-row-selected": u(D)(Be),
                "is-expanded": u(Z)(Be),
                "has-children": u(J)(Be),
                clickable: e.clickable !== !1,
                hoverable: e.hoverable !== !1,
                "row-attrs": u(U)(Be),
                "cell-attrs": e.cellAttrs,
                "row-state": ve(Be),
                "cell-geometry": u(K),
                "spacer-index": ce.value,
                onRowClick: (Ue) => u(re)(Be),
                onToggleRow: (Ue) => u(z)(Be),
                onToggleExpand: (Ue) => u(P)(Be)
              }, it({ _: 2 }, [
                De(u($), (Ue) => ({
                  name: `cell-${Ue.key}`,
                  fn: B((qe) => [
                    L(Te.$slots, `cell-${Ue.key}`, {
                      row: qe.row,
                      value: qe.value
                    }, () => [
                      me(le(qe.value), 1)
                    ])
                  ])
                }))
              ]), 1032, ["row", "columns", "selectable", "expandable", "is-row-selected", "is-expanded", "has-children", "clickable", "hoverable", "row-attrs", "cell-attrs", "row-state", "cell-geometry", "spacer-index", "onRowClick", "onToggleRow", "onToggleExpand"]),
              u(w) && u(Z)(Be) ? (i(), R(by, {
                key: 0,
                "column-count": u(ge)
              }, {
                default: B(() => [
                  L(Te.$slots, "expanded", { row: Be })
                ]),
                _: 2
              }, 1032, ["column-count"])) : A("", !0)
            ], 64))), 128)) : e.loading ? (i(), R(zg, {
              key: 1,
              columns: u($),
              selectable: u(y),
              expandable: u(w),
              "skeleton-rows": e.skeletonRows,
              "cell-geometry": u(K),
              "spacer-index": ce.value
            }, null, 8, ["columns", "selectable", "expandable", "skeleton-rows", "cell-geometry", "spacer-index"])) : e.emptyPlacement === "row" ? (i(), R($g, {
              key: 2,
              "column-count": u(ge)
            }, {
              default: B(() => [
                L(Te.$slots, "empty", {}, () => [
                  me(le(u(n)("ui.dataTable.noDataAvailable", "No data available")), 1)
                ])
              ]),
              _: 3
            }, 8, ["column-count"])) : A("", !0)
          ]),
          a.tfoot ? (i(), g("tfoot", Wy, [
            L(Te.$slots, "tfoot", {
              columns: u($),
              cellGeometry: u(K),
              spacerIndex: ce.value,
              selectable: e.selectable,
              expandable: e.expandable
            })
          ])) : A("", !0)
        ]),
        u(H).length === 0 && !e.loading && e.emptyPlacement === "container" ? (i(), g("div", Uy, [
          C("div", qy, [
            L(Te.$slots, "empty", {}, () => [
              me(le(u(n)("ui.dataTable.noDataAvailable", "No data available")), 1)
            ])
          ])
        ])) : A("", !0)
      ], 4),
      a.footer ? (i(), g("div", Zy, [
        L(Te.$slots, "footer")
      ])) : A("", !0),
      C("span", Gy, le(u(X).announcement.value), 1)
    ], 6));
  }
});
function Dn() {
  const e = bi();
  return i(), g(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img",
      ...e
    },
    [
      C("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      C("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      C("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      C("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
Dn.compatConfig = {
  MODE: 3
};
function yc() {
  return i(), g(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      C("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      C("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
yc.compatConfig = {
  MODE: 3
};
function gr() {
  return i(), g(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      C("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
gr.compatConfig = {
  MODE: 3
};
function yr() {
  return i(), g(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      C("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
yr.compatConfig = {
  MODE: 3
};
function wr() {
  return i(), g(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      C("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      C("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
wr.compatConfig = {
  MODE: 3
};
function br() {
  return i(), g(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      C("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
br.compatConfig = {
  MODE: 3
};
function kr() {
  return i(), g(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon",
      role: "img"
    },
    [
      C("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
kr.compatConfig = {
  MODE: 3
};
const Yt = (e, t) => t ? new Date(e.toLocaleString("en-US", { timeZone: t })) : new Date(e), _r = (e, t, n) => Ll(e, t, n) || ye(), Qy = (e, t, n) => {
  const a = t.dateInTz ? Yt(new Date(e), t.dateInTz) : ye(e);
  return n ? Tt(a, !0) : a;
}, Ll = (e, t, n) => {
  if (!e) return null;
  const a = n ? Tt(ye(e), !0) : ye(e);
  return t ? t.exactMatch ? Qy(e, t, n) : Yt(a, t.timezone) : a;
}, Jy = (e) => {
  const t = new Date(e.getFullYear(), 0, 1).getTimezoneOffset();
  return e.getTimezoneOffset() < t;
}, e3 = (e, t) => {
  if (!e) return 0;
  const n = /* @__PURE__ */ new Date(), a = new Date(n.toLocaleString("en-US", { timeZone: "UTC" })), o = new Date(n.toLocaleString("en-US", { timeZone: e })), l = (Jy(t ?? o) ? o : t ?? o).getTimezoneOffset() / 60;
  return (+a - +o) / (1e3 * 60 * 60) - l;
};
var ta = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(ta || {}), aa = /* @__PURE__ */ ((e) => (e.top = "top", e.bottom = "bottom", e))(aa || {}), Qa = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(Qa || {}), It = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(It || {});
const t3 = ["timestamp", "date", "iso"];
var Ot = /* @__PURE__ */ ((e) => (e.up = "up", e.down = "down", e.left = "left", e.right = "right", e))(Ot || {}), dt = /* @__PURE__ */ ((e) => (e.arrowUp = "ArrowUp", e.arrowDown = "ArrowDown", e.arrowLeft = "ArrowLeft", e.arrowRight = "ArrowRight", e.enter = "Enter", e.space = " ", e.esc = "Escape", e.tab = "Tab", e.home = "Home", e.end = "End", e.pageUp = "PageUp", e.pageDown = "PageDown", e))(dt || {}), vn = /* @__PURE__ */ ((e) => (e.MONTH_AND_YEAR = "MM-yyyy", e.YEAR = "yyyy", e.DATE = "dd-MM-yyyy", e))(vn || {});
function Cs(e) {
  return (t) => {
    const n = new Intl.DateTimeFormat(e, {
      weekday: "short",
      timeZone: "UTC"
    }).format(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`));
    return e === "ar" ? n.slice(2, 5) : n.slice(0, 2);
  };
}
function a3(e) {
  return (t) => yt(Yt(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`), "UTC"), "EEEEEE", { locale: e });
}
const n3 = (e, t, n) => {
  const a = [1, 2, 3, 4, 5, 6, 7];
  let o;
  if (e !== null)
    try {
      o = a.map(a3(e));
    } catch {
      o = a.map(Cs(t));
    }
  else
    o = a.map(Cs(t));
  const l = o.slice(0, n), r = o.slice(n + 1, o.length);
  return [o[n]].concat(...r).concat(...l);
}, Cr = (e, t, n) => {
  const a = [];
  for (let o = +e[0]; o <= +e[1]; o++)
    a.push({ value: +o, text: $r(o, t) });
  return n ? a.reverse() : a;
}, wc = (e, t, n) => {
  const a = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((l) => {
    const r = l < 10 ? `0${l}` : l;
    return /* @__PURE__ */ new Date(`2017-${r}-01T00:00:00+00:00`);
  });
  if (e !== null)
    try {
      const l = n === "long" ? "LLLL" : "LLL";
      return a.map((r, c) => {
        const s = yt(Yt(r, "UTC"), l, { locale: e });
        return {
          text: s.charAt(0).toUpperCase() + s.substring(1),
          value: c
        };
      });
    } catch {
    }
  const o = new Intl.DateTimeFormat(t, { month: n, timeZone: "UTC" });
  return a.map((l, r) => {
    const c = o.format(l);
    return {
      text: c.charAt(0).toUpperCase() + c.substring(1),
      value: r
    };
  });
}, o3 = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], St = (e) => {
  const t = u(e);
  return t?.$el ? t?.$el : t;
}, l3 = (e) => ({ type: "dot", ...e ?? {} }), bc = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, xr = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, Bt = (e) => e, xs = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, $s = (e) => e === null, kc = (e) => {
  if (e)
    return [...e.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, r3 = (e) => {
  const t = [], n = (a) => a.filter((o) => o);
  for (let a = 0; a < e.length; a += 3) {
    const o = [e[a], e[a + 1], e[a + 2]];
    t.push(n(o));
  }
  return t;
}, Yn = (e, t, n) => {
  const a = n != null, o = t != null;
  if (!a && !o) return !1;
  const l = +n, r = +t;
  return a && o ? +e > l || +e < r : a ? +e > l : o ? +e < r : !1;
}, Cn = (e, t) => r3(e).map((n) => n.map((a) => {
  const { active: o, disabled: l, isBetween: r, highlighted: c } = t(a);
  return {
    ...a,
    active: o,
    disabled: l,
    className: {
      dp__overlay_cell_active: o,
      dp__overlay_cell: !o,
      dp__overlay_cell_disabled: l,
      dp__overlay_cell_pad: !0,
      dp__overlay_cell_active_disabled: l && o,
      dp__cell_in_between: r,
      "dp--highlighted": c
    }
  };
})), Ea = (e, t, n = !1) => {
  e && t.allowStopPropagation && (n && e.stopImmediatePropagation(), e.stopPropagation());
}, s3 = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function i3(e, t) {
  let n = [...document.querySelectorAll(s3())];
  n = n.filter((o) => !e.contains(o) || o.hasAttribute("data-datepicker-instance"));
  const a = n.indexOf(e);
  if (a >= 0 && (t ? a - 1 >= 0 : a + 1 <= n.length))
    return n[a + (t ? -1 : 1)];
}
const El = (e, t) => e?.querySelector(`[data-dp-element="${t}"]`), $r = (e, t) => new Intl.NumberFormat(t, { useGrouping: !1, style: "decimal" }).format(e), Sr = (e, t) => yt(e, t ?? vn.DATE), tl = (e) => Array.isArray(e), Bo = (e, t, n) => t.get(Sr(e, n)), c3 = (e, t) => e ? t ? t instanceof Map ? !!Bo(e, t) : t(ye(e)) : !1 : !0, Vt = (e, t, n = !1, a) => {
  if (e.key === dt.enter || e.key === dt.space)
    return n && e.preventDefault(), t();
  if (a) return a(e);
}, u3 = () => "ontouchstart" in window || navigator.maxTouchPoints > 0, _c = (e, t) => e ? vn.MONTH_AND_YEAR : t ? vn.YEAR : vn.DATE, Cc = (e) => e < 10 ? `0${e}` : e, Ss = (e, t, n, a, o, l) => {
  const r = kn(e, t.slice(0, e.length), /* @__PURE__ */ new Date(), { locale: l });
  return Ut(r) && Ni(r) ? a || o ? r : st(r, {
    hours: +n.hours,
    minutes: +n?.minutes,
    seconds: +n?.seconds,
    milliseconds: 0
  }) : null;
}, d3 = (e, t, n, a, o, l) => {
  const r = Array.isArray(n) ? n[0] : n;
  if (typeof t == "string")
    return Ss(e, t, r, a, o, l);
  if (Array.isArray(t)) {
    let c = null;
    for (const s of t)
      if (c = Ss(e, s, r, a, o, l), c)
        break;
    return c;
  }
  return typeof t == "function" ? t(e) : null;
}, ye = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), p3 = (e, t, n) => {
  if (t) {
    const o = (e.getMonth() + 1).toString().padStart(2, "0"), l = e.getDate().toString().padStart(2, "0"), r = e.getHours().toString().padStart(2, "0"), c = e.getMinutes().toString().padStart(2, "0"), s = n ? e.getSeconds().toString().padStart(2, "0") : "00";
    return `${e.getFullYear()}-${o}-${l}T${r}:${c}:${s}.000Z`;
  }
  const a = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(a).toISOString();
}, Tt = (e, t) => {
  const n = ye(JSON.parse(JSON.stringify(e))), a = st(n, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
  return t ? Xa(a) : a;
}, Ia = (e, t, n, a) => {
  let o = e ? ye(e) : ye();
  return (t || t === 0) && (o = lv(o, +t)), (n || n === 0) && (o = rv(o, +n)), (a || a === 0) && (o = tc(o, +a)), ec(o, 0);
}, gt = (e, t) => !e || !t ? !1 : ma(Tt(e), Tt(t)), Je = (e, t) => !e || !t ? !1 : pn(Tt(e), Tt(t)), kt = (e, t) => !e || !t ? !1 : va(Tt(e), Tt(t)), jn = (e, t, n) => e?.[0] && e?.[1] ? kt(n, e[0]) && gt(n, e[1]) : e?.[0] && t ? kt(n, e[0]) && gt(n, t) || gt(n, e[0]) && kt(n, t) : !1, la = (e) => {
  const t = st(new Date(e), { date: 1 });
  return Tt(t);
}, al = (e, t, n) => t && (n || n === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((a) => a === t ? [a, n] : [a, isNaN(+e[a]) ? void 0 : +e[a]])
) : {
  hours: isNaN(+e.hours) ? void 0 : +e.hours,
  minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
  seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
}, Ja = (e) => ({
  hours: Sa(e),
  minutes: Va(e),
  seconds: bn(e)
}), xc = (e, t) => {
  if (t) {
    const n = je(ye(t));
    if (n > e) return 12;
    if (n === e) return Qe(ye(t));
  }
}, $c = (e, t) => {
  if (t) {
    const n = je(ye(t));
    return n < e ? -1 : n === e ? Qe(ye(t)) : void 0;
  }
}, xn = (e) => {
  if (e) return je(ye(e));
}, Sc = (e, t) => {
  const n = kt(e, t) ? t : e, a = kt(t, e) ? t : e;
  return ar({ start: n, end: a });
}, f3 = (e) => {
  const t = Pt(e, 1);
  return { month: Qe(t), year: je(t) };
}, ba = (e, t) => {
  const n = qt(e, { weekStartsOn: +t }), a = nr(e, { weekStartsOn: +t });
  return [n, a];
}, Mc = (e, t) => {
  const n = {
    hours: Sa(ye()),
    minutes: Va(ye()),
    seconds: t ? bn(ye()) : 0
  };
  return Object.assign(n, e);
}, La = (e, t, n) => [st(ye(e), { date: 1 }), st(ye(), { month: t, year: n, date: 1 })], _a = (e, t, n) => {
  let a = e ? ye(e) : ye();
  return (t || t === 0) && (a = Ji(a, t)), n && (a = oa(a, n)), a;
}, Dc = (e, t, n, a, o) => {
  if (!a || o && !t || !o && !n) return !1;
  const l = o ? Pt(e, 1) : Ha(e, 1), r = [Qe(l), je(l)];
  return o ? !v3(...r, t) : !h3(...r, n);
}, h3 = (e, t, n) => gt(...La(n, e, t)) || Je(...La(n, e, t)), v3 = (e, t, n) => kt(...La(n, e, t)) || Je(...La(n, e, t)), Tc = (e, t, n, a, o, l, r) => {
  if (typeof t == "function" && !r) return t(e);
  const c = n ? { locale: n } : void 0;
  return Array.isArray(e) ? `${yt(e[0], l, c)}${o && !e[1] ? "" : a}${e[1] ? yt(e[1], l, c) : ""}` : yt(e, l, c);
}, cn = (e) => {
  if (e) return null;
  throw new Error(xr.prop("partial-range"));
}, uo = (e, t) => {
  if (t) return e();
  throw new Error(xr.prop("range"));
}, Il = (e) => Array.isArray(e) ? Ut(e[0]) && (e[1] ? Ut(e[1]) : !0) : e ? Ut(e) : !1, m3 = (e, t) => st(t ?? ye(), {
  hours: +e.hours || 0,
  minutes: +e.minutes || 0,
  seconds: +e.seconds || 0
}), nl = (e, t, n, a) => {
  if (!e) return !0;
  if (a) {
    const o = n === "max" ? ma(e, t) : va(e, t), l = { seconds: 0, milliseconds: 0 };
    return o || pn(st(e, l), st(t, l));
  }
  return n === "max" ? e.getTime() <= t.getTime() : e.getTime() >= t.getTime();
}, ol = (e, t, n) => e ? m3(e, t) : ye(n ?? t), Ms = (e, t, n, a, o) => {
  if (Array.isArray(a)) {
    const r = ol(e, a[0], t), c = ol(e, a[1], t);
    return nl(a[0], r, n, !!t) && nl(a[1], c, n, !!t) && o;
  }
  const l = ol(e, a, t);
  return nl(a, l, n, !!t) && o;
}, ll = (e) => st(ye(), Ja(e)), g3 = (e, t, n) => {
  if (e instanceof Map) {
    const a = `${Cc(n + 1)}-${t}`;
    return e.size ? e.has(a) : !1;
  }
  return typeof e == "function" ? e(Tt(st(ye(), { month: n, year: t }), !0)) : !1;
}, y3 = (e, t, n) => {
  if (e instanceof Map) {
    const a = `${Cc(n + 1)}-${t}`;
    return e.size ? e.has(a) : !0;
  }
  return !0;
}, Bc = (e, t, n) => typeof e == "function" ? e({ month: t, year: n }) : !!e.months.find((a) => a.month === t && a.year === n), Mr = (e, t) => typeof e == "function" ? e(t) : e.years.includes(t), Rl = (e) => `dp-${yt(e, "yyyy-MM-dd")}`, Ds = (e, t) => {
  const n = Fn(Tt(t), e), a = At(Tt(t), e);
  return { before: n, after: a };
}, zc = (e, t) => t < +e[0] || t > +e[1], Rn = Na({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), Ac = () => {
  const e = (n) => {
    Rn.menuFocused = n;
  }, t = (n) => {
    Rn.shiftKeyInMenu !== n && (Rn.shiftKeyInMenu = n);
  };
  return {
    control: m(() => ({ shiftKeyInMenu: Rn.shiftKeyInMenu, menuFocused: Rn.menuFocused })),
    setMenuFocused: e,
    setShiftKey: t
  };
}, ut = Na({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), rl = N(null), po = N(!1), sl = N(!1), il = N(!1), cl = N(!1), Et = N(0), bt = N(0), Ya = () => {
  const e = m(() => po.value ? [...ut.selectionGrid, ut.actionRow].filter((f) => f.length) : sl.value ? [
    ...ut.timePicker[0],
    ...ut.timePicker[1],
    cl.value ? [] : [rl.value],
    ut.actionRow
  ].filter((f) => f.length) : il.value ? [...ut.monthPicker, ut.actionRow] : [ut.monthYear, ...ut.calendar, ut.time, ut.actionRow].filter((f) => f.length)), t = (f) => {
    Et.value = f ? Et.value + 1 : Et.value - 1;
    let h = null;
    e.value[bt.value] && (h = e.value[bt.value][Et.value]), !h && e.value[bt.value + (f ? 1 : -1)] ? (bt.value = bt.value + (f ? 1 : -1), Et.value = f ? 0 : e.value[bt.value].length - 1) : h || (Et.value = f ? Et.value - 1 : Et.value + 1);
  }, n = (f) => {
    bt.value === 0 && !f || bt.value === e.value.length && f || (bt.value = f ? bt.value + 1 : bt.value - 1, e.value[bt.value] ? e.value[bt.value] && !e.value[bt.value][Et.value] && Et.value !== 0 && (Et.value = e.value[bt.value].length - 1) : bt.value = f ? bt.value - 1 : bt.value + 1);
  }, a = (f) => {
    let h = null;
    e.value[bt.value] && (h = e.value[bt.value][Et.value]), h ? h.focus({ preventScroll: !po.value }) : Et.value = f ? Et.value - 1 : Et.value + 1;
  }, o = () => {
    t(!0), a(!0);
  }, l = () => {
    t(!1), a(!1);
  }, r = () => {
    n(!1), a(!0);
  }, c = () => {
    n(!0), a(!0);
  }, s = (f, h) => {
    ut[h] = f;
  }, p = (f, h) => {
    ut[h] = f;
  }, d = () => {
    Et.value = 0, bt.value = 0;
  };
  return {
    buildMatrix: s,
    buildMultiLevelMatrix: p,
    setTimePickerBackRef: (f) => {
      rl.value = f;
    },
    setSelectionGrid: (f) => {
      po.value = f, d(), f || (ut.selectionGrid = []);
    },
    setTimePicker: (f, h = !1) => {
      sl.value = f, cl.value = h, d(), f || (ut.timePicker[0] = [], ut.timePicker[1] = []);
    },
    setTimePickerElements: (f, h = 0) => {
      ut.timePicker[h] = f;
    },
    arrowRight: o,
    arrowLeft: l,
    arrowUp: r,
    arrowDown: c,
    clearArrowNav: () => {
      ut.monthYear = [], ut.calendar = [], ut.time = [], ut.actionRow = [], ut.selectionGrid = [], ut.timePicker[0] = [], ut.timePicker[1] = [], po.value = !1, sl.value = !1, cl.value = !1, il.value = !1, d(), rl.value = null;
    },
    setMonthPicker: (f) => {
      il.value = f, d();
    },
    refSets: ut
    // exposed for testing
  };
}, Ts = (e) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...e ?? {}
}), w3 = (e) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (t) => `Increment ${t}`,
  decrementValue: (t) => `Decrement ${t}`,
  openTpOverlay: (t) => `Open ${t} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  clearInput: "Clear value",
  calendarIcon: "Calendar icon",
  timePicker: "Time picker",
  monthPicker: (t) => `Month picker${t ? " overlay" : ""}`,
  yearPicker: (t) => `Year picker${t ? " overlay" : ""}`,
  timeOverlay: (t) => `${t} overlay`,
  ...e ?? {}
}), Bs = (e) => e ? typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2 : 0, b3 = (e) => {
  const t = typeof e == "object" && e, n = {
    static: !0,
    solo: !1
  };
  if (!e) return { ...n, count: Bs(!1) };
  const a = t ? e : {}, o = t ? a.count ?? !0 : e, l = Bs(o);
  return Object.assign(n, a, { count: l });
}, k3 = (e, t, n) => e || (typeof n == "string" ? n : t), _3 = (e) => typeof e == "boolean" ? e ? Ts({}) : !1 : Ts(e), C3 = (e) => {
  const t = {
    enterSubmit: !0,
    tabSubmit: !0,
    openMenu: "open",
    selectOnFocus: !1,
    rangeSeparator: " - ",
    escClose: !0
  };
  return typeof e == "object" ? { ...t, ...e ?? {}, enabled: !0 } : { ...t, enabled: e };
}, x3 = (e) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...e ?? {}
}), $3 = (e) => ({
  showSelect: !0,
  showCancel: !0,
  showNow: !1,
  showPreview: !0,
  ...e ?? {}
}), S3 = (e) => {
  const t = { input: !1 };
  return typeof e == "object" ? { ...t, ...e ?? {}, enabled: !0 } : {
    enabled: e,
    ...t
  };
}, M3 = (e) => ({ allowStopPropagation: !0, closeOnScroll: !1, modeHeight: 255, allowPreventDefault: !1, closeOnClearValue: !0, closeOnAutoApply: !0, noSwipe: !1, keepActionRow: !1, onClickOutside: void 0, tabOutClosesMenu: !0, arrowLeft: void 0, keepViewOnOffsetClick: !1, timeArrowHoldThreshold: 0, shadowDom: !1, mobileBreakpoint: 600, setDateOnMenuClose: !1, ...e ?? {} }), D3 = (e) => {
  const t = {
    dates: Array.isArray(e) ? e.map((n) => ye(n)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: [],
    options: { highlightDisabled: !1 }
  };
  return typeof e == "function" ? e : { ...t, ...e ?? {} };
}, T3 = (e) => typeof e == "object" ? {
  type: e?.type ?? "local",
  hideOnOffsetDates: e?.hideOnOffsetDates ?? !1
} : {
  type: e,
  hideOnOffsetDates: !1
}, B3 = (e) => {
  const t = {
    noDisabledRange: !1,
    showLastInRange: !0,
    minMaxRawRange: !1,
    partialRange: !0,
    disableTimeRangeValidation: !1,
    maxRange: void 0,
    minRange: void 0,
    autoRange: void 0,
    fixedStart: !1,
    fixedEnd: !1
  };
  return typeof e == "object" ? { enabled: !0, ...t, ...e } : {
    enabled: e,
    ...t
  };
}, z3 = (e) => e ? typeof e == "string" ? {
  timezone: e,
  exactMatch: !1,
  dateInTz: void 0,
  emitTimezone: void 0,
  convertModel: !0
} : {
  timezone: e.timezone,
  exactMatch: e.exactMatch ?? !1,
  dateInTz: e.dateInTz ?? void 0,
  emitTimezone: e.emitTimezone ?? void 0,
  convertModel: e.convertModel ?? !0
} : { timezone: void 0, exactMatch: !1, emitTimezone: void 0 }, ul = (e, t, n, a) => new Map(
  e.map((o) => {
    const l = _r(o, t, a);
    return [Sr(l, n), l];
  })
), A3 = (e, t) => e.length ? new Map(
  e.map((n) => {
    const a = _r(n.date, t);
    return [Sr(a, vn.DATE), n];
  })
) : null, L3 = (e) => {
  const t = _c(e.isMonthPicker, e.isYearPicker);
  return {
    minDate: Ll(e.minDate, e.timezone, e.isSpecific),
    maxDate: Ll(e.maxDate, e.timezone, e.isSpecific),
    disabledDates: tl(e.disabledDates) ? ul(e.disabledDates, e.timezone, t, e.isSpecific) : e.disabledDates,
    allowedDates: tl(e.allowedDates) ? ul(e.allowedDates, e.timezone, t, e.isSpecific) : null,
    highlight: typeof e.highlight == "object" && tl(e.highlight?.dates) ? ul(e.highlight.dates, e.timezone, t) : e.highlight,
    markers: A3(e.markers, e.timezone)
  };
}, E3 = (e) => typeof e == "boolean" ? { enabled: e, dragSelect: !0, limit: null } : {
  enabled: !!e,
  limit: e.limit ? +e.limit : null,
  dragSelect: e.dragSelect ?? !0
}, I3 = (e) => ({
  ...Object.fromEntries(
    Object.keys(e).map((t) => {
      const n = t, a = e[n], o = typeof e[n] == "string" ? { [a]: !0 } : Object.fromEntries(a.map((l) => [l, !0]));
      return [t, o];
    })
  )
}), ft = (e) => {
  const t = () => {
    const S = e.enableSeconds ? ":ss" : "", M = e.enableMinutes ? ":mm" : "";
    return e.is24 ? `HH${M}${S}` : `hh${M}${S} aa`;
  }, n = () => e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? t() : e.weekPicker ? `${v.value?.type === "iso" ? "II" : "ww"}-RR` : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${t()}` : "MM/dd/yyyy", a = (S) => Mc(S, e.enableSeconds), o = () => _.value.enabled ? e.startTime && Array.isArray(e.startTime) ? [a(e.startTime[0]), a(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? a(e.startTime) : null, l = m(() => b3(e.multiCalendars)), r = m(() => o()), c = m(() => w3(e.ariaLabels)), s = m(() => x3(e.filters)), p = m(() => _3(e.transitions)), d = m(() => $3(e.actionRow)), f = m(
    () => k3(e.previewFormat, e.format, n())
  ), h = m(() => C3(e.textInput)), $ = m(() => S3(e.inline)), y = m(() => M3(e.config)), w = m(() => D3(e.highlight)), v = m(() => T3(e.weekNumbers)), x = m(() => z3(e.timezone)), b = m(() => E3(e.multiDates)), k = m(
    () => L3({
      minDate: e.minDate,
      maxDate: e.maxDate,
      disabledDates: e.disabledDates,
      allowedDates: e.allowedDates,
      highlight: w.value,
      markers: e.markers,
      timezone: x.value,
      isSpecific: e.monthPicker || e.yearPicker || e.quarterPicker,
      isMonthPicker: e.monthPicker,
      isYearPicker: e.yearPicker
    })
  ), _ = m(() => B3(e.range)), T = m(() => I3(e.ui));
  return {
    defaultedTransitions: p,
    defaultedMultiCalendars: l,
    defaultedStartTime: r,
    defaultedAriaLabels: c,
    defaultedFilters: s,
    defaultedActionRow: d,
    defaultedPreviewFormat: f,
    defaultedTextInput: h,
    defaultedInline: $,
    defaultedConfig: y,
    defaultedHighlight: w,
    defaultedWeekNumbers: v,
    defaultedRange: _,
    propDates: k,
    defaultedTz: x,
    defaultedMultiDates: b,
    defaultedUI: T,
    getDefaultPattern: n,
    getDefaultStartTime: o,
    handleEventPropagation: (S) => {
      y.value.allowStopPropagation && S.stopPropagation(), y.value.allowPreventDefault && S.preventDefault();
    }
  };
}, R3 = (e, t, { isInputFocused: n, isTextInputDate: a }) => {
  const o = N(), { defaultedTextInput: l, defaultedRange: r, defaultedTz: c, defaultedMultiDates: s, getDefaultPattern: p } = ft(t), d = N(""), f = Ze(t, "format"), h = Ze(t, "formatLocale");
  Se(
    o,
    () => {
      typeof t.onInternalModelChange == "function" && e("internal-model-change", o.value, q(!0));
    },
    { deep: !0 }
  ), Se(r, (I, oe) => {
    I.enabled !== oe.enabled && (o.value = null);
  }), Se(f, () => {
    J();
  });
  const $ = (I) => c.value.timezone && c.value.convertModel ? Yt(I, c.value.timezone) : I, y = (I) => {
    if (c.value.timezone && c.value.convertModel) {
      const oe = e3(c.value.timezone, I);
      return Yp(I, oe);
    }
    return I;
  }, w = (I, oe, be = !1) => Tc(
    I,
    t.format,
    t.formatLocale,
    l.value.rangeSeparator,
    t.modelAuto,
    oe ?? p(),
    be
  ), v = (I) => I ? t.modelType ? U(I) : {
    hours: Sa(I),
    minutes: Va(I),
    seconds: t.enableSeconds ? bn(I) : 0
  } : null, x = (I) => t.modelType ? U(I) : { month: Qe(I), year: je(I) }, b = (I) => Array.isArray(I) ? s.value.enabled ? I.map((oe) => k(oe, oa(ye(), oe))) : uo(
    () => [
      oa(ye(), I[0]),
      I[1] ? oa(ye(), I[1]) : cn(r.value.partialRange)
    ],
    r.value.enabled
  ) : oa(ye(), +I), k = (I, oe) => (typeof I == "string" || typeof I == "number") && t.modelType ? re(I) : oe, _ = (I) => Array.isArray(I) ? [
    k(
      I[0],
      Ia(null, +I[0].hours, +I[0].minutes, I[0].seconds)
    ),
    k(
      I[1],
      Ia(null, +I[1].hours, +I[1].minutes, I[1].seconds)
    )
  ] : k(I, Ia(null, I.hours, I.minutes, I.seconds)), T = (I) => {
    const oe = st(ye(), { date: 1 });
    return Array.isArray(I) ? s.value.enabled ? I.map((be) => k(be, _a(oe, +be.month, +be.year))) : uo(
      () => [
        k(I[0], _a(oe, +I[0].month, +I[0].year)),
        k(
          I[1],
          I[1] ? _a(oe, +I[1].month, +I[1].year) : cn(r.value.partialRange)
        )
      ],
      r.value.enabled
    ) : k(I, _a(oe, +I.month, +I.year));
  }, S = (I) => {
    if (Array.isArray(I))
      return I.map((oe) => re(oe));
    throw new Error(xr.dateArr("multi-dates"));
  }, M = (I) => {
    if (Array.isArray(I) && r.value.enabled) {
      const oe = I[0], be = I[1];
      return [
        ye(Array.isArray(oe) ? oe[0] : null),
        Array.isArray(be) && be.length ? ye(be[0]) : null
      ];
    }
    return ye(I[0]);
  }, E = (I) => t.modelAuto ? Array.isArray(I) ? [re(I[0]), re(I[1])] : t.autoApply ? [re(I)] : [re(I), null] : Array.isArray(I) ? uo(
    () => I[1] ? [
      re(I[0]),
      I[1] ? re(I[1]) : cn(r.value.partialRange)
    ] : [re(I[0])],
    r.value.enabled
  ) : re(I), F = () => {
    Array.isArray(o.value) && r.value.enabled && o.value.length === 1 && o.value.push(cn(r.value.partialRange));
  }, H = () => {
    const I = o.value;
    return [
      U(I[0]),
      I[1] ? U(I[1]) : cn(r.value.partialRange)
    ];
  }, te = () => Array.isArray(o.value) ? o.value[1] ? H() : U(Bt(o.value[0])) : [], ie = () => (o.value || []).map((I) => U(I)), ee = (I = !1) => (I || F(), t.modelAuto ? te() : s.value.enabled ? ie() : Array.isArray(o.value) ? uo(() => H(), r.value.enabled) : U(Bt(o.value))), O = (I) => !I || Array.isArray(I) && !I.length ? null : t.timePicker ? _(Bt(I)) : t.monthPicker ? T(Bt(I)) : t.yearPicker ? b(Bt(I)) : s.value.enabled ? S(Bt(I)) : t.weekPicker ? M(Bt(I)) : E(Bt(I)), z = (I) => {
    if (a.value) return;
    const oe = O(I);
    Il(Bt(oe)) ? (o.value = Bt(oe), J()) : (o.value = null, d.value = "");
  }, D = () => {
    const I = (oe) => yt(oe, l.value.format);
    return `${I(o.value[0])} ${l.value.rangeSeparator} ${o.value[1] ? I(o.value[1]) : ""}`;
  }, P = () => n.value && o.value ? Array.isArray(o.value) ? D() : yt(o.value, l.value.format) : w(o.value), Z = () => o.value ? s.value.enabled ? o.value.map((I) => w(I)).join("; ") : l.value.enabled && typeof l.value.format == "string" ? P() : w(o.value) : "", J = () => {
    !t.format || typeof t.format == "string" || l.value.enabled && typeof l.value.format == "string" ? d.value = Z() : d.value = t.format(o.value);
  }, re = (I) => {
    if (t.utc) {
      const oe = new Date(I);
      return t.utc === "preserve" ? new Date(oe.getTime() + oe.getTimezoneOffset() * 6e4) : oe;
    }
    return t.modelType ? t3.includes(t.modelType) ? $(new Date(I)) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? $(
      kn(I, p(), /* @__PURE__ */ new Date(), { locale: h.value })
    ) : $(
      kn(I, t.modelType, /* @__PURE__ */ new Date(), { locale: h.value })
    ) : $(new Date(I));
  }, U = (I) => I ? t.utc ? p3(I, t.utc === "preserve", t.enableSeconds) : t.modelType ? t.modelType === "timestamp" ? +y(I) : t.modelType === "iso" ? y(I).toISOString() : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? w(y(I)) : w(y(I), t.modelType, !0) : y(I) : "", ge = (I, oe = !1, be = !1) => {
    if (be) return I;
    if (e("update:model-value", I), c.value.emitTimezone && oe) {
      const de = Array.isArray(I) ? I.map((X) => Yt(Bt(X), c.value.emitTimezone)) : Yt(Bt(I), c.value.emitTimezone);
      e("update:model-timezone-value", de);
    }
  }, K = (I) => Array.isArray(o.value) ? s.value.enabled ? o.value.map((oe) => I(oe)) : [
    I(o.value[0]),
    o.value[1] ? I(o.value[1]) : cn(r.value.partialRange)
  ] : I(Bt(o.value)), pe = () => {
    if (Array.isArray(o.value)) {
      const I = ba(o.value[0], t.weekStart), oe = o.value[1] ? ba(o.value[1], t.weekStart) : [];
      return [I.map((be) => ye(be)), oe.map((be) => ye(be))];
    }
    return ba(o.value, t.weekStart).map((I) => ye(I));
  }, ae = (I, oe) => ge(Bt(K(I)), !1, oe), Ce = (I) => {
    const oe = pe();
    return I ? oe : e("update:model-value", pe());
  }, q = (I = !1) => (I || J(), t.monthPicker ? ae(x, I) : t.timePicker ? ae(v, I) : t.yearPicker ? ae(je, I) : t.weekPicker ? Ce(I) : ge(ee(I), !0, I));
  return {
    inputValue: d,
    internalModelValue: o,
    checkBeforeEmit: () => o.value ? r.value.enabled ? r.value.partialRange ? o.value.length >= 1 : o.value.length === 2 : !!o.value : !1,
    parseExternalModelValue: z,
    formatInputValue: J,
    emitModelValue: q
  };
}, P3 = (e, t) => {
  const { defaultedFilters: n, propDates: a } = ft(e), { validateMonthYearInRange: o } = ja(e), l = (d, f) => {
    let h = d;
    return n.value.months.includes(Qe(h)) ? (h = f ? Pt(d, 1) : Ha(d, 1), l(h, f)) : h;
  }, r = (d, f) => {
    let h = d;
    return n.value.years.includes(je(h)) ? (h = f ? tr(d, 1) : ac(d, 1), r(h, f)) : h;
  }, c = (d, f = !1) => {
    const h = st(ye(), { month: e.month, year: e.year });
    let $ = d ? Pt(h, 1) : Ha(h, 1);
    e.disableYearSelect && ($ = oa($, e.year));
    let y = Qe($), w = je($);
    n.value.months.includes(y) && ($ = l($, d), y = Qe($), w = je($)), n.value.years.includes(w) && ($ = r($, d), w = je($)), o(y, w, d, e.preventMinMaxNavigation) && s(y, w, f);
  }, s = (d, f, h) => {
    t("update-month-year", { month: d, year: f, fromNav: h });
  }, p = m(() => (d) => Dc(
    st(ye(), { month: e.month, year: e.year }),
    a.value.maxDate,
    a.value.minDate,
    e.preventMinMaxNavigation,
    d
  ));
  return { handleMonthYearChange: c, isDisabled: p, updateMonthYear: s };
}, Ho = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: [Boolean, String], default: !0 },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: [String, Object], default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  disableYearSelect: { type: Boolean, default: !1 },
  dayClass: {
    type: Function,
    default: null
  },
  yearRange: { type: Array, default: () => [1900, 2100] },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: !1 },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  reverseYears: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  highlight: {
    type: [Function, Object],
    default: null
  },
  teleport: { type: [Boolean, String, Object], default: null },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: [Object, Boolean], default: !1 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  alwaysClearable: { type: Boolean, default: !1 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: [Boolean, Object], default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: [Boolean, Object], default: !1 },
  textInput: { type: [Boolean, Object], default: !1 },
  sixWeeks: { type: [Boolean, String], default: !1 },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: !1 },
  disabledTimes: { type: [Function, Array], default: void 0 },
  timePickerInline: { type: Boolean, default: !1 },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: !1 },
  yearFirst: { type: Boolean, default: !1 },
  loading: { type: Boolean, default: !1 },
  onInternalModelChange: { type: [Function, Object], default: null },
  enableMinutes: { type: Boolean, default: !0 },
  ui: { type: Object, default: () => ({}) }
}, ia = {
  ...Ho,
  shadow: { type: Boolean, default: !1 },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  noOverlayFocus: { type: Boolean, default: !1 },
  collapse: { type: Boolean, default: !1 },
  menuWrapRef: { type: Object, default: null },
  getInputRect: { type: Function, default: () => ({}) },
  isTextInputDate: { type: Boolean, default: !1 },
  isMobile: { type: Boolean, default: void 0 }
}, O3 = ["title"], V3 = ["disabled"], H3 = /* @__PURE__ */ Y({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: !1 },
    calendarWidth: { type: Number, default: 0 },
    ...ia
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(e, { emit: t }) {
    const n = t, a = e, {
      defaultedActionRow: o,
      defaultedPreviewFormat: l,
      defaultedMultiCalendars: r,
      defaultedTextInput: c,
      defaultedInline: s,
      defaultedRange: p,
      defaultedMultiDates: d
    } = ft(a), { isTimeValid: f, isMonthValid: h } = ja(a), { buildMatrix: $ } = Ya(), y = N(null), w = N(null), v = N(!1), x = N({}), b = N(null), k = N(null);
    tt(() => {
      a.arrowNavigation && $([St(y), St(w)], "actionRow"), _(), window.addEventListener("resize", _);
    }), Fa(() => {
      window.removeEventListener("resize", _);
    });
    const _ = () => {
      v.value = !1, setTimeout(() => {
        const O = b.value?.getBoundingClientRect(), z = k.value?.getBoundingClientRect();
        O && z && (x.value.maxWidth = `${z.width - O.width - 20}px`), v.value = !0;
      }, 0);
    }, T = m(() => p.value.enabled && !p.value.partialRange && a.internalModelValue ? a.internalModelValue.length === 2 : !0), S = m(
      () => !f.value(a.internalModelValue) || !h.value(a.internalModelValue) || !T.value
    ), M = () => {
      const O = l.value;
      return a.timePicker || a.monthPicker, O(Bt(a.internalModelValue));
    }, E = () => {
      const O = a.internalModelValue;
      return r.value.count > 0 ? `${F(O[0])} - ${F(O[1])}` : [F(O[0]), F(O[1])];
    }, F = (O) => Tc(
      O,
      l.value,
      a.formatLocale,
      c.value.rangeSeparator,
      a.modelAuto,
      l.value
    ), H = m(() => !a.internalModelValue || !a.menuMount ? "" : typeof l.value == "string" ? Array.isArray(a.internalModelValue) ? a.internalModelValue.length === 2 && a.internalModelValue[1] ? E() : d.value.enabled ? a.internalModelValue.map((O) => `${F(O)}`) : a.modelAuto ? `${F(a.internalModelValue[0])}` : `${F(a.internalModelValue[0])} -` : F(a.internalModelValue) : M()), te = () => d.value.enabled ? "; " : " - ", ie = m(
      () => Array.isArray(H.value) ? H.value.join(te()) : H.value
    ), ee = () => {
      f.value(a.internalModelValue) && h.value(a.internalModelValue) && T.value ? n("select-date") : n("invalid-select");
    };
    return (O, z) => (i(), g("div", {
      ref_key: "actionRowRef",
      ref: k,
      class: "dp__action_row"
    }, [
      O.$slots["action-row"] ? L(O.$slots, "action-row", Mt(Ke({ key: 0 }, {
        internalModelValue: O.internalModelValue,
        disabled: S.value,
        selectDate: () => O.$emit("select-date"),
        closePicker: () => O.$emit("close-picker")
      }))) : (i(), g(he, { key: 1 }, [
        u(o).showPreview ? (i(), g("div", {
          key: 0,
          class: "dp__selection_preview",
          title: ie.value,
          style: Ie(x.value)
        }, [
          O.$slots["action-preview"] && v.value ? L(O.$slots, "action-preview", {
            key: 0,
            value: O.internalModelValue
          }) : A("", !0),
          !O.$slots["action-preview"] && v.value ? (i(), g(he, { key: 1 }, [
            me(le(ie.value), 1)
          ], 64)) : A("", !0)
        ], 12, O3)) : A("", !0),
        C("div", {
          ref_key: "actionBtnContainer",
          ref: b,
          class: "dp__action_buttons",
          "data-dp-element": "action-row"
        }, [
          O.$slots["action-buttons"] ? L(O.$slots, "action-buttons", {
            key: 0,
            value: O.internalModelValue
          }) : A("", !0),
          O.$slots["action-buttons"] ? A("", !0) : (i(), g(he, { key: 1 }, [
            !u(s).enabled && u(o).showCancel ? (i(), g("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: y,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: z[0] || (z[0] = (D) => O.$emit("close-picker")),
              onKeydown: z[1] || (z[1] = (D) => u(Vt)(D, () => O.$emit("close-picker")))
            }, le(O.cancelText), 545)) : A("", !0),
            u(o).showNow ? (i(), g("button", {
              key: 1,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: z[2] || (z[2] = (D) => O.$emit("select-now")),
              onKeydown: z[3] || (z[3] = (D) => u(Vt)(D, () => O.$emit("select-now")))
            }, le(O.nowButtonLabel), 33)) : A("", !0),
            u(o).showSelect ? (i(), g("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: w,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: S.value,
              "data-test-id": "select-button",
              onKeydown: z[4] || (z[4] = (D) => u(Vt)(D, () => ee())),
              onClick: ee
            }, le(O.selectText), 41, V3)) : A("", !0)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), N3 = ["role", "aria-label", "tabindex"], F3 = { class: "dp__selection_grid_header" }, K3 = ["aria-selected", "aria-disabled", "data-test-id", "onClick", "onKeydown", "onMouseover"], Y3 = ["aria-label"], to = /* @__PURE__ */ Y({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {},
    menuWrapRef: {},
    ariaLabels: {},
    overlayLabel: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { expose: t, emit: n }) {
    const { setSelectionGrid: a, buildMultiLevelMatrix: o, setMonthPicker: l } = Ya(), r = n, c = e, { defaultedAriaLabels: s, defaultedTextInput: p, defaultedConfig: d, handleEventPropagation: f } = ft(
      c
    ), { hideNavigationButtons: h } = Ko(), $ = N(!1), y = N(null), w = N(null), v = N([]), x = N(), b = N(null), k = N(0), _ = N(null);
    Nu(() => {
      y.value = null;
    }), tt(() => {
      Ye().then(() => ie()), c.noOverlayFocus || S(), T(!0);
    }), Fa(() => T(!1));
    const T = (K) => {
      c.arrowNavigation && (c.headerRefs?.length ? l(K) : a(K));
    }, S = () => {
      const K = St(w);
      K && (p.value.enabled || (y.value ? y.value?.focus({ preventScroll: !0 }) : K.focus({ preventScroll: !0 })), $.value = K.clientHeight < K.scrollHeight);
    }, M = m(
      () => ({
        dp__overlay: !0,
        "dp--overlay-absolute": !c.useRelative,
        "dp--overlay-relative": c.useRelative
      })
    ), E = m(
      () => c.useRelative ? { height: `${c.height}px`, width: "var(--dp-menu-min-width)" } : void 0
    ), F = m(() => ({
      dp__overlay_col: !0
    })), H = m(
      () => ({
        dp__btn: !0,
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: $.value,
        dp__button_bottom: c.isLast
      })
    ), te = m(() => ({
      dp__overlay_container: !0,
      dp__container_flex: c.items?.length <= 6,
      dp__container_block: c.items?.length > 6
    }));
    Se(
      () => c.items,
      () => ie(!1),
      { deep: !0 }
    );
    const ie = (K = !0) => {
      Ye().then(() => {
        const pe = St(y), ae = St(w), Ce = St(b), q = St(_), I = Ce ? Ce.getBoundingClientRect().height : 0;
        ae && (ae.getBoundingClientRect().height ? k.value = ae.getBoundingClientRect().height - I : k.value = d.value.modeHeight - I), pe && q && K && (q.scrollTop = pe.offsetTop - q.offsetTop - (k.value / 2 - pe.getBoundingClientRect().height) - I);
      });
    }, ee = (K) => {
      K.disabled || r("selected", K.value);
    }, O = () => {
      r("toggle"), r("reset-flow");
    }, z = (K) => {
      c.escClose && (O(), f(K));
    }, D = (K, pe, ae, Ce) => {
      K && ((pe.active || pe.value === c.focusValue) && (y.value = K), c.arrowNavigation && (Array.isArray(v.value[ae]) ? v.value[ae][Ce] = K : v.value[ae] = [K], P()));
    }, P = () => {
      const K = c.headerRefs?.length ? [c.headerRefs].concat(v.value) : v.value.concat([c.skipButtonRef ? [] : [b.value]]);
      o(Bt(K), c.headerRefs?.length ? "monthPicker" : "selectionGrid");
    }, Z = (K) => {
      c.arrowNavigation || Ea(K, d.value, !0);
    }, J = (K) => {
      x.value = K, r("hover-value", K);
    }, re = () => {
      if (O(), !c.isLast) {
        const K = El(c.menuWrapRef ?? null, "action-row");
        K && kc(K)?.focus();
      }
    }, U = (K) => {
      switch (K.key) {
        case dt.esc:
          return z(K);
        case dt.arrowLeft:
          return Z(K);
        case dt.arrowRight:
          return Z(K);
        case dt.arrowUp:
          return Z(K);
        case dt.arrowDown:
          return Z(K);
        default:
          return;
      }
    }, ge = (K) => {
      if (K.key === dt.enter) return O();
      if (K.key === dt.tab) return re();
    };
    return t({ focusGrid: S }), (K, pe) => (i(), g("div", {
      ref_key: "gridWrapRef",
      ref: w,
      class: W(M.value),
      style: Ie(E.value),
      role: e.useRelative ? void 0 : "dialog",
      "aria-label": e.overlayLabel,
      tabindex: e.useRelative ? void 0 : "0",
      onKeydown: U,
      onClick: pe[0] || (pe[0] = Fe(() => {
      }, ["prevent"]))
    }, [
      C("div", {
        ref_key: "containerRef",
        ref: _,
        class: W(te.value),
        style: Ie({ "--dp-overlay-height": `${k.value}px` }),
        role: "grid"
      }, [
        C("div", F3, [
          L(K.$slots, "header")
        ]),
        K.$slots.overlay ? L(K.$slots, "overlay", { key: 0 }) : (i(!0), g(he, { key: 1 }, De(e.items, (ae, Ce) => (i(), g("div", {
          key: Ce,
          class: W(["dp__overlay_row", { dp__flex_row: e.items.length >= 3 }]),
          role: "row"
        }, [
          (i(!0), g(he, null, De(ae, (q, I) => (i(), g("div", {
            key: q.value,
            ref_for: !0,
            ref: (oe) => D(oe, q, Ce, I),
            role: "gridcell",
            class: W(F.value),
            "aria-selected": q.active || void 0,
            "aria-disabled": q.disabled || void 0,
            tabindex: "0",
            "data-test-id": q.text,
            onClick: Fe((oe) => ee(q), ["prevent"]),
            onKeydown: (oe) => u(Vt)(oe, () => ee(q), !0),
            onMouseover: (oe) => J(q.value)
          }, [
            C("div", {
              class: W(q.className)
            }, [
              K.$slots.item ? L(K.$slots, "item", {
                key: 0,
                item: q
              }) : A("", !0),
              K.$slots.item ? A("", !0) : (i(), g(he, { key: 1 }, [
                me(le(q.text), 1)
              ], 64))
            ], 2)
          ], 42, K3))), 128))
        ], 2))), 128))
      ], 6),
      K.$slots["button-icon"] ? ra((i(), g("button", {
        key: 0,
        ref_key: "toggleButton",
        ref: b,
        type: "button",
        "aria-label": u(s)?.toggleOverlay,
        class: W(H.value),
        tabindex: "0",
        onClick: O,
        onKeydown: ge
      }, [
        L(K.$slots, "button-icon")
      ], 42, Y3)), [
        [xa, !u(h)(e.hideNavigation, e.type)]
      ]) : A("", !0)
    ], 46, N3));
  }
}), j3 = ["data-dp-mobile"], No = /* @__PURE__ */ Y({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean },
    collapse: { type: Boolean },
    isMobile: { type: Boolean }
  },
  setup(e) {
    const t = e, n = m(
      () => t.multiCalendars > 0 ? [...Array(t.multiCalendars).keys()] : [0]
    ), a = m(() => ({
      dp__instance_calendar: t.multiCalendars > 0
    }));
    return (o, l) => (i(), g("div", {
      class: W({
        dp__menu_inner: !e.stretch,
        "dp--menu--inner-stretched": e.stretch,
        dp__flex_display: e.multiCalendars > 0,
        "dp--flex-display-collapsed": e.collapse
      }),
      "data-dp-mobile": e.isMobile
    }, [
      (i(!0), g(he, null, De(n.value, (r, c) => (i(), g("div", {
        key: r,
        class: W(a.value)
      }, [
        L(o.$slots, "default", {
          instance: r,
          index: c
        })
      ], 2))), 128))
    ], 10, j3));
  }
}), W3 = ["data-dp-element", "aria-label", "aria-disabled"], Vn = /* @__PURE__ */ Y({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    elName: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: t }) {
    const n = t, a = N(null);
    return tt(() => n("set-ref", a)), (o, l) => (i(), g("button", {
      ref_key: "elRef",
      ref: a,
      type: "button",
      "data-dp-element": e.elName,
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": e.ariaLabel,
      "aria-disabled": e.disabled || void 0,
      onClick: l[0] || (l[0] = (r) => n("activate")),
      onKeydown: l[1] || (l[1] = (r) => u(Vt)(r, () => n("activate"), !0))
    }, [
      C("span", {
        class: W(["dp__inner_nav", { dp__inner_nav_disabled: e.disabled }])
      }, [
        L(o.$slots, "default")
      ], 2)
    ], 40, W3));
  }
}), U3 = ["aria-label", "data-test-id"], Lc = /* @__PURE__ */ Y({
  __name: "YearModePicker",
  props: {
    ...ia,
    showYearPicker: { type: Boolean, default: !1 },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => !1 }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(e, { emit: t }) {
    const n = t, a = e, { showRightIcon: o, showLeftIcon: l } = Ko(), { defaultedConfig: r, defaultedMultiCalendars: c, defaultedAriaLabels: s, defaultedTransitions: p, defaultedUI: d } = ft(a), { showTransition: f, transitionName: h } = ao(p), $ = N(!1), y = m(() => $r(a.year, a.locale)), w = (b = !1, k) => {
      $.value = !$.value, n("toggle-year-picker", { flow: b, show: k });
    }, v = (b) => {
      $.value = !1, n("year-select", b);
    }, x = (b = !1) => {
      n("handle-year", b);
    };
    return (b, k) => (i(), g(he, null, [
      C("div", {
        class: W(["dp--year-mode-picker", { "dp--hidden-el": $.value }])
      }, [
        u(l)(u(c), e.instance) ? (i(), R(Vn, {
          key: 0,
          ref: "mpPrevIconRef",
          "aria-label": u(s)?.prevYear,
          disabled: e.isDisabled(!1),
          class: W(u(d)?.navBtnPrev),
          onActivate: k[0] || (k[0] = (_) => x(!1))
        }, {
          default: B(() => [
            b.$slots["arrow-left"] ? L(b.$slots, "arrow-left", { key: 0 }) : A("", !0),
            b.$slots["arrow-left"] ? A("", !0) : (i(), R(u(gr), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled", "class"])) : A("", !0),
        C("button", {
          ref: "mpYearButtonRef",
          class: "dp__btn dp--year-select",
          type: "button",
          "aria-label": `${e.year}-${u(s)?.openYearsOverlay}`,
          "data-test-id": `year-mode-btn-${e.instance}`,
          onClick: k[1] || (k[1] = () => w(!1)),
          onKeydown: k[2] || (k[2] = sa(() => w(!1), ["enter"]))
        }, [
          b.$slots.year ? L(b.$slots, "year", {
            key: 0,
            year: e.year,
            text: y.value,
            value: e.year
          }) : A("", !0),
          b.$slots.year ? A("", !0) : (i(), g(he, { key: 1 }, [
            me(le(y.value), 1)
          ], 64))
        ], 40, U3),
        u(o)(u(c), e.instance) ? (i(), R(Vn, {
          key: 1,
          ref: "mpNextIconRef",
          "aria-label": u(s)?.nextYear,
          disabled: e.isDisabled(!0),
          class: W(u(d)?.navBtnNext),
          onActivate: k[3] || (k[3] = (_) => x(!0))
        }, {
          default: B(() => [
            b.$slots["arrow-right"] ? L(b.$slots, "arrow-right", { key: 0 }) : A("", !0),
            b.$slots["arrow-right"] ? A("", !0) : (i(), R(u(yr), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled", "class"])) : A("", !0)
      ], 2),
      j(Ra, {
        name: u(h)(e.showYearPicker),
        css: u(f)
      }, {
        default: B(() => [
          e.showYearPicker ? (i(), R(to, {
            key: 0,
            items: e.items,
            "text-input": b.textInput,
            "esc-close": b.escClose,
            config: b.config,
            "is-last": b.autoApply && !u(r).keepActionRow,
            "hide-navigation": b.hideNavigation,
            "aria-labels": b.ariaLabels,
            "overlay-label": u(s)?.yearPicker?.(!0),
            type: "year",
            onToggle: w,
            onSelected: k[4] || (k[4] = (_) => v(_))
          }, it({
            "button-icon": B(() => [
              b.$slots["calendar-icon"] ? L(b.$slots, "calendar-icon", { key: 0 }) : A("", !0),
              b.$slots["calendar-icon"] ? A("", !0) : (i(), R(u(Dn), { key: 1 }))
            ]),
            _: 2
          }, [
            b.$slots["year-overlay-value"] ? {
              name: "item",
              fn: B(({ item: _ }) => [
                L(b.$slots, "year-overlay-value", {
                  text: _.text,
                  value: _.value
                })
              ]),
              key: "0"
            } : void 0
          ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation", "aria-labels", "overlay-label"])) : A("", !0)
        ]),
        _: 3
      }, 8, ["name", "css"])
    ], 64));
  }
}), Dr = (e, t, n) => {
  if (t.value && Array.isArray(t.value))
    if (t.value.some((a) => Je(e, a))) {
      const a = t.value.filter((o) => !Je(o, e));
      t.value = a.length ? a : null;
    } else (n && +n > t.value.length || !n) && t.value.push(e);
  else
    t.value = [e];
}, Tr = (e, t, n) => {
  let a = e.value ? e.value.slice() : [];
  return a.length === 2 && a[1] !== null && (a = []), a.length ? (gt(t, a[0]) ? a.unshift(t) : a[1] = t, n("range-end", t)) : (a = [t], n("range-start", t)), a;
}, Fo = (e, t, n, a) => {
  e && (e[0] && e[1] && n && t("auto-apply"), e[0] && !e[1] && a && n && t("auto-apply"));
}, Ec = (e) => {
  Array.isArray(e.value) && e.value.length <= 2 && e.range ? e.modelValue.value = e.value.map((t) => Yt(ye(t), e.timezone)) : Array.isArray(e.value) || (e.modelValue.value = Yt(ye(e.value), e.timezone));
}, Ic = (e, t, n, a) => Array.isArray(t.value) && (t.value.length === 2 || t.value.length === 1 && a.value.partialRange) ? a.value.fixedStart && (kt(e, t.value[0]) || Je(e, t.value[0])) ? [t.value[0], e] : a.value.fixedEnd && (gt(e, t.value[1]) || Je(e, t.value[1])) ? [e, t.value[1]] : (n("invalid-fixed-range", e), t.value) : [], Rc = ({
  multiCalendars: e,
  range: t,
  highlight: n,
  propDates: a,
  calendars: o,
  modelValue: l,
  props: r,
  filters: c,
  year: s,
  month: p,
  emit: d
}) => {
  const f = m(() => Cr(r.yearRange, r.locale, r.reverseYears)), h = N([!1]), $ = m(() => (H, te) => {
    const ie = st(la(/* @__PURE__ */ new Date()), {
      month: p.value(H),
      year: s.value(H)
    }), ee = te ? Ki(ie) : hn(ie);
    return Dc(
      ee,
      a.value.maxDate,
      a.value.minDate,
      r.preventMinMaxNavigation,
      te
    );
  }), y = () => Array.isArray(l.value) && e.value.solo && l.value[1], w = () => {
    for (let H = 0; H < e.value.count; H++)
      if (H === 0)
        o.value[H] = o.value[0];
      else if (H === e.value.count - 1 && y())
        o.value[H] = {
          month: Qe(l.value[1]),
          year: je(l.value[1])
        };
      else {
        const te = st(ye(), o.value[H - 1]);
        o.value[H] = { month: Qe(te), year: je(tr(te, 1)) };
      }
  }, v = (H) => {
    if (!H) return w();
    const te = st(ye(), o.value[H]);
    return o.value[0].year = je(ac(te, e.value.count - 1)), w();
  }, x = (H, te) => {
    const ie = Gp(te, H);
    return t.value.showLastInRange && ie > 1 ? te : H;
  }, b = (H) => r.focusStartDate || e.value.solo ? H[0] : H[1] ? x(H[0], H[1]) : H[0], k = () => {
    if (l.value) {
      const H = Array.isArray(l.value) ? b(l.value) : l.value;
      o.value[0] = { month: Qe(H), year: je(H) };
    }
  }, _ = () => {
    k(), e.value.count && w();
  };
  Se(l, (H, te) => {
    r.isTextInputDate && JSON.stringify(H ?? {}) !== JSON.stringify(te ?? {}) && _();
  }), tt(() => {
    _();
  });
  const T = (H, te) => {
    o.value[te].year = H, d("update-month-year", { instance: te, year: H, month: o.value[te].month }), e.value.count && !e.value.solo && v(te);
  }, S = m(() => (H) => Cn(f.value, (te) => {
    const ie = s.value(H) === te.value, ee = Yn(
      te.value,
      xn(a.value.minDate),
      xn(a.value.maxDate)
    ) || c.value.years?.includes(s.value(H)), O = Mr(n.value, te.value);
    return { active: ie, disabled: ee, highlighted: O };
  })), M = (H, te) => {
    T(H, te), F(te);
  }, E = (H, te = !1) => {
    if (!$.value(H, te)) {
      const ie = te ? s.value(H) + 1 : s.value(H) - 1;
      T(ie, H);
    }
  }, F = (H, te = !1, ie) => {
    te || d("reset-flow"), ie !== void 0 ? h.value[H] = ie : h.value[H] = !h.value[H], h.value[H] ? d("overlay-toggle", { open: !0, overlay: It.year }) : (d("overlay-closed"), d("overlay-toggle", { open: !1, overlay: It.year }));
  };
  return {
    isDisabled: $,
    groupedYears: S,
    showYearPicker: h,
    selectYear: T,
    toggleYearPicker: F,
    handleYearSelect: M,
    handleYear: E
  };
}, q3 = (e, t) => {
  const {
    defaultedMultiCalendars: n,
    defaultedAriaLabels: a,
    defaultedTransitions: o,
    defaultedConfig: l,
    defaultedRange: r,
    defaultedHighlight: c,
    propDates: s,
    defaultedTz: p,
    defaultedFilters: d,
    defaultedMultiDates: f
  } = ft(e), h = () => {
    e.isTextInputDate && _(je(ye(e.startDate)), 0);
  }, { modelValue: $, year: y, month: w, calendars: v } = no(e, t, h), x = m(() => wc(e.formatLocale, e.locale, e.monthNameFormat)), b = N(null), { checkMinMaxRange: k } = ja(e), {
    selectYear: _,
    groupedYears: T,
    showYearPicker: S,
    toggleYearPicker: M,
    handleYearSelect: E,
    handleYear: F,
    isDisabled: H
  } = Rc({
    modelValue: $,
    multiCalendars: n,
    range: r,
    highlight: c,
    calendars: v,
    year: y,
    propDates: s,
    month: w,
    filters: d,
    props: e,
    emit: t
  });
  tt(() => {
    e.startDate && ($.value && e.focusStartDate || !$.value) && _(je(ye(e.startDate)), 0);
  });
  const te = (pe) => pe ? { month: Qe(pe), year: je(pe) } : { month: null, year: null }, ie = () => $.value ? Array.isArray($.value) ? $.value.map((pe) => te(pe)) : te($.value) : te(), ee = (pe, ae) => {
    const Ce = v.value[pe], q = ie();
    return Array.isArray(q) ? q.some((I) => I.year === Ce?.year && I.month === ae) : Ce?.year === q.year && ae === q.month;
  }, O = (pe, ae, Ce) => {
    const q = ie();
    return Array.isArray(q) ? y.value(ae) === q[Ce]?.year && pe === q[Ce]?.month : !1;
  }, z = (pe, ae) => {
    if (r.value.enabled) {
      const Ce = ie();
      if (Array.isArray($.value) && Array.isArray(Ce)) {
        const q = O(pe, ae, 0) || O(pe, ae, 1), I = _a(la(ye()), pe, y.value(ae));
        return jn($.value, b.value, I) && !q;
      }
      return !1;
    }
    return !1;
  }, D = m(() => (pe) => Cn(x.value, (ae) => {
    const Ce = ee(pe, ae.value), q = Yn(
      ae.value,
      xc(y.value(pe), s.value.minDate),
      $c(y.value(pe), s.value.maxDate)
    ) || g3(s.value.disabledDates, y.value(pe), ae.value) || d.value.months?.includes(ae.value) || !y3(s.value.allowedDates, y.value(pe), ae.value) || zc(e.yearRange, y.value(pe)), I = z(ae.value, pe), oe = Bc(c.value, ae.value, y.value(pe));
    return { active: Ce, disabled: q, isBetween: I, highlighted: oe };
  })), P = (pe, ae) => _a(la(ye()), pe, y.value(ae)), Z = (pe, ae) => {
    const Ce = $.value ? $.value : la(/* @__PURE__ */ new Date());
    $.value = _a(Ce, pe, y.value(ae)), t("auto-apply"), t("update-flow-step");
  }, J = (pe, ae) => {
    const Ce = P(pe, ae);
    r.value.fixedEnd || r.value.fixedStart ? $.value = Ic(Ce, $, t, r) : $.value ? k(Ce, $.value) && ($.value = Tr($, P(pe, ae), t)) : $.value = [P(pe, ae)], Ye().then(() => {
      Fo($.value, t, e.autoApply, e.modelAuto);
    });
  }, re = (pe, ae) => {
    Dr(P(pe, ae), $, f.value.limit), t("auto-apply", !0);
  }, U = (pe, ae) => (v.value[ae].month = pe, K(ae, v.value[ae].year, pe), f.value.enabled ? re(pe, ae) : r.value.enabled ? J(pe, ae) : Z(pe, ae)), ge = (pe, ae) => {
    _(pe, ae), K(ae, pe, null);
  }, K = (pe, ae, Ce) => {
    let q = Ce;
    if (!q && q !== 0) {
      const I = ie();
      q = Array.isArray(I) ? I[pe].month : I.month;
    }
    t("update-month-year", { instance: pe, year: ae, month: q });
  };
  return {
    groupedMonths: D,
    groupedYears: T,
    year: y,
    isDisabled: H,
    defaultedMultiCalendars: n,
    defaultedAriaLabels: a,
    defaultedTransitions: o,
    defaultedConfig: l,
    showYearPicker: S,
    modelValue: $,
    presetDate: (pe, ae) => {
      Ec({
        value: pe,
        modelValue: $,
        range: r.value.enabled,
        timezone: ae ? void 0 : p.value.timezone
      }), t("auto-apply");
    },
    setHoverDate: (pe, ae) => {
      b.value = P(pe, ae);
    },
    selectMonth: U,
    selectYear: ge,
    toggleYearPicker: M,
    handleYearSelect: E,
    handleYear: F,
    getModelMonthYear: ie
  };
}, Z3 = /* @__PURE__ */ Y({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...ia
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "update-flow-step",
    "mount",
    "invalid-fixed-range",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, o = mt(), l = Wt(o, "yearMode"), r = e;
    tt(() => {
      r.shadow || a("mount", null);
    });
    const {
      groupedMonths: c,
      groupedYears: s,
      year: p,
      isDisabled: d,
      defaultedMultiCalendars: f,
      defaultedConfig: h,
      showYearPicker: $,
      modelValue: y,
      presetDate: w,
      setHoverDate: v,
      selectMonth: x,
      selectYear: b,
      toggleYearPicker: k,
      handleYearSelect: _,
      handleYear: T,
      getModelMonthYear: S
    } = q3(r, a);
    return t({ getSidebarProps: () => ({
      modelValue: y,
      year: p,
      getModelMonthYear: S,
      selectMonth: x,
      selectYear: b,
      handleYear: T
    }), presetDate: w, toggleYearPicker: (M) => k(0, M) }), (M, E) => (i(), R(No, {
      "multi-calendars": u(f).count,
      collapse: M.collapse,
      stretch: "",
      "is-mobile": M.isMobile
    }, {
      default: B(({ instance: F }) => [
        M.$slots["top-extra"] ? L(M.$slots, "top-extra", {
          key: 0,
          value: M.internalModelValue
        }) : A("", !0),
        M.$slots["month-year"] ? L(M.$slots, "month-year", Mt(Ke({ key: 1 }, {
          year: u(p),
          months: u(c)(F),
          years: u(s)(F),
          selectMonth: u(x),
          selectYear: u(b),
          instance: F
        }))) : (i(), R(to, {
          key: 2,
          items: u(c)(F),
          "arrow-navigation": M.arrowNavigation,
          "is-last": M.autoApply && !u(h).keepActionRow,
          "esc-close": M.escClose,
          height: u(h).modeHeight,
          config: M.config,
          "no-overlay-focus": !!(M.noOverlayFocus || M.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (H) => u(x)(H, F),
          onHoverValue: (H) => u(v)(H, F)
        }, it({
          header: B(() => [
            j(Lc, Ke(M.$props, {
              items: u(s)(F),
              instance: F,
              "show-year-picker": u($)[F],
              year: u(p)(F),
              "is-disabled": (H) => u(d)(F, H),
              onHandleYear: (H) => u(T)(F, H),
              onYearSelect: (H) => u(_)(H, F),
              onToggleYearPicker: (H) => u(k)(F, H?.flow, H?.show)
            }), it({ _: 2 }, [
              De(u(l), (H, te) => ({
                name: H,
                fn: B((ie) => [
                  L(M.$slots, H, Mt(Kt(ie)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, [
          M.$slots["month-overlay-value"] ? {
            name: "item",
            fn: B(({ item: H }) => [
              L(M.$slots, "month-overlay-value", {
                text: H.text,
                value: H.value
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), G3 = (e, t) => {
  const n = () => {
    e.isTextInputDate && (d.value = je(ye(e.startDate)));
  }, { modelValue: a } = no(e, t, n), o = N(null), { defaultedHighlight: l, defaultedMultiDates: r, defaultedFilters: c, defaultedRange: s, propDates: p } = ft(e), d = N();
  tt(() => {
    e.startDate && (a.value && e.focusStartDate || !a.value) && (d.value = je(ye(e.startDate)));
  });
  const f = (x) => Array.isArray(a.value) ? a.value.some((b) => je(b) === x) : a.value ? je(a.value) === x : !1, h = (x) => s.value.enabled && Array.isArray(a.value) ? jn(a.value, o.value, v(x)) : !1, $ = (x) => p.value.allowedDates instanceof Map ? p.value.allowedDates.size ? p.value.allowedDates.has(`${x}`) : !1 : !0, y = (x) => p.value.disabledDates instanceof Map ? p.value.disabledDates.size ? p.value.disabledDates.has(`${x}`) : !1 : typeof p.value.disabledDates == "function" ? p.value.disabledDates(oa(Tt(hn(ye())), x)) : !0, w = m(() => Cn(Cr(e.yearRange, e.locale, e.reverseYears), (x) => {
    const b = f(x.value), k = Yn(
      x.value,
      xn(p.value.minDate),
      xn(p.value.maxDate)
    ) || c.value.years.includes(x.value) || !$(x.value) || y(x.value), _ = h(x.value) && !b, T = Mr(l.value, x.value);
    return { active: b, disabled: k, isBetween: _, highlighted: T };
  })), v = (x) => oa(la(hn(/* @__PURE__ */ new Date())), x);
  return {
    groupedYears: w,
    modelValue: a,
    focusYear: d,
    setHoverValue: (x) => {
      o.value = oa(la(/* @__PURE__ */ new Date()), x);
    },
    selectYear: (x) => {
      if (t("update-month-year", { instance: 0, year: x }), r.value.enabled)
        return a.value ? Array.isArray(a.value) && ((a.value?.map((b) => je(b))).includes(x) ? a.value = a.value.filter((b) => je(b) !== x) : a.value.push(oa(Tt(ye()), x))) : a.value = [oa(Tt(hn(ye())), x)], t("auto-apply", !0);
      s.value.enabled ? (a.value = Tr(a, v(x), t), Ye().then(() => {
        Fo(a.value, t, e.autoApply, e.modelAuto);
      })) : (a.value = v(x), t("auto-apply"));
    }
  };
}, X3 = /* @__PURE__ */ Y({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...ia
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, o = e, { groupedYears: l, modelValue: r, focusYear: c, selectYear: s, setHoverValue: p } = G3(o, a), { defaultedConfig: d } = ft(o);
    return t({ getSidebarProps: () => ({
      modelValue: r,
      selectYear: s
    }) }), (f, h) => (i(), g("div", null, [
      f.$slots["top-extra"] ? L(f.$slots, "top-extra", {
        key: 0,
        value: f.internalModelValue
      }) : A("", !0),
      f.$slots["month-year"] ? L(f.$slots, "month-year", Mt(Ke({ key: 1 }, {
        years: u(l),
        selectYear: u(s)
      }))) : (i(), R(to, {
        key: 2,
        items: u(l),
        "is-last": f.autoApply && !u(d).keepActionRow,
        height: u(d).modeHeight,
        config: f.config,
        "no-overlay-focus": !!(f.noOverlayFocus || f.textInput),
        "focus-value": u(c),
        type: "year",
        "use-relative": "",
        onSelected: u(s),
        onHoverValue: u(p)
      }, it({ _: 2 }, [
        f.$slots["year-overlay-value"] ? {
          name: "item",
          fn: B(({ item: $ }) => [
            L(f.$slots, "year-overlay-value", {
              text: $.text,
              value: $.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), Q3 = {
  key: 0,
  class: "dp__time_input"
}, J3 = ["data-compact", "data-collapsed"], e2 = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], t2 = ["aria-label", "disabled", "data-test-id", "onKeydown", "onClick"], a2 = ["data-test-id", "aria-label", "onKeydown", "onClick", "onMousedown"], n2 = { key: 0 }, o2 = ["aria-label", "data-compact"], l2 = /* @__PURE__ */ Y({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => !1 },
    ...ia
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "overlay-opened",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, o = e, { setTimePickerElements: l, setTimePickerBackRef: r } = Ya(), {
      defaultedAriaLabels: c,
      defaultedTransitions: s,
      defaultedFilters: p,
      defaultedConfig: d,
      defaultedRange: f,
      defaultedMultiCalendars: h
    } = ft(o), { transitionName: $, showTransition: y } = ao(s), w = Na({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), v = N("AM"), x = N(null), b = N([]), k = N(), _ = N(!1);
    tt(() => {
      a("mounted");
    });
    const T = (V) => st(/* @__PURE__ */ new Date(), {
      hours: V.hours,
      minutes: V.minutes,
      seconds: o.enableSeconds ? V.seconds : 0,
      milliseconds: 0
    }), S = m(
      () => (V) => J(V, o[V]) || E(V, o[V])
    ), M = m(() => ({ hours: o.hours, minutes: o.minutes, seconds: o.seconds })), E = (V, xe) => f.value.enabled && !f.value.disableTimeRangeValidation ? !o.validateTime(V, xe) : !1, F = (V, xe) => {
      if (f.value.enabled && !f.value.disableTimeRangeValidation) {
        const ce = xe ? +o[`${V}Increment`] : -+o[`${V}Increment`], Te = o[V] + ce;
        return !o.validateTime(V, Te);
      }
      return !1;
    }, H = m(() => (V) => !pe(+o[V] + +o[`${V}Increment`], V) || F(V, !0)), te = m(() => (V) => !pe(+o[V] - +o[`${V}Increment`], V) || F(V, !1)), ie = (V, xe) => Oi(st(ye(), V), xe), ee = (V, xe) => sv(st(ye(), V), xe), O = m(
      () => ({
        dp__time_col: !0,
        dp__time_col_block: !o.timePickerInline,
        dp__time_col_reg_block: !o.enableSeconds && o.is24 && !o.timePickerInline,
        dp__time_col_reg_inline: !o.enableSeconds && o.is24 && o.timePickerInline,
        dp__time_col_reg_with_button: !o.enableSeconds && !o.is24,
        dp__time_col_sec: o.enableSeconds && o.is24,
        dp__time_col_sec_with_button: o.enableSeconds && !o.is24
      })
    ), z = m(
      () => o.timePickerInline && f.value.enabled && !h.value.count
    ), D = m(() => {
      const V = [{ type: "hours" }];
      return o.enableMinutes && V.push({ type: "", separator: !0 }, {
        type: "minutes"
      }), o.enableSeconds && V.push({ type: "", separator: !0 }, {
        type: "seconds"
      }), V;
    }), P = m(() => D.value.filter((V) => !V.separator)), Z = m(() => (V) => {
      if (V === "hours") {
        const xe = be(+o.hours);
        return { text: xe < 10 ? `0${xe}` : `${xe}`, value: xe };
      }
      return { text: o[V] < 10 ? `0${o[V]}` : `${o[V]}`, value: o[V] };
    }), J = (V, xe) => {
      if (!o.disabledTimesConfig) return !1;
      const ce = o.disabledTimesConfig(o.order, V === "hours" ? xe : void 0);
      return ce[V] ? !!ce[V]?.includes(xe) : !0;
    }, re = (V, xe) => xe !== "hours" || v.value === "AM" ? V : V + 12, U = (V) => {
      const xe = o.is24 ? 24 : 12, ce = V === "hours" ? xe : 60, Te = +o[`${V}GridIncrement`], $e = V === "hours" && !o.is24 ? Te : 0, Be = [];
      for (let Ue = $e; Ue < ce; Ue += Te)
        Be.push({ value: o.is24 ? Ue : re(Ue, V), text: Ue < 10 ? `0${Ue}` : `${Ue}` });
      return V === "hours" && !o.is24 && Be.unshift({ value: v.value === "PM" ? 12 : 0, text: "12" }), Cn(Be, (Ue) => ({ active: !1, disabled: p.value.times[V].includes(Ue.value) || !pe(Ue.value, V) || J(V, Ue.value) || E(V, Ue.value) }));
    }, ge = (V) => V >= 0 ? V : 59, K = (V) => V >= 0 ? V : 23, pe = (V, xe) => {
      const ce = o.minTime ? T(al(o.minTime)) : null, Te = o.maxTime ? T(al(o.maxTime)) : null, $e = T(
        al(
          M.value,
          xe,
          xe === "minutes" || xe === "seconds" ? ge(V) : K(V)
        )
      );
      return ce && Te ? (ma($e, Te) || pn($e, Te)) && (va($e, ce) || pn($e, ce)) : ce ? va($e, ce) || pn($e, ce) : Te ? ma($e, Te) || pn($e, Te) : !0;
    }, ae = (V) => o[`no${V[0].toUpperCase() + V.slice(1)}Overlay`], Ce = (V) => {
      ae(V) || (w[V] = !w[V], w[V] ? (_.value = !0, a("overlay-opened", V)) : (_.value = !1, a("overlay-closed", V)));
    }, q = (V) => V === "hours" ? Sa : V === "minutes" ? Va : bn, I = () => {
      k.value && clearTimeout(k.value);
    }, oe = (V, xe = !0, ce) => {
      const Te = xe ? ie : ee, $e = xe ? +o[`${V}Increment`] : -+o[`${V}Increment`];
      pe(+o[V] + $e, V) && a(
        `update:${V}`,
        q(V)(Te({ [V]: +o[V] }, { [V]: +o[`${V}Increment`] }))
      ), !ce?.keyboard && d.value.timeArrowHoldThreshold && (k.value = setTimeout(() => {
        oe(V, xe);
      }, d.value.timeArrowHoldThreshold));
    }, be = (V) => o.is24 ? V : (V >= 12 ? v.value = "PM" : v.value = "AM", o3(V)), de = () => {
      v.value === "PM" ? (v.value = "AM", a("update:hours", o.hours - 12)) : (v.value = "PM", a("update:hours", o.hours + 12)), a("am-pm-change", v.value);
    }, X = (V) => {
      w[V] = !0;
    }, ne = (V, xe, ce) => {
      if (V && o.arrowNavigation) {
        Array.isArray(b.value[xe]) ? b.value[xe][ce] = V : b.value[xe] = [V];
        const Te = b.value.reduce(
          ($e, Be) => Be.map((Ue, qe) => [...$e[qe] || [], Be[qe]]),
          []
        );
        r(o.closeTimePickerBtn), x.value && (Te[1] = Te[1].concat(x.value)), l(Te, o.order);
      }
    }, ve = (V, xe) => (Ce(V), a(`update:${V}`, xe));
    return t({ openChildCmp: X }), (V, xe) => V.disabled ? A("", !0) : (i(), g("div", Q3, [
      (i(!0), g(he, null, De(D.value, (ce, Te) => (i(), g("div", {
        key: Te,
        class: W(O.value),
        "data-compact": z.value && !V.enableSeconds,
        "data-collapsed": z.value && V.enableSeconds
      }, [
        ce.separator ? (i(), g(he, { key: 0 }, [
          _.value ? A("", !0) : (i(), g(he, { key: 0 }, [
            me(":")
          ], 64))
        ], 64)) : (i(), g(he, { key: 1 }, [
          C("button", {
            ref_for: !0,
            ref: ($e) => ne($e, Te, 0),
            type: "button",
            class: W({
              dp__btn: !0,
              dp__inc_dec_button: !V.timePickerInline,
              dp__inc_dec_button_inline: V.timePickerInline,
              dp__tp_inline_btn_top: V.timePickerInline,
              dp__inc_dec_button_disabled: H.value(ce.type),
              "dp--hidden-el": _.value
            }),
            "data-test-id": `${ce.type}-time-inc-btn-${o.order}`,
            "aria-label": u(c)?.incrementValue(ce.type),
            tabindex: "0",
            onKeydown: ($e) => u(Vt)($e, () => oe(ce.type, !0, { keyboard: !0 }), !0),
            onClick: ($e) => u(d).timeArrowHoldThreshold ? void 0 : oe(ce.type, !0),
            onMousedown: ($e) => u(d).timeArrowHoldThreshold ? oe(ce.type, !0) : void 0,
            onMouseup: I
          }, [
            o.timePickerInline ? (i(), g(he, { key: 1 }, [
              V.$slots["tp-inline-arrow-up"] ? L(V.$slots, "tp-inline-arrow-up", { key: 0 }) : (i(), g(he, { key: 1 }, [
                xe[2] || (xe[2] = C("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                xe[3] || (xe[3] = C("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
              ], 64))
            ], 64)) : (i(), g(he, { key: 0 }, [
              V.$slots["arrow-up"] ? L(V.$slots, "arrow-up", { key: 0 }) : A("", !0),
              V.$slots["arrow-up"] ? A("", !0) : (i(), R(u(br), { key: 1 }))
            ], 64))
          ], 42, e2),
          C("button", {
            ref_for: !0,
            ref: ($e) => ne($e, Te, 1),
            type: "button",
            "aria-label": `${Z.value(ce.type).text}-${u(c)?.openTpOverlay(ce.type)}`,
            class: W({
              dp__time_display: !0,
              dp__time_display_block: !V.timePickerInline,
              dp__time_display_inline: V.timePickerInline,
              "dp--time-invalid": S.value(ce.type),
              "dp--time-overlay-btn": !S.value(ce.type),
              "dp--hidden-el": _.value
            }),
            disabled: ae(ce.type),
            tabindex: "0",
            "data-test-id": `${ce.type}-toggle-overlay-btn-${o.order}`,
            onKeydown: ($e) => u(Vt)($e, () => Ce(ce.type), !0),
            onClick: ($e) => Ce(ce.type)
          }, [
            V.$slots[ce.type] ? L(V.$slots, ce.type, {
              key: 0,
              text: Z.value(ce.type).text,
              value: Z.value(ce.type).value
            }) : A("", !0),
            V.$slots[ce.type] ? A("", !0) : (i(), g(he, { key: 1 }, [
              me(le(Z.value(ce.type).text), 1)
            ], 64))
          ], 42, t2),
          C("button", {
            ref_for: !0,
            ref: ($e) => ne($e, Te, 2),
            type: "button",
            class: W({
              dp__btn: !0,
              dp__inc_dec_button: !V.timePickerInline,
              dp__inc_dec_button_inline: V.timePickerInline,
              dp__tp_inline_btn_bottom: V.timePickerInline,
              dp__inc_dec_button_disabled: te.value(ce.type),
              "dp--hidden-el": _.value
            }),
            "data-test-id": `${ce.type}-time-dec-btn-${o.order}`,
            "aria-label": u(c)?.decrementValue(ce.type),
            tabindex: "0",
            onKeydown: ($e) => u(Vt)($e, () => oe(ce.type, !1, { keyboard: !0 }), !0),
            onClick: ($e) => u(d).timeArrowHoldThreshold ? void 0 : oe(ce.type, !1),
            onMousedown: ($e) => u(d).timeArrowHoldThreshold ? oe(ce.type, !1) : void 0,
            onMouseup: I
          }, [
            o.timePickerInline ? (i(), g(he, { key: 1 }, [
              V.$slots["tp-inline-arrow-down"] ? L(V.$slots, "tp-inline-arrow-down", { key: 0 }) : (i(), g(he, { key: 1 }, [
                xe[4] || (xe[4] = C("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1)),
                xe[5] || (xe[5] = C("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1))
              ], 64))
            ], 64)) : (i(), g(he, { key: 0 }, [
              V.$slots["arrow-down"] ? L(V.$slots, "arrow-down", { key: 0 }) : A("", !0),
              V.$slots["arrow-down"] ? A("", !0) : (i(), R(u(kr), { key: 1 }))
            ], 64))
          ], 42, a2)
        ], 64))
      ], 10, J3))), 128)),
      V.is24 ? A("", !0) : (i(), g("div", n2, [
        V.$slots["am-pm-button"] ? L(V.$slots, "am-pm-button", {
          key: 0,
          toggle: de,
          value: v.value
        }) : A("", !0),
        V.$slots["am-pm-button"] ? A("", !0) : (i(), g("button", {
          key: 1,
          ref_key: "amPmButton",
          ref: x,
          type: "button",
          class: "dp__pm_am_button",
          role: "button",
          "aria-label": u(c)?.amPmButton,
          tabindex: "0",
          "data-compact": z.value,
          onClick: de,
          onKeydown: xe[0] || (xe[0] = (ce) => u(Vt)(ce, () => de(), !0))
        }, le(v.value), 41, o2))
      ])),
      (i(!0), g(he, null, De(P.value, (ce, Te) => (i(), R(Ra, {
        key: Te,
        name: u($)(w[ce.type]),
        css: u(y)
      }, {
        default: B(() => [
          w[ce.type] ? (i(), R(to, {
            key: 0,
            items: U(ce.type),
            "is-last": V.autoApply && !u(d).keepActionRow,
            "esc-close": V.escClose,
            type: ce.type,
            "text-input": V.textInput,
            config: V.config,
            "arrow-navigation": V.arrowNavigation,
            "aria-labels": V.ariaLabels,
            "overlay-label": u(c).timeOverlay?.(ce.type),
            onSelected: ($e) => ve(ce.type, $e),
            onToggle: ($e) => Ce(ce.type),
            onResetFlow: xe[1] || (xe[1] = ($e) => V.$emit("reset-flow"))
          }, it({
            "button-icon": B(() => [
              V.$slots["clock-icon"] ? L(V.$slots, "clock-icon", { key: 0 }) : A("", !0),
              V.$slots["clock-icon"] ? A("", !0) : (i(), R(Pe(V.timePickerInline ? u(Dn) : u(wr)), { key: 1 }))
            ]),
            _: 2
          }, [
            V.$slots[`${ce.type}-overlay-value`] ? {
              name: "item",
              fn: B(({ item: $e }) => [
                L(V.$slots, `${ce.type}-overlay-value`, {
                  text: $e.text,
                  value: $e.value
                })
              ]),
              key: "0"
            } : void 0,
            V.$slots[`${ce.type}-overlay-header`] ? {
              name: "header",
              fn: B(() => [
                L(V.$slots, `${ce.type}-overlay-header`, {
                  toggle: () => Ce(ce.type)
                })
              ]),
              key: "1"
            } : void 0
          ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : A("", !0)
        ]),
        _: 2
      }, 1032, ["name", "css"]))), 128))
    ]));
  }
}), r2 = ["data-dp-mobile"], s2 = ["aria-label", "tabindex"], i2 = ["role", "aria-label", "tabindex"], c2 = ["aria-label"], Pc = /* @__PURE__ */ Y({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => !1
    },
    ...ia
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, o = e, { buildMatrix: l, setTimePicker: r } = Ya(), c = mt(), { defaultedTransitions: s, defaultedAriaLabels: p, defaultedTextInput: d, defaultedConfig: f, defaultedRange: h } = ft(o), { transitionName: $, showTransition: y } = ao(s), { hideNavigationButtons: w } = Ko(), v = N(null), x = N(null), b = N([]), k = N(null), _ = N(!1);
    tt(() => {
      a("mount"), !o.timePicker && o.arrowNavigation ? l([St(v.value)], "time") : r(!0, o.timePicker);
    });
    const T = m(() => h.value.enabled && o.modelAuto ? bc(o.internalModelValue) : !0), S = N(!1), M = (J) => ({
      hours: Array.isArray(o.hours) ? o.hours[J] : o.hours,
      minutes: Array.isArray(o.minutes) ? o.minutes[J] : o.minutes,
      seconds: Array.isArray(o.seconds) ? o.seconds[J] : o.seconds
    }), E = m(() => {
      const J = [];
      if (h.value.enabled)
        for (let re = 0; re < 2; re++)
          J.push(M(re));
      else
        J.push(M(0));
      return J;
    }), F = (J, re = !1, U = "") => {
      re || a("reset-flow"), S.value = J, a(J ? "overlay-opened" : "overlay-closed", It.time), o.arrowNavigation && r(J), Ye(() => {
        U !== "" && b.value[0] && b.value[0].openChildCmp(U);
      });
    }, H = m(() => ({
      dp__btn: !0,
      dp__button: !0,
      dp__button_bottom: o.autoApply && !f.value.keepActionRow
    })), te = Wt(c, "timePicker"), ie = (J, re, U) => h.value.enabled ? re === 0 ? [J, E.value[1][U]] : [E.value[0][U], J] : J, ee = (J) => {
      a("update:hours", J);
    }, O = (J) => {
      a("update:minutes", J);
    }, z = (J) => {
      a("update:seconds", J);
    }, D = () => {
      if (k.value && !d.value.enabled && !o.noOverlayFocus) {
        const J = kc(k.value);
        J && J.focus({ preventScroll: !0 });
      }
    }, P = (J) => {
      _.value = !1, a("overlay-closed", J);
    }, Z = (J) => {
      _.value = !0, a("overlay-opened", J);
    };
    return t({ toggleTimePicker: F }), (J, re) => (i(), g("div", {
      class: "dp--tp-wrap",
      "data-dp-mobile": J.isMobile
    }, [
      !J.timePicker && !J.timePickerInline ? ra((i(), g("button", {
        key: 0,
        ref_key: "openTimePickerBtn",
        ref: v,
        type: "button",
        class: W({ ...H.value, "dp--hidden-el": S.value }),
        "aria-label": u(p)?.openTimePicker,
        tabindex: J.noOverlayFocus ? void 0 : 0,
        "data-test-id": "open-time-picker-btn",
        onKeydown: re[0] || (re[0] = (U) => u(Vt)(U, () => F(!0))),
        onClick: re[1] || (re[1] = (U) => F(!0))
      }, [
        J.$slots["clock-icon"] ? L(J.$slots, "clock-icon", { key: 0 }) : A("", !0),
        J.$slots["clock-icon"] ? A("", !0) : (i(), R(u(wr), { key: 1 }))
      ], 42, s2)), [
        [xa, !u(w)(J.hideNavigation, "time")]
      ]) : A("", !0),
      j(Ra, {
        name: u($)(S.value),
        css: u(y) && !J.timePickerInline
      }, {
        default: B(() => [
          S.value || J.timePicker || J.timePickerInline ? (i(), g("div", {
            key: 0,
            ref_key: "overlayRef",
            ref: k,
            role: J.timePickerInline ? void 0 : "dialog",
            class: W({
              dp__overlay: !J.timePickerInline,
              "dp--overlay-absolute": !o.timePicker && !J.timePickerInline,
              "dp--overlay-relative": o.timePicker
            }),
            style: Ie(J.timePicker ? { height: `${u(f).modeHeight}px` } : void 0),
            "aria-label": u(p)?.timePicker,
            tabindex: J.timePickerInline ? void 0 : 0
          }, [
            C("div", {
              class: W(
                J.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
              ),
              style: { display: "flex" }
            }, [
              J.$slots["time-picker-overlay"] ? L(J.$slots, "time-picker-overlay", {
                key: 0,
                hours: e.hours,
                minutes: e.minutes,
                seconds: e.seconds,
                setHours: ee,
                setMinutes: O,
                setSeconds: z
              }) : A("", !0),
              J.$slots["time-picker-overlay"] ? A("", !0) : (i(), g("div", {
                key: 1,
                class: W(J.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
              }, [
                (i(!0), g(he, null, De(E.value, (U, ge) => ra((i(), R(l2, Ke({ key: ge }, { ref_for: !0 }, {
                  ...J.$props,
                  order: ge,
                  hours: U.hours,
                  minutes: U.minutes,
                  seconds: U.seconds,
                  closeTimePickerBtn: x.value,
                  disabledTimesConfig: e.disabledTimesConfig,
                  disabled: ge === 0 ? u(h).fixedStart : u(h).fixedEnd
                }, {
                  ref_for: !0,
                  ref_key: "timeInputRefs",
                  ref: b,
                  "validate-time": (K, pe) => e.validateTime(K, ie(pe, ge, K)),
                  "onUpdate:hours": (K) => ee(ie(K, ge, "hours")),
                  "onUpdate:minutes": (K) => O(ie(K, ge, "minutes")),
                  "onUpdate:seconds": (K) => z(ie(K, ge, "seconds")),
                  onMounted: D,
                  onOverlayClosed: P,
                  onOverlayOpened: Z,
                  onAmPmChange: re[2] || (re[2] = (K) => J.$emit("am-pm-change", K))
                }), it({ _: 2 }, [
                  De(u(te), (K, pe) => ({
                    name: K,
                    fn: B((ae) => [
                      L(J.$slots, K, Ke({ ref_for: !0 }, ae))
                    ])
                  }))
                ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                  [xa, ge === 0 ? !0 : T.value]
                ])), 128))
              ], 2)),
              !J.timePicker && !J.timePickerInline ? ra((i(), g("button", {
                key: 2,
                ref_key: "closeTimePickerBtn",
                ref: x,
                type: "button",
                class: W({ ...H.value, "dp--hidden-el": _.value }),
                "aria-label": u(p)?.closeTimePicker,
                tabindex: "0",
                onKeydown: re[3] || (re[3] = (U) => u(Vt)(U, () => F(!1))),
                onClick: re[4] || (re[4] = (U) => F(!1))
              }, [
                J.$slots["calendar-icon"] ? L(J.$slots, "calendar-icon", { key: 0 }) : A("", !0),
                J.$slots["calendar-icon"] ? A("", !0) : (i(), R(u(Dn), { key: 1 }))
              ], 42, c2)), [
                [xa, !u(w)(J.hideNavigation, "time")]
              ]) : A("", !0)
            ], 2)
          ], 14, i2)) : A("", !0)
        ]),
        _: 3
      }, 8, ["name", "css"])
    ], 8, r2));
  }
}), Oc = (e, t, n, a) => {
  const { defaultedRange: o } = ft(e), l = (k, _) => Array.isArray(t[k]) ? t[k][_] : t[k], r = (k) => e.enableSeconds ? Array.isArray(t.seconds) ? t.seconds[k] : t.seconds : 0, c = (k, _) => k ? _ !== void 0 ? Ia(k, l("hours", _), l("minutes", _), r(_)) : Ia(k, t.hours, t.minutes, r()) : tc(ye(), r(_)), s = (k, _) => {
    t[k] = _;
  }, p = m(() => e.modelAuto && o.value.enabled ? Array.isArray(n.value) ? n.value.length > 1 : !1 : o.value.enabled), d = (k, _) => {
    const T = Object.fromEntries(
      Object.keys(t).map((S) => S === k ? [S, _] : [S, t[S]].slice())
    );
    if (p.value && !o.value.disableTimeRangeValidation) {
      const S = (E) => n.value ? Ia(
        n.value[E],
        T.hours[E],
        T.minutes[E],
        T.seconds[E]
      ) : null, M = (E) => ec(n.value[E], 0);
      return !(Je(S(0), S(1)) && (va(S(0), M(1)) || ma(S(1), M(0))));
    }
    return !0;
  }, f = (k, _) => {
    d(k, _) && (s(k, _), a && a());
  }, h = (k) => {
    f("hours", k);
  }, $ = (k) => {
    f("minutes", k);
  }, y = (k) => {
    f("seconds", k);
  }, w = (k, _, T, S) => {
    _ && h(k), !_ && !T && $(k), T && y(k), n.value && S(n.value);
  }, v = (k) => {
    if (k) {
      const _ = Array.isArray(k), T = _ ? [+k[0].hours, +k[1].hours] : +k.hours, S = _ ? [+k[0].minutes, +k[1].minutes] : +k.minutes, M = _ ? [+k[0].seconds, +k[1].seconds] : +k.seconds;
      s("hours", T), s("minutes", S), e.enableSeconds && s("seconds", M);
    }
  }, x = (k, _) => {
    const T = {
      hours: Array.isArray(t.hours) ? t.hours[k] : t.hours,
      disabledArr: []
    };
    return (_ || _ === 0) && (T.hours = _), Array.isArray(e.disabledTimes) && (T.disabledArr = o.value.enabled && Array.isArray(e.disabledTimes[k]) ? e.disabledTimes[k] : e.disabledTimes), T;
  }, b = m(() => (k, _) => {
    if (Array.isArray(e.disabledTimes)) {
      const { disabledArr: T, hours: S } = x(k, _), M = T.filter((E) => +E.hours === S);
      return M[0]?.minutes === "*" ? { hours: [S], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: M?.map((E) => +E.minutes) ?? [],
        seconds: M?.map((E) => E.seconds ? +E.seconds : void 0) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: s,
    updateHours: h,
    updateMinutes: $,
    updateSeconds: y,
    getSetDateTime: c,
    updateTimeValues: w,
    getSecondsValue: r,
    assignStartTime: v,
    validateTime: d,
    disabledTimesConfig: b
  };
}, u2 = (e, t) => {
  const n = () => {
    e.isTextInputDate && _();
  }, { modelValue: a, time: o } = no(e, t, n), { defaultedStartTime: l, defaultedRange: r, defaultedTz: c } = ft(e), { updateTimeValues: s, getSetDateTime: p, setTime: d, assignStartTime: f, disabledTimesConfig: h, validateTime: $ } = Oc(e, o, a, y);
  function y() {
    t("update-flow-step");
  }
  const w = (S) => {
    const { hours: M, minutes: E, seconds: F } = S;
    return { hours: +M, minutes: +E, seconds: F ? +F : 0 };
  }, v = () => {
    if (e.startTime) {
      if (Array.isArray(e.startTime)) {
        const M = w(e.startTime[0]), E = w(e.startTime[1]);
        return [st(ye(), M), st(ye(), E)];
      }
      const S = w(e.startTime);
      return st(ye(), S);
    }
    return r.value.enabled ? [null, null] : null;
  }, x = () => {
    if (r.value.enabled) {
      const [S, M] = v();
      a.value = [
        Yt(p(S, 0), c.value.timezone),
        Yt(p(M, 1), c.value.timezone)
      ];
    } else
      a.value = Yt(p(v()), c.value.timezone);
  }, b = (S) => Array.isArray(S) ? [Ja(ye(S[0])), Ja(ye(S[1]))] : [Ja(S ?? ye())], k = (S, M, E) => {
    d("hours", S), d("minutes", M), d("seconds", e.enableSeconds ? E : 0);
  }, _ = () => {
    const [S, M] = b(a.value);
    return r.value.enabled ? k(
      [S.hours, M.hours],
      [S.minutes, M.minutes],
      [S.seconds, M.seconds]
    ) : k(S.hours, S.minutes, S.seconds);
  };
  tt(() => {
    if (!e.shadow)
      return f(l.value), a.value ? _() : x();
  });
  const T = () => {
    Array.isArray(a.value) ? a.value = a.value.map((S, M) => S && p(S, M)) : a.value = p(a.value), t("time-update");
  };
  return {
    modelValue: a,
    time: o,
    disabledTimesConfig: h,
    updateTime: (S, M = !0, E = !1) => {
      s(S, M, E, T);
    },
    validateTime: $
  };
}, d2 = /* @__PURE__ */ Y({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...ia
  },
  emits: [
    "update:internal-model-value",
    "time-update",
    "am-pm-change",
    "mount",
    "reset-flow",
    "update-flow-step",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, o = e, l = mt(), r = Wt(l, "timePicker"), c = N(null), { time: s, modelValue: p, disabledTimesConfig: d, updateTime: f, validateTime: h } = u2(o, a);
    return tt(() => {
      o.shadow || a("mount", null);
    }), t({ getSidebarProps: () => ({
      modelValue: p,
      time: s,
      updateTime: f
    }), toggleTimePicker: ($, y = !1, w = "") => {
      c.value?.toggleTimePicker($, y, w);
    } }), ($, y) => (i(), R(No, {
      "multi-calendars": 0,
      stretch: "",
      "is-mobile": $.isMobile
    }, {
      default: B(() => [
        j(Pc, Ke({
          ref_key: "tpRef",
          ref: c
        }, $.$props, {
          hours: u(s).hours,
          minutes: u(s).minutes,
          seconds: u(s).seconds,
          "internal-model-value": $.internalModelValue,
          "disabled-times-config": u(d),
          "validate-time": u(h),
          "onUpdate:hours": y[0] || (y[0] = (w) => u(f)(w)),
          "onUpdate:minutes": y[1] || (y[1] = (w) => u(f)(w, !1)),
          "onUpdate:seconds": y[2] || (y[2] = (w) => u(f)(w, !1, !0)),
          onAmPmChange: y[3] || (y[3] = (w) => $.$emit("am-pm-change", w)),
          onResetFlow: y[4] || (y[4] = (w) => $.$emit("reset-flow")),
          onOverlayClosed: y[5] || (y[5] = (w) => $.$emit("overlay-toggle", { open: !1, overlay: w })),
          onOverlayOpened: y[6] || (y[6] = (w) => $.$emit("overlay-toggle", { open: !0, overlay: w }))
        }), it({ _: 2 }, [
          De(u(r), (w, v) => ({
            name: w,
            fn: B((x) => [
              L($.$slots, w, Mt(Kt(x)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }, 8, ["is-mobile"]));
  }
}), p2 = { class: "dp--header-wrap" }, f2 = {
  key: 0,
  class: "dp__month_year_wrap"
}, h2 = { key: 0 }, v2 = { class: "dp__month_year_wrap" }, m2 = ["data-dp-element", "aria-label", "data-test-id", "onClick", "onKeydown"], g2 = /* @__PURE__ */ Y({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...ia
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed", "overlay-opened"],
  setup(e, { expose: t, emit: n }) {
    const a = n, o = e, {
      defaultedTransitions: l,
      defaultedAriaLabels: r,
      defaultedMultiCalendars: c,
      defaultedFilters: s,
      defaultedConfig: p,
      defaultedHighlight: d,
      propDates: f,
      defaultedUI: h
    } = ft(o), { transitionName: $, showTransition: y } = ao(l), { buildMatrix: w } = Ya(), { handleMonthYearChange: v, isDisabled: x, updateMonthYear: b } = P3(o, a), { showLeftIcon: k, showRightIcon: _ } = Ko(), T = N(!1), S = N(!1), M = N(!1), E = N([null, null, null, null]);
    tt(() => {
      a("mount");
    });
    const F = (K) => ({
      get: () => o[K],
      set: (pe) => {
        const ae = K === ta.month ? ta.year : ta.month;
        a("update-month-year", { [K]: pe, [ae]: o[ae] }), K === ta.month ? P(!0) : Z(!0);
      }
    }), H = m(F(ta.month)), te = m(F(ta.year)), ie = m(() => (K) => ({
      month: o.month,
      year: o.year,
      items: K === ta.month ? o.months : o.years,
      instance: o.instance,
      updateMonthYear: b,
      toggle: K === ta.month ? P : Z
    })), ee = m(() => o.months.find((pe) => pe.value === o.month) || { text: "", value: 0 }), O = m(() => Cn(o.months, (K) => {
      const pe = o.month === K.value, ae = Yn(
        K.value,
        xc(o.year, f.value.minDate),
        $c(o.year, f.value.maxDate)
      ) || s.value.months.includes(K.value), Ce = Bc(d.value, K.value, o.year);
      return { active: pe, disabled: ae, highlighted: Ce };
    })), z = m(() => Cn(o.years, (K) => {
      const pe = o.year === K.value, ae = Yn(
        K.value,
        xn(f.value.minDate),
        xn(f.value.maxDate)
      ) || s.value.years.includes(K.value), Ce = Mr(d.value, K.value);
      return { active: pe, disabled: ae, highlighted: Ce };
    })), D = (K, pe, ae) => {
      ae !== void 0 ? K.value = ae : K.value = !K.value, K.value ? (M.value = !0, a("overlay-opened", pe)) : (M.value = !1, a("overlay-closed", pe));
    }, P = (K = !1, pe) => {
      J(K), D(T, It.month, pe);
    }, Z = (K = !1, pe) => {
      J(K), D(S, It.year, pe);
    }, J = (K) => {
      K || a("reset-flow");
    }, re = (K, pe) => {
      o.arrowNavigation && (E.value[pe] = St(K), w(E.value, "monthYear"));
    }, U = m(() => [
      {
        type: ta.month,
        index: 1,
        toggle: P,
        modelValue: H.value,
        updateModelValue: (K) => H.value = K,
        text: ee.value.text,
        showSelectionGrid: T.value,
        items: O.value,
        ariaLabel: r.value?.openMonthsOverlay,
        overlayLabel: r.value.monthPicker?.(!0) ?? void 0
      },
      {
        type: ta.year,
        index: 2,
        toggle: Z,
        modelValue: te.value,
        updateModelValue: (K) => te.value = K,
        text: $r(o.year, o.locale),
        showSelectionGrid: S.value,
        items: z.value,
        ariaLabel: r.value?.openYearsOverlay,
        overlayLabel: r.value.yearPicker?.(!0) ?? void 0
      }
    ]), ge = m(() => o.disableYearSelect ? [U.value[0]] : o.yearFirst ? [...U.value].reverse() : U.value);
    return t({
      toggleMonthPicker: P,
      toggleYearPicker: Z,
      handleMonthYearChange: v
    }), (K, pe) => (i(), g("div", p2, [
      K.$slots["month-year"] ? (i(), g("div", f2, [
        L(K.$slots, "month-year", Mt(Kt({
          month: e.month,
          year: e.year,
          months: e.months,
          years: e.years,
          updateMonthYear: u(b),
          handleMonthYearChange: u(v),
          instance: e.instance,
          isDisabled: u(x)
        })))
      ])) : (i(), g(he, { key: 1 }, [
        K.$slots["top-extra"] ? (i(), g("div", h2, [
          L(K.$slots, "top-extra", { value: K.internalModelValue })
        ])) : A("", !0),
        C("div", v2, [
          u(k)(u(c), e.instance) && !K.vertical ? (i(), R(Vn, {
            key: 0,
            "aria-label": u(r)?.prevMonth,
            disabled: u(x)(!1),
            class: W(u(h)?.navBtnPrev),
            "el-name": "action-prev",
            onActivate: pe[0] || (pe[0] = (ae) => u(v)(!1, !0)),
            onSetRef: pe[1] || (pe[1] = (ae) => re(ae, 0))
          }, {
            default: B(() => [
              K.$slots["arrow-left"] ? L(K.$slots, "arrow-left", { key: 0 }) : A("", !0),
              K.$slots["arrow-left"] ? A("", !0) : (i(), R(u(gr), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : A("", !0),
          C("div", {
            class: W(["dp__month_year_wrap", {
              dp__year_disable_select: K.disableYearSelect
            }])
          }, [
            (i(!0), g(he, null, De(ge.value, (ae, Ce) => (i(), g(he, {
              key: ae.type
            }, [
              C("button", {
                ref_for: !0,
                ref: (q) => re(q, Ce + 1),
                type: "button",
                "data-dp-element": `overlay-${ae.type}`,
                class: W(["dp__btn dp__month_year_select", { "dp--hidden-el": M.value }]),
                "aria-label": `${ae.text}-${ae.ariaLabel}`,
                "data-test-id": `${ae.type}-toggle-overlay-${e.instance}`,
                onClick: ae.toggle,
                onKeydown: (q) => u(Vt)(q, () => ae.toggle(), !0)
              }, [
                K.$slots[ae.type] ? L(K.$slots, ae.type, {
                  key: 0,
                  text: ae.text,
                  value: o[ae.type]
                }) : A("", !0),
                K.$slots[ae.type] ? A("", !0) : (i(), g(he, { key: 1 }, [
                  me(le(ae.text), 1)
                ], 64))
              ], 42, m2),
              j(Ra, {
                name: u($)(ae.showSelectionGrid),
                css: u(y)
              }, {
                default: B(() => [
                  ae.showSelectionGrid ? (i(), R(to, {
                    key: 0,
                    items: ae.items,
                    "arrow-navigation": K.arrowNavigation,
                    "hide-navigation": K.hideNavigation,
                    "is-last": K.autoApply && !u(p).keepActionRow,
                    "skip-button-ref": !1,
                    config: K.config,
                    type: ae.type,
                    "header-refs": [],
                    "esc-close": K.escClose,
                    "menu-wrap-ref": K.menuWrapRef,
                    "text-input": K.textInput,
                    "aria-labels": K.ariaLabels,
                    "overlay-label": ae.overlayLabel,
                    onSelected: ae.updateModelValue,
                    onToggle: ae.toggle
                  }, it({
                    "button-icon": B(() => [
                      K.$slots["calendar-icon"] ? L(K.$slots, "calendar-icon", { key: 0 }) : A("", !0),
                      K.$slots["calendar-icon"] ? A("", !0) : (i(), R(u(Dn), { key: 1 }))
                    ]),
                    _: 2
                  }, [
                    K.$slots[`${ae.type}-overlay-value`] ? {
                      name: "item",
                      fn: B(({ item: q }) => [
                        L(K.$slots, `${ae.type}-overlay-value`, {
                          text: q.text,
                          value: q.value
                        })
                      ]),
                      key: "0"
                    } : void 0,
                    K.$slots[`${ae.type}-overlay`] ? {
                      name: "overlay",
                      fn: B(() => [
                        L(K.$slots, `${ae.type}-overlay`, Ke({ ref_for: !0 }, ie.value(ae.type)))
                      ]),
                      key: "1"
                    } : void 0,
                    K.$slots[`${ae.type}-overlay-header`] ? {
                      name: "header",
                      fn: B(() => [
                        L(K.$slots, `${ae.type}-overlay-header`, {
                          toggle: ae.toggle
                        })
                      ]),
                      key: "2"
                    } : void 0
                  ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "menu-wrap-ref", "text-input", "aria-labels", "overlay-label", "onSelected", "onToggle"])) : A("", !0)
                ]),
                _: 2
              }, 1032, ["name", "css"])
            ], 64))), 128))
          ], 2),
          u(k)(u(c), e.instance) && K.vertical ? (i(), R(Vn, {
            key: 1,
            "aria-label": u(r)?.prevMonth,
            "el-name": "action-prev",
            disabled: u(x)(!1),
            class: W(u(h)?.navBtnPrev),
            onActivate: pe[2] || (pe[2] = (ae) => u(v)(!1, !0))
          }, {
            default: B(() => [
              K.$slots["arrow-up"] ? L(K.$slots, "arrow-up", { key: 0 }) : A("", !0),
              K.$slots["arrow-up"] ? A("", !0) : (i(), R(u(br), { key: 1 }))
            ]),
            _: 3
          }, 8, ["aria-label", "disabled", "class"])) : A("", !0),
          u(_)(u(c), e.instance) ? (i(), R(Vn, {
            key: 2,
            ref: "rightIcon",
            "el-name": "action-next",
            disabled: u(x)(!0),
            "aria-label": u(r)?.nextMonth,
            class: W(u(h)?.navBtnNext),
            onActivate: pe[3] || (pe[3] = (ae) => u(v)(!0, !0)),
            onSetRef: pe[4] || (pe[4] = (ae) => re(ae, K.disableYearSelect ? 2 : 3))
          }, {
            default: B(() => [
              K.$slots[K.vertical ? "arrow-down" : "arrow-right"] ? L(K.$slots, K.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : A("", !0),
              K.$slots[K.vertical ? "arrow-down" : "arrow-right"] ? A("", !0) : (i(), R(Pe(K.vertical ? u(kr) : u(yr)), { key: 1 }))
            ]),
            _: 3
          }, 8, ["disabled", "aria-label", "class"])) : A("", !0)
        ])
      ], 64))
    ]));
  }
}), y2 = {
  class: "dp__calendar_header",
  role: "row"
}, w2 = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, b2 = ["aria-label"], k2 = {
  key: 0,
  class: "dp__calendar_item dp__week_num",
  role: "gridcell"
}, _2 = { class: "dp__cell_inner" }, C2 = ["id", "aria-selected", "aria-disabled", "aria-label", "tabindex", "data-test-id", "onClick", "onTouchend", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], x2 = /* @__PURE__ */ Y({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...ia
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, o = e, { buildMultiLevelMatrix: l } = Ya(), {
      defaultedTransitions: r,
      defaultedConfig: c,
      defaultedAriaLabels: s,
      defaultedMultiCalendars: p,
      defaultedWeekNumbers: d,
      defaultedMultiDates: f,
      defaultedUI: h
    } = ft(o), $ = N(null), y = N({
      bottom: "",
      left: "",
      transform: ""
    }), w = N([]), v = N(null), x = N(!0), b = N(""), k = N({ startX: 0, endX: 0, startY: 0, endY: 0 }), _ = N([]), T = N({ left: "50%" }), S = N(!1), M = m(() => o.calendar ? o.calendar(o.mappedDates) : o.mappedDates), E = m(() => o.dayNames ? Array.isArray(o.dayNames) ? o.dayNames : o.dayNames(o.locale, +o.weekStart) : n3(o.formatLocale, o.locale, +o.weekStart));
    tt(() => {
      a("mount", { cmp: "calendar", refs: w }), c.value.noSwipe || v.value && (v.value.addEventListener("touchstart", re, { passive: !1 }), v.value.addEventListener("touchend", U, { passive: !1 }), v.value.addEventListener("touchmove", ge, { passive: !1 })), o.monthChangeOnScroll && v.value && v.value.addEventListener("wheel", ae, { passive: !1 });
    }), Fa(() => {
      c.value.noSwipe || v.value && (v.value.removeEventListener("touchstart", re), v.value.removeEventListener("touchend", U), v.value.removeEventListener("touchmove", ge)), o.monthChangeOnScroll && v.value && v.value.removeEventListener("wheel", ae);
    });
    const F = (de) => de ? o.vertical ? "vNext" : "next" : o.vertical ? "vPrevious" : "previous", H = (de, X) => {
      if (o.transitions) {
        const ne = Tt(_a(ye(), o.month, o.year));
        b.value = kt(Tt(_a(ye(), de, X)), ne) ? r.value[F(!0)] : r.value[F(!1)], x.value = !1, Ye(() => {
          x.value = !0;
        });
      }
    }, te = m(
      () => ({
        ...h.value.calendar ?? {}
      })
    ), ie = m(() => (de) => {
      const X = l3(de);
      return {
        dp__marker_dot: X.type === "dot",
        dp__marker_line: X.type === "line"
      };
    }), ee = m(() => (de) => Je(de, $.value)), O = m(() => ({
      dp__calendar: !0,
      dp__calendar_next: p.value.count > 0 && o.instance !== 0
    })), z = m(() => (de) => o.hideOffsetDates ? de.current : !0), D = async (de, X) => {
      const { width: ne, height: ve } = de.getBoundingClientRect();
      $.value = X.value;
      let V = { left: `${ne / 2}px` }, xe = -50;
      if (await Ye(), _.value[0]) {
        const { left: ce, width: Te } = _.value[0].getBoundingClientRect();
        ce < 0 && (V = { left: "0" }, xe = 0, T.value.left = `${ne / 2}px`), window.innerWidth < ce + Te && (V = { right: "0" }, xe = 0, T.value.left = `${Te - ne / 2}px`);
      }
      y.value = {
        bottom: `${ve}px`,
        ...V,
        transform: `translateX(${xe}%)`
      };
    }, P = async (de, X, ne) => {
      const ve = St(w.value[X][ne]);
      ve && (de.marker?.customPosition && de.marker?.tooltip?.length ? y.value = de.marker.customPosition(ve) : await D(ve, de), a("tooltip-open", de.marker));
    }, Z = async (de, X, ne) => {
      if (S.value && f.value.enabled && f.value.dragSelect)
        return a("select-date", de);
      if (a("set-hover-date", de), de.marker?.tooltip?.length) {
        if (o.hideOffsetDates && !de.current) return;
        await P(de, X, ne);
      }
    }, J = (de) => {
      $.value && ($.value = null, y.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), a("tooltip-close", de.marker));
    }, re = (de) => {
      k.value.startX = de.changedTouches[0].screenX, k.value.startY = de.changedTouches[0].screenY;
    }, U = (de) => {
      k.value.endX = de.changedTouches[0].screenX, k.value.endY = de.changedTouches[0].screenY, K();
    }, ge = (de) => {
      o.vertical && !o.inline && de.preventDefault();
    }, K = () => {
      const de = o.vertical ? "Y" : "X";
      Math.abs(k.value[`start${de}`] - k.value[`end${de}`]) > 10 && a("handle-swipe", k.value[`start${de}`] > k.value[`end${de}`] ? "right" : "left");
    }, pe = (de, X, ne) => {
      de && (Array.isArray(w.value[X]) ? w.value[X][ne] = de : w.value[X] = [de]), o.arrowNavigation && l(w.value, "calendar");
    }, ae = (de) => {
      o.monthChangeOnScroll && (de.preventDefault(), a("handle-scroll", de));
    }, Ce = (de) => d.value.type === "local" ? rr(de.value, { weekStartsOn: +o.weekStart }) : d.value.type === "iso" ? or(de.value) : typeof d.value.type == "function" ? d.value.type(de.value) : "", q = (de) => {
      const X = de[0];
      return d.value.hideOnOffsetDates ? de.some((ne) => ne.current) ? Ce(X) : "" : Ce(X);
    }, I = (de, X, ne = !0) => {
      !ne && u3() || (!f.value.enabled || c.value.allowPreventDefault) && (Ea(de, c.value), a("select-date", X));
    }, oe = (de) => {
      Ea(de, c.value);
    }, be = (de) => {
      f.value.enabled && f.value.dragSelect ? (S.value = !0, a("select-date", de)) : f.value.enabled && a("select-date", de);
    };
    return t({ triggerTransition: H }), (de, X) => (i(), g("div", {
      class: W(O.value)
    }, [
      C("div", {
        ref_key: "calendarWrapRef",
        ref: v,
        class: W(te.value),
        role: "grid"
      }, [
        C("div", y2, [
          de.weekNumbers ? (i(), g("div", w2, le(de.weekNumName), 1)) : A("", !0),
          (i(!0), g(he, null, De(E.value, (ne, ve) => (i(), g("div", {
            key: ve,
            class: "dp__calendar_header_item",
            role: "gridcell",
            "data-test-id": "calendar-header",
            "aria-label": u(s)?.weekDay?.(ve)
          }, [
            de.$slots["calendar-header"] ? L(de.$slots, "calendar-header", {
              key: 0,
              day: ne,
              index: ve
            }) : A("", !0),
            de.$slots["calendar-header"] ? A("", !0) : (i(), g(he, { key: 1 }, [
              me(le(ne), 1)
            ], 64))
          ], 8, b2))), 128))
        ]),
        X[2] || (X[2] = C("div", { class: "dp__calendar_header_separator" }, null, -1)),
        j(Ra, {
          name: b.value,
          css: !!de.transitions
        }, {
          default: B(() => [
            x.value ? (i(), g("div", {
              key: 0,
              class: "dp__calendar",
              role: "rowgroup",
              onMouseleave: X[1] || (X[1] = (ne) => S.value = !1)
            }, [
              (i(!0), g(he, null, De(M.value, (ne, ve) => (i(), g("div", {
                key: ve,
                class: "dp__calendar_row",
                role: "row"
              }, [
                de.weekNumbers ? (i(), g("div", k2, [
                  C("div", _2, le(q(ne.days)), 1)
                ])) : A("", !0),
                (i(!0), g(he, null, De(ne.days, (V, xe) => (i(), g("div", {
                  id: u(Rl)(V.value),
                  ref_for: !0,
                  ref: (ce) => pe(ce, ve, xe),
                  key: xe + ve,
                  role: "gridcell",
                  class: "dp__calendar_item",
                  "aria-selected": (V.classData.dp__active_date || V.classData.dp__range_start || V.classData.dp__range_end) ?? void 0,
                  "aria-disabled": V.classData.dp__cell_disabled || void 0,
                  "aria-label": u(s)?.day?.(V),
                  tabindex: !V.current && de.hideOffsetDates ? void 0 : 0,
                  "data-test-id": u(Rl)(V.value),
                  onClick: Fe((ce) => I(ce, V), ["prevent"]),
                  onTouchend: (ce) => I(ce, V, !1),
                  onKeydown: (ce) => u(Vt)(ce, () => de.$emit("select-date", V)),
                  onMouseenter: (ce) => Z(V, ve, xe),
                  onMouseleave: (ce) => J(V),
                  onMousedown: (ce) => be(V),
                  onMouseup: X[0] || (X[0] = (ce) => S.value = !1)
                }, [
                  C("div", {
                    class: W(["dp__cell_inner", V.classData])
                  }, [
                    de.$slots.day && z.value(V) ? L(de.$slots, "day", {
                      key: 0,
                      day: +V.text,
                      date: V.value
                    }) : A("", !0),
                    de.$slots.day ? A("", !0) : (i(), g(he, { key: 1 }, [
                      me(le(V.text), 1)
                    ], 64)),
                    V.marker && z.value(V) ? (i(), g(he, { key: 2 }, [
                      de.$slots.marker ? L(de.$slots, "marker", {
                        key: 0,
                        marker: V.marker,
                        day: +V.text,
                        date: V.value
                      }) : (i(), g("div", {
                        key: 1,
                        class: W(ie.value(V.marker)),
                        style: Ie(V.marker.color ? { backgroundColor: V.marker.color } : {})
                      }, null, 6))
                    ], 64)) : A("", !0),
                    ee.value(V.value) ? (i(), g("div", {
                      key: 3,
                      ref_for: !0,
                      ref_key: "activeTooltip",
                      ref: _,
                      class: "dp__marker_tooltip",
                      style: Ie(y.value)
                    }, [
                      V.marker?.tooltip ? (i(), g("div", {
                        key: 0,
                        class: "dp__tooltip_content",
                        onClick: oe
                      }, [
                        (i(!0), g(he, null, De(V.marker.tooltip, (ce, Te) => (i(), g("div", {
                          key: Te,
                          class: "dp__tooltip_text"
                        }, [
                          de.$slots["marker-tooltip"] ? L(de.$slots, "marker-tooltip", {
                            key: 0,
                            tooltip: ce,
                            day: V.value
                          }) : A("", !0),
                          de.$slots["marker-tooltip"] ? A("", !0) : (i(), g(he, { key: 1 }, [
                            C("div", {
                              class: "dp__tooltip_mark",
                              style: Ie(ce.color ? { backgroundColor: ce.color } : {})
                            }, null, 4),
                            C("div", null, le(ce.text), 1)
                          ], 64))
                        ]))), 128)),
                        C("div", {
                          class: "dp__arrow_bottom_tp",
                          style: Ie(T.value)
                        }, null, 4)
                      ])) : A("", !0)
                    ], 4)) : A("", !0)
                  ], 2)
                ], 40, C2))), 128))
              ]))), 128))
            ], 32)) : A("", !0)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ], 2)
    ], 2));
  }
}), zs = (e) => Array.isArray(e), $2 = (e, t, n, a) => {
  const o = N([]), l = N(/* @__PURE__ */ new Date()), r = N(), c = () => U(e.isTextInputDate), { modelValue: s, calendars: p, time: d, today: f } = no(e, t, c), {
    defaultedMultiCalendars: h,
    defaultedStartTime: $,
    defaultedRange: y,
    defaultedConfig: w,
    defaultedTz: v,
    propDates: x,
    defaultedMultiDates: b
  } = ft(e), { validateMonthYearInRange: k, isDisabled: _, isDateRangeAllowed: T, checkMinMaxRange: S } = ja(e), { updateTimeValues: M, getSetDateTime: E, setTime: F, assignStartTime: H, validateTime: te, disabledTimesConfig: ie } = Oc(e, d, s, a), ee = m(
    () => (ue) => p.value[ue] ? p.value[ue].month : 0
  ), O = m(
    () => (ue) => p.value[ue] ? p.value[ue].year : 0
  ), z = (ue) => !w.value.keepViewOnOffsetClick || ue ? !0 : !r.value, D = (ue, Me, Oe, Ge = !1) => {
    z(Ge) && (p.value[ue] || (p.value[ue] = { month: 0, year: 0 }), p.value[ue].month = $s(Me) ? p.value[ue]?.month : Me, p.value[ue].year = $s(Oe) ? p.value[ue]?.year : Oe);
  }, P = () => {
    e.autoApply && t("select-date");
  }, Z = () => {
    $.value && H($.value);
  };
  tt(() => {
    e.shadow || (s.value || (X(), Z()), U(!0), e.focusStartDate && e.startDate && X());
  });
  const J = m(() => e.flow?.length && !e.partialFlow ? e.flowStep === e.flow.length : !0), re = () => {
    e.autoApply && J.value && t("auto-apply", e.partialFlow ? e.flowStep !== e.flow.length : !1);
  }, U = (ue = !1) => {
    if (s.value)
      return Array.isArray(s.value) ? (o.value = s.value, I(ue)) : pe(s.value, ue);
    if (h.value.count && ue && !e.startDate)
      return K(ye(), ue);
  }, ge = () => Array.isArray(s.value) && y.value.enabled ? Qe(s.value[0]) === Qe(s.value[1] ?? s.value[0]) : !1, K = (ue = /* @__PURE__ */ new Date(), Me = !1) => {
    if ((!h.value.count || !h.value.static || Me) && D(0, Qe(ue), je(ue)), h.value.count && (!s.value || ge() || !h.value.solo) && (!h.value.solo || Me))
      for (let Oe = 1; Oe < h.value.count; Oe++) {
        const Ge = st(ye(), { month: ee.value(Oe - 1), year: O.value(Oe - 1) }), _e = Oi(Ge, { months: 1 });
        p.value[Oe] = { month: Qe(_e), year: je(_e) };
      }
  }, pe = (ue, Me) => {
    K(ue), F("hours", Sa(ue)), F("minutes", Va(ue)), F("seconds", bn(ue)), h.value.count && Me && de();
  }, ae = (ue) => {
    if (h.value.count) {
      if (h.value.solo) return 0;
      const Me = Qe(ue[0]), Oe = Qe(ue[1]);
      return Math.abs(Oe - Me) < h.value.count ? 0 : 1;
    }
    return 1;
  }, Ce = (ue, Me) => {
    ue[1] && y.value.showLastInRange ? K(ue[ae(ue)], Me) : K(ue[0], Me);
    const Oe = (Ge, _e) => [
      Ge(ue[0]),
      ue[1] ? Ge(ue[1]) : d[_e][1]
    ];
    F("hours", Oe(Sa, "hours")), F("minutes", Oe(Va, "minutes")), F("seconds", Oe(bn, "seconds"));
  }, q = (ue, Me) => {
    if ((y.value.enabled || e.weekPicker) && !b.value.enabled)
      return Ce(ue, Me);
    if (b.value.enabled && Me) {
      const Oe = ue[ue.length - 1];
      return pe(Oe, Me);
    }
  }, I = (ue) => {
    const Me = s.value;
    q(Me, ue), h.value.count && h.value.solo && de();
  }, oe = (ue, Me) => {
    const Oe = st(ye(), { month: ee.value(Me), year: O.value(Me) }), Ge = ue < 0 ? Pt(Oe, 1) : Ha(Oe, 1);
    k(Qe(Ge), je(Ge), ue < 0, e.preventMinMaxNavigation) && (D(Me, Qe(Ge), je(Ge)), t("update-month-year", { instance: Me, month: Qe(Ge), year: je(Ge) }), h.value.count && !h.value.solo && be(Me), n());
  }, be = (ue) => {
    for (let Me = ue - 1; Me >= 0; Me--) {
      const Oe = Ha(st(ye(), { month: ee.value(Me + 1), year: O.value(Me + 1) }), 1);
      D(Me, Qe(Oe), je(Oe));
    }
    for (let Me = ue + 1; Me <= h.value.count - 1; Me++) {
      const Oe = Pt(st(ye(), { month: ee.value(Me - 1), year: O.value(Me - 1) }), 1);
      D(Me, Qe(Oe), je(Oe));
    }
  }, de = () => {
    if (Array.isArray(s.value) && s.value.length === 2) {
      const ue = ye(
        ye(s.value[1] ? s.value[1] : Pt(s.value[0], 1))
      ), [Me, Oe] = [Qe(s.value[0]), je(s.value[0])], [Ge, _e] = [Qe(s.value[1]), je(s.value[1])];
      (Me !== Ge || Me === Ge && Oe !== _e) && h.value.solo && D(1, Qe(ue), je(ue));
    } else s.value && !Array.isArray(s.value) && (D(0, Qe(s.value), je(s.value)), K(ye()));
  }, X = () => {
    e.startDate && (D(0, Qe(ye(e.startDate)), je(ye(e.startDate))), h.value.count && be(0));
  }, ne = (ue, Me) => {
    if (e.monthChangeOnScroll) {
      const Oe = (/* @__PURE__ */ new Date()).getTime() - l.value.getTime(), Ge = Math.abs(ue.deltaY);
      let _e = 500;
      Ge > 1 && (_e = 100), Ge > 100 && (_e = 0), Oe > _e && (l.value = /* @__PURE__ */ new Date(), oe(e.monthChangeOnScroll !== "inverse" ? -ue.deltaY : ue.deltaY, Me));
    }
  }, ve = (ue, Me, Oe = !1) => {
    e.monthChangeOnArrows && e.vertical === Oe && V(ue, Me);
  }, V = (ue, Me) => {
    oe(ue === "right" ? -1 : 1, Me);
  }, xe = (ue) => {
    if (x.value.markers)
      return Bo(ue.value, x.value.markers);
  }, ce = (ue, Me) => {
    switch (e.sixWeeks === !0 ? "append" : e.sixWeeks) {
      case "prepend":
        return [!0, !1];
      case "center":
        return [ue == 0, !0];
      case "fair":
        return [ue == 0 || Me > ue, !0];
      case "append":
        return [!1, !1];
      default:
        return [!1, !1];
    }
  }, Te = (ue, Me, Oe, Ge) => {
    if (e.sixWeeks && ue.length < 6) {
      const _e = 6 - ue.length, Ee = (Me.getDay() + 7 - Ge) % 7, Ve = 6 - (Oe.getDay() + 7 - Ge) % 7, [Zt, ea] = ce(Ee, Ve);
      for (let ga = 1; ga <= _e; ga++)
        if (ea ? !!(ga % 2) == Zt : Zt) {
          const ca = ue[0].days[0], we = $e(At(ca.value, -7), Qe(Me));
          ue.unshift({ days: we });
        } else {
          const ca = ue[ue.length - 1], we = ca.days[ca.days.length - 1], We = $e(At(we.value, 1), Qe(Me));
          ue.push({ days: We });
        }
    }
    return ue;
  }, $e = (ue, Me) => {
    const Oe = ye(ue), Ge = [];
    for (let _e = 0; _e < 7; _e++) {
      const Ee = At(Oe, _e), Ve = Qe(Ee) !== Me;
      Ge.push({
        text: e.hideOffsetDates && Ve ? "" : Ee.getDate(),
        value: Ee,
        current: !Ve,
        classData: {}
      });
    }
    return Ge;
  }, Be = (ue, Me) => {
    const Oe = [], Ge = new Date(Me, ue), _e = new Date(Me, ue + 1, 0), Ee = e.weekStart, Ve = qt(Ge, { weekStartsOn: Ee }), Zt = (ea) => {
      const ga = $e(ea, ue);
      if (Oe.push({ days: ga }), !Oe[Oe.length - 1].days.some(
        (ca) => Je(Tt(ca.value), Tt(_e))
      )) {
        const ca = At(ea, 7);
        Zt(ca);
      }
    };
    return Zt(Ve), Te(Oe, Ge, _e, Ee);
  }, Ue = (ue) => {
    const Me = Ia(ye(ue.value), d.hours, d.minutes, xt());
    t("date-update", Me), b.value.enabled ? Dr(Me, s, b.value.limit) : s.value = Me, a(), Ye().then(() => {
      re();
    });
  }, qe = (ue) => y.value.noDisabledRange ? Sc(o.value[0], ue).some((Me) => _(Me)) : !1, Q = () => {
    o.value = s.value ? s.value.slice() : [], o.value.length === 2 && !(y.value.fixedStart || y.value.fixedEnd) && (o.value = []);
  }, G = (ue, Me) => {
    const Oe = [
      ye(ue.value),
      At(ye(ue.value), +y.value.autoRange)
    ];
    T(Oe) ? (Me && fe(ue.value), o.value = Oe) : t("invalid-date", ue.value);
  }, fe = (ue) => {
    const Me = Qe(ye(ue)), Oe = je(ye(ue));
    if (D(0, Me, Oe), h.value.count > 0)
      for (let Ge = 1; Ge < h.value.count; Ge++) {
        const _e = f3(
          st(ye(ue), { year: O.value(Ge - 1), month: ee.value(Ge - 1) })
        );
        D(Ge, _e.month, _e.year);
      }
  }, ke = (ue) => {
    if (qe(ue.value) || !S(ue.value, s.value, y.value.fixedStart ? 0 : 1))
      return t("invalid-date", ue.value);
    o.value = Ic(ye(ue.value), s, t, y);
  }, Re = (ue, Me) => {
    if (Q(), y.value.autoRange) return G(ue, Me);
    if (y.value.fixedStart || y.value.fixedEnd) return ke(ue);
    o.value[0] ? S(ye(ue.value), s.value) && !qe(ue.value) ? gt(ye(ue.value), ye(o.value[0])) ? (o.value.unshift(ye(ue.value)), t("range-end", o.value[0])) : (o.value[1] = ye(ue.value), t("range-end", o.value[1])) : (e.autoApply && t("auto-apply-invalid", ue.value), t("invalid-date", ue.value)) : (o.value[0] = ye(ue.value), t("range-start", o.value[0]));
  }, xt = (ue = !0) => e.enableSeconds ? Array.isArray(d.seconds) ? ue ? d.seconds[0] : d.seconds[1] : d.seconds : 0, ot = (ue) => {
    o.value[ue] = Ia(
      o.value[ue],
      d.hours[ue],
      d.minutes[ue],
      xt(ue !== 1)
    );
  }, Lt = () => {
    o.value[0] && o.value[1] && +o.value?.[0] > +o.value?.[1] && (o.value.reverse(), t("range-start", o.value[0]), t("range-end", o.value[1]));
  }, Ft = () => {
    o.value.length && (o.value[0] && !o.value[1] ? ot(0) : (ot(0), ot(1), a()), Lt(), s.value = o.value.slice(), Fo(o.value, t, e.autoApply, e.modelAuto));
  }, Ma = (ue, Me = !1) => {
    if (_(ue.value) || !ue.current && e.hideOffsetDates) return t("invalid-date", ue.value);
    if (r.value = JSON.parse(JSON.stringify(ue)), !y.value.enabled) return Ue(ue);
    zs(d.hours) && zs(d.minutes) && !b.value.enabled && (Re(ue, Me), Ft());
  }, Da = (ue, Me) => {
    D(ue, Me.month, Me.year, !0), h.value.count && !h.value.solo && be(ue), t("update-month-year", { instance: ue, month: Me.month, year: Me.year }), n(h.value.solo ? ue : void 0);
    const Oe = e.flow?.length ? e.flow[e.flowStep] : void 0;
    !Me.fromNav && (Oe === It.month || Oe === It.year) && a();
  }, Ta = (ue, Me) => {
    Ec({
      value: ue,
      modelValue: s,
      range: y.value.enabled,
      timezone: Me ? void 0 : v.value.timezone
    }), P(), e.multiCalendars && Ye().then(() => U(!0));
  }, Wa = () => {
    const ue = _r(ye(), v.value);
    !y.value.enabled && !b.value.enabled ? s.value = ue : s.value && Array.isArray(s.value) && s.value[0] ? b.value.enabled ? s.value = [...s.value, ue] : s.value = gt(ue, s.value[0]) ? [ue, s.value[0]] : [s.value[0], ue] : s.value = [ue], P();
  }, Tn = () => {
    if (Array.isArray(s.value))
      if (b.value.enabled) {
        const ue = Bn();
        s.value[s.value.length - 1] = E(ue);
      } else
        s.value = s.value.map((ue, Me) => ue && E(ue, Me));
    else
      s.value = E(s.value);
    t("time-update");
  }, Bn = () => Array.isArray(s.value) && s.value.length ? s.value[s.value.length - 1] : null;
  return {
    calendars: p,
    modelValue: s,
    month: ee,
    year: O,
    time: d,
    disabledTimesConfig: ie,
    today: f,
    validateTime: te,
    getCalendarDays: Be,
    getMarker: xe,
    handleScroll: ne,
    handleSwipe: V,
    handleArrow: ve,
    selectDate: Ma,
    updateMonthYear: Da,
    presetDate: Ta,
    selectCurrentDate: Wa,
    updateTime: (ue, Me = !0, Oe = !1) => {
      M(ue, Me, Oe, Tn);
    },
    assignMonthAndYear: K,
    setStartTime: Z
  };
}, S2 = { key: 0 }, M2 = /* @__PURE__ */ Y({
  __name: "DatePicker",
  props: {
    ...ia
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, o = e, {
      calendars: l,
      month: r,
      year: c,
      modelValue: s,
      time: p,
      disabledTimesConfig: d,
      today: f,
      validateTime: h,
      getCalendarDays: $,
      getMarker: y,
      handleArrow: w,
      handleScroll: v,
      handleSwipe: x,
      selectDate: b,
      updateMonthYear: k,
      presetDate: _,
      selectCurrentDate: T,
      updateTime: S,
      assignMonthAndYear: M,
      setStartTime: E
    } = $2(o, a, ge, K), F = mt(), { setHoverDate: H, getDayClassData: te, clearHoverDate: ie } = Y2(s, o), { defaultedMultiCalendars: ee } = ft(o), O = N([]), z = N([]), D = N(null), P = Wt(F, "calendar"), Z = Wt(F, "monthYear"), J = Wt(F, "timePicker"), re = (ne) => {
      o.shadow || a("mount", ne);
    };
    Se(
      l,
      () => {
        o.shadow || setTimeout(() => {
          a("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    ), Se(
      ee,
      (ne, ve) => {
        ne.count - ve.count > 0 && M();
      },
      { deep: !0 }
    );
    const U = m(() => (ne) => $(r.value(ne), c.value(ne)).map((ve) => ({
      ...ve,
      days: ve.days.map((V) => (V.marker = y(V), V.classData = te(V), V))
    })));
    function ge(ne) {
      ne || ne === 0 ? z.value[ne]?.triggerTransition(r.value(ne), c.value(ne)) : z.value.forEach((ve, V) => ve.triggerTransition(r.value(V), c.value(V)));
    }
    function K() {
      a("update-flow-step");
    }
    const pe = (ne, ve = !1) => {
      b(ne, ve), o.spaceConfirm && a("select-date");
    }, ae = (ne, ve, V = 0) => {
      O.value[V]?.toggleMonthPicker(ne, ve);
    }, Ce = (ne, ve, V = 0) => {
      O.value[V]?.toggleYearPicker(ne, ve);
    }, q = (ne, ve, V) => {
      D.value?.toggleTimePicker(ne, ve, V);
    }, I = (ne, ve) => {
      if (!o.range) {
        const V = s.value ? s.value : f, xe = ve ? new Date(ve) : V, ce = ne ? qt(xe, { weekStartsOn: 1 }) : nr(xe, { weekStartsOn: 1 });
        b({
          value: ce,
          current: Qe(xe) === r.value(0),
          text: "",
          classData: {}
        }), document.getElementById(Rl(ce))?.focus();
      }
    }, oe = (ne) => {
      O.value[0]?.handleMonthYearChange(ne, !0);
    }, be = (ne) => {
      k(0, { month: r.value(0), year: c.value(0) + (ne ? 1 : -1), fromNav: !0 });
    }, de = (ne, ve) => {
      ne === It.time && a(`time-picker-${ve ? "open" : "close"}`), a("overlay-toggle", { open: ve, overlay: ne });
    }, X = (ne) => {
      a("overlay-toggle", { open: !1, overlay: ne }), a("focus-menu");
    };
    return t({
      clearHoverDate: ie,
      presetDate: _,
      selectCurrentDate: T,
      toggleMonthPicker: ae,
      toggleYearPicker: Ce,
      toggleTimePicker: q,
      handleArrow: w,
      updateMonthYear: k,
      getSidebarProps: () => ({
        modelValue: s,
        month: r,
        year: c,
        time: p,
        updateTime: S,
        updateMonthYear: k,
        selectDate: b,
        presetDate: _
      }),
      changeMonth: oe,
      changeYear: be,
      selectWeekDate: I,
      setStartTime: E
    }), (ne, ve) => (i(), g(he, null, [
      j(No, {
        "multi-calendars": u(ee).count,
        collapse: ne.collapse,
        "is-mobile": ne.isMobile
      }, {
        default: B(({ instance: V, index: xe }) => [
          ne.disableMonthYearSelect ? A("", !0) : (i(), R(g2, Ke({
            key: 0,
            ref: (ce) => {
              ce && (O.value[xe] = ce);
            },
            months: u(wc)(ne.formatLocale, ne.locale, ne.monthNameFormat),
            years: u(Cr)(ne.yearRange, ne.locale, ne.reverseYears),
            month: u(r)(V),
            year: u(c)(V),
            instance: V
          }, ne.$props, {
            onMount: ve[0] || (ve[0] = (ce) => re(u(Qa).header)),
            onResetFlow: ve[1] || (ve[1] = (ce) => ne.$emit("reset-flow")),
            onUpdateMonthYear: (ce) => u(k)(V, ce),
            onOverlayClosed: X,
            onOverlayOpened: ve[2] || (ve[2] = (ce) => ne.$emit("overlay-toggle", { open: !0, overlay: ce }))
          }), it({ _: 2 }, [
            De(u(Z), (ce, Te) => ({
              name: ce,
              fn: B(($e) => [
                L(ne.$slots, ce, Mt(Kt($e)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          j(x2, Ke({
            ref: (ce) => {
              ce && (z.value[xe] = ce);
            },
            "mapped-dates": U.value(V),
            month: u(r)(V),
            year: u(c)(V),
            instance: V
          }, ne.$props, {
            onSelectDate: (ce) => u(b)(ce, V !== 1),
            onHandleSpace: (ce) => pe(ce, V !== 1),
            onSetHoverDate: ve[3] || (ve[3] = (ce) => u(H)(ce)),
            onHandleScroll: (ce) => u(v)(ce, V),
            onHandleSwipe: (ce) => u(x)(ce, V),
            onMount: ve[4] || (ve[4] = (ce) => re(u(Qa).calendar)),
            onResetFlow: ve[5] || (ve[5] = (ce) => ne.$emit("reset-flow")),
            onTooltipOpen: ve[6] || (ve[6] = (ce) => ne.$emit("tooltip-open", ce)),
            onTooltipClose: ve[7] || (ve[7] = (ce) => ne.$emit("tooltip-close", ce))
          }), it({ _: 2 }, [
            De(u(P), (ce, Te) => ({
              name: ce,
              fn: B(($e) => [
                L(ne.$slots, ce, Mt(Kt({ ...$e })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars", "collapse", "is-mobile"]),
      ne.enableTimePicker ? (i(), g("div", S2, [
        ne.$slots["time-picker"] ? L(ne.$slots, "time-picker", Mt(Ke({ key: 0 }, { time: u(p), updateTime: u(S) }))) : (i(), R(Pc, Ke({
          key: 1,
          ref_key: "timePickerRef",
          ref: D
        }, ne.$props, {
          hours: u(p).hours,
          minutes: u(p).minutes,
          seconds: u(p).seconds,
          "internal-model-value": ne.internalModelValue,
          "disabled-times-config": u(d),
          "validate-time": u(h),
          onMount: ve[8] || (ve[8] = (V) => re(u(Qa).timePicker)),
          "onUpdate:hours": ve[9] || (ve[9] = (V) => u(S)(V)),
          "onUpdate:minutes": ve[10] || (ve[10] = (V) => u(S)(V, !1)),
          "onUpdate:seconds": ve[11] || (ve[11] = (V) => u(S)(V, !1, !0)),
          onResetFlow: ve[12] || (ve[12] = (V) => ne.$emit("reset-flow")),
          onOverlayClosed: ve[13] || (ve[13] = (V) => de(V, !1)),
          onOverlayOpened: ve[14] || (ve[14] = (V) => de(V, !0)),
          onAmPmChange: ve[15] || (ve[15] = (V) => ne.$emit("am-pm-change", V))
        }), it({ _: 2 }, [
          De(u(J), (V, xe) => ({
            name: V,
            fn: B((ce) => [
              L(ne.$slots, V, Mt(Kt(ce)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : A("", !0)
    ], 64));
  }
}), D2 = (e, t) => {
  const n = N(), {
    defaultedMultiCalendars: a,
    defaultedConfig: o,
    defaultedHighlight: l,
    defaultedRange: r,
    propDates: c,
    defaultedFilters: s,
    defaultedMultiDates: p
  } = ft(e), { modelValue: d, year: f, month: h, calendars: $ } = no(e, t), { isDisabled: y } = ja(e), { selectYear: w, groupedYears: v, showYearPicker: x, isDisabled: b, toggleYearPicker: k, handleYearSelect: _, handleYear: T } = Rc({
    modelValue: d,
    multiCalendars: a,
    range: r,
    highlight: l,
    calendars: $,
    propDates: c,
    month: h,
    year: f,
    filters: s,
    props: e,
    emit: t
  }), S = (z, D) => [z, D].map((P) => yt(P, "MMMM", { locale: e.formatLocale })).join("-"), M = m(() => (z) => d.value ? Array.isArray(d.value) ? d.value.some((D) => os(z, D)) : os(d.value, z) : !1), E = (z) => {
    if (r.value.enabled) {
      if (Array.isArray(d.value)) {
        const D = Je(z, d.value[0]) || Je(z, d.value[1]);
        return jn(d.value, n.value, z) && !D;
      }
      return !1;
    }
    return !1;
  }, F = (z, D) => z.quarter === Xr(D) && z.year === je(D), H = (z) => typeof l.value == "function" ? l.value({ quarter: Xr(z), year: je(z) }) : !!l.value.quarters.find((D) => F(D, z)), te = m(() => (z) => {
    const D = st(/* @__PURE__ */ new Date(), { year: f.value(z) });
    return Xp({
      start: hn(D),
      end: Ki(D)
    }).map((P) => {
      const Z = Za(P), J = Jr(P), re = y(P), U = E(Z), ge = H(Z);
      return {
        text: S(Z, J),
        value: Z,
        active: M.value(Z),
        highlighted: ge,
        disabled: re,
        isBetween: U
      };
    });
  }), ie = (z) => {
    Dr(z, d, p.value.limit), t("auto-apply", !0);
  }, ee = (z) => {
    d.value = Tr(d, z, t), Fo(d.value, t, e.autoApply, e.modelAuto);
  }, O = (z) => {
    d.value = z, t("auto-apply");
  };
  return {
    defaultedConfig: o,
    defaultedMultiCalendars: a,
    groupedYears: v,
    year: f,
    isDisabled: b,
    quarters: te,
    showYearPicker: x,
    modelValue: d,
    setHoverDate: (z) => {
      n.value = z;
    },
    selectYear: w,
    selectQuarter: (z, D, P) => {
      if (!P)
        return $.value[D].month = Qe(Jr(z)), p.value.enabled ? ie(z) : r.value.enabled ? ee(z) : O(z);
    },
    toggleYearPicker: k,
    handleYearSelect: _,
    handleYear: T
  };
}, T2 = { class: "dp--quarter-items" }, B2 = ["data-test-id", "disabled", "onClick", "onMouseover"], z2 = /* @__PURE__ */ Y({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...ia
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end",
    "overlay-toggle",
    "update-month-year"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, o = e, l = mt(), r = Wt(l, "yearMode"), {
      defaultedMultiCalendars: c,
      defaultedConfig: s,
      groupedYears: p,
      year: d,
      isDisabled: f,
      quarters: h,
      modelValue: $,
      showYearPicker: y,
      setHoverDate: w,
      selectQuarter: v,
      toggleYearPicker: x,
      handleYearSelect: b,
      handleYear: k
    } = D2(o, a);
    return t({ getSidebarProps: () => ({
      modelValue: $,
      year: d,
      selectQuarter: v,
      handleYearSelect: b,
      handleYear: k
    }) }), (_, T) => (i(), R(No, {
      "multi-calendars": u(c).count,
      collapse: _.collapse,
      stretch: "",
      "is-mobile": _.isMobile
    }, {
      default: B(({ instance: S }) => [
        C("div", {
          class: "dp-quarter-picker-wrap",
          style: Ie({ minHeight: `${u(s).modeHeight}px` })
        }, [
          _.$slots["top-extra"] ? L(_.$slots, "top-extra", {
            key: 0,
            value: _.internalModelValue
          }) : A("", !0),
          C("div", null, [
            j(Lc, Ke(_.$props, {
              items: u(p)(S),
              instance: S,
              "show-year-picker": u(y)[S],
              year: u(d)(S),
              "is-disabled": (M) => u(f)(S, M),
              onHandleYear: (M) => u(k)(S, M),
              onYearSelect: (M) => u(b)(M, S),
              onToggleYearPicker: (M) => u(x)(S, M?.flow, M?.show)
            }), it({ _: 2 }, [
              De(u(r), (M, E) => ({
                name: M,
                fn: B((F) => [
                  L(_.$slots, M, Mt(Kt(F)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          C("div", T2, [
            (i(!0), g(he, null, De(u(h)(S), (M, E) => (i(), g("div", { key: E }, [
              C("button", {
                type: "button",
                class: W(["dp--qr-btn", {
                  "dp--qr-btn-active": M.active,
                  "dp--qr-btn-between": M.isBetween,
                  "dp--qr-btn-disabled": M.disabled,
                  "dp--highlighted": M.highlighted
                }]),
                "data-test-id": M.value,
                disabled: M.disabled,
                onClick: (F) => u(v)(M.value, S, M.disabled),
                onMouseover: (F) => u(w)(M.value)
              }, [
                _.$slots.quarter ? L(_.$slots, "quarter", {
                  key: 0,
                  value: M.value,
                  text: M.text
                }) : (i(), g(he, { key: 1 }, [
                  me(le(M.text), 1)
                ], 64))
              ], 42, B2)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse", "is-mobile"]));
  }
}), Vc = (e, t) => {
  const n = N(0);
  tt(() => {
    a(), window.addEventListener("resize", a, { passive: !0 });
  }), Fa(() => {
    window.removeEventListener("resize", a);
  });
  const a = () => {
    n.value = window.document.documentElement.clientWidth;
  };
  return {
    isMobile: m(
      () => n.value <= e.value.mobileBreakpoint && !t ? !0 : void 0
    )
  };
}, A2 = ["id", "tabindex", "role", "aria-label"], L2 = {
  key: 0,
  class: "dp--menu-load-container"
}, E2 = {
  key: 1,
  class: "dp--menu-header"
}, I2 = ["data-dp-mobile"], R2 = {
  key: 0,
  class: "dp__sidebar_left"
}, P2 = ["data-dp-mobile"], O2 = ["data-test-id", "data-dp-mobile", "onClick", "onKeydown"], V2 = {
  key: 2,
  class: "dp__sidebar_right"
}, H2 = {
  key: 3,
  class: "dp__action_extra"
}, As = /* @__PURE__ */ Y({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...Ho,
    shadow: { type: Boolean, default: !1 },
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    noOverlayFocus: { type: Boolean, default: !1 },
    collapse: { type: Boolean, default: !1 },
    getInputRect: { type: Function, default: () => ({}) },
    isTextInputDate: { type: Boolean, default: !1 }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "menu-blur"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, o = e, l = N(null), r = m(() => {
      const { openOnTop: Q, ...G } = o;
      return {
        ...G,
        isMobile: v.value,
        flowStep: ee.value,
        menuWrapRef: l.value
      };
    }), { setMenuFocused: c, setShiftKey: s, control: p } = Ac(), d = mt(), { defaultedTextInput: f, defaultedInline: h, defaultedConfig: $, defaultedUI: y, handleEventPropagation: w } = ft(o), { isMobile: v } = Vc($, o.shadow), x = N(null), b = N(0), k = N(null), _ = N(!1), T = N(null), S = N(!1), M = (Q) => {
      S.value = !0, $.value.allowPreventDefault && Q.preventDefault(), Ea(Q, $.value, !0);
    };
    tt(() => {
      if (!o.shadow) {
        _.value = !0, E(), window.addEventListener("resize", E);
        const Q = St(l);
        Q && !f.value.enabled && !h.value.enabled && (c(!0), re()), Q && (Q.addEventListener("pointerdown", M), Q.addEventListener("mousedown", M));
      }
      document.addEventListener("mousedown", qe);
    }), Fa(() => {
      window.removeEventListener("resize", E), document.removeEventListener("mousedown", qe);
      const Q = St(l);
      Q && (Q.removeEventListener("pointerdown", M), Q.removeEventListener("mousedown", M));
    });
    const E = () => {
      const Q = St(k);
      Q && (b.value = Q.getBoundingClientRect().width);
    }, { arrowRight: F, arrowLeft: H, arrowDown: te, arrowUp: ie } = Ya(), { flowStep: ee, updateFlowStep: O, childMount: z, resetFlow: D, handleFlow: P } = j2(o, a, T), Z = m(() => o.monthPicker ? Z3 : o.yearPicker ? X3 : o.timePicker ? d2 : o.quarterPicker ? z2 : M2), J = m(() => {
      if ($.value.arrowLeft) return $.value.arrowLeft;
      const Q = l.value?.getBoundingClientRect(), G = o.getInputRect();
      return G?.width < b?.value && G?.left <= (Q?.left ?? 0) ? `${G?.width / 2}px` : G?.right >= (Q?.right ?? 0) && G?.width < b?.value ? `${b?.value - G?.width / 2}px` : "50%";
    }), re = () => {
      const Q = St(l);
      Q && Q.focus({ preventScroll: !0 });
    }, U = m(() => T.value?.getSidebarProps() || {}), ge = () => {
      o.openOnTop && a("recalculate-position");
    }, K = Wt(d, "action"), pe = m(() => o.monthPicker || o.yearPicker ? Wt(d, "monthYear") : o.timePicker ? Wt(d, "timePicker") : Wt(d, "shared")), ae = m(() => o.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), Ce = m(() => ({
      dp__menu_disabled: o.disabled,
      dp__menu_readonly: o.readonly,
      "dp-menu-loading": o.loading
    })), q = m(
      () => ({
        dp__menu: !0,
        dp__menu_index: !h.value.enabled,
        dp__relative: h.value.enabled,
        ...y.value.menu ?? {}
      })
    ), I = (Q) => {
      Ea(Q, $.value, !0);
    }, oe = (Q) => {
      o.escClose && (a("close-picker"), w(Q));
    }, be = (Q) => {
      if (o.arrowNavigation) {
        if (Q === Ot.up) return ie();
        if (Q === Ot.down) return te();
        if (Q === Ot.left) return H();
        if (Q === Ot.right) return F();
      } else Q === Ot.left || Q === Ot.up ? V("handleArrow", Ot.left, 0, Q === Ot.up) : V("handleArrow", Ot.right, 0, Q === Ot.down);
    }, de = (Q) => {
      s(Q.shiftKey), !o.disableMonthYearSelect && Q.code === dt.tab && Q.target.classList.contains("dp__menu") && p.value.shiftKeyInMenu && (Q.preventDefault(), Ea(Q, $.value, !0), a("close-picker"));
    }, X = () => {
      re(), a("time-picker-close");
    }, ne = (Q) => {
      T.value?.toggleTimePicker(!1, !1), T.value?.toggleMonthPicker(!1, !1, Q), T.value?.toggleYearPicker(!1, !1, Q);
    }, ve = (Q, G = 0) => Q === "month" ? T.value?.toggleMonthPicker(!1, !0, G) : Q === "year" ? T.value?.toggleYearPicker(!1, !0, G) : Q === "time" ? T.value?.toggleTimePicker(!0, !1) : ne(G), V = (Q, ...G) => {
      T.value?.[Q] && T.value?.[Q](...G);
    }, xe = () => {
      V("selectCurrentDate");
    }, ce = (Q, G) => {
      V("presetDate", Ne(Q), G);
    }, Te = () => {
      V("clearHoverDate");
    }, $e = (Q, G) => {
      V("updateMonthYear", Q, G);
    }, Be = (Q, G) => {
      Q.preventDefault(), be(G);
    }, Ue = (Q) => {
      if (de(Q), Q.key === dt.home || Q.key === dt.end)
        return V(
          "selectWeekDate",
          Q.key === dt.home,
          Q.target.getAttribute("id")
        );
      switch ((Q.key === dt.pageUp || Q.key === dt.pageDown) && (Q.shiftKey ? (V("changeYear", Q.key === dt.pageUp), El(l.value, "overlay-year")?.focus()) : (V("changeMonth", Q.key === dt.pageUp), El(l.value, Q.key === dt.pageUp ? "action-prev" : "action-next")?.focus()), Q.target.getAttribute("id") && l.value?.focus({ preventScroll: !0 })), Q.key) {
        case dt.esc:
          return oe(Q);
        case dt.arrowLeft:
          return Be(Q, Ot.left);
        case dt.arrowRight:
          return Be(Q, Ot.right);
        case dt.arrowUp:
          return Be(Q, Ot.up);
        case dt.arrowDown:
          return Be(Q, Ot.down);
        default:
          return;
      }
    }, qe = (Q) => {
      h.value.enabled && !h.value.input && !l.value?.contains(Q.target) && S.value && (S.value = !1, a("menu-blur"));
    };
    return t({
      updateMonthYear: $e,
      switchView: ve,
      handleFlow: P,
      onValueCleared: () => {
        T.value?.setStartTime?.();
      }
    }), (Q, G) => (i(), g("div", {
      id: Q.uid ? `dp-menu-${Q.uid}` : void 0,
      ref_key: "dpMenuRef",
      ref: l,
      tabindex: u(h).enabled ? void 0 : "0",
      role: u(h).enabled ? void 0 : "dialog",
      "aria-label": Q.ariaLabels?.menu,
      class: W(q.value),
      style: Ie({ "--dp-arrow-left": J.value }),
      onMouseleave: Te,
      onClick: I,
      onKeydown: Ue
    }, [
      (Q.disabled || Q.readonly) && u(h).enabled || Q.loading ? (i(), g("div", {
        key: 0,
        class: W(Ce.value)
      }, [
        Q.loading ? (i(), g("div", L2, [...G[19] || (G[19] = [
          C("span", { class: "dp--menu-loader" }, null, -1)
        ])])) : A("", !0)
      ], 2)) : A("", !0),
      Q.$slots["menu-header"] ? (i(), g("div", E2, [
        L(Q.$slots, "menu-header")
      ])) : A("", !0),
      !u(h).enabled && !Q.teleportCenter ? (i(), g("div", {
        key: 2,
        class: W(ae.value)
      }, null, 2)) : A("", !0),
      C("div", {
        ref_key: "innerMenuRef",
        ref: k,
        class: W({
          dp__menu_content_wrapper: Q.presetDates?.length || !!Q.$slots["left-sidebar"] || !!Q.$slots["right-sidebar"],
          "dp--menu-content-wrapper-collapsed": e.collapse && (Q.presetDates?.length || !!Q.$slots["left-sidebar"] || !!Q.$slots["right-sidebar"])
        }),
        "data-dp-mobile": u(v),
        style: Ie({ "--dp-menu-width": `${b.value}px` })
      }, [
        Q.$slots["left-sidebar"] ? (i(), g("div", R2, [
          L(Q.$slots, "left-sidebar", Mt(Kt(U.value)))
        ])) : A("", !0),
        Q.presetDates.length ? (i(), g("div", {
          key: 1,
          class: W({ "dp--preset-dates-collapsed": e.collapse, "dp--preset-dates": !0 }),
          "data-dp-mobile": u(v)
        }, [
          (i(!0), g(he, null, De(Q.presetDates, (fe, ke) => (i(), g(he, { key: ke }, [
            fe.slot ? L(Q.$slots, fe.slot, {
              key: 0,
              presetDate: ce,
              label: fe.label,
              value: fe.value
            }) : (i(), g("button", {
              key: 1,
              type: "button",
              style: Ie(fe.style || {}),
              class: W(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": e.collapse }]),
              "data-test-id": fe.testId ?? void 0,
              "data-dp-mobile": u(v),
              onClick: Fe((Re) => ce(fe.value, fe.noTz), ["prevent"]),
              onKeydown: (Re) => u(Vt)(Re, () => ce(fe.value, fe.noTz), !0)
            }, le(fe.label), 47, O2))
          ], 64))), 128))
        ], 10, P2)) : A("", !0),
        C("div", {
          ref_key: "calendarWrapperRef",
          ref: x,
          class: "dp__instance_calendar",
          role: "document"
        }, [
          (i(), R(Pe(Z.value), Ke({
            ref_key: "dynCmpRef",
            ref: T
          }, r.value, {
            "flow-step": u(ee),
            onMount: u(z),
            onUpdateFlowStep: u(O),
            onResetFlow: u(D),
            onFocusMenu: re,
            onSelectDate: G[0] || (G[0] = (fe) => Q.$emit("select-date")),
            onDateUpdate: G[1] || (G[1] = (fe) => Q.$emit("date-update", fe)),
            onTooltipOpen: G[2] || (G[2] = (fe) => Q.$emit("tooltip-open", fe)),
            onTooltipClose: G[3] || (G[3] = (fe) => Q.$emit("tooltip-close", fe)),
            onAutoApply: G[4] || (G[4] = (fe) => Q.$emit("auto-apply", fe)),
            onRangeStart: G[5] || (G[5] = (fe) => Q.$emit("range-start", fe)),
            onRangeEnd: G[6] || (G[6] = (fe) => Q.$emit("range-end", fe)),
            onInvalidFixedRange: G[7] || (G[7] = (fe) => Q.$emit("invalid-fixed-range", fe)),
            onTimeUpdate: G[8] || (G[8] = (fe) => Q.$emit("time-update")),
            onAmPmChange: G[9] || (G[9] = (fe) => Q.$emit("am-pm-change", fe)),
            onTimePickerOpen: G[10] || (G[10] = (fe) => Q.$emit("time-picker-open", fe)),
            onTimePickerClose: X,
            onRecalculatePosition: ge,
            onUpdateMonthYear: G[11] || (G[11] = (fe) => Q.$emit("update-month-year", fe)),
            onAutoApplyInvalid: G[12] || (G[12] = (fe) => Q.$emit("auto-apply-invalid", fe)),
            onInvalidDate: G[13] || (G[13] = (fe) => Q.$emit("invalid-date", fe)),
            onOverlayToggle: G[14] || (G[14] = (fe) => Q.$emit("overlay-toggle", fe)),
            "onUpdate:internalModelValue": G[15] || (G[15] = (fe) => Q.$emit("update:internal-model-value", fe))
          }), it({ _: 2 }, [
            De(pe.value, (fe, ke) => ({
              name: fe,
              fn: B((Re) => [
                L(Q.$slots, fe, Mt(Kt({ ...Re })))
              ])
            }))
          ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
        ], 512),
        Q.$slots["right-sidebar"] ? (i(), g("div", V2, [
          L(Q.$slots, "right-sidebar", Mt(Kt(U.value)))
        ])) : A("", !0),
        Q.$slots["action-extra"] ? (i(), g("div", H2, [
          Q.$slots["action-extra"] ? L(Q.$slots, "action-extra", {
            key: 0,
            selectCurrentDate: xe
          }) : A("", !0)
        ])) : A("", !0)
      ], 14, I2),
      !Q.autoApply || u($).keepActionRow ? (i(), R(H3, Ke({
        key: 3,
        "menu-mount": _.value
      }, r.value, {
        "calendar-width": b.value,
        onClosePicker: G[16] || (G[16] = (fe) => Q.$emit("close-picker")),
        onSelectDate: G[17] || (G[17] = (fe) => Q.$emit("select-date")),
        onInvalidSelect: G[18] || (G[18] = (fe) => Q.$emit("invalid-select")),
        onSelectNow: xe
      }), it({ _: 2 }, [
        De(u(K), (fe, ke) => ({
          name: fe,
          fn: B((Re) => [
            L(Q.$slots, fe, Mt(Kt({ ...Re })))
          ])
        }))
      ]), 1040, ["menu-mount", "calendar-width"])) : A("", !0)
    ], 46, A2));
  }
});
var dn = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(dn || {});
const N2 = ({
  menuRef: e,
  menuRefInner: t,
  inputRef: n,
  pickerWrapperRef: a,
  inline: o,
  emit: l,
  props: r,
  slots: c
}) => {
  const { defaultedConfig: s } = ft(r), p = N({}), d = N(!1), f = N({
    top: "0",
    left: "0"
  }), h = N(!1), $ = Ze(r, "teleportCenter");
  Se($, () => {
    f.value = JSON.parse(JSON.stringify({})), T();
  });
  const y = (D) => {
    if (r.teleport) {
      const P = D.getBoundingClientRect();
      return {
        left: P.left + window.scrollX,
        top: P.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, w = (D, P) => {
    f.value.left = `${D + P - p.value.width}px`;
  }, v = (D) => {
    f.value.left = `${D}px`;
  }, x = (D, P) => {
    r.position === dn.left && v(D), r.position === dn.right && w(D, P), r.position === dn.center && (f.value.left = `${D + P / 2 - p.value.width / 2}px`);
  }, b = (D) => {
    const { width: P, height: Z } = D.getBoundingClientRect(), { top: J, left: re } = y(D);
    return { top: +J, left: +re, width: P, height: Z };
  }, k = () => {
    f.value.left = "50%", f.value.top = "50%", f.value.transform = "translate(-50%, -50%)", f.value.position = "fixed", delete f.value.opacity;
  }, _ = () => {
    const D = St(n);
    f.value = r.altPosition(D);
  }, T = (D = !0) => {
    if (!o.value.enabled) {
      if ($.value) return k();
      if (r.altPosition !== null) return _();
      if (D) {
        const P = r.teleport ? t.value?.$el : e.value;
        P && (p.value = P.getBoundingClientRect()), l("recalculate-position");
      }
      return ie();
    }
  }, S = ({ inputEl: D, left: P, width: Z }) => {
    window.screen.width > 768 && !d.value && x(P, Z), F(D);
  }, M = (D) => {
    const { top: P, left: Z, height: J, width: re } = b(D);
    f.value.top = `${J + P + +r.offset}px`, h.value = !1, d.value || (f.value.left = `${Z + re / 2 - p.value.width / 2}px`), S({ inputEl: D, left: Z, width: re });
  }, E = (D) => {
    const { top: P, left: Z, width: J } = b(D);
    f.value.top = `${P - +r.offset - p.value.height}px`, h.value = !0, S({ inputEl: D, left: Z, width: J });
  }, F = (D) => {
    if (r.autoPosition) {
      const { left: P, width: Z } = b(D), { left: J, right: re } = p.value;
      if (!d.value) {
        if (Math.abs(J) !== Math.abs(re)) {
          if (J <= 0)
            return d.value = !0, v(P);
          if (re >= document.documentElement.clientWidth)
            return d.value = !0, w(P, Z);
        }
        return x(P, Z);
      }
    }
  }, H = () => {
    const D = St(n);
    if (D) {
      if (r.autoPosition === aa.top) return aa.top;
      if (r.autoPosition === aa.bottom) return aa.bottom;
      const { height: P } = p.value, { top: Z, height: J } = D.getBoundingClientRect(), re = window.innerHeight - Z - J, U = Z;
      return P <= re ? aa.bottom : P > re && P <= U ? aa.top : re >= U ? aa.bottom : aa.top;
    }
    return aa.bottom;
  }, te = (D) => H() === aa.bottom ? M(D) : E(D), ie = () => {
    const D = St(n);
    if (D)
      return r.autoPosition ? te(D) : M(D);
  }, ee = function(D) {
    if (D) {
      const P = D.scrollHeight > D.clientHeight, Z = window.getComputedStyle(D).overflowY.indexOf("hidden") !== -1;
      return P && !Z;
    }
    return !0;
  }, O = function(D) {
    return !D || D === document.body || D.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : ee(D) ? D : O(
      D.assignedSlot && s.value.shadowDom ? D.assignedSlot.parentNode : D.parentNode
    );
  }, z = (D) => {
    if (D)
      switch (r.position) {
        case dn.left:
          return { left: 0, transform: "translateX(0)" };
        case dn.right:
          return { left: `${D.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${D.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: h,
    menuStyle: f,
    xCorrect: d,
    setMenuPosition: T,
    getScrollableParent: O,
    shadowRender: (D, P, Z) => {
      const J = document.createElement("div"), re = St(n)?.getBoundingClientRect();
      J.setAttribute("id", "dp--temp-container");
      const U = a.value?.clientWidth ? a.value : document.body;
      U.append(J);
      const ge = z(re), K = s.value.shadowDom ? Object.keys(c).filter(
        (ae) => ["right-sidebar", "left-sidebar", "top-extra", "action-extra"].includes(ae)
      ) : Object.keys(c), pe = na(
        P,
        {
          ...Z,
          shadow: !0,
          style: { opacity: 0, position: "absolute", ...ge }
        },
        Object.fromEntries(K.map((ae) => [ae, c[ae]]))
      );
      D != null && (pe.appContext = D.appContext), jr(pe, J), p.value = pe.el?.getBoundingClientRect(), jr(null, J), U.removeChild(J);
    }
  };
}, za = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] },
  { name: "top-extra", use: ["shared", "month-year"] },
  { name: "tp-inline-arrow-up", use: ["shared", "time"] },
  { name: "tp-inline-arrow-down", use: ["shared", "time"] },
  { name: "menu-header", use: ["menu"] }
], F2 = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], K2 = {
  all: () => za,
  monthYear: () => za.filter((e) => e.use.includes("month-year")),
  input: () => F2,
  timePicker: () => za.filter((e) => e.use.includes("time")),
  action: () => za.filter((e) => e.use.includes("action")),
  calendar: () => za.filter((e) => e.use.includes("calendar")),
  menu: () => za.filter((e) => e.use.includes("menu")),
  shared: () => za.filter((e) => e.use.includes("shared")),
  yearMode: () => za.filter((e) => e.use.includes("year-mode"))
}, Wt = (e, t, n) => {
  const a = [];
  return K2[t]().forEach((o) => {
    e[o.name] && a.push(o.name);
  }), n?.length && n.forEach((o) => {
    o.slot && a.push(o.slot);
  }), a;
}, ao = (e) => {
  const t = m(() => (a) => e.value ? a ? e.value.open : e.value.close : ""), n = m(() => (a) => e.value ? a ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: t, showTransition: !!e.value, menuTransition: n };
}, no = (e, t, n) => {
  const { defaultedRange: a, defaultedTz: o } = ft(e), l = ye(Yt(ye(), o.value.timezone)), r = N([{ month: Qe(l), year: je(l) }]), c = (h) => {
    const $ = {
      hours: Sa(l),
      minutes: Va(l),
      seconds: 0
    };
    return a.value.enabled ? [$[h], $[h]] : $[h];
  }, s = Na({
    hours: c("hours"),
    minutes: c("minutes"),
    seconds: c("seconds")
  });
  Se(
    a,
    (h, $) => {
      h.enabled !== $.enabled && (s.hours = c("hours"), s.minutes = c("minutes"), s.seconds = c("seconds"));
    },
    { deep: !0 }
  );
  const p = m({
    get: () => e.internalModelValue,
    set: (h) => {
      !e.readonly && !e.disabled && t("update:internal-model-value", h);
    }
  }), d = m(
    () => (h) => r.value[h] ? r.value[h].month : 0
  ), f = m(
    () => (h) => r.value[h] ? r.value[h].year : 0
  );
  return Se(
    p,
    (h, $) => {
      n && JSON.stringify(h ?? {}) !== JSON.stringify($ ?? {}) && n();
    },
    { deep: !0 }
  ), {
    calendars: r,
    time: s,
    modelValue: p,
    month: d,
    year: f,
    today: l
  };
}, Y2 = (e, t) => {
  const {
    defaultedMultiCalendars: n,
    defaultedMultiDates: a,
    defaultedUI: o,
    defaultedHighlight: l,
    defaultedTz: r,
    propDates: c,
    defaultedRange: s
  } = ft(t), { isDisabled: p } = ja(t), d = N(null), f = N(Yt(/* @__PURE__ */ new Date(), r.value.timezone)), h = (q) => {
    !q.current && t.hideOffsetDates || (d.value = q.value);
  }, $ = () => {
    d.value = null;
  }, y = (q) => Array.isArray(e.value) && s.value.enabled && e.value[0] && d.value ? q ? kt(d.value, e.value[0]) : gt(d.value, e.value[0]) : !0, w = (q, I) => {
    const oe = () => e.value ? I ? e.value[0] || null : e.value[1] : null, be = e.value && Array.isArray(e.value) ? oe() : null;
    return Je(ye(q.value), be);
  }, v = (q) => {
    const I = Array.isArray(e.value) ? e.value[0] : null;
    return q ? !gt(d.value ?? null, I) : !0;
  }, x = (q, I = !0) => (s.value.enabled || t.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? t.hideOffsetDates && !q.current ? !1 : Je(ye(q.value), e.value[I ? 0 : 1]) : s.value.enabled ? w(q, I) && v(I) || Je(q.value, Array.isArray(e.value) ? e.value[0] : null) && y(I) : !1, b = (q, I) => {
    if (Array.isArray(e.value) && e.value[0] && e.value.length === 1) {
      const oe = Je(q.value, d.value);
      return I ? kt(e.value[0], q.value) && oe : gt(e.value[0], q.value) && oe;
    }
    return !1;
  }, k = (q) => !e.value || t.hideOffsetDates && !q.current ? !1 : s.value.enabled ? t.modelAuto && Array.isArray(e.value) ? Je(q.value, e.value[0] ? e.value[0] : f.value) : !1 : a.value.enabled && Array.isArray(e.value) ? e.value.some((I) => Je(I, q.value)) : Je(q.value, e.value ? e.value : f.value), _ = (q) => {
    if (s.value.autoRange || t.weekPicker) {
      if (d.value) {
        if (t.hideOffsetDates && !q.current) return !1;
        const I = At(d.value, +s.value.autoRange), oe = ba(ye(d.value), t.weekStart);
        return t.weekPicker ? Je(oe[1], ye(q.value)) : Je(I, ye(q.value));
      }
      return !1;
    }
    return !1;
  }, T = (q) => {
    if (s.value.autoRange || t.weekPicker) {
      if (d.value) {
        const I = At(d.value, +s.value.autoRange);
        if (t.hideOffsetDates && !q.current) return !1;
        const oe = ba(ye(d.value), t.weekStart);
        return t.weekPicker ? kt(q.value, oe[0]) && gt(q.value, oe[1]) : kt(q.value, d.value) && gt(q.value, I);
      }
      return !1;
    }
    return !1;
  }, S = (q) => {
    if (s.value.autoRange || t.weekPicker) {
      if (d.value) {
        if (t.hideOffsetDates && !q.current) return !1;
        const I = ba(ye(d.value), t.weekStart);
        return t.weekPicker ? Je(I[0], q.value) : Je(d.value, q.value);
      }
      return !1;
    }
    return !1;
  }, M = (q) => jn(e.value, d.value, q.value), E = () => t.modelAuto && Array.isArray(t.internalModelValue) ? !!t.internalModelValue[0] : !1, F = () => t.modelAuto ? bc(t.internalModelValue) : !0, H = (q) => {
    if (t.weekPicker) return !1;
    const I = s.value.enabled ? !x(q) && !x(q, !1) : !0;
    return !p(q.value) && !k(q) && !(!q.current && t.hideOffsetDates) && I;
  }, te = (q) => s.value.enabled ? t.modelAuto ? E() && k(q) : !1 : k(q), ie = (q) => l.value ? c3(q.value, c.value.highlight) : !1, ee = (q) => {
    const I = p(q.value);
    return I && (typeof l.value == "function" ? !l.value(q.value, I) : !l.value.options.highlightDisabled);
  }, O = (q) => typeof l.value == "function" ? l.value(q.value) : l.value.weekdays?.includes(q.value.getDay()), z = (q) => (s.value.enabled || t.weekPicker) && (!(n.value.count > 0) || q.current) && F() && !(!q.current && t.hideOffsetDates) && !k(q) ? M(q) : !1, D = (q) => {
    if (Array.isArray(e.value) && e.value.length === 1) {
      const { before: I, after: oe } = Ds(+s.value.maxRange, e.value[0]);
      return ma(q.value, I) || va(q.value, oe);
    }
    return !1;
  }, P = (q) => {
    if (Array.isArray(e.value) && e.value.length === 1) {
      const { before: I, after: oe } = Ds(+s.value.minRange, e.value[0]);
      return jn([I, oe], e.value[0], q.value);
    }
    return !1;
  }, Z = (q) => s.value.enabled && (s.value.maxRange || s.value.minRange) ? s.value.maxRange && s.value.minRange ? D(q) || P(q) : s.value.maxRange ? D(q) : P(q) : !1, J = (q) => {
    const { isRangeStart: I, isRangeEnd: oe } = K(q), be = s.value.enabled ? I || oe : !1;
    return {
      dp__cell_offset: !q.current,
      dp__pointer: !t.disabled && !(!q.current && t.hideOffsetDates) && !p(q.value) && !Z(q),
      dp__cell_disabled: p(q.value) || Z(q),
      dp__cell_highlight: !ee(q) && (ie(q) || O(q)) && !te(q) && !be && !S(q) && !(z(q) && t.weekPicker) && !oe,
      dp__cell_highlight_active: !ee(q) && (ie(q) || O(q)) && te(q),
      dp__today: !t.noToday && Je(q.value, f.value) && q.current,
      "dp--past": gt(q.value, f.value),
      "dp--future": kt(q.value, f.value)
    };
  }, re = (q) => ({
    dp__active_date: te(q),
    dp__date_hover: H(q)
  }), U = (q) => {
    if (e.value && !Array.isArray(e.value)) {
      const I = ba(e.value, t.weekStart);
      return {
        ...ae(q),
        dp__range_start: Je(I[0], q.value),
        dp__range_end: Je(I[1], q.value),
        dp__range_between_week: kt(q.value, I[0]) && gt(q.value, I[1])
      };
    }
    return {
      ...ae(q)
    };
  }, ge = (q) => {
    if (e.value && Array.isArray(e.value)) {
      const I = ba(e.value[0], t.weekStart), oe = e.value[1] ? ba(e.value[1], t.weekStart) : [];
      return {
        ...ae(q),
        dp__range_start: Je(I[0], q.value) || Je(oe[0], q.value),
        dp__range_end: Je(I[1], q.value) || Je(oe[1], q.value),
        dp__range_between_week: kt(q.value, I[0]) && gt(q.value, I[1]) || kt(q.value, oe[0]) && gt(q.value, oe[1]),
        dp__range_between: kt(q.value, I[1]) && gt(q.value, oe[0])
      };
    }
    return {
      ...ae(q)
    };
  }, K = (q) => {
    const I = n.value.count > 0 ? q.current && x(q) && F() : x(q) && F(), oe = n.value.count > 0 ? q.current && x(q, !1) && F() : x(q, !1) && F();
    return { isRangeStart: I, isRangeEnd: oe };
  }, pe = (q) => {
    const { isRangeStart: I, isRangeEnd: oe } = K(q);
    return {
      dp__range_start: I,
      dp__range_end: oe,
      dp__range_between: z(q),
      dp__date_hover: Je(q.value, d.value) && !I && !oe && !t.weekPicker,
      dp__date_hover_start: b(q, !0),
      dp__date_hover_end: b(q, !1)
    };
  }, ae = (q) => ({
    ...pe(q),
    dp__cell_auto_range: T(q),
    dp__cell_auto_range_start: S(q),
    dp__cell_auto_range_end: _(q)
  }), Ce = (q) => s.value.enabled ? s.value.autoRange ? ae(q) : t.modelAuto ? { ...re(q), ...pe(q) } : t.weekPicker ? ge(q) : pe(q) : t.weekPicker ? U(q) : re(q);
  return {
    setHoverDate: h,
    clearHoverDate: $,
    getDayClassData: (q) => t.hideOffsetDates && !q.current ? {} : {
      ...J(q),
      ...Ce(q),
      [t.dayClass ? t.dayClass(q.value, t.internalModelValue) : ""]: !0,
      ...o.value.calendarCell ?? {}
    }
  };
}, ja = (e) => {
  const { defaultedFilters: t, defaultedRange: n, propDates: a, defaultedMultiDates: o } = ft(e), l = (O) => a.value.disabledDates ? typeof a.value.disabledDates == "function" ? a.value.disabledDates(ye(O)) : !!Bo(O, a.value.disabledDates) : !1, r = (O) => a.value.maxDate ? e.yearPicker ? je(O) > je(a.value.maxDate) : kt(O, a.value.maxDate) : !1, c = (O) => a.value.minDate ? e.yearPicker ? je(O) < je(a.value.minDate) : gt(O, a.value.minDate) : !1, s = (O) => {
    const z = r(O), D = c(O), P = l(O), Z = t.value.months.map((K) => +K).includes(Qe(O)), J = e.disabledWeekDays.length ? e.disabledWeekDays.some((K) => +K === Yf(O)) : !1, re = $(O), U = je(O), ge = zc(e.yearRange, U);
    return !(z || D || P || Z || ge || J || re);
  }, p = (O, z) => gt(...La(a.value.minDate, O, z)) || Je(...La(a.value.minDate, O, z)), d = (O, z) => kt(...La(a.value.maxDate, O, z)) || Je(...La(a.value.maxDate, O, z)), f = (O, z, D) => {
    let P = !1;
    return a.value.maxDate && D && d(O, z) && (P = !0), a.value.minDate && !D && p(O, z) && (P = !0), P;
  }, h = (O, z, D, P) => {
    let Z = !1;
    return P && (a.value.minDate || a.value.maxDate) ? a.value.minDate && a.value.maxDate ? Z = f(O, z, D) : (a.value.minDate && p(O, z) || a.value.maxDate && d(O, z)) && (Z = !0) : Z = !0, Z;
  }, $ = (O) => Array.isArray(a.value.allowedDates) && !a.value.allowedDates.length ? !0 : a.value.allowedDates ? !Bo(O, a.value.allowedDates, _c(e.monthPicker, e.yearPicker)) : !1, y = (O) => !s(O), w = (O) => n.value.noDisabledRange ? !ar({ start: O[0], end: O[1] }).some((z) => y(z)) : !0, v = (O) => {
    if (O) {
      const z = je(O);
      return z >= +e.yearRange[0] && z <= e.yearRange[1];
    }
    return !0;
  }, x = (O, z) => !!(Array.isArray(O) && O[z] && (n.value.maxRange || n.value.minRange) && v(O[z])), b = (O, z, D = 0) => {
    if (x(z, D) && v(O)) {
      const P = Hi(O, z[D]), Z = Sc(z[D], O), J = Z.length === 1 ? 0 : Z.filter((U) => y(U)).length, re = Math.abs(P) - (n.value.minMaxRawRange ? 0 : J);
      if (n.value.minRange && n.value.maxRange)
        return re >= +n.value.minRange && re <= +n.value.maxRange;
      if (n.value.minRange) return re >= +n.value.minRange;
      if (n.value.maxRange) return re <= +n.value.maxRange;
    }
    return !0;
  }, k = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, _ = (O) => Array.isArray(O) ? [O[0] ? ll(O[0]) : null, O[1] ? ll(O[1]) : null] : ll(O), T = (O, z, D) => O.find(
    (P) => +P.hours === Sa(z) && P.minutes === "*" ? !0 : +P.minutes === Va(z) && +P.hours === Sa(z)
  ) && D, S = (O, z, D) => {
    const [P, Z] = O, [J, re] = z;
    return !T(P, J, D) && !T(Z, re, D) && D;
  }, M = (O, z) => {
    const D = Array.isArray(z) ? z : [z];
    return Array.isArray(e.disabledTimes) ? Array.isArray(e.disabledTimes[0]) ? S(e.disabledTimes, D, O) : !D.some((P) => T(e.disabledTimes, P, O)) : O;
  }, E = (O, z) => {
    const D = Array.isArray(z) ? [Ja(z[0]), z[1] ? Ja(z[1]) : void 0] : Ja(z), P = !e.disabledTimes(D);
    return O && P;
  }, F = (O, z) => e.disabledTimes ? Array.isArray(e.disabledTimes) ? M(z, O) : E(z, O) : z, H = (O) => {
    let z = !0;
    if (!O || k()) return !0;
    const D = !a.value.minDate && !a.value.maxDate ? _(O) : O;
    return (e.maxTime || a.value.maxDate) && (z = Ms(
      e.maxTime,
      a.value.maxDate,
      "max",
      Bt(D),
      z
    )), (e.minTime || a.value.minDate) && (z = Ms(
      e.minTime,
      a.value.minDate,
      "min",
      Bt(D),
      z
    )), F(O, z);
  }, te = (O) => {
    if (!e.monthPicker) return !0;
    let z = !0;
    const D = ye(la(O));
    if (a.value.minDate && a.value.maxDate) {
      const P = ye(la(a.value.minDate)), Z = ye(la(a.value.maxDate));
      return kt(D, P) && gt(D, Z) || Je(D, P) || Je(D, Z);
    }
    if (a.value.minDate) {
      const P = ye(la(a.value.minDate));
      z = kt(D, P) || Je(D, P);
    }
    if (a.value.maxDate) {
      const P = ye(la(a.value.maxDate));
      z = gt(D, P) || Je(D, P);
    }
    return z;
  }, ie = m(() => (O) => !e.enableTimePicker || e.ignoreTimeValidation ? !0 : H(O)), ee = m(() => (O) => e.monthPicker ? Array.isArray(O) && (n.value.enabled || o.value.enabled) ? !O.filter((z) => !te(z)).length : te(O) : !0);
  return {
    isDisabled: y,
    validateDate: s,
    validateMonthYearInRange: h,
    isDateRangeAllowed: w,
    checkMinMaxRange: b,
    isValidTime: H,
    isTimeValid: ie,
    isMonthValid: ee
  };
}, Ko = () => {
  const e = m(() => (a, o) => a?.includes(o)), t = m(() => (a, o) => a.count ? a.solo ? !0 : o === 0 : !0), n = m(() => (a, o) => a.count ? a.solo ? !0 : o === a.count - 1 : !0);
  return { hideNavigationButtons: e, showLeftIcon: t, showRightIcon: n };
}, j2 = (e, t, n) => {
  const a = N(0), o = Na({
    [Qa.timePicker]: !e.enableTimePicker || e.timePicker || e.monthPicker,
    [Qa.calendar]: !1,
    [Qa.header]: !1
  }), l = m(() => e.monthPicker || e.timePicker), r = (f) => {
    if (e.flow?.length) {
      if (!f && l.value) return d();
      o[f] = !0, Object.keys(o).filter((h) => !o[h]).length || d();
    }
  }, c = () => {
    e.flow?.length && a.value !== -1 && (a.value += 1, t("flow-step", a.value), d()), e.flow?.length === a.value && Ye().then(() => s());
  }, s = () => {
    a.value = -1;
  }, p = (f, h, ...$) => {
    e.flow[a.value] === f && n.value && n.value[h]?.(...$);
  }, d = (f = 0) => {
    f && (a.value += f), p(It.month, "toggleMonthPicker", !0), p(It.year, "toggleYearPicker", !0), p(It.calendar, "toggleTimePicker", !1, !0), p(It.time, "toggleTimePicker", !0, !0);
    const h = e.flow[a.value];
    (h === It.hours || h === It.minutes || h === It.seconds) && p(h, "toggleTimePicker", !0, !0, h);
  };
  return { childMount: r, updateFlowStep: c, resetFlow: s, handleFlow: d, flowStep: a };
}, W2 = {
  key: 1,
  class: "dp__input_wrap"
}, U2 = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], q2 = {
  key: 2,
  class: "dp--clear-btn"
}, Z2 = ["aria-label"], G2 = /* @__PURE__ */ Y({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...Ho
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur",
    "text-input"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, o = e, {
      defaultedTextInput: l,
      defaultedAriaLabels: r,
      defaultedInline: c,
      defaultedConfig: s,
      defaultedRange: p,
      defaultedMultiDates: d,
      defaultedUI: f,
      getDefaultPattern: h,
      getDefaultStartTime: $
    } = ft(o), { checkMinMaxRange: y } = ja(o), w = N(), v = N(null), x = N(!1), b = N(!1), k = m(
      () => ({
        dp__pointer: !o.disabled && !o.readonly && !l.value.enabled,
        dp__disabled: o.disabled,
        dp__input_readonly: !l.value.enabled,
        dp__input: !0,
        dp__input_not_clearable: !o.clearable,
        dp__input_icon_pad: !o.hideInputIcon,
        dp__input_valid: typeof o.state == "boolean" ? o.state : !1,
        dp__input_invalid: typeof o.state == "boolean" ? !o.state : !1,
        dp__input_focus: x.value || o.isMenuOpen,
        dp__input_reg: !l.value.enabled,
        ...f.value.input ?? {}
      })
    ), _ = () => {
      a("set-input-date", null), o.clearable && o.autoApply && (a("set-empty-date"), w.value = null);
    }, T = (U) => {
      const ge = $();
      return d3(
        U,
        l.value.format ?? h(),
        ge ?? Mc({}, o.enableSeconds),
        o.inputValue,
        b.value,
        o.formatLocale
      );
    }, S = (U) => {
      const { rangeSeparator: ge } = l.value, [K, pe] = U.split(`${ge}`);
      if (K) {
        const ae = T(K.trim()), Ce = pe ? T(pe.trim()) : void 0;
        if (va(ae, Ce)) return;
        const q = ae && Ce ? [ae, Ce] : [ae];
        y(Ce, q, 0) && (w.value = ae ? q : null);
      }
    }, M = () => {
      b.value = !0;
    }, E = (U) => {
      if (p.value.enabled)
        S(U);
      else if (d.value.enabled) {
        const ge = U.split(";");
        w.value = ge.map((K) => T(K.trim())).filter((K) => K);
      } else
        w.value = T(U);
    }, F = (U) => {
      const ge = typeof U == "string" ? U : U.target?.value;
      ge !== "" ? (l.value.openMenu && !o.isMenuOpen && a("open"), E(ge), a("set-input-date", w.value)) : _(), b.value = !1, a("update:input-value", ge), a("text-input", U, w.value);
    }, H = (U) => {
      l.value.enabled ? (E(U.target.value), l.value.enterSubmit && Il(w.value) && o.inputValue !== "" ? (a("set-input-date", w.value, !0), w.value = null) : l.value.enterSubmit && o.inputValue === "" && (w.value = null, a("clear"))) : ee(U);
    }, te = (U, ge) => {
      l.value.enabled && l.value.tabSubmit && !ge && E(U.target.value), l.value.tabSubmit && Il(w.value) && o.inputValue !== "" ? (a("set-input-date", w.value, !0, !0), w.value = null) : l.value.tabSubmit && o.inputValue === "" && (w.value = null, a("clear", !0));
    }, ie = () => {
      x.value = !0, a("focus"), Ye().then(() => {
        l.value.enabled && l.value.selectOnFocus && v.value?.select();
      });
    }, ee = (U) => {
      if (Ea(U, s.value, !0), l.value.enabled && l.value.openMenu && !c.value.input) {
        if (l.value.openMenu === "open" && !o.isMenuOpen) return a("open");
        if (l.value.openMenu === "toggle") return a("toggle");
      } else l.value.enabled || a("toggle");
    }, O = () => {
      a("real-blur"), x.value = !1, (!o.isMenuOpen || c.value.enabled && c.value.input) && a("blur"), o.autoApply && l.value.enabled && w.value && !o.isMenuOpen && (a("set-input-date", w.value), a("select-date"), w.value = null);
    }, z = (U) => {
      Ea(U, s.value, !0), a("clear");
    }, D = () => {
      a("close");
    }, P = (U) => {
      if (U.key === "Tab" && te(U), U.key === "Enter" && H(U), U.key === "Escape" && l.value.escClose && D(), !l.value.enabled) {
        if (U.code === "Tab") return;
        U.preventDefault();
      }
    }, Z = () => {
      v.value?.focus({ preventScroll: !0 });
    }, J = (U) => {
      w.value = U;
    }, re = (U) => {
      U.key === dt.tab && te(U, !0);
    };
    return t({
      focusInput: Z,
      setParsedDate: J
    }), (U, ge) => (i(), g("div", { onClick: ee }, [
      U.$slots.trigger && !U.$slots["dp-input"] && !u(c).enabled ? L(U.$slots, "trigger", { key: 0 }) : A("", !0),
      !U.$slots.trigger && (!u(c).enabled || u(c).input) ? (i(), g("div", W2, [
        U.$slots["dp-input"] && !U.$slots.trigger && (!u(c).enabled || u(c).enabled && u(c).input) ? L(U.$slots, "dp-input", {
          key: 0,
          value: e.inputValue,
          isMenuOpen: e.isMenuOpen,
          onInput: F,
          onEnter: H,
          onTab: te,
          onClear: z,
          onBlur: O,
          onKeypress: P,
          onPaste: M,
          onFocus: ie,
          openMenu: () => U.$emit("open"),
          closeMenu: () => U.$emit("close"),
          toggleMenu: () => U.$emit("toggle")
        }) : A("", !0),
        U.$slots["dp-input"] ? A("", !0) : (i(), g("input", {
          key: 1,
          id: U.uid ? `dp-input-${U.uid}` : void 0,
          ref_key: "inputRef",
          ref: v,
          "data-test-id": "dp-input",
          name: U.name,
          class: W(k.value),
          inputmode: u(l).enabled ? "text" : "none",
          placeholder: U.placeholder,
          disabled: U.disabled,
          readonly: U.readonly,
          required: U.required,
          value: e.inputValue,
          autocomplete: U.autocomplete,
          "aria-label": u(r)?.input,
          "aria-disabled": U.disabled || void 0,
          "aria-invalid": U.state === !1 ? !0 : void 0,
          onInput: F,
          onBlur: O,
          onFocus: ie,
          onKeypress: P,
          onKeydown: ge[0] || (ge[0] = (K) => P(K)),
          onPaste: M
        }, null, 42, U2)),
        C("div", {
          onClick: ge[3] || (ge[3] = (K) => a("toggle"))
        }, [
          U.$slots["input-icon"] && !U.hideInputIcon ? (i(), g("span", {
            key: 0,
            class: "dp__input_icon",
            onClick: ge[1] || (ge[1] = (K) => a("toggle"))
          }, [
            L(U.$slots, "input-icon")
          ])) : A("", !0),
          !U.$slots["input-icon"] && !U.hideInputIcon && !U.$slots["dp-input"] ? (i(), R(u(Dn), {
            key: 1,
            "aria-label": u(r)?.calendarIcon,
            class: "dp__input_icon dp__input_icons",
            onClick: ge[2] || (ge[2] = (K) => a("toggle"))
          }, null, 8, ["aria-label"])) : A("", !0)
        ]),
        U.$slots["clear-icon"] && (U.alwaysClearable || e.inputValue && U.clearable && !U.disabled && !U.readonly) ? (i(), g("span", q2, [
          L(U.$slots, "clear-icon", { clear: z })
        ])) : A("", !0),
        !U.$slots["clear-icon"] && (U.alwaysClearable || U.clearable && e.inputValue && !U.disabled && !U.readonly) ? (i(), g("button", {
          key: 3,
          "aria-label": u(r)?.clearInput,
          class: "dp--clear-btn",
          type: "button",
          onKeydown: ge[4] || (ge[4] = (K) => u(Vt)(K, () => z(K), !0, re)),
          onClick: ge[5] || (ge[5] = Fe((K) => z(K), ["prevent"]))
        }, [
          j(u(yc), {
            class: "dp__input_icons",
            "data-test-id": "clear-icon"
          })
        ], 40, Z2)) : A("", !0)
      ])) : A("", !0)
    ]));
  }
}), X2 = typeof window < "u" ? window : void 0, dl = () => {
}, Q2 = (e) => Hu() ? (Un(e), !0) : !1, J2 = (e, t, n, a) => {
  if (!e) return dl;
  let o = dl;
  const l = Se(
    () => u(e),
    (c) => {
      o(), c && (c.removeEventListener(t, n), c.addEventListener(t, n, a), o = () => {
        c.removeEventListener(t, n, a), o = dl;
      });
    },
    { immediate: !0, flush: "post" }
  ), r = () => {
    l(), o();
  };
  return Q2(r), r;
}, e5 = (e, t, n, a = {}) => {
  const { window: o = X2, event: l = "pointerdown" } = a;
  return o ? J2(o, l, (r) => {
    const c = St(e), s = St(t);
    !c || !s || c === r.target || r.composedPath().includes(c) || r.composedPath().includes(s) || n(r);
  }, { passive: !0 }) : void 0;
}, t5 = ["data-dp-mobile"], a5 = /* @__PURE__ */ Y({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...Ho
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date",
    "overlay-toggle",
    "text-input"
  ],
  setup(e, { expose: t, emit: n }) {
    const a = n, o = e, l = mt(), r = N(!1), c = Ze(o, "modelValue"), s = Ze(o, "timezone"), p = N(null), d = N(null), f = N(null), h = N(!1), $ = N(null), y = N(!1), w = N(!1), v = N(!1), x = N(!1), { setMenuFocused: b, setShiftKey: k } = Ac(), { clearArrowNav: _ } = Ya(), { validateDate: T, isValidTime: S } = ja(o), {
      defaultedTransitions: M,
      defaultedTextInput: E,
      defaultedInline: F,
      defaultedConfig: H,
      defaultedRange: te,
      defaultedMultiDates: ie
    } = ft(o), { menuTransition: ee, showTransition: O } = ao(M), { isMobile: z } = Vc(H), D = Nl();
    tt(() => {
      q(o.modelValue), Ye().then(() => {
        F.value.enabled || (K($.value)?.addEventListener("scroll", ce), window?.addEventListener("resize", Te));
      }), F.value.enabled && (r.value = !0), window?.addEventListener("keyup", $e), window?.addEventListener("keydown", Be);
    }), Fa(() => {
      F.value.enabled || (K($.value)?.removeEventListener("scroll", ce), window?.removeEventListener("resize", Te)), window?.removeEventListener("keyup", $e), window?.removeEventListener("keydown", Be);
    });
    const P = Wt(l, "all", o.presetDates), Z = Wt(l, "input");
    Se(
      [c, s],
      () => {
        q(c.value);
      },
      { deep: !0 }
    );
    const { openOnTop: J, menuStyle: re, xCorrect: U, setMenuPosition: ge, getScrollableParent: K, shadowRender: pe } = N2({
      menuRef: p,
      menuRefInner: d,
      inputRef: f,
      pickerWrapperRef: $,
      inline: F,
      emit: a,
      props: o,
      slots: l
    }), {
      inputValue: ae,
      internalModelValue: Ce,
      parseExternalModelValue: q,
      emitModelValue: I,
      formatInputValue: oe,
      checkBeforeEmit: be
    } = R3(a, o, { isInputFocused: h, isTextInputDate: x }), de = m(
      () => ({
        dp__main: !0,
        dp__theme_dark: o.dark,
        dp__theme_light: !o.dark,
        dp__flex_display: F.value.enabled,
        "dp--flex-display-collapsed": v.value,
        dp__flex_display_with_input: F.value.input
      })
    ), X = m(() => o.dark ? "dp__theme_dark" : "dp__theme_light"), ne = m(() => o.teleport ? {
      to: typeof o.teleport == "boolean" ? "body" : o.teleport,
      disabled: !o.teleport || F.value.enabled
    } : {}), ve = m(() => ({ class: "dp__outer_menu_wrap" })), V = m(() => F.value.enabled && (o.timePicker || o.monthPicker || o.yearPicker || o.quarterPicker)), xe = () => f.value?.$el?.getBoundingClientRect() ?? { width: 0, left: 0, right: 0 }, ce = () => {
      r.value && (H.value.closeOnScroll ? ot() : ge());
    }, Te = () => {
      r.value && ge();
      const _e = d.value?.$el.getBoundingClientRect().width ?? 0;
      v.value = document.body.offsetWidth <= _e;
    }, $e = (_e) => {
      _e.key === "Tab" && !F.value.enabled && !o.teleport && H.value.tabOutClosesMenu && ($.value.contains(document.activeElement) || ot()), w.value = _e.shiftKey;
    }, Be = (_e) => {
      w.value = _e.shiftKey;
    }, Ue = () => {
      !o.disabled && !o.readonly && (pe(D, As, o), ge(!1), r.value = !0, r.value && a("open"), r.value || xt(), q(o.modelValue));
    }, qe = () => {
      ae.value = "", xt(), d.value?.onValueCleared(), f.value?.setParsedDate(null), a("update:model-value", null), a("update:model-timezone-value", null), a("cleared"), H.value.closeOnClearValue && ot();
    }, Q = () => {
      const _e = Ce.value;
      return !_e || !Array.isArray(_e) && T(_e) ? !0 : Array.isArray(_e) ? ie.value.enabled || _e.length === 2 && T(_e[0]) && T(_e[1]) ? !0 : te.value.partialRange && !o.timePicker ? T(_e[0]) : !1 : !1;
    }, G = () => {
      be() && Q() ? (I(), ot()) : a("invalid-select", Ce.value);
    }, fe = (_e) => {
      ke(), I(), H.value.closeOnAutoApply && !_e && ot();
    }, ke = () => {
      f.value && E.value.enabled && f.value.setParsedDate(Ce.value);
    }, Re = (_e = !1) => {
      o.autoApply && S(Ce.value) && Q() && (te.value.enabled && Array.isArray(Ce.value) ? (te.value.partialRange || Ce.value.length === 2) && fe(_e) : fe(_e));
    }, xt = () => {
      E.value.enabled || (Ce.value = null);
    }, ot = (_e = !1) => {
      _e && Ce.value && H.value.setDateOnMenuClose && G(), F.value.enabled || (r.value && (r.value = !1, U.value = !1, b(!1), k(!1), _(), a("closed"), ae.value && q(c.value)), xt(), a("blur"), d.value?.$el?.remove());
    }, Lt = (_e, Ee, Ve = !1) => {
      if (!_e) {
        Ce.value = null;
        return;
      }
      const Zt = Array.isArray(_e) ? !_e.some((ga) => !T(ga)) : T(_e), ea = S(_e);
      Zt && ea ? (x.value = !0, Ce.value = _e, Ee ? (y.value = Ve, G(), a("text-submit")) : o.autoApply && Re(!0), Ye().then(() => {
        x.value = !1;
      })) : a("invalid-date", _e);
    }, Ft = () => {
      o.autoApply && S(Ce.value) && I(), ke();
    }, Ma = () => r.value ? ot() : Ue(), Da = (_e) => {
      Ce.value = _e;
    }, Ta = () => {
      E.value.enabled && (h.value = !0, oe()), a("focus");
    }, Wa = () => {
      E.value.enabled && (h.value = !1, q(o.modelValue), y.value && i3($.value, w.value)?.focus()), a("blur");
    }, Tn = (_e) => {
      d.value && d.value.updateMonthYear(0, {
        month: xs(_e.month),
        year: xs(_e.year)
      });
    }, Bn = (_e) => {
      q(_e ?? o.modelValue);
    }, ue = (_e, Ee) => {
      d.value?.switchView(_e, Ee);
    }, Me = (_e, Ee) => H.value.onClickOutside ? H.value.onClickOutside(_e, Ee) : ot(!0), Oe = (_e = 0) => {
      d.value?.handleFlow(_e);
    }, Ge = () => p;
    return e5(
      p,
      f,
      (_e) => Me(Q, _e)
    ), t({
      closeMenu: ot,
      selectDate: G,
      clearValue: qe,
      openMenu: Ue,
      onScroll: ce,
      formatInputValue: oe,
      // exposed for testing purposes
      updateInternalModelValue: Da,
      // modify internal modelValue
      setMonthYear: Tn,
      parseModel: Bn,
      switchView: ue,
      toggleMenu: Ma,
      handleFlow: Oe,
      getDpWrapMenuRef: Ge
    }), (_e, Ee) => (i(), g("div", {
      ref_key: "pickerWrapperRef",
      ref: $,
      class: W(de.value),
      "data-datepicker-instance": "",
      "data-dp-mobile": u(z)
    }, [
      j(G2, Ke({
        ref_key: "inputRef",
        ref: f,
        "input-value": u(ae),
        "onUpdate:inputValue": Ee[0] || (Ee[0] = (Ve) => xo(ae) ? ae.value = Ve : null),
        "is-menu-open": r.value
      }, _e.$props, {
        onClear: qe,
        onOpen: Ue,
        onSetInputDate: Lt,
        onSetEmptyDate: u(I),
        onSelectDate: G,
        onToggle: Ma,
        onClose: ot,
        onFocus: Ta,
        onBlur: Wa,
        onRealBlur: Ee[1] || (Ee[1] = (Ve) => h.value = !1),
        onTextInput: Ee[2] || (Ee[2] = (Ve) => _e.$emit("text-input", Ve))
      }), it({ _: 2 }, [
        De(u(Z), (Ve, Zt) => ({
          name: Ve,
          fn: B((ea) => [
            L(_e.$slots, Ve, Mt(Kt(ea)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      (i(), R(Pe(_e.teleport ? Eo : "div"), Mt(Kt(ne.value)), {
        default: B(() => [
          j(Ra, {
            name: u(ee)(u(J)),
            css: u(O) && !u(F).enabled
          }, {
            default: B(() => [
              r.value ? (i(), g("div", Ke({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: p
              }, ve.value, {
                class: { "dp--menu-wrapper": !u(F).enabled },
                style: u(F).enabled ? void 0 : u(re)
              }), [
                j(As, Ke({
                  ref_key: "dpMenuRef",
                  ref: d
                }, _e.$props, {
                  "internal-model-value": u(Ce),
                  "onUpdate:internalModelValue": Ee[3] || (Ee[3] = (Ve) => xo(Ce) ? Ce.value = Ve : null),
                  class: { [X.value]: !0, "dp--menu-wrapper": _e.teleport },
                  "open-on-top": u(J),
                  "no-overlay-focus": V.value,
                  collapse: v.value,
                  "get-input-rect": xe,
                  "is-text-input-date": x.value,
                  onClosePicker: ot,
                  onSelectDate: G,
                  onAutoApply: Re,
                  onTimeUpdate: Ft,
                  onFlowStep: Ee[4] || (Ee[4] = (Ve) => _e.$emit("flow-step", Ve)),
                  onUpdateMonthYear: Ee[5] || (Ee[5] = (Ve) => _e.$emit("update-month-year", Ve)),
                  onInvalidSelect: Ee[6] || (Ee[6] = (Ve) => _e.$emit("invalid-select", u(Ce))),
                  onAutoApplyInvalid: Ee[7] || (Ee[7] = (Ve) => _e.$emit("invalid-select", Ve)),
                  onInvalidFixedRange: Ee[8] || (Ee[8] = (Ve) => _e.$emit("invalid-fixed-range", Ve)),
                  onRecalculatePosition: u(ge),
                  onTooltipOpen: Ee[9] || (Ee[9] = (Ve) => _e.$emit("tooltip-open", Ve)),
                  onTooltipClose: Ee[10] || (Ee[10] = (Ve) => _e.$emit("tooltip-close", Ve)),
                  onTimePickerOpen: Ee[11] || (Ee[11] = (Ve) => _e.$emit("time-picker-open", Ve)),
                  onTimePickerClose: Ee[12] || (Ee[12] = (Ve) => _e.$emit("time-picker-close", Ve)),
                  onAmPmChange: Ee[13] || (Ee[13] = (Ve) => _e.$emit("am-pm-change", Ve)),
                  onRangeStart: Ee[14] || (Ee[14] = (Ve) => _e.$emit("range-start", Ve)),
                  onRangeEnd: Ee[15] || (Ee[15] = (Ve) => _e.$emit("range-end", Ve)),
                  onDateUpdate: Ee[16] || (Ee[16] = (Ve) => _e.$emit("date-update", Ve)),
                  onInvalidDate: Ee[17] || (Ee[17] = (Ve) => _e.$emit("invalid-date", Ve)),
                  onOverlayToggle: Ee[18] || (Ee[18] = (Ve) => _e.$emit("overlay-toggle", Ve)),
                  onMenuBlur: Ee[19] || (Ee[19] = (Ve) => _e.$emit("blur"))
                }), it({ _: 2 }, [
                  De(u(P), (Ve, Zt) => ({
                    name: Ve,
                    fn: B((ea) => [
                      L(_e.$slots, Ve, Mt(Kt({ ...ea })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "no-overlay-focus", "collapse", "is-text-input-date", "onRecalculatePosition"])
              ], 16)) : A("", !0)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16))
    ], 10, t5));
  }
}), Br = /* @__PURE__ */ (() => {
  const e = a5;
  return e.install = (t) => {
    t.component("Vue3DatePicker", e);
  }, e;
})(), n5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Br
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(n5).forEach(([e, t]) => {
  e !== "default" && (Br[e] = t);
});
const o5 = ze("hp-input", {
  variants: Qn,
  defaultVariants: Jn
}), l5 = { class: "hp-input__icon hp-input__icon--prefix" }, zo = /* @__PURE__ */ Y({
  __name: "InputPrefix",
  setup(e) {
    return (t, n) => (i(), g("span", l5, [
      L(t.$slots, "default")
    ]));
  }
}), r5 = {
  class: "hp-input__spinner",
  "aria-hidden": "true"
}, Pl = /* @__PURE__ */ Y({
  __name: "InputSpinner",
  setup(e) {
    return (t, n) => (i(), g("span", r5, [...n[0] || (n[0] = [
      C("svg", {
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        C("circle", {
          cx: "8",
          cy: "8",
          r: "6",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-opacity": "0.2"
        }),
        C("path", {
          d: "M14 8a6 6 0 0 0-6-6",
          stroke: "currentColor",
          "stroke-width": "2",
          "stroke-linecap": "round"
        })
      ], -1)
    ])]));
  }
}), s5 = { class: "hp-input__icon hp-input__icon--suffix" }, da = /* @__PURE__ */ Y({
  __name: "InputSuffix",
  setup(e) {
    return (t, n) => (i(), g("span", s5, [
      L(t.$slots, "default")
    ]));
  }
}), i5 = {
  key: 0,
  class: "hp-input-field"
}, c5 = ["data-theme"], u5 = ["type", "value", "placeholder", "disabled", "readonly", "aria-invalid", "aria-busy", "aria-describedby"], d5 = ["id"], p5 = ["data-theme"], f5 = ["type", "value", "placeholder", "disabled", "readonly", "aria-invalid", "aria-busy"], tn = /* @__PURE__ */ Y({
  inheritAttrs: !1,
  __name: "Input",
  props: /* @__PURE__ */ Xe({
    variant: { default: "filled" },
    size: { default: "3" },
    color: { default: void 0 },
    radius: { default: void 0 },
    placeholder: { default: void 0 },
    align: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    readOnly: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 },
    width: { default: void 0 },
    minWidth: { default: void 0 },
    maxWidth: { default: void 0 },
    class: { default: void 0 },
    prefix: { default: void 0 },
    suffix: { default: void 0 },
    type: { default: "text" },
    clearable: { type: Boolean, default: !1 },
    error: { default: void 0 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["focus", "blur", "change", "clear"], ["update:modelValue"]),
  setup(e, { expose: t, emit: n }) {
    const a = Le(), o = e, l = n, r = vt(e, "modelValue"), c = N(null), s = mt(), p = ha(), { cvaSizing: d, styleVars: f } = Xn(o), h = m(() => !!o.invalid || !!o.error), $ = m(
      () => o5({
        variant: o.variant,
        size: o.size,
        disabled: o.disabled,
        readOnly: o.readOnly,
        invalid: h.value,
        loading: o.loading,
        radius: o.radius,
        align: o.align,
        width: d.value.width,
        minWidth: d.value.minWidth,
        maxWidth: d.value.maxWidth,
        class: o.class
      })
    ), y = m(() => f.value), w = m(() => !!o.prefix || !!s.prefix), v = m(() => !!o.suffix || !!s.suffix), x = m(() => r.value != null && String(r.value).length > 0), b = m(() => o.clearable === !0 && x.value && !o.loading), k = (T) => {
      r.value = T.target.value;
    }, _ = () => {
      r.value = "", l("clear");
    };
    return t({
      inputRef: c,
      focus: () => c.value?.focus(),
      blur: () => c.value?.blur(),
      select: () => c.value?.select()
    }), (T, S) => e.error ? (i(), g("div", i5, [
      C("div", {
        class: W($.value),
        style: Ie(y.value),
        "data-theme": e.color
      }, [
        w.value ? (i(), R(zo, { key: 0 }, {
          default: B(() => [
            L(T.$slots, "prefix", {}, () => [
              e.prefix ? (i(), R(Pe(e.prefix), { key: 0 })) : A("", !0)
            ])
          ]),
          _: 3
        })) : A("", !0),
        C("input", Ke({
          ref_key: "inputRef",
          ref: c,
          class: "hp-input__field",
          type: e.type,
          value: r.value,
          placeholder: e.placeholder,
          disabled: e.disabled || e.loading,
          readonly: e.readOnly,
          "aria-invalid": h.value || void 0,
          "aria-busy": e.loading || void 0,
          "aria-describedby": u(p)
        }, T.$attrs, {
          onInput: k,
          onChange: S[0] || (S[0] = (M) => l("change", M)),
          onFocus: S[1] || (S[1] = (M) => l("focus", M)),
          onBlur: S[2] || (S[2] = (M) => l("blur", M))
        }), null, 16, u5),
        e.loading ? (i(), R(da, { key: 1 }, {
          default: B(() => [
            j(Pl)
          ]),
          _: 1
        })) : (i(), g(he, { key: 2 }, [
          b.value ? (i(), R(da, { key: 0 }, {
            default: B(() => [
              j(Rt, {
                variant: "soft",
                size: "1",
                square: "",
                icon: zt,
                class: "hp-input__clear",
                "aria-label": u(a)("ui.common.clear", "Clear"),
                onClick: Fe(_, ["stop"])
              }, null, 8, ["aria-label"])
            ]),
            _: 1
          })) : A("", !0),
          v.value ? (i(), R(da, { key: 1 }, {
            default: B(() => [
              L(T.$slots, "suffix", {}, () => [
                e.suffix ? (i(), R(Pe(e.suffix), { key: 0 })) : A("", !0)
              ])
            ]),
            _: 3
          })) : A("", !0)
        ], 64))
      ], 14, c5),
      C("span", {
        id: u(p),
        class: "hp-input-field__error",
        role: "alert"
      }, le(e.error), 9, d5)
    ])) : (i(), g("div", {
      key: 1,
      class: W($.value),
      style: Ie(y.value),
      "data-theme": e.color
    }, [
      w.value ? (i(), R(zo, { key: 0 }, {
        default: B(() => [
          L(T.$slots, "prefix", {}, () => [
            e.prefix ? (i(), R(Pe(e.prefix), { key: 0 })) : A("", !0)
          ])
        ]),
        _: 3
      })) : A("", !0),
      C("input", Ke({
        ref_key: "inputRef",
        ref: c,
        class: "hp-input__field",
        type: e.type,
        value: r.value,
        placeholder: e.placeholder,
        disabled: e.disabled || e.loading,
        readonly: e.readOnly,
        "aria-invalid": h.value || void 0,
        "aria-busy": e.loading || void 0
      }, T.$attrs, {
        onInput: k,
        onChange: S[3] || (S[3] = (M) => l("change", M)),
        onFocus: S[4] || (S[4] = (M) => l("focus", M)),
        onBlur: S[5] || (S[5] = (M) => l("blur", M))
      }), null, 16, f5),
      e.loading ? (i(), R(da, { key: 1 }, {
        default: B(() => [
          j(Pl)
        ]),
        _: 1
      })) : (i(), g(he, { key: 2 }, [
        b.value ? (i(), R(da, { key: 0 }, {
          default: B(() => [
            j(Rt, {
              variant: "soft",
              size: "1",
              square: "",
              icon: zt,
              class: "hp-input__clear",
              "aria-label": u(a)("ui.common.clear", "Clear"),
              onClick: Fe(_, ["stop"])
            }, null, 8, ["aria-label"])
          ]),
          _: 1
        })) : A("", !0),
        v.value ? (i(), R(da, { key: 1 }, {
          default: B(() => [
            L(T.$slots, "suffix", {}, () => [
              e.suffix ? (i(), R(Pe(e.suffix), { key: 0 })) : A("", !0)
            ])
          ]),
          _: 3
        })) : A("", !0)
      ], 64))
    ], 14, p5));
  }
}), h5 = { class: "hp-datepicker__action-row" }, v5 = { class: "hp-datepicker__action-preview" }, m5 = { class: "hp-datepicker__action-buttons" }, BM = /* @__PURE__ */ Y({
  inheritAttrs: !1,
  __name: "DatePicker",
  props: /* @__PURE__ */ Xe({
    variant: { default: "filled" },
    size: { default: "3" },
    color: {},
    radius: { default: void 0 },
    placeholder: { default: void 0 },
    align: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean },
    readOnly: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 },
    width: { default: void 0 },
    minWidth: { default: void 0 },
    maxWidth: { default: void 0 },
    class: { default: void 0 },
    prefix: { default: void 0 },
    suffix: { default: void 0 },
    modelValue: {},
    mode: { default: "single" },
    enableTimePicker: { type: Boolean, default: !1 },
    timePicker: { type: Boolean, default: !1 },
    format: { default: void 0 },
    presets: {},
    showPresets: { type: Boolean, default: !0 },
    minDate: { default: void 0 },
    maxDate: { default: void 0 },
    position: { default: "center" },
    offset: { default: void 0 },
    inline: { type: Boolean, default: !1 },
    clearable: { type: Boolean, default: !1 },
    teleport: { type: [Boolean, String], default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["focus", "blur", "update:modelValue", "range-start"], ["update:modelValue"]),
  setup(e, { expose: t, emit: n }) {
    const a = Le(), o = e, l = n, r = vt(e, "modelValue"), c = N(null), s = { menu: "hp-ui-boundary" }, p = m(() => o.placeholder ?? a("ui.datePicker.selectDate", "Select date")), d = m(() => o.format ? o.format : o.timePicker ? "HH:mm" : o.enableTimePicker ? "dd/MM/yyyy HH:mm" : "dd/MM/yyyy"), f = m(() => {
      const M = /* @__PURE__ */ new Date(), E = new Date(M.getFullYear(), M.getMonth(), M.getDate());
      return [
        {
          label: a("ui.datePicker.nextDay", "Next day"),
          value: [E, new Date(E.getTime() + 1440 * 60 * 1e3)]
        },
        {
          label: a("ui.datePicker.next7Days", "Next 7 days"),
          value: [E, new Date(E.getTime() + 10080 * 60 * 1e3)]
        },
        {
          label: a("ui.datePicker.next30Days", "Next 30 days"),
          value: [E, new Date(E.getTime() + 720 * 60 * 60 * 1e3)]
        },
        {
          label: a("ui.datePicker.nextYear", "Next year"),
          value: [E, new Date(E.getFullYear() + 1, E.getMonth(), E.getDate())]
        }
      ];
    }), h = m(() => !o.showPresets || o.mode !== "range" ? [] : (o.presets || f.value).map((E) => ({
      label: E.label,
      value: E.value
    }))), $ = m(() => typeof o.offset == "number" || o.offset === void 0 ? o.offset : o.offset.left ?? o.offset.top ?? 0), y = m(() => o.teleport === !0 ? "body" : o.teleport), w = ze("hp-datepicker", {
      variants: {
        disabled: {
          true: "hp-datepicker--disabled"
        }
      }
    }), v = m(
      () => w({
        disabled: o.disabled,
        class: o.class
      })
    ), x = (M) => {
      if (!M)
        return "";
      const E = d.value;
      return Array.isArray(M) ? M.filter(Boolean).map((F) => yt(F, E)).join(" - ") : yt(M, E);
    }, b = (M) => {
      if (!M)
        return "";
      const E = d.value;
      return Array.isArray(M) ? M.filter(Boolean).map((F) => F instanceof Date ? yt(F, E) : String(F)).join(" - ") : M instanceof Date ? yt(M, E) : String(M);
    }, k = () => r.value ? x(r.value) : "", _ = (M) => {
      l("update:modelValue", M);
    }, T = (M) => {
      l("range-start", M);
    }, S = (M) => {
      if (!M)
        return { top: "0px", left: "0px" };
      const E = 350, F = 420, H = M.getBoundingClientRect(), te = 5, ie = window.innerHeight - H.bottom, ee = H.top, O = ie < E && ee > ie, z = O ? H.top - 8 : H.bottom + 8, D = H.left + H.width / 2, P = H.right;
      let Z = D - F / 2;
      return Z + F > window.innerWidth - te && (Z = window.innerWidth - F - te), Z < te && (Z = te), Z + F > window.innerWidth && (Z = P - F), {
        top: `${z}px`,
        left: `${Z}px`,
        ...O && { transform: "translateY(-100%)" }
      };
    };
    return t({
      datepickerRef: c,
      openMenu: () => c.value?.openMenu?.(),
      closeMenu: () => c.value?.closeMenu?.()
    }), (M, E) => (i(), g("div", {
      class: W(v.value)
    }, [
      j(u(Br), {
        ref_key: "datepickerRef",
        ref: c,
        modelValue: r.value,
        "onUpdate:modelValue": [
          E[0] || (E[0] = (F) => r.value = F),
          _
        ],
        range: e.mode === "range",
        "enable-time-picker": e.enableTimePicker,
        "time-picker": e.timePicker,
        format: x,
        "preview-format": x,
        placeholder: p.value,
        disabled: e.disabled,
        "min-date": e.minDate,
        "max-date": e.maxDate,
        "preset-dates": h.value,
        "auto-apply": !e.showPresets,
        teleport: y.value,
        "alt-position": y.value ? S : void 0,
        "no-input-clear": !e.clearable,
        "arrow-navigation": !0,
        "close-on-scroll": !1,
        "six-weeks": "fair",
        position: e.position,
        offset: $.value,
        inline: e.inline,
        ui: s,
        onRangeStart: T,
        onBlur: E[1] || (E[1] = (F) => l("blur", F))
      }, it({
        "arrow-left": B(() => [
          j(en, { class: "hp-datepicker__nav-arrow hp-datepicker__nav-arrow--left" })
        ]),
        "arrow-right": B(() => [
          j(en, { class: "hp-datepicker__nav-arrow hp-datepicker__nav-arrow--right" })
        ]),
        "action-row": B(({ selectDate: F, closePicker: H }) => [
          C("div", h5, [
            C("div", v5, le(k()), 1),
            C("div", m5, [
              j(u(Ae), {
                variant: "outline",
                size: "3",
                onClick: H
              }, {
                default: B(() => [
                  me(le(u(a)("ui.common.cancel", "Cancel")), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              j(u(Ae), {
                variant: "filled",
                size: "3",
                onClick: F
              }, {
                default: B(() => [
                  me(le(u(a)("ui.datePicker.select", "Select")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        _: 2
      }, [
        e.inline ? void 0 : {
          name: "dp-input",
          fn: B(({ value: F }) => [
            j(u(tn), {
              "model-value": b(F),
              variant: e.variant,
              size: e.size,
              disabled: e.disabled,
              "read-only": !0,
              clearable: !1,
              placeholder: p.value,
              prefix: e.prefix,
              invalid: e.invalid,
              width: e.width,
              "min-width": e.minWidth,
              "max-width": e.maxWidth,
              radius: e.radius,
              align: e.align,
              class: "hp-datepicker__input"
            }, it({
              prefix: B(() => [
                L(M.$slots, "prefix", {}, () => [
                  e.prefix ? (i(), R(Pe(e.prefix), { key: 0 })) : (i(), R(ur, { key: 1 }))
                ])
              ]),
              _: 2
            }, [
              M.$slots.suffix || e.suffix ? {
                name: "suffix",
                fn: B(() => [
                  L(M.$slots, "suffix")
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["model-value", "variant", "size", "disabled", "placeholder", "prefix", "invalid", "width", "min-width", "max-width", "radius", "align"])
          ]),
          key: "0"
        }
      ]), 1032, ["modelValue", "range", "enable-time-picker", "time-picker", "placeholder", "disabled", "min-date", "max-date", "preset-dates", "auto-apply", "teleport", "alt-position", "no-input-clear", "position", "offset", "inline"])
    ], 2));
  }
}), Hc = /* @__PURE__ */ Symbol("DialogContext"), oo = () => {
  const e = pt(Hc);
  if (!e)
    throw new Error("Dialog compound components must be used within <Dialog>");
  return e;
}, Nc = (e, t) => t.isGuarded ? !1 : t.escapeEmitsCancel, an = Fu([]), Fc = (e) => {
  Ca(e), an.push(e);
}, Ca = (e) => {
  const t = an.lastIndexOf(e);
  t !== -1 && an.splice(t, 1);
}, mn = (e) => e ? an[an.length - 1] === e : !1, g5 = () => an[an.length - 1], Ls = "hp-dialog-scroll-locked";
let pl = 0;
const Kc = () => {
  let e = !1;
  const t = () => {
    e || (e = !0, pl++, document.body.classList.add(Ls));
  }, n = () => {
    e && (e = !1, pl--, pl === 0 && document.body.classList.remove(Ls));
  };
  return Un(() => {
    n();
  }), { lock: t, unlock: n };
}, y5 = ["id", "data-theme", "aria-labelledby", "aria-describedby"], w5 = { class: "hp-dialog__container" }, b5 = { class: "hp-dialog-header" }, k5 = { class: "hp-dialog-body hp-dialog-body--padded" }, _5 = { class: "hp-dialog-footer" }, Yc = /* @__PURE__ */ Y({
  inheritAttrs: !1,
  __name: "Dialog",
  props: /* @__PURE__ */ Xe({
    id: { default: void 0 },
    variant: { default: "surface" },
    size: { default: "2" },
    color: { default: void 0 },
    confirmColor: { default: void 0 },
    title: {},
    description: {},
    cancelText: { default: void 0 },
    confirmText: { default: void 0 },
    showClose: { type: Boolean, default: !0 },
    closeOnBackdrop: { type: Boolean, default: !1 },
    closeOnEscape: { type: Boolean, default: !0 },
    shadow: { type: Boolean, default: !0 },
    showBackdrop: { type: Boolean, default: !0 },
    class: { default: void 0 },
    bodyClass: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    confirmClose: { type: Boolean, default: !1 },
    expandable: { type: Boolean, default: !1 },
    escapeEmitsCancel: { type: Boolean, default: !0 }
  }, {
    expanded: { type: Boolean, default: !1 },
    expandedModifiers: {},
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["cancel", "confirm", "close"], ["update:expanded", "update:open"]),
  setup(e, { expose: t, emit: n }) {
    const a = Le(), o = e, l = vt(e, "expanded"), r = ze("hp-ui-boundary hp-dialog", {
      variants: {
        variant: {
          filled: "hp-dialog--filled",
          surface: "hp-dialog--surface"
        },
        size: {
          1: "hp-dialog--size-1",
          2: "hp-dialog--size-2",
          3: "hp-dialog--size-3",
          4: "hp-dialog--size-4",
          5: "hp-dialog--size-5",
          6: "hp-dialog--size-6",
          7: "hp-dialog--size-7",
          8: "hp-dialog--size-8"
        },
        shadow: {
          true: "hp-dialog--shadow",
          false: ""
        },
        showBackdrop: {
          true: "",
          false: "hp-dialog--no-backdrop"
        }
      },
      defaultVariants: {
        variant: "surface",
        size: "2",
        shadow: !0,
        showBackdrop: !0
      }
    }), c = m(() => {
      const P = r({
        variant: o.variant,
        size: o.size,
        shadow: o.shadow,
        showBackdrop: o.showBackdrop,
        class: o.class
      });
      return l.value ? `${P} hp-dialog--expanded` : P;
    }), s = m(() => o.loading || o.confirmClose), p = vt(e, "open"), d = N(!1), f = n, h = N(), $ = N(null), y = N(), w = N(!1), v = m(() => mn(h.value));
    Zl(p), Gl($, p, v);
    const x = ha(), b = ha(), { lock: k, unlock: _ } = Kc(), T = (P) => {
      P && (P.open || P.showModal(), Fc(P));
    }, S = (P) => {
      P && (Ca(P), P.open && P.close());
    }, M = () => {
      T(y.value);
    }, E = () => {
      S(y.value);
    }, F = () => {
      S(y.value), d.value = !0, l.value = !1, p.value = !1, f("close"), Ye(() => {
        d.value = !1;
      });
    }, H = () => {
      if (s.value) {
        M();
        return;
      }
      l.value = !1, p.value = !1, f("close");
    };
    Dt(Hc, { titleId: x, descriptionId: b, close: H, closeImmediately: F, expanded: l }), Se(
      p,
      async (P, Z) => {
        if (Z && !P && s.value && !d.value) {
          p.value = !0, M();
          return;
        }
        await Ye(), P ? (T(h.value), k()) : (S(h.value), l.value = !1, _());
      },
      { immediate: !0 }
    ), Se(s, (P) => {
      P || E();
    });
    const te = () => {
      f("cancel"), F();
    }, ie = () => {
      h.value && Ca(h.value), p.value && (p.value = !1, f("close"));
    }, ee = (P) => {
      if (!mn(h.value)) {
        P.preventDefault();
        return;
      }
      P.preventDefault(), o.closeOnEscape && (Nc("escape", {
        escapeEmitsCancel: o.escapeEmitsCancel,
        isGuarded: s.value
      }) && f("cancel"), H());
    }, O = (P) => {
      w.value = P.target === h.value;
    }, z = (P) => {
      if (!mn(h.value)) {
        w.value = !1;
        return;
      }
      o.closeOnBackdrop && (P.target === h.value && w.value && H(), w.value = !1);
    }, D = (P) => {
      P.preventDefault(), E();
    };
    return t({
      dialogRef: h,
      open: () => {
        p.value = !0;
      },
      close: H,
      closeImmediately: F
    }), ct(() => {
      h.value && Ca(h.value), y.value && Ca(y.value);
    }), (P, Z) => (i(), R(Eo, { to: "body" }, [
      C("dialog", {
        ref_key: "dialogRef",
        ref: h,
        id: e.id,
        class: W(c.value),
        "data-theme": e.color,
        "aria-labelledby": u(x),
        "aria-describedby": u(b),
        onClose: ie,
        onCancel: ee,
        onMousedown: O,
        onClick: z
      }, [
        C("div", {
          ref_key: "containerRef",
          ref: $,
          class: "hp-dialog__container",
          tabindex: "-1",
          onClick: Z[0] || (Z[0] = Fe(() => {
          }, ["stop"]))
        }, [
          L(P.$slots, "default")
        ], 512)
      ], 42, y5),
      C("dialog", {
        ref_key: "confirmDialogRef",
        ref: y,
        class: "hp-ui-boundary hp-dialog hp-dialog--surface hp-dialog--size-1 hp-dialog--shadow",
        onCancel: D
      }, [
        C("div", w5, [
          C("header", b5, [
            j(u($n), {
              size: "6",
              weight: "semibold",
              as: "h2",
              class: "hp-dialog-title"
            }, {
              default: B(() => [
                me(le(u(a)("ui.dialog.unsavedChanges", "Unsaved changes")), 1)
              ]),
              _: 1
            })
          ]),
          C("div", k5, le(u(a)("ui.dialog.yourChangesWillBeLostIfYouLeave", "Your changes will be lost if you leave.")), 1),
          C("footer", _5, [
            j(u(Ae), {
              variant: "outline",
              onClick: te
            }, {
              default: B(() => [
                me(le(u(a)("ui.dialog.leaveWithoutSaving", "Leave without saving")), 1)
              ]),
              _: 1
            }),
            j(u(Ae), {
              variant: "filled",
              onClick: E
            }, {
              default: B(() => [
                me(le(u(a)("ui.dialog.stay", "Stay")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 544)
    ]));
  }
}), C5 = /* @__PURE__ */ Y({
  __name: "DialogBody",
  props: {
    padded: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (i(), g("div", {
      class: W(["hp-dialog-body", { "hp-dialog-body--padded": e.padded }]),
      tabindex: "-1"
    }, [
      L(t.$slots, "default")
    ], 2));
  }
}), x5 = /* @__PURE__ */ Y({
  __name: "DialogClose",
  setup(e) {
    const t = Le(), n = oo();
    return (a, o) => (i(), R(u(Ae), {
      variant: "soft",
      size: "1",
      square: "",
      icon: zt,
      class: "hp-dialog-close",
      "aria-label": u(t)("ui.dialog.closeDialog", "Close dialog"),
      onClick: o[0] || (o[0] = (l) => u(n).close())
    }, null, 8, ["aria-label"]));
  }
}), $5 = {}, S5 = { class: "hp-dialog-header__controls" };
function M5(e, t) {
  return i(), g("div", S5, [
    L(e.$slots, "default")
  ]);
}
const D5 = /* @__PURE__ */ se($5, [["render", M5]]), T5 = /* @__PURE__ */ Y({
  __name: "DialogDescription",
  setup(e) {
    const t = oo();
    return (n, a) => (i(), R(u(at), {
      id: u(t).descriptionId,
      size: "2",
      variant: "soft",
      as: "p",
      class: "hp-dialog-description"
    }, {
      default: B(() => [
        L(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["id"]));
  }
}), B5 = {}, z5 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function A5(e, t) {
  return i(), g("svg", z5, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M11.6667 8.33333L17.5 2.5M11.6667 3.33333V8.33333L16.6667 8.33333",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M2.5 17.5L8.33333 11.6667M8.33333 16.6667L8.33333 11.6667H3.33333",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const L5 = /* @__PURE__ */ se(B5, [["render", A5]]), E5 = {}, I5 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function R5(e, t) {
  return i(), g("svg", I5, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M16 4L4 16M12 4.00001L16 4V8.00001M8 16L4 16L4 12",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const P5 = /* @__PURE__ */ se(E5, [["render", R5]]), O5 = /* @__PURE__ */ Y({
  __name: "DialogExpand",
  setup(e) {
    const t = Le(), n = oo();
    return (a, o) => (i(), R(u(Ae), {
      variant: "soft",
      size: "1",
      square: "",
      icon: u(n).expanded.value ? L5 : P5,
      class: "hp-dialog-expand",
      "aria-label": u(n).expanded.value ? u(t)("ui.dialog.exitFullscreen", "Exit fullscreen") : u(t)("ui.dialog.fullscreen", "Fullscreen"),
      onClick: o[0] || (o[0] = (l) => u(n).expanded.value = !u(n).expanded.value)
    }, null, 8, ["icon", "aria-label"]));
  }
}), V5 = {}, H5 = { class: "hp-dialog-footer" };
function N5(e, t) {
  return i(), g("div", H5, [
    L(e.$slots, "default")
  ]);
}
const F5 = /* @__PURE__ */ se(V5, [["render", N5]]), zM = /* @__PURE__ */ Y({
  __name: "DialogFooterActions",
  props: {
    align: { default: "space-between" }
  },
  setup(e) {
    const t = e, n = m(() => `hp-dialog-footer-actions--${t.align}`);
    return (a, o) => (i(), g("div", {
      class: W(["hp-dialog-footer-actions", n.value])
    }, [
      L(a.$slots, "default")
    ], 2));
  }
}), K5 = {}, Y5 = { class: "hp-dialog-footer-info" };
function j5(e, t) {
  return i(), g("div", Y5, [
    L(e.$slots, "default")
  ]);
}
const AM = /* @__PURE__ */ se(K5, [["render", j5]]), W5 = {}, U5 = { class: "hp-dialog-header" };
function q5(e, t) {
  return i(), g("div", U5, [
    L(e.$slots, "default")
  ]);
}
const Z5 = /* @__PURE__ */ se(W5, [["render", q5]]), G5 = /* @__PURE__ */ Y({
  __name: "DialogLoader",
  props: {
    loading: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (t, n) => (i(), R(u(Mn), { loading: e.loading }, null, 8, ["loading"]));
  }
}), X5 = ["aria-label"], Q5 = 240, J5 = 4, e6 = 320, t6 = 0, a6 = /* @__PURE__ */ Y({
  __name: "DialogResizeHandle",
  props: {
    minSize: { default: "1" },
    minHeight: { default: Q5 },
    initialHeight: {}
  },
  setup(e) {
    const t = Le(), n = e, a = oo(), o = N(), l = (y, w, v) => Math.min(Math.max(y, w), v), r = () => o.value?.closest("dialog") ?? null, c = (y) => {
      y.style.width = "", y.style.height = "", y.style.maxWidth = "", y.style.maxHeight = "";
    }, s = (y) => {
      const w = y.querySelector(".hp-dialog__container");
      w && (w.style.height = "100%");
    }, p = (y) => {
      const w = getComputedStyle(y).getPropertyValue(`--dialog-size-${n.minSize}`).trim();
      return Number.parseFloat(w) || e6;
    }, d = (y) => {
      const w = getComputedStyle(y).getPropertyValue("--dialog-viewport-gap").trim();
      return Number.parseFloat(w) || J5;
    };
    tt(() => {
      if (n.initialHeight === void 0)
        return;
      const y = r();
      if (!y)
        return;
      const w = d(y), v = window.innerHeight - w * 2, x = l(n.initialHeight, Math.min(n.minHeight, v), v);
      y.style.height = `${x}px`, s(y);
    });
    let f = null;
    const h = (y) => {
      if (y.button !== t6)
        return;
      const w = r();
      if (!w)
        return;
      s(w);
      const v = w.getBoundingClientRect(), x = y.clientX, b = y.clientY, k = v.width, _ = v.height, T = p(w), S = d(w), M = (H) => {
        const te = window.innerWidth - S * 2, ie = window.innerHeight - S * 2, ee = l(k + (H.clientX - x) * 2, Math.min(T, te), te), O = l(_ + (H.clientY - b) * 2, Math.min(n.minHeight, ie), ie);
        w.style.width = `${ee}px`, w.style.maxWidth = `${ee}px`, w.style.height = `${O}px`, w.style.maxHeight = `${O}px`;
      }, E = y.currentTarget, F = () => {
        E.removeEventListener("pointermove", M), E.removeEventListener("pointerup", F), E.removeEventListener("pointercancel", F), f = null;
      };
      f = F, E.setPointerCapture(y.pointerId), E.addEventListener("pointermove", M), E.addEventListener("pointerup", F), E.addEventListener("pointercancel", F), y.preventDefault();
    };
    ct(() => f?.());
    let $ = null;
    return Se(
      () => a.expanded.value,
      (y) => {
        const w = r();
        w && (y ? ($ ??= {
          width: w.style.width,
          height: w.style.height,
          maxWidth: w.style.maxWidth,
          maxHeight: w.style.maxHeight
        }, c(w)) : $ && (Object.assign(w.style, $), $ = null));
      }
    ), (y, w) => (i(), g("span", {
      ref_key: "handleRef",
      ref: o,
      class: "hp-dialog-resize-handle",
      role: "separator",
      "aria-label": u(t)("ui.dialog.resizeDialog", "Resize dialog"),
      onPointerdown: h
    }, null, 40, X5));
  }
}), n6 = /* @__PURE__ */ Y({
  __name: "DialogTitle",
  setup(e) {
    const t = oo();
    return (n, a) => (i(), R(u($n), {
      id: u(t).titleId,
      size: "6",
      weight: "semibold",
      as: "h2",
      class: "hp-dialog-title"
    }, {
      default: B(() => [
        L(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["id"]));
  }
});
class Ol extends Error {
  constructor(t = "BailOut") {
    super(t), this.name = "BailOutError";
  }
}
const o6 = 5e3, Es = 5, jc = /* @__PURE__ */ Symbol("toastContext"), l6 = () => `toast-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`, LM = (e = o6, t = Es) => {
  const n = Number.isFinite(t) && t > 0 ? Math.floor(t) : Es, a = Na({
    toasts: []
  }), o = (s, p, d, f = e) => {
    const h = l6(), $ = {
      id: h,
      type: s,
      title: p,
      description: d,
      duration: f,
      createdAt: Date.now()
    };
    return a.toasts.push($), a.toasts.length > n && a.toasts.splice(0, a.toasts.length - n), h;
  };
  return { state: a, context: {
    error: (s, p) => o("error", s, p),
    success: (s, p) => o("success", s, p),
    warning: (s, p) => o("warning", s, p),
    info: (s, p) => o("info", s, p),
    remove: (s) => {
      const p = a.toasts.findIndex((d) => d.id === s);
      p !== -1 && a.toasts.splice(p, 1);
    },
    clear: () => {
      a.toasts.splice(0, a.toasts.length);
    }
  } };
}, EM = (e) => {
  Dt(jc, e);
}, r6 = () => {
  const e = pt(jc);
  if (!e)
    throw new Error("useToast must be used within a component tree that has ToastContainer");
  return e;
}, Wc = /* @__PURE__ */ Symbol("dialogContext"), s6 = () => {
  let e = 0;
  const t = Na({
    stack: []
  });
  return { state: t, open: (r) => new Promise((c) => {
    t.stack.push({
      ...r,
      actions: r.actions ?? [],
      id: e++,
      expandable: r.expandable ?? !1,
      expanded: !1,
      resizable: r.resizable ?? !1,
      loading: !1,
      loadingActionIndex: null,
      confirmClose: !1,
      _resolve: c,
      _resolved: !1
    });
  }), resolve: (r, c) => {
    const s = t.stack.findIndex((d) => d.id === r);
    if (s === -1)
      return;
    const p = t.stack[s];
    p._resolved || (p._resolved = !0, p._resolve(c)), t.stack.splice(s, 1);
  }, updateItem: (r, c, s) => {
    const p = t.stack.find((d) => d.id === r);
    p && (p[c] = s);
  }, setActionLoading: (r, c) => {
    const s = t.stack.find((p) => p.id === r);
    s && (s.loadingActionIndex = c);
  } };
}, i6 = (e) => {
  Dt(Wc, e);
}, Yo = () => {
  const e = pt(Wc);
  if (!e)
    throw new Error("useDialog must be used within a component tree that has DialogProvider");
  return e;
}, c6 = (e) => {
  const t = Le();
  return async (n) => {
    const { confirmText: a, cancelText: o, confirmColor: l, ...r } = n;
    return await e({
      bodyPadded: !0,
      ...r,
      actions: [
        { text: o ?? t("ui.common.cancel", "Cancel"), variant: "outline", action: !1 },
        {
          text: a ?? t("ui.dialog.confirm", "Confirm"),
          color: l,
          variant: "filled",
          action: !0
        }
      ]
    }) ?? !1;
  };
}, IM = () => c6(Yo()), RM = /* @__PURE__ */ Y({
  __name: "DialogProvider",
  setup(e) {
    const { state: t, open: n, resolve: a, updateItem: o, setActionLoading: l } = s6(), r = Le(), c = r6();
    i6(n);
    const s = (v) => {
      const x = v.bodyProps?.isLoading;
      return x != null ? !!Ne(x) : !1;
    }, p = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Map(), f = (v, x) => {
      if (x) {
        p.set(v, x);
        return;
      }
      p.delete(v);
    }, h = (v, x, b = !1) => {
      d.set(v, x);
      const k = p.get(v);
      if (!k) {
        a(v, x);
        return;
      }
      b ? k.closeImmediately() : k.close();
    }, $ = (v, x) => {
      h(v, x, x !== null);
    }, y = async (v, x, b) => {
      if (b.onAction) {
        l(v, x);
        try {
          await b.onAction(), h(v, b.action, !0);
        } catch (k) {
          k instanceof Ol || c.warning(
            r("ui.dialog.saveFailedTitle", "Could not save"),
            r("ui.dialog.saveFailedBody", "Check for warnings or errors and try again.")
          );
        } finally {
          l(v, null);
        }
      } else
        h(v, b.action, !0);
    }, w = (v) => {
      const x = d.has(v) ? d.get(v) : null;
      d.delete(v), p.delete(v), a(v, x);
    };
    return (v, x) => (i(), g(he, null, [
      L(v.$slots, "default"),
      (i(!0), g(he, null, De(u(t).stack, (b) => (i(), R(Yc, {
        key: b.id,
        ref_for: !0,
        ref: (k) => f(b.id, k),
        open: !0,
        size: b.size ?? "2",
        expandable: b.expandable,
        expanded: b.expanded,
        "onUpdate:expanded": (k) => b.expanded = k,
        loading: b.loading,
        "confirm-close": b.confirmClose,
        onClose: (k) => w(b.id)
      }, {
        default: B(() => [
          b.title || b.description && b.body || b.expandable ? (i(), R(Z5, { key: 0 }, {
            default: B(() => [
              b.title ? (i(), R(n6, { key: 0 }, {
                default: B(() => [
                  me(le(b.title), 1)
                ]),
                _: 2
              }, 1024)) : A("", !0),
              b.description && b.body ? (i(), R(T5, { key: 1 }, {
                default: B(() => [
                  me(le(b.description), 1)
                ]),
                _: 2
              }, 1024)) : A("", !0),
              j(D5, null, {
                default: B(() => [
                  b.expandable ? (i(), R(O5, { key: 0 })) : A("", !0),
                  j(x5)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)) : A("", !0),
          j(G5, {
            loading: s(b)
          }, null, 8, ["loading"]),
          j(C5, {
            padded: b.bodyPadded
          }, {
            default: B(() => [
              b.body ? (i(), R(Pe(b.body), Ke({
                key: 0,
                ref_for: !0
              }, b.bodyProps, {
                onResolve: (k) => $(b.id, k),
                "onUpdate:loading": (k) => u(o)(b.id, "loading", k),
                "onUpdate:confirmClose": (k) => u(o)(b.id, "confirmClose", k)
              }), null, 16, ["onResolve", "onUpdate:loading", "onUpdate:confirmClose"])) : b.description ? (i(), g(he, { key: 1 }, [
                me(le(b.description), 1)
              ], 64)) : A("", !0)
            ]),
            _: 2
          }, 1032, ["padded"]),
          b.footer || b.actions.length > 0 ? (i(), R(F5, { key: 1 }, {
            default: B(() => [
              b.footer ? (i(), R(Pe(b.footer), Ke({
                key: 0,
                ref_for: !0
              }, b.footerProps, {
                onResolve: (k) => $(b.id, k)
              }), null, 16, ["onResolve"])) : (i(!0), g(he, { key: 1 }, De(b.actions, (k, _) => (i(), R(Ae, {
                key: _,
                variant: k.variant ?? (_ === b.actions.length - 1 ? "filled" : "outline"),
                color: k.color,
                loading: b.loadingActionIndex === _,
                disabled: b.loadingActionIndex !== null && b.loadingActionIndex !== _,
                size: "3",
                onClick: (T) => y(b.id, _, k)
              }, {
                default: B(() => [
                  me(le(k.text), 1)
                ]),
                _: 2
              }, 1032, ["variant", "color", "loading", "disabled", "onClick"]))), 128))
            ]),
            _: 2
          }, 1024)) : A("", !0),
          b.resizable ? (i(), R(a6, {
            key: 2,
            "min-size": b.minResizeSize,
            "min-height": b.minResizeHeight,
            "initial-height": b.initialResizeHeight
          }, null, 8, ["min-size", "min-height", "initial-height"])) : A("", !0)
        ]),
        _: 2
      }, 1032, ["size", "expandable", "expanded", "onUpdate:expanded", "loading", "confirm-close", "onClose"]))), 128))
    ], 64));
  }
}), PM = /* @__PURE__ */ Y({
  __name: "EditRowDialogFooter",
  props: {
    isBusy: { type: Boolean },
    isLoading: { type: Boolean },
    submitText: {},
    onSubmit: { type: Function }
  },
  emits: ["resolve"],
  setup(e, { emit: t }) {
    const n = Le(), a = e, o = t, l = async () => {
      try {
        await a.onSubmit(), o("resolve", !0);
      } catch {
      }
    };
    return (r, c) => (i(), g(he, null, [
      j(Ae, {
        variant: "outline",
        size: "3",
        disabled: e.isBusy,
        onClick: c[0] || (c[0] = (s) => o("resolve", null))
      }, {
        default: B(() => [
          j($a, null, {
            default: B(() => [
              me(le(u(n)("ui.common.cancel", "Cancel")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["disabled"]),
      j(Ae, {
        variant: "filled",
        size: "3",
        loading: e.isBusy,
        onClick: l
      }, {
        default: B(() => [
          j($a, null, {
            default: B(() => [
              me(le(e.submitText), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"])
    ], 64));
  }
}), u6 = (e, t) => {
  const { isLoading: n, ...a } = t;
  return e({
    ...a,
    bodyProps: { ...a.bodyProps, isLoading: n },
    footerProps: { ...a.footerProps, isLoading: n }
  });
}, d6 = () => {
  const e = Yo();
  return (t) => u6(e, t);
}, p6 = (e) => {
  if (e == null)
    return Al();
  if (e instanceof Error) {
    const t = e.message.trim();
    if (t.length > 0)
      return t;
  }
  return "Unable to submit form due to an unknown error. Please ask support for help.";
}, Uc = async (e, t) => {
  const {
    onSubmit: n,
    errorToString: a = p6,
    errorToColor: o = () => "red",
    isLoading: l,
    ...r
  } = t, c = N(!1), s = N(Al()), p = N("red"), d = m(() => c.value || !!Ne(l)), f = async () => {
    c.value = !0, s.value = Al();
    try {
      await n();
    } catch ($) {
      throw s.value = a($), p.value = o($), $;
    } finally {
      c.value = !1;
    }
  };
  return !!await e({
    ...r,
    bodyProps: { ...r.bodyProps, error: s, errorColor: p },
    footerProps: { ...r.footerProps, isBusy: d, onSubmit: f },
    isLoading: d
  });
}, OM = () => {
  const e = d6();
  return (t) => Uc(e, t);
}, VM = (e) => (t) => Uc(e, t), f6 = {}, h6 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function v6(e, t) {
  return i(), g("svg", h6, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M3 12.5C3 11.1022 3 10.4033 3.22836 9.85195C3.53284 9.11687 4.11687 8.53284 4.85195 8.22836C5.40326 8 6.10218 8 7.5 8C8.89782 8 9.59674 8 10.1481 8.22836C10.8831 8.53284 11.4672 9.11687 11.7716 9.85195C12 10.4033 12 11.1022 12 12.5C12 13.8978 12 14.5967 11.7716 15.1481C11.4672 15.8831 10.8831 16.4672 10.1481 16.7716C9.59674 17 8.89782 17 7.5 17C6.10218 17 5.40326 17 4.85195 16.7716C4.11687 16.4672 3.53284 15.8831 3.22836 15.1481C3 14.5967 3 13.8978 3 12.5Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M8 7.75V7.5C8 6.10218 8 5.40326 8.22836 4.85195C8.53284 4.11687 9.11687 3.53284 9.85195 3.22836C10.4033 3 11.1022 3 12.5 3C13.8978 3 14.5967 3 15.1481 3.22836C15.8831 3.53284 16.4672 4.11687 16.7716 4.85195C17 5.40326 17 6.10218 17 7.5C17 8.89782 17 9.59674 16.7716 10.1481C16.4672 10.8831 15.8831 11.4672 15.1481 11.7716C14.5967 12 13.8978 12 12.5 12H12.25",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const m6 = /* @__PURE__ */ se(f6, [["render", v6]]), zr = "[data-editable-cell]", g6 = (e, t) => {
  const n = `${zr}[data-row="${CSS.escape(String(t))}"]`, a = Array.from(e.querySelectorAll(n)), o = /* @__PURE__ */ new Set(), l = [];
  for (const r of a) {
    const c = r.dataset.col;
    c == null || o.has(c) || (o.add(c), l.push(c));
  }
  return l;
}, Ga = (e) => e.replace(/\t/g, " ").replace(/\r?\n/g, " ").trim(), y6 = (e) => {
  const t = e.querySelector(
    "input, textarea, select"
  );
  return !t || typeof t.value != "string" || t.value === "" ? null : t.value;
}, Is = (e) => e.innerText || e.textContent || "", Rs = (e) => {
  const t = e.dataset.editableCellValue;
  if (t != null)
    return Ga(t);
  const n = e.querySelector("[data-editable-cell-body]");
  if (n) {
    const a = y6(n);
    if (a != null)
      return Ga(a);
    const o = Is(n);
    if (o)
      return Ga(o);
  }
  return Ga(Is(e));
}, qc = (e) => {
  if (e.state.value === "editing")
    return Ga(e.draft.value);
  const n = e.displayValue.value;
  if (n !== "")
    return Ga(n);
  const a = e.value.value;
  return Ga(a == null ? "" : String(a));
}, w6 = (e, t) => {
  const n = e.dataset.row, a = e.dataset.col;
  if (n == null || a == null)
    return null;
  const o = t.get({ rowKey: n, colKey: a });
  return o ? qc(o) : null;
}, Ps = (e, t) => e.map(t).filter((n) => n.length > 0).join(`
`), Zc = (e, t) => Array.from(e.querySelectorAll(zr)).map(
  (a) => t != null ? w6(a, t) ?? Rs(a) : Rs(a)
).join("	"), b6 = (e, t, n) => {
  const a = g6(t, e);
  return a.length === 0 ? "" : a.map((o) => {
    const l = n.get({ rowKey: e, colKey: o });
    return l ? qc(l) : "";
  }).join("	");
}, k6 = (e) => e.length === 0 || e[0] instanceof HTMLElement, Gc = (e, t) => Zc(e, t);
function Os(e, t, n) {
  return k6(e) ? Ps(e, (a) => Zc(a, t)) : (
    // registry and container are guaranteed non-undefined here by the second overload signature;
    // the implementation signature must declare them optional so TS can accept both call shapes.
    Ps(
      e,
      (a) => b6(a, n, t)
    )
  );
}
const fo = async (e) => {
  if (typeof navigator > "u" || !navigator.clipboard)
    return !1;
  try {
    return await navigator.clipboard.writeText(e), !0;
  } catch {
    return !1;
  }
}, Ar = (e = {}) => {
  const { registry: t } = e;
  return { copyRow: async (l) => {
    const r = Gc(l, t);
    return r ? fo(r) : !1;
  }, copyRows: async (l) => {
    const r = Os(l, t);
    return r ? fo(r) : !1;
  }, copyRowsByKeys: async (l, r) => {
    if (!t || l.length === 0)
      return !1;
    const c = Os(l, t, r);
    return c ? fo(c) : !1;
  }, writeText: fo };
}, Xc = /* @__PURE__ */ Symbol("EditableCellContext"), Qc = /* @__PURE__ */ Symbol("TableGridContext"), Jc = /* @__PURE__ */ Symbol("EditableCellPopoverContext"), Lr = () => pt(Qc, null), _6 = () => {
  const e = Lr();
  if (!e)
    throw new Error("This component must be used inside a <TableGridProvider>");
  return e;
}, HM = /* @__PURE__ */ Y({
  __name: "EditableCellBulkCopyButton",
  props: {
    selection: {},
    label: { default: void 0 }
  },
  setup(e) {
    const t = Le(), n = e, a = _6(), { copyRowsByKeys: o } = Ar({ registry: a.registry }), l = m(() => n.selection.count() > 0), r = m(() => {
      const s = n.selection.count();
      return s <= 0 ? t("ui.editableCell.copyRows", "Copy rows") : s === 1 ? t("ui.editableCell.copyRow", "Copy row") : t("ui.editableCell.copyRowsCount", "Copy {count} rows", { count: s });
    }), c = async () => {
      const s = n.selection.getSelectedKeys();
      if (s.length === 0)
        return;
      const p = a.containerRef.value;
      p && await o(s, p);
    };
    return (s, p) => (i(), R(u(Ae), {
      variant: "soft",
      size: "2",
      disabled: !l.value,
      onClick: c
    }, {
      default: B(() => [
        j(Pa, null, {
          default: B(() => [
            j(m6)
          ]),
          _: 1
        }),
        j($a, null, {
          default: B(() => [
            me(le(n.label ?? r.value), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["disabled"]));
  }
}), lo = () => {
  const e = pt(Xc);
  if (!e)
    throw new Error("EditableCell children must be used within an <EditableCell>");
  return e;
}, eu = {
  fg: "var(--surface-fg)",
  soft: "var(--surface-fg-soft)",
  // --surface-fg-muted never existed (the declaration was silently dropped, cells inherited full
  // fg). The system has no step below soft, so muted intentionally aliases it.
  muted: "var(--surface-fg-soft)",
  accent: "var(--soft-fg)"
}, C6 = ["inputmode", "value", "placeholder", "readonly", "disabled", "autocomplete", "spellcheck", "maxlength", "tabindex", "aria-readonly"], NM = /* @__PURE__ */ Y({
  __name: "EditableCellInput",
  props: {
    placeholder: { default: void 0 },
    inputmode: { default: "text" },
    autocomplete: { default: "off" },
    spellcheck: { type: Boolean, default: !1 },
    maxlength: { default: void 0 },
    class: { default: void 0 },
    editable: { type: Boolean, default: !0 },
    value: { default: "" },
    compact: { type: Boolean, default: !1 },
    width: { default: void 0 },
    align: { default: void 0 },
    weight: { default: "normal" },
    color: { default: void 0 },
    numeric: { type: Boolean, default: !1 }
  },
  setup(e, { expose: t }) {
    const n = e, a = (w) => {
      if (w.length === 0)
        return !0;
      let v = w[0] === "-" ? 1 : 0, x = !1;
      for (; v < w.length; v += 1) {
        const b = w[v];
        if (b === ".") {
          if (x)
            return !1;
          x = !0;
          continue;
        }
        if (b === void 0 || b < "0" || b > "9")
          return !1;
      }
      return !0;
    }, o = {
      normal: "var(--font-weight-normal, 400)",
      medium: "var(--font-weight-medium, 500)",
      semibold: "var(--font-weight-semibold, 600)",
      bold: "var(--font-weight-bold, 700)"
    }, l = lo(), r = N(null), c = m(() => n.editable), s = m(() => l.state.value === "editing"), p = m(() => !c.value || !s.value), d = m(() => {
      const w = {};
      return n.width !== void 0 && (w.width = n.width), n.align !== void 0 && (w.textAlign = n.align), n.weight !== void 0 && n.weight !== "normal" && (w.fontWeight = o[n.weight]), n.color !== void 0 && (w.color = eu[n.color]), w;
    }), f = m(() => c.value ? s.value ? l.draft.value : l.displayValue.value : n.value);
    Se(s, (w) => {
      !w || !c.value || Ye(() => {
        const v = r.value;
        if (v) {
          v.focus();
          try {
            v.select();
          } catch {
          }
        }
      });
    }, { immediate: !0 });
    const h = (w) => {
      if (!n.numeric || !c.value || !s.value)
        return;
      const v = w.data;
      if (v == null)
        return;
      const x = w.target, b = x.selectionStart ?? x.value.length, k = x.selectionEnd ?? x.value.length, _ = x.value.slice(0, b) + v + x.value.slice(k);
      a(_) || w.preventDefault();
    }, $ = (w) => {
      if (!c.value || !s.value)
        return;
      const v = w.target;
      l.setDraft(v.value);
    }, y = (w) => {
      (!c.value || !s.value) && (w.preventDefault(), l.focusCell());
    };
    return t({
      inputRef: r
    }), (w, v) => (i(), g("input", {
      ref_key: "inputRef",
      ref: r,
      class: W([
        "hp-editable-cell__input",
        {
          "hp-editable-cell__input--compact": n.compact,
          "hp-editable-cell__input--readonly": !n.editable
        },
        n.class
      ]),
      style: Ie(d.value),
      type: "text",
      inputmode: n.inputmode,
      value: f.value,
      placeholder: n.placeholder,
      readonly: p.value,
      disabled: u(l).disabled.value,
      autocomplete: n.autocomplete,
      spellcheck: n.spellcheck,
      maxlength: n.maxlength,
      tabindex: s.value && c.value ? 0 : -1,
      "aria-readonly": p.value || void 0,
      onBeforeinput: h,
      onInput: $,
      onMousedown: y
    }, null, 46, C6));
  }
}), tu = /* @__PURE__ */ Y({
  __name: "EditableCellSide",
  props: {
    side: {},
    class: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), g("div", {
      class: W(["hp-editable-cell__side", `hp-editable-cell__side--${t.side}`, t.class]),
      "aria-hidden": "true"
    }, [
      L(n.$slots, "default")
    ], 2));
  }
}), FM = /* @__PURE__ */ Y({
  __name: "EditableCellLeft",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), R(tu, {
      side: "left",
      class: W(t.class)
    }, {
      default: B(() => [
        L(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), Er = (e) => Se(
  e.state,
  (t, n) => {
    t === "editing" && n !== "editing" ? e.onEnter?.() : t !== "editing" && n === "editing" && e.onLeave?.();
  },
  { immediate: e.immediate }
), x6 = (e) => {
  const { cell: t, identity: n } = e, a = N([]), o = () => {
    a.value = Array.isArray(t.value.value) ? [...t.value.value] : [];
  }, l = (d) => a.value.some((f) => n.isEqual(f, d)), r = (d) => {
    a.value = l(d) ? a.value.filter((f) => !n.isEqual(f, d)) : [...a.value, d];
  }, c = m(() => a.value.map((d) => n.resolveItemLabel(d)).join(", "));
  return { draftSelected: a, displayText: c, syncDraftFromCell: o, isSelected: l, toggleItem: r, handleApply: () => {
    t.commitValue(a.value), t.focusCell();
  }, handleCancel: () => {
    o(), t.revertDraft(), t.focusCell();
  } };
}, $6 = ["value", "id", "key", "label", "name"], fl = (e) => {
  if (gc(e))
    for (const t of $6) {
      const n = e[t];
      if (typeof n == "string" || typeof n == "number")
        return n;
    }
}, S6 = (e) => ({ resolveItemLabel: (o) => {
  const { getItemLabel: l } = e();
  if (l)
    return l(o);
  if (typeof o == "string" || typeof o == "number")
    return String(o);
  if (gc(o)) {
    if (typeof o.label == "string" || typeof o.label == "number")
      return String(o.label);
    if (typeof o.name == "string" || typeof o.name == "number")
      return String(o.name);
  }
  return String(o ?? "");
}, resolveItemKey: (o, l) => {
  const { getItemKey: r } = e();
  if (r)
    return r(o, l);
  const c = fl(o);
  return c ?? (typeof o == "string" || typeof o == "number" ? o : l);
}, isEqual: (o, l) => {
  const { isItemEqual: r } = e();
  if (r)
    return r(o, l);
  const c = fl(o), s = fl(l);
  return c != null && s != null ? c === s : Object.is(o, l);
} }), M6 = ["data-theme", "aria-disabled", "onClick"], D6 = { class: "hp-editable-cell__select-trigger-chevron" }, au = /* @__PURE__ */ Y({
  __name: "EditableCellSelectTrigger",
  props: {
    isPlaceholder: { type: Boolean },
    dropdownClass: {},
    labelStyle: { type: [Boolean, null, String, Object, Array], default: void 0 },
    triggerClass: { default: void 0 },
    dataTheme: { default: void 0 }
  },
  setup(e, { expose: t }) {
    const n = lo(), a = N(null), o = (l) => {
      n.disabled.value || (n.focusCell(), l());
    };
    return t({
      open: () => a.value?.open(),
      close: () => a.value?.close()
    }), (l, r) => (i(), R(u(Xt), {
      ref_key: "anchorRef",
      ref: a,
      type: "menu",
      placement: "bottom-start",
      "match-width": ""
    }, {
      default: B(() => [
        j(u(Jt), null, {
          default: B(({ toggle: c }) => [
            C("div", {
              class: W(["hp-editable-cell__select-trigger", e.triggerClass]),
              "data-theme": e.dataTheme,
              role: "combobox",
              "aria-disabled": u(n).disabled.value || void 0,
              onClick: (s) => o(c),
              onMousedown: r[0] || (r[0] = Fe(() => {
              }, ["prevent"]))
            }, [
              C("span", {
                class: W(["hp-editable-cell__select-trigger-label", { "hp-editable-cell__select-trigger-placeholder": e.isPlaceholder }]),
                style: Ie(e.labelStyle)
              }, [
                L(l.$slots, "label")
              ], 6),
              C("span", D6, [
                j(Sn)
              ])
            ], 42, M6)
          ]),
          _: 3
        }),
        j(u(Qt), {
          class: W(e.dropdownClass),
          onClick: r[1] || (r[1] = Fe(() => {
          }, ["stop"]))
        }, {
          default: B(() => [
            L(l.$slots, "dropdown")
          ]),
          _: 3
        }, 8, ["class"])
      ]),
      _: 3
    }, 512));
  }
}), T6 = {
  key: 0,
  class: "hp-editable-cell__multi-select-list"
}, B6 = {
  key: 1,
  class: "hp-editable-cell__multi-select-empty"
}, z6 = { class: "hp-editable-cell__multi-select-footer" }, A6 = /* @__PURE__ */ Y({
  __name: "EditableCellMultiSelect",
  props: {
    items: {},
    placeholder: { default: void 0 },
    emptyText: { default: void 0 },
    getItemLabel: { type: Function, default: void 0 },
    getItemKey: { type: Function, default: void 0 },
    isItemEqual: { type: Function, default: void 0 }
  },
  setup(e) {
    const t = Le(), n = e, a = m(() => n.emptyText ?? t("ui.editableCell.noOptionsFound", "No options found")), o = m(() => n.placeholder ?? t("ui.editableCell.selectItems", "Select items")), l = lo(), r = N(null), c = S6(() => ({
      getItemLabel: n.getItemLabel,
      getItemKey: n.getItemKey,
      isItemEqual: n.isItemEqual
    })), { resolveItemKey: s, resolveItemLabel: p } = c, { displayText: d, syncDraftFromCell: f, isSelected: h, toggleItem: $, handleApply: y, handleCancel: w } = x6({
      cell: l,
      identity: c
    });
    return Er({
      state: l.state,
      onEnter: () => {
        f(), Ye(() => r.value?.open());
      },
      onLeave: () => r.value?.close(),
      immediate: !0
    }), (v, x) => (i(), R(au, {
      ref_key: "anchorRef",
      ref: r,
      "is-placeholder": !u(d),
      "dropdown-class": "hp-editable-cell__multi-select-dropdown"
    }, {
      label: B(() => [
        me(le(u(d) || o.value), 1)
      ]),
      dropdown: B(() => [
        n.items.length > 0 ? (i(), g("div", T6, [
          (i(!0), g(he, null, De(n.items, (b, k) => (i(), g("label", {
            key: u(s)(b, k),
            class: "hp-editable-cell__multi-select-option"
          }, [
            j(u(ln), {
              "model-value": u(h)(b),
              size: "1",
              variant: "outline",
              "onUpdate:modelValue": (_) => u($)(b)
            }, null, 8, ["model-value", "onUpdate:modelValue"]),
            C("span", null, le(u(p)(b)), 1)
          ]))), 128))
        ])) : (i(), g("div", B6, le(a.value), 1)),
        C("div", z6, [
          j(u(Ae), {
            variant: "outline",
            size: "1",
            onClick: u(w)
          }, {
            default: B(() => [
              me(le(u(t)("ui.common.cancel", "Cancel")), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          j(u(Ae), {
            variant: "filled",
            size: "1",
            onClick: u(y)
          }, {
            default: B(() => [
              me(le(u(t)("ui.common.apply", "Apply")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }, 8, ["is-placeholder"]));
  }
}), KM = /* @__PURE__ */ se(A6, [["__scopeId", "data-v-becf989f"]]), L6 = (e) => {
  const n = `--anchor-teleport-${String(ha()).replace(/:/g, "-")}`, a = N(null);
  let o = null;
  const l = m(() => {
    const s = ["hp-anchor", `hp-anchor--${e.type}`];
    return e.variant && s.push(`hp-anchor--${e.variant}`), e.matchWidth && s.push("hp-anchor--match-width"), s.join(" ");
  }), r = (s) => {
    const p = a.value;
    if (p) {
      o && o !== s.anchorEl && o.style.removeProperty("anchor-name"), o = ql(s.anchorEl), o.style.setProperty("anchor-name", n), p.style.setProperty("position-anchor", n), p.dataset.placement = s.placement;
      try {
        p.showPopover();
      } catch {
      }
    }
  }, c = () => {
    o && (o.style.removeProperty("anchor-name"), o = null);
    const s = a.value;
    if (s)
      try {
        s.hidePopover();
      } catch {
      }
  };
  return ct(() => {
    c();
  }), {
    contentRef: a,
    contentClass: l,
    show: r,
    hide: c
  };
}, YM = /* @__PURE__ */ Y({
  __name: "EditableCellPopover",
  props: {
    variant: { default: "surface" },
    placement: { default: "bottom-start" },
    matchWidth: { type: Boolean, default: !0 },
    class: { default: void 0 }
  },
  emits: ["close"],
  setup(e, { expose: t, emit: n }) {
    const a = e, o = n, l = N(!1), r = N(!1), c = N(null), s = Ku(null), { contentRef: p, contentClass: d, show: f, hide: h } = L6({
      type: "popover",
      variant: a.variant,
      matchWidth: a.matchWidth
    }), $ = N(null);
    Fl(() => {
      p.value = $.value;
    });
    const y = (b, k) => {
      c.value = b, s.value = k, l.value = !0, f({ anchorEl: b, placement: a.placement });
    }, w = () => {
      const b = s.value;
      r.value = !0, h(), l.value = !1, s.value = null, c.value = null, o("close"), b?.focusCell(), Ye(() => {
        r.value = !1;
      });
    }, v = (b) => {
      s.value?.commitValue(b);
    }, x = m(() => {
      const b = s.value;
      return b ? {
        rowKey: b.rowKey,
        colKey: b.colKey,
        value: b.value.value,
        commitValue: v,
        close: w
      } : null;
    });
    return Ul({
      contentRef: $,
      anchorRef: c,
      isOpen: l,
      close: w,
      closeOnClickOutside: !0,
      closeOnEscape: !0,
      ignoreAnchorClicks: !0
    }), Dt(Jc, {
      show: y,
      hide: w,
      isOpen: l,
      closing: r
    }), ct(() => {
      l.value && h();
    }), t({
      show: y,
      hide: w,
      isOpen: l
    }), (b, k) => (i(), g(he, null, [
      L(b.$slots, "default"),
      C("div", {
        ref_key: "contentEl",
        ref: $,
        popover: "manual",
        class: W([u(d), a.class]),
        role: "dialog"
      }, [
        x.value ? L(b.$slots, "popover", Mt(Ke({ key: 0 }, x.value))) : A("", !0)
      ], 2)
    ], 64));
  }
}), jM = /* @__PURE__ */ Y({
  __name: "EditableCellPopoverTrigger",
  setup(e) {
    const t = lo(), n = pt(Jc, null), a = () => {
      !n || !t.rootRef.value || n.closing.value || n.show(t.rootRef.value, {
        rowKey: t.rowKey.value,
        colKey: t.colKey.value,
        value: t.value,
        commitValue: t.commitValue,
        focusCell: t.focusCell
      });
    }, o = () => {
      n?.hide();
    };
    return Er({
      state: t.state,
      onEnter: () => {
        n && a();
      }
    }), (l, r) => L(l.$slots, "default", {
      isOpen: u(n)?.isOpen.value ?? !1,
      isActive: u(t).state.value !== "idle",
      open: a,
      close: o
    });
  }
}), WM = /* @__PURE__ */ Y({
  __name: "EditableCellRight",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), R(tu, {
      side: "right",
      class: W(t.class)
    }, {
      default: B(() => [
        L(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["class"]));
  }
}), E6 = /* @__PURE__ */ Y({
  __name: "MenuPrefix",
  props: {
    class: {}
  },
  setup(e) {
    return (t, n) => (i(), g("span", {
      class: W(["hp-menu-item__prefix", t.$attrs.class])
    }, [
      L(t.$slots, "default")
    ], 2));
  }
}), UM = /* @__PURE__ */ Y({
  __name: "MenuSuffix",
  props: {
    class: {}
  },
  setup(e) {
    return (t, n) => (i(), g("span", {
      class: W(["hp-menu-item__suffix", t.$attrs.class])
    }, [
      L(t.$slots, "default")
    ], 2));
  }
}), nu = (e) => {
  const { options: t, modelValue: n, multiple: a } = e, o = m(() => {
    const s = n.value;
    return !a.value || !Array.isArray(s) ? [] : t.value.filter((p) => s.includes(p.value)).map((p) => ({ value: p.value, label: p.label }));
  }), l = m(() => {
    if (a.value)
      return "";
    const s = n.value;
    return s == null || s === "" ? "" : t.value.find((p) => p.value === s)?.label || String(s);
  }), r = m(() => {
    if (a.value)
      return !1;
    const s = n.value;
    return s != null && s !== "";
  }), c = m(() => t.value.length > 0);
  return { selectedChipItems: o, singleDisplayText: l, hasValue: r, hasOptions: c };
}, qM = /* @__PURE__ */ Y({
  __name: "EditableCellSelect",
  props: {
    options: {},
    placeholder: { default: void 0 },
    class: { default: void 0 },
    color: { default: void 0 },
    dataTheme: { default: void 0 }
  },
  setup(e) {
    const t = e, n = lo(), a = m(
      () => t.color !== void 0 ? { color: eu[t.color] } : {}
    ), o = N(null), l = N(null), r = m(() => {
      const y = t.options.findIndex((w) => w.value === n.value.value);
      return y === -1 ? 0 : y;
    }), c = Ze(t, "options"), s = m(() => {
      const y = n.value.value;
      if (y != null)
        return typeof y == "number" ? y : String(y);
    }), p = m(() => !1), { singleDisplayText: d, hasValue: f } = nu({
      options: c,
      modelValue: s,
      multiple: p
    }), h = (y) => {
      y.disabled || (n.commitValue(y.value), o.value?.close(), n.focusCell());
    }, $ = (y) => {
      if (y.key !== "ArrowDown" && y.key !== "ArrowUp")
        return;
      const w = l.value;
      if (!w)
        return;
      const v = Array.from(
        w.querySelectorAll("button.hp-menu-item:not(:disabled)")
      );
      if (v.length === 0)
        return;
      y.preventDefault();
      const x = v.indexOf(document.activeElement), b = y.key === "ArrowDown" ? 1 : -1, k = x === -1 ? b > 0 ? 0 : v.length - 1 : (x + b + v.length) % v.length;
      v[k]?.focus();
    };
    return Er({
      state: n.state,
      onEnter: () => o.value?.open(),
      onLeave: () => o.value?.close()
    }), (y, w) => (i(), R(au, {
      ref_key: "anchorRef",
      ref: o,
      "is-placeholder": !u(f),
      "label-style": a.value,
      "trigger-class": t.class,
      "data-theme": t.dataTheme,
      "dropdown-class": "hp-select-dropdown"
    }, {
      label: B(() => [
        me(le(u(f) ? u(d) : t.placeholder ?? ""), 1)
      ]),
      dropdown: B(() => [
        C("div", {
          ref_key: "listRef",
          ref: l,
          class: "hp-select-dropdown__list",
          onKeydown: $
        }, [
          (i(!0), g(he, null, De(t.options, (v, x) => (i(), R(u(Oa), {
            key: v.value,
            label: v.label,
            icon: v.icon,
            badge: v.badge,
            disabled: v.disabled,
            selected: v.value === u(n).value.value,
            "data-autofocus": x === r.value || void 0,
            onClick: (b) => h(v)
          }, null, 8, ["label", "icon", "badge", "disabled", "selected", "data-autofocus", "onClick"]))), 128))
        ], 544)
      ]),
      _: 1
    }, 8, ["is-placeholder", "label-style", "trigger-class", "data-theme"]));
  }
}), I6 = ["aria-hidden"], R6 = /* @__PURE__ */ Y({
  __name: "EditableCellAffix",
  props: {
    side: {},
    class: { default: void 0 },
    ariaHidden: { type: [Boolean, String], default: void 0 }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), g("span", {
      class: W(["hp-editable-cell-affix", [`hp-editable-cell-affix--${t.side}`, t.class]]),
      "aria-hidden": t.ariaHidden ?? "true"
    }, [
      L(n.$slots, "default", {}, void 0, !0)
    ], 10, I6));
  }
}), ZM = /* @__PURE__ */ se(R6, [["__scopeId", "data-v-37bc2e0d"]]), P6 = /* @__PURE__ */ Y({
  __name: "EditableCellBadge",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), g("span", {
      class: W(["hp-editable-cell-badge", t.class])
    }, [
      L(n.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), GM = /* @__PURE__ */ se(P6, [["__scopeId", "data-v-2784779a"]]), O6 = {}, V6 = {
  class: "hp-editable-cell-divider",
  "aria-hidden": "true"
};
function H6(e, t) {
  return i(), g("span", V6, [
    L(e.$slots, "default", {}, () => [
      t[0] || (t[0] = me("—", -1))
    ], !0)
  ]);
}
const XM = /* @__PURE__ */ se(O6, [["render", H6], ["__scopeId", "data-v-1a3189e3"]]), N6 = /* @__PURE__ */ Y({
  __name: "EditableCellPrimary",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), g("span", {
      class: W(["hp-editable-cell-primary", t.class])
    }, [
      L(n.$slots, "default", {}, void 0, !0)
    ], 2));
  }
}), QM = /* @__PURE__ */ se(N6, [["__scopeId", "data-v-d122ad43"]]), F6 = /* @__PURE__ */ Y({
  __name: "EditableCellSecondary",
  props: {
    width: { default: void 0 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = m(
      () => t.width ? { "--editable-cell-secondary-width": t.width } : void 0
    );
    return (a, o) => (i(), g("span", {
      class: W(["hp-editable-cell-secondary", t.class]),
      style: Ie(n.value)
    }, [
      L(a.$slots, "default", {}, void 0, !0)
    ], 6));
  }
}), JM = /* @__PURE__ */ se(F6, [["__scopeId", "data-v-e9c87a6a"]]), Ua = (e) => e == null ? "" : e instanceof Date ? e.toISOString() : String(e), K6 = (e) => {
  const t = N("idle"), n = N(Ua(e.value.value)), a = m(() => e.displayValue.value != null && e.displayValue.value !== "" ? e.displayValue.value : Ua(e.value.value));
  return Se(
    () => e.value.value,
    (f) => {
      t.value !== "editing" && (n.value = Ua(f));
    }
  ), {
    state: t,
    draft: n,
    displayText: a,
    setDraft: (f) => {
      n.value = f;
    },
    setState: (f) => {
      e.disabled.value && f !== "idle" || (t.value = f);
    },
    enterEditing: (f) => {
      e.disabled.value || (f?.initialChar != null ? n.value = f.initialChar : n.value = Ua(e.value.value), t.value = "editing");
    },
    commitDraft: () => {
      if (t.value !== "editing")
        return;
      const f = Ua(e.value.value), h = n.value === "" ? null : n.value;
      t.value = "focused", n.value !== f && e.onCommit(h);
    },
    revertDraft: () => {
      n.value = Ua(e.value.value), t.value === "editing" && (t.value = "focused");
    },
    commitValue: (f) => {
      e.disabled.value || (n.value = Ua(f), t.value === "editing" && (t.value = "focused"), f !== e.value.value && e.onCommit(f));
    },
    clearValue: () => {
      e.disabled.value || (n.value = "", e.value.value !== null && e.value.value !== "" && e.onCommit(null));
    }
  };
}, Y6 = (e) => {
  const { isActive: t, state: n, setState: a, commitDraft: o } = e;
  Se(t, (l) => {
    if (!l && n.value !== "idle") {
      n.value === "editing" && o(), a("idle");
      return;
    }
    l && n.value === "idle" && a("focused");
  });
}, Vs = '[role="dialog"], [data-editable-cell-popup]', Ir = (e) => e instanceof HTMLElement ? e.closest(Vs) != null : e == null ? document.querySelector(Vs) != null : !1, j6 = (e) => {
  const { rowKey: t, colKey: n, disabled: a, state: o, isActive: l, provider: r, rootRef: c, setState: s, enterEditing: p, commitDraft: d } = e, f = () => ({ rowKey: t.value, colKey: n.value }), h = () => {
    a.value || (r ? r.setActive(f()) : (s("focused"), c.value?.focus()));
  };
  return {
    activate: h,
    handleClick: (b) => {
      if (b.stopPropagation(), !a.value) {
        if (o.value === "idle") {
          h();
          return;
        }
        o.value === "focused" && p({ selectAll: !0 });
      }
    },
    handleDoubleClick: (b) => {
      b.stopPropagation(), !a.value && (l.value || h(), o.value !== "editing" && p({ selectAll: !0 }));
    },
    handleFocus: () => {
      a.value || o.value === "idle" && (r ? r.setActive(f()) : s("focused"));
    },
    handleFocusIn: () => {
      a.value || !l.value && r && r.setActive(f());
    },
    handleFocusOut: (b) => {
      const k = b.relatedTarget;
      k && c.value?.contains(k) || Ir(k) || (o.value === "editing" && d(), !r && o.value !== "idle" && s("idle"));
    }
  };
}, Rr = (e) => e.target?.closest('[role="dialog"]') != null, ou = {
  ArrowUp: { dRow: -1, dCol: 0 },
  ArrowDown: { dRow: 1, dCol: 0 }
}, lu = {
  ArrowLeft: { dRow: 0, dCol: -1 },
  ArrowRight: { dRow: 0, dCol: 1 },
  Home: "home",
  End: "end"
}, ru = new Set(Object.keys(ou).concat(["Tab"])), su = new Set(Object.keys(lu)), W6 = /^.$/u, U6 = /* @__PURE__ */ new Set(["F2", " "]), q6 = /* @__PURE__ */ new Set(["ArrowUp", "ArrowDown", "Tab"]), Z6 = (e) => {
  const { state: t, disabled: n, provider: a, enterEditing: o, commitDraft: l, revertDraft: r, clearValue: c } = e, s = (w) => n.value || w.isComposing ? !0 : Rr(w), p = (w, v) => ru.has(w) ? !0 : !v && su.has(w), d = (w, v) => {
    if (w.preventDefault(), !v) {
      o({ selectAll: !0 });
      return;
    }
    l(), a?.moveActive(w.shiftKey ? -1 : 1, 0);
  }, f = (w) => w.ctrlKey || w.metaKey || w.altKey || !W6.test(w.key) ? !1 : (w.preventDefault(), o({ initialChar: w.key }), !0), h = (w) => {
    const v = w.key;
    if (v === "Enter") {
      d(w, !1);
      return;
    }
    if (U6.has(v)) {
      w.preventDefault(), o();
      return;
    }
    if (v === "Delete" || v === "Backspace") {
      w.preventDefault(), c();
      return;
    }
    f(w);
  }, $ = (w) => {
    const v = w.key;
    if (v === "Enter") {
      d(w, !0);
      return;
    }
    v === "Escape" && (w.preventDefault(), r());
  };
  return { handleKeydown: (w) => {
    if (s(w))
      return;
    const v = t.value === "editing";
    if (p(w.key, v)) {
      v && q6.has(w.key) && l();
      return;
    }
    v ? $(w) : h(w);
  } };
}, iu = (e) => {
  const { provider: t, rowKey: n, colKey: a, gridNav: o, entry: l } = e;
  t && Se(
    [n, a],
    ([r, c], s, p) => {
      o.value !== !1 && (t.registerCell({ rowKey: r, colKey: c }, l), p(() => {
        t.unregisterCell({ rowKey: r, colKey: c });
      }));
    },
    { immediate: !0 }
  );
}, G6 = (e) => {
  const { state: t, selectOnFocus: n, disabled: a, enterEditing: o } = e;
  Se(t, (l) => {
    n.value && l === "focused" && !a.value && o({ selectAll: !0 });
  });
}, X6 = ze("hp-editable-cell", {
  variants: {
    state: {
      idle: "",
      focused: "hp-editable-cell--focused",
      editing: "hp-editable-cell--editing"
    },
    background: {
      inherit: "",
      soft: "hp-editable-cell--bg-soft",
      surface: "hp-editable-cell--bg-surface",
      transparent: "hp-editable-cell--bg-transparent"
    },
    align: {
      left: "",
      center: "hp-editable-cell--align-center",
      right: "hp-editable-cell--align-right"
    },
    disabled: {
      true: "hp-editable-cell--disabled",
      false: ""
    },
    invalid: {
      true: "hp-editable-cell--invalid",
      false: ""
    }
  },
  defaultVariants: {
    state: "idle",
    background: "inherit",
    align: "left",
    disabled: !1,
    invalid: !1
  }
}), Q6 = ["tabindex", "data-editable-cell", "data-row", "data-col", "data-active-cell", "data-editable-cell-disabled", "aria-disabled", "aria-invalid"], eD = /* @__PURE__ */ Y({
  __name: "EditableCell",
  props: {
    rowKey: {},
    colKey: {},
    modelValue: { default: null },
    displayValue: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 },
    background: { default: "inherit" },
    align: { default: "left" },
    class: { default: void 0 },
    compact: { type: Boolean, default: !1 },
    selectOnFocus: { type: Boolean, default: !1 },
    gridNav: { type: Boolean, default: !0 }
  },
  emits: ["update:modelValue", "commit", "revert"],
  setup(e, { expose: t, emit: n }) {
    const a = e, o = n, l = Lr(), r = N(null), c = N(null), s = Ze(a, "modelValue"), p = Ze(a, "displayValue"), d = Ze(a, "disabled"), {
      state: f,
      draft: h,
      displayText: $,
      setDraft: y,
      setState: w,
      enterEditing: v,
      commitDraft: x,
      revertDraft: b,
      commitValue: k,
      clearValue: _
    } = K6({
      value: s,
      displayValue: p,
      disabled: d,
      onCommit: (O) => {
        o("update:modelValue", O), o("commit", O), l && l.notifyCommit({
          rowKey: a.rowKey,
          colKey: a.colKey,
          value: O
        });
      }
    });
    iu({
      provider: l,
      rowKey: Ze(a, "rowKey"),
      colKey: Ze(a, "colKey"),
      gridNav: Ze(a, "gridNav"),
      entry: { state: f, value: s, displayValue: $, draft: h }
    });
    const T = m(() => {
      if (!l)
        return f.value !== "idle";
      const O = l.activeCell.value;
      return O ? O.rowKey === a.rowKey && O.colKey === a.colKey : !1;
    });
    Y6({ isActive: T, state: f, setState: w, commitDraft: x }), G6({
      state: f,
      selectOnFocus: Ze(a, "selectOnFocus"),
      disabled: d,
      enterEditing: v
    });
    const { handleKeydown: S } = Z6({
      state: f,
      disabled: d,
      provider: l,
      enterEditing: v,
      commitDraft: x,
      revertDraft: b,
      clearValue: _
    }), {
      handleClick: M,
      handleDoubleClick: E,
      handleFocus: F,
      handleFocusIn: H,
      handleFocusOut: te
    } = j6({
      rowKey: Ze(a, "rowKey"),
      colKey: Ze(a, "colKey"),
      disabled: d,
      state: f,
      isActive: T,
      provider: l,
      rootRef: r,
      setState: w,
      enterEditing: v,
      commitDraft: x
    }), ie = m(() => {
      const O = X6({
        state: f.value,
        background: a.background,
        align: a.align,
        disabled: a.disabled,
        invalid: a.invalid,
        class: a.class
      });
      return a.compact ? `${O} hp-editable-cell--compact` : O;
    }), ee = {
      rowKey: Ze(a, "rowKey"),
      colKey: Ze(a, "colKey"),
      state: f,
      value: s,
      displayValue: $,
      draft: h,
      disabled: d,
      setDraft: y,
      enterEditing: v,
      commitDraft: x,
      revertDraft: b,
      commitValue: k,
      clearValue: _,
      rootRef: r,
      bodyRef: c,
      focusCell: () => r.value?.focus()
    };
    return Dt(Xc, ee), t({
      rootRef: r,
      bodyRef: c,
      state: f,
      focus: () => r.value?.focus()
    }), (O, z) => (i(), g("div", {
      ref_key: "rootRef",
      ref: r,
      class: W(ie.value),
      tabindex: a.disabled ? -1 : 0,
      "data-editable-cell": a.gridNav !== !1 ? "" : void 0,
      "data-row": a.gridNav !== !1 ? String(a.rowKey) : void 0,
      "data-col": a.gridNav !== !1 ? a.colKey : void 0,
      "data-active-cell": T.value ? "" : void 0,
      "data-editable-cell-disabled": a.disabled ? "" : void 0,
      "data-hp-flush-content": "",
      role: "gridcell",
      "aria-disabled": a.disabled || void 0,
      "aria-invalid": a.invalid || void 0,
      onClick: z[0] || (z[0] = //@ts-ignore
      (...D) => u(M) && u(M)(...D)),
      onDblclick: z[1] || (z[1] = //@ts-ignore
      (...D) => u(E) && u(E)(...D)),
      onFocus: z[2] || (z[2] = //@ts-ignore
      (...D) => u(F) && u(F)(...D)),
      onFocusin: z[3] || (z[3] = //@ts-ignore
      (...D) => u(H) && u(H)(...D)),
      onFocusout: z[4] || (z[4] = //@ts-ignore
      (...D) => u(te) && u(te)(...D)),
      onKeydown: z[5] || (z[5] = //@ts-ignore
      (...D) => u(S) && u(S)(...D))
    }, [
      L(O.$slots, "left"),
      C("div", {
        ref_key: "bodyRef",
        ref: c,
        class: "hp-editable-cell__body",
        "data-editable-cell-body": ""
      }, [
        u(f) !== "editing" && O.$slots.display ? L(O.$slots, "display", { key: 0 }) : A("", !0),
        u(f) === "editing" || !O.$slots.display ? L(O.$slots, "default", { key: 1 }) : A("", !0)
      ], 512),
      L(O.$slots, "right")
    ], 42, Q6));
  }
}), J6 = ["data-theme"], ew = ["placeholder", "maxlength", "onKeydown"], tD = /* @__PURE__ */ Y({
  __name: "EditableHeading",
  props: {
    as: {},
    size: { default: "7" },
    weight: { default: "bold" },
    variant: { default: "inherit" },
    color: {},
    font: {},
    truncate: { type: Boolean, default: !1 },
    align: {},
    wrap: {},
    lineHeight: {},
    cursor: {},
    class: {},
    value: {},
    placeholder: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    maxlength: { default: void 0 }
  },
  emits: ["change"],
  setup(e, { expose: t, emit: n }) {
    const a = Le(), o = e, l = n, r = m(
      () => Wl({
        size: o.size,
        weight: o.weight,
        variant: o.variant,
        font: o.font,
        lineHeight: o.lineHeight,
        align: o.align,
        wrap: o.wrap,
        truncate: o.truncate,
        cursor: o.cursor
      })
    ), c = N(!1), s = N(""), p = N(null), d = N(null), f = () => {
      o.disabled || (s.value = o.value, c.value = !0, Ye(() => {
        p.value?.focus(), p.value?.select();
      }));
    }, h = () => {
      if (!c.value)
        return;
      c.value = !1;
      const w = s.value.trim();
      w && w !== o.value && l("change", w);
    }, $ = () => {
      c.value = !1, s.value = o.value;
    }, y = (w) => {
      const v = w.relatedTarget;
      d.value?.contains(v) || h();
    };
    return t({ startEditing: f }), (w, v) => (i(), g("div", {
      class: W(["hp-editable-heading", w.$props.class]),
      "data-theme": e.color
    }, [
      C("div", {
        class: W(["hp-editable-heading__field", { "hp-editable-heading__field--editing": c.value }])
      }, [
        C("span", {
          class: W(["hp-editable-heading__sizer", r.value]),
          "aria-hidden": "true"
        }, le(c.value ? s.value : e.value) + "  ", 3),
        c.value ? ra((i(), g("input", {
          key: 0,
          ref_key: "inputRef",
          ref: p,
          "onUpdate:modelValue": v[0] || (v[0] = (x) => s.value = x),
          type: "text",
          placeholder: e.placeholder,
          maxlength: e.maxlength,
          class: W(["hp-editable-heading__input", r.value]),
          spellcheck: "false",
          onBlur: y,
          onKeydown: [
            sa(Fe(h, ["prevent"]), ["enter"]),
            sa(Fe($, ["prevent"]), ["escape"])
          ]
        }, null, 42, ew)), [
          [ki, s.value]
        ]) : (i(), g("span", {
          key: 1,
          class: W(["hp-editable-heading__text", r.value, { "hp-editable-heading__text--disabled": e.disabled }]),
          onClick: f
        }, le(e.value), 3))
      ], 2),
      c.value ? (i(), g("div", {
        key: 0,
        ref_key: "actionsRef",
        ref: d,
        class: "hp-editable-heading__actions"
      }, [
        j(u(Ae), {
          variant: "soft",
          color: "green",
          size: "1",
          square: "",
          tabindex: "-1",
          "aria-label": u(a)("ui.common.apply", "Apply"),
          onClick: h
        }, {
          default: B(() => [
            j(Pa, null, {
              default: B(() => [
                j(eo)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["aria-label"]),
        j(u(Ae), {
          variant: "soft",
          size: "1",
          square: "",
          tabindex: "-1",
          "aria-label": u(a)("ui.common.cancel", "Cancel"),
          onClick: $
        }, {
          default: B(() => [
            j(Pa, null, {
              default: B(() => [
                j(zt)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["aria-label"])
      ], 512)) : A("", !0)
    ], 10, J6));
  }
}), tw = {}, aw = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function nw(e, t) {
  return i(), g("svg", aw, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M9.16667 13.3333L5.83333 16.6667L2.5 13.3333M5.83333 16.6667L5.83333 3.33334",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10.8333 6.66668L14.1667 3.33334L17.5 6.66668M14.1667 3.33334L14.1667 16.6667",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const ow = /* @__PURE__ */ se(tw, [["render", nw]]), lw = {}, rw = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function sw(e, t) {
  return i(), g("svg", rw, [...t[0] || (t[0] = [
    C("rect", {
      class: "hp-icon",
      x: "2.00",
      y: "6.0",
      width: "16.00",
      height: "8.0",
      rx: "1.5",
      fill: "var(--icon-color, currentColor)",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)"
    }, null, -1)
  ])]);
}
const cu = /* @__PURE__ */ se(lw, [["render", sw]]), iw = {}, cw = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function uw(e, t) {
  return i(), g("svg", cw, [...t[0] || (t[0] = [
    C("rect", {
      class: "hp-icon",
      x: "2.00",
      y: "6.0",
      width: "7.25",
      height: "8.0",
      rx: "1.5",
      fill: "var(--icon-color, currentColor)",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)"
    }, null, -1),
    C("rect", {
      class: "hp-icon",
      x: "10.75",
      y: "6.0",
      width: "7.25",
      height: "8.0",
      rx: "1.5",
      fill: "none",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      opacity: "0.45"
    }, null, -1)
  ])]);
}
const uu = /* @__PURE__ */ se(iw, [["render", uw]]), dw = {}, pw = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function fw(e, t) {
  return i(), g("svg", pw, [...t[0] || (t[0] = [
    C("rect", {
      class: "hp-icon",
      x: "2.00",
      y: "6.0",
      width: "2.88",
      height: "8.0",
      rx: "1.5",
      fill: "var(--icon-color, currentColor)",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)"
    }, null, -1),
    C("rect", {
      class: "hp-icon",
      x: "6.38",
      y: "6.0",
      width: "2.88",
      height: "8.0",
      rx: "1.5",
      fill: "none",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      opacity: "0.45"
    }, null, -1),
    C("rect", {
      class: "hp-icon",
      x: "10.75",
      y: "6.0",
      width: "2.88",
      height: "8.0",
      rx: "1.5",
      fill: "none",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      opacity: "0.45"
    }, null, -1),
    C("rect", {
      class: "hp-icon",
      x: "15.12",
      y: "6.0",
      width: "2.88",
      height: "8.0",
      rx: "1.5",
      fill: "none",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      opacity: "0.45"
    }, null, -1)
  ])]);
}
const du = /* @__PURE__ */ se(dw, [["render", fw]]), hw = {}, vw = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function mw(e, t) {
  return i(), g("svg", vw, [...t[0] || (t[0] = [
    C("rect", {
      class: "hp-icon",
      x: "2.00",
      y: "6.0",
      width: "4.33",
      height: "8.0",
      rx: "1.5",
      fill: "var(--icon-color, currentColor)",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)"
    }, null, -1),
    C("rect", {
      class: "hp-icon",
      x: "7.83",
      y: "6.0",
      width: "4.33",
      height: "8.0",
      rx: "1.5",
      fill: "none",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      opacity: "0.45"
    }, null, -1),
    C("rect", {
      class: "hp-icon",
      x: "13.67",
      y: "6.0",
      width: "4.33",
      height: "8.0",
      rx: "1.5",
      fill: "none",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      opacity: "0.45"
    }, null, -1)
  ])]);
}
const pu = /* @__PURE__ */ se(hw, [["render", mw]]), gw = (e, t, n) => {
  const a = t.length, o = Math.min(e.w, a), l = e.break || o === a;
  l && n.column > 0 && (n.row++, n.column = 0);
  const r = () => t.slice(n.column, n.column + o).every((s) => s <= n.row);
  for (; n.column + o > a || !r(); )
    l || n.column + o >= a ? (n.row++, n.column = 0) : n.column++;
  const c = n.row + Math.max(1, e.h);
  return t.fill(c, n.column, n.column + o), n.column += o, c;
}, yw = (e, t, n, a = "0") => {
  if (!n || !e.some((c) => c.key === n))
    return;
  const o = Array(t).fill(0), l = { row: 0, column: 0 };
  let r = 0;
  for (const c of e) {
    const s = gw(c, o, l);
    c.key === n && (r = s - 1);
  }
  return Array.from(
    { length: Math.max(...o) },
    (c, s) => s === r ? `minmax(${a}, 1fr)` : "minmax(min-content, auto)"
  ).join(" ");
}, Hs = (e, t, n) => {
  const a = e.filter((l) => l.key !== t);
  let o = 0;
  for (const l of a) {
    const r = n.y > l.bottom, c = n.y >= l.top && n.x > (l.left + l.right) / 2;
    (r || c) && (o += 1);
  }
  return o;
}, ww = (e, t, n, a) => {
  const o = Math.max(1, n), l = t.top + o - e, r = e - (t.bottom - o);
  return l > 0 ? -Math.round(a * Math.min(1, l / o)) : r > 0 ? Math.round(a * Math.min(1, r / o)) : 0;
}, bw = (e, t, n) => !Number.isFinite(e) || e <= 0 || t <= 0 ? 1 : Math.max(1, Math.ceil((e + n) / (t + n))), jt = 1, _o = 0, Hn = 8, ka = (e, t) => Number.isFinite(e) && e >= jt ? Math.floor(e) : t, Ns = (e, t) => Number.isFinite(e) && e >= _o ? Math.floor(e) : t, fn = (e, t, n) => Math.min(Math.max(e, t), n), Pr = (e, t) => e[t] ?? {}, Or = (e, t, n) => {
  const a = ka(n, jt), o = Math.min(ka(t.maxW ?? a, a), a), l = fn(ka(t.minW ?? jt, jt), jt, o), r = Math.min(ka(t.maxH ?? Hn, Hn), Hn), c = fn(Ns(t.minH ?? _o, _o), _o, r);
  return {
    key: e.key,
    w: e.w === "full" ? o : fn(ka(e.w, jt), l, o),
    h: fn(Ns(e.h ?? jt, jt), c, r),
    break: e.break === !0
  };
};
function fu(e, t, n) {
  const a = ka(t, jt), o = ka(n, jt);
  return e === "full" || o >= a ? e : fn(Math.ceil(ka(e, jt) / a * o), jt, o);
}
const kw = (e, t, n) => t === n ? e : e.map((a) => ({ ...a, w: fu(a.w, t, n) })), _w = (e, t, n) => e.map((a) => Or(a, Pr(t, a.key), n)), Fs = (e, t, n, a = {}) => {
  const o = e.find((c) => c.key === t);
  if (o === void 0 || Pr(a, t).movable === !1)
    return e;
  const l = e.filter((c) => c.key !== t), r = fn(Math.floor(n), 0, l.length);
  return [...l.slice(0, r), o, ...l.slice(r)];
}, Ks = (e, t, n, a, o) => {
  const l = Pr(a, t);
  return l.resizable === !1 ? e : e.map((r) => {
    if (r.key !== t)
      return r;
    const c = Or({ ...r, w: n.w, h: n.h }, l, o);
    return { ...r, w: c.w >= ka(o, jt) ? "full" : c.w, h: c.h };
  });
}, Ys = (e, t) => {
  const n = new Set(e.map((r) => r.key)), a = (t.items ?? []).filter((r) => n.has(r.key)), o = new Set(a.map((r) => r.key)), l = e.filter((r) => !o.has(r.key)).map((r) => t.fallback === void 0 ? r : { ...r, w: t.fallback });
  return [...a, ...l];
}, aD = (e, t) => e.filter((n) => n.key !== t), Cw = (e, t) => {
  const n = new Map(t.map((l) => [l.key, l])), a = e.filter((l) => n.has(l.key)), o = new Set(a.map((l) => l.key));
  return [...a, ...t.filter((l) => !o.has(l.key))];
}, nD = (e, t) => e.map((n) => n.key === t ? { ...n, break: n.break !== !0 } : n), xw = 12, $w = (e, t) => {
  const n = [];
  return n.push(e.w >= t ? "hp-col-span-full" : `hp-col-span-${Math.min(e.w, xw)}`), e.h >= 1 && n.push(`hp-row-span-${Math.min(e.h, Hn)}`), e.break && n.push("hp-col-start-1"), n;
}, Sw = ["data-layout-key"], Mw = { class: "hp-editable-layout__content" }, Dw = { class: "hp-editable-layout__toolbar" }, Tw = {
  key: 1,
  class: "hp-editable-layout__span-label"
}, Bw = 72, zw = 18, oD = /* @__PURE__ */ Y({
  __name: "EditableLayout",
  props: {
    items: {},
    contracts: { default: () => ({}) },
    columns: { default: 12 },
    rowHeight: { default: "80px" },
    gap: { default: "4" },
    condenseBelow: { default: "1280px" },
    collapseBelow: { default: "1024px" },
    fillKey: {},
    fillMinHeight: {},
    editing: { type: Boolean, default: !1 },
    hiddenKeys: { default: () => /* @__PURE__ */ new Set() },
    class: { default: void 0 }
  },
  emits: ["update:items", "remove", "restore"],
  setup(e, { emit: t }) {
    const n = Le(), a = e, o = t, l = N(null), r = /* @__PURE__ */ new Map(), c = N({ width: 0, gap: 0 }), s = N(null), p = N(null), d = N(null);
    let f = null;
    const h = () => {
      for (let G = l.value?.parentElement ?? null; G !== null; G = G.parentElement) {
        const { overflowY: fe } = getComputedStyle(G);
        if ((fe === "auto" || fe === "scroll") && G.scrollHeight > G.clientHeight) {
          const ke = G.getBoundingClientRect();
          return { scrollBy: (Re, xt) => G.scrollBy(Re, xt), top: ke.top, bottom: ke.bottom };
        }
      }
      return { scrollBy: (G, fe) => window.scrollBy(G, fe), top: 0, bottom: window.innerHeight };
    }, $ = () => {
      const G = d.value, fe = p.value, ke = h(), Re = G === null || fe === null ? 0 : ww(fe.y, ke, Bw, zw);
      if (Re === 0 || G === null || fe === null) {
        f = null;
        return;
      }
      ke.scrollBy(0, Re), s.value = Hs(ge(), G.key, fe), f = requestAnimationFrame($);
    }, y = (G) => Number.parseFloat(G) || 0, w = m(() => Math.max(1, Math.floor(a.columns))), v = m(() => {
      const G = c.value.width;
      return G <= 0 ? w.value : G < y(a.collapseBelow) ? 1 : G < y(a.condenseBelow) ? Math.min(2, w.value) : w.value;
    }), x = m(() => ({
      width: (c.value.width - c.value.gap * (v.value - 1)) / v.value,
      gap: c.value.gap
    })), b = m(() => a.editing && v.value > 1), k = m(() => a.editing && v.value > 1), _ = m(() => {
      const { width: G, gap: fe } = x.value, ke = (ot) => ot === void 0 ? void 0 : fu(ot, w.value, v.value), Re = v.value < w.value, xt = Object.entries(a.contracts).map(([ot, Lt]) => {
        const Ft = Number.parseFloat(Lt.minContentWidth ?? ""), Ma = Re && Number.isFinite(Ft) && G > 0 ? bw(Ft, G, fe) : 1, Da = ke(Lt.maxW), Ta = Math.max(ke(Lt.minW) ?? 1, Ma);
        return [
          ot,
          { ...Lt, minW: Ta, ...Da === void 0 ? {} : { maxW: Math.max(Da, Ta) } }
        ];
      });
      return Object.fromEntries(xt);
    }), T = m(
      () => _w(
        kw(a.items, w.value, v.value),
        _.value,
        v.value
      )
    ), S = (G) => _.value[G] ?? {}, M = (G) => k.value && S(G).resizable !== !1, E = (G) => (S(G).minW ?? 1) >= v.value, F = (G) => S(G).removable !== !1, H = (G) => a.hiddenKeys?.has(G) === !0, te = (G) => {
      if (H(G)) {
        o("restore", G);
        return;
      }
      o("remove", G);
    }, ie = (G, fe) => {
      fe instanceof HTMLElement ? r.set(G, fe) : r.delete(G);
    }, ee = m(() => yw(T.value, v.value, a.fillKey, a.fillMinHeight)), O = m(() => ["hp-editable-layout", { "hp-editable-layout--editing": b.value, "hp-editable-layout--fill": !!ee.value }, a.class]), z = m(() => ({
      gridTemplateRows: ee.value,
      "--hp-editable-layout-columns": String(v.value),
      "--hp-editable-layout-row-height": a.rowHeight,
      "--hp-editable-layout-gap": `var(--space-${a.gap})`,
      // Read by the `hp-row-span-*` utilities, which turn a span into a minimum height.
      "--hp-row-unit": a.rowHeight,
      "--hp-row-gap": `var(--space-${a.gap})`
    })), D = (G) => [
      ...$w(G, v.value),
      {
        "hp-editable-layout__cell--dragging": d.value?.key === G.key,
        "hp-editable-layout__cell--hidden": H(G.key),
        "hp-editable-layout__cell--fill": !!ee.value && G.key === a.fillKey
      }
    ], P = (G) => {
      const fe = d.value, ke = p.value;
      return fe !== null && fe.key === G.key && ke !== null ? { transform: `translate(${ke.x - fe.origin.x}px, ${ke.y - fe.origin.y}px)` } : void 0;
    }, Z = m(() => {
      const G = s.value, fe = l.value;
      if (G === null || fe === null || d.value === null)
        return null;
      const ke = a.items.filter((Ft) => Ft.key !== d.value?.key), Re = ke[G], xt = Re ?? ke[G - 1], ot = xt === void 0 ? void 0 : r.get(xt.key)?.getBoundingClientRect();
      if (ot === void 0)
        return null;
      const Lt = fe.getBoundingClientRect();
      return {
        left: `${(Re === void 0 ? ot.right : ot.left) - Lt.left}px`,
        top: `${ot.top - Lt.top}px`,
        height: `${ot.height}px`
      };
    }), J = m(
      () => new Map(
        a.items.map((G) => [G.key, Or(G, a.contracts[G.key] ?? {}, w.value)])
      )
    ), re = (G) => J.value.get(G) ?? { key: G, w: 1, h: 1, break: !1 }, U = (G) => {
      const fe = w.value, { w: ke } = re(G);
      return ke >= fe ? "full" : `${ke}/${fe}`;
    }, ge = () => a.items.flatMap((G) => {
      const fe = r.get(G.key)?.getBoundingClientRect();
      return fe === void 0 ? [] : [{ key: G.key, left: fe.left, top: fe.top, right: fe.right, bottom: fe.bottom }];
    }), K = (G) => {
      const fe = d.value;
      fe === null || G.pointerId !== fe.pointerId || (p.value = { x: G.clientX, y: G.clientY }, s.value = Hs(ge(), fe.key, { x: G.clientX, y: G.clientY }), f ??= requestAnimationFrame($));
    }, pe = (G) => {
      G.pointerId === d.value?.pointerId && oe(!0);
    }, ae = (G) => {
      G.pointerId === d.value?.pointerId && oe(!1);
    }, Ce = (G) => {
      G.key === "Escape" && oe(!1);
    }, q = () => oe(!1), I = () => {
      document.removeEventListener("pointermove", K), document.removeEventListener("pointerup", pe), document.removeEventListener("pointercancel", ae), document.removeEventListener("keydown", Ce), window.removeEventListener("blur", q), document.documentElement.classList.remove("hp-editable-layout-gesture"), f !== null && (cancelAnimationFrame(f), f = null);
    }, oe = (G) => {
      const fe = d.value, ke = s.value;
      fe !== null && G && ke !== null && o("update:items", Fs(a.items, fe.key, ke, _.value)), d.value = null, s.value = null, p.value = null, I();
    }, be = (G, fe) => {
      G.button !== 0 || !b.value || S(fe.key).movable === !1 || (G.preventDefault(), d.value = { key: fe.key, pointerId: G.pointerId, origin: { x: G.clientX, y: G.clientY } }, p.value = { x: G.clientX, y: G.clientY }, document.documentElement.classList.add("hp-editable-layout-gesture"), document.addEventListener("pointermove", K), document.addEventListener("pointerup", pe), document.addEventListener("pointercancel", ae), document.addEventListener("keydown", Ce), window.addEventListener("blur", q));
    }, de = [
      {
        parts: 1,
        // Getter: this array is built once when the component is created.
        get label() {
          return n("ui.editableLayout.fullRow", "Full row");
        },
        icon: cu
      },
      {
        parts: 2,
        // Getter: this array is built once when the component is created.
        get label() {
          return n("ui.editableLayout.halfRow", "Half row");
        },
        icon: uu
      },
      {
        parts: 3,
        // Getter: this array is built once when the component is created.
        get label() {
          return n("ui.editableLayout.thirdOfARow", "Third of a row");
        },
        icon: pu
      },
      {
        parts: 4,
        // Getter: this array is built once when the component is created.
        get label() {
          return n("ui.editableLayout.quarterOfARow", "Quarter of a row");
        },
        icon: du
      }
    ], X = (G) => {
      const fe = G.target.value.trim(), ke = Number(fe);
      return fe === "" || !Number.isFinite(ke) ? void 0 : ke;
    }, ne = (G, fe) => {
      const ke = re(G), Re = { w: fe.w ?? ke.w, h: fe.h ?? ke.h };
      !Number.isFinite(Re.w) || !Number.isFinite(Re.h) || o("update:items", Ks(a.items, G, Re, _.value, w.value));
    }, ve = (G) => Math.max(1, Math.round(w.value / G)), V = m(
      () => de.filter(
        (G, fe) => de.findIndex((ke) => ve(ke.parts) === ve(G.parts)) === fe
      )
    ), xe = (G, fe) => ne(G, { w: ve(fe) }), ce = (G, fe) => re(G).w === ve(fe) ? "hp-editable-layout__preset hp-editable-layout__preset--active" : "hp-editable-layout__preset", Te = { ArrowLeft: -1, ArrowUp: -1, ArrowRight: 1, ArrowDown: 1 }, $e = (G, fe, ke) => {
      if (!M(G.key))
        return;
      const Re = fe === "ArrowLeft" || fe === "ArrowRight";
      o(
        "update:items",
        Ks(
          a.items,
          G.key,
          { w: G.w + (Re ? ke : 0), h: G.h + (Re ? 0 : ke) },
          _.value,
          v.value
        )
      );
    }, Be = (G) => !G.altKey && !G.ctrlKey && !G.metaKey, Ue = (G, fe) => {
      const ke = Te[G.key];
      if (ke === void 0 || !Be(G) || !b.value)
        return;
      if (G.preventDefault(), G.shiftKey) {
        $e(fe, G.key, ke);
        return;
      }
      const Re = a.items.findIndex((xt) => xt.key === fe.key);
      o("update:items", Fs(a.items, fe.key, Re + ke, _.value));
    };
    let qe = null;
    const Q = () => {
      const G = l.value;
      if (G === null)
        return;
      const fe = getComputedStyle(G), ke = G.getBoundingClientRect().width - y(fe.paddingInlineStart) - y(fe.paddingInlineEnd), Re = y(fe.columnGap);
      (ke !== c.value.width || Re !== c.value.gap) && (c.value = { width: ke, gap: Re });
    };
    return tt(() => {
      Q(), typeof ResizeObserver < "u" && l.value !== null && (qe = new ResizeObserver(Q), qe.observe(l.value));
    }), ct(() => {
      oe(!1), qe?.disconnect(), qe = null;
    }), (G, fe) => (i(), g("div", {
      ref_key: "rootRef",
      ref: l,
      class: W(O.value),
      style: Ie(z.value)
    }, [
      (i(!0), g(he, null, De(T.value, (ke) => (i(), g("div", {
        key: ke.key,
        ref_for: !0,
        ref: (Re) => ie(ke.key, Re),
        class: W(["hp-editable-layout__cell", D(ke)]),
        style: Ie(P(ke)),
        "data-layout-key": ke.key
      }, [
        C("div", Mw, [
          L(G.$slots, "cell", {
            cellKey: ke.key
          })
        ]),
        b.value ? (i(), g(he, { key: 0 }, [
          C("div", Dw, [
            j(Ae, {
              class: "hp-editable-layout__handle hp-editable-layout__handle--move",
              variant: "blank",
              size: "1",
              square: "",
              radius: "full",
              icon: Jl,
              "aria-label": u(n)("ui.editableLayout.moveItem", "Move {item}", { item: ke.key }),
              onPointerdown: (Re) => be(Re, ke),
              onKeydown: (Re) => Ue(Re, ke)
            }, null, 8, ["aria-label", "onPointerdown", "onKeydown"]),
            M(ke.key) ? (i(), g(he, { key: 0 }, [
              j(tn, {
                class: "hp-editable-layout__field",
                type: "number",
                variant: "blank",
                size: "1",
                align: "center",
                width: "34px",
                min: "0",
                max: u(Hn),
                "aria-label": u(n)("ui.editableLayout.rowsFor", "Rows for {item}", { item: ke.key }),
                "model-value": re(ke.key).h,
                onChange: (Re) => ne(ke.key, { h: X(Re) })
              }, null, 8, ["max", "aria-label", "model-value", "onChange"]),
              E(ke.key) ? A("", !0) : (i(), g(he, { key: 0 }, [
                fe[0] || (fe[0] = C("span", {
                  class: "hp-editable-layout__times",
                  "aria-hidden": "true"
                }, "×", -1)),
                j(tn, {
                  class: "hp-editable-layout__field",
                  type: "number",
                  variant: "blank",
                  size: "1",
                  align: "center",
                  width: "34px",
                  min: "1",
                  max: w.value,
                  "aria-label": u(n)("ui.editableLayout.columnsFor", "Columns for {item}", { item: ke.key }),
                  "model-value": re(ke.key).w,
                  onChange: (Re) => ne(ke.key, { w: X(Re) })
                }, null, 8, ["max", "aria-label", "model-value", "onChange"]),
                fe[1] || (fe[1] = C("span", {
                  class: "hp-editable-layout__separator",
                  "aria-hidden": "true"
                }, null, -1))
              ], 64)),
              (i(!0), g(he, null, De(V.value, (Re) => ra((i(), R(Ae, {
                key: Re.parts,
                class: W(ce(ke.key, Re.parts)),
                variant: "blank",
                size: "1",
                square: "",
                radius: "full",
                icon: Re.icon,
                "aria-label": u(n)("ui.editableLayout.presetFor", "{preset} for {item}", { preset: Re.label, item: ke.key }),
                title: Re.label,
                "aria-pressed": re(ke.key).w === ve(Re.parts),
                onClick: (xt) => xe(ke.key, Re.parts)
              }, null, 8, ["class", "icon", "aria-label", "title", "aria-pressed", "onClick"])), [
                [xa, !E(ke.key)]
              ])), 128))
            ], 64)) : (i(), g("span", Tw, [
              ke.break ? (i(), R(ow, {
                key: 0,
                class: "hp-editable-layout__badge-icon",
                "aria-hidden": "true"
              })) : A("", !0),
              me(" " + le(U(ke.key)), 1)
            ]))
          ]),
          F(ke.key) ? (i(), R(Ae, {
            key: 0,
            class: W(
              [
                "hp-editable-layout__handle",
                "hp-editable-layout__handle--visibility",
                H(ke.key) ? "hp-editable-layout__handle--restore" : "hp-editable-layout__handle--remove"
              ].join(" ")
            ),
            variant: "blank",
            size: "1",
            square: "",
            radius: "full",
            icon: H(ke.key) ? eo : zt,
            "aria-label": H(ke.key) ? u(n)("ui.editableLayout.showItem", "Show {item}", { item: ke.key }) : u(n)("ui.editableLayout.removeItem", "Remove {item}", { item: ke.key }),
            onClick: (Re) => te(ke.key)
          }, null, 8, ["class", "icon", "aria-label", "onClick"])) : A("", !0)
        ], 64)) : A("", !0)
      ], 14, Sw))), 128)),
      Z.value !== null ? (i(), g("div", {
        key: 0,
        class: "hp-editable-layout__marker",
        style: Ie(Z.value),
        "aria-hidden": "true"
      }, null, 4)) : A("", !0)
    ], 6));
  }
}), js = Object.freeze([
  { id: "stack", label: "One per row", fallback: "full", icon: cu },
  { id: "halves", label: "Two per row", fallback: 6, icon: uu },
  { id: "thirds", label: "Three per row", fallback: 4, icon: pu },
  { id: "quarters", label: "Four per row", fallback: 3, icon: du }
]), Aw = ["aria-label"], lD = /* @__PURE__ */ Y({
  __name: "EditableLayoutPresets",
  props: {
    items: {},
    presets: { default: void 0 },
    class: { default: void 0 }
  },
  emits: ["update:items"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = Le(), l = m(
      () => (n.presets ?? js).map(
        (p) => js.includes(p) ? { ...p, label: o(`ui.editableLayout.preset.${p.id}`, p.label) } : p
      )
    ), r = m(
      () => new Set(
        l.value.filter((p) => {
          const d = Ys(n.items, p);
          return n.items.length > 0 && d.every((f, h) => f.key === n.items[h]?.key && f.w === n.items[h]?.w);
        }).map((p) => p.id)
      )
    ), c = (p) => r.value.has(p.id), s = (p) => c(p) ? "hp-editable-layout-presets__item hp-editable-layout-presets__item--active" : "hp-editable-layout-presets__item";
    return (p, d) => (i(), g("div", {
      class: W(["hp-editable-layout-presets", n.class]),
      role: "group",
      "aria-label": u(o)("ui.editableLayout.layoutPresets", "Layout presets")
    }, [
      (i(!0), g(he, null, De(l.value, (f) => (i(), R(Ae, {
        key: f.id,
        class: W(s(f)),
        variant: "blank",
        size: "1",
        square: "",
        radius: "full",
        icon: f.icon,
        "aria-label": f.label,
        title: f.label,
        "aria-pressed": c(f),
        onClick: (h) => a("update:items", u(Ys)(n.items, f), f)
      }, null, 8, ["class", "icon", "aria-label", "title", "aria-pressed", "onClick"]))), 128))
    ], 10, Aw));
  }
}), Lw = (e) => {
  if (typeof e != "object" || e === null)
    return !1;
  const t = e;
  return typeof t.key == "string" && (typeof t.w == "number" || t.w === "full") && (t.h === void 0 || typeof t.h == "number") && (t.break === void 0 || typeof t.break == "boolean");
}, Ew = (e) => {
  if (e === void 0)
    return null;
  try {
    const t = globalThis.localStorage?.getItem(e) ?? null;
    if (t === null)
      return null;
    const n = JSON.parse(t);
    return n.version === 1 && Array.isArray(n.items) && n.items.every(Lw) ? n.items : null;
  } catch {
    return null;
  }
}, Iw = (e, t) => {
  if (e !== void 0)
    try {
      globalThis.localStorage?.setItem(e, JSON.stringify({ version: 1, items: t }));
    } catch {
    }
}, Rw = (e) => {
  if (e !== void 0)
    try {
      globalThis.localStorage?.removeItem(e);
    } catch {
    }
}, rD = (e) => {
  const t = () => Ne(e.items), n = N(Ew(e.storageKey) ?? t()), a = m(() => Cw(n.value, t())), o = N(!1), l = (r) => {
    n.value = r, Iw(e.storageKey, r);
  };
  return {
    items: a,
    isEditing: Kl(o),
    setItems: l,
    startEditing: () => {
      o.value = !0;
    },
    stopEditing: () => {
      o.value = !1;
    },
    /**
     * Forgets rather than saves: writing today's defaults back would pin the user to this
     * release's spans, and the next one that changes a default would never reach them.
     */
    reset: () => {
      n.value = t(), Rw(e.storageKey);
    }
  };
}, Pw = {
  key: 0,
  class: "sr-only"
}, Ow = { class: "d-inline-flex items-center gap-2" }, Vw = 400, sD = /* @__PURE__ */ Y({
  name: "IncludeExcludeSwitch",
  __name: "IncludeExcludeSwitch",
  props: {
    exclude: { type: Boolean },
    disabled: { type: Boolean, default: !1 },
    hideLabel: { type: Boolean },
    empty: { type: Boolean, default: !1 },
    tooltip: { default: "" },
    layout: { default: "separate" },
    size: { default: "3" },
    includeLabel: { default: void 0 },
    excludeLabel: { default: void 0 },
    includeColor: { default: "green" },
    excludeColor: { default: "red" }
  },
  emits: ["toggle"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = Le(), l = m(
      () => n.exclude ? n.excludeLabel ?? o("ui.smartFilter.exclude", "Exclude") : n.includeLabel ?? o("ui.smartFilter.include", "Include")
    ), r = m(() => n.exclude ? n.excludeColor : n.includeColor);
    return (c, s) => e.layout !== "separate" || e.hideLabel ? (i(), R(u($o), {
      key: 0,
      "model-value": e.exclude,
      disabled: e.disabled,
      size: n.size,
      "label-position": e.layout === "right" ? "right" : "left",
      label: l.value,
      variant: e.empty ? "soft" : "filled",
      color: e.empty ? void 0 : r.value,
      onChange: s[0] || (s[0] = (p) => a("toggle"))
    }, {
      default: B(() => [
        e.hideLabel ? (i(), g("span", Pw, le(l.value), 1)) : (i(), g(he, { key: 1 }, [
          me(le(l.value), 1)
        ], 64))
      ]),
      _: 1
    }, 8, ["model-value", "disabled", "size", "label-position", "label", "variant", "color"])) : (i(), R(u(Ro), {
      key: 1,
      text: e.empty && e.tooltip ? e.tooltip : "",
      placement: "top-start",
      "show-delay": Vw
    }, {
      default: B(() => [
        C("span", Ow, [
          j(u(at), {
            size: "4",
            weight: "semibold",
            variant: e.empty ? "soft" : "surface",
            color: e.exclude && !e.empty ? e.excludeColor : void 0
          }, {
            default: B(() => [
              me(le(l.value), 1)
            ]),
            _: 1
          }, 8, ["variant", "color"]),
          j(u($o), {
            "model-value": e.exclude,
            disabled: e.disabled,
            size: n.size,
            variant: e.empty ? "soft" : "filled",
            color: e.empty ? void 0 : r.value,
            onChange: s[1] || (s[1] = (p) => a("toggle"))
          }, null, 8, ["model-value", "disabled", "size", "variant", "color"])
        ])
      ]),
      _: 1
    }, 8, ["text"]));
  }
}), iD = /* @__PURE__ */ Y({
  __name: "LayoutGrid",
  props: {
    spanCols: {},
    spanRows: {},
    columns: { default: "auto" },
    rows: { default: "auto" },
    minColumnWidth: { default: "370px" },
    maxColumns: {},
    wideColumns: {},
    columnGap: { default: "4" },
    rowGap: { default: "4" },
    class: {}
  },
  setup(e) {
    const t = e, o = ze("hp-layout-grid", {
      variants: {
        columnGap: {
          1: "hp-layout-grid--column-gap-1",
          2: "hp-layout-grid--column-gap-2",
          3: "hp-layout-grid--column-gap-3",
          4: "hp-layout-grid--column-gap-4",
          5: "hp-layout-grid--column-gap-5",
          6: "hp-layout-grid--column-gap-6",
          7: "hp-layout-grid--column-gap-7",
          8: "hp-layout-grid--column-gap-8",
          9: "hp-layout-grid--column-gap-9",
          10: "hp-layout-grid--column-gap-10"
        },
        rowGap: {
          1: "hp-layout-grid--row-gap-1",
          2: "hp-layout-grid--row-gap-2",
          3: "hp-layout-grid--row-gap-3",
          4: "hp-layout-grid--row-gap-4",
          5: "hp-layout-grid--row-gap-5",
          6: "hp-layout-grid--row-gap-6",
          7: "hp-layout-grid--row-gap-7",
          8: "hp-layout-grid--row-gap-8",
          9: "hp-layout-grid--row-gap-9",
          10: "hp-layout-grid--row-gap-10"
        },
        maxCols: {
          true: "hp-layout-grid--max-cols",
          false: ""
        }
      },
      defaultVariants: {
        columnGap: "4",
        rowGap: "4",
        maxCols: !1
      }
    }), l = m(() => t.maxColumns !== void 0 && t.columns === "auto"), r = m(() => [
      o({ columnGap: t.columnGap, rowGap: t.rowGap, maxCols: l.value }),
      t.wideColumns === void 0 ? void 0 : `hp-layout-grid--wide-cols-${t.wideColumns}`,
      t.class
    ]), c = m(() => {
      const s = {};
      return t.columns !== "auto" && (s["--layout-grid-col-count"] = String(t.columns)), s["--layout-grid-col-gap"] = `var(--space-${t.columnGap})`, (t.minColumnWidth !== "370px" || t.columns === "auto") && (s["--layout-grid-min-col-width"] = t.minColumnWidth), l.value && (s["--layout-grid-max-col-count"] = String(t.maxColumns)), t.rows !== "auto" && (s["--layout-grid-rows"] = `repeat(${t.rows}, 1fr)`), t.spanCols && (s["grid-column"] = t.spanCols === "full" ? "1 / -1" : `span ${t.spanCols}`), t.spanRows && (s["grid-row"] = t.spanRows === "full" ? "1 / -1" : `span ${t.spanRows}`), s;
    });
    return (s, p) => (i(), g("div", {
      class: W(r.value),
      style: Ie(c.value)
    }, [
      L(s.$slots, "default")
    ], 6));
  }
}), cD = /* @__PURE__ */ Y({
  __name: "LayoutItem",
  props: {
    spanCols: {},
    spanRows: {},
    class: {}
  },
  setup(e) {
    const t = e, n = m(() => {
      const a = {};
      return t.spanCols && (a["grid-column"] = t.spanCols === "full" ? "1 / -1" : `span ${t.spanCols}`), t.spanRows && (a["grid-row"] = t.spanRows === "full" ? "1 / -1" : `span ${t.spanRows}`), Object.keys(a).length > 0 ? a : void 0;
    });
    return (a, o) => (i(), g("div", {
      class: W(["hp-layout-item", t.class]),
      style: Ie(n.value)
    }, [
      L(a.$slots, "default")
    ], 6));
  }
}), Co = /* @__PURE__ */ Y({
  __name: "ListEmpty",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = Le(), n = e;
    return (a, o) => (i(), g("div", {
      class: W(["hp-list-empty", n.class])
    }, [
      L(a.$slots, "default", {}, () => [
        L(a.$slots, "icon"),
        L(a.$slots, "title", {}, () => [
          j(u(at), {
            size: "2",
            variant: "soft"
          }, {
            default: B(() => [
              me(le(u(t)("ui.list.noItems", "No items")), 1)
            ]),
            _: 1
          })
        ]),
        L(a.$slots, "description"),
        L(a.$slots, "action")
      ])
    ], 2));
  }
}), uD = /* @__PURE__ */ Y({
  __name: "List",
  props: {
    maxHeight: { default: void 0 },
    borderless: { type: Boolean, default: !1 },
    transparent: { type: Boolean, default: !1 },
    empty: { type: Boolean, default: !1 },
    error: { type: Boolean, default: !1 },
    warning: { type: Boolean, default: !1 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = Le(), n = e, a = ze("hp-list", {
      variants: {
        hasMaxHeight: {
          true: "hp-list--has-max-height",
          false: ""
        },
        borderless: {
          true: "hp-list--borderless",
          false: ""
        },
        transparent: {
          true: "hp-list--transparent",
          false: ""
        }
      },
      defaultVariants: {
        hasMaxHeight: !1,
        borderless: !1,
        transparent: !1
      }
    }), o = m(
      () => a({
        hasMaxHeight: !!n.maxHeight,
        borderless: n.borderless,
        transparent: n.transparent,
        class: n.class
      })
    ), l = m(
      () => n.maxHeight ? { "--list-max-height": n.maxHeight } : void 0
    );
    return (r, c) => (i(), g("div", {
      class: W(o.value),
      style: Ie(l.value)
    }, [
      L(r.$slots, "default"),
      n.empty ? L(r.$slots, "empty", { key: 0 }, () => [
        j(Co, null, {
          default: B(() => [
            j(u(at), {
              size: "2",
              variant: "soft"
            }, {
              default: B(() => [
                me(le(u(t)("ui.list.noItems", "No items")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]) : A("", !0),
      n.error ? L(r.$slots, "error", { key: 1 }, () => [
        j(Co, { class: "hp-list-error" }, {
          default: B(() => [
            j(u(at), {
              size: "2",
              variant: "surface",
              color: "red"
            }, {
              default: B(() => [
                me(le(u(t)("ui.list.somethingWentWrong", "Something went wrong")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]) : A("", !0),
      n.warning ? L(r.$slots, "warning", { key: 2 }, () => [
        j(Co, { class: "hp-list-warning" }, {
          default: B(() => [
            j(u(at), {
              size: "2",
              variant: "surface",
              color: "orange"
            }, {
              default: B(() => [
                me(le(u(t)("ui.list.somethingWentWrong", "Something went wrong")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]) : A("", !0)
    ], 6));
  }
}), dD = /* @__PURE__ */ Y({
  __name: "ListDivider",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), g("div", {
      class: W(["hp-list-divider", t.class])
    }, null, 2));
  }
}), Hw = { class: "hp-list-group__content" }, pD = /* @__PURE__ */ Y({
  __name: "ListGroup",
  props: {
    label: { default: void 0 },
    collapsible: { type: Boolean, default: !1 },
    expanded: { type: Boolean, default: !0 },
    empty: { type: Boolean, default: !1 },
    class: { default: void 0 }
  },
  emits: ["update:expanded"],
  setup(e, { emit: t }) {
    const n = Le(), a = e, o = t;
    return (l, r) => (i(), g("div", {
      class: W(["hp-list-group", a.class])
    }, [
      C("div", {
        class: W([
          "hp-list-group__label",
          a.collapsible && "hp-list-group__label--collapsible"
        ]),
        onClick: r[0] || (r[0] = (c) => a.collapsible && o("update:expanded", !a.expanded))
      }, [
        a.collapsible ? (i(), g("span", {
          key: 0,
          class: W([
            "hp-list-group__chevron",
            a.expanded && "hp-list-group__chevron--expanded"
          ])
        }, [
          j(Ka)
        ], 2)) : A("", !0),
        L(l.$slots, "label", {}, () => [
          j(u(at), {
            size: "1",
            weight: "semibold"
          }, {
            default: B(() => [
              me(le(a.label), 1)
            ]),
            _: 1
          })
        ])
      ], 2),
      ra(C("div", Hw, [
        L(l.$slots, "default"),
        a.empty ? L(l.$slots, "empty", { key: 0 }, () => [
          j(Co, null, {
            default: B(() => [
              me(le(u(n)("ui.list.noItems", "No items")), 1)
            ]),
            _: 1
          })
        ]) : A("", !0)
      ], 512), [
        [xa, !a.collapsible || a.expanded]
      ])
    ], 2));
  }
}), fD = /* @__PURE__ */ Y({
  __name: "ListHeader",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), g("div", {
      class: W(["hp-list-header", t.class])
    }, [
      L(n.$slots, "default")
    ], 2));
  }
}), hu = /* @__PURE__ */ Symbol("ListItemContext"), hD = /* @__PURE__ */ Y({
  __name: "ListItem",
  props: {
    size: { default: "2" },
    active: { type: Boolean, default: !1 },
    checked: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    excluded: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    interactive: { type: Boolean, default: !0 },
    transparent: { type: Boolean, default: !1 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = e;
    Dt(hu, Na({
      checked: Ze(t, "checked"),
      indeterminate: Ze(t, "indeterminate"),
      disabled: Ze(t, "disabled")
    }));
    const n = ze("hp-list-item", {
      variants: {
        size: {
          1: "hp-list-item--size-1",
          2: "hp-list-item--size-2",
          3: "hp-list-item--size-3"
        },
        interactive: {
          true: "hp-list-item--interactive",
          false: ""
        },
        active: {
          true: "hp-list-item--active",
          false: ""
        },
        checked: {
          true: "hp-list-item--checked",
          false: ""
        },
        excluded: {
          true: "hp-list-item--excluded",
          false: ""
        },
        disabled: {
          true: "hp-list-item--disabled",
          false: ""
        },
        transparent: {
          true: "hp-list-item--transparent",
          false: ""
        }
      },
      defaultVariants: {
        size: "2",
        interactive: !0,
        active: !1,
        checked: !1,
        excluded: !1,
        disabled: !1,
        transparent: !1
      }
    }), a = m(
      () => n({
        size: t.size,
        interactive: t.interactive,
        active: t.active,
        checked: t.checked,
        excluded: t.excluded,
        disabled: t.disabled || t.loading,
        transparent: t.transparent,
        class: t.class
      })
    );
    return (o, l) => (i(), g("div", {
      class: W(a.value)
    }, [
      L(o.$slots, "default"),
      t.loading ? (i(), R(u(Io), {
        key: 0,
        class: "hp-list-item__loader",
        size: "1"
      })) : A("", !0)
    ], 2));
  }
}), vD = /* @__PURE__ */ Y({
  __name: "ListItemCheckbox",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = pt(hu, void 0);
    return (a, o) => (i(), g("div", {
      class: W(["hp-list-item-checkbox", t.class])
    }, [
      j(u(ln), {
        "model-value": u(n)?.checked ?? !1,
        indeterminate: u(n)?.indeterminate ?? !1,
        disabled: u(n)?.disabled ?? !1,
        variant: "surface",
        size: "2"
      }, null, 8, ["model-value", "indeterminate", "disabled"])
    ], 2));
  }
}), mD = /* @__PURE__ */ Y({
  __name: "ListItemIcon",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), g("div", {
      class: W(["hp-list-item-icon", t.class])
    }, [
      L(n.$slots, "default")
    ], 2));
  }
}), gD = /* @__PURE__ */ Y({
  __name: "ListItemRight",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), g("div", {
      class: W(["hp-list-item-right", t.class])
    }, [
      L(n.$slots, "default")
    ], 2));
  }
}), yD = /* @__PURE__ */ Y({
  __name: "ListItemText",
  props: {
    class: { default: void 0 }
  },
  setup(e) {
    return (t, n) => (i(), R(u(at), {
      class: "hp-list-item-text",
      size: "2",
      weight: "medium"
    }, {
      default: B(() => [
        L(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), wD = (e) => {
  const t = m(() => xo(e.nodes) ? e.nodes.value : e.nodes), n = N(/* @__PURE__ */ new Set()), a = N(/* @__PURE__ */ new Set()), o = /* @__PURE__ */ new WeakMap(), l = (x) => {
    const b = o.get(x);
    if (b)
      return b;
    const k = x.children?.length ? x.children.flatMap(l) : [x.id];
    return o.set(x, k), k;
  };
  if (e.defaultExpanded) {
    const x = (b) => {
      const k = [];
      return b.forEach((_) => {
        _.children?.length && (k.push(_.id), k.push(...x(_.children)));
      }), k;
    };
    x(t.value).forEach((b) => a.value.add(b)), Se(t, (b) => {
      if (!b)
        return;
      const k = x(b);
      let _ = !1;
      k.forEach((T) => {
        a.value.has(T) || (a.value.add(T), _ = !0);
      }), _ && zn(a);
    });
  }
  const r = (x) => {
    const b = a.value.has(x.id);
    if (!x.children?.length)
      return { checked: n.value.has(x.id), indeterminate: !1, expanded: b };
    const k = l(x), _ = k.filter((T) => n.value.has(T)).length;
    return {
      checked: _ === k.length,
      indeterminate: _ > 0 && _ < k.length,
      expanded: b
    };
  }, c = (x) => {
    const b = r(x);
    if (!x.children?.length)
      n.value.has(x.id) ? n.value.delete(x.id) : n.value.add(x.id);
    else {
      const k = l(x), _ = b.checked ? (T) => n.value.delete(T) : (T) => n.value.add(T);
      k.forEach(_);
    }
    zn(n);
  }, s = (x) => {
    a.value.has(x.id) ? a.value.delete(x.id) : a.value.add(x.id), zn(a);
  }, p = (x) => {
    (x ?? t.value).flatMap(l).forEach((k) => n.value.add(k)), zn(n);
  }, d = () => {
    n.value.clear(), zn(n);
  }, f = m(() => [...n.value]), h = m(() => {
    const x = t.value.flatMap(l);
    return x.length > 0 && x.every((b) => n.value.has(b));
  }), $ = m(() => n.value.size > 0), y = (x, b, k = []) => ({ last: b.indexOf(x) === b.length - 1, lines: k }), w = (x, b, k = []) => {
    const _ = x.indexOf(b);
    return [...k, _ !== x.length - 1];
  }, v = m(() => {
    const x = [], b = (k, _, T) => {
      k.forEach((S, M) => {
        const E = M === k.length - 1, F = !!S.children?.length, H = r(S);
        x.push({
          node: S,
          depth: _,
          last: E,
          lines: T,
          expandable: F,
          expanded: H.expanded,
          checked: H.checked,
          indeterminate: H.indeterminate
        }), F && a.value.has(S.id) && b(S.children, _ + 1, [...T, !E]);
      });
    };
    return b(t.value, 0, []), x;
  });
  return {
    getNodeState: r,
    getNodePosition: y,
    childLines: w,
    toggleNode: c,
    toggleExpand: s,
    selectAll: p,
    deselectAll: d,
    selectedIds: f,
    allSelected: h,
    someSelected: $,
    flattenedNodes: v
  };
}, Nw = {
  key: 3,
  class: "hp-tree-connector__chevron-spacer"
}, Vl = /* @__PURE__ */ Y({
  __name: "TreeConnector",
  props: {
    depth: { default: 0 },
    expandable: { type: Boolean, default: !1 },
    expanded: { type: Boolean, default: !1 },
    last: { type: Boolean, default: !1 },
    lines: { default: () => [] },
    showLines: { type: Boolean, default: !0 },
    showChevronSpacer: { type: Boolean, default: !0 },
    shrink: { type: Boolean, default: !1 },
    class: { default: void 0 }
  },
  emits: ["expand"],
  setup(e, { emit: t }) {
    const n = t, a = e;
    return (o, l) => (i(), g("div", {
      class: W(["hp-tree-connector", a.shrink && "hp-tree-connector--shrink", a.class])
    }, [
      a.showLines ? (i(), g(he, { key: 0 }, [
        (i(!0), g(he, null, De(a.lines ?? [], (r, c) => (i(), g("span", {
          key: c,
          class: W([
            "hp-tree-connector__line",
            r && "hp-tree-connector__line--active"
          ])
        }, null, 2))), 128)),
        a.depth > 0 ? (i(), g("span", {
          key: 0,
          class: W([
            "hp-tree-connector__branch",
            a.last && "hp-tree-connector__branch--last"
          ])
        }, null, 2)) : A("", !0)
      ], 64)) : a.depth > 0 ? (i(), g("span", {
        key: 1,
        style: Ie({ width: `${a.depth * (a.shrink ? 10 : 16)}px` }),
        class: "hp-tree-connector__indent"
      }, null, 4)) : A("", !0),
      a.expandable ? (i(), g("span", {
        key: 2,
        "data-range-ignore": "",
        class: W([
          "hp-tree-connector__chevron",
          a.expanded && "hp-tree-connector__chevron--expanded"
        ]),
        onClick: l[0] || (l[0] = Fe((r) => n("expand"), ["stop"]))
      }, [
        j(Ka)
      ], 2)) : a.showChevronSpacer ? (i(), g("span", Nw)) : A("", !0),
      L(o.$slots, "default")
    ], 2));
  }
}), bD = /* @__PURE__ */ Y({
  __name: "TreePadding",
  props: {
    depth: { default: 0 },
    shrink: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = m(() => t.shrink ? 10 : 16);
    return (a, o) => t.depth > 0 ? (i(), g("span", {
      key: 0,
      style: Ie({ width: `${t.depth * n.value}px` }),
      class: "hp-tree-padding",
      "aria-hidden": "true"
    }, null, 4)) : A("", !0);
  }
}), kD = /* @__PURE__ */ Y({
  __name: "ListItemTree",
  props: {
    depth: { default: 0 },
    expandable: { type: Boolean, default: !1 },
    expanded: { type: Boolean, default: !1 },
    last: { type: Boolean, default: !1 },
    lines: { default: () => [] },
    showLines: { type: Boolean, default: !0 },
    showChevronSpacer: { type: Boolean },
    shrink: { type: Boolean, default: !1 },
    class: { default: void 0 }
  },
  emits: ["expand"],
  setup(e, { emit: t }) {
    const n = t, a = e;
    return (o, l) => (i(), g("div", {
      class: W(["hp-list-item-tree", a.class])
    }, [
      j(u(Vl), {
        depth: a.depth,
        expandable: a.expandable,
        expanded: a.expanded,
        last: a.last,
        lines: a.lines,
        "show-lines": a.showLines,
        shrink: a.shrink,
        onExpand: l[0] || (l[0] = (r) => n("expand"))
      }, null, 8, ["depth", "expandable", "expanded", "last", "lines", "show-lines", "shrink"]),
      L(o.$slots, "default")
    ], 2));
  }
}), _D = /* @__PURE__ */ Y({
  __name: "ListLoader",
  props: {
    loading: { type: Boolean, default: !0 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), R(u(Mn), {
      loading: e.loading,
      class: W(t.class)
    }, null, 8, ["loading", "class"]));
  }
}), Fw = { class: "hp-side-menu__icon d-flex items-center shrink-0" }, Ws = /* @__PURE__ */ Y({
  __name: "MenuIcon",
  props: {
    icon: {}
  },
  setup(e) {
    return (t, n) => (i(), g("span", Fw, [
      (i(), R(Pe(e.icon)))
    ]));
  }
}), vu = /* @__PURE__ */ Symbol("SideMenu"), jo = () => pt(vu, {
  size: m(() => "3"),
  variant: m(() => "blank")
}), Kw = { class: "hp-side-menu__child-content d-flex items-center gap-2 min-w-0" }, Yw = { class: "hp-side-menu__child-content d-flex items-center gap-2 min-w-0" }, jw = /* @__PURE__ */ Y({
  __name: "MenuSubItem",
  props: {
    dense: { type: Boolean, default: !1 },
    showTreeChevronSpacer: { type: Boolean, default: void 0 },
    variant: { default: void 0 },
    compactIcon: { default: void 0 },
    compactPresentation: { default: "icon" },
    link: { default: void 0 },
    active: { type: Boolean, default: !1 }
  },
  emits: ["click"],
  setup(e) {
    const t = e, n = jo(), a = m(() => t.variant ?? n.variant.value), o = m(() => !!(n.collapsed?.value && !n.revealLabels?.value)), l = ze("", {
      variants: {
        size: {
          1: "hp-side-menu__child--size-1",
          2: "hp-side-menu__child--size-2",
          3: "hp-side-menu__child--size-3",
          4: "hp-side-menu__child--size-4"
        },
        dense: { true: "hp-side-menu__child--dense" },
        compact: { true: "hp-side-menu__child--compact" },
        compactText: { true: "hp-side-menu__child--compact-text" },
        variant: {
          blank: "hp-side-menu__child--blank",
          soft: "hp-side-menu__child--soft",
          surface: "hp-side-menu__child--surface",
          attention: "hp-side-menu__child--attention"
        }
      },
      defaultVariants: { size: "3", variant: "blank" }
    }), r = m(
      () => l({
        size: n.size.value,
        compact: o.value,
        compactText: o.value && t.compactPresentation !== "icon",
        dense: t.dense,
        variant: a.value,
        class: t.active ? "is-active" : void 0
      })
    );
    return (c, s) => (i(), R(Pe(c.$slots.actions ? "div" : e.link ? "router-link" : "div"), {
      to: c.$slots.actions ? void 0 : e.link,
      "exact-active-class": "is-active",
      "active-class": "",
      onClick: s[2] || (s[2] = (p) => !c.$slots.actions && c.$emit("click")),
      class: W(["hp-side-menu__child", r.value]),
      "data-theme": a.value === "attention" ? "purple" : void 0
    }, {
      default: B(() => [
        c.$slots.actions ? (i(), g(he, { key: 0 }, [
          (i(), R(Pe(e.link ? "router-link" : "div"), {
            to: e.link,
            class: "hp-side-menu__child-navigation",
            onClick: s[0] || (s[0] = (p) => c.$emit("click"))
          }, {
            default: B(() => [
              o.value ? A("", !0) : (i(), R(Vl, {
                key: 0,
                class: "hp-side-menu__child-tree",
                shrink: e.dense,
                "show-chevron-spacer": e.showTreeChevronSpacer ?? !e.dense,
                depth: 1,
                "aria-hidden": "true"
              }, null, 8, ["shrink", "show-chevron-spacer"])),
              C("div", Kw, [
                o.value && e.compactPresentation === "icon" && e.compactIcon ? (i(), R(Ws, {
                  key: 0,
                  icon: e.compactIcon
                }, null, 8, ["icon"])) : A("", !0),
                L(c.$slots, "default")
              ])
            ]),
            _: 3
          }, 8, ["to"])),
          C("span", {
            class: "hp-side-menu__child-actions",
            onClick: s[1] || (s[1] = Fe(() => {
            }, ["stop"]))
          }, [
            L(c.$slots, "actions")
          ])
        ], 64)) : (i(), g(he, { key: 1 }, [
          o.value ? A("", !0) : (i(), R(Vl, {
            key: 0,
            class: "hp-side-menu__child-tree",
            shrink: e.dense,
            "show-chevron-spacer": e.showTreeChevronSpacer ?? !e.dense,
            depth: 1,
            "aria-hidden": "true"
          }, null, 8, ["shrink", "show-chevron-spacer"])),
          C("div", Yw, [
            o.value && e.compactPresentation === "icon" && e.compactIcon ? (i(), R(Ws, {
              key: 0,
              icon: e.compactIcon
            }, null, 8, ["icon"])) : A("", !0),
            L(c.$slots, "default")
          ])
        ], 64))
      ]),
      _: 3
    }, 8, ["to", "class", "data-theme"]));
  }
}), Ww = { class: "hp-menu-chip-item__compact-label" }, CD = /* @__PURE__ */ Y({
  __name: "MenuChipItem",
  props: {
    dense: { type: Boolean, default: !0 },
    variant: { default: "soft" },
    compactIcon: { default: void 0 },
    compactPresentation: { default: "icon" },
    link: { default: void 0 },
    active: { type: Boolean, default: !1 },
    icon: { default: void 0 },
    color: { default: void 0 },
    size: { default: "3" }
  },
  emits: ["click"],
  setup(e) {
    const t = e, n = jo(), a = m(() => !!(n.collapsed?.value && !n.revealLabels?.value)), o = m(() => a.value && t.compactPresentation === "icon" && !!(t.compactIcon ?? t.icon)), l = ze("hp-menu-chip-item", {
      variants: {
        compact: { false: "hp-menu-chip-item--expanded" },
        compactChip: { true: "hp-menu-chip-item--compact-icon" },
        size: {
          1: "hp-menu-chip-item--size-1",
          2: "hp-menu-chip-item--size-2",
          3: "hp-menu-chip-item--size-3",
          4: "hp-menu-chip-item--size-4",
          5: "hp-menu-chip-item--size-5"
        }
      }
    }), r = m(() => l({ compact: a.value, compactChip: o.value, size: t.size }));
    return (c, s) => (i(), R(jw, {
      class: W(r.value),
      link: e.link,
      active: e.active,
      dense: e.dense,
      "show-tree-chevron-spacer": "",
      variant: e.variant,
      "compact-icon": o.value ? void 0 : e.compactIcon ?? e.icon,
      "compact-presentation": e.compactPresentation,
      onClick: s[0] || (s[0] = (p) => c.$emit("click"))
    }, it({
      default: B(() => [
        o.value ? (i(), g(he, { key: 0 }, [
          j(Ht, {
            size: e.size,
            icon: e.compactIcon ?? e.icon,
            color: e.active ? e.color : void 0,
            active: e.active,
            variant: "soft",
            radius: "full",
            square: "",
            clickable: ""
          }, null, 8, ["size", "icon", "color", "active"]),
          C("span", Ww, [
            L(c.$slots, "default")
          ])
        ], 64)) : a.value ? L(c.$slots, "default", { key: 1 }) : (i(), R(Ht, {
          key: 2,
          size: e.size,
          icon: e.icon,
          color: e.active ? e.color : void 0,
          active: e.active,
          variant: "soft",
          radius: "full",
          clickable: "",
          truncate: "",
          "max-width": "100%"
        }, {
          default: B(() => [
            L(c.$slots, "default")
          ]),
          _: 3
        }, 8, ["size", "icon", "color", "active"]))
      ]),
      _: 2
    }, [
      c.$slots.actions ? {
        name: "actions",
        fn: B(() => [
          L(c.$slots, "actions")
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["class", "link", "active", "dense", "variant", "compact-icon", "compact-presentation"]));
  }
}), Uw = ["src", "alt"], xD = /* @__PURE__ */ Y({
  __name: "NavigationBrand",
  props: {
    src: {},
    compactSrc: {},
    alt: {},
    compact: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = e, n = ze("hp-navigation-brand", {
      variants: { compact: { true: "hp-navigation-brand--compact" } }
    }), a = m(() => n({ compact: t.compact }));
    return (o, l) => (i(), g("div", {
      class: W(a.value)
    }, [
      C("img", {
        src: e.compact ? e.compactSrc : e.src,
        alt: e.alt
      }, null, 8, Uw)
    ], 2));
  }
}), Aa = {
  xs: 0,
  sm: 430,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1440,
  xxxl: 1680,
  wide: 1920,
  ultrawide: 2560
}, ho = Object.keys(Aa), qw = () => {
  const e = N(typeof window < "u" ? window.innerWidth : 0), t = () => {
    e.value = window.innerWidth;
  };
  tt(() => {
    window.addEventListener("resize", t);
  }), ct(() => {
    window.removeEventListener("resize", t);
  });
  const n = m(() => {
    let p = "xs";
    for (const d of ho)
      e.value >= Aa[d] && (p = d);
    return p;
  }), a = (p) => e.value >= Aa[p], o = (p) => {
    const d = ho.indexOf(p);
    if (d >= 0 && d < ho.length - 1) {
      const f = ho[d + 1];
      return e.value < Aa[f];
    }
    return !0;
  }, l = (p, d) => a(p) && o(d), r = m(() => e.value < Aa.md), c = m(() => e.value >= Aa.md && e.value < Aa.xl), s = m(() => e.value >= Aa.xl);
  return {
    width: e,
    current: n,
    up: a,
    down: o,
    between: l,
    isMobile: r,
    isTablet: c,
    isDesktop: s
  };
}, Zw = {}, Gw = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Xw(e, t) {
  return i(), g("svg", Gw, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M7 3H13M8 3V8L5 12V13H15V12L12 8V3M10 13V18",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Qw = /* @__PURE__ */ se(Zw, [["render", Xw]]), Jw = {}, eb = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function tb(e, t) {
  return i(), g("svg", eb, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M8 3H13M12 3V7M15 12V13H9M8 8L5 12V13H6M10 13V18M3 3L17 17",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const ab = /* @__PURE__ */ se(Jw, [["render", tb]]), Us = /* @__PURE__ */ Y({
  __name: "SideMenuNew",
  props: {
    collapsed: { type: Boolean },
    showCollapsedChildren: { type: Boolean },
    revealLabels: { type: Boolean },
    size: { default: "3" },
    variant: { default: "blank" },
    items: {}
  },
  setup(e) {
    const t = e, n = ze("hp-side-menu d-flex flex-column", { variants: { size: { 1: "hp-side-menu--size-1", 2: "hp-side-menu--size-2", 3: "hp-side-menu--size-3", 4: "hp-side-menu--size-4" }, showCollapsedChildren: { true: "hp-side-menu--show-collapsed-children" }, collapsed: { true: "hp-side-menu--collapsed" }, revealLabels: { true: "hp-side-menu--reveal-labels" } } }), a = m(() => n({ showCollapsedChildren: t.showCollapsedChildren, size: t.size, collapsed: t.collapsed, revealLabels: t.collapsed && t.revealLabels }));
    return Dt(vu, {
      collapsed: m(() => t.collapsed ?? !1),
      revealLabels: m(() => t.revealLabels ?? !1),
      size: m(() => t.size),
      variant: m(() => t.variant)
    }), (o, l) => (i(), g("nav", {
      class: W(a.value)
    }, [
      L(o.$slots, "default")
    ], 2));
  }
}), qs = /* @__PURE__ */ Symbol("navigation-drawer-group"), nb = /* @__PURE__ */ Y({
  inheritAttrs: !1,
  __name: "NavigationDrawerGroup",
  props: {
    active: { type: Boolean },
    expanded: { type: Boolean }
  },
  emits: ["leave", "blur"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = ze("hp-navigation-drawer-group", {
      variants: { expanded: { true: "hp-navigation-drawer-group--expanded" } }
    }), l = m(() => o({ expanded: n.expanded }));
    return (r, c) => e.active ? (i(), g("div", {
      key: 0,
      class: W(l.value),
      onPointerleave: c[0] || (c[0] = (s) => a("leave", s)),
      onFocusout: c[1] || (c[1] = (s) => a("blur", s))
    }, [
      L(r.$slots, "default")
    ], 34)) : L(r.$slots, "default", { key: 1 });
  }
}), ob = /* @__PURE__ */ Y({
  __name: "PageShellSidebar",
  props: {
    mobile: { type: Boolean },
    collapsed: { type: Boolean },
    persistent: { type: Boolean },
    bordered: { type: Boolean },
    expandOnHover: { type: Boolean },
    expanded: { type: Boolean, default: void 0 }
  },
  setup(e) {
    const t = e, n = N(!1), a = N(!1), o = m(() => t.collapsed && t.expandOnHover), l = m(() => !!(t.collapsed && !(o.value && (t.expanded ?? (n.value || a.value))))), r = ze("hp-page-shell__sidebar", { variants: {
      mobile: { true: "hp-page-shell__sidebar--mobile" },
      bordered: { true: "hp-page-shell__sidebar--bordered" },
      persistent: { true: "hp-page-shell__sidebar--persistent" },
      collapsed: { true: "hp-page-shell__sidebar--collapsed" },
      overlay: { true: "hp-page-shell__sidebar--overlay" }
    } }), c = ze("hp-page-shell__sidebar-surface", { variants: {
      expanded: { true: "hp-page-shell__sidebar-surface--expanded" }
    } }), s = m(() => r({ ...t, overlay: o.value })), p = m(() => c({ expanded: o.value && !l.value })), d = (h) => {
      h.pointerType === "mouse" && (n.value = !0);
    }, f = (h) => {
      h.currentTarget instanceof HTMLElement && !h.currentTarget.contains(h.relatedTarget) && (a.value = !1);
    };
    return (h, $) => (i(), g("div", {
      class: W(s.value),
      onPointerenter: d,
      onPointerleave: $[0] || ($[0] = (y) => n.value = !1),
      onFocusin: $[1] || ($[1] = (y) => a.value = !0),
      onFocusout: f
    }, [
      C("div", {
        class: W(p.value)
      }, [
        L(h.$slots, "default", { collapsed: l.value })
      ], 2)
    ], 34));
  }
}), lb = ["aria-label"], $D = /* @__PURE__ */ Y({
  inheritAttrs: !1,
  __name: "NavigationDrawer",
  props: /* @__PURE__ */ Xe({
    bordered: { type: [Boolean, String], default: !0 },
    closeDelay: { default: 150 },
    size: { default: "3" },
    width: { default: "2" },
    label: { default: void 0 },
    showToggle: { type: Boolean, default: !0 },
    showMobileClose: { type: Boolean, default: !0 },
    showCollapsedChildren: { type: Boolean },
    controlsPlacement: { default: "flow" },
    dockFrom: { default: "md" }
  }, {
    pinned: { type: Boolean, default: !1 },
    pinnedModifiers: {},
    open: { type: Boolean, default: !1 },
    openModifiers: {},
    hovered: { type: Boolean, default: !1 },
    hoveredModifiers: {}
  }),
  emits: ["update:pinned", "update:open", "update:hovered"],
  setup(e) {
    const t = e, n = N(!1), a = ze("hp-navigation-drawer", {
      variants: {
        attached: { true: "hp-navigation-drawer--attached" },
        width: {
          1: "hp-navigation-drawer--width-1",
          2: "hp-navigation-drawer--width-2",
          3: "hp-navigation-drawer--width-3",
          4: "hp-navigation-drawer--width-4",
          5: "hp-navigation-drawer--width-5",
          6: "hp-navigation-drawer--width-6",
          7: "hp-navigation-drawer--width-7"
        }
      },
      defaultVariants: { width: "2" }
    }), o = m(() => a({ width: t.width, attached: n.value })), l = vt(e, "pinned"), r = vt(e, "open"), c = vt(e, "hovered"), s = Le(), p = N(), d = mt(), f = pt(qs, void 0), h = () => !!d.secondary && !v.value;
    let $, y;
    const w = () => {
      clearTimeout(y), y = void 0;
    };
    tt(() => {
      $ = requestAnimationFrame(() => {
        !v.value && window.matchMedia("(any-hover: hover)").matches && p.value?.matches(":hover") && (c.value = !0);
      });
    }), ct(() => {
      w(), $ !== void 0 && cancelAnimationFrame($);
    });
    const { isMobile: v, up: x } = qw();
    let b = null;
    Se(() => v.value && r.value, async (P) => {
      P ? (b = document.activeElement instanceof HTMLElement ? document.activeElement : null, await Ye(), (p.value?.querySelector('button:not([disabled]), a[href], [tabindex="0"]') ?? p.value)?.focus()) : (b?.focus(), b = null);
    });
    const k = m(() => !v.value && x(t.dockFrom)), _ = m(() => k.value && l.value), T = m(() => v.value ? !0 : _.value || r.value || c.value);
    Dt(qs, { expanded: T, overlay: m(() => !v.value && !_.value) }), Se(T, (P) => {
      P || (n.value = !1);
    });
    const S = m(() => t.bordered === "expanded" ? T.value : t.bordered), M = () => {
      w(), T.value ? (_.value && (l.value = !1), r.value = !1, c.value = !1) : r.value = !0;
    }, E = () => {
      w();
      const P = !l.value;
      l.value = P, r.value = P, P || (c.value = !1);
    }, F = () => {
      w();
      const P = () => {
        r.value = !1, c.value = !1, y = void 0;
      };
      t.closeDelay > 0 ? y = setTimeout(P, t.closeDelay) : P();
    }, H = (P) => {
      v.value || P.currentTarget instanceof HTMLElement && P.currentTarget.contains(P.relatedTarget) || (_.value ? c.value = !1 : F());
    }, te = (P) => {
      h() || H(P);
    }, ie = (P) => {
      !v.value && P.currentTarget instanceof HTMLElement && !P.currentTarget.contains(P.relatedTarget) && !_.value && F();
    }, ee = (P) => {
      h() || ie(P);
    }, O = () => {
      T.value || (n.value = !!(f?.expanded.value && f.overlay.value));
    }, z = (P) => {
      !v.value && P.pointerType === "mouse" && (O(), w(), c.value = !0);
    }, D = (P) => {
      w(), P.target instanceof HTMLElement && P.target.matches(":focus-visible") && (v.value || O(), r.value = !0);
    };
    return (P, Z) => (i(), R(nb, {
      active: h(),
      expanded: T.value && !_.value,
      onLeave: H,
      onBlur: ie
    }, {
      default: B(() => [
        j(Ra, { name: "hp-navigation-backdrop" }, {
          default: B(() => [
            u(v) && r.value ? (i(), g("div", {
              key: 0,
              class: "hp-navigation-drawer__backdrop",
              "aria-hidden": "true",
              onClick: F
            })) : A("", !0)
          ]),
          _: 1
        }),
        j(Ra, {
          name: "hp-navigation-slide",
          css: u(v)
        }, {
          default: B(() => [
            ra(j(ob, Ke(P.$attrs, {
              mobile: u(v),
              class: o.value,
              bordered: S.value,
              persistent: "",
              "expand-on-hover": "",
              collapsed: !_.value,
              expanded: T.value,
              onPointerenter: z,
              onPointermove: z,
              onPointerleave: te,
              onFocusin: D,
              onFocusout: ee,
              onKeydown: sa(F, ["esc"])
            }), {
              default: B(() => [
                C("nav", {
                  ref_key: "body",
                  ref: p,
                  tabindex: "-1",
                  "aria-label": t.label ?? u(s)("ui.navigationDrawer.label", "Navigation"),
                  class: "hp-navigation-drawer__body pt-2 pb-4"
                }, [
                  !u(v) && (e.showToggle || T.value) ? (i(), g("div", {
                    key: 0,
                    class: W(["hp-navigation-drawer__controls d-flex justify-between items-center", { "hp-navigation-drawer__controls--corner": e.controlsPlacement === "corner" }])
                  }, [
                    e.showToggle ? (i(), R(Ae, {
                      key: 0,
                      size: "3",
                      variant: "blank",
                      square: "",
                      icon: T.value ? Oo : Ka,
                      "aria-expanded": T.value,
                      "aria-label": T.value ? u(s)("ui.navigationDrawer.collapse", "Collapse menu") : u(s)("ui.navigationDrawer.expand", "Expand menu"),
                      title: T.value ? u(s)("ui.navigationDrawer.collapse", "Collapse menu") : u(s)("ui.navigationDrawer.expand", "Expand menu"),
                      onClick: M
                    }, null, 8, ["icon", "aria-expanded", "aria-label", "title"])) : A("", !0),
                    T.value && k.value ? (i(), R(Ae, {
                      key: 1,
                      class: "hp-navigation-drawer__pin",
                      size: "1",
                      variant: "surface",
                      square: "",
                      radius: "full",
                      icon: l.value ? Qw : ab,
                      "aria-pressed": l.value,
                      "aria-label": l.value ? u(s)("ui.navigationDrawer.unpin", "Unpin menu") : u(s)("ui.navigationDrawer.pin", "Pin menu"),
                      title: l.value ? u(s)("ui.navigationDrawer.unpin", "Unpin menu") : u(s)("ui.navigationDrawer.pin", "Pin menu"),
                      onClick: E
                    }, null, 8, ["icon", "aria-pressed", "aria-label", "title"])) : A("", !0)
                  ], 2)) : A("", !0),
                  u(v) && e.showMobileClose ? (i(), R(Ae, {
                    key: 1,
                    class: "hp-navigation-drawer__mobile-close",
                    size: "1",
                    variant: "surface",
                    square: "",
                    radius: "full",
                    icon: zt,
                    "aria-label": u(s)("ui.navigationDrawer.collapse", "Collapse menu"),
                    onClick: F
                  }, null, 8, ["aria-label"])) : A("", !0),
                  j(Us, {
                    class: "hp-navigation-drawer__content",
                    "show-collapsed-children": e.showCollapsedChildren,
                    size: e.size,
                    collapsed: !_.value,
                    "reveal-labels": !_.value && T.value
                  }, {
                    default: B(() => [
                      L(P.$slots, "default", {
                        expanded: T.value,
                        pinned: l.value,
                        docked: _.value
                      })
                    ]),
                    _: 3
                  }, 8, ["show-collapsed-children", "size", "collapsed", "reveal-labels"]),
                  P.$slots.footer ? (i(), R(Us, {
                    key: 2,
                    class: "hp-navigation-drawer__footer",
                    size: e.size,
                    collapsed: !_.value,
                    "reveal-labels": !_.value && T.value
                  }, {
                    default: B(() => [
                      L(P.$slots, "footer", {
                        expanded: T.value,
                        pinned: l.value,
                        docked: _.value
                      })
                    ]),
                    _: 3
                  }, 8, ["size", "collapsed", "reveal-labels"])) : A("", !0)
                ], 8, lb)
              ]),
              _: 3
            }, 16, ["mobile", "class", "bordered", "collapsed", "expanded"]), [
              [xa, !u(v) || r.value]
            ])
          ]),
          _: 3
        }, 8, ["css"]),
        h() ? L(P.$slots, "secondary", {
          key: 0,
          expanded: T.value,
          pinned: l.value,
          docked: _.value
        }) : A("", !0)
      ]),
      _: 3
    }, 8, ["active", "expanded"]));
  }
}), SD = /* @__PURE__ */ Y({
  __name: "PageContent",
  props: {
    uniformPadding: { type: Boolean },
    fill: { type: Boolean }
  },
  setup(e) {
    const t = e, n = ze("hp-page-content", {
      variants: { fill: { true: "hp-page-content--fill" }, uniformPadding: { true: "hp-page-content--uniform-padding" } }
    }), a = m(() => n({ uniformPadding: t.uniformPadding, fill: t.fill }));
    return (o, l) => (i(), g("div", {
      class: W(a.value)
    }, [
      L(o.$slots, "default")
    ], 2));
  }
}), rb = {}, sb = { class: "hp-page-content__alerts" };
function ib(e, t) {
  return i(), g("div", sb, [
    L(e.$slots, "default")
  ]);
}
const MD = /* @__PURE__ */ se(rb, [["render", ib]]), cb = {}, ub = { class: "hp-page-content__body" };
function db(e, t) {
  return i(), g("div", ub, [
    L(e.$slots, "default")
  ]);
}
const DD = /* @__PURE__ */ se(cb, [["render", db]]), pb = {}, fb = { class: "hp-page-content__header" };
function hb(e, t) {
  return i(), g("div", fb, [
    L(e.$slots, "default")
  ]);
}
const TD = /* @__PURE__ */ se(pb, [["render", hb]]), vb = {}, mb = { class: "hp-page-header" };
function gb(e, t) {
  return i(), g("div", mb, [
    L(e.$slots, "default")
  ]);
}
const BD = /* @__PURE__ */ se(vb, [["render", gb]]), yb = {}, wb = { class: "hp-page-header__left" };
function bb(e, t) {
  return i(), g("div", wb, [
    L(e.$slots, "default")
  ]);
}
const zD = /* @__PURE__ */ se(yb, [["render", bb]]), kb = {}, _b = { class: "hp-page-header__right" };
function Cb(e, t) {
  return i(), g("div", _b, [
    L(e.$slots, "default")
  ]);
}
const AD = /* @__PURE__ */ se(kb, [["render", Cb]]), LD = /* @__PURE__ */ Y({
  __name: "PageShell",
  props: {
    contained: { type: Boolean }
  },
  setup(e) {
    return (t, n) => (i(), g("div", {
      class: W(["hp-page-shell", { "hp-page-shell--contained": e.contained }])
    }, [
      L(t.$slots, "default")
    ], 2));
  }
}), xb = {}, $b = { class: "hp-page-shell__content" };
function Sb(e, t) {
  return i(), g("div", $b, [
    L(e.$slots, "default")
  ]);
}
const ED = /* @__PURE__ */ se(xb, [["render", Sb]]), Mb = { class: "hp-page-shell-header__logo" }, ID = /* @__PURE__ */ Y({
  __name: "PageShellHeader",
  props: {
    compact: { type: Boolean, default: !1 },
    logoDivider: { type: Boolean, default: !0 }
  },
  setup(e) {
    const t = e, n = ze("hp-page-shell-header", {
      variants: { compact: { true: "hp-page-shell-header--compact" } }
    }), a = m(() => n({ compact: t.compact }));
    return (o, l) => (i(), g("div", {
      class: W([a.value, { "hp-page-shell-header--with-logo": o.$slots.logo }])
    }, [
      o.$slots.logo ? (i(), g(he, { key: 0 }, [
        C("div", Mb, [
          L(o.$slots, "logo")
        ]),
        e.logoDivider ? (i(), R(vr, {
          key: 0,
          orientation: "vertical",
          inset: "0"
        })) : A("", !0)
      ], 64)) : A("", !0),
      L(o.$slots, "default")
    ], 2));
  }
}), Db = { class: "hp-page-shell-header__caption" }, Tb = { class: "hp-page-shell-header__row" }, RD = /* @__PURE__ */ Y({
  __name: "PageShellHeaderLeft",
  setup(e) {
    return (t, n) => (i(), g("div", {
      class: W(["hp-page-shell-header__left", { "hp-page-shell-header__left--with-caption": t.$slots.caption }])
    }, [
      t.$slots.caption ? (i(), g(he, { key: 0 }, [
        C("div", Db, [
          L(t.$slots, "caption")
        ]),
        C("div", Tb, [
          L(t.$slots, "default")
        ])
      ], 64)) : L(t.$slots, "default", { key: 1 })
    ], 2));
  }
}), Bb = {}, zb = { class: "hp-page-shell-header__right" };
function Ab(e, t) {
  return i(), g("div", zb, [
    L(e.$slots, "default")
  ]);
}
const PD = /* @__PURE__ */ se(Bb, [["render", Ab]]), Lb = {}, Eb = { class: "hp-page-shell__panel" };
function Ib(e, t) {
  return i(), g("div", Eb, [
    L(e.$slots, "default")
  ]);
}
const OD = /* @__PURE__ */ se(Lb, [["render", Ib]]), Rb = {}, Pb = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ob(e, t) {
  return i(), g("svg", Pb, [...t[0] || (t[0] = [
    C("circle", {
      cx: "10",
      cy: "5",
      r: "1.5",
      fill: "var(--icon-fill, var(--icon-color, currentColor))"
    }, null, -1),
    C("circle", {
      cx: "10",
      cy: "10",
      r: "1.5",
      fill: "var(--icon-fill, var(--icon-color, currentColor))"
    }, null, -1),
    C("circle", {
      cx: "10",
      cy: "15",
      r: "1.5",
      fill: "var(--icon-fill, var(--icon-color, currentColor))"
    }, null, -1)
  ])]);
}
const Vb = /* @__PURE__ */ se(Rb, [["render", Ob]]), Hb = ["wide", "compact", "minimal"], Nb = { class: "hp-responsive-header-actions" }, Fb = ["data-mode"], VD = /* @__PURE__ */ Y({
  __name: "ResponsiveHeaderActions",
  props: {
    actions: {},
    size: { default: "3" },
    menuIcon: { default: Vb },
    menuLabel: { default: void 0 },
    menuVariant: { default: "blank" },
    menuColor: { default: void 0 }
  },
  setup(e) {
    const t = Le(), n = e, a = m(
      () => Hb.map((l) => {
        const r = [], c = [];
        for (const s of n.actions) {
          const p = s.presentation[l];
          p === "button" || p === "icon" ? r.push({ action: s, presentation: p }) : p === "menu" && (s.menuItems !== void 0 ? c.push(
            ...s.menuItems.map((d) => ({
              ...d,
              disabled: s.disabled || s.loading || d.disabled
            }))
          ) : c.push({
            label: s.label,
            icon: s.icon,
            variant: s.menuVariant,
            disabled: s.disabled || s.loading,
            tooltip: s.tooltip,
            onClick: s.onClick
          }));
        }
        return { mode: l, inlineActions: r, menuItems: c };
      })
    ), o = m(() => n.menuLabel ?? t("ui.pageLayout.moreActions", "More actions"));
    return (l, r) => (i(), g("div", Nb, [
      (i(!0), g(he, null, De(a.value, (c) => (i(), g("div", {
        key: c.mode,
        class: W(["hp-responsive-header-actions__mode", `hp-responsive-header-actions__mode--${c.mode}`]),
        "data-mode": c.mode
      }, [
        (i(!0), g(he, null, De(c.inlineActions, (s) => (i(), g(he, {
          key: s.action.id
        }, [
          s.action.menuItems !== void 0 ? (i(), R(So, {
            key: 0,
            items: s.action.menuItems,
            label: s.action.label,
            icon: s.action.icon,
            variant: s.action.variant,
            color: s.action.color,
            size: s.action.size ?? n.size,
            disabled: s.action.disabled || s.action.loading
          }, null, 8, ["items", "label", "icon", "variant", "color", "size", "disabled"])) : (i(), R(Ae, {
            key: 1,
            variant: s.action.variant,
            color: s.action.color,
            size: s.action.size ?? n.size,
            icon: s.presentation === "icon" || s.action.showIconWithLabel ? s.action.icon : void 0,
            square: s.presentation === "icon",
            "aria-label": s.presentation === "icon" ? s.action.label : void 0,
            disabled: s.action.disabled,
            loading: s.action.loading,
            onClick: s.action.onClick
          }, {
            default: B(() => [
              s.presentation === "button" ? (i(), R($a, { key: 0 }, {
                default: B(() => [
                  me(le(s.action.label), 1)
                ]),
                _: 2
              }, 1024)) : A("", !0)
            ]),
            _: 2
          }, 1032, ["variant", "color", "size", "icon", "square", "aria-label", "disabled", "loading", "onClick"]))
        ], 64))), 128)),
        c.menuItems.length > 0 ? (i(), R(So, {
          key: 0,
          items: c.menuItems,
          icon: n.menuIcon,
          variant: n.menuVariant,
          color: n.menuColor,
          size: n.size,
          "aria-label": o.value,
          placement: "bottom-end",
          disabled: c.menuItems.every((s) => s.disabled)
        }, null, 8, ["items", "icon", "variant", "color", "size", "aria-label", "disabled"])) : A("", !0)
      ], 10, Fb))), 128))
    ]));
  }
}), Kb = ze("hp-responsive-header-item", {
  variants: {
    wide: { true: "hp-responsive-header-item--wide" },
    compact: { true: "hp-responsive-header-item--compact" },
    minimal: { true: "hp-responsive-header-item--minimal" }
  }
}), HD = /* @__PURE__ */ Y({
  __name: "ResponsiveHeaderItem",
  props: {
    modes: { default: () => ["wide", "compact", "minimal"] }
  },
  setup(e) {
    const t = e, n = m(
      () => Kb({
        wide: t.modes.includes("wide"),
        compact: t.modes.includes("compact"),
        minimal: t.modes.includes("minimal")
      })
    );
    return (a, o) => (i(), g("div", {
      class: W(n.value)
    }, [
      L(a.$slots, "default")
    ], 2));
  }
}), Yb = ze("hp-pagination", {
  variants: {
    size: {
      1: "hp-pagination--size-1",
      2: "hp-pagination--size-2",
      3: "hp-pagination--size-3",
      4: "hp-pagination--size-4",
      5: "hp-pagination--size-5"
    },
    padded: {
      true: "hp-pagination--padded"
    }
  },
  defaultVariants: {
    size: "2"
  }
}), jb = {}, Wb = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Ub(e, t) {
  return i(), g("svg", Wb, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M5 9.99999H10M10 9.99999H15M10 9.99999L10 4.99997M10 9.99999V15",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const qb = /* @__PURE__ */ se(jb, [["render", Ub]]), Zb = (e) => {
  const { modelValue: t, multiple: n } = e;
  return { handleClear: () => {
    t.value = n.value ? [] : "";
  }, removeChip: (l) => {
    !n.value || !Array.isArray(t.value) || (t.value = t.value.filter((r) => r !== l));
  } };
}, Gb = (e) => {
  const { options: t, modelValue: n, isOpen: a, maxSelected: o } = e, l = N(/* @__PURE__ */ new Set()), r = N("");
  Se(a, ($) => {
    if ($) {
      const y = n.value;
      l.value = new Set(Array.isArray(y) ? y : []), r.value = "";
    }
  });
  const c = m(() => {
    const $ = r.value.toLowerCase().trim();
    return $ ? t.value.filter((y) => y.label.toLowerCase().includes($)) : t.value;
  }), s = m(() => {
    const $ = o?.value;
    return $ !== void 0 && l.value.size >= $;
  });
  return {
    searchQuery: r,
    filteredOptions: c,
    toggleDraft: ($) => {
      const y = new Set(l.value);
      if (y.has($))
        y.delete($);
      else {
        if (s.value)
          return;
        y.add($);
      }
      l.value = y;
    },
    isDraftSelected: ($) => l.value.has($),
    isDraftFull: s,
    getDraftValues: () => [...l.value],
    cancel: () => {
      const $ = n.value;
      l.value = new Set(Array.isArray($) ? $ : []);
    }
  };
}, Xb = ["tabindex", "aria-expanded", "aria-readonly", "onClick"], Qb = ["data-theme", "aria-invalid"], Jb = {
  key: 0,
  class: "hp-input__icon hp-input__icon--prefix"
}, ek = {
  key: 1,
  class: "hp-select__inline-values"
}, tk = {
  key: 0,
  class: "hp-select__inline-separator",
  "aria-hidden": "true"
}, ak = { class: "hp-select__inline-label" }, nk = {
  key: 0,
  class: "hp-select__chips-placeholder"
}, ok = {
  key: 2,
  class: "hp-select__chips-wrap"
}, lk = {
  key: 0,
  class: "hp-select__chips-placeholder"
}, rk = { class: "hp-input__icon hp-input__icon--suffix hp-select__right" }, sk = { class: "hp-select__chevron-icon" }, ik = { class: "hp-select-dropdown__search" }, ck = {
  key: 0,
  class: "hp-select-dropdown__search"
}, uk = { class: "hp-select-dropdown__list" }, dk = ["data-select-option", "title"], pk = { class: "hp-select-dropdown__option-label" }, fk = {
  key: 1,
  class: "hp-select-dropdown__empty"
}, hk = { class: "hp-select-dropdown__footer" }, vk = /* @__PURE__ */ Y({
  __name: "SelectMultiple",
  props: {
    color: {},
    clearable: { type: Boolean },
    placeholder: {},
    searchPlaceholder: {},
    triggerClasses: {},
    chipItems: {},
    maxVisible: {},
    options: {},
    modelValue: {},
    disabled: { type: Boolean },
    readOnly: { type: Boolean },
    isEmptyButEnabled: { type: Boolean },
    invalid: { type: Boolean },
    prefix: {},
    suffix: {},
    maxSelected: {},
    showSelectAll: { type: Boolean },
    triggerMode: {}
  },
  emits: ["remove-chip", "clear", "apply"],
  setup(e, { emit: t }) {
    const n = Le(), a = e, o = t, l = N(!1), r = m(() => a.triggerMode === "inline"), c = m(() => {
      const D = a.modelValue;
      return (Array.isArray(D) ? D : []).flatMap((Z) => {
        const J = a.options.find(({ value: re }) => re === Z);
        return J === void 0 ? [] : [J];
      });
    }), s = N(null), p = m(() => a.clearable && !a.readOnly && a.chipItems.length > 0), d = m(
      () => a.maxVisible !== void 0 && a.chipItems.length > a.maxVisible
    ), f = m(() => d.value ? a.chipItems.slice(0, a.maxVisible) : a.chipItems), h = m(() => d.value ? a.chipItems.length - (a.maxVisible ?? 0) : 0), { searchQuery: $, filteredOptions: y, toggleDraft: w, isDraftSelected: v, isDraftFull: x, getDraftValues: b, cancel: k } = Gb({
      options: Ze(a, "options"),
      modelValue: Ze(a, "modelValue"),
      isOpen: l,
      maxSelected: Ze(a, "maxSelected")
    }), _ = () => {
      for (const D of a.options)
        !D.disabled && !v(D.value) && w(D.value);
    }, T = (D) => {
      !a.disabled && !a.readOnly && D();
    }, S = () => {
      a.disabled || a.readOnly || (l.value = !0);
    }, M = (D) => {
      H(D), S();
    }, { handleEscape: E, handleTab: F, consume: H } = Gn({
      isOpen: l,
      close: () => {
        z();
      },
      refocus: () => {
        s.value?.focus();
      }
    }), te = {
      Enter: M,
      " ": M,
      ArrowDown: M,
      Tab: F,
      Escape: E
    }, ie = (D) => {
      a.disabled || a.readOnly || te[D.key]?.(D);
    }, ee = () => {
      o("apply", b()), l.value = !1;
    }, O = () => {
      o("clear");
    }, z = () => {
      k(), l.value = !1;
    };
    return (D, P) => (i(), R(u(Xt), {
      open: l.value,
      "onUpdate:open": P[3] || (P[3] = (Z) => l.value = Z),
      type: "menu",
      placement: "bottom-start"
    }, {
      default: B(() => [
        j(u(Jt), null, {
          default: B(({ toggle: Z }) => [
            C("div", {
              ref_key: "triggerRef",
              ref: s,
              tabindex: e.disabled ? -1 : 0,
              role: "combobox",
              "aria-haspopup": "dialog",
              "aria-expanded": l.value,
              "aria-readonly": e.readOnly || void 0,
              class: W([
                "hp-select__trigger-wrapper",
                e.readOnly && "hp-select__trigger-wrapper--readonly",
                e.isEmptyButEnabled && "hp-select__trigger-wrapper--no-options"
              ]),
              onClick: (J) => T(Z),
              onKeydown: ie
            }, [
              C("div", {
                class: W([e.triggerClasses, "hp-select__input"]),
                "data-theme": e.color,
                "aria-invalid": e.invalid || void 0
              }, [
                D.$slots.prefix || e.prefix ? (i(), g("span", Jb, [
                  L(D.$slots, "prefix", {}, () => [
                    e.prefix ? (i(), R(Pe(e.prefix), { key: 0 })) : A("", !0)
                  ])
                ])) : A("", !0),
                r.value ? (i(), g("div", ek, [
                  (i(!0), g(he, null, De(c.value, (J, re) => (i(), g(he, {
                    key: J.value
                  }, [
                    re > 0 ? (i(), g("span", tk, "/")) : A("", !0),
                    J.icon ? (i(), g("span", {
                      key: 1,
                      class: W(["hp-select__inline-icon", `hp-icon--size-${J.iconSize ?? "2"}`])
                    }, [
                      (i(), R(Pe(J.icon)))
                    ], 2)) : A("", !0),
                    C("span", ak, le(J.label), 1),
                    J.badge ? (i(), R(u(Rt), {
                      key: 2,
                      class: "hp-select__inline-badge",
                      color: J.badgeColor,
                      variant: J.badgeVariant ?? "soft",
                      size: J.badgeSize ?? "1"
                    }, {
                      default: B(() => [
                        me(le(J.badge), 1)
                      ]),
                      _: 2
                    }, 1032, ["color", "variant", "size"])) : A("", !0),
                    J.labelBadge ? (i(), R(u(Nn), {
                      key: 3,
                      class: "hp-select__inline-badge",
                      badge: J.labelBadge
                    }, null, 8, ["badge"])) : A("", !0)
                  ], 64))), 128)),
                  c.value.length === 0 ? (i(), g("span", nk, le(e.placeholder), 1)) : A("", !0)
                ])) : (i(), g("div", ok, [
                  (i(!0), g(he, null, De(f.value, (J) => (i(), R(u(Ht), {
                    key: J.value,
                    variant: "soft",
                    size: "2",
                    truncate: "",
                    title: J.label,
                    dismissible: e.clearable && !e.readOnly,
                    class: "hp-select__chip",
                    "dismiss-tabindex": -1,
                    onClick: P[0] || (P[0] = Fe(() => {
                    }, ["stop"])),
                    onDismiss: (re) => o("remove-chip", J.value)
                  }, {
                    default: B(() => [
                      me(le(J.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["title", "dismissible", "onDismiss"]))), 128)),
                  e.chipItems.length === 0 ? (i(), g("span", lk, le(e.placeholder), 1)) : A("", !0),
                  h.value > 0 ? (i(), R(u(Ht), {
                    key: 1,
                    variant: "soft",
                    size: "2",
                    class: "hp-select__chip"
                  }, {
                    default: B(() => [
                      me(" +" + le(h.value), 1)
                    ]),
                    _: 1
                  })) : A("", !0)
                ])),
                C("span", rk, [
                  D.$slots.suffix || e.suffix ? (i(), g("span", {
                    key: 0,
                    class: "hp-select__suffix-slot",
                    onClick: P[1] || (P[1] = Fe(() => {
                    }, ["stop"]))
                  }, [
                    L(D.$slots, "suffix", {}, () => [
                      e.suffix ? (i(), R(Pe(e.suffix), { key: 0 })) : A("", !0)
                    ])
                  ])) : A("", !0),
                  p.value ? (i(), R(u(Rt), {
                    key: 1,
                    variant: "soft",
                    size: "1",
                    square: "",
                    radius: "full",
                    icon: zt,
                    class: "hp-select__clear-btn",
                    "aria-label": u(n)("ui.common.clear", "Clear"),
                    onClick: Fe(O, ["stop"])
                  }, null, 8, ["aria-label"])) : A("", !0),
                  C("span", sk, [
                    j(Sn)
                  ])
                ])
              ], 10, Qb)
            ], 42, Xb)
          ]),
          _: 3
        }),
        j(u(Qt), {
          class: "hp-select-dropdown hp-select-dropdown--multiple",
          onKeydown: sa(u(E), ["escape"])
        }, {
          default: B(() => [
            C("div", ik, [
              j(u(tn), {
                modelValue: u($),
                "onUpdate:modelValue": P[2] || (P[2] = (Z) => xo($) ? $.value = Z : null),
                placeholder: e.searchPlaceholder,
                size: "3",
                variant: "outline",
                "data-autofocus": "",
                clearable: ""
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            e.showSelectAll ? (i(), g("div", ck, [
              j(u(Ae), {
                variant: "outline",
                size: "2",
                radius: "full",
                disabled: u(x),
                onClick: _
              }, {
                default: B(() => [
                  me(le(u(n)("ui.treeControl.selectAll", "Select all")), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ])) : A("", !0),
            C("div", uk, [
              u(y).length > 0 ? (i(!0), g(he, { key: 0 }, De(u(y), (Z) => (i(), g("label", {
                key: Z.value,
                "data-select-option": Z.value,
                title: Z.label,
                class: W([
                  "hp-select-dropdown__option",
                  (Z.disabled || u(x) && !u(v)(Z.value)) && "hp-select-dropdown__option--disabled"
                ])
              }, [
                j(u(ln), {
                  "model-value": u(v)(Z.value),
                  disabled: Z.disabled || u(x) && !u(v)(Z.value),
                  variant: "outline",
                  size: "2",
                  "onUpdate:modelValue": (J) => u(w)(Z.value)
                }, null, 8, ["model-value", "disabled", "onUpdate:modelValue"]),
                Z.icon ? (i(), g("span", {
                  key: 0,
                  class: W(["hp-select-dropdown__option-icon", `hp-icon--size-${Z.iconSize ?? "2"}`])
                }, [
                  (i(), R(Pe(Z.icon)))
                ], 2)) : A("", !0),
                C("span", pk, le(Z.label), 1),
                Z.badge ? (i(), R(u(Rt), {
                  key: 1,
                  class: "hp-select-dropdown__option-badge",
                  color: Z.badgeColor,
                  variant: Z.badgeVariant ?? "soft",
                  size: Z.badgeSize ?? "1"
                }, {
                  default: B(() => [
                    me(le(Z.badge), 1)
                  ]),
                  _: 2
                }, 1032, ["color", "variant", "size"])) : A("", !0),
                Z.labelBadge ? (i(), R(u(Nn), {
                  key: 2,
                  class: "hp-select-dropdown__option-badge",
                  badge: Z.labelBadge
                }, null, 8, ["badge"])) : A("", !0)
              ], 10, dk))), 128)) : (i(), g("div", fk, le(u(n)("ui.editableCell.noOptionsFound", "No options found")), 1))
            ]),
            C("div", hk, [
              j(u(Ae), {
                variant: "outline",
                size: "3",
                radius: "big",
                onClick: z
              }, {
                default: B(() => [
                  me(le(u(n)("ui.common.cancel", "Cancel")), 1)
                ]),
                _: 1
              }),
              j(u(Ae), {
                variant: "filled",
                size: "3",
                radius: "big",
                onClick: ee
              }, {
                default: B(() => [
                  me(le(u(n)("ui.common.apply", "Apply")), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["onKeydown"])
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), Vr = (e) => {
  const t = e.scroll ?? { kind: "element-id" }, n = e.scrollOnInit ?? !0, a = e.isDisabled ?? ((v) => v.disabled === !0), o = e.initialIndex ?? (() => -1), l = N(-1), r = N(!1), c = ha() ?? "", s = (v) => `${c}-${e.idSegment}-${v}`, p = m(
    () => Ne(e.open) && l.value >= 0 ? s(l.value) : void 0
  ), d = m(
    () => Ne(e.items).reduce((v, x, b) => (a(x) || v.push(b), v), [])
  ), f = async () => {
    if (await Ye(), l.value < 0)
      return;
    const v = t.kind === "listbox-children" ? t.listboxRef.value?.children[l.value] : document.getElementById(s(l.value));
    if (v && typeof v.scrollIntoView == "function")
      try {
        v.scrollIntoView({ block: "nearest" });
      } catch {
      }
  }, h = (v) => (l.value = v, f()), $ = (v) => {
    const x = d.value;
    if (x.length === 0)
      return Promise.resolve();
    const b = x.indexOf(l.value), k = v > 0 ? 0 : x.length - 1, _ = b === -1 ? k : (b + v + x.length) % x.length;
    return l.value = x[_], f();
  }, y = () => {
    const v = o(), x = Ne(e.items), b = v >= 0 && v < x.length && !a(x[v]);
    return l.value = b ? v : d.value[0] ?? -1, n ? f() : Promise.resolve();
  }, w = () => {
    l.value = -1, r.value = !1;
  };
  return Se(
    () => Ne(e.open),
    async (v) => {
      v ? (await y(), e.onOpen?.()) : w();
    }
  ), {
    activeIndex: l,
    keyboardNav: r,
    enabledIndexes: d,
    baseId: c,
    optionId: s,
    activeDescendantId: p,
    moveActive: $,
    setActive: h,
    scrollActiveIntoView: f,
    initActive: y,
    reset: w
  };
}, mk = ["aria-readonly", "onClick"], gk = {
  key: 0,
  class: "hp-select__chip-pair"
}, yk = { class: "hp-select__chip-icon" }, wk = { class: "hp-select__right" }, bk = { class: "hp-select__chevron-icon" }, kk = { class: "hp-select-badge-tooltip" }, _k = {
  key: 3,
  class: "hp-select__empty-action-wrap"
}, Ck = /* @__PURE__ */ Y({
  __name: "SelectSingle",
  props: {
    variant: {},
    size: {},
    color: {},
    disabled: { type: Boolean },
    readOnly: { type: Boolean },
    placeholder: {},
    clearable: { type: Boolean },
    radius: {},
    options: {},
    searchable: { type: Boolean },
    modelValue: {},
    displayText: {},
    hasValue: { type: Boolean },
    isEmptyButEnabled: { type: Boolean },
    hasEmptyAction: { type: Boolean },
    emptyActionLabel: {},
    emptyActionIcon: {},
    dropdownWidth: {},
    selectedIcon: { type: Boolean },
    selectedChip: { type: Boolean },
    invalid: { type: Boolean },
    align: {},
    width: {},
    minWidth: {},
    maxWidth: {},
    prefix: {},
    suffix: {}
  },
  emits: ["clear", "select", "empty-action"],
  setup(e, { expose: t, emit: n }) {
    const a = e, o = n, l = m(
      () => a.options.find((U) => U.value === a.modelValue)
    ), r = m(() => l.value?.icon), c = m(() => a.selectedChip === !0 && l.value?.icon !== void 0), s = N(!1), p = Le(), d = N(""), f = N(null), h = m(() => {
      const U = d.value.trim().toLocaleLowerCase();
      return a.searchable && U ? a.options.filter((ge) => `${ge.label} ${ge.value}`.toLocaleLowerCase().includes(U)) : a.options;
    });
    Se(s, () => {
      d.value = "";
    });
    const $ = N(null), y = N(null), w = () => {
      a.disabled || a.readOnly || (s.value = !0);
    }, v = () => {
      $.value?.querySelector("input")?.focus();
    }, { handleEscape: x, handleTab: b, consume: k } = Gn({
      isOpen: s,
      close: () => {
        s.value = !1;
      },
      refocus: v
    }), { activeIndex: _, keyboardNav: T, enabledIndexes: S, optionId: M, activeDescendantId: E, moveActive: F, setActive: H } = Vr({
      items: () => h.value,
      open: s,
      idSegment: "option",
      // SelectSingle already holds a ref to its <div role="listbox">, so index into its children.
      scroll: { kind: "listbox-children", listboxRef: y },
      // Open onto the currently-selected option; the composable falls back to the first enabled
      // option when nothing is selected or the selected option is disabled.
      initialIndex: () => h.value.findIndex((U) => U.value === a.modelValue),
      onOpen: () => {
        Ye(() => a.searchable ? f.value?.querySelector("input")?.focus() : v());
      }
    }), te = () => {
      const U = _.value >= 0 ? h.value[_.value] : void 0;
      U && J(U);
    }, ie = (U) => {
      !a.disabled && !a.readOnly && U();
    }, ee = (U, ge) => {
      if (k(U), T.value = !0, s.value)
        return F(ge);
      w();
    }, O = (U) => {
      k(U), s.value ? te() : (T.value = !0, w());
    }, z = (U, ge) => {
      if (s.value)
        return k(U), T.value = !0, H(ge);
    }, D = {
      ArrowDown: (U) => ee(U, 1),
      ArrowUp: (U) => ee(U, -1),
      Home: (U) => z(U, S.value[0] ?? -1),
      End: (U) => z(U, S.value[S.value.length - 1] ?? -1),
      Enter: O,
      // Space mirrors Enter (native <select> parity; the trigger input is read-only, so there is
      // no text entry to conflict with). SelectMultiple already opens on Space — keep them symmetric.
      " ": O,
      Escape: x,
      Tab: b
    }, P = (U) => {
      if (!(a.disabled || a.readOnly))
        return D[U.key]?.(U);
    }, Z = (U) => {
      if (["ArrowDown", "ArrowUp", "Enter", "Escape", "Tab"].includes(U.key))
        return P(U);
    }, J = (U) => {
      U.disabled || (o("select", U.value), s.value = !1, v());
    }, re = () => {
      o("empty-action"), s.value = !1;
    };
    return t({
      triggerRef: $
    }), (U, ge) => (i(), R(u(Xt), {
      open: s.value,
      "onUpdate:open": ge[3] || (ge[3] = (K) => s.value = K),
      type: "menu",
      placement: "bottom-start"
    }, {
      default: B(() => [
        j(u(Jt), null, {
          default: B(({ toggle: K }) => [
            C("div", {
              ref_key: "triggerRef",
              ref: $,
              class: W([
                "hp-select__trigger-wrapper",
                e.readOnly && "hp-select__trigger-wrapper--readonly",
                e.isEmptyButEnabled && "hp-select__trigger-wrapper--no-options"
              ]),
              "aria-readonly": e.readOnly || void 0,
              onClick: (pe) => ie(K),
              onKeydown: P
            }, [
              j(u(tn), {
                "model-value": c.value ? "" : e.displayText,
                variant: e.variant,
                size: e.size,
                color: e.color,
                disabled: e.disabled,
                "read-only": !0,
                "aria-readonly": e.readOnly || void 0,
                radius: e.radius,
                align: e.align,
                width: e.width,
                "min-width": e.minWidth,
                "max-width": e.maxWidth,
                placeholder: c.value ? "" : e.placeholder,
                clearable: !1,
                invalid: e.invalid,
                prefix: e.prefix,
                class: "hp-select__input",
                "aria-activedescendant": u(E)
              }, it({
                suffix: B(() => [
                  C("div", wk, [
                    U.$slots.suffix || e.suffix ? (i(), g("span", {
                      key: 0,
                      class: "hp-select__suffix-slot",
                      onClick: ge[0] || (ge[0] = Fe(() => {
                      }, ["stop"]))
                    }, [
                      L(U.$slots, "suffix", {}, () => [
                        e.suffix ? (i(), R(Pe(e.suffix), { key: 0 })) : A("", !0)
                      ])
                    ])) : A("", !0),
                    e.clearable && e.hasValue && !e.readOnly ? (i(), R(u(Rt), {
                      key: 1,
                      variant: "soft",
                      size: "1",
                      square: "",
                      radius: "full",
                      icon: zt,
                      class: "hp-select__clear-btn",
                      onClick: ge[1] || (ge[1] = Fe((pe) => o("clear"), ["stop"]))
                    })) : A("", !0),
                    C("span", bk, [
                      j(Sn)
                    ])
                  ])
                ]),
                _: 2
              }, [
                U.$slots.prefix ? {
                  name: "prefix",
                  fn: B(() => [
                    L(U.$slots, "prefix")
                  ]),
                  key: "0"
                } : !e.prefix && r.value && (e.selectedIcon || e.selectedChip) ? {
                  name: "prefix",
                  fn: B(() => [
                    r.value ? (i(), g(he, { key: 0 }, [
                      e.selectedChip ? (i(), g("span", gk, [
                        j(u(Ht), {
                          size: "3",
                          variant: "surface",
                          square: "",
                          radius: "full"
                        }, {
                          default: B(() => [
                            C("span", yk, [
                              (i(), R(Pe(r.value)))
                            ])
                          ]),
                          _: 1
                        }),
                        j(u(Ht), {
                          size: "3",
                          variant: "surface",
                          truncate: ""
                        }, {
                          default: B(() => [
                            me(le(e.displayText), 1)
                          ]),
                          _: 1
                        })
                      ])) : (i(), R(Pe(r.value), { key: 1 }))
                    ], 64)) : A("", !0)
                  ]),
                  key: "1"
                } : void 0
              ]), 1032, ["model-value", "variant", "size", "color", "disabled", "aria-readonly", "radius", "align", "width", "min-width", "max-width", "placeholder", "invalid", "prefix", "aria-activedescendant"])
            ], 42, mk)
          ]),
          _: 3
        }),
        j(u(Qt), {
          class: "hp-select-dropdown",
          style: Ie(e.dropdownWidth ? { "--hp-select-dropdown-width": e.dropdownWidth } : void 0)
        }, {
          default: B(() => [
            e.searchable ? (i(), g("div", {
              key: 0,
              ref_key: "searchRef",
              ref: f,
              class: "p-2",
              onKeydown: Z
            }, [
              j(u(tn), {
                modelValue: d.value,
                "onUpdate:modelValue": ge[2] || (ge[2] = (K) => d.value = K),
                placeholder: u(p)("ui.select.searchPlaceholder", "Search..."),
                "aria-label": u(p)("ui.select.searchPlaceholder", "Search..."),
                "aria-activedescendant": u(E),
                clearable: ""
              }, null, 8, ["modelValue", "placeholder", "aria-label", "aria-activedescendant"])
            ], 544)) : A("", !0),
            h.value.length > 0 ? (i(), g("div", {
              key: 1,
              ref_key: "listboxRef",
              ref: y,
              role: "listbox",
              class: "hp-select__listbox"
            }, [
              (i(!0), g(he, null, De(h.value, (K, pe) => (i(), R(u(Oa), {
                id: u(M)(pe),
                key: K.value,
                role: "option",
                tabindex: "-1",
                "aria-selected": K.value === e.modelValue,
                class: W(u(T) && pe === u(_) && !K.disabled ? "is-active" : void 0),
                label: K.label,
                tooltip: K.label,
                icon: K.icon,
                "icon-size": K.iconSize,
                badge: K.badgeTooltipItems?.length ? void 0 : K.badge,
                "badge-color": K.badgeColor,
                "badge-variant": K.badgeVariant,
                "badge-size": K.badgeSize,
                disabled: K.disabled,
                selected: K.value === e.modelValue,
                onClick: (ae) => J(K)
              }, it({ _: 2 }, [
                K.description ? {
                  name: "suffix",
                  fn: B(() => [
                    j(Bl, {
                      class: "hp-select__option-hint",
                      size: "1",
                      "popover-size": "2",
                      placement: "top-end",
                      content: K.description
                    }, null, 8, ["content"])
                  ]),
                  key: "0"
                } : K.badgeTooltipItems?.length ? {
                  name: "suffix",
                  fn: B(() => [
                    j(u(pr), {
                      placement: "right",
                      delay: 200
                    }, {
                      default: B(() => [
                        j(u(hr), null, {
                          default: B(() => [
                            j(u(Rt), {
                              size: K.badgeSize ?? "2",
                              variant: K.badgeVariant ?? "soft",
                              color: K.badgeColor
                            }, {
                              default: B(() => [
                                me(le(K.badge), 1)
                              ]),
                              _: 2
                            }, 1032, ["size", "variant", "color"])
                          ]),
                          _: 2
                        }, 1024),
                        j(u(fr), null, {
                          default: B(() => [
                            C("div", kk, [
                              K.badgeTooltipTitle ? (i(), R(u(at), {
                                key: 0,
                                size: "3",
                                weight: "semibold"
                              }, {
                                default: B(() => [
                                  me(le(K.badgeTooltipTitle), 1)
                                ]),
                                _: 2
                              }, 1024)) : A("", !0),
                              (i(!0), g(he, null, De(K.badgeTooltipItems, (ae) => (i(), g("div", {
                                key: ae.label,
                                class: "hp-select-badge-tooltip__row"
                              }, [
                                j(u(Rt), {
                                  variant: "soft",
                                  size: "2",
                                  square: "",
                                  radius: "full",
                                  color: ae.color,
                                  icon: ae.icon
                                }, null, 8, ["color", "icon"]),
                                j(u(at), { size: "2" }, {
                                  default: B(() => [
                                    me(le(ae.label), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]))), 128))
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  key: "1"
                } : void 0
              ]), 1032, ["id", "aria-selected", "class", "label", "tooltip", "icon", "icon-size", "badge", "badge-color", "badge-variant", "badge-size", "disabled", "selected", "onClick"]))), 128))
            ], 512)) : e.searchable && d.value ? (i(), R(u(at), {
              key: 2,
              class: "p-2",
              variant: "soft"
            }, {
              default: B(() => [
                me(le(u(p)("ui.select.noResults", "No results found")), 1)
              ]),
              _: 1
            })) : e.hasEmptyAction ? (i(), g("div", _k, [
              j(u(Ae), {
                variant: "outline",
                size: "2",
                icon: e.emptyActionIcon,
                class: "hp-select__empty-action",
                onClick: re
              }, {
                default: B(() => [
                  me(le(e.emptyActionLabel), 1)
                ]),
                _: 1
              }, 8, ["icon"])
            ])) : A("", !0)
          ]),
          _: 1
        }, 8, ["style"])
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), xk = (e, t) => {
  const n = e ?? t;
  if (!n || typeof n != "object")
    return null;
  const a = n;
  return typeof a.label != "string" || a.label.trim().length === 0 ? null : { label: a.label, icon: a.icon };
}, $k = ["data-theme"], Hr = /* @__PURE__ */ Y({
  inheritAttrs: !1,
  __name: "Select",
  props: /* @__PURE__ */ Xe({
    variant: { default: "filled" },
    size: { default: "3" },
    color: { default: void 0 },
    radius: { default: void 0 },
    placeholder: { default: void 0 },
    align: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    readOnly: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 },
    width: { default: void 0 },
    minWidth: { default: void 0 },
    maxWidth: { default: void 0 },
    class: { default: void 0 },
    prefix: { default: void 0 },
    suffix: { default: void 0 },
    options: { default: () => [] },
    searchable: { type: Boolean },
    multiple: { type: Boolean, default: !1 },
    clearable: { type: Boolean, default: !0 },
    maxVisible: { default: void 0 },
    maxSelected: { default: void 0 },
    showSelectAll: { type: Boolean, default: !1 },
    triggerMode: { default: "chips" },
    emptyAction: {},
    dropdownWidth: { default: void 0 },
    selectedIcon: { type: Boolean, default: !1 },
    selectedChip: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["focus", "blur", "empty-action"], ["update:modelValue"]),
  setup(e, { expose: t, emit: n }) {
    const a = Le(), o = e, l = n, r = bi(), c = vt(e, "modelValue"), s = N(null), p = N(null), d = nu({
      options: Ze(o, "options"),
      modelValue: c,
      multiple: Ze(o, "multiple")
    }), f = Zb({
      modelValue: c,
      multiple: Ze(o, "multiple")
    }), { cvaSizing: h, styleVars: $ } = Xn(o), y = m(
      () => xk(o.emptyAction, r.emptyAction ?? r["empty-action"])
    ), w = m(() => !o.multiple && y.value !== null), v = m(() => !o.disabled && !d.hasOptions.value && !w.value), x = m(() => y.value?.icon || qb), b = m(() => d.singleDisplayText.value || o.placeholder || a("ui.select.selectPlaceholder", "Select...")), k = ze("hp-input", {
      variants: Qn,
      defaultVariants: Jn
    }), _ = m(
      () => k({
        variant: o.variant,
        size: o.size,
        disabled: o.disabled,
        readOnly: o.readOnly,
        radius: o.radius,
        align: o.align,
        invalid: o.invalid,
        width: h.value.width,
        minWidth: h.value.minWidth,
        maxWidth: h.value.maxWidth
      })
    ), T = (M) => {
      c.value = M;
    }, S = (M) => {
      c.value = M;
    };
    return t({
      selectWrapperRef: s,
      focus: () => {
        o.multiple || p.value?.triggerRef?.focus();
      },
      blur: () => {
        o.multiple || p.value?.triggerRef?.blur();
      }
    }), (M, E) => (i(), g("div", {
      ref_key: "selectWrapperRef",
      ref: s,
      class: W(["hp-select-wrapper", o.class]),
      style: Ie(u($)),
      "data-theme": e.color
    }, [
      e.multiple ? (i(), R(vk, {
        key: 0,
        color: e.color,
        clearable: e.clearable,
        placeholder: e.placeholder || u(a)("ui.select.selectPlaceholder", "Select..."),
        "search-placeholder": e.placeholder || u(a)("ui.select.searchPlaceholder", "Search..."),
        "trigger-classes": _.value,
        "chip-items": u(d).selectedChipItems.value,
        "max-visible": e.maxVisible,
        options: o.options,
        "model-value": c.value,
        disabled: e.disabled,
        "read-only": e.readOnly,
        "is-empty-but-enabled": v.value,
        invalid: e.invalid,
        prefix: e.prefix,
        suffix: e.suffix,
        "max-selected": e.maxSelected,
        "show-select-all": e.showSelectAll,
        "trigger-mode": e.triggerMode,
        onRemoveChip: u(f).removeChip,
        onClear: u(f).handleClear,
        onApply: S
      }, it({ _: 2 }, [
        M.$slots.prefix ? {
          name: "prefix",
          fn: B(() => [
            L(M.$slots, "prefix")
          ]),
          key: "0"
        } : void 0,
        M.$slots.suffix ? {
          name: "suffix",
          fn: B(() => [
            L(M.$slots, "suffix")
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["color", "clearable", "placeholder", "search-placeholder", "trigger-classes", "chip-items", "max-visible", "options", "model-value", "disabled", "read-only", "is-empty-but-enabled", "invalid", "prefix", "suffix", "max-selected", "show-select-all", "trigger-mode", "onRemoveChip", "onClear"])) : (i(), R(Ck, {
        key: 1,
        ref_key: "singleSelectRef",
        ref: p,
        variant: e.variant,
        size: e.size,
        color: e.color,
        disabled: e.disabled,
        "read-only": e.readOnly,
        placeholder: e.placeholder || u(a)("ui.select.selectPlaceholder", "Select..."),
        clearable: e.clearable,
        radius: e.radius,
        align: e.align,
        width: e.width,
        "min-width": e.minWidth,
        "max-width": e.maxWidth,
        options: o.options,
        "model-value": c.value,
        "display-text": b.value,
        "has-value": u(d).hasValue.value,
        "is-empty-but-enabled": v.value,
        "has-empty-action": w.value,
        "empty-action-label": y.value?.label,
        "empty-action-icon": x.value,
        "dropdown-width": e.dropdownWidth,
        "selected-icon": e.selectedIcon || e.selectedChip,
        "selected-chip": e.selectedChip,
        searchable: e.searchable,
        invalid: e.invalid,
        prefix: e.prefix,
        suffix: e.suffix,
        onClear: u(f).handleClear,
        onSelect: T,
        onEmptyAction: E[0] || (E[0] = (F) => l("empty-action"))
      }, it({ _: 2 }, [
        M.$slots.prefix ? {
          name: "prefix",
          fn: B(() => [
            L(M.$slots, "prefix")
          ]),
          key: "0"
        } : void 0,
        M.$slots.suffix ? {
          name: "suffix",
          fn: B(() => [
            L(M.$slots, "suffix")
          ]),
          key: "1"
        } : void 0
      ]), 1032, ["variant", "size", "color", "disabled", "read-only", "placeholder", "clearable", "radius", "align", "width", "min-width", "max-width", "options", "model-value", "display-text", "has-value", "is-empty-but-enabled", "has-empty-action", "empty-action-label", "empty-action-icon", "dropdown-width", "selected-icon", "selected-chip", "searchable", "invalid", "prefix", "suffix", "onClear"]))
    ], 14, $k));
  }
}), Sk = ["data-theme"], Mk = { class: "hp-pagination__left" }, Dk = { class: "hp-pagination__controls" }, Tk = 100, Bk = /* @__PURE__ */ Y({
  __name: "Pagination",
  props: {
    total: {},
    page: { default: 1 },
    pageSize: { default: 25 },
    pageSizeOptions: { default: void 0 },
    size: { default: "2" },
    variant: { default: "outline" },
    color: { default: void 0 },
    radius: { default: void 0 },
    maxPages: { default: 7 },
    alwaysShow: { type: Boolean, default: !1 },
    padded: { type: Boolean, default: !1 },
    class: { default: void 0 }
  },
  emits: ["update:page", "update:pageSize"],
  setup(e, { emit: t }) {
    const n = Le(), a = e, o = t, l = {
      filled: "filled",
      soft: "soft",
      outline: "outline",
      surface: "outline",
      blank: "outline",
      "soft-outlined": "soft-outlined"
    }, r = m(() => l[a.variant] ?? "outline"), c = m(
      () => (a.pageSizeOptions ?? []).map((y) => ({
        value: y,
        label: String(y)
      }))
    ), s = m({
      get: () => a.pageSize,
      set: (y) => {
        const w = Number(y);
        !isNaN(w) && w > 0 && (o("update:pageSize", w), o("update:page", 1));
      }
    }), p = m(() => Math.ceil(a.total / a.pageSize)), d = m(() => {
      const y = (a.page - 1) * a.pageSize + 1, w = Math.min(a.page * a.pageSize, a.total);
      return n("ui.pagination.range", "{start}-{end} of {total}", { start: y, end: w, total: a.total });
    }), f = m(() => {
      const y = p.value, w = a.page, v = Math.max(5, a.maxPages ?? 7), x = [];
      if (y <= v) {
        for (let T = 1; T <= y; T++)
          x.push(T);
        return x;
      }
      const b = v - 2, k = w > Math.ceil(b / 2) + 1, _ = w < y - Math.ceil(b / 2);
      if (x.push(1), !k && !_)
        for (let T = 2; T < y; T++)
          x.push(T);
      else if (k)
        if (_) {
          x.push("ellipsis");
          const T = b - 2, S = Math.floor(T / 2);
          for (let M = w - S; M <= w + S; M++)
            x.push(M);
          x.push("ellipsis");
        } else {
          x.push("ellipsis");
          const T = b - 1;
          for (let S = y - T; S < y; S++)
            x.push(S);
        }
      else {
        const T = b - 1;
        for (let S = 2; S <= 1 + T; S++)
          x.push(S);
        x.push("ellipsis");
      }
      return x.push(y), x;
    }), h = (y) => {
      o("update:page", y);
    }, $ = m(
      () => Yb({
        size: a.size,
        padded: a.padded,
        class: a.class
      })
    );
    return (y, w) => p.value > 1 || e.alwaysShow ? (i(), g("div", {
      key: 0,
      class: W($.value),
      "data-theme": e.color
    }, [
      C("div", Mk, [
        c.value.length > 0 ? (i(), R(Hr, {
          key: 0,
          modelValue: s.value,
          "onUpdate:modelValue": w[0] || (w[0] = (v) => s.value = v),
          options: c.value,
          size: e.size,
          variant: r.value,
          color: e.color,
          radius: e.radius,
          clearable: !1,
          width: "80px",
          class: "hp-pagination__page-size-select"
        }, null, 8, ["modelValue", "options", "size", "variant", "color", "radius"])) : A("", !0),
        j(at, {
          size: e.size,
          variant: "soft",
          wrap: "nowrap"
        }, {
          default: B(() => [
            me(le(d.value), 1)
          ]),
          _: 1
        }, 8, ["size"])
      ]),
      C("div", Dk, [
        j(Ae, {
          variant: e.variant,
          size: e.size,
          color: e.color,
          radius: e.radius,
          icon: Oo,
          square: "",
          disabled: e.page === 1,
          "aria-label": u(n)("ui.pagination.previousPage", "Previous page"),
          onClick: w[1] || (w[1] = (v) => h(e.page - 1))
        }, null, 8, ["variant", "size", "color", "radius", "disabled", "aria-label"]),
        (i(!0), g(he, null, De(f.value, (v, x) => (i(), g(he, { key: x }, [
          v === "ellipsis" ? (i(), R(at, {
            key: 0,
            size: e.size,
            variant: "soft"
          }, {
            default: B(() => [...w[3] || (w[3] = [
              me("...", -1)
            ])]),
            _: 1
          }, 8, ["size"])) : (i(), R(Ae, {
            key: 1,
            variant: v === e.page ? "filled" : e.variant,
            size: e.size,
            color: e.color,
            radius: e.radius,
            square: v < Tk,
            "aria-current": v === e.page ? "page" : void 0,
            onClick: (b) => h(v)
          }, {
            default: B(() => [
              me(le(v), 1)
            ]),
            _: 2
          }, 1032, ["variant", "size", "color", "radius", "square", "aria-current", "onClick"]))
        ], 64))), 128)),
        j(Ae, {
          variant: e.variant,
          size: e.size,
          color: e.color,
          radius: e.radius,
          icon: Ka,
          square: "",
          disabled: e.page === p.value,
          "aria-label": u(n)("ui.pagination.nextPage", "Next page"),
          onClick: w[2] || (w[2] = (v) => h(e.page + 1))
        }, null, 8, ["variant", "size", "color", "radius", "disabled", "aria-label"])
      ])
    ], 10, Sk)) : A("", !0);
  }
}), mu = /* @__PURE__ */ Symbol("PickerContext"), gu = (e) => {
  Dt(mu, e);
}, yu = () => {
  const e = pt(mu);
  if (!e)
    throw new Error("usePickerContext() must be used inside a Picker shell (PickerDialog, PickerAnchor, PickerPanel)");
  return e;
}, zk = { class: "hp-picker-actions" }, ND = /* @__PURE__ */ Y({
  __name: "PickerActions",
  props: {
    confirmLabel: { type: [String, Function], default: void 0 },
    cancelLabel: { default: void 0 },
    confirmDisabled: { type: Boolean, default: void 0 }
  },
  setup(e) {
    const t = e, n = Le(), a = m(() => t.cancelLabel ?? n("ui.common.cancel", "Cancel")), o = yu(), l = m(() => {
      const c = o.selection.count.value;
      return typeof t.confirmLabel == "function" ? t.confirmLabel(c) : t.confirmLabel ?? n("ui.dialog.confirm", "Confirm");
    }), r = m(() => t.confirmDisabled !== void 0 ? t.confirmDisabled : o.selection.count.value === 0);
    return (c, s) => (i(), g("div", zk, [
      j(u(Ae), {
        variant: "outline",
        size: "3",
        onClick: s[0] || (s[0] = (p) => u(o).lifecycle.dismiss())
      }, {
        default: B(() => [
          me(le(a.value), 1)
        ]),
        _: 1
      }),
      j(u(Ae), {
        variant: "filled",
        size: "3",
        disabled: r.value,
        onClick: s[1] || (s[1] = (p) => u(o).lifecycle.resolve())
      }, {
        default: B(() => [
          me(le(l.value), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ]));
  }
}), gn = 25, Ak = 2, Lk = 3, Nr = [
  gn,
  gn * Ak,
  gn * Lk
], wu = (e = {}) => {
  const {
    singleSelect: t = !1,
    defaultPageSize: n = gn,
    pageSizeOptions: a = [...Nr]
  } = e, o = N([]), l = (S) => {
    const M = o.value.indexOf(S);
    M >= 0 ? o.value.splice(M, 1) : t ? o.value = [S] : o.value.push(S);
  }, r = (S) => {
    o.value = t ? S.slice(0, 1) : S;
  }, c = () => {
    o.value = [];
  }, s = {
    items: o,
    count: m(() => o.value.length),
    toggle: l,
    set: r,
    clear: c
  }, p = N(1), d = N(n), f = N(0), $ = {
    page: p,
    pageSize: d,
    total: f,
    pageSizeOptions: a,
    setTotal: (S) => {
      f.value = S;
    }
  }, y = N(0), v = {
    refresh: y,
    triggerRefresh: () => {
      y.value++;
    }
  }, x = N(!1);
  let b = null;
  return {
    selection: s,
    pagination: $,
    signals: v,
    lifecycle: {
      isOpen: x,
      resolve: (S) => {
        const M = S ?? o.value;
        b?.(M), b = null, x.value = !1;
      },
      dismiss: () => {
        b?.(null), b = null, x.value = !1;
      }
    }
  };
}, FD = /* @__PURE__ */ Y({
  __name: "PickerAnchor",
  props: /* @__PURE__ */ Xe({
    singleSelect: { type: Boolean, default: !1 },
    defaultPageSize: { default: gn },
    pageSizeOptions: { default: () => [...Nr] },
    placement: { default: "bottom-start" },
    closeOnClickOutside: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    focusTrap: { type: Boolean, default: !0 },
    class: { default: void 0 }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["resolve"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = e, a = t, o = vt(e, "open"), l = wu(n);
    gu(l), Se(o, (s) => {
      l.lifecycle.isOpen.value = s, s && (l.pagination.page.value = 1, l.pagination.total.value = 0);
    });
    const r = l.lifecycle.resolve, c = l.lifecycle.dismiss;
    return l.lifecycle.resolve = (s) => {
      const p = s ?? [...l.selection.items.value];
      a("resolve", p), o.value = !1, r(s);
    }, l.lifecycle.dismiss = () => {
      a("resolve", null), o.value = !1, c();
    }, (s, p) => (i(), R(u(Xt), {
      open: o.value,
      "onUpdate:open": p[0] || (p[0] = (d) => o.value = d),
      type: "popover",
      placement: e.placement,
      "close-on-click-outside": e.closeOnClickOutside,
      "close-on-escape": e.closeOnEscape,
      "focus-trap": e.focusTrap
    }, {
      default: B(() => [
        j(u(Jt), null, {
          default: B(({ toggle: d }) => [
            L(s.$slots, "trigger", {
              toggle: d,
              isOpen: o.value
            })
          ]),
          _: 3
        }),
        j(u(Qt), {
          class: W(n.class)
        }, {
          default: B(() => [
            L(s.$slots, "default")
          ]),
          _: 3
        }, 8, ["class"])
      ]),
      _: 3
    }, 8, ["open", "placement", "close-on-click-outside", "close-on-escape", "focus-trap"]));
  }
}), KD = /* @__PURE__ */ Y({
  __name: "PickerBody",
  props: {
    class: {}
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), g("div", {
      class: W(["hp-picker-body", t.class])
    }, [
      L(n.$slots, "default")
    ], 2));
  }
}), Ek = { class: "hp-picker-layout" }, YD = /* @__PURE__ */ Y({
  __name: "PickerDialog",
  props: /* @__PURE__ */ Xe({
    singleSelect: { type: Boolean, default: !1 },
    defaultPageSize: { default: gn },
    pageSizeOptions: { default: () => [...Nr] },
    variant: { default: "surface" },
    size: { default: "5" },
    expandable: { type: Boolean, default: !1 },
    showClose: { type: Boolean, default: !0 },
    closeOnBackdrop: { type: Boolean, default: !1 },
    closeOnEscape: { type: Boolean, default: !0 },
    class: { default: void 0 }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["resolve"], ["update:open"]),
  setup(e, { emit: t }) {
    const n = e, a = t, o = vt(e, "open"), l = wu(n);
    gu(l), Se(o, (p) => {
      l.lifecycle.isOpen.value = p;
    }), Se(l.lifecycle.isOpen, (p) => {
      o.value = p;
    }), Se(o, (p) => {
      p && (l.pagination.page.value = 1, l.pagination.total.value = 0);
    });
    const r = l.lifecycle.resolve, c = l.lifecycle.dismiss;
    l.lifecycle.resolve = (p) => {
      const d = p ?? [...l.selection.items.value];
      a("resolve", d), r(p);
    }, l.lifecycle.dismiss = () => {
      a("resolve", null), c();
    };
    const s = () => {
      l.lifecycle.dismiss();
    };
    return (p, d) => (i(), R(u(Yc), {
      open: o.value,
      "onUpdate:open": d[0] || (d[0] = (f) => o.value = f),
      variant: e.variant,
      size: e.size,
      expandable: e.expandable,
      "show-close": e.showClose,
      "close-on-backdrop": e.closeOnBackdrop,
      "close-on-escape": e.closeOnEscape,
      class: W(n.class),
      "body-class": "hp-picker-dialog-body",
      onCancel: s
    }, {
      default: B(() => [
        C("div", Ek, [
          L(p.$slots, "default")
        ])
      ]),
      _: 3
    }, 8, ["open", "variant", "size", "expandable", "show-close", "close-on-backdrop", "close-on-escape", "class"]));
  }
}), jD = /* @__PURE__ */ Y({
  __name: "PickerFooter",
  props: {
    class: {}
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), g("div", {
      class: W(["hp-picker-footer", t.class])
    }, [
      L(n.$slots, "default")
    ], 2));
  }
}), WD = /* @__PURE__ */ Y({
  __name: "PickerLoader",
  props: {
    loading: { type: Boolean, default: !0 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = e;
    return (n, a) => e.loading ? (i(), g("div", {
      key: 0,
      class: W(["hp-picker-loader", t.class])
    }, [
      j(u(Mn))
    ], 2)) : A("", !0);
  }
}), UD = /* @__PURE__ */ Y({
  __name: "PickerPagination",
  props: {
    alwaysShow: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = yu(), n = (a) => {
      t.pagination.pageSize.value = a, t.pagination.page.value = 1;
    };
    return (a, o) => (i(), R(u(Bk), {
      page: u(t).pagination.page.value,
      total: u(t).pagination.total.value,
      "page-size": u(t).pagination.pageSize.value,
      "page-size-options": u(t).pagination.pageSizeOptions,
      "always-show": e.alwaysShow,
      "onUpdate:page": o[0] || (o[0] = (l) => u(t).pagination.page.value = l),
      "onUpdate:pageSize": n
    }, null, 8, ["page", "total", "page-size", "page-size-options", "always-show"]));
  }
}), qD = /* @__PURE__ */ Y({
  __name: "PickerSidebar",
  props: {
    class: {}
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), g("div", {
      class: W(["hp-picker-sidebar", t.class])
    }, [
      L(n.$slots, "default")
    ], 2));
  }
}), Zs = ["cat", "fox", "bear", "rabbit", "frog", "panda"], Gs = [
  { tone: "fur", path: "M4 3h5v3h6V3h5v15h-2v3H6v-3H4Z" },
  { tone: "blush", path: "M6 5h1v2H6Z M17 5h1v2h-1Z" }
], Xs = [
  { tone: "fur", path: "M3 4h6v3h6V4h6v6h-1v8h-2v3H6v-3H4v-8H3Z" },
  { tone: "blush", path: "M5 6h2v2H5Z M17 6h2v2h-2Z" }
], Ik = {
  cat: [...Gs, { tone: "patch", path: "M9 14h6v5H9Z" }],
  fox: [...Gs, { tone: "patch", path: "M5 12h4v2h6v-2h4v4h-2v2h-2v2H9v-2H7v-2H5Z" }],
  bear: [...Xs, { tone: "patch", path: "M8 14h8v5H8Z" }],
  rabbit: [
    { tone: "fur", path: "M5 1h5v7h4V1h5v8h1v9h-2v3H6v-3H4V9h1Z" },
    { tone: "blush", path: "M7 3h1v5H7Z M16 3h1v5h-1Z" }
  ],
  frog: [
    { tone: "fur", path: "M4 4h6v3h4V4h6v6h1v8h-3v3H6v-3H3v-8h1Z" },
    { tone: "patch", path: "M5 8h5v5H5Z M14 8h5v5h-5Z M7 16h10v3H7Z" }
  ],
  panda: [...Xs, { tone: "patch", path: "M4 5h4v3H4Z M16 5h4v3h-4Z M6 9h5v4H6Z M13 9h5v4h-5Z" }]
}, Qs = [
  "M7 10h2v2H7Z M15 10h2v2h-2Z",
  "M6 10h4v1H8v1H7v-1H6Z M14 10h4v1h-1v1h-1v-1h-2Z",
  "M7 10h2v2H7Z M14 11h4v1h-4Z"
], Js = [
  "M11 14h2v2h-2Z M10 17h4v1h-4Z",
  "M11 14h2v2h-2Z M9 17h1v1h4v-1h1v2H9Z",
  "M11 14h2v2h-2Z M8 17h3v-1h2v1h3v1h-3v-1h-2v1H8Z"
], Rk = 2166136261, Pk = 16777619, ei = 4294967296, Ok = ["blue", "green", "orange", "purple", "red", "dark-blue"], hl = ["blue", "green", "purple", "dark-blue"], Vk = {
  cat: hl,
  fox: hl,
  bear: hl,
  rabbit: ["blue", "green", "purple", "red", "dark-blue", "orange"],
  frog: ["blue", "orange", "purple", "red", "dark-blue"],
  panda: Ok
}, vo = (e) => {
  let t = Rk;
  for (let n = 0; n < e.length; n++)
    t = Math.imul(t ^ e.charCodeAt(n), Pk);
  return (t + ei) % ei;
}, Hk = (e) => {
  const t = String(e), n = Zs[vo(`${t}:animal`) % Zs.length], a = Vk[n];
  return {
    animal: n,
    color: a[vo(`${t}:color`) % a.length],
    eyes: Qs[vo(`${t}:eyes`) % Qs.length],
    mouth: Js[vo(`${t}:mouth`) % Js.length]
  };
}, Nk = {
  viewBox: "-3 -3 30 30",
  "aria-hidden": "true",
  focusable: "false",
  "shape-rendering": "crispEdges"
}, Fk = ["d"], Kk = ["d"], Yk = ["d"], jk = ["href"], ZD = /* @__PURE__ */ Y({
  __name: "PixelAvatar",
  props: {
    size: { default: "3" },
    radius: { default: "full" },
    color: {},
    seed: {},
    label: {},
    interactive: { type: Boolean }
  },
  setup(e) {
    const t = e, n = `pixel-avatar-${ha()}`, a = m(() => Hk(t.seed)), o = m(() => Ik[a.value.animal]), l = ze("hp-pixel-avatar", { variants: { animal: {
      cat: "hp-pixel-avatar--cat",
      fox: "hp-pixel-avatar--fox",
      bear: "hp-pixel-avatar--bear",
      rabbit: "hp-pixel-avatar--rabbit",
      frog: "hp-pixel-avatar--frog",
      panda: "hp-pixel-avatar--panda"
    }, interactive: { true: "hp-pixel-avatar--interactive" } } }), r = m(() => l({ animal: a.value.animal, interactive: t.interactive }));
    return (c, s) => (i(), R(J1, {
      class: W(r.value),
      size: e.size,
      radius: e.radius,
      color: e.color ?? a.value.color,
      variant: "soft",
      role: e.label ? "img" : void 0,
      "aria-label": e.label,
      "aria-hidden": e.label ? void 0 : !0
    }, {
      default: B(() => [
        (i(), g("svg", Nk, [
          C("defs", null, [
            C("symbol", {
              id: n,
              viewBox: "0 0 24 24"
            }, [
              (i(!0), g(he, null, De(o.value, (p, d) => (i(), g("path", {
                key: d,
                d: p.path,
                class: W(`hp-pixel-avatar__${p.tone}`)
              }, null, 10, Fk))), 128)),
              C("path", {
                d: a.value.eyes,
                class: "hp-pixel-avatar__eyes"
              }, null, 8, Kk),
              C("path", {
                d: a.value.mouth,
                class: "hp-pixel-avatar__ink"
              }, null, 8, Yk)
            ])
          ]),
          C("use", {
            href: `#${n}`,
            width: "24",
            height: "24"
          }, null, 8, jk)
        ]))
      ]),
      _: 1
    }, 8, ["class", "size", "radius", "color", "role", "aria-label", "aria-hidden"]));
  }
}), Wk = {
  key: 0,
  class: "hp-popover__header"
}, Uk = ["href", "onClick"], qk = {
  key: 2,
  class: "hp-popover__row"
}, Zk = {
  key: 2,
  class: "hp-popover__empty"
}, ti = 1, GD = /* @__PURE__ */ Y({
  __name: "Popover",
  props: {
    items: {},
    size: { default: "1" },
    buttonSize: { default: "3" },
    variant: { default: "blank" },
    color: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    teleportTo: {}
  },
  setup(e) {
    const t = Le(), n = e, a = N(!1), o = () => {
      n.disabled || (a.value = !a.value);
    }, l = () => {
      a.value = !1;
    }, r = (y, w) => {
      y.disabled || (a.value = !1, y.onClick?.(w));
    }, c = (y, w) => {
      const v = w.ctrlKey || w.metaKey || w.shiftKey;
      w.button !== 0 || v || (w.preventDefault(), r(y, w));
    }, s = (y, w) => {
      w.button !== ti || y.disabled || !y.onAuxClick || (w.preventDefault(), a.value = !1, y.onAuxClick(w));
    }, p = (y, w) => {
      w.button === ti && y.onAuxClick && w.preventDefault();
    }, d = (y) => ({
      label: y.label,
      icon: y.icon,
      iconColor: y.iconColor,
      badge: y.badge,
      variant: y.variant,
      disabled: y.disabled,
      selected: y.selected
    }), f = (y) => Ii({ variant: y.variant, disabled: y.disabled, selected: y.selected }), h = ze("hp-popover__menu", {
      variants: {
        size: {
          1: "hp-popover__menu--size-1",
          2: "hp-popover__menu--size-2",
          3: "hp-popover__menu--size-3"
        }
      },
      defaultVariants: {
        size: "1"
      }
    }), $ = m(
      () => h({
        size: n.size
      })
    );
    return (y, w) => (i(), R(Xt, {
      open: a.value,
      "onUpdate:open": w[0] || (w[0] = (v) => a.value = v),
      type: "menu",
      placement: "bottom-end"
    }, {
      default: B(() => [
        j(Jt, null, {
          default: B(() => [
            L(y.$slots, "trigger", {
              toggle: o,
              isOpen: a.value
            }, () => [
              j(Ae, {
                variant: e.variant,
                size: e.buttonSize,
                color: e.color,
                disabled: e.disabled,
                loading: e.loading,
                square: "",
                "aria-label": u(t)("ui.popover.openMenu", "Open menu"),
                onClick: o
              }, {
                default: B(() => [
                  j(Pa, null, {
                    default: B(() => [
                      L(y.$slots, "prefix")
                    ]),
                    _: 3
                  })
                ]),
                _: 3
              }, 8, ["variant", "size", "color", "disabled", "loading", "aria-label"])
            ])
          ]),
          _: 3
        }),
        j(Qt, {
          class: W($.value)
        }, {
          default: B(() => [
            y.$slots.header ? (i(), g("div", Wk, [
              L(y.$slots, "header")
            ])) : A("", !0),
            e.items.length > 0 ? (i(!0), g(he, { key: 1 }, De(e.items, (v, x) => (i(), g(he, { key: x }, [
              v.divider ? (i(), R(Ei, { key: 0 })) : A("", !0),
              v.href ? (i(), g("a", {
                key: 1,
                href: v.disabled ? void 0 : v.href,
                class: W(f(v)),
                onClick: (b) => c(v, b)
              }, [
                j(at, {
                  size: "3",
                  weight: "medium",
                  class: "hp-menu-item__label"
                }, {
                  default: B(() => [
                    me(le(v.label), 1)
                  ]),
                  _: 2
                }, 1024)
              ], 10, Uk)) : v.action ? (i(), g("div", qk, [
                j(Oa, Ke({ ref_for: !0 }, d(v), {
                  class: "hp-popover__row-item",
                  onClick: (b) => r(v),
                  onAuxclick: (b) => s(v, b),
                  onMousedown: (b) => p(v, b)
                }), null, 16, ["onClick", "onAuxclick", "onMousedown"]),
                j(Ae, {
                  class: "hp-popover__row-action",
                  size: "1",
                  variant: "blank",
                  square: "",
                  icon: v.action.icon,
                  "aria-label": v.action.label,
                  title: v.action.label,
                  onClick: Fe((b) => v.action.onClick(), ["stop"])
                }, null, 8, ["icon", "aria-label", "title", "onClick"])
              ])) : (i(), R(Oa, Ke({
                key: 3,
                ref_for: !0
              }, d(v), {
                onClick: (b) => r(v),
                onAuxclick: (b) => s(v, b),
                onMousedown: (b) => p(v, b)
              }), null, 16, ["onClick", "onAuxclick", "onMousedown"]))
            ], 64))), 128)) : y.$slots.empty ? (i(), g("div", Zk, [
              L(y.$slots, "empty", { close: l })
            ])) : A("", !0)
          ]),
          _: 3
        }, 8, ["class"])
      ]),
      _: 3
    }, 8, ["open"]));
  }
}), Gk = ze("hp-radio-group", {
  variants: {
    variant: {
      filled: "hp-radio-group--filled",
      soft: "hp-radio-group--soft",
      outline: "hp-radio-group--outline",
      surface: "hp-radio-group--surface"
    },
    size: {
      1: "hp-radio-group--size-1",
      2: "hp-radio-group--size-2",
      3: "hp-radio-group--size-3",
      4: "hp-radio-group--size-4",
      5: "hp-radio-group--size-5"
    },
    orientation: {
      vertical: "hp-radio-group--vertical",
      horizontal: "hp-radio-group--horizontal"
    },
    disabled: {
      true: "hp-radio-group--disabled"
    }
  },
  defaultVariants: {
    variant: "filled",
    size: "3",
    orientation: "vertical"
  }
}), Xk = ["data-theme", "aria-disabled"], Qk = ["name", "value", "checked", "disabled", "onChange"], Jk = { class: "hp-radio-group__label" }, e4 = /* @__PURE__ */ Y({
  __name: "RadioGroup",
  props: /* @__PURE__ */ Xe({
    modelValue: {},
    options: {},
    name: { default: void 0 },
    variant: { default: "filled" },
    size: { default: "3" },
    orientation: { default: "vertical" },
    disabled: { type: Boolean, default: !1 },
    color: { default: void 0 },
    class: { default: void 0 }
  }, {
    modelValue: { default: void 0 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["change"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, a = vt(e, "modelValue"), o = t, l = ha(), r = m(() => n.name ?? l), c = m(
      () => Gk({
        variant: n.variant,
        size: n.size,
        orientation: n.orientation,
        disabled: n.disabled,
        class: n.class
      })
    ), s = (d) => n.disabled || d.disabled ? "hp-radio-group__option hp-radio-group__option--disabled" : "hp-radio-group__option", p = (d) => {
      a.value = d, o("change", d);
    };
    return (d, f) => (i(), g("div", {
      class: W(c.value),
      "data-theme": e.color,
      role: "radiogroup",
      "aria-disabled": e.disabled || void 0
    }, [
      (i(!0), g(he, null, De(e.options, (h) => (i(), g("label", {
        key: h.value,
        class: W(s(h))
      }, [
        C("input", {
          type: "radio",
          class: "hp-radio-group__input",
          name: r.value,
          value: h.value,
          checked: a.value === h.value,
          disabled: e.disabled || h.disabled,
          onChange: ($) => p(h.value)
        }, null, 40, Qk),
        f[0] || (f[0] = C("span", { class: "hp-radio-group__indicator" }, [
          C("span", { class: "hp-radio-group__dot" })
        ], -1)),
        C("span", Jk, le(h.label), 1)
      ], 2))), 128))
    ], 10, Xk));
  }
}), XD = /* @__PURE__ */ se(e4, [["__scopeId", "data-v-7751598c"]]), t4 = ze("hp-ui-boundary hp-sidebar", {
  variants: {
    variant: {
      filled: "hp-sidebar--filled",
      surface: "hp-sidebar--surface"
    },
    size: {
      1: "hp-sidebar--size-1",
      2: "hp-sidebar--size-2",
      3: "hp-sidebar--size-3",
      4: "hp-sidebar--size-4",
      5: "hp-sidebar--size-5",
      6: "hp-sidebar--size-6",
      7: "hp-sidebar--size-7"
    },
    shadow: {
      true: "hp-sidebar--shadow",
      false: ""
    },
    showBackdrop: {
      true: "",
      false: "hp-sidebar--no-backdrop"
    }
  },
  defaultVariants: {
    variant: "surface",
    size: "3",
    shadow: !0,
    showBackdrop: !0
  }
}), bu = /* @__PURE__ */ Symbol("SidebarContext"), Wo = () => {
  const e = pt(bu);
  if (!e)
    throw new Error("Sidebar compound components must be used within <Sidebar>");
  return e;
}, a4 = ["id", "data-theme", "aria-labelledby", "aria-describedby"], n4 = { class: "hp-dialog__container" }, o4 = { class: "hp-dialog-header" }, l4 = { class: "hp-dialog-body hp-dialog-body--padded" }, r4 = { class: "hp-dialog-footer" }, QD = /* @__PURE__ */ Y({
  inheritAttrs: !1,
  __name: "Sidebar",
  props: /* @__PURE__ */ Xe({
    id: { default: void 0 },
    variant: { default: "surface" },
    size: { default: "3" },
    color: { default: void 0 },
    showClose: { type: Boolean, default: !0 },
    closeOnBackdrop: { type: Boolean, default: !0 },
    closeOnEscape: { type: Boolean, default: !0 },
    shadow: { type: Boolean, default: !0 },
    showBackdrop: { type: Boolean, default: !0 },
    class: { default: void 0 },
    loading: { type: Boolean, default: !1 },
    confirmClose: { type: Boolean, default: !1 },
    escapeEmitsCancel: { type: Boolean, default: !0 }
  }, {
    open: { type: Boolean, default: !1 },
    openModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["cancel", "close"], ["update:open"]),
  setup(e, { expose: t, emit: n }) {
    const a = Le(), o = e, l = m(
      () => t4({
        variant: o.variant,
        size: o.size,
        shadow: o.shadow,
        showBackdrop: o.showBackdrop,
        class: o.class
      })
    ), r = m(() => o.loading || o.confirmClose), c = vt(e, "open"), s = N(!1), p = n, d = N(), f = N(null), h = N(), $ = N(!1), y = m(() => mn(d.value));
    Zl(c), Gl(f, c, y);
    const w = ha(), v = ha(), { lock: x, unlock: b } = Kc(), k = (z) => {
      z && (z.open || z.showModal(), Fc(z));
    }, _ = (z) => {
      z && (Ca(z), z.open && z.close());
    }, T = () => {
      k(h.value);
    }, S = () => {
      _(h.value);
    }, M = () => {
      _(h.value), s.value = !0, c.value = !1, p("close"), Ye(() => {
        s.value = !1;
      });
    }, E = () => {
      if (r.value) {
        T();
        return;
      }
      c.value = !1, p("close");
    };
    Dt(bu, { titleId: w, descriptionId: v, close: E, closeImmediately: M }), Se(
      c,
      async (z, D) => {
        if (D && !z && r.value && !s.value) {
          c.value = !0, T();
          return;
        }
        await Ye(), z ? (k(d.value), x()) : (_(d.value), b());
      },
      { immediate: !0 }
    ), Se(r, (z) => {
      z || S();
    });
    const F = () => {
      p("cancel"), M();
    }, H = () => {
      d.value && Ca(d.value), c.value && (c.value = !1, p("close"));
    }, te = (z) => {
      if (!mn(d.value)) {
        z.preventDefault();
        return;
      }
      z.preventDefault(), o.closeOnEscape && (Nc("escape", {
        escapeEmitsCancel: o.escapeEmitsCancel,
        isGuarded: r.value
      }) && p("cancel"), E());
    }, ie = (z) => {
      $.value = z.target === d.value;
    }, ee = (z) => {
      if (!mn(d.value)) {
        $.value = !1;
        return;
      }
      o.closeOnBackdrop && (z.target === d.value && $.value && E(), $.value = !1);
    }, O = (z) => {
      z.preventDefault(), S();
    };
    return t({
      dialogRef: d,
      open: () => {
        c.value = !0;
      },
      close: E,
      closeImmediately: M
    }), ct(() => {
      d.value && Ca(d.value), h.value && Ca(h.value);
    }), (z, D) => (i(), R(Eo, { to: "body" }, [
      C("dialog", {
        ref_key: "dialogRef",
        ref: d,
        id: e.id,
        class: W(l.value),
        "data-theme": e.color,
        "aria-labelledby": u(w),
        "aria-describedby": u(v),
        onClose: H,
        onCancel: te,
        onMousedown: ie,
        onClick: ee
      }, [
        C("div", {
          ref_key: "containerRef",
          ref: f,
          class: "hp-sidebar__container",
          tabindex: "-1",
          onClick: D[0] || (D[0] = Fe(() => {
          }, ["stop"]))
        }, [
          L(z.$slots, "default")
        ], 512)
      ], 42, a4),
      C("dialog", {
        ref_key: "confirmDialogRef",
        ref: h,
        class: "hp-ui-boundary hp-dialog hp-dialog--surface hp-dialog--size-1 hp-dialog--shadow",
        onCancel: O
      }, [
        C("div", n4, [
          C("header", o4, [
            j(u($n), {
              size: "6",
              weight: "semibold",
              as: "h2",
              class: "hp-dialog-title"
            }, {
              default: B(() => [
                me(le(u(a)("ui.dialog.unsavedChanges", "Unsaved changes")), 1)
              ]),
              _: 1
            })
          ]),
          C("div", l4, le(u(a)("ui.dialog.yourChangesWillBeLostIfYouLeave", "Your changes will be lost if you leave.")), 1),
          C("footer", r4, [
            j(u(Ae), {
              variant: "outline",
              onClick: F
            }, {
              default: B(() => [
                me(le(u(a)("ui.dialog.leaveWithoutSaving", "Leave without saving")), 1)
              ]),
              _: 1
            }),
            j(u(Ae), {
              variant: "filled",
              onClick: S
            }, {
              default: B(() => [
                me(le(u(a)("ui.dialog.stay", "Stay")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ], 544)
    ]));
  }
}), s4 = {}, i4 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function c4(e, t) {
  return i(), g("svg", i4, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M8.5 15L3.5 10L8.5 5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M17.5 10H4.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const u4 = /* @__PURE__ */ se(s4, [["render", c4]]), JD = /* @__PURE__ */ Y({
  __name: "SidebarBack",
  setup(e) {
    const t = Le(), n = Wo();
    return (a, o) => (i(), R(u(Ae), {
      variant: "soft",
      size: "1",
      square: "",
      icon: u4,
      class: "hp-sidebar-back",
      "aria-label": u(t)("ui.sidebar.goBack", "Go back"),
      onClick: o[0] || (o[0] = (l) => u(n).close())
    }, null, 8, ["aria-label"]));
  }
}), eT = /* @__PURE__ */ Y({
  __name: "SidebarBody",
  props: {
    padded: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (t, n) => (i(), g("div", {
      class: W(["hp-sidebar-body", { "hp-sidebar-body--padded": e.padded }]),
      tabindex: "-1"
    }, [
      L(t.$slots, "default")
    ], 2));
  }
}), tT = /* @__PURE__ */ Y({
  __name: "SidebarClose",
  setup(e) {
    const t = Le(), n = Wo();
    return (a, o) => (i(), R(u(Ae), {
      variant: "soft",
      size: "1",
      square: "",
      icon: zt,
      class: "hp-sidebar-close",
      "aria-label": u(t)("ui.sidebar.closeSidebar", "Close sidebar"),
      onClick: o[0] || (o[0] = (l) => u(n).close())
    }, null, 8, ["aria-label"]));
  }
}), d4 = {}, p4 = { class: "hp-sidebar-header__controls" };
function f4(e, t) {
  return i(), g("div", p4, [
    L(e.$slots, "default")
  ]);
}
const aT = /* @__PURE__ */ se(d4, [["render", f4]]), nT = /* @__PURE__ */ Y({
  __name: "SidebarDescription",
  setup(e) {
    const t = Wo();
    return (n, a) => (i(), R(u(at), {
      id: u(t).descriptionId,
      size: "2",
      variant: "soft",
      as: "p",
      class: "hp-sidebar-description"
    }, {
      default: B(() => [
        L(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["id"]));
  }
}), h4 = {}, v4 = { class: "hp-sidebar-footer" };
function m4(e, t) {
  return i(), g("div", v4, [
    L(e.$slots, "default")
  ]);
}
const oT = /* @__PURE__ */ se(h4, [["render", m4]]), g4 = {}, y4 = { class: "hp-sidebar-header" };
function w4(e, t) {
  return i(), g("div", y4, [
    L(e.$slots, "default")
  ]);
}
const lT = /* @__PURE__ */ se(g4, [["render", w4]]), rT = /* @__PURE__ */ Y({
  __name: "SidebarLoader",
  props: {
    loading: { type: Boolean, default: !0 }
  },
  setup(e) {
    return (t, n) => (i(), R(u(Mn), { loading: e.loading }, null, 8, ["loading"]));
  }
}), b4 = {}, k4 = { class: "hp-sidebar-menu" };
function _4(e, t) {
  return i(), g("div", k4, [
    L(e.$slots, "default")
  ]);
}
const sT = /* @__PURE__ */ se(b4, [["render", _4]]), iT = /* @__PURE__ */ Y({
  __name: "SidebarTitle",
  setup(e) {
    const t = Wo();
    return (n, a) => (i(), R(u($n), {
      id: u(t).titleId,
      size: "6",
      weight: "semibold",
      as: "h2",
      class: "hp-sidebar-title"
    }, {
      default: B(() => [
        L(n.$slots, "default")
      ]),
      _: 3
    }, 8, ["id"]));
  }
}), C4 = {}, x4 = { class: "hp-side-menu__action" };
function $4(e, t) {
  return i(), g("span", x4, [
    L(e.$slots, "default")
  ]);
}
const cT = /* @__PURE__ */ se(C4, [["render", $4]]), uT = /* @__PURE__ */ Y({
  __name: "MenuDivider",
  props: {
    fullWidth: { type: Boolean }
  },
  setup(e) {
    const t = e, n = ze("hp-side-menu__divider", { variants: { fullWidth: { true: "hp-side-menu__divider--full-width" } } }), a = m(() => n({ fullWidth: t.fullWidth }));
    return (o, l) => (i(), g("div", {
      class: W(a.value),
      role: "separator"
    }, [...l[0] || (l[0] = [
      C("hr", null, null, -1)
    ])], 2));
  }
}), dT = /* @__PURE__ */ Y({
  __name: "MenuEnd",
  setup(e) {
    const t = jo(), n = m(() => t.collapsed?.value && !t.revealLabels?.value);
    return (a, o) => !n.value || a.$slots.compact ? (i(), g("span", {
      key: 0,
      class: W(["hp-side-menu__end", { "hp-side-menu__end--compact": n.value }])
    }, [
      n.value ? L(a.$slots, "compact", { key: 0 }) : L(a.$slots, "default", { key: 1 })
    ], 2)) : A("", !0);
  }
}), mo = "max-height var(--duration-slow, 300ms) ease-in-out", S4 = (e) => {
  const t = e?.isOpen, n = N(typeof t == "object" ? t.value : t ?? !1), a = N(null), o = N(!1);
  let l = !1;
  const r = N(
    n.value ? { maxHeight: "none", overflow: "hidden" } : { maxHeight: "0px", overflow: "hidden", transition: mo }
  ), c = () => a.value?.scrollHeight ?? 0, s = () => {
    o.value = !1, n.value && (r.value = { maxHeight: "none", overflow: "hidden" });
  }, p = () => {
    o.value = !0, r.value = { maxHeight: `${c()}px`, overflow: "hidden", transition: mo };
  }, d = () => {
    if (!a.value) {
      r.value = { maxHeight: "0px", overflow: "hidden", transition: mo };
      return;
    }
    const v = c();
    r.value = { maxHeight: `${v}px`, overflow: "hidden" }, a.value.offsetHeight, o.value = !0, r.value = { maxHeight: "0px", overflow: "hidden", transition: mo };
  }, f = () => {
    n.value = !n.value;
  }, h = () => {
    n.value = !0;
  }, $ = () => {
    n.value = !1;
  }, y = () => {
    l = !0, n.value = !0, o.value = !1, r.value = { maxHeight: "none", overflow: "hidden" };
  }, w = () => {
    n.value && !o.value && (r.value = { maxHeight: "none", overflow: "hidden" });
  };
  return Se(n, (v) => {
    if (l) {
      l = !1;
      return;
    }
    v ? p() : d();
  }), typeof t == "object" && Se(t, (v) => {
    n.value = v;
  }), tt(() => {
    a.value?.addEventListener("transitionend", s);
  }), Se(a, (v, x) => {
    x?.removeEventListener("transitionend", s), v?.addEventListener("transitionend", s);
  }), { isOpen: n, toggle: f, open: h, close: $, snapOpen: y, contentRef: a, contentStyle: r, recalculate: w };
}, M4 = { class: "hp-side-menu__item" }, D4 = ["inert"], T4 = { class: "hp-side-menu__children-list" }, pT = /* @__PURE__ */ Y({
  __name: "MenuItem",
  props: {
    link: { default: void 0 },
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    isOpen: { type: Boolean, default: !1 },
    variant: { default: void 0 }
  },
  emits: ["click", "toggle"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = mt(), l = jo(), r = ze("hp-side-menu__item-row d-flex items-center gap-2", {
      variants: {
        size: {
          1: "hp-side-menu__item-row--size-1",
          2: "hp-side-menu__item-row--size-2",
          3: "hp-side-menu__item-row--size-3",
          4: "hp-side-menu__item-row--size-4"
        },
        variant: {
          blank: "hp-side-menu__item-row--blank",
          soft: "hp-side-menu__item-row--soft",
          surface: "hp-side-menu__item-row--surface",
          attention: "hp-side-menu__item-row--attention"
        },
        disabled: { true: "hp-side-menu__item-row--disabled" }
      },
      defaultVariants: { size: "3", variant: "blank" }
    }), c = m(() => n.variant ?? l.variant.value), s = m(
      () => r({
        size: l.size.value,
        variant: c.value,
        disabled: n.disabled || void 0,
        class: [n.active ? "is-active" : "", d.isOpen.value ? "is-open" : ""].filter(Boolean).join(" ") || void 0
      })
    ), p = () => !!o.children, d = S4({ isOpen: n.isOpen }), f = d.contentRef, h = () => p() && !n.link && !n.disabled;
    Se(
      () => n.isOpen,
      (w) => {
        w && !d.isOpen.value && d.snapOpen();
      }
    );
    const $ = () => {
      a("click"), p() && (d.toggle(), a("toggle", d.isOpen.value));
    }, y = (w) => {
      h() && (w.key === "Enter" || w.key === " " || w.key === "Spacebar") && (w.preventDefault(), $());
    };
    return tt(() => d.recalculate()), (w, v) => {
      const x = Yl("router-link");
      return i(), g("div", M4, [
        (i(), R(Pe(e.link && !w.$slots.actions ? "router-link" : "div"), {
          to: w.$slots.actions ? void 0 : e.link,
          "exact-active-class": "is-active",
          "active-class": "",
          class: W(s.value),
          "data-theme": c.value === "attention" ? "purple" : void 0,
          role: h() ? "button" : void 0,
          tabindex: h() ? 0 : void 0,
          "aria-expanded": h() ? u(d).isOpen.value : void 0,
          onClick: $,
          onKeydown: y
        }, {
          default: B(() => [
            e.link && w.$slots.actions ? (i(), R(x, {
              key: 0,
              to: e.link,
              class: "hp-side-menu__item-navigation"
            }, {
              default: B(() => [
                L(w.$slots, "default")
              ]),
              _: 3
            }, 8, ["to"])) : L(w.$slots, "default", { key: 1 }),
            w.$slots.actions ? (i(), g("span", {
              key: 2,
              class: W(["hp-side-menu__end", { "hp-side-menu__end--compact": u(l).collapsed?.value && !u(l).revealLabels?.value }]),
              onClick: v[0] || (v[0] = Fe(() => {
              }, ["stop"])),
              onKeydown: v[1] || (v[1] = Fe(() => {
              }, ["stop"]))
            }, [
              L(w.$slots, "actions")
            ], 34)) : A("", !0),
            p() ? (i(), g("span", {
              key: 3,
              class: W(["hp-side-menu__chevron", { "is-open": u(d).isOpen.value }])
            }, [
              j(en)
            ], 2)) : A("", !0)
          ]),
          _: 3
        }, 40, ["to", "class", "data-theme", "role", "tabindex", "aria-expanded"])),
        p() ? (i(), g("div", {
          key: 0,
          ref_key: "childrenEl",
          ref: f,
          class: "hp-side-menu__children",
          inert: !u(d).isOpen.value || void 0,
          style: Ie(u(d).contentStyle.value)
        }, [
          C("div", T4, [
            L(w.$slots, "children")
          ])
        ], 12, D4)) : A("", !0)
      ]);
    };
  }
}), B4 = (e) => {
  const t = N(!1), n = N("");
  let a = null, o = null;
  const l = () => {
    const c = e.value;
    if (!c) {
      t.value = !1, n.value = "";
      return;
    }
    n.value = c.textContent?.trim() ?? "", t.value = n.value.length > 0 && c.scrollWidth > c.clientWidth;
  }, r = () => {
    a?.disconnect(), a = null, o?.disconnect(), o = null;
  };
  return Se(
    e,
    (c) => {
      if (r(), !c) {
        l();
        return;
      }
      typeof ResizeObserver < "u" && (a = new ResizeObserver(() => l()), a.observe(c)), typeof MutationObserver < "u" && (o = new MutationObserver(() => l()), o.observe(c, { characterData: !0, childList: !0, subtree: !0 })), l();
    },
    { immediate: !0, flush: "post" }
  ), Un(r), { isOverflowing: t, fullText: n };
}, z4 = ["title"], fT = /* @__PURE__ */ Y({
  __name: "MenuLabel",
  setup(e) {
    const t = N(null), { isOverflowing: n, fullText: a } = B4(t);
    return (o, l) => (i(), R(Ro, {
      text: u(a),
      disabled: !u(n),
      "max-width": "5"
    }, {
      default: B(() => [
        C("span", {
          ref_key: "labelEl",
          ref: t,
          class: "hp-side-menu__label",
          title: u(n) ? u(a) : void 0
        }, [
          L(o.$slots, "default")
        ], 8, z4)
      ]),
      _: 3
    }, 8, ["text", "disabled"]));
  }
}), A4 = {}, L4 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "hp-tree-icon"
};
function E4(e, t) {
  return i(), g("svg", L4, [...t[0] || (t[0] = [
    C("mask", {
      id: "path-1-inside-1_1049_164",
      fill: "white"
    }, [
      C("path", { d: "M0 0H16V16H0V0Z" })
    ], -1),
    C("path", {
      d: "M0 16H1.5V0H0H-1.5V16H0Z",
      fill: "var(--icon-fill, var(--icon-color, currentColor))",
      mask: "url(#path-1-inside-1_1049_164)"
    }, null, -1)
  ])]);
}
const I4 = /* @__PURE__ */ se(A4, [["render", E4]]), R4 = {}, P4 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "hp-tree-icon"
};
function O4(e, t) {
  return i(), g("svg", P4, [...t[0] || (t[0] = [
    C("mask", {
      id: "path-1-inside-1_1049_163",
      fill: "white"
    }, [
      C("path", { d: "M0 0H16V16H0V0Z" })
    ], -1),
    C("path", {
      d: "M0 16H-1.5V17.5H0V16ZM16 16V14.5H0V16V17.5H16V16ZM0 16H1.5V0H0H-1.5V16H0Z",
      fill: "var(--icon-fill, var(--icon-color, currentColor))",
      mask: "url(#path-1-inside-1_1049_163)"
    }, null, -1)
  ])]);
}
const V4 = /* @__PURE__ */ se(R4, [["render", O4]]), H4 = { class: "hp-side-menu" }, N4 = { class: "hp-side-menu__list" }, F4 = { style: { position: "relative" } }, K4 = { class: "hp-side-menu__item-right" }, Y4 = ["data-index"], j4 = { class: "hp-side-menu__children-inner" }, W4 = { class: "hp-side-menu__children-list" }, U4 = ["onClick"], q4 = { class: "hp-side-menu__child-wrapper hp-button" }, Z4 = { style: { display: "flex", "flex-direction": "column" } }, G4 = { class: "hp-side-menu__item-left" }, X4 = { class: "hp-side-menu__child-name" }, Q4 = {
  key: 0,
  class: "hp-side-menu__child-right"
}, J4 = {
  key: 1,
  class: "hp-list-border"
}, e8 = /* @__PURE__ */ Y({
  __name: "SideMenu",
  props: {
    collapsed: { type: Boolean },
    showCollapsedChildren: { type: Boolean },
    revealLabels: { type: Boolean },
    size: {},
    variant: {},
    items: { default: () => [] }
  },
  emits: ["item-click", "child-click", "toggle"],
  setup(e, { emit: t }) {
    const n = mt(), a = e, o = t, r = N((() => {
      const v = /* @__PURE__ */ new Set();
      return a.items.forEach((x, b) => {
        x.isOpen && x.items && x.items.length > 0 && v.add(b);
      }), v;
    })()), c = N(/* @__PURE__ */ new Map()), s = N([]), p = (v) => v == 0 ? !1 : r.value.has(v), d = (v) => {
      const x = p(v), b = c.value.get(v) || 0;
      return {
        maxHeight: x ? `${b}px` : "0px",
        overflow: "hidden",
        transition: "max-height 0.3s ease-in-out"
      };
    }, f = (v) => {
      Ye(() => {
        const x = s.value.find((b) => b && b.dataset.index === String(v));
        if (x) {
          const b = x.querySelector(".hp-side-menu__children-inner");
          b && c.value.set(v, b.scrollHeight);
        }
      });
    }, h = (v) => {
      const x = p(v);
      x ? r.value.delete(v) : (r.value.add(v), f(v)), o("toggle", v, !x);
    }, $ = (v) => !v.link && (!v.items || v.items.length === 0) ? "hp-side-menu__item--surface" : "", y = (v, x) => {
      o("item-click", v, x), v.items && v.items.length > 0 && h(x);
    }, w = (v, x, b) => {
      o("child-click", v, x, b);
    };
    return tt(() => {
      a.items.forEach((v, x) => {
        v.items && v.items.length > 0 && f(x);
      });
    }), Se(
      () => a.items,
      () => {
        Ye(() => {
          a.items.forEach((v, x) => {
            v.items && v.items.length > 0 && (f(x), v.isOpen && !r.value.has(x) && r.value.add(x));
          });
        });
      },
      { deep: !0 }
    ), (v, x) => (i(), g("nav", H4, [
      C("ul", N4, [
        (i(!0), g(he, null, De(e.items, (b, k) => (i(), g("li", {
          key: k,
          class: "hp-side-menu__item"
        }, [
          C("div", F4, [
            j(Ae, {
              as: b.link ? "router-link" : "button",
              to: b.link,
              onClick: (_) => y(b, k),
              variant: !b.link && (!b.items || b.items.length === 0) ? "soft" : "blank",
              class: W(`${$(b)} ${p(k) && "is-open"}`),
              color: !b.link && (!b.items || b.items.length === 0) ? "purple" : "default"
            }, {
              default: B(() => [
                b.icon ? (i(), R(Pa, { key: 0 }, {
                  default: B(() => [
                    (i(), R(Pe(b.icon), { class: "hp-side-menu__item-icon" }))
                  ]),
                  _: 2
                }, 1024)) : A("", !0),
                j($a, null, {
                  default: B(() => [
                    me(le(b.name), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["as", "to", "onClick", "variant", "class", "color"]),
            C("div", K4, [
              L(v.$slots, "item-right", {
                item: b,
                parentIndex: k,
                isOpen: p(k)
              }, void 0, !0)
            ])
          ]),
          b.items && b.items.length > 0 ? (i(), g("div", {
            key: 0,
            ref_for: !0,
            ref_key: "childrenRefs",
            ref: s,
            "data-index": k,
            class: W(["hp-side-menu__children", { "hp-side-menu__children--open": p(k) }]),
            style: Ie(d(k))
          }, [
            C("div", j4, [
              C("ul", W4, [
                (i(!0), g(he, null, De(b.items, (_, T) => (i(), g("li", {
                  key: T,
                  class: "hp-side-menu__child",
                  onClick: (S) => w(_, k, T)
                }, [
                  C("div", q4, [
                    C("div", Z4, [
                      j(V4),
                      j(I4, {
                        style: Ie(T == b.items.length - 1 && "opacity: 0")
                      }, null, 8, ["style"])
                    ]),
                    (i(), R(Pe(_.link ? "router-link" : "button"), {
                      to: _.link || void 0,
                      class: "hp-side-menu__child-button"
                    }, {
                      default: B(() => [
                        L(v.$slots, "child", {
                          child: _,
                          parentIndex: k,
                          childIndex: T
                        }, () => [
                          C("div", G4, [
                            _.icon ? (i(), R(Pe(_.icon), {
                              key: 0,
                              class: "hp-side-menu__child-icon"
                            })) : A("", !0),
                            C("span", X4, le(_.name), 1)
                          ])
                        ], !0),
                        u(n)["child-right"] ? (i(), g("div", Q4, [
                          L(v.$slots, "child-right", {
                            child: _,
                            parentIndex: k,
                            childIndex: T
                          }, void 0, !0)
                        ])) : A("", !0)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  ])
                ], 8, U4))), 128))
              ])
            ])
          ], 14, Y4)) : A("", !0),
          b.bottomBorder ? (i(), g("div", J4)) : A("", !0)
        ]))), 128))
      ])
    ]));
  }
}), hT = /* @__PURE__ */ se(e8, [["__scopeId", "data-v-680e706d"]]), t8 = 3, vT = /* @__PURE__ */ Y({
  __name: "SkeletonGrid",
  props: {
    rows: {},
    columns: { default: 1 },
    columnGap: { default: "2" },
    rowGap: { default: "2" },
    random: { type: Boolean, default: !1 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = [2, 1, 3, 1.5, 2.5, 1.2, 2.2, 1.8], n = e, a = m(() => n.rows * n.columns), o = m(() => n.random ? Array.from(
      { length: n.columns },
      (s, p) => t[p * t8 % t.length]
    ).map((s) => `minmax(0, ${s}fr)`).join(" ") : `repeat(${n.columns}, minmax(0, 1fr))`), l = m(() => ["hp-skeleton-grid", n.class]), r = m(() => ({
      "--hp-skeleton-grid-columns": o.value,
      "--hp-skeleton-grid-rows": `repeat(${n.rows}, auto)`,
      "--hp-skeleton-grid-col-gap": `var(--space-${n.columnGap})`,
      "--hp-skeleton-grid-row-gap": `var(--space-${n.rowGap})`
    }));
    return (c, s) => (i(), g("div", {
      class: W(l.value),
      style: Ie(r.value),
      "aria-hidden": "true"
    }, [
      (i(!0), g(he, null, De(a.value, (p) => L(c.$slots, "default", {
        key: p,
        index: p
      }, () => [
        j(Xl)
      ])), 128))
    ], 6));
  }
}), a8 = /* @__PURE__ */ new Set([
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "auto",
  "full",
  "fit",
  "min",
  "max",
  "screen",
  "0",
  "none"
]), ku = (e) => typeof e == "string" && a8.has(e), n8 = (e) => {
  if (!(e == null || ku(e)))
    return typeof e == "number" ? `${e}px` : e;
}, o8 = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "auto",
  "full",
  "fit",
  "min",
  "max",
  "screen",
  "0",
  "none"
], un = (e) => Object.fromEntries(o8.map((t) => [t, `${e}-${t}`])), l8 = ze("hp-smart-layout", {
  variants: {
    tone: {
      surface: "hp-smart-layout--surface",
      soft: "hp-smart-layout--soft",
      transparent: "hp-smart-layout--transparent"
    },
    width: un("w"),
    height: un("h"),
    minWidth: un("min-w"),
    maxWidth: un("max-w"),
    minHeight: un("min-h"),
    maxHeight: un("max-h"),
    topBorder: {
      true: "hp-smart-layout--border-top",
      false: ""
    },
    rightBorder: {
      true: "hp-smart-layout--border-right",
      false: ""
    },
    bottomBorder: {
      true: "hp-smart-layout--border-bottom",
      false: ""
    },
    leftBorder: {
      true: "hp-smart-layout--border-left",
      false: ""
    }
  },
  defaultVariants: {
    tone: "surface",
    topBorder: !1,
    rightBorder: !1,
    bottomBorder: !1,
    leftBorder: !1
  }
}), r8 = ["data-smart-layout-id", "data-smart-layout-resizable"], s8 = {
  key: 0,
  class: "hp-smart-layout__body-grid"
}, i8 = /* @__PURE__ */ Y({
  name: "SmartLayout",
  __name: "SmartLayout",
  props: {
    class: {},
    topBorder: { type: Boolean, default: !1 },
    rightBorder: { type: Boolean, default: !1 },
    bottomBorder: { type: Boolean, default: !1 },
    leftBorder: { type: Boolean, default: !1 },
    tone: { default: "surface" },
    width: {},
    minWidth: {},
    maxWidth: {},
    height: {},
    minHeight: {},
    maxHeight: {},
    layoutId: {},
    resizable: { type: [String, Boolean] },
    templateColumns: {},
    columnGap: {},
    bg: {}
  },
  setup(e) {
    const t = /* @__PURE__ */ new Set([
      "SmartLayoutHeader",
      "SmartLayoutLoader",
      "SmartLayoutToolbar",
      "SmartLayoutAlerts",
      "SmartLayoutBody",
      "SmartLayoutBottomBar",
      "SmartLayoutFooter"
    ]), n = Y({
      name: "SmartLayoutSlotNodes",
      props: {
        nodes: {
          type: Array,
          required: !0
        }
      },
      setup(_) {
        return () => _.nodes;
      }
    }), a = e, o = mt(), l = Nl(), r = m(() => a.layoutId ?? `smart-layout-${l?.uid ?? "0"}`), c = (_) => n8(_), s = (_) => ku(_) ? _ : void 0, p = m(() => [
      l8({
        tone: a.tone,
        width: s(a.width),
        height: s(a.height),
        minWidth: s(a.minWidth),
        maxWidth: s(a.maxWidth),
        minHeight: s(a.minHeight),
        maxHeight: s(a.maxHeight),
        topBorder: a.topBorder,
        rightBorder: a.rightBorder,
        bottomBorder: a.bottomBorder,
        leftBorder: a.leftBorder
      }),
      a.class
    ]), d = m(() => {
      if (a.resizable === !0)
        return "true";
      if (a.resizable === "start" || a.resizable === "end")
        return a.resizable;
    }), f = (_) => typeof _ == "object" && _ !== null || typeof _ == "function", h = (_) => {
      if (f(_.type))
        return _.type.name ?? _.type.__name;
    }, $ = (_) => _.type === Ci && typeof _.children == "string" && _.children.trim() === "", y = (_) => _.type === _i || $(_), w = (_) => _.filter(Yu).flatMap((T) => v(T)), v = (_) => _.type === he && Array.isArray(_.children) ? w(_.children) : y(_) ? [] : [_], x = (_) => {
      const T = h(_);
      return T !== void 0 && t.has(T);
    }, b = () => {
      const T = (o.default?.() ?? []).flatMap((te) => v(te)), S = [], M = /* @__PURE__ */ new Map();
      let E = [], F = 0;
      const H = () => {
        E.length !== 0 && (S.push({
          key: `body-grid-${F}`,
          kind: "body-grid",
          nodes: E
        }), E = [], F += 1);
      };
      return T.forEach((te) => {
        const ie = x(te) ? h(te) : void 0;
        if (ie !== void 0) {
          H();
          const ee = M.get(ie) ?? 0;
          M.set(ie, ee + 1), S.push({
            key: `${ie}-${ee}`,
            kind: "node",
            nodes: [te]
          });
          return;
        }
        E.push(te);
      }), H(), S;
    }, k = m(() => {
      const _ = {}, T = c(a.width), S = c(a.minWidth), M = c(a.maxWidth), E = c(a.height), F = c(a.minHeight), H = c(a.maxHeight);
      return T && (_.width = T), S && (_.minWidth = S), M && (_.maxWidth = M), E && (_.height = E), F && (_.minHeight = F), H && (_.maxHeight = H), a.templateColumns && (_["--smart-layout-columns"] = a.templateColumns), a.columnGap && (_["--smart-layout-column-gap"] = `var(--space-${a.columnGap})`), a.bg && (_["--smart-layout-bg"] = a.bg), _;
    });
    return (_, T) => (i(), g("div", {
      class: W(p.value),
      style: Ie(k.value),
      "data-smart-layout-id": r.value,
      "data-smart-layout-resizable": d.value
    }, [
      (i(!0), g(he, null, De(b(), (S) => (i(), g(he, {
        key: S.key
      }, [
        S.kind === "body-grid" ? (i(), g("div", s8, [
          j(u(n), {
            nodes: S.nodes
          }, null, 8, ["nodes"])
        ])) : (i(), R(u(n), {
          key: 1,
          nodes: S.nodes
        }, null, 8, ["nodes"]))
      ], 64))), 128))
    ], 14, r8));
  }
}), _u = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"], c8 = ["1", "2", "3", "4", "5"], u8 = (e) => Object.fromEntries(_u.map((t) => [t, `${e}-${t}`])), vl = (e) => Object.fromEntries(_u.map((t) => [t, `hp-smart-layout-section--padding-${e}-${t}`])), d8 = (e) => Object.fromEntries(c8.map((t) => [t, `${e}-${t}`])), p8 = ze("hp-smart-layout-section", {
  variants: {
    tone: {
      surface: "hp-smart-layout-section--surface",
      soft: "hp-smart-layout-section--soft",
      transparent: "hp-smart-layout-section--transparent"
    },
    density: {
      dense: "hp-smart-layout-section--density-dense",
      normal: "hp-smart-layout-section--density-normal",
      loose: "hp-smart-layout-section--density-loose"
    },
    align: {
      left: "hp-smart-layout-section--align-left",
      right: "hp-smart-layout-section--align-right"
    },
    gap: u8("gap"),
    paddingX: vl("x"),
    paddingY: vl("y"),
    paddingTop: vl("top"),
    minHeight: d8("hp-smart-layout-section--min-height"),
    wrap: {
      true: "hp-smart-layout-section--wrap",
      false: ""
    },
    scrollable: {
      true: "hp-smart-layout-section--scrollable",
      false: ""
    },
    sticky: {
      true: "hp-smart-layout-section--sticky",
      false: ""
    },
    topBorder: {
      true: "hp-smart-layout-section--border-top",
      false: ""
    },
    rightBorder: {
      true: "hp-smart-layout-section--border-right",
      false: ""
    },
    bottomBorder: {
      true: "hp-smart-layout-section--border-bottom",
      false: ""
    },
    leftBorder: {
      true: "hp-smart-layout-section--border-left",
      false: ""
    }
  },
  defaultVariants: {
    tone: "transparent",
    scrollable: !1,
    sticky: !1,
    wrap: !1,
    topBorder: !1,
    rightBorder: !1,
    bottomBorder: !1,
    leftBorder: !1
  }
}), f8 = ["data-smart-layout-section"], rn = /* @__PURE__ */ Y({
  __name: "SmartLayoutSection",
  props: {
    class: { default: void 0 },
    topBorder: { type: Boolean, default: !1 },
    rightBorder: { type: Boolean, default: !1 },
    bottomBorder: { type: Boolean, default: !1 },
    leftBorder: { type: Boolean, default: !1 },
    tone: { default: "transparent" },
    density: { default: void 0 },
    gap: { default: void 0 },
    paddingX: { default: void 0 },
    paddingY: { default: void 0 },
    paddingTop: { default: void 0 },
    minHeight: { default: void 0 },
    align: { default: void 0 },
    wrap: { type: Boolean, default: !1 },
    scrollable: { type: Boolean, default: !1 },
    sticky: { type: Boolean, default: !1 },
    section: {}
  },
  setup(e) {
    const t = e, n = m(() => [
      p8({
        tone: t.tone,
        density: t.density,
        align: t.align,
        gap: t.gap,
        paddingX: t.paddingX,
        paddingY: t.paddingY,
        paddingTop: t.paddingTop,
        minHeight: t.minHeight,
        wrap: t.wrap,
        scrollable: t.scrollable,
        sticky: t.sticky,
        topBorder: t.topBorder,
        rightBorder: t.rightBorder,
        bottomBorder: t.bottomBorder,
        leftBorder: t.leftBorder
      }),
      t.class
    ]);
    return (a, o) => (i(), g("div", {
      class: W(n.value),
      "data-smart-layout-section": e.section
    }, [
      L(a.$slots, "default")
    ], 10, f8));
  }
}), mT = /* @__PURE__ */ Y({
  name: "SmartLayoutAlerts",
  __name: "SmartLayoutAlerts",
  props: {
    class: {},
    topBorder: { type: Boolean },
    rightBorder: { type: Boolean },
    bottomBorder: { type: Boolean, default: !0 },
    leftBorder: { type: Boolean },
    tone: {},
    density: {},
    gap: { default: "2" },
    paddingX: { default: "4" },
    paddingY: { default: "2" },
    paddingTop: {},
    minHeight: {},
    align: {},
    wrap: { type: Boolean },
    scrollable: { type: Boolean },
    sticky: { type: Boolean }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), R(rn, Ke({ section: "alerts" }, t), {
      default: B(() => [
        L(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), h8 = [
  "left",
  "center",
  "right",
  "actions",
  "title",
  "meta"
], v8 = (e) => typeof e == "string" && h8.includes(e), m8 = (e) => {
  if (!e)
    return null;
  const t = e, n = t.zone ?? t["data-smart-layout-zone"];
  return v8(n) ? n : null;
}, g8 = (e) => m8(e.props), y8 = (e) => typeof e.type == "symbol" || typeof e.children == "string" && e.children.trim() === "", Cu = (e) => {
  const t = [];
  for (const n of e) {
    if (n.type === he && Array.isArray(n.children)) {
      t.push(...Cu(n.children));
      continue;
    }
    y8(n) || t.push(n);
  }
  return t;
}, w8 = () => {
  const e = mt();
  return m(() => {
    const t = [], n = [], a = [], o = [], l = [], r = [], c = [], s = e.default;
    if (!s)
      return { left: t, center: n, right: a, actions: o, title: l, meta: r, free: c };
    const p = Cu(s());
    for (const d of p) {
      const f = g8(d);
      f === "left" ? t.push(d) : f === "center" ? n.push(d) : f === "right" ? a.push(d) : f === "actions" ? o.push(d) : f === "title" ? l.push(d) : f === "meta" ? r.push(d) : c.push(d);
    }
    return { left: t, center: n, right: a, actions: o, title: l, meta: r, free: c };
  });
}, ai = "hp-smart-layout-bar-zones__zone", ml = (e, t) => t.length === 0 ? null : na(
  "div",
  {
    class: [ai, `${ai}--${e}`],
    "data-smart-layout-bar-zone": e
  },
  [...t]
), Uo = Y({
  name: "SmartLayoutBarZones",
  setup() {
    const e = w8();
    return () => {
      const { left: t, center: n, right: a, actions: o, title: l, meta: r, free: c } = e.value, s = [...l, ...r, ...t], p = [...n], d = [...a, ...o];
      if (!(s.length > 0 || p.length > 0 || d.length > 0))
        return na(he, null, [...c]);
      const h = [...p, ...c], $ = [
        ml("left", s),
        ml("center", h),
        ml("right", d)
      ];
      return na(
        "div",
        {
          class: "hp-smart-layout-bar-zones",
          "data-smart-layout-bar-zones": ""
        },
        $.filter((y) => y !== null)
      );
    };
  }
}), ni = /* @__PURE__ */ Y({
  name: "SmartLayoutBody",
  __name: "SmartLayoutBody",
  props: {
    class: {},
    topBorder: { type: Boolean },
    rightBorder: { type: Boolean },
    bottomBorder: { type: Boolean },
    leftBorder: { type: Boolean },
    tone: {},
    density: {},
    gap: {},
    paddingX: {},
    paddingY: {},
    paddingTop: {},
    minHeight: {},
    align: {},
    wrap: { type: Boolean },
    scrollable: { type: Boolean },
    sticky: { type: Boolean }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), R(rn, Ke({ section: "body" }, t), {
      default: B(() => [
        L(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), b8 = /* @__PURE__ */ Y({
  name: "SmartLayoutBottomBar",
  __name: "SmartLayoutBottomBar",
  props: {
    class: {},
    topBorder: { type: Boolean },
    rightBorder: { type: Boolean },
    bottomBorder: { type: Boolean },
    leftBorder: { type: Boolean },
    tone: {},
    density: {},
    gap: {},
    paddingX: {},
    paddingY: {},
    paddingTop: {},
    minHeight: {},
    align: {},
    wrap: { type: Boolean },
    scrollable: { type: Boolean },
    sticky: { type: Boolean }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), R(rn, Ke({ section: "bottom-bar" }, t), {
      default: B(() => [
        j(u(Uo), null, {
          default: B(() => [
            L(n.$slots, "default")
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16));
  }
}), k8 = /* @__PURE__ */ Y({
  name: "SmartLayoutFooter",
  __name: "SmartLayoutFooter",
  props: {
    class: {},
    topBorder: { type: Boolean },
    rightBorder: { type: Boolean },
    bottomBorder: { type: Boolean },
    leftBorder: { type: Boolean },
    tone: {},
    density: {},
    gap: {},
    paddingX: {},
    paddingY: {},
    paddingTop: {},
    minHeight: {},
    align: {},
    wrap: { type: Boolean },
    scrollable: { type: Boolean },
    sticky: { type: Boolean }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), R(rn, Ke({ section: "footer" }, t), {
      default: B(() => [
        j(u(Uo), null, {
          default: B(() => [
            L(n.$slots, "default")
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16));
  }
}), _8 = /* @__PURE__ */ Y({
  name: "SmartLayoutHeaderIcon",
  __name: "SmartLayoutHeaderIcon",
  props: {
    icon: { default: void 0 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = m(() => ["hp-smart-layout-header__icon", t.class]);
    return (a, o) => (i(), g("div", {
      class: W(n.value)
    }, [
      e.icon ? (i(), R(Pe(e.icon), { key: 0 })) : L(a.$slots, "default", { key: 1 })
    ], 2));
  }
}), C8 = /* @__PURE__ */ Y({
  name: "SmartLayoutHeaderTitle",
  __name: "SmartLayoutHeaderTitle",
  props: {
    size: { default: "5" },
    truncate: { type: Boolean, default: !1 },
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = m(() => ["hp-smart-layout-header__title", t.class].filter(Boolean).join(" "));
    return (a, o) => (i(), R(u($n), {
      size: t.size,
      weight: "semibold",
      truncate: t.truncate,
      class: W(n.value)
    }, {
      default: B(() => [
        L(a.$slots, "default")
      ]),
      _: 3
    }, 8, ["size", "truncate", "class"]));
  }
}), x8 = ze("hp-smart-layout-section-part", {
  variants: {
    zone: {
      left: "hp-smart-layout-section-part--left",
      center: "hp-smart-layout-section-part--center",
      right: "hp-smart-layout-section-part--right",
      actions: "hp-smart-layout-section-part--actions",
      title: "hp-smart-layout-section-part--title",
      meta: "hp-smart-layout-section-part--meta"
    },
    wrap: {
      true: "hp-smart-layout-section-part--wrap",
      false: ""
    },
    grow: {
      true: "hp-smart-layout-section-part--grow",
      false: ""
    }
  },
  defaultVariants: {
    wrap: !1,
    grow: !1
  }
}), $8 = ["data-smart-layout-zone"], xu = /* @__PURE__ */ Y({
  name: "SmartLayoutSectionPart",
  __name: "SmartLayoutSectionPart",
  props: {
    class: { default: void 0 },
    wrap: { type: Boolean, default: !1 },
    grow: { type: Boolean, default: !1 },
    zone: {}
  },
  setup(e) {
    const t = e, n = mt(), a = m(() => {
      const l = n.default?.({});
      return !l || l.length === 0 ? !1 : l.some((r) => !(r.type === _i || r.type === Ci && typeof r.children == "string" && r.children.trim() === ""));
    }), o = m(() => [
      x8({
        zone: t.zone,
        wrap: t.wrap,
        grow: t.grow
      }),
      t.class
    ]);
    return (l, r) => a.value ? (i(), g("div", {
      key: 0,
      class: W(o.value),
      "data-smart-layout-zone": e.zone
    }, [
      L(l.$slots, "default")
    ], 10, $8)) : A("", !0);
  }
}), S8 = /* @__PURE__ */ Y({
  name: "SmartLayoutHeader",
  __name: "SmartLayoutHeader",
  props: {
    class: {},
    topBorder: { type: Boolean },
    rightBorder: { type: Boolean },
    bottomBorder: { type: Boolean },
    leftBorder: { type: Boolean },
    tone: {},
    density: {},
    gap: {},
    paddingX: {},
    paddingY: {},
    paddingTop: {},
    minHeight: {},
    align: {},
    wrap: { type: Boolean },
    scrollable: { type: Boolean },
    sticky: { type: Boolean },
    icon: {},
    title: {},
    showClose: { type: Boolean }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = Le(), a = e, o = t, l = m(() => !!(a.icon || a.title)), r = m(() => {
      const { icon: c, showClose: s, title: p, ...d } = a;
      return d;
    });
    return (c, s) => (i(), R(rn, Ke({ section: "header" }, r.value), {
      default: B(() => [
        j(u(Uo), null, {
          default: B(() => [
            l.value ? (i(), R(xu, {
              key: 0,
              zone: "title",
              class: "hp-smart-layout-header__identity"
            }, {
              default: B(() => [
                a.icon ? (i(), R(_8, {
                  key: 0,
                  icon: a.icon
                }, null, 8, ["icon"])) : A("", !0),
                a.title ? (i(), R(C8, {
                  key: 1,
                  truncate: ""
                }, {
                  default: B(() => [
                    me(le(a.title), 1)
                  ]),
                  _: 1
                })) : A("", !0)
              ]),
              _: 1
            })) : A("", !0),
            L(c.$slots, "default")
          ]),
          _: 3
        }),
        a.showClose ? (i(), R(Ae, {
          key: 0,
          class: "hp-smart-layout-header__close",
          variant: "blank",
          size: "1",
          square: "",
          radius: "full",
          icon: zt,
          "aria-label": u(n)("ui.card.hideSection", "Hide section"),
          title: u(n)("ui.card.hideSection", "Hide section"),
          onClick: s[0] || (s[0] = (p) => o("close"))
        }, null, 8, ["aria-label", "title"])) : A("", !0)
      ]),
      _: 3
    }, 16));
  }
}), M8 = /* @__PURE__ */ Y({
  name: "SmartLayoutLoader",
  __name: "SmartLayoutLoader",
  props: {
    class: {},
    topBorder: { type: Boolean },
    rightBorder: { type: Boolean },
    bottomBorder: { type: Boolean },
    leftBorder: { type: Boolean },
    tone: {},
    density: {},
    gap: {},
    paddingX: {},
    paddingY: {},
    paddingTop: {},
    minHeight: {},
    align: {},
    wrap: { type: Boolean },
    scrollable: { type: Boolean },
    sticky: { type: Boolean }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), R(rn, Ke({ section: "loader" }, t), {
      default: B(() => [
        L(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), D8 = ze("hp-spacer", {
  variants: {
    mode: {
      auto: "hp-spacer--auto",
      sized: "hp-spacer--sized"
    },
    axis: {
      horizontal: "hp-spacer--horizontal",
      vertical: "hp-spacer--vertical"
    }
  },
  defaultVariants: {
    mode: "auto",
    axis: "horizontal"
  }
}), T8 = /* @__PURE__ */ Y({
  name: "Spacer",
  __name: "Spacer",
  props: {
    class: { default: void 0 },
    size: { default: "auto" },
    axis: { default: "horizontal" }
  },
  setup(e) {
    const t = e, n = m(() => t.size === "auto" ? "auto" : "sized"), a = m(() => [
      D8({
        mode: n.value,
        axis: t.axis
      }),
      t.class
    ]), o = m(() => t.size === "auto" ? {} : { [t.axis === "vertical" ? "height" : "width"]: `var(--space-${t.size})` });
    return (l, r) => (i(), g("div", {
      class: W(a.value),
      style: Ie(o.value),
      "aria-hidden": "true"
    }, null, 6));
  }
}), B8 = {
  spacer: T8,
  divider: vr,
  "section-part": xu
}, z8 = (e, t) => t?.[e] ?? B8[e], gl = /* @__PURE__ */ Y({
  name: "SmartLayoutNodeRenderer",
  __name: "SmartLayoutNodeRenderer",
  props: {
    nodes: {},
    registry: { default: void 0 }
  },
  setup(e) {
    const t = e, n = (a) => z8(a, t.registry);
    return (a, o) => {
      const l = Yl("SmartLayoutNodeRenderer", !0);
      return i(!0), g(he, null, De(e.nodes, (r, c) => (i(), g(he, { key: c }, [
        n(r.kind) ? (i(), R(Pe(n(r.kind)), Ke({
          key: 0,
          ref_for: !0
        }, r.props ?? {}), {
          default: B(() => [
            r.children && r.children.length ? (i(), R(l, {
              key: 0,
              nodes: r.children,
              registry: e.registry
            }, null, 8, ["nodes", "registry"])) : A("", !0)
          ]),
          _: 2
        }, 1040)) : A("", !0)
      ], 64))), 128);
    };
  }
}), A8 = (e) => typeof e == "object", L8 = (e) => A8(e) ? e : { target: e }, E8 = (e, t) => e === t - 1 ? "start" : "end", oi = (e, t) => {
  const n = t.findIndex((r) => r.id === e.target);
  if (n < 0)
    return null;
  const a = e.edge ?? E8(n, t.length), o = a === "start" ? t[n - 1] : t[n], l = a === "start" ? t[n] : t[n + 1];
  return !o || !l ? null : {
    before: o.id,
    after: l.id,
    target: e.target,
    edge: a,
    key: `${o.id}:${l.id}:${e.target}`
  };
}, I8 = (e) => e.flatMap((t) => t.resizable ? [
  {
    target: t.id,
    edge: t.resizable === !0 ? void 0 : t.resizable
  }
] : []), R8 = (e) => e.targets && e.targets.length > 0 ? e.targets.map((t) => oi(L8(t), e.cells)).filter((t) => t !== null) : I8(e.cells).map((t) => oi(t, e.cells)).filter((t) => t !== null), Fr = (e) => {
  if (!e || e === "none")
    return null;
  const t = Number.parseFloat(e);
  return Number.isFinite(t) ? t : null;
}, Hl = (e) => Fr(getComputedStyle(e).minWidth) ?? 0, li = (e) => Fr(getComputedStyle(e).maxWidth) ?? Number.POSITIVE_INFINITY, P8 = (e, t, n) => Math.min(n, Math.max(t, e)), O8 = (e, t) => (Fr(getComputedStyle(e).columnGap) ?? 0) * Math.max(0, t - 1), ri = (e) => {
  const t = e.container.getBoundingClientRect().width, n = O8(e.container, e.cells.length), a = e.cells.reduce((o, l) => l.id === e.targetId ? o : o + Hl(l.element), 0);
  return Math.max(0, t - n - a);
}, V8 = ["aria-label", "aria-valuenow", "aria-valuemin", "aria-valuemax", "onMousedown", "onKeydown"], H8 = 8, N8 = 32, F8 = /* @__PURE__ */ Y({
  __name: "SmartLayoutResizer",
  props: {
    class: {},
    targets: {},
    keyboardStep: { default: H8 },
    keyboardStepLarge: { default: N8 }
  },
  emits: ["resize", "resize-end"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = N(null), l = N(null), r = N([]);
    let c = null, s = null, p = null;
    const d = ze("hp-smart-layout__resizer", {
      variants: {
        active: {
          true: "hp-smart-layout__resizer--active",
          false: ""
        }
      },
      defaultVariants: {
        active: !1
      }
    }), f = () => o.value?.parentElement ?? null, h = (S) => {
      if (S !== null) {
        if (S === "true")
          return !0;
        if (S === "start" || S === "end")
          return S;
      }
    }, $ = () => {
      const S = f();
      if (!S)
        return [];
      const M = S.querySelectorAll(":scope > [data-smart-layout-id]");
      return Array.from(M).map((E) => ({
        id: E.dataset.smartLayoutId ?? "",
        element: E,
        resizable: h(E.getAttribute("data-smart-layout-resizable"))
      }));
    }, y = () => {
      const S = f();
      if (!S) {
        r.value = [];
        return;
      }
      const M = $(), E = R8({ cells: M, targets: n.targets });
      r.value = E.flatMap((F) => {
        const H = M.find((J) => J.id === F.before), te = M.find((J) => J.id === F.after), ie = M.find((J) => J.id === F.target);
        if (!H || !te || !ie)
          return [];
        const ee = H.element.offsetLeft + H.element.offsetWidth, O = te.element.offsetLeft, z = (ee + O) / 2, D = Math.round(ie.element.offsetWidth), P = Math.round(Hl(ie.element)), Z = Math.round(
          Math.max(
            P,
            Math.min(
              li(ie.element),
              ri({ container: S, cells: M, targetId: ie.id })
            )
          )
        );
        return [
          {
            key: F.key,
            link: F,
            classes: d({ active: l.value === F.key }),
            style: { left: `${z}px` },
            ariaLabel: `Resize ${F.target}`,
            ariaValueNow: D,
            ariaValueMin: P,
            ariaValueMax: Z
          }
        ];
      });
    }, w = () => {
      s?.disconnect(), p?.disconnect(), s = null, p = null;
      const S = f();
      S && (typeof ResizeObserver > "u" || typeof MutationObserver > "u" || (s = new ResizeObserver(() => y()), s.observe(S), $().forEach((M) => s?.observe(M.element)), p = new MutationObserver(() => {
        y(), s?.disconnect();
        const M = f();
        M && s?.observe(M), $().forEach((E) => s?.observe(E.element));
      }), p.observe(S, {
        childList: !0,
        attributes: !0,
        attributeFilter: ["data-smart-layout-resizable", "data-smart-layout-id", "style"]
      })));
    }, v = (S) => {
      const M = f();
      if (!M)
        return null;
      const E = $(), F = E.find((ee) => ee.id === S.before), H = E.find((ee) => ee.id === S.target);
      if (!F || !H)
        return null;
      const te = Hl(H.element), ie = Math.max(
        te,
        Math.min(
          li(H.element),
          ri({ container: M, cells: E, targetId: H.id })
        )
      );
      return {
        targetElement: H.element,
        min: te,
        max: ie,
        isTargetBefore: H.id === F.id
      };
    }, x = (S, M) => {
      const E = v(S);
      if (!E)
        return null;
      const F = P8(M, E.min, E.max);
      return E.targetElement.style.width = `${F}px`, y(), F;
    }, b = (S, M) => {
      const E = v(M);
      if (!E)
        return;
      S.preventDefault(), S.stopPropagation(), c?.();
      const F = S.clientX, H = E.targetElement.getBoundingClientRect().width;
      let te = H;
      l.value = M.key, c = mr({
        label: "SmartLayoutResizer",
        onMove: (ie) => {
          const ee = ie.clientX - F, O = E.isTargetBefore ? H + ee : H - ee, z = x(M, O);
          z !== null && (te = z, a("resize", { id: M.target, width: z }));
        },
        onCleanup: () => {
          l.value = null, c = null, a("resize-end", { id: M.target, width: te });
        }
      });
    }, k = (S) => S.key === "ArrowRight" ? S.current + S.step * S.direction : S.key === "ArrowLeft" ? S.current - S.step * S.direction : S.key === "Home" ? S.direction === 1 ? S.min : S.max : S.key === "End" ? S.direction === 1 ? S.max : S.min : S.current, _ = (S) => S === "ArrowLeft" || S === "ArrowRight" || S === "Home" || S === "End", T = (S, M) => {
      if (!_(S.key))
        return;
      const E = v(M);
      if (!E)
        return;
      S.preventDefault();
      const F = k({
        key: S.key,
        step: S.shiftKey ? n.keyboardStepLarge : n.keyboardStep,
        direction: E.isTargetBefore ? 1 : -1,
        min: E.min,
        max: E.max,
        current: E.targetElement.getBoundingClientRect().width
      }), H = x(M, F);
      H !== null && (a("resize", { id: M.target, width: H }), a("resize-end", { id: M.target, width: H }));
    };
    return Se(
      () => n.targets,
      async () => {
        await Ye(), y();
      },
      { deep: !0 }
    ), tt(async () => {
      await Ye(), y(), w();
    }), ct(() => {
      c?.(), s?.disconnect(), p?.disconnect();
    }), (S, M) => (i(), g("div", {
      ref_key: "layerRef",
      ref: o,
      class: W(["hp-smart-layout__resizer-layer", n.class])
    }, [
      (i(!0), g(he, null, De(r.value, (E) => (i(), g("div", {
        key: E.key,
        class: W(E.classes),
        style: Ie(E.style),
        role: "separator",
        "aria-orientation": "vertical",
        "aria-label": E.ariaLabel,
        "aria-valuenow": E.ariaValueNow,
        "aria-valuemin": E.ariaValueMin,
        "aria-valuemax": E.ariaValueMax,
        tabindex: "0",
        onMousedown: (F) => b(F, E.link),
        onKeydown: (F) => T(F, E.link)
      }, null, 46, V8))), 128))
    ], 2));
  }
}), K8 = /* @__PURE__ */ Y({
  name: "SmartLayoutToolbar",
  __name: "SmartLayoutToolbar",
  props: {
    class: {},
    topBorder: { type: Boolean },
    rightBorder: { type: Boolean },
    bottomBorder: { type: Boolean },
    leftBorder: { type: Boolean },
    tone: {},
    density: {},
    gap: {},
    paddingX: {},
    paddingY: {},
    paddingTop: {},
    minHeight: {},
    align: {},
    wrap: { type: Boolean },
    scrollable: { type: Boolean },
    sticky: { type: Boolean }
  },
  setup(e) {
    const t = e;
    return (n, a) => (i(), R(rn, Ke({ section: "toolbar" }, t), {
      default: B(() => [
        j(u(Uo), null, {
          default: B(() => [
            L(n.$slots, "default")
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16));
  }
}), Y8 = {
  key: 1,
  class: "hp-smart-layout__schema-block hp-smart-layout__schema-block--body"
}, j8 = "minmax(0, 1fr)", W8 = "auto", gT = /* @__PURE__ */ Y({
  name: "SmartLayoutSchemaRenderer",
  __name: "SmartLayoutSchemaRenderer",
  props: {
    class: {},
    schema: {},
    nodeRegistry: {}
  },
  setup(e) {
    const t = Le(), n = [
      {
        key: "header",
        block: "header",
        get label() {
          return t("ui.smartLayout.header", "Header");
        },
        component: S8
      },
      {
        key: "loader",
        block: "loader",
        get label() {
          return t("ui.smartLayout.loader", "Loader");
        },
        component: M8
      },
      {
        key: "toolbar",
        block: "toolbar",
        get label() {
          return t("ui.smartLayout.toolbar", "Toolbar");
        },
        component: K8
      }
    ], a = {
      key: "body",
      block: "body",
      component: ni
    }, o = [
      {
        key: "bottomBar",
        block: "bottom-bar",
        get label() {
          return t("ui.smartLayout.bottomBar", "BottomBar");
        },
        component: b8
      },
      {
        key: "footer",
        block: "footer",
        get label() {
          return t("ui.smartLayout.footer", "Footer");
        },
        component: k8
      }
    ], l = e, r = m(() => l.schema), c = m(() => l.nodeRegistry), s = m(() => [r.value.class, l.class].filter(Boolean).join(" ")), p = m(() => !!(r.value.children && r.value.children.length > 0)), d = m(() => {
      if (r.value.templateColumns)
        return r.value.templateColumns;
      if (r.value.columnCount && r.value.columnCount > 0)
        return `repeat(${r.value.columnCount}, auto)`;
      const k = r.value.children;
      if (!(!k || k.length === 0))
        return k.map((_) => _.width !== void 0 ? W8 : j8).join(" ");
    }), f = m(() => {
      const k = !!(r.value.resizeTargets && r.value.resizeTargets.length > 0), _ = !!r.value.children?.some((T) => !!T.resizable);
      return k || _;
    }), h = (k, _) => k === !1 || k === void 0 ? null : k === !0 ? { ..._ } : typeof k == "string" ? { ..._, label: k } : { ..._, ...k }, $ = (k) => {
      const { label: _, children: T, ...S } = k;
      return S;
    }, y = (k) => {
      const _ = h(r.value[k.key], r.value.bandDefaults);
      return _ ? {
        key: k.key,
        block: k.block,
        label: _.label ?? r.value.label ?? k.label,
        component: k.component,
        children: _.children,
        props: $(_)
      } : null;
    }, w = m(
      () => n.map(y).filter((k) => k !== null)
    ), v = m(
      () => o.map(y).filter((k) => k !== null)
    ), x = m(() => {
      const k = r.value.body;
      if (k === !1)
        return null;
      const _ = h(k ?? !0, r.value.bandDefaults);
      return _ ? {
        key: a.key,
        block: a.block,
        label: _.label ?? r.value.label ?? r.value.id,
        component: a.component,
        children: _.children,
        props: $(_)
      } : null;
    }), b = (k) => [
      "hp-smart-layout__schema-block",
      `hp-smart-layout__schema-block--${k}`
    ];
    return (k, _) => {
      const T = Yl("SmartLayoutSchemaRenderer", !0);
      return i(), R(i8, {
        "layout-id": r.value.id,
        tone: r.value.tone ?? "surface",
        width: r.value.width,
        "min-width": r.value.minWidth,
        "max-width": r.value.maxWidth,
        height: r.value.height,
        "min-height": r.value.minHeight,
        "max-height": r.value.maxHeight,
        resizable: r.value.resizable,
        "template-columns": d.value,
        "column-gap": r.value.columnGap,
        "top-border": r.value.topBorder,
        "right-border": r.value.rightBorder,
        "bottom-border": r.value.bottomBorder,
        "left-border": r.value.leftBorder,
        class: W(s.value)
      }, {
        default: B(() => [
          (i(!0), g(he, null, De(w.value, (S) => (i(), R(Pe(S.component), Ke({
            key: S.key
          }, { ref_for: !0 }, S.props), {
            default: B(() => [
              S.children && S.children.length ? (i(), R(gl, {
                key: 0,
                nodes: S.children,
                registry: c.value
              }, null, 8, ["nodes", "registry"])) : (i(), g("div", {
                key: 1,
                class: W(b(S.block))
              }, le(S.label), 3))
            ]),
            _: 2
          }, 1040))), 128)),
          p.value ? (i(), g(he, { key: 0 }, [
            (i(!0), g(he, null, De(r.value.children, (S) => (i(), R(T, {
              key: S.id,
              schema: S,
              "node-registry": c.value
            }, null, 8, ["schema", "node-registry"]))), 128)),
            f.value ? (i(), R(F8, {
              key: 0,
              targets: r.value.resizeTargets
            }, null, 8, ["targets"])) : A("", !0)
          ], 64)) : x.value ? (i(), R(ni, Mt(Ke({ key: 1 }, x.value.props)), {
            default: B(() => [
              x.value.children && x.value.children.length ? (i(), R(gl, {
                key: 0,
                nodes: x.value.children,
                registry: c.value
              }, null, 8, ["nodes", "registry"])) : (i(), g("div", Y8, le(x.value.label), 1))
            ]),
            _: 1
          }, 16)) : A("", !0),
          (i(!0), g(he, null, De(v.value, (S) => (i(), R(Pe(S.component), Ke({
            key: S.key
          }, { ref_for: !0 }, S.props), {
            default: B(() => [
              S.children && S.children.length ? (i(), R(gl, {
                key: 0,
                nodes: S.children,
                registry: c.value
              }, null, 8, ["nodes", "registry"])) : (i(), g("div", {
                key: 1,
                class: W(b(S.block))
              }, le(S.label), 3))
            ]),
            _: 2
          }, 1040))), 128))
        ]),
        _: 1
      }, 8, ["layout-id", "tone", "width", "min-width", "max-width", "height", "min-height", "max-height", "resizable", "template-columns", "column-gap", "top-border", "right-border", "bottom-border", "left-border", "class"]);
    };
  }
}), U8 = ze("hp-status-changer__trigger", {
  variants: {
    size: {
      1: "hp-status-changer__trigger--size-1",
      2: "hp-status-changer__trigger--size-2",
      3: "hp-status-changer__trigger--size-3",
      4: "hp-status-changer__trigger--size-4",
      5: "hp-status-changer__trigger--size-5"
    },
    open: {
      true: "hp-status-changer__trigger--open",
      false: ""
    }
  },
  defaultVariants: {
    size: "3",
    open: !1
  }
}), q8 = ["disabled", "aria-expanded", "aria-label", "aria-activedescendant"], yT = /* @__PURE__ */ Y({
  __name: "StatusChanger",
  props: {
    icon: {},
    color: {},
    items: {},
    size: { default: "3" },
    disabled: { type: Boolean, default: !1 },
    ariaLabel: { default: void 0 }
  },
  setup(e) {
    const t = e, n = Le(), a = m(() => t.ariaLabel ?? n("ui.statusChanger.changeStatus", "Change status")), o = N(!1), { activeIndex: l, keyboardNav: r, enabledIndexes: c, optionId: s, activeDescendantId: p, moveActive: d, setActive: f } = Vr({
      items: () => t.items,
      open: o,
      idSegment: "status-item",
      // StatusChanger's original open-init never scrolled the first item into view — preserve that.
      scrollOnInit: !1
    }), h = {
      1: "1",
      2: "2",
      3: "2",
      4: "3",
      5: "3"
    }, $ = {
      1: "1",
      2: "1",
      3: "2",
      4: "2",
      5: "3"
    }, y = m(() => h[t.size]), w = m(() => $[t.size]), v = m(() => h[w.value]), x = {
      1: "2",
      2: "3",
      3: "3",
      4: "4",
      5: "5"
    }, b = m(
      () => x[t.size]
    ), k = m(
      () => U8({ size: t.size, open: o.value })
    ), _ = () => {
      t.disabled || (o.value = !o.value);
    }, T = (z) => {
      if (!z.disabled)
        return o.value = !1, z.onClick?.();
    }, S = () => {
      const z = l.value >= 0 ? t.items[l.value] : void 0;
      z && T(z);
    }, { handleEscape: M, handleTab: E, consume: F } = Gn({
      isOpen: o,
      close: () => {
        o.value = !1;
      }
    }), H = (z, D) => {
      if (F(z), r.value = !0, o.value)
        return d(D);
      _();
    }, te = (z) => {
      F(z), o.value ? S() : (r.value = !0, _());
    }, ie = (z, D) => {
      if (o.value)
        return F(z), r.value = !0, f(D);
    }, ee = {
      ArrowDown: (z) => H(z, 1),
      ArrowUp: (z) => H(z, -1),
      Home: (z) => ie(z, c.value[0] ?? -1),
      End: (z) => ie(z, c.value[c.value.length - 1] ?? -1),
      Enter: te,
      " ": te,
      Escape: M,
      Tab: E
    }, O = (z) => {
      if (!t.disabled)
        return ee[z.key]?.(z);
    };
    return (z, D) => (i(), R(Xt, {
      open: o.value,
      "onUpdate:open": D[1] || (D[1] = (P) => o.value = P),
      type: "menu",
      placement: "bottom-start"
    }, {
      default: B(() => [
        j(Jt, null, {
          default: B(() => [
            C("div", {
              class: "hp-status-changer",
              onClick: D[0] || (D[0] = Fe(() => {
              }, ["stop"]))
            }, [
              C("button", {
                type: "button",
                class: W(k.value),
                disabled: e.disabled,
                "aria-expanded": o.value,
                "aria-haspopup": "menu",
                "aria-label": a.value,
                "aria-activedescendant": u(p),
                onClick: _,
                onKeydown: O
              }, [
                j(Rt, {
                  variant: "soft",
                  size: e.size,
                  "icon-size": y.value,
                  square: "",
                  radius: "full",
                  color: e.color,
                  icon: e.icon
                }, null, 8, ["size", "icon-size", "color", "icon"]),
                C("span", {
                  class: W(["hp-status-changer__chevron-slot", { "hp-status-changer__chevron-slot--open": o.value }]),
                  "aria-hidden": "true"
                }, [
                  j(Sn, { class: "hp-status-changer__chevron" })
                ], 2)
              ], 42, q8)
            ])
          ]),
          _: 1
        }),
        j(Qt, { class: "hp-status-changer__dropdown" }, {
          default: B(() => [
            j(Li, {
              bordered: "",
              role: "menu"
            }, {
              default: B(() => [
                (i(!0), g(he, null, De(e.items, (P, Z) => (i(), R(Oa, {
                  id: u(s)(Z),
                  key: Z,
                  role: "menuitem",
                  tabindex: "-1",
                  class: W(u(r) && Z === u(l) && P.disabled !== !0 ? "is-active" : void 0),
                  disabled: P.disabled,
                  onClick: (J) => T(P)
                }, {
                  default: B(() => [
                    j(E6, null, {
                      default: B(() => [
                        P.icon ? (i(), R(Rt, {
                          key: 0,
                          variant: "soft",
                          size: w.value,
                          "icon-size": v.value,
                          square: "",
                          radius: "full",
                          color: P.color,
                          icon: P.icon
                        }, null, 8, ["size", "icon-size", "color", "icon"])) : A("", !0)
                      ]),
                      _: 2
                    }, 1024),
                    j(at, { size: b.value }, {
                      default: B(() => [
                        me(le(P.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["size"])
                  ]),
                  _: 2
                }, 1032, ["id", "class", "disabled", "onClick"]))), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), Z8 = `${zr}:not([data-editable-cell-disabled])`, yn = (e) => {
  const t = e.dataset.row, n = e.dataset.col;
  return t == null || n == null ? null : { rowKey: t, colKey: n };
}, $u = (e) => Array.from(e.querySelectorAll(Z8)), Kr = (e, t) => {
  const n = `[data-editable-cell][data-row="${CSS.escape(
    String(t.rowKey)
  )}"][data-col="${CSS.escape(t.colKey)}"]:not([data-editable-cell-disabled])`;
  return e.querySelector(n);
}, Su = (e) => {
  const t = $u(e), n = /* @__PURE__ */ new Set(), a = [];
  for (const o of t) {
    const l = o.dataset.row;
    l == null || n.has(l) || (n.add(l), a.push(l));
  }
  return a;
}, Ao = (e, t) => {
  const n = `[data-editable-cell][data-row="${CSS.escape(t)}"]:not([data-editable-cell-disabled])`;
  return Array.from(e.querySelectorAll(n));
}, G8 = (e, t, n) => t === 0 ? -1 : e < 0 ? n ? t - 1 : -1 : e >= t ? n ? 0 : -1 : e, Mu = (e, t, n) => {
  if (e.length === 0)
    return null;
  if (t != null) {
    const a = e.find((o) => o.dataset.col === t);
    if (a)
      return a;
  }
  return n === "first" ? e[0] ?? null : e[e.length - 1] ?? null;
}, Du = (e, t, n, a) => {
  if (e.length === 0)
    return -1;
  const o = e.indexOf(t);
  return o === -1 ? 0 : G8(o + n, e.length, a);
}, X8 = (e, t, n, a) => {
  const o = Su(e), l = Du(o, String(t.rowKey), n, a);
  if (l === -1)
    return null;
  const r = o[l];
  if (r == null)
    return null;
  const c = Mu(Ao(e, r), t.colKey, "first");
  return c ? yn(c) : null;
}, Q8 = (e, t, n, a) => {
  const o = String(t.rowKey), l = Ao(e, o), r = l.findIndex(($) => $.dataset.col === t.colKey);
  if (r === -1)
    return l[0] ? yn(l[0]) : null;
  const c = l[r + n];
  if (c)
    return yn(c);
  const s = Su(e), p = Du(s, o, n > 0 ? 1 : -1, a);
  if (p === -1)
    return null;
  const d = s[p];
  if (d == null)
    return null;
  const f = n > 0 ? "first" : "last", h = Mu(Ao(e, d), null, f);
  return h ? yn(h) : null;
}, J8 = (e) => {
  const { container: t, current: n, dRow: a, dCol: o, wrap: l } = e;
  return !t || !n ? null : a !== 0 ? X8(t, n, a, l) : o !== 0 ? Q8(t, n, o, l) : null;
}, e7 = (e, t, n) => {
  if (!e || !t)
    return null;
  const a = Ao(e, String(t.rowKey));
  if (a.length === 0)
    return null;
  const o = n === "home" ? a[0] : a[a.length - 1];
  return o ? yn(o) : null;
}, wT = (e) => {
  if (!e)
    return null;
  const n = $u(e)[0];
  return n ? yn(n) : null;
}, t7 = (e) => {
  const { containerRef: t, onActiveChange: n, isInsideTeleportedPopup: a = Ir } = e, o = N(null), l = () => {
    const d = t.value, f = o.value;
    if (!d || !f)
      return;
    const h = Kr(d, f);
    h && document.activeElement !== h && !h.contains(document.activeElement) && h.focus({ preventScroll: !1 });
  }, r = (d) => {
    o.value = d, n?.(d), d && Kn(Ye(() => l()));
  };
  Se(o, (d) => {
    d && Kn(Ye(() => l()));
  });
  const c = (d) => {
    const f = t.value;
    if (!f)
      return;
    const h = d.relatedTarget;
    if (!a(h)) {
      if (!h || !f.contains(h)) {
        r(null);
        return;
      }
      h.closest("[data-editable-cell]") || r(null);
    }
  }, s = (d) => {
    if (!o.value)
      return;
    const f = d.target;
    if (!f)
      return;
    const h = f instanceof Element ? f : f.parentElement;
    h && (h.closest("[data-editable-cell]") || a(f) || r(null));
  };
  let p = null;
  return tt(() => {
    p = t.value, p?.addEventListener("focusout", c), document.addEventListener("pointerdown", s, !0);
  }), ct(() => {
    p?.removeEventListener("focusout", c), document.removeEventListener("pointerdown", s, !0), p = null;
  }), { activeCell: o, setActive: r };
}, a7 = (e, t, n) => {
  const a = ou[e];
  return a || (n ? null : lu[e] ?? null);
}, n7 = (e) => (e.metaKey || e.ctrlKey) && (e.key === "c" || e.key === "C"), o7 = (e) => {
  if (!(e instanceof HTMLInputElement))
    return !1;
  const { selectionStart: t, selectionEnd: n } = e;
  return t != null && n != null && t !== n;
}, l7 = (e) => {
  const { activeCell: t, containerRef: n, isEditing: a, registry: o, moveActive: l, moveHomeEnd: r, copyFocusedRow: c } = e, s = (y) => !t.value || y.isComposing ? !0 : Rr(y), p = (y) => y === "home" || y === "end" ? (r(y), !0) : l(y.dRow, y.dCol), d = (y, w) => {
    const v = a7(y.key, y.shiftKey, w);
    return v ? (p(v), y.preventDefault(), !0) : !1;
  }, f = (y, w) => !n7(y) || w && o7(y.target) ? !1 : (y.preventDefault(), Kn(c()), !0);
  return { handleKeydown: (y) => {
    if (s(y))
      return;
    const w = a();
    d(y, w) || f(y, w);
  }, handleCopy: (y) => {
    const w = window.getSelection?.();
    if (w && w.toString().length > 0 || !t.value)
      return;
    const v = n.value;
    if (!v)
      return;
    const b = Kr(v, t.value)?.closest("tr");
    if (!b)
      return;
    const k = Gc(b, o);
    k && (y.preventDefault(), y.clipboardData?.setData("text/plain", k));
  } };
}, go = (e, t) => `${String(e)}::${t}`, r7 = () => {
  const e = /* @__PURE__ */ new Map();
  return {
    register(t, n) {
      e.set(go(t.rowKey, t.colKey), n);
    },
    unregister(t) {
      e.delete(go(t.rowKey, t.colKey));
    },
    get(t) {
      return e.get(go(t.rowKey, t.colKey)) ?? null;
    },
    getState(t) {
      return e.get(go(t.rowKey, t.colKey))?.state.value ?? null;
    }
  };
}, s7 = (e, t) => {
  let n = 0, a = e.length;
  for (; n < a; ) {
    const o = Math.floor((n + a) / 2);
    e[o].getBoundingClientRect().bottom <= t ? n = o + 1 : a = o;
  }
  return n;
}, i7 = (e, t, n, a) => {
  const o = e.querySelector("table");
  if (!o)
    return null;
  let l = null, r = 1 / 0;
  const c = (d, f) => {
    let h = !1;
    for (const $ of d.cells) {
      if (!$.matches("[data-range-row][data-range-column]") || !a($))
        continue;
      const y = $.getBoundingClientRect(), w = Math.max(t.left, y.left), v = Math.min(t.right, y.right), x = Math.max(t.top, y.top), b = Math.min(f, y.bottom);
      if (v <= w || b <= x)
        continue;
      h = !0;
      const k = Math.max(w - n.x, 0, n.x - v) + Math.max(x - n.y, 0, n.y - b);
      k < r && (r = k, l = $);
    }
    return h;
  }, s = (d, f, h, $) => {
    for (let y = f; y >= 0 && y < d.length; y += h) {
      const w = d[y], v = w.getBoundingClientRect();
      if (h < 0 && v.bottom <= t.top || h > 0 && v.top >= $ || c(w, $))
        break;
    }
  }, p = o.tFoot?.rows[0]?.getBoundingClientRect().top ?? t.bottom;
  for (const d of [...o.tFoot ? [o.tFoot] : [], ...o.tBodies]) {
    const f = s7(d.rows, n.y), h = d === o.tFoot ? t.bottom : Math.min(t.bottom, p);
    s(d.rows, f, 1, h), s(d.rows, f - 1, -1, h);
  }
  return l;
}, c7 = "[data-range-row][data-range-column]", u7 = 'input, textarea, select, button, a, [contenteditable]:not([contenteditable="false"]), [role="button"], [role="link"], [role="combobox"], [role="checkbox"], [role="radio"], [role="switch"], [role="slider"], [role="spinbutton"], [role="textbox"], [data-range-ignore]', si = 32, ii = 16, d7 = 2, ci = (e, t, n) => e > n - si ? ii : e < t + si ? -ii : 0, p7 = (e) => {
  const t = Le(), n = m(() => Ne(e.selection)), a = m(() => n.value?.enabled.value === !0), o = () => Ne(e.blocked), l = N(""), r = N(""), c = () => {
    r.value = "";
  }, { writeText: s } = Ar();
  let p = null, d = null, f = 0, h = 0, $ = 0, y = !1, w = 0, v = 0;
  const x = (X) => X instanceof Element ? X : null, b = (X) => X?.closest("[data-table-grid]") === e.root.value, k = (X) => b(X) ? X?.closest(c7) ?? null : null, _ = (X) => ({
    rowKey: X.dataset.rangeRow,
    columnKey: X.dataset.rangeColumn
  }), T = () => e.root.value?.querySelector('[data-editable-cell][data-state="editing"]'), S = () => {
    const X = T();
    return X ? e.registry.get({ rowKey: X.dataset.row, colKey: X.dataset.col }) : null;
  }, M = () => e.beforeMove?.() === !1 ? !1 : S()?.commit?.() ?? !0, E = (X) => {
    const ne = x(X.target);
    return !b(ne) || !!ne?.closest(u7) || !!(ne?.closest('[role="dialog"]') && !ne.closest('[role="dialog"]')?.contains(e.root.value));
  }, F = () => {
    const X = n.value?.state.value.focus;
    if (!X)
      return;
    const ne = e.root.value, ve = `[data-range-row="${CSS.escape(X.rowKey)}"][data-range-column="${CSS.escape(X.columnKey)}"]`;
    ne?.querySelector(ve)?.focus({ preventScroll: p !== null });
  }, H = (X) => ({
    extend: X.shiftKey,
    additive: X.ctrlKey || X.metaKey,
    toggle: X.ctrlKey || X.metaKey
  }), te = () => {
    p !== null && d?.hasPointerCapture?.(p) && d.releasePointerCapture(p), p = null, d = null, cancelAnimationFrame(f);
  }, ie = () => {
    const X = e.root.value?.querySelector(".hp-data-table__wrapper"), ne = X?.getBoundingClientRect();
    if (!X || !ne?.width || !ne.height)
      return k(document.elementFromPoint(h, $));
    const ve = ne.left + X.clientLeft, V = ne.top + X.clientTop, xe = ve + (X.clientWidth || ne.width), ce = V + (X.clientHeight || ne.height), Te = X.querySelector("thead")?.getBoundingClientRect().bottom ?? V, $e = Math.max(ve + 1, Math.min(h, xe - 1)), Be = Math.max(Math.min(Math.max(V, Te), ce - 1) + 1, Math.min($, ce - 1)), Ue = k(document.elementFromPoint($e, Be));
    return Ue || i7(
      X,
      { left: ve, right: xe, top: Math.max(V, Te), bottom: ce },
      { x: $e, y: Be },
      b
    );
  }, ee = () => {
    const X = ie();
    if (X && p !== null) {
      const ne = _(X), ve = n.value?.state.value.focus;
      if (ve?.rowKey === ne.rowKey && ve.columnKey === ne.columnKey)
        return;
      n.value?.select(ne, { extend: !0 }), F();
    }
  }, O = () => {
    if (p === null)
      return;
    const X = e.root.value?.querySelector(".hp-data-table__wrapper");
    if (X && y) {
      const ne = X.getBoundingClientRect(), ve = ci(h, ne.left, ne.right), V = ci($, ne.top, ne.bottom);
      if (ve || V) {
        const xe = X.scrollLeft, ce = X.scrollTop;
        X.scrollBy(ve, V), (X.scrollLeft !== xe || X.scrollTop !== ce) && ee();
      }
    }
    f = requestAnimationFrame(O);
  }, z = (X) => {
    if (!a.value || o() || X.button !== 0 || X.pointerType === "touch" || E(X))
      return;
    const ne = k(x(X.target));
    !ne || ne.contains(T() ?? null) || (X.preventDefault(), M() && (l.value = "", c(), n.value?.select(_(ne), H(X)), F(), p = X.pointerId, y = !1, h = w = X.clientX, $ = v = X.clientY, d = ne, d.setPointerCapture?.(p), f = requestAnimationFrame(O)));
  }, D = (X) => {
    p === X.pointerId && (Math.abs(X.clientX - w) + Math.abs(X.clientY - v) > d7 && (y = !0), h = X.clientX, $ = X.clientY, y && ee());
  }, P = (X) => {
    !a.value || E(X) || ((k(x(X.target)) || y) && X.stopPropagation(), y = !1);
  }, Z = () => {
    const X = n.value?.state.value.focus;
    X && !o() && !Ne(e.editingBlocked) && e.registry.get({ rowKey: X.rowKey, colKey: X.columnKey })?.activate?.();
  }, J = (X) => {
    !a.value || E(X) || o() || k(x(X.target)) && (X.preventDefault(), X.stopPropagation(), Z());
  }, re = (X, ne, ve = !1) => {
    const V = n.value, xe = V?.state.value.focus, ce = document.activeElement, Te = b(ce) && ce?.closest("[data-editable-cell]") && !k(ce);
    if (!V || !xe || o() || Te)
      return !1;
    const $e = V.surface.value, Be = $e.rowKeys[Math.max(0, Math.min($e.rowKeys.length - 1, $e.rowKeys.indexOf(xe.rowKey) + X))], Ue = $e.columnKeys[Math.max(0, Math.min($e.columnKeys.length - 1, $e.columnKeys.indexOf(xe.columnKey) + ne))];
    return !Be || !Ue || !M() ? !1 : (V.select({ rowKey: Be, columnKey: Ue }, { extend: ve }), F(), !0);
  }, U = (X) => !a.value || o() || X.defaultPrevented || E(X) || !k(x(X.target)) || !!S(), ge = (X) => {
    const ne = n.value, ve = ne.state.value.focus;
    if (!ve)
      return;
    const V = ne.surface.value, xe = X.key === "End", ce = V.rowKeys[xe ? V.rowKeys.length - 1 : 0];
    ne.select(
      {
        rowKey: X.ctrlKey || X.metaKey ? ce : ve.rowKey,
        columnKey: V.columnKeys[xe ? V.columnKeys.length - 1 : 0]
      },
      { extend: X.shiftKey }
    );
  }, K = (X) => {
    const ne = n.value, ve = ne.state.value.focus;
    ve && (X.shiftKey ? ne.selectRow(ve.rowKey) : ne.selectColumn(ve.columnKey));
  }, pe = (X) => {
    const ne = k(x(X.target));
    X.key !== "Escape" && !n.value?.state.value.focus && ne && n.value?.select(_(ne));
  }, ae = (X) => {
    const ne = X.ctrlKey || X.metaKey, ve = X.key.toLowerCase();
    if (ne && ve === "a")
      return n.value?.selectAll(), !0;
    if (ve === " " && (ne || X.shiftKey))
      return pe(X), K(X), !0;
    const xe = {
      Escape: () => n.value?.clear(),
      Enter: Z,
      F2: Z,
      Home: () => ge(X),
      End: () => ge(X),
      ArrowUp: () => {
        re(-1, 0, X.shiftKey);
      },
      ArrowDown: () => {
        re(1, 0, X.shiftKey);
      },
      ArrowLeft: () => {
        re(0, -1, X.shiftKey);
      },
      ArrowRight: () => {
        re(0, 1, X.shiftKey);
      }
    }[X.key];
    return xe ? (pe(X), xe(), !0) : !1;
  }, Ce = (X) => {
    U(X) || X.isComposing || ae(X) && (X.preventDefault(), X.stopPropagation(), F());
  }, q = () => {
    r.value = t(
      "ui.tableRange.copyError",
      "Unable to copy this selection. Select a rectangle or matching rows or columns."
    );
  }, I = (X) => {
    if (U(X) || !n.value?.clipboardEnabled.value || window.getSelection()?.toString())
      return;
    const ne = n.value.serialize();
    if (!(!ne.ok && ne.reason === "empty")) {
      if (X.preventDefault(), X.stopPropagation(), !ne.ok || !X.clipboardData) {
        q();
        return;
      }
      try {
        X.clipboardData.setData("text/plain", ne.text), n.value.markCopied(), c(), l.value = t("ui.tableRange.copied", "Selection copied");
      } catch {
        q();
      }
    }
  }, oe = async () => {
    if (o())
      return;
    const X = n.value, ne = X?.serialize();
    if (!X || !ne?.ok) {
      q();
      return;
    }
    const ve = X.state.value;
    if (await s(ne.text)) {
      c();
      const V = X.serialize();
      X.state.value === ve && V.ok && V.text === ne.text && X.markCopied(), l.value = t("ui.tableRange.copied", "Selection copied");
    } else
      q();
  }, be = (X, ne, ve) => {
    o() || !M() || (X === "row" ? n.value?.selectRow(ne, ve ? H(ve) : {}) : n.value?.selectColumn(ne, ve ? H(ve) : {}), F());
  }, de = (X) => {
    X && (n.value?.select({ rowKey: String(X.rowKey), columnKey: X.colKey }), F());
  };
  return Se([a, () => Ne(e.blocked)], () => {
    te(), l.value = "", c();
  }), ct(te), {
    enabled: a,
    message: l,
    errorMessage: r,
    dismissError: c,
    onPointerDown: z,
    onPointerMove: D,
    finish: te,
    onClick: P,
    onDoubleClick: J,
    onKeydown: Ce,
    onCopy: I,
    move: re,
    setActive: de,
    selectAxis: be,
    copy: () => Kn(oe())
  };
}, bT = (e, t, n = {}) => {
  if (!e.enabled.value || !e.hasCell(t))
    return {};
  const a = {
    role: "gridcell",
    "data-range-row": t.rowKey,
    "data-range-column": t.columnKey,
    onFocus: () => {
      e.state.value.focus || e.select(t);
    }
  };
  return n.managed ? { ...a, "data-range-managed": "" } : { ...a, ...Tu(e, t) };
}, Tu = (e, t) => {
  const n = e.surface.value, a = e.state.value.focus, o = e.isSelected(t);
  return {
    tabindex: (a ? t.rowKey === a.rowKey && t.columnKey === a.columnKey : t.rowKey === n.rowKeys[0] && t.columnKey === n.columnKeys[0]) ? 0 : -1,
    "aria-selected": o,
    "data-range-selected": o ? "true" : void 0,
    "data-range-multiple": o && e.count.value > 1 ? "true" : void 0,
    "data-range-edges": e.cellEdges(t),
    "data-range-copied": e.cellEdges(t, !0)
  };
}, yl = "[data-range-managed][data-range-row][data-range-column]", ui = [
  "tabindex",
  "aria-selected",
  "data-range-selected",
  "data-range-multiple",
  "data-range-edges",
  "data-range-copied"
], f7 = (e) => {
  const t = m(() => Ne(e.selection)), n = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new WeakMap();
  let l = /* @__PURE__ */ new Set(), r;
  const c = (y) => y.closest("[data-table-grid]") === e.root.value, s = (y) => {
    for (const w of ui)
      y.removeAttribute(w);
    o.delete(y);
  }, p = (y, w) => {
    const v = a.get(y);
    if (!v)
      return;
    const x = Tu(w, v), b = o.get(y);
    for (const k of ui) {
      const _ = x[k];
      (!b || b[k] !== _) && (_ === void 0 ? y.removeAttribute(k) : y.setAttribute(k, String(_)));
    }
    o.set(y, x);
  }, d = (y) => {
    const w = /* @__PURE__ */ new Set();
    for (const b of [...y.state.value.ranges, ...y.state.value.copiedRanges])
      for (const k of b.rowKeys) {
        const _ = n.get(k);
        if (_)
          for (const T of b.columnKeys) {
            const S = _.get(T);
            S && w.add(S);
          }
      }
    const v = y.state.value.focus ?? {
      rowKey: y.surface.value.rowKeys[0] ?? "",
      columnKey: y.surface.value.columnKeys[0] ?? ""
    }, x = n.get(v.rowKey)?.get(v.columnKey);
    return x && w.add(x), w;
  }, f = () => {
    const y = t.value;
    if (!y?.enabled.value || Ne(e.blocked))
      return;
    const w = d(y);
    for (const v of /* @__PURE__ */ new Set([...l, ...w]))
      p(v, y);
    l = w;
  }, h = () => {
    const y = t.value, w = new Set(a.keys());
    if (n.clear(), a.clear(), y?.enabled.value && !Ne(e.blocked))
      for (const v of e.root.value?.querySelectorAll(yl) ?? []) {
        if (!c(v))
          continue;
        const x = { rowKey: v.dataset.rangeRow, columnKey: v.dataset.rangeColumn };
        if (!y.hasCell(x))
          continue;
        const b = n.get(x.rowKey) ?? /* @__PURE__ */ new Map();
        b.set(x.columnKey, v), n.set(x.rowKey, b), a.set(v, x), w.delete(v), p(v, y);
      }
    w.forEach(s), f();
  }, $ = (y) => y instanceof Element && (y.matches(yl) || y.querySelector(yl));
  Se(
    e.root,
    (y) => {
      r?.disconnect(), y && (r = new MutationObserver((w) => {
        w.some(
          (v) => v.type === "attributes" || [...v.addedNodes, ...v.removedNodes].some($)
        ) && h();
      }), r.observe(y, {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["data-range-managed", "data-range-row", "data-range-column"]
      })), h();
    },
    { flush: "post" }
  ), Se(
    () => [
      t.value?.enabled.value ? t.value.surface.value : null,
      t.value?.enabled.value,
      Ne(e.blocked)
    ],
    h,
    { flush: "post" }
  ), Se(() => t.value?.state.value, f, { flush: "post" }), ct(() => {
    r?.disconnect(), a.forEach((y, w) => s(w));
  });
}, h7 = {
  class: "hp-table-range-status",
  role: "status",
  "aria-live": "polite"
}, v7 = /* @__PURE__ */ Y({
  __name: "TableRangeStatus",
  props: {
    api: {},
    message: {}
  },
  setup(e) {
    const t = Le();
    return (n, a) => (i(), g("span", h7, le(e.message.value || (e.api?.count.value ? u(t)("ui.tableRange.selectedCount", "Cells selected: {count}", { count: e.api.count.value }) : "")), 1));
  }
}), m7 = ["aria-multiselectable"], kT = /* @__PURE__ */ Y({
  __name: "TableGridProvider",
  props: {
    rangeSelection: {},
    rangeBlocked: { type: Boolean },
    rangeReadonly: { type: Boolean },
    class: { default: void 0 },
    wrap: { type: Boolean, default: !1 },
    onBeforeMove: {}
  },
  emits: ["active-change", "commit"],
  setup(e, { expose: t, emit: n }) {
    const a = e, o = n, l = N(null), r = Ze(a, "wrap"), { activeCell: c, setActive: s } = t7({
      containerRef: l,
      onActiveChange: (M) => o("active-change", M)
    }), p = r7();
    f7({ root: l, selection: () => a.rangeSelection, blocked: () => a.rangeBlocked ?? !1 });
    const d = p7({ root: l, selection: () => a.rangeSelection, registry: p, blocked: () => a.rangeBlocked ?? !1, editingBlocked: () => a.rangeReadonly ?? !1, beforeMove: () => a.onBeforeMove?.() ?? !0 }), f = m(() => {
      const M = a.rangeSelection?.state.value.focus;
      return d.enabled.value ? M ? { rowKey: M.rowKey, colKey: M.columnKey } : null : c.value;
    }), h = (M) => {
      d.enabled.value ? d.setActive(M) : s(M);
    }, { copyRow: $ } = Ar({ registry: p }), y = (M, E) => {
      if (d.enabled.value)
        return d.move(M, E);
      if (a.onBeforeMove !== void 0 && !a.onBeforeMove())
        return !1;
      const F = J8({
        container: l.value,
        current: f.value,
        dRow: M,
        dCol: E,
        wrap: r.value
      });
      return F ? (h(F), !0) : !1;
    }, w = (M) => {
      const E = e7(l.value, f.value, M);
      E && h(E);
    }, v = async () => {
      const M = l.value, E = f.value;
      if (!M || !E)
        return;
      const H = Kr(M, E)?.closest("tr");
      H && await $(H);
    }, b = l7({
      activeCell: f,
      containerRef: l,
      isEditing: () => {
        const M = f.value;
        return M ? p.getState(M) === "editing" : !1;
      },
      registry: p,
      moveActive: y,
      moveHomeEnd: w,
      copyFocusedRow: v
    }), k = (M) => {
      d.enabled.value ? d.onKeydown(M) : b.handleKeydown(M);
    }, _ = (M) => {
      d.enabled.value ? d.onCopy(M) : b.handleCopy(M);
    }, S = {
      activeCell: f,
      setActive: h,
      moveActive: y,
      moveHomeEnd: w,
      containerRef: l,
      wrap: r,
      copyFocusedRow: v,
      notifyCommit: (M) => {
        o("commit", M);
      },
      registry: p,
      registerCell: p.register,
      unregisterCell: p.unregister,
      getCellEntry: p.get,
      getCellState: p.getState
    };
    return Dt(Qc, S), t({
      selectAxis: d.selectAxis,
      copySelection: d.copy,
      activeCell: f,
      setActive: h,
      moveActive: y,
      copyFocusedRow: v,
      containerRef: l
    }), (M, E) => (i(), g("div", {
      ref_key: "containerRef",
      ref: l,
      class: W(["hp-editable-cell-provider", a.class, { "hp-table-range-grid": u(d).enabled.value }]),
      role: "grid",
      "data-table-grid": "",
      "aria-multiselectable": u(d).enabled.value || void 0,
      onPointerdownCapture: E[0] || (E[0] = //@ts-ignore
      (...F) => u(d).onPointerDown && u(d).onPointerDown(...F)),
      onPointermove: E[1] || (E[1] = //@ts-ignore
      (...F) => u(d).onPointerMove && u(d).onPointerMove(...F)),
      onPointerup: E[2] || (E[2] = //@ts-ignore
      (...F) => u(d).finish && u(d).finish(...F)),
      onPointercancel: E[3] || (E[3] = //@ts-ignore
      (...F) => u(d).finish && u(d).finish(...F)),
      onLostpointercapture: E[4] || (E[4] = //@ts-ignore
      (...F) => u(d).finish && u(d).finish(...F)),
      onClickCapture: E[5] || (E[5] = //@ts-ignore
      (...F) => u(d).onClick && u(d).onClick(...F)),
      onDblclickCapture: E[6] || (E[6] = //@ts-ignore
      (...F) => u(d).onDoubleClick && u(d).onDoubleClick(...F)),
      onKeydown: k,
      onCopy: _
    }, [
      L(M.$slots, "default"),
      u(d).enabled.value && u(d).errorMessage.value ? (i(), R(qn, {
        key: 0,
        variant: "soft",
        color: "red",
        size: "2",
        title: u(d).errorMessage.value,
        onClose: u(d).dismissError
      }, null, 8, ["title", "onClose"])) : A("", !0),
      u(d).enabled.value ? (i(), R(v7, {
        key: 1,
        api: a.rangeSelection,
        message: u(d).message
      }, null, 8, ["api", "message"])) : A("", !0)
    ], 42, m7));
  }
}), g7 = { class: "hp-tags-suggestion-item__checkbox" }, y7 = /* @__PURE__ */ Y({
  __name: "TagsInputSuggestionItem",
  props: {
    label: {},
    selected: { type: Boolean },
    showCheckbox: { type: Boolean },
    checkbox: {},
    colorDot: {},
    colorDotVariant: {}
  },
  emits: ["click"],
  setup(e) {
    return (t, n) => (i(), R(u(Oa), {
      label: e.label,
      selected: e.selected,
      onClick: n[0] || (n[0] = (a) => t.$emit("click"))
    }, it({
      suffix: B(() => [
        e.colorDot ? (i(), R(Rt, {
          key: 0,
          color: e.colorDot,
          variant: e.colorDotVariant,
          size: "1",
          square: "",
          radius: "full",
          "aria-hidden": "true"
        }, null, 8, ["color", "variant"])) : A("", !0)
      ]),
      _: 2
    }, [
      e.showCheckbox ? {
        name: "prefix",
        fn: B(() => [
          C("span", g7, [
            j(ln, {
              "model-value": e.selected,
              size: e.checkbox?.size ?? "1",
              variant: e.checkbox?.variant,
              color: e.checkbox?.color,
              tabindex: "-1",
              "aria-hidden": "true"
            }, null, 8, ["model-value", "size", "variant", "color"])
          ])
        ]),
        key: "0"
      } : void 0
    ]), 1032, ["label", "selected"]));
  }
}), w7 = /* @__PURE__ */ se(y7, [["__scopeId", "data-v-694f0d6e"]]), b7 = ["data-theme", "data-multi-row"], k7 = ["role", "aria-expanded", "aria-controls", "aria-autocomplete", "aria-activedescendant", "placeholder", "disabled", "readonly", "aria-invalid", "aria-busy"], _7 = {
  key: 2,
  class: "hp-tags-input__empty"
}, C7 = /* @__PURE__ */ Y({
  inheritAttrs: !1,
  __name: "TagsInput",
  props: /* @__PURE__ */ Xe({
    variant: { default: "filled" },
    size: { default: "3" },
    color: { default: void 0 },
    radius: { default: void 0 },
    placeholder: { default: void 0 },
    align: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    readOnly: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 },
    width: { default: void 0 },
    minWidth: { default: void 0 },
    maxWidth: { default: void 0 },
    class: { default: void 0 },
    prefix: { default: void 0 },
    suffix: { default: void 0 },
    allowDuplicates: { type: Boolean, default: !1 },
    dismissible: { type: Boolean, default: !0 },
    validate: { type: Function, default: () => !0 },
    options: { default: void 0 },
    optionLabel: { default: "name" },
    optionValue: { default: "id" },
    optionColor: { default: void 0 },
    chipColor: { default: void 0 },
    toggleSelect: { type: Boolean, default: !1 },
    showOptionColorDot: { type: Boolean, default: !1 },
    optionColorDotVariant: { default: void 0 },
    allowCreate: { type: Boolean, default: !1 },
    createOption: { type: Function, default: void 0 },
    maxVisible: { default: void 0 },
    dropdownSize: { default: void 0 },
    dropdownPlacement: { default: "bottom-start" },
    suggestionCheckbox: { default: () => ({ size: "1" }) }
  }, {
    modelValue: { default: () => [] },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["focus", "blur", "clear", "overflow-click"], ["update:modelValue"]),
  setup(e, { expose: t, emit: n }) {
    const a = e, o = n, l = vt(e, "modelValue"), r = N(null), c = N(null), s = N(""), p = N(!1), d = N(!1), f = N(!1), h = mt(), $ = Le(), y = m(() => a.placeholder ?? $("ui.tagsInput.addATag", "Add a tag")), { cvaSizing: w, styleVars: v } = Xn(a), x = ze("hp-tags-input hp-input", {
      variants: Qn,
      defaultVariants: Jn
    }), b = m(
      () => x({
        variant: a.variant,
        size: a.size,
        disabled: a.disabled,
        readOnly: a.readOnly,
        invalid: a.invalid,
        loading: a.loading,
        radius: a.radius,
        align: a.align,
        width: w.value.width,
        minWidth: w.value.minWidth,
        maxWidth: w.value.maxWidth,
        class: a.class
      })
    ), k = m(() => v.value), _ = m(() => Array.isArray(a.options)), T = m(() => a.optionLabel ?? "name"), S = m(() => a.optionValue ?? "id"), M = N(!1), E = () => {
      const we = c.value;
      if (!we) {
        M.value = !1;
        return;
      }
      const We = we.querySelector(".hp-tags-input__tags");
      if (!We) {
        M.value = !1;
        return;
      }
      const et = Array.from(We.children), ua = et[0];
      if (et.length < 2 || !ua) {
        M.value = !1;
        return;
      }
      const qo = ua.offsetTop;
      M.value = et.some((Vu) => Vu.offsetTop > qo);
    }, F = (we) => we instanceof Node ? !!c.value?.contains(we) : !1, H = (we) => we instanceof Element ? !!we.closest(".hp-tags-input__suggestions") : !1, te = () => {
      d.value = !1, f.value = !1, Ye(E);
    }, ie = () => {
      window.setTimeout(() => {
        !_.value && s.value.trim() && Q(), te();
      }, 0);
    }, ee = (we) => {
      f.value && (F(we.target) || H(we.target) || ie());
    };
    let O = null;
    tt(() => {
      typeof ResizeObserver < "u" && c.value && (O = new ResizeObserver(() => E()), O.observe(c.value)), document.addEventListener("pointerdown", ee, !0), Ye(E);
    }), ct(() => {
      O?.disconnect(), O = null, document.removeEventListener("pointerdown", ee, !0);
    });
    const z = m(() => l.value?.length ?? 0), D = m(
      () => a.maxVisible !== void 0 && z.value > a.maxVisible
    ), P = m(() => d.value || f.value), Z = m(() => D.value && !P.value), J = m(() => {
      const we = l.value ?? [];
      return Z.value ? we.slice(0, a.maxVisible) : we;
    }), re = m(() => Z.value ? z.value - (a.maxVisible ?? 0) : 0), U = () => {
      a.disabled || (f.value = !0, o("overflow-click", re.value), Ye(() => r.value?.focus()));
    }, ge = (we) => typeof we == "string" ? we : String(we[T.value] ?? ""), K = (we) => {
      if (typeof we == "string" || !a.optionColor)
        return;
      const We = we[a.optionColor];
      return typeof We == "string" ? We : void 0;
    }, pe = (we) => l.value.some((et) => et[S.value] === we[S.value]), ae = m(() => {
      if (!_.value || !a.options)
        return [];
      const we = s.value.toLowerCase();
      return a.options.filter((We) => we === "" || String(We[T.value] ?? "").toLowerCase().includes(we) ? a.toggleSelect ? !0 : !pe(We) : !1);
    }), Ce = (we) => {
      if (a.disabled)
        return;
      const We = l.value;
      pe(we) ? l.value = We.filter((et) => et[S.value] !== we[S.value]) : l.value = [...We, we], s.value = "", r.value?.focus();
    }, q = (we) => {
      a.toggleSelect ? Ce(we) : ce(we);
    }, I = m(() => s.value.trim()), oe = m(
      () => _.value && ae.value.length === 0 && !be.value
    ), be = m(() => {
      if (!_.value || !a.allowCreate)
        return !1;
      const we = I.value;
      if (!we)
        return !1;
      const We = we.toLowerCase();
      return !(a.options ?? []).some((ua) => String(ua[T.value] ?? "").toLowerCase() === We);
    }), de = m(() => a.variant === "cell" ? "1" : a.size), X = m(() => !!a.prefix || !!h.prefix), ne = m(() => !!a.suffix || !!h.suffix), ve = m(() => !!(l.value && l.value.length > 0)), V = m(() => ve.value && !a.disabled && !a.loading && !a.readOnly), xe = () => {
      if (!a.disabled) {
        if (D.value) {
          f.value = !0, Ye(() => r.value?.focus());
          return;
        }
        r.value?.focus();
      }
    }, ce = (we) => {
      if (a.disabled)
        return;
      const We = l.value;
      if (!a.allowDuplicates && We.some((et) => et[S.value] === we[S.value])) {
        s.value = "", r.value?.focus();
        return;
      }
      l.value = [...We, we], s.value = "", r.value?.focus();
    }, Te = (we) => {
      if (!we)
        return;
      const We = we.toLowerCase();
      return ae.value.find((et) => String(et[T.value] ?? "").toLowerCase() === We);
    }, $e = (we) => a.createOption ? a.createOption(we) : { [S.value]: we, [T.value]: we }, Be = (we) => a.allowDuplicates ? !1 : l.value.some((We) => We[S.value] === we), Ue = () => {
      const we = s.value.trim();
      if (!we)
        return;
      const We = Te(we);
      if (We) {
        ce(We);
        return;
      }
      if (!a.allowCreate || !a.validate(we))
        return;
      const et = $e(we);
      if (Be(et[S.value])) {
        s.value = "";
        return;
      }
      ce(et);
    }, qe = () => {
      const we = s.value.trim();
      if (!(!we || !a.validate(we))) {
        if (!a.allowDuplicates && l.value?.includes(we)) {
          s.value = "";
          return;
        }
        l.value = [...l.value || [], we], s.value = "";
      }
    }, Q = () => {
      _.value ? Ue() : qe();
    }, G = (we) => {
      if (l.value)
        if (_.value) {
          const We = [...l.value];
          We.splice(we, 1), l.value = We;
        } else {
          const We = [...l.value];
          We.splice(we, 1), l.value = We;
        }
    }, fe = (we) => {
      s.value === "" && l.value && l.value.length > 0 && (we.preventDefault(), G(l.value.length - 1));
    };
    Se(() => l.value?.length ?? 0, () => {
      Ye(E);
    }), Se(() => ae.value.length, (we) => {
      we > 0 && document.activeElement === r.value && (p.value = !0);
    }), Se(be, (we) => {
      we && document.activeElement === r.value && (p.value = !0);
    }), Se(s, () => {
      _.value && document.activeElement === r.value && (ae.value.length > 0 || be.value) && (p.value = !0);
    });
    const ke = (we) => {
      d.value = !0, D.value && (f.value = !0), _.value && !H(we.relatedTarget) && (p.value = !0), o("focus", we);
    }, Re = (we) => {
      d.value = !1, !_.value && s.value.trim() && Q(), F(we.relatedTarget) || te(), o("blur", we);
    }, xt = (we) => {
      F(we.relatedTarget) || te();
    }, ot = () => {
      l.value = [], s.value = "", o("clear");
    }, {
      activeIndex: Lt,
      keyboardNav: Ft,
      baseId: Ma,
      optionId: Da,
      activeDescendantId: Ta,
      enabledIndexes: Wa,
      moveActive: Tn,
      setActive: Bn,
      scrollActiveIntoView: ue,
      initActive: Me
    } = Vr({
      items: ae,
      open: p,
      idSegment: "suggestion"
    }), Oe = `${Ma}-listbox`, { handleEscape: Ge, handleTab: _e, consume: Ee } = Gn({
      isOpen: p,
      close: () => {
        p.value = !1;
      },
      refocus: () => {
        r.value?.focus();
      }
    });
    Se(ae, async () => {
      p.value && await Me();
    });
    const Ve = (we, We) => {
      if (!_.value)
        return;
      Ee(we);
      const et = !Ft.value;
      if (Ft.value = !0, !p.value) {
        p.value = !0;
        return;
      }
      return et ? Lt.value < 0 ? Me() : ue() : Tn(We);
    }, Zt = (we, We) => {
      if (!(!_.value || !p.value))
        return Ee(we), Ft.value = !0, Bn(We);
    }, ga = {
      ArrowDown: (we) => Ve(we, 1),
      ArrowUp: (we) => Ve(we, -1),
      Home: (we) => Zt(we, Wa.value[0] ?? -1),
      End: (we) => Zt(we, Wa.value[Wa.value.length - 1] ?? -1),
      Enter: (we) => {
        if (_.value && p.value && Ft.value && Lt.value >= 0) {
          const We = ae.value[Lt.value];
          if (We && We.disabled !== !0) {
            Ee(we), q(We);
            return;
          }
        }
        we.preventDefault(), Q();
      },
      Escape: Ge,
      Tab: _e
    }, ca = (we) => {
      if (!a.disabled)
        return ga[we.key]?.(we);
    };
    return t({
      inputRef: r,
      focus: () => r.value?.focus(),
      blur: () => r.value?.blur(),
      clear: ot
    }), (we, We) => (i(), R(u(Xt), {
      open: p.value,
      "onUpdate:open": We[1] || (We[1] = (et) => p.value = et),
      type: "menu",
      placement: e.dropdownPlacement,
      "match-width": !e.dropdownSize,
      "focus-trap": !1,
      "focus-return": !1,
      "close-on-click-outside": !0,
      "close-on-escape": !0
    }, {
      default: B(() => [
        j(u(Jt), null, {
          default: B(() => [
            C("div", Ke({
              ref_key: "wrapperRef",
              ref: c,
              class: b.value,
              style: k.value,
              "data-theme": e.color,
              "data-multi-row": M.value || void 0
            }, we.$attrs, {
              onClick: xe,
              onFocusout: xt
            }), [
              X.value ? (i(), R(zo, { key: 0 }, {
                default: B(() => [
                  L(we.$slots, "prefix", {}, () => [
                    e.prefix ? (i(), R(Pe(e.prefix), { key: 0 })) : A("", !0)
                  ], !0)
                ]),
                _: 3
              })) : A("", !0),
              C("div", {
                class: W(["hp-tags-input__tags", { "hp-tags-input__tags--truncated": Z.value }])
              }, [
                (i(!0), g(he, null, De(J.value, (et, ua) => (i(), R(u(Ht), {
                  key: `${ge(et)}-${ua}`,
                  size: de.value,
                  variant: "soft",
                  color: K(et) ?? e.chipColor,
                  dismissible: e.dismissible && !Z.value,
                  disabled: e.disabled,
                  onDismiss: (qo) => G(ua)
                }, {
                  default: B(() => [
                    me(le(ge(et)), 1)
                  ]),
                  _: 2
                }, 1032, ["size", "color", "dismissible", "disabled", "onDismiss"]))), 128)),
                re.value > 0 ? (i(), R(u(Ht), {
                  key: 0,
                  size: de.value,
                  variant: "soft",
                  class: "hp-tags-input__more",
                  disabled: e.disabled,
                  onClick: Fe(U, ["stop"])
                }, {
                  default: B(() => [
                    me(" +" + le(re.value), 1)
                  ]),
                  _: 1
                }, 8, ["size", "disabled"])) : A("", !0),
                Z.value ? A("", !0) : ra((i(), g("input", {
                  key: 1,
                  ref_key: "inputRef",
                  ref: r,
                  type: "text",
                  class: "hp-tags-input__field",
                  role: _.value ? "combobox" : void 0,
                  "aria-expanded": _.value ? p.value : void 0,
                  "aria-controls": _.value ? Oe : void 0,
                  "aria-autocomplete": _.value ? "list" : void 0,
                  "aria-activedescendant": u(Ta),
                  placeholder: l.value && l.value.length > 0 ? "" : y.value,
                  disabled: e.disabled || e.loading,
                  readonly: e.readOnly,
                  "aria-invalid": e.invalid || void 0,
                  "aria-busy": e.loading || void 0,
                  "onUpdate:modelValue": We[0] || (We[0] = (et) => s.value = et),
                  onKeydown: [
                    ca,
                    sa(fe, ["delete"])
                  ],
                  onFocus: ke,
                  onBlur: Re
                }, null, 40, k7)), [
                  [ki, s.value]
                ])
              ], 2),
              e.loading ? (i(), R(da, { key: 1 }, {
                default: B(() => [
                  j(Pl)
                ]),
                _: 1
              })) : V.value ? (i(), R(da, { key: 2 }, {
                default: B(() => [
                  j(Rt, {
                    variant: "soft",
                    size: de.value,
                    square: "",
                    icon: zt,
                    class: "hp-input__clear",
                    "aria-label": u($)("ui.tagsInput.clearAll", "Clear all"),
                    onClick: Fe(ot, ["stop"])
                  }, null, 8, ["size", "aria-label"])
                ]),
                _: 1
              })) : ne.value ? (i(), R(da, { key: 3 }, {
                default: B(() => [
                  L(we.$slots, "suffix", {}, () => [
                    e.suffix ? (i(), R(Pe(e.suffix), { key: 0 })) : A("", !0)
                  ], !0)
                ]),
                _: 3
              })) : A("", !0)
            ], 16, b7)
          ]),
          _: 3
        }),
        j(u(Qt), {
          class: W(e.dropdownSize ? `hp-tags-input__suggestions hp-tags-input__suggestions--size-${e.dropdownSize}` : "hp-tags-input__suggestions"),
          onKeydown: sa(u(Ge), ["escape"])
        }, {
          default: B(() => [
            _.value ? (i(), g(he, { key: 0 }, [
              ae.value.length > 0 ? (i(), g("div", {
                key: 0,
                id: Oe,
                role: "listbox",
                class: "hp-tags-input__listbox"
              }, [
                (i(!0), g(he, null, De(ae.value, (et, ua) => (i(), R(w7, {
                  id: u(Da)(ua),
                  key: String(et[S.value]),
                  role: "option",
                  tabindex: "-1",
                  "aria-selected": pe(et),
                  class: W(u(Ft) && ua === u(Lt) && et.disabled !== !0 ? "is-active" : void 0),
                  label: ge(et),
                  selected: pe(et),
                  "show-checkbox": e.toggleSelect,
                  checkbox: e.suggestionCheckbox,
                  "color-dot": e.showOptionColorDot ? K(et) : void 0,
                  "color-dot-variant": e.optionColorDotVariant,
                  onClick: (qo) => q(et)
                }, null, 8, ["id", "aria-selected", "class", "label", "selected", "show-checkbox", "checkbox", "color-dot", "color-dot-variant", "onClick"]))), 128))
              ])) : A("", !0),
              be.value ? (i(), R(u(Oa), {
                key: `__create__:${I.value}`,
                label: u($)("ui.tagsInput.createOption", '+ Create "{value}"', { value: I.value }),
                onClick: Q
              }, null, 8, ["label"])) : A("", !0),
              oe.value ? (i(), g("div", _7, le(u($)("ui.list.noItems", "No items")), 1)) : A("", !0)
            ], 64)) : A("", !0)
          ]),
          _: 1
        }, 8, ["class", "onKeydown"])
      ]),
      _: 3
    }, 8, ["open", "placement", "match-width"]));
  }
}), _T = /* @__PURE__ */ se(C7, [["__scopeId", "data-v-b925c256"]]), x7 = ze("hp-textarea", {
  variants: {
    variant: {
      filled: "hp-textarea--filled",
      soft: "hp-textarea--soft",
      outline: "hp-textarea--outline",
      surface: "hp-textarea--surface",
      "soft-outlined": "hp-textarea--outline hp-textarea--soft-outlined",
      blank: "hp-textarea--blank",
      underlined: "hp-textarea--underlined",
      // Cell mode — shared flush class. See styles/_cell-primitives.scss.
      cell: "hp-cell-primitive"
    },
    size: {
      1: "hp-textarea--size-1 hp-icon--size-2",
      2: "hp-textarea--size-2 hp-icon--size-2",
      3: "hp-textarea--size-3 hp-icon--size-2",
      4: "hp-textarea--size-4 hp-icon--size-3",
      5: "hp-textarea--size-5 hp-icon--size-3"
    },
    disabled: { true: "hp-textarea--disabled" },
    readOnly: { true: "hp-textarea--readonly" },
    invalid: { true: "hp-textarea--invalid" },
    loading: { true: "hp-textarea--loading" },
    radius: {
      none: "hp-textarea--radius-none",
      small: "hp-textarea--radius-small",
      big: "hp-textarea--radius-big",
      full: "hp-textarea--radius-full"
    },
    align: {
      left: "hp-textarea--align-left",
      center: "hp-textarea--align-center",
      right: "hp-textarea--align-right"
    },
    resize: {
      none: "hp-textarea--resize-none",
      vertical: "hp-textarea--resize-vertical",
      horizontal: "hp-textarea--resize-horizontal",
      both: "hp-textarea--resize-both"
    },
    autoResize: { true: "hp-textarea--auto-resize" },
    breakAnywhere: { true: "hp-textarea--break-anywhere" },
    width: {
      1: "hp-textarea--w-1",
      2: "hp-textarea--w-2",
      3: "hp-textarea--w-3",
      4: "hp-textarea--w-4",
      5: "hp-textarea--w-5",
      6: "hp-textarea--w-6",
      7: "hp-textarea--w-7"
    },
    minWidth: {
      1: "hp-textarea--min-w-1",
      2: "hp-textarea--min-w-2",
      3: "hp-textarea--min-w-3",
      4: "hp-textarea--min-w-4",
      5: "hp-textarea--min-w-5",
      6: "hp-textarea--min-w-6",
      7: "hp-textarea--min-w-7"
    },
    maxWidth: {
      1: "hp-textarea--max-w-1",
      2: "hp-textarea--max-w-2",
      3: "hp-textarea--max-w-3",
      4: "hp-textarea--max-w-4",
      5: "hp-textarea--max-w-5",
      6: "hp-textarea--max-w-6",
      7: "hp-textarea--max-w-7"
    }
  },
  defaultVariants: {
    variant: "filled",
    size: "3",
    resize: "vertical"
  }
}), $7 = ["data-theme"], S7 = ["value", "placeholder", "disabled", "readonly", "rows", "aria-invalid", "aria-busy"], CT = /* @__PURE__ */ Y({
  inheritAttrs: !1,
  __name: "Textarea",
  props: /* @__PURE__ */ Xe({
    variant: { default: "filled" },
    size: { default: "3" },
    color: { default: void 0 },
    radius: { default: void 0 },
    placeholder: { default: void 0 },
    align: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    loading: { type: Boolean, default: !1 },
    readOnly: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 },
    width: { default: void 0 },
    minWidth: { default: void 0 },
    maxWidth: { default: void 0 },
    class: { default: void 0 },
    prefix: { default: void 0 },
    suffix: { default: void 0 },
    rows: { default: 3 },
    resize: { default: "vertical" },
    autoResize: { type: Boolean, default: !1 },
    breakAnywhere: { type: Boolean, default: !1 }
  }, {
    modelValue: {},
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["focus", "blur", "change"], ["update:modelValue"]),
  setup(e, { expose: t, emit: n }) {
    const a = e, o = n, l = vt(e, "modelValue"), r = N(null), { cvaSizing: c, styleVars: s } = Xn(a), p = m(
      () => x7({
        variant: a.variant,
        size: a.size,
        disabled: a.disabled,
        readOnly: a.readOnly,
        invalid: a.invalid,
        loading: a.loading,
        radius: a.radius,
        align: a.align,
        resize: a.autoResize ? "none" : a.resize,
        autoResize: a.autoResize,
        breakAnywhere: a.breakAnywhere,
        width: c.value.width,
        minWidth: c.value.minWidth,
        maxWidth: c.value.maxWidth,
        class: a.class
      })
    ), d = m(() => s.value), f = mt(), h = m(() => !!a.prefix || !!f.prefix), $ = m(() => !!a.suffix || !!f.suffix), y = () => {
      if (!a.autoResize || !r.value)
        return;
      const v = r.value;
      v.style.height = "auto";
      const b = Math.max(v.scrollHeight, 40);
      v.style.height = `${b}px`;
    }, w = (v) => {
      const x = v.target;
      l.value = x.value, y();
    };
    return tt(() => {
      a.autoResize && (Ye(y), requestAnimationFrame(y), setTimeout(y, 100));
    }), Se(
      l,
      () => {
        a.autoResize && Ye(y);
      }
    ), Se(
      () => a.autoResize,
      (v) => {
        v ? Ye(y) : r.value && (r.value.style.height = "");
      }
    ), t({
      textareaRef: r,
      focus: () => r.value?.focus(),
      blur: () => r.value?.blur(),
      select: () => r.value?.select()
    }), (v, x) => (i(), g("div", {
      class: W(p.value),
      style: Ie(d.value),
      "data-theme": e.color
    }, [
      h.value ? (i(), R(zo, { key: 0 }, {
        default: B(() => [
          L(v.$slots, "prefix", {}, () => [
            e.prefix ? (i(), R(Pe(e.prefix), { key: 0 })) : A("", !0)
          ])
        ]),
        _: 3
      })) : A("", !0),
      C("textarea", Ke({
        ref_key: "textareaRef",
        ref: r,
        class: "hp-textarea__field",
        value: l.value,
        placeholder: e.placeholder,
        disabled: e.disabled || e.loading,
        readonly: e.readOnly,
        rows: e.autoResize ? void 0 : e.rows,
        "aria-invalid": e.invalid || void 0,
        "aria-busy": e.loading || void 0
      }, v.$attrs, {
        onInput: w,
        onChange: x[0] || (x[0] = (b) => o("change", b)),
        onFocus: x[1] || (x[1] = (b) => o("focus", b)),
        onBlur: x[2] || (x[2] = (b) => o("blur", b))
      }), null, 16, S7),
      $.value ? (i(), R(da, { key: 1 }, {
        default: B(() => [
          L(v.$slots, "suffix", {}, () => [
            e.suffix ? (i(), R(Pe(e.suffix), { key: 0 })) : A("", !0)
          ])
        ]),
        _: 3
      })) : A("", !0)
    ], 14, $7));
  }
}), M7 = {}, D7 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function T7(e, t) {
  return i(), g("svg", D7, [...t[0] || (t[0] = [
    C("circle", {
      cx: "8",
      cy: "8",
      r: "7",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)"
    }, null, -1),
    C("path", {
      d: "M5 8L7 10L11 6",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Bu = /* @__PURE__ */ se(M7, [["render", T7]]), B7 = {}, z7 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function A7(e, t) {
  return i(), g("svg", z7, [...t[0] || (t[0] = [
    C("circle", {
      cx: "8",
      cy: "8",
      r: "7",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)"
    }, null, -1),
    C("path", {
      d: "M8 5V9",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round"
    }, null, -1),
    C("circle", {
      cx: "8",
      cy: "11",
      r: "0.75",
      fill: "var(--icon-fill, var(--icon-color, currentColor))"
    }, null, -1)
  ])]);
}
const L7 = /* @__PURE__ */ se(B7, [["render", A7]]), E7 = {}, I7 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function R7(e, t) {
  return i(), g("svg", I7, [...t[0] || (t[0] = [
    C("path", {
      d: "M10.5 7.48291V10.9829M10.5 12.9829V13.4829M18.5 10.4829C18.5 14.9012 14.9183 18.4829 10.5 18.4829C6.08172 18.4829 2.5 14.9012 2.5 10.4829C2.5 6.06463 6.08172 2.48291 10.5 2.48291C14.9183 2.48291 18.5 6.06463 18.5 10.4829Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const zu = /* @__PURE__ */ se(E7, [["render", R7]]), P7 = {}, O7 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function V7(e, t) {
  return i(), g("svg", O7, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M8.09273 3.90371C9.59356 1.36543 10.4064 1.36543 11.9073 3.90371L17.1522 12.7743C18.6531 15.3126 18.2466 16 15.245 16H4.75503C1.75338 16 1.34694 15.3126 2.84776 12.7743L8.09273 3.90371Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10 7V10.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10 12.5V13",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Au = /* @__PURE__ */ se(P7, [["render", V7]]), H7 = ["data-theme"], N7 = {
  class: "hp-toast__ring",
  viewBox: "0 0 28 28",
  fill: "none",
  "aria-hidden": "true"
}, F7 = 11, K7 = /* @__PURE__ */ Y({
  __name: "Toast",
  props: {
    toast: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = 2 * Math.PI * F7, a = e, o = t, l = m(() => ({
      error: "red",
      success: "green",
      warning: "amber",
      info: "blue"
    })[a.toast.type]), r = m(() => ({
      error: L7,
      success: Bu,
      warning: Au,
      info: zu
    })[a.toast.type]), c = N(100);
    let s = null;
    const p = m(() => n * (1 - c.value / 100)), d = () => {
      const h = Date.now() - a.toast.createdAt, $ = Math.max(0, a.toast.duration - h);
      c.value = $ / a.toast.duration * 100, $ > 0 ? s = requestAnimationFrame(d) : o("close");
    };
    tt(() => {
      s = requestAnimationFrame(d);
    }), Fa(() => {
      s !== null && cancelAnimationFrame(s);
    });
    const f = () => {
      o("close");
    };
    return (h, $) => (i(), g("div", {
      class: "hp-toast",
      "data-theme": l.value
    }, [
      j(u(qn), {
        title: e.toast.title,
        description: e.toast.description,
        icon: r.value,
        variant: "filled",
        size: "2",
        shadow: "",
        onClose: f
      }, null, 8, ["title", "description", "icon"]),
      (i(), g("svg", N7, [
        $[0] || ($[0] = C("circle", {
          class: "hp-toast__ring-track",
          cx: "14",
          cy: "14",
          r: "11"
        }, null, -1)),
        C("circle", {
          class: "hp-toast__ring-fill",
          cx: "14",
          cy: "14",
          r: "11",
          style: Ie({ strokeDashoffset: p.value })
        }, null, 4)
      ]))
    ], 8, H7));
  }
}), xT = /* @__PURE__ */ Y({
  __name: "ToastContainer",
  props: /* @__PURE__ */ Xe({
    maxToasts: { default: 5 }
  }, {
    toasts: { required: !0 },
    toastsModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["remove"], ["update:toasts"]),
  setup(e, { emit: t }) {
    const n = e, a = vt(e, "toasts"), o = N(null), l = N(!1), r = m(() => g5() ?? "body"), c = t, s = m(() => a.value.slice(-n.maxToasts)), p = () => {
      const $ = o.value;
      !$ || typeof $.showPopover != "function" || s.value.length !== 0 && (l.value && $.hidePopover(), $.showPopover(), l.value = !0);
    }, d = () => {
      const $ = o.value;
      !$ || typeof $.hidePopover != "function" || l.value && s.value.length === 0 && ($.hidePopover(), l.value = !1);
    }, f = async () => {
      await Ye(), p();
    };
    Se(
      [() => s.value.at(-1)?.id, r],
      f
    ), tt(f), ct(() => {
      l.value && o.value && o.value.hidePopover();
    });
    const h = ($) => {
      c("remove", $);
    };
    return ($, y) => (i(), R(Eo, { to: r.value }, [
      C("div", {
        ref_key: "containerRef",
        ref: o,
        class: "hp-ui-boundary hp-toast-container",
        popover: "manual"
      }, [
        j(ju, {
          name: "hp-toast",
          onAfterLeave: d
        }, {
          default: B(() => [
            (i(!0), g(he, null, De(s.value, (w) => (i(), R(K7, {
              key: w.id,
              toast: w,
              onClose: (v) => h(w.id)
            }, null, 8, ["toast", "onClose"]))), 128))
          ]),
          _: 1
        })
      ], 512)
    ], 8, ["to"]));
  }
}), Y7 = {
  key: 0,
  class: "hp-toolbar__end"
}, $T = /* @__PURE__ */ Y({
  __name: "Toolbar",
  props: {
    padded: { type: Boolean, default: !1 },
    topBorder: { type: Boolean, default: !1 },
    bottomBorder: { type: Boolean, default: !1 },
    wrap: { type: Boolean, default: !1 },
    fullWidth: { type: Boolean, default: !1 },
    gap: { default: "2" },
    class: { default: void 0 }
  },
  setup(e) {
    const t = e, n = ze("hp-toolbar", {
      variants: {
        padded: { true: "hp-toolbar--padded" },
        topBorder: { true: "hp-toolbar--border-top" },
        bottomBorder: { true: "hp-toolbar--border-bottom" },
        wrap: { true: "hp-toolbar--wrap" },
        fullWidth: { true: "hp-toolbar--full-width" },
        gap: {
          1: "hp-toolbar--gap-1",
          2: "hp-toolbar--gap-2",
          3: "hp-toolbar--gap-3",
          4: "hp-toolbar--gap-4",
          5: "hp-toolbar--gap-5",
          6: "hp-toolbar--gap-6",
          7: "hp-toolbar--gap-7",
          8: "hp-toolbar--gap-8",
          9: "hp-toolbar--gap-9",
          10: "hp-toolbar--gap-10"
        }
      }
    }), a = m(() => [
      n({
        padded: t.padded,
        topBorder: t.topBorder,
        bottomBorder: t.bottomBorder,
        wrap: t.wrap,
        fullWidth: t.fullWidth,
        gap: t.gap
      }),
      t.class
    ]);
    return (o, l) => (i(), g("div", {
      class: W(a.value)
    }, [
      L(o.$slots, "default"),
      o.$slots.end ? (i(), g("div", Y7, [
        L(o.$slots, "end")
      ])) : A("", !0)
    ], 2));
  }
}), j7 = { class: "hp-week-scheduler__row hp-week-scheduler__row--header" }, W7 = ["onMousedown"], U7 = ["onMousedown"], q7 = ["data-theme", "onMousedown", "onMouseenter"], Z7 = { class: "hp-week-scheduler__row hp-week-scheduler__row--header" }, G7 = ["onMousedown"], X7 = { class: "hp-week-scheduler__hour-text" }, Q7 = ["onMousedown"], J7 = ["onMousedown"], e_ = ["data-theme", "onMousedown", "onMouseenter"], t_ = { class: "hp-week-scheduler__footer" }, a_ = 680, n_ = /* @__PURE__ */ Y({
  __name: "WeekScheduler",
  props: /* @__PURE__ */ Xe({
    modelValue: { default: () => [] }
  }, {
    timezone: { default: "+00:00" },
    timezoneModifiers: {}
  }),
  emits: /* @__PURE__ */ Xe(["update:modelValue"], ["update:timezone"]),
  setup(e, { emit: t }) {
    const n = Le(), a = [
      ["-11:00", "ui.weekScheduler.utc11SamoaPagoPago", "UTC-11 — Samoa, Pago Pago"],
      ["-10:00", "ui.weekScheduler.utc10HonoluluTahiti", "UTC-10 — Honolulu, Tahiti"],
      ["-09:00", "ui.weekScheduler.utc9AnchorageJuneau", "UTC-9 — Anchorage, Juneau"],
      ["-08:00", "ui.weekScheduler.utc8LosAngelesVancouverSeattle", "UTC-8 — Los Angeles, Vancouver, Seattle"],
      ["-07:00", "ui.weekScheduler.utc7DenverPhoenixCalgary", "UTC-7 — Denver, Phoenix, Calgary"],
      ["-06:00", "ui.weekScheduler.utc6ChicagoDallasMexicoCity", "UTC-6 — Chicago, Dallas, Mexico City"],
      ["-05:00", "ui.weekScheduler.utc5NewYorkTorontoLima", "UTC-5 — New York, Toronto, Lima"],
      ["-04:00", "ui.weekScheduler.utc4HalifaxSantiagoCaracas", "UTC-4 — Halifax, Santiago, Caracas"],
      ["-03:00", "ui.weekScheduler.utc3SOPauloBuenosAiresMontevideo", "UTC-3 — São Paulo, Buenos Aires, Montevideo"],
      ["-02:00", "ui.weekScheduler.utc2MidAtlanticSouthGeorgia", "UTC-2 — Mid-Atlantic, South Georgia"],
      ["-01:00", "ui.weekScheduler.utc1AzoresCapeVerde", "UTC-1 — Azores, Cape Verde"],
      ["+00:00", "ui.weekScheduler.utc0LondonDublinLisbon", "UTC+0 — London, Dublin, Lisbon"],
      ["+01:00", "ui.weekScheduler.utc1ParisBerlinWarsaw", "UTC+1 — Paris, Berlin, Warsaw"],
      ["+02:00", "ui.weekScheduler.utc2HelsinkiTallinnKyiv", "UTC+2 — Helsinki, Tallinn, Kyiv"],
      ["+03:00", "ui.weekScheduler.utc3MoscowIstanbulRiyadh", "UTC+3 — Moscow, Istanbul, Riyadh"],
      ["+04:00", "ui.weekScheduler.utc4DubaiBakuTbilisi", "UTC+4 — Dubai, Baku, Tbilisi"],
      ["+05:00", "ui.weekScheduler.utc5KarachiTashkentIslamabad", "UTC+5 — Karachi, Tashkent, Islamabad"],
      ["+05:30", "ui.weekScheduler.utc530MumbaiDelhiKolkata", "UTC+5:30 — Mumbai, Delhi, Kolkata"],
      ["+06:00", "ui.weekScheduler.utc6DhakaAlmatyOmsk", "UTC+6 — Dhaka, Almaty, Omsk"],
      ["+07:00", "ui.weekScheduler.utc7BangkokJakartaHanoi", "UTC+7 — Bangkok, Jakarta, Hanoi"],
      ["+08:00", "ui.weekScheduler.utc8BeijingSingaporeHongKong", "UTC+8 — Beijing, Singapore, Hong Kong"],
      ["+09:00", "ui.weekScheduler.utc9TokyoSeoulOsaka", "UTC+9 — Tokyo, Seoul, Osaka"],
      ["+10:00", "ui.weekScheduler.utc10SydneyMelbourneBrisbane", "UTC+10 — Sydney, Melbourne, Brisbane"],
      ["+11:00", "ui.weekScheduler.utc11NoumeaHoniaraMagadan", "UTC+11 — Noumea, Honiara, Magadan"],
      ["+12:00", "ui.weekScheduler.utc12AucklandWellingtonSuva", "UTC+12 — Auckland, Wellington, Suva"]
    ], o = m(
      () => a.map(([I, oe, be]) => ({ value: I, label: n(oe, be) }))
    ), l = e, r = t, c = Wu("rootEl"), s = N(Number.POSITIVE_INFINITY), p = m(() => s.value <= a_);
    let d;
    tt(() => {
      c.value === null || typeof ResizeObserver > "u" || (d = new ResizeObserver(([I]) => {
        I !== void 0 && (s.value = I.contentRect.width);
      }), d.observe(c.value));
    }), ct(() => {
      d?.disconnect(), d = void 0;
    });
    const f = vt(e, "timezone"), h = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23], $ = [18, 19, 20, 21], y = [9, 10, 11, 12, 13, 14, 15, 16], w = [0, 1, 2, 3, 4, 5], v = [1, 2, 3, 4, 5], x = [0, 6], b = [
      { id: 0, name: "Sunday", shortName: "Sun" },
      { id: 1, name: "Monday", shortName: "Mon" },
      { id: 2, name: "Tuesday", shortName: "Tue" },
      { id: 3, name: "Wednesday", shortName: "Wed" },
      { id: 4, name: "Thursday", shortName: "Thu" },
      { id: 5, name: "Friday", shortName: "Fri" },
      { id: 6, name: "Saturday", shortName: "Sat" }
    ], k = m(
      () => b.map((I) => ({
        id: I.id,
        name: n(`ui.weekScheduler.days[${I.id}]`, I.name),
        shortName: n(`ui.weekScheduler.daysShort[${I.id}]`, I.shortName)
      }))
    ), _ = N(!1), T = N(!1), S = N(!1), M = m(() => {
      const I = /* @__PURE__ */ new Map();
      for (const oe of l.modelValue)
        I.set(oe.day, new Set(oe.hours));
      return I;
    }), E = (I) => {
      const oe = [...I.entries()].map(([be, de]) => ({ day: be, hours: [...de].sort((X, ne) => X - ne) })).sort((be, de) => be.day - de.day);
      r("update:modelValue", oe);
    }, F = () => {
      const I = /* @__PURE__ */ new Map();
      for (const [oe, be] of M.value)
        I.set(oe, new Set(be));
      return I;
    }, H = (I) => I < 10 ? `0${I}:00` : `${I}:00`, te = (I, oe) => M.value.get(I)?.has(oe) ?? !1, ie = (I) => {
      if (M.value.size !== 7)
        return !1;
      for (const oe of M.value.values())
        if (!oe.has(I))
          return !1;
      return !0;
    }, ee = (I, oe, be) => {
      if (!_.value && !be)
        return;
      const X = M.value.get(I)?.has(oe) ?? !1;
      if (be && (T.value = !X, S.value = X), !T.value && !S.value)
        return;
      const ne = F(), ve = ne.get(I) ?? /* @__PURE__ */ new Set();
      T.value && !X && (ve.add(oe), ne.set(I, ve)), S.value && X && (ve.delete(oe), ve.size === 0 ? ne.delete(I) : ne.set(I, ve)), E(ne);
    }, O = (I, oe, be) => {
      be.preventDefault(), _.value = !0, ee(I, oe, !0);
    }, z = (I, oe) => {
      _.value && ee(I, oe, !1);
    }, D = (I) => {
      _.value = !0;
    }, P = () => {
      _.value = !1;
    }, Z = () => {
      _.value = !1;
    }, J = (I) => {
      const oe = F();
      (oe.get(I)?.size ?? 0) === 24 ? oe.delete(I) : oe.set(I, new Set(h)), E(oe);
    }, re = (I) => {
      const oe = F();
      if (ie(I))
        for (const { id: be } of k.value) {
          const de = oe.get(be);
          de !== void 0 && (de.delete(I), de.size === 0 && oe.delete(be));
        }
      else
        for (const { id: be } of k.value) {
          const de = oe.get(be) ?? /* @__PURE__ */ new Set();
          de.add(I), oe.set(be, de);
        }
      E(oe);
    }, U = () => {
      const I = /* @__PURE__ */ new Map();
      for (const { id: oe } of k.value)
        I.set(oe, new Set($));
      E(I);
    }, ge = () => {
      const I = /* @__PURE__ */ new Map();
      for (const { id: oe } of k.value)
        I.set(oe, new Set(h));
      E(I);
    }, K = () => {
      E(/* @__PURE__ */ new Map());
    }, pe = () => {
      const I = F();
      for (const oe of v)
        I.set(oe, new Set(h));
      for (const oe of x)
        I.delete(oe);
      E(I);
    }, ae = () => {
      const I = F();
      for (const oe of x)
        I.set(oe, new Set(h));
      for (const oe of v)
        I.delete(oe);
      E(I);
    }, Ce = () => {
      const I = /* @__PURE__ */ new Map();
      for (const { id: oe } of k.value)
        I.set(oe, new Set(y));
      E(I);
    }, q = () => {
      const I = /* @__PURE__ */ new Map();
      for (const { id: oe } of k.value)
        I.set(oe, new Set(w));
      E(I);
    };
    return (I, oe) => (i(), g("div", {
      ref_key: "rootEl",
      ref: c,
      class: "hp-week-scheduler",
      onMouseup: P,
      onMouseleave: Z
    }, [
      C("div", {
        class: W(["hp-week-scheduler__grid", { "hp-week-scheduler__grid--transposed": p.value }])
      }, [
        p.value ? (i(), g(he, { key: 0 }, [
          C("div", j7, [
            oe[1] || (oe[1] = C("div", { class: "hp-week-scheduler__cell hp-week-scheduler__cell--hour-label hp-week-scheduler__cell--corner" }, null, -1)),
            (i(!0), g(he, null, De(k.value, (be) => (i(), g("div", {
              key: be.id,
              class: "hp-week-scheduler__cell hp-week-scheduler__cell--day-header",
              onMousedown: Fe((de) => J(be.id), ["stop"])
            }, le(be.shortName), 41, W7))), 128))
          ]),
          (i(), g(he, null, De(h, (be, de) => C("div", {
            key: be,
            class: W(["hp-week-scheduler__row hp-week-scheduler__row--hour", { "hp-week-scheduler__row--last": de === h.length - 1 }])
          }, [
            C("div", {
              class: "hp-week-scheduler__cell hp-week-scheduler__cell--hour-label",
              onMousedown: Fe((X) => re(be), ["stop"])
            }, le(H(be)), 41, U7),
            (i(!0), g(he, null, De(k.value, (X) => (i(), g("div", {
              key: X.id,
              "data-theme": te(X.id, be) ? "green" : "",
              class: W(["hp-week-scheduler__cell hp-week-scheduler__cell--time", {
                "hp-week-scheduler__cell--active": te(X.id, be)
              }]),
              onMousedown: (ne) => O(X.id, be, ne),
              onMouseenter: (ne) => z(X.id, be)
            }, null, 42, q7))), 128))
          ], 2)), 64))
        ], 64)) : (i(), g(he, { key: 1 }, [
          C("div", Z7, [
            oe[2] || (oe[2] = C("div", { class: "hp-week-scheduler__cell hp-week-scheduler__cell--day-label hp-week-scheduler__cell--corner" }, null, -1)),
            (i(), g(he, null, De(h, (be) => C("div", {
              key: be,
              class: "hp-week-scheduler__cell hp-week-scheduler__cell--hour-header",
              onMousedown: Fe((de) => re(be), ["stop"])
            }, [
              C("span", X7, le(H(be)), 1)
            ], 40, G7)), 64))
          ]),
          (i(!0), g(he, null, De(k.value, (be, de) => (i(), g("div", {
            key: be.id,
            class: W(["hp-week-scheduler__row hp-week-scheduler__row--day", { "hp-week-scheduler__row--last": de === k.value.length - 1 }]),
            onMousedown: (X) => D(be.id)
          }, [
            C("div", {
              class: "hp-week-scheduler__cell hp-week-scheduler__cell--day-label",
              onMousedown: Fe((X) => J(be.id), ["stop"])
            }, le(be.name), 41, J7),
            (i(), g(he, null, De(h, (X) => C("div", {
              key: X,
              "data-theme": te(be.id, X) ? "green" : "",
              class: W(["hp-week-scheduler__cell hp-week-scheduler__cell--time", {
                "hp-week-scheduler__cell--active": te(be.id, X)
              }]),
              onMousedown: (ne) => O(be.id, X, ne),
              onMouseenter: (ne) => z(be.id, X)
            }, null, 42, e_)), 64))
          ], 42, Q7))), 128))
        ], 64))
      ], 2),
      C("div", t_, [
        j(u(Hr), {
          modelValue: f.value,
          "onUpdate:modelValue": oe[0] || (oe[0] = (be) => f.value = be),
          options: o.value,
          placeholder: u(n)("ui.weekScheduler.timezone", "Timezone"),
          size: "2",
          width: "fit-content",
          "min-width": "280px",
          variant: "outline",
          radius: "full",
          clearable: !1
        }, null, 8, ["modelValue", "options", "placeholder"]),
        oe[3] || (oe[3] = C("span", { class: "hp-week-scheduler__divider" }, null, -1)),
        j(u(Ae), {
          variant: "outline",
          size: "2",
          radius: "full",
          onClick: ge
        }, {
          default: B(() => [
            me(le(u(n)("ui.weekScheduler.selectAll", "Select all")), 1)
          ]),
          _: 1
        }),
        j(u(Ae), {
          variant: "outline",
          size: "2",
          radius: "full",
          onClick: K
        }, {
          default: B(() => [
            me(le(u(n)("ui.weekScheduler.deselectAll", "Deselect all")), 1)
          ]),
          _: 1
        }),
        oe[4] || (oe[4] = C("span", { class: "hp-week-scheduler__divider" }, null, -1)),
        j(u(Ae), {
          variant: "outline",
          size: "2",
          radius: "full",
          onClick: U
        }, {
          default: B(() => [
            me(le(u(n)("ui.weekScheduler.primeTime", "Prime time")), 1)
          ]),
          _: 1
        }),
        j(u(Ae), {
          variant: "outline",
          size: "2",
          radius: "full",
          onClick: pe
        }, {
          default: B(() => [
            me(le(u(n)("ui.weekScheduler.weekdays", "Weekdays")), 1)
          ]),
          _: 1
        }),
        j(u(Ae), {
          variant: "outline",
          size: "2",
          radius: "full",
          onClick: ae
        }, {
          default: B(() => [
            me(le(u(n)("ui.weekScheduler.weekends", "Weekends")), 1)
          ]),
          _: 1
        }),
        j(u(Ae), {
          variant: "outline",
          size: "2",
          radius: "full",
          onClick: Ce
        }, {
          default: B(() => [
            me(le(u(n)("ui.weekScheduler.businessHours", "Business hours")), 1)
          ]),
          _: 1
        }),
        j(u(Ae), {
          variant: "outline",
          size: "2",
          radius: "full",
          onClick: q
        }, {
          default: B(() => [
            me(le(u(n)("ui.weekScheduler.nightHours", "Night hours")), 1)
          ]),
          _: 1
        })
      ])
    ], 544));
  }
}), ST = /* @__PURE__ */ se(n_, [["__scopeId", "data-v-d47ceec2"]]), o_ = {}, l_ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function r_(e, t) {
  return i(), g("svg", l_, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M7.5 16.9726C6.00458 16.9139 5.06837 16.7299 4.36493 16.1526C4.1759 15.9974 4.00256 15.8241 3.84743 15.6351C3 14.6025 3 13.0683 3 10C3 6.93168 3 5.39753 3.84743 4.36493C4.00256 4.1759 4.1759 4.00256 4.36493 3.84743C5.39753 3 6.93168 3 10 3C13.0683 3 14.6025 3 15.6351 3.84743C15.8241 4.00256 15.9974 4.1759 16.1526 4.36493C16.6627 4.98649 16.8657 5.78978 16.9465 7",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M15.0731 16.55L12.8581 14.3348L12.1814 15.011C11.4896 15.704 11.1431 16.0499 10.7708 15.9684C10.3984 15.8868 10.2291 15.4267 9.8905 14.5081L8.76161 11.4423C8.08609 9.60909 7.74748 8.69274 8.21995 8.22023C8.69243 7.74771 9.60926 8.08522 11.4429 8.76137L14.5084 9.88978C15.4269 10.2284 15.8864 10.3977 15.9686 10.7701C16.0507 11.1425 15.7042 11.4885 15.0112 12.1809L14.3351 12.8576L16.5502 15.0728C16.7797 15.3023 16.8944 15.4171 16.9473 15.5453C17.0176 15.7158 17.0176 15.907 16.9473 16.0781C16.8944 16.2057 16.7797 16.3205 16.5502 16.55C16.3207 16.7795 16.2059 16.8943 16.0777 16.9471C15.9071 17.0176 15.7156 17.0176 15.545 16.9471C15.4173 16.8943 15.3032 16.7795 15.0731 16.55Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const MT = /* @__PURE__ */ se(o_, [["render", r_]]), s_ = {}, i_ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function c_(e, t) {
  return i(), g("svg", i_, [...t[0] || (t[0] = [
    Nt('<path class="hp-icon" d="M8.70851 16.9971C6.47872 16.9806 5.24122 16.8717 4.36493 16.1526C4.1759 15.9974 4.00256 15.8241 3.84743 15.6351C3 14.6025 3 13.0683 3 10C3 6.93168 3 5.39753 3.84743 4.36493C4.00256 4.1759 4.1759 4.00256 4.36493 3.84743C5.39753 3 6.93168 3 10 3C13.0683 3 14.6025 3 15.6351 3.84743C15.8241 4.00256 15.9974 4.1759 16.1526 4.36493C16.849 5.21352 16.9731 6.40084 16.9952 8.5" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M15.0438 15.9691L14.6198 16.3928C14.1863 16.827 13.9693 17.0437 13.736 16.9926C13.5027 16.9415 13.3966 16.6532 13.1845 16.0777L12.4772 14.1568C12.0539 13.0082 11.8418 12.434 12.1378 12.138C12.4338 11.8419 13.0083 12.0534 14.1571 12.477L16.0777 13.1841C16.6532 13.3962 16.9411 13.5023 16.9926 13.7356C17.044 13.969 16.8269 14.1857 16.3928 14.6196L15.9692 15.0436L15.0438 15.9691Z" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M15.5 15.5L17 17" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M6 6L10 10" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M10 6L6 10" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const DT = /* @__PURE__ */ se(s_, [["render", c_]]), u_ = {}, d_ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function p_(e, t) {
  return i(), g("svg", d_, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M15 11.5L10 16.5L5 11.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10 2.5V15.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const TT = /* @__PURE__ */ se(u_, [["render", p_]]), f_ = {}, h_ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function v_(e, t) {
  return i(), g("svg", h_, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M12.5 5L17.5 10L12.5 15",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M3.5 10L16.5 10",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const BT = /* @__PURE__ */ se(f_, [["render", v_]]), m_ = {}, g_ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function y_(e, t) {
  return i(), g("svg", g_, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M10 5V15",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M14.33 7.5L5.67 12.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M5.67 7.5L14.33 12.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const zT = /* @__PURE__ */ se(m_, [["render", y_]]), w_ = {}, b_ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function k_(e, t) {
  return i(), g("svg", b_, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M13.7 7.06305C13.7 5.94894 13.2785 4.88047 12.5284 4.09267C11.7782 3.30488 10.7608 2.8623 9.69995 2.8623C8.63909 2.8623 7.62167 3.30488 6.87152 4.09267C6.12138 4.88047 5.69995 5.94894 5.69995 7.06305C5.69995 11.9639 3.69995 13.3642 3.69995 13.3642H15.7C15.7 13.3642 13.7 11.9639 13.7 7.06305Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10.8533 16.1647C10.7361 16.3769 10.5679 16.553 10.3654 16.6754C10.163 16.7979 9.93355 16.8623 9.69996 16.8623C9.46638 16.8623 9.23689 16.7979 9.03448 16.6754C8.83207 16.553 8.66384 16.3769 8.54663 16.1647",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const AT = /* @__PURE__ */ se(w_, [["render", k_]]), __ = {}, C_ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function x_(e, t) {
  return i(), g("svg", C_, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M2.5 10C2.5 6.71252 2.5 5.06878 3.40796 3.96243C3.57418 3.75989 3.75989 3.57418 3.96243 3.40796C5.06878 2.5 6.71252 2.5 10 2.5C13.2875 2.5 14.9312 2.5 16.0376 3.40796C16.2401 3.57418 16.4258 3.75989 16.592 3.96243C17.5 5.06878 17.5 6.71252 17.5 10C17.5 13.2875 17.5 14.9312 16.592 16.0376C16.4258 16.2401 16.2401 16.4258 16.0376 16.592C14.9312 17.5 13.2875 17.5 10 17.5C6.71252 17.5 5.06878 17.5 3.96243 16.592C3.75989 16.4258 3.57418 16.2401 3.40796 16.0376C2.5 14.9312 2.5 13.2875 2.5 10Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const LT = /* @__PURE__ */ se(__, [["render", x_]]), $_ = {}, S_ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function M_(e, t) {
  return i(), g("svg", S_, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M2.5 12H13.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M7.125 12L8.875 9",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M9.75 12L11.5 9",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M6 9H10C11.8856 9 12.8284 9 13.4142 9.58579C14 10.1716 14 11.1144 14 13V14C14 15.8856 14 16.8284 13.4142 17.4142C12.8284 18 11.8856 18 10 18H6C4.11438 18 3.17157 18 2.58579 17.4142C2 16.8284 2 15.8856 2 14V13C2 11.1144 2 10.1716 2.58579 9.58579C3.17157 9 4.11438 9 6 9ZM6 9V6C6 4.11438 6 3.17157 6.58579 2.58579C7.17157 2 8.11438 2 10 2H14C15.8856 2 16.8284 2 17.4142 2.58579C18 3.17157 18 4.11438 18 6V7C18 8.88562 18 9.82843 17.4142 10.4142C16.8284 11 15.8856 11 14 11M6 9L4.5 12",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const ET = /* @__PURE__ */ se($_, [["render", M_]]), D_ = {}, T_ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function B_(e, t) {
  return i(), g("svg", T_, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M17.4764 10.5949C17.3625 12.0263 16.8402 13.3948 15.9714 14.538C15.1025 15.6813 13.9239 16.551 12.5752 17.0439C11.2266 17.537 9.76487 17.6325 8.3636 17.3193C6.96233 17.0059 5.68045 16.2969 4.67025 15.2765C3.66005 14.2562 2.96399 12.9672 2.66478 11.5628C2.36557 10.1585 2.47578 8.69775 2.98232 7.3542C3.48885 6.01064 4.37042 4.84072 5.52229 3.98344C6.67416 3.12616 8.0479 2.61755 9.48032 2.51804",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M13.2193 11.2576C13.0109 11.7939 12.6722 12.2698 12.2337 12.6423C11.7951 13.0147 11.2707 13.272 10.7077 13.3909C10.1448 13.5097 9.5611 13.4864 9.00945 13.3229C8.4578 13.1595 7.95558 12.8611 7.54821 12.4548C7.14086 12.0485 6.84119 11.5471 6.67635 10.9958C6.51148 10.4446 6.48663 9.86095 6.60402 9.29771C6.72143 8.73445 6.97737 8.20934 7.34871 7.76987C7.72005 7.33039 8.19509 6.99042 8.73084 6.78067",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10 9.99999L12.8846 7.11538M12.8846 7.11538L14.7345 7.57786C15.0185 7.64886 15.3189 7.56565 15.5259 7.35867L16.4592 6.42535C16.9172 5.96733 16.7005 5.18475 16.0721 5.02765L15.6773 4.92896C15.3788 4.85432 15.1456 4.6212 15.071 4.32262L14.9723 3.92789C14.8152 3.29949 14.0326 3.08272 13.5746 3.54075L12.6413 4.47406C12.4343 4.68105 12.3511 4.98146 12.4221 5.26544L12.8846 7.11538Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const IT = /* @__PURE__ */ se(D_, [["render", B_]]), z_ = {}, A_ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function L_(e, t) {
  return i(), g("svg", A_, [...t[0] || (t[0] = [
    Nt('<path class="hp-icon" d="M7 16.1582C5.56445 16.1326 4.69349 16.0313 4 15.6309C3.39192 15.2799 2.88697 14.7749 2.5359 14.1668C2 13.2386 2 11.9925 2 9.50016C2 7.00785 2 5.7617 2.5359 4.8335C2.88697 4.22542 3.39192 3.72047 4 3.3694C4.9282 2.8335 6.17436 2.8335 8.66667 2.8335H10.3333C12.8256 2.8335 14.0718 2.8335 15 3.3694C15.6081 3.72047 16.113 4.22542 16.4641 4.8335C16.7223 5.28063 16.856 5.80154 16.9254 6.5" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M2 7H8.5" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M6.16663 2V3.66667" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M12.8334 2V3.66667" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M13.4332 11.3334V13.1667L14.7665 14" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M13.4332 18C16.1946 18 18.4332 15.7614 18.4332 13C18.4332 10.2386 16.1946 8 13.4332 8C10.6717 8 8.43317 10.2386 8.43317 13C8.43317 15.7614 10.6717 18 13.4332 18Z" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path>', 6)
  ])]);
}
const RT = /* @__PURE__ */ se(z_, [["render", L_]]), E_ = {}, I_ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function R_(e, t) {
  return i(), g("svg", I_, [...t[0] || (t[0] = [
    Nt('<path class="hp-icon" d="M10.4161 6.27063L15.25 14.6431" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M14.9968 14.2033L3.08087 16.9701L2.31767 15.6482L10.6719 6.7121" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M5.67299 16.3675L6.32913 17.5039C6.56716 17.9119 6.9575 18.2087 7.4143 18.3288C7.87107 18.4489 8.35689 18.3827 8.76485 18.1446C9.17282 17.9067 9.46952 17.5163 9.58968 17.0595C9.70983 16.6027 9.64362 16.1169 9.40559 15.7089L9.30051 15.527" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M10.7448 3.04414V1.47345" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M15.8894 8.18872H17.4601" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M4.02954 8.18872H5.60024" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M5.99644 3.44031L7.10709 4.55096" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M14.3826 4.55102L15.4933 3.44037" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path>', 8)
  ])]);
}
const PT = /* @__PURE__ */ se(E_, [["render", R_]]), P_ = {}, O_ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function V_(e, t) {
  return i(), g("svg", O_, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M7.37494 10.016L9.24995 11.891L13 8.14102",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const OT = /* @__PURE__ */ se(P_, [["render", V_]]), H_ = {}, N_ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function F_(e, t) {
  return i(), g("svg", N_, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M12.3438 7.65625L7.65625 12.3438",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M7.65625 7.65625L12.3438 12.3438",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const VT = /* @__PURE__ */ se(H_, [["render", F_]]), K_ = {}, Y_ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function j_(e, t) {
  return i(), g("svg", Y_, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M8.17194 8.01205C8.32316 7.58618 8.62165 7.22707 9.01453 6.99833C9.40741 6.76959 9.86934 6.68597 10.3185 6.76229C10.7676 6.83861 11.175 7.06995 11.4685 7.41532C11.762 7.76069 11.9226 8.19782 11.9219 8.64927C11.9219 9.9237 9.99226 10.5609 9.99226 10.5609",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10.0437 13.1098H10.0501",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const HT = /* @__PURE__ */ se(K_, [["render", j_]]), W_ = {}, U_ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function q_(e, t) {
  return i(), g("svg", U_, [...t[0] || (t[0] = [
    Nt('<path class="hp-icon" d="M14.0731 15.55L11.8581 13.3348L11.1814 14.011C10.4896 14.704 10.1431 15.0499 9.77076 14.9684C9.39841 14.8868 9.2291 14.4267 8.8905 13.5081L7.76161 10.4423C7.08609 8.60909 6.74748 7.69274 7.21995 7.22023C7.69243 6.74771 8.60926 7.08522 10.4429 7.76137L13.5084 8.88978C14.4269 9.22842 14.8864 9.39774 14.9686 9.77013C15.0507 10.1425 14.7042 10.4885 14.0112 11.1809L13.3351 11.8576L15.5502 14.0728C15.7797 14.3023 15.8944 14.4171 15.9473 14.5453C16.0176 14.7158 16.0176 14.907 15.9473 15.0781C15.8944 15.2057 15.7797 15.3205 15.5502 15.55C15.3207 15.7795 15.2059 15.8943 15.0777 15.9471C14.9071 16.0176 14.7156 16.0176 14.545 15.9471C14.4173 15.8943 14.3032 15.7795 14.0731 15.55Z" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M1 8.995H2.5H3.25" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M8.995 1L8.995 2.5L8.995 3.25" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M3.34668 3.3396L4.40734 4.40026L4.93767 4.93059" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M14.6533 3.33961L13.5926 4.40027L13.0623 4.9306" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M3.3396 14.6533L4.40026 13.5927L4.93059 13.0623" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path>', 6)
  ])]);
}
const NT = /* @__PURE__ */ se(W_, [["render", q_]]), Z_ = {}, G_ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function X_(e, t) {
  return i(), g("svg", G_, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M10 5.3125V10L12.8125 12.8125",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const FT = /* @__PURE__ */ se(Z_, [["render", X_]]), Q_ = {}, J_ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function eC(e, t) {
  return i(), g("svg", J_, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M13.3333 15L15.5049 12.8284C16.8382 11.4951 17.5049 10.8284 17.5049 10C17.5049 9.17157 16.8382 8.50491 15.5049 7.17157L13.3333 5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M6.66669 5L4.49511 7.17158C3.16178 8.50491 2.49512 9.17157 2.49512 10C2.49512 10.8284 3.16178 11.4951 4.49512 12.8284L6.66669 15",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10.8333 8.33334L8.33331 11.6667",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const KT = /* @__PURE__ */ se(Q_, [["render", eC]]), tC = {}, aC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function nC(e, t) {
  return i(), g("svg", aC, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M8.34845 3.35046C8.71334 1.54985 11.2867 1.54985 11.6516 3.35046C11.9535 4.83996 13.492 5.72826 14.9329 5.24492C16.6747 4.66062 17.9614 6.88923 16.5845 8.10555C15.4455 9.1117 15.4455 10.8883 16.5845 11.8945C17.9614 13.1108 16.6747 15.3394 14.9329 14.7551C13.492 14.2717 11.9535 15.16 11.6516 16.6495C11.2867 18.4502 8.71334 18.4502 8.34845 16.6495C8.0466 15.16 6.50803 14.2717 5.06716 14.7551C3.32533 15.3394 2.03864 13.1108 3.41557 11.8945C4.55459 10.8883 4.55459 9.11171 3.41557 8.10555C2.03864 6.88923 3.32533 4.66062 5.06716 5.24492C6.50803 5.72826 8.0466 4.83996 8.34845 3.35046Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M12.4231 9.9897C12.4231 11.3135 11.35 12.3866 10.02626 12.3866C8.70251 12.3866 7.62939 11.3135 7.62939 9.9897C7.62939 8.66595 8.70251 7.59283 10.02626 7.59283C11.35 7.59283 12.4231 8.66595 12.4231 9.9897Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const YT = /* @__PURE__ */ se(tC, [["render", nC]]), oC = {}, lC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function rC(e, t) {
  return i(), g("svg", lC, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.5 16.3889C2.5 16.0821 2.787 15.8333 3.14103 15.8333H10.1923C10.5463 15.8333 10.8333 16.0821 10.8333 16.3889V17.3333C10.8333 17.8856 10.3856 18.3333 9.83333 18.3333H3.5C2.94771 18.3333 2.5 17.8856 2.5 17.3333V16.3889Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M6.37115 7.42642C5.65405 8.14351 5.65405 9.30615 6.37115 10.0232L8.31009 11.9622C9.02718 12.6793 10.1898 12.6793 10.9069 11.9622L15.2955 7.57357C16.0126 6.85649 16.0126 5.69386 15.2955 4.97677L13.3566 3.03782C12.6395 2.32073 11.4768 2.32073 10.7598 3.03782L6.37115 7.42642Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M13.3333 10L18.3333 15",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M1.66667 18.3333L11.6667 18.3333",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const jT = /* @__PURE__ */ se(oC, [["render", rC]]), sC = {}, iC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function cC(e, t) {
  return i(), g("svg", iC, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M14.115 8.90743C14.7017 9.01694 15.2214 9.33275 15.5677 9.79009C15.914 10.2474 16.0605 10.8116 15.9772 11.367L15.2627 16.0556C15.223 16.3195 15.0822 16.5607 14.8667 16.7345C14.6513 16.9082 14.3757 17.0026 14.0915 16.9999H6.50219C6.26762 17.0002 6.03839 16.9343 5.84419 16.811C5.64999 16.6877 5.49977 16.5125 5.41298 16.3082L4.1598 13.3874C3.9453 12.8712 3.94679 12.2981 4.16399 11.7829C4.38119 11.2678 4.79804 10.8486 5.33099 10.6094L6.91211 9.86272V4.64705C6.91211 4.21023 7.0972 3.79129 7.42666 3.48241C7.75613 3.17353 8.20297 3 8.6689 3C9.13483 3 9.58168 3.17353 9.91115 3.48241C10.2406 3.79129 10.4257 4.21023 10.4257 4.64705L10.5 8.5L14.115 8.90743Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10.5 8.5V10",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M13 9V10.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const WT = /* @__PURE__ */ se(sC, [["render", cC]]), uC = {}, dC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function pC(e, t) {
  return i(), g("svg", dC, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M16.6667 10H15C14.0795 10 13.3333 10.7462 13.3333 11.6667V16.6667C13.3333 17.5871 14.0795 18.3333 15 18.3333H16.6667C17.5871 18.3333 18.3333 17.5871 18.3333 16.6667V11.6667C18.3333 10.7462 17.5871 10 16.6667 10Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10.3999 15.4482H7.3999C5.53614 15.4482 4.60425 15.4482 3.86917 15.1438C2.88906 14.7378 2.11036 13.9591 1.70438 12.979C1.3999 12.2439 1.3999 11.312 1.3999 9.44824C1.3999 7.58448 1.3999 6.65259 1.70438 5.91751C2.11036 4.9374 2.88906 4.1587 3.86917 3.75272C4.60425 3.44824 5.53614 3.44824 7.3999 3.44824H9.3999C11.2637 3.44824 12.1956 3.44824 12.9306 3.75272C13.9107 4.1587 14.6894 4.9374 15.0954 5.91751",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M3.8999 17.9482H10.8999",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const UT = /* @__PURE__ */ se(uC, [["render", pC]]), fC = {}, hC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function vC(e, t) {
  return i(), g("svg", hC, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M3 9C3 7.13623 3 6.20435 3.30448 5.46927C3.71046 4.48915 4.48915 3.71046 5.46927 3.30448C6.20435 3 7.13623 3 9 3H11C12.8638 3 13.7956 3 14.5307 3.30448C15.5108 3.71046 16.2895 4.48915 16.6955 5.46927C17 6.20435 17 7.13623 17 9C17 10.8638 17 11.7956 16.6955 12.5307C16.2895 13.5108 15.5108 14.2895 14.5307 14.6955C13.7956 15 12.8638 15 11 15H9C7.13623 15 6.20435 15 5.46927 14.6955C4.48915 14.2895 3.71046 13.5108 3.30448 12.5307C3 11.7956 3 10.8638 3 9Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M5.5 17.5H14.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const qT = /* @__PURE__ */ se(fC, [["render", vC]]), mC = {}, gC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function yC(e, t) {
  return i(), g("svg", gC, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M17.4996 8.80386C17.5 9.17787 17.5 9.57404 17.5 9.83334C17.5 13.1208 17.5 15.0979 16.592 16.2042C16.4258 16.4068 16.2401 16.5925 16.0376 16.7587C14.9312 17.6667 13.2875 17.6667 10 17.6667C6.71252 17.6667 5.06878 17.6667 3.96243 16.7587C3.75989 16.5925 3.57418 16.4068 3.40796 16.2042C2.5 15.0979 2.5 13.1208 2.5 9.83334C2.5 6.54586 2.5 4.90212 3.40796 3.79577C3.57418 3.59323 3.75989 3.40752 3.96243 3.2413C5.06878 2.33334 6.71252 2.33334 10 2.33334C10.4178 2.33334 10.8091 2.33334 11.1761 2.33521C11.5768 2.33724 11.7772 2.33826 11.9624 2.41708M17.4996 8.80386C17.4991 8.40911 17.4988 8.21173 17.4254 8.03118C17.352 7.85063 17.2137 7.70825 16.9369 7.42351L12.5743 2.93486C12.2898 2.64223 12.1476 2.49591 11.9624 2.41708M17.4996 8.80386C15.4926 8.76761 14.3172 8.12695 13.4624 7.42537C13.2598 7.25916 13.0741 7.07344 12.9079 6.87091C12.1683 5.96976 11.9879 4.62916 11.9624 2.41708",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const ZT = /* @__PURE__ */ se(mC, [["render", yC]]), wC = {}, bC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function kC(e, t) {
  return i(), g("svg", bC, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M6.1001 7.20703H8.92363",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M6.1001 10.207H11.2766",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M6.1001 13.207H14.1001",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M17.5997 9.01089C17.6001 9.3849 17.6001 9.78107 17.6001 10.0404C17.6001 13.3279 17.6001 15.3049 16.6921 16.4113C16.5259 16.6138 16.3402 16.7995 16.1377 16.9657C15.0313 17.8737 13.3876 17.8737 10.1001 17.8737C6.81262 17.8737 5.16887 17.8737 4.06252 16.9657C3.85999 16.7995 3.67427 16.6138 3.50806 16.4113C2.6001 15.3049 2.6001 13.3279 2.6001 10.0404C2.6001 6.75289 2.6001 5.10915 3.50806 4.0028C3.67427 3.80027 3.85999 3.61455 4.06252 3.44833C5.16887 2.54037 6.81262 2.54037 10.1001 2.54037C10.5179 2.54037 10.9092 2.54037 11.2762 2.54224C11.6769 2.54427 11.8773 2.54529 12.0625 2.62412M17.5997 9.01089C17.5992 8.61614 17.5989 8.41876 17.5255 8.23821C17.4521 8.05766 17.3137 7.91529 17.037 7.63054L12.6744 3.14189C12.3899 2.84926 12.2477 2.70294 12.0625 2.62412M17.5997 9.01089C15.5927 8.97464 14.4173 8.33398 13.5625 7.63241C13.3599 7.46619 13.1742 7.28047 13.008 7.07794C12.2684 6.17679 12.088 4.83619 12.0625 2.62412",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const GT = /* @__PURE__ */ se(wC, [["render", kC]]), _C = {}, CC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function xC(e, t) {
  return i(), g("svg", CC, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M6.75272 15.2488L12.2976 13.8623C13.5225 13.556 14.2494 12.381 13.9212 11.2378C13.593 10.0947 12.3339 9.4163 11.109 9.72261L8.89103 10.2772C7.6661 10.5835 6.40703 9.90513 6.07881 8.76199C5.75059 7.61885 6.47752 6.44384 7.70245 6.13754L13.2473 4.75101",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10 17.5L10 2.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const XT = /* @__PURE__ */ se(_C, [["render", xC]]), $C = {}, SC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function MC(e, t) {
  return i(), g("svg", SC, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M9.99999 12.5V2.5M14.1667 8.33333L9.99999 12.5L5.83333 8.33333",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const QT = /* @__PURE__ */ se($C, [["render", MC]]), DC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, JT = /* @__PURE__ */ Y({
  name: "EqualIcon",
  __name: "Equal",
  setup(e) {
    return (t, n) => (i(), g("svg", DC, [...n[0] || (n[0] = [
      C("path", {
        d: "M5 7H15M5 13H15",
        stroke: "var(--icon-color, currentColor)",
        "stroke-width": "var(--icon-stroke)",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ])]));
  }
}), TC = {}, BC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function zC(e, t) {
  return i(), g("svg", BC, [...t[0] || (t[0] = [
    C("path", {
      d: "M8 3V9.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round"
    }, null, -1),
    C("circle", {
      cx: "8",
      cy: "12.25",
      r: "1",
      fill: "var(--icon-fill, var(--icon-color, currentColor))"
    }, null, -1)
  ])]);
}
const eB = /* @__PURE__ */ se(TC, [["render", zC]]), AC = {}, LC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function EC(e, t) {
  return i(), g("svg", LC, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M10.1001 5V11.6667",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10.1001 14.4445V15",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const IC = /* @__PURE__ */ se(AC, [["render", EC]]), RC = {}, PC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function OC(e, t) {
  return i(), g("svg", PC, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M3.43694 12.6083C2.79738 11.7735 2.4776 11.3562 2.4776 10C2.4776 8.64384 2.79738 8.22645 3.43694 7.39168C5.02865 5.31413 7.37865 4 10 4C12.6214 4 14.9714 5.31413 16.5631 7.39168C17.2027 8.22645 17.5224 8.64384 17.5224 10C17.5224 11.3562 17.2027 11.7735 16.5631 12.6083C14.9714 14.6859 12.6214 16 10 16C7.37865 16 5.02865 14.6859 3.43694 12.6083Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M13 10C13 11.6569 11.6569 13 10 13C8.34315 13 7 11.6569 7 10C7 8.34315 8.34315 7 10 7C11.6569 7 13 8.34315 13 10Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const tB = /* @__PURE__ */ se(RC, [["render", OC]]), VC = {}, HC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function NC(e, t) {
  return i(), g("svg", HC, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M6.98541 8.60861C7.48673 9.1726 7.7374 9.45459 7.86796 9.79813C7.99852 10.1417 7.99841 10.5203 7.99821 11.2775C7.99783 12.6639 7.99998 14.2655 7.99998 15.3599C7.99998 16.0889 7.99998 16.4535 8.20288 16.7213C8.40578 16.9891 8.75668 17.0878 9.45849 17.2852C10.6246 17.6132 11.2077 17.7772 11.6038 17.4771C12 17.1769 12 16.5713 12 15.3599C12 14.2655 12.0021 12.6639 12.0018 11.2775C12.0016 10.5203 12.0015 10.1417 12.132 9.79812C12.2626 9.45458 12.5132 9.17259 13.0146 8.6086L15.0411 6.32873C16.314 4.8967 16.9505 4.18069 16.6854 3.59034C16.4203 3 15.4623 3 13.5463 3H6.45367C4.53768 3 3.57969 3 3.31459 3.59034C3.04948 4.18069 3.68594 4.8967 4.95885 6.32873L6.98541 8.60861Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M6 6.99999L7.88777 6.24488C8.25918 6.09632 8.6834 6.18339 8.96626 6.46625L9.03374 6.53373C9.3166 6.81659 9.74082 6.90366 10.1122 6.7551L11.5831 6.16677C11.8483 6.06069 12.1462 6.07308 12.4017 6.20082L14 6.99999",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const aB = /* @__PURE__ */ se(VC, [["render", NC]]), FC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, nB = /* @__PURE__ */ Y({
  name: "FlagIcon",
  __name: "Flag",
  setup(e) {
    return (t, n) => (i(), g("svg", FC, [...n[0] || (n[0] = [
      C("path", {
        class: "hp-icon",
        d: "M5 5a5 5 0 0 1 7 0a5 5 0 0 0 7 0v9a5 5 0 0 1-7 0a5 5 0 0 0-7 0zm0 16v-7",
        stroke: "var(--icon-color, currentColor)",
        "stroke-width": "var(--icon-stroke)",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, -1)
    ])]));
  }
}), KC = {}, YC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function jC(e, t) {
  return i(), g("svg", YC, [...t[0] || (t[0] = [
    C("g", { "clip-path": "url(#clip0_209_1433)" }, [
      C("path", {
        d: "M11.5267 13.8067C11.6988 13.8857 11.8927 13.9038 12.0764 13.8579C12.2602 13.812 12.4228 13.7048 12.5375 13.5542L12.8334 13.1667C12.9886 12.9597 13.1899 12.7917 13.4213 12.6759C13.6528 12.5602 13.9079 12.5 14.1667 12.5H16.6667C17.1087 12.5 17.5326 12.6756 17.8452 12.9881C18.1578 13.3007 18.3334 13.7246 18.3334 14.1667V16.6667C18.3334 17.1087 18.1578 17.5326 17.8452 17.8452C17.5326 18.1577 17.1087 18.3333 16.6667 18.3333C12.6884 18.3333 8.87313 16.753 6.06009 13.9399C3.24704 11.1269 1.66669 7.31157 1.66669 3.33332C1.66669 2.8913 1.84228 2.46737 2.15484 2.15481C2.4674 1.84225 2.89133 1.66666 3.33335 1.66666H5.83335C6.27538 1.66666 6.6993 1.84225 7.01186 2.15481C7.32443 2.46737 7.50002 2.8913 7.50002 3.33332V5.83332C7.50002 6.09206 7.43978 6.34725 7.32407 6.57868C7.20835 6.8101 7.04035 7.01141 6.83335 7.16666L6.44335 7.45916C6.29037 7.57597 6.18254 7.74214 6.13818 7.92945C6.09382 8.11675 6.11567 8.31364 6.20002 8.48666C7.33892 10.7999 9.21204 12.6707 11.5267 13.8067Z",
        stroke: "var(--icon-color, currentColor)",
        "stroke-width": "var(--icon-stroke)",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1),
    C("defs", null, [
      C("clipPath", { id: "clip0_209_1433" }, [
        C("rect", {
          width: "20",
          height: "20",
          fill: "white"
        })
      ])
    ], -1)
  ])]);
}
const oB = /* @__PURE__ */ se(KC, [["render", jC]]), WC = {}, UC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function qC(e, t) {
  return i(), g("svg", UC, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M16.2 8.45003C16.2 12.3196 11.9073 16.3495 10.4658 17.5942C10.3315 17.6951 10.168 17.7498 10 17.7498C9.832 17.7498 9.66853 17.6951 9.53424 17.5942C8.09276 16.3495 3.80007 12.3196 3.80007 8.45003C3.80007 6.80571 4.45328 5.22873 5.61599 4.06601C6.77871 2.9033 8.35569 2.25009 10 2.25009C11.6443 2.25009 13.2213 2.9033 14.384 4.06601C15.5467 5.22873 16.2 6.80571 16.2 8.45003Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10 10.775C11.2841 10.775 12.325 9.73403 12.325 8.44998C12.325 7.16593 11.2841 6.125 10 6.125C8.71595 6.125 7.67503 7.16593 7.67503 8.44998C7.67503 9.73403 8.71595 10.775 10 10.775Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const lB = /* @__PURE__ */ se(WC, [["render", qC]]), ZC = {}, GC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function XC(e, t) {
  return i(), g("svg", GC, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M15 17.5C16.3807 17.5 17.5 16.3807 17.5 15C17.5 13.6193 16.3807 12.5 15 12.5C13.6193 12.5 12.5 13.6193 12.5 15C12.5 16.3807 13.6193 17.5 15 17.5Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M5 7.5C6.38071 7.5 7.5 6.38071 7.5 5C7.5 3.61929 6.38071 2.5 5 2.5C3.61929 2.5 2.5 3.61929 2.5 5C2.5 6.38071 3.61929 7.5 5 7.5ZM5 7.5V17.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10.8333 5C10.9881 5 11.0654 5 11.1309 5.00214C13.2373 5.0711 14.9289 6.76267 14.9978 8.86912C15 8.93454 15 9.01192 15 9.16667V11.6667",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const rB = /* @__PURE__ */ se(ZC, [["render", XC]]), QC = {}, JC = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function e9(e, t) {
  return i(), g("svg", JC, [...t[0] || (t[0] = [
    Nt('<path class="hp-icon" d="M2.91669 7.16667L8.66609 3.78467C9.30709 3.4076 9.6276 3.21907 9.96657 3.2623C10.3055 3.30553 10.5685 3.56846 11.0943 4.09432L11.4419 4.44183C11.9514 4.95139 12.2062 5.20617 12.5355 5.2536C12.8648 5.30102 13.1811 5.12848 13.8138 4.78341L17.0834 3" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M5 12.5V17.5" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M7.5 11V17.5" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M12.5 10.5V17.5" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M15 9.50001L13.1031 9.86599C12.8038 9.93249 12.6542 9.96574 12.5038 9.95354C12.3533 9.94134 12.211 9.88442 11.9264 9.77057L10.9111 9.36443C10.4637 9.18549 10.2401 9.09602 10.0086 9.11355C9.77719 9.13108 9.56954 9.25323 9.15425 9.49752L3.90265 12.5867C3.42127 12.8699 3.18059 13.0114 3.04864 13.2421C2.91669 13.4728 2.91669 13.7521 2.91669 14.3106V16C2.91669 16.9428 2.91669 17.4142 3.20958 17.7071C3.50247 18 3.97388 18 4.91669 18H15M15 18C15.9428 18 16.4142 18 16.7071 17.7071C17 17.4142 17 16.9428 17 16V11.4932C17 10.3423 17 9.76681 16.6257 9.46658C16.2515 9.16635 16.1235 9.25033 15 9.50001M15 18V9.50001M10.0086 9.11355L10 17.5" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path>', 5)
  ])]);
}
const sB = /* @__PURE__ */ se(QC, [["render", e9]]), t9 = {}, a9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function n9(e, t) {
  return i(), g("svg", a9, [...t[0] || (t[0] = [
    C("path", {
      d: "M6 5L14 10L6 15",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const iB = /* @__PURE__ */ se(t9, [["render", n9]]), o9 = {}, l9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function r9(e, t) {
  return i(), g("svg", l9, [...t[0] || (t[0] = [
    C("path", {
      d: "M6 3L14 8L6 13M6 17H14",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const cB = /* @__PURE__ */ se(o9, [["render", r9]]), s9 = {}, i9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function c9(e, t) {
  return i(), g("svg", i9, [...t[0] || (t[0] = [
    C("path", {
      d: "M10 13.5C10.8284 13.5 11.5 14.1716 11.5 15C11.5 15.8284 10.8284 16.5 10 16.5C9.17157 16.5 8.5 15.8284 8.5 15C8.5 14.1716 9.17157 13.5 10 13.5Z",
      fill: "var(--icon-fill, var(--icon-color, currentColor))"
    }, null, -1),
    C("path", {
      d: "M10 8.5C10.8284 8.5 11.5 9.17157 11.5 10C11.5 10.8284 10.8284 11.5 10 11.5C9.17157 11.5 8.5 10.8284 8.5 10C8.5 9.17157 9.17157 8.5 10 8.5Z",
      fill: "var(--icon-fill, var(--icon-color, currentColor))"
    }, null, -1),
    C("path", {
      d: "M10 3.5C10.8284 3.5 11.5 4.17157 11.5 5C11.5 5.82843 10.8284 6.5 10 6.5C9.17157 6.5 8.5 5.82843 8.5 5C8.5 4.17157 9.17157 3.5 10 3.5Z",
      fill: "var(--icon-fill, var(--icon-color, currentColor))"
    }, null, -1)
  ])]);
}
const uB = /* @__PURE__ */ se(s9, [["render", c9]]), u9 = {}, d9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function p9(e, t) {
  return i(), g("svg", d9, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M10 7.083 2.601 14.482a1.768 1.768 0 1 0 2.5 2.5L12.5 9.583",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "m13.433 4.198 3.540 3.569c.538.542.808.814.897 1.131.063.225.063.463 0 .687-.089.317-.358.589-.897 1.132s-.808.814-1.122.903c-.223.063-.458.063-.681 0-.315-.089-.583-.361-1.123-.903l-5.695-5.743c-.862-.869-1.292-1.303-1.268-1.683.012-.187.085-.364.208-.505C7.542 2.5 8.15 2.5 9.369 2.5c.981 0 1.471 0 1.928.133q.356.104.679.283c.417.232.763.582 1.458 1.281Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const dB = /* @__PURE__ */ se(u9, [["render", p9]]), f9 = {}, h9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function v9(e, t) {
  return i(), g("svg", h9, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M4.45224 7.91959H15.5477",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M4.45224 12.0804H15.5477",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M8.61307 3.75879L7.22614 16.2412",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M12.7739 3.75879L11.3869 16.2412",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const pB = /* @__PURE__ */ se(f9, [["render", v9]]), m9 = {}, g9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function y9(e, t) {
  return i(), g("svg", g9, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M2.5 10.8262C2.5 9.36649 2.5 8.63662 2.7312 7.98646C2.88297 7.55965 3.10615 7.16173 3.39119 6.80966C3.8254 6.27336 4.44818 5.89277 5.69374 5.1316L6.08913 4.88997C7.86265 3.80615 8.74941 3.26424 9.72594 3.19717C9.90843 3.18464 10.0916 3.18464 10.2741 3.19717C11.2506 3.26424 12.1373 3.80615 13.9109 4.88997L14.3063 5.1316C15.5518 5.89277 16.1746 6.27336 16.6088 6.80966C16.8939 7.16173 17.117 7.55965 17.2688 7.98646C17.5 8.63662 17.5 9.36649 17.5 10.8262C17.5 13.3253 17.5 14.5748 16.9613 15.5048C16.6113 16.1091 16.1091 16.6113 15.5048 16.9613C14.5748 17.5 13.3253 17.5 10.8262 17.5H9.17378C6.67473 17.5 5.42521 17.5 4.49516 16.9613C3.89086 16.6113 3.38872 16.1091 3.03869 15.5048C2.5 14.5748 2.5 13.3253 2.5 10.8262Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M7.5 16.6667V13.3333C7.5 12.8687 7.5 12.6364 7.53843 12.4432C7.69624 11.6498 8.31644 11.0296 9.10982 10.8718C9.30302 10.8333 9.53534 10.8333 10 10.8333C10.4647 10.8333 10.697 10.8333 10.8902 10.8718C11.6836 11.0296 12.3038 11.6498 12.4616 12.4432C12.5 12.6364 12.5 12.8687 12.5 13.3333V16.6667",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const fB = /* @__PURE__ */ se(m9, [["render", y9]]), w9 = {}, b9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function k9(e, t) {
  return i(), g("svg", b9, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M6.86662 8.91975C7.78709 8.91975 8.53328 8.17357 8.53328 7.25309C8.53328 6.33262 7.78709 5.58643 6.86662 5.58643C5.94614 5.58643 5.19995 6.33262 5.19995 7.25309C5.19995 8.17357 5.94614 8.91975 6.86662 8.91975Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M3.60791 16.4858C2.69995 15.3795 2.69995 13.7357 2.69995 10.4482C2.69995 7.16076 2.69995 5.51702 3.60791 4.41067C3.77413 4.20813 3.95984 4.02242 4.16238 3.8562C5.26873 2.94824 6.91247 2.94824 10.2 2.94824C13.4874 2.94824 15.1312 2.94824 16.2375 3.8562C16.4401 4.02242 16.6258 4.20813 16.792 4.41067C17.7 5.51702 17.7 7.16076 17.7 10.4482C17.7 13.7357 17.7 15.3795 16.792 16.4858C16.6258 16.6884 16.4401 16.8741 16.2375 17.0403C15.1312 17.9482 13.4874 17.9482 10.2 17.9482C6.91247 17.9482 5.26873 17.9482 4.16238 17.0403C3.95984 16.8741 3.77413 16.6884 3.60791 16.4858ZM3.60791 16.4858L8.76957 11.8892C8.96518 11.6966 9.23005 11.5878 9.50665 11.5864C9.78324 11.5851 10.0492 11.6913 10.2467 11.8819L11.2953 13.058C11.6778 13.487 12.3424 13.506 12.7488 13.0996L17.5 8.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const hB = /* @__PURE__ */ se(w9, [["render", k9]]), _9 = {}, C9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function x9(e, t) {
  return i(), g("svg", C9, [...t[0] || (t[0] = [
    C("path", {
      d: "M2.5 10C2.5 6.71252 2.5 5.06878 3.40796 3.96243C3.57418 3.75989 3.75989 3.57418 3.96243 3.40796C5.06878 2.5 6.71252 2.5 10 2.5C13.2875 2.5 14.9312 2.5 16.0376 3.40796C16.2401 3.57418 16.4258 3.75989 16.592 3.96243C17.5 5.06878 17.5 6.71252 17.5 10C17.5 13.2875 17.5 14.9312 16.592 16.0376C16.4258 16.2401 16.2401 16.4258 16.0376 16.592C14.9312 17.5 13.2875 17.5 10 17.5C6.71252 17.5 5.06878 17.5 3.96243 16.592C3.75989 16.4258 3.57418 16.2401 3.40796 16.0376C2.5 14.9312 2.5 13.2875 2.5 10Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      d: "M12.9167 5.83333C13.149 5.83333 13.2652 5.83333 13.3618 5.85255C13.7584 5.93145 14.0685 6.24155 14.1475 6.63824C14.1667 6.73484 14.1667 6.85101 14.1667 7.08333C14.1667 7.31566 14.1667 7.43182 14.1475 7.52842C14.0685 7.92511 13.7584 8.23521 13.3618 8.31412C13.2652 8.33333 13.149 8.33333 12.9167 8.33333L7.91667 8.33333C7.68434 8.33333 7.56818 8.33333 7.47158 8.31412C7.07489 8.23521 6.76479 7.92511 6.68588 7.52842C6.66667 7.43182 6.66667 7.31566 6.66667 7.08333C6.66667 6.85101 6.66667 6.73484 6.68588 6.63824C6.76479 6.24155 7.07489 5.93145 7.47158 5.85255C7.56818 5.83333 7.68434 5.83333 7.91667 5.83333L12.9167 5.83333Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      d: "M12.9167 11.6667C13.149 11.6667 13.2652 11.6667 13.3618 11.6859C13.7584 11.7648 14.0685 12.0749 14.1475 12.4716C14.1667 12.5682 14.1667 12.6843 14.1667 12.9167C14.1667 13.149 14.1667 13.2652 14.1475 13.3618C14.0685 13.7584 13.7584 14.0685 13.3618 14.1475C13.2652 14.1667 13.149 14.1667 12.9167 14.1667H11.25C11.0177 14.1667 10.9015 14.1667 10.8049 14.1475C10.4082 14.0685 10.0981 13.7584 10.0192 13.3618C10 13.2652 10 13.149 10 12.9167C10 12.6843 10 12.5682 10.0192 12.4716C10.0981 12.0749 10.4082 11.7648 10.8049 11.6859C10.9015 11.6667 11.0177 11.6667 11.25 11.6667H12.9167Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const vB = /* @__PURE__ */ se(_9, [["render", x9]]), $9 = {}, S9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function M9(e, t) {
  return i(), g("svg", S9, [...t[0] || (t[0] = [
    Nt('<path class="hp-icon" d="M4.71375 6.97931L9.24481 11.5104" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M3.95859 11.5104L8.48965 6.97931L10 4.71378" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M2.44821 4.71378H11.5103" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M6.22412 2.44824H6.9793" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M17.5518 17.5518L13.7759 10L10 17.5518" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M11.5103 14.5311H16.0414" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path>', 6)
  ])]);
}
const mB = /* @__PURE__ */ se($9, [["render", M9]]), D9 = {}, T9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function B9(e, t) {
  return i(), g("svg", T9, [...t[0] || (t[0] = [
    Nt('<path class="hp-icon" d="M2.5 8.33334H17.5" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M5.83333 5.83334H6.66666" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M9.16667 5.83334H10" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M5.83333 11.6667H9.16666" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M5.83333 14.1667H9.16666" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M11.6667 11.6667H14.1667" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M11.6667 14.1667H14.1667" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M2.5 10C2.5 6.71252 2.5 5.06878 3.40796 3.96243C3.57418 3.75989 3.75989 3.57418 3.96243 3.40796C5.06878 2.5 6.71252 2.5 10 2.5C13.2875 2.5 14.9312 2.5 16.0376 3.40796C16.2401 3.57418 16.4258 3.75989 16.592 3.96243C17.5 5.06878 17.5 6.71252 17.5 10C17.5 13.2875 17.5 14.9312 16.592 16.0376C16.4258 16.2401 16.2401 16.4258 16.0376 16.592C14.9312 17.5 13.2875 17.5 10 17.5C6.71252 17.5 5.06878 17.5 3.96243 16.592C3.75989 16.4258 3.57418 16.2401 3.40796 16.0376C2.5 14.9312 2.5 13.2875 2.5 10Z" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path>', 8)
  ])]);
}
const gB = /* @__PURE__ */ se(D9, [["render", B9]]), z9 = {}, A9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function L9(e, t) {
  return i(), g("svg", A9, [...t[0] || (t[0] = [
    C("rect", {
      class: "hp-icon",
      x: "2",
      y: "4",
      width: "8",
      height: "12",
      rx: "1.5",
      fill: "var(--icon-color, currentColor)",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)"
    }, null, -1),
    C("rect", {
      class: "hp-icon",
      x: "11.5",
      y: "4",
      width: "6.5",
      height: "5.25",
      rx: "1.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      opacity: "0.45"
    }, null, -1),
    C("rect", {
      class: "hp-icon",
      x: "11.5",
      y: "10.75",
      width: "6.5",
      height: "5.25",
      rx: "1.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      opacity: "0.45"
    }, null, -1)
  ])]);
}
const yB = /* @__PURE__ */ se(z9, [["render", L9]]), E9 = {}, I9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function R9(e, t) {
  return i(), g("svg", I9, [...t[0] || (t[0] = [
    C("rect", {
      class: "hp-icon",
      x: "2",
      y: "3.5",
      width: "16",
      height: "5",
      rx: "1.5",
      fill: "var(--icon-color, currentColor)",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)"
    }, null, -1),
    C("rect", {
      class: "hp-icon",
      x: "2",
      y: "11.5",
      width: "16",
      height: "5",
      rx: "1.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      opacity: "0.45"
    }, null, -1)
  ])]);
}
const wB = /* @__PURE__ */ se(E9, [["render", R9]]), P9 = {}, O9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function V9(e, t) {
  return i(), g("svg", O9, [...t[0] || (t[0] = [
    C("path", {
      d: "M14 5L6 10L14 15",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const bB = /* @__PURE__ */ se(P9, [["render", V9]]), H9 = {}, N9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function F9(e, t) {
  return i(), g("svg", N9, [...t[0] || (t[0] = [
    C("path", {
      d: "M14 3L6 8L14 13M6 17H14",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const kB = /* @__PURE__ */ se(H9, [["render", F9]]), K9 = {}, Y9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function j9(e, t) {
  return i(), g("svg", Y9, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M8.49146 10.755C8.81537 11.1885 9.22863 11.5472 9.70321 11.8067C10.1778 12.0663 10.7026 12.2206 11.242 12.2593C11.7814 12.298 12.3228 12.22 12.8295 12.0309C13.3361 11.8417 13.7962 11.5456 14.1786 11.1627L16.4413 8.89769C17.1283 8.1857 17.5084 7.2321 17.4998 6.24229C17.4912 5.25247 17.0946 4.30563 16.3954 3.6057C15.6962 2.90577 14.7503 2.50874 13.7615 2.50014C12.7726 2.49154 11.82 2.87205 11.1087 3.55971L9.81141 4.85079",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M11.5085 9.24497C11.1846 8.81149 10.7713 8.45282 10.2968 8.19328C9.82219 7.93373 9.29741 7.77939 8.75801 7.74072C8.2186 7.70205 7.6772 7.77996 7.17052 7.96916C6.66385 8.15835 6.20374 8.45442 5.82142 8.83726L3.55865 11.1023C2.87167 11.8143 2.49155 12.7679 2.50014 13.7577C2.50874 14.7475 2.90536 15.6944 3.60458 16.3943C4.30381 17.0942 5.2497 17.4913 6.23852 17.4999C7.22734 17.5085 8.17997 17.128 8.89125 16.4403L10.181 15.1492",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const _B = /* @__PURE__ */ se(K9, [["render", j9]]), W9 = {}, U9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function q9(e, t) {
  return i(), g("svg", U9, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M6.66669 8.66668V5.66668C6.66669 4.78262 7.01788 3.93478 7.643 3.30965C8.26812 2.68453 9.11597 2.33334 10 2.33334C10.8841 2.33334 11.7319 2.68453 12.357 3.30965C12.9822 3.93478 13.3334 4.78262 13.3334 5.66668V8.66668",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M11.5 9H8.5C7.10218 9 6.40326 9 5.85195 9.22836C5.11687 9.53284 4.53284 10.1169 4.22836 10.8519C4 11.4033 4 12.1022 4 13.5C4 14.8978 4 15.5967 4.22836 16.1481C4.53284 16.8831 5.11687 17.4672 5.85195 17.7716C6.40326 18 7.10218 18 8.5 18H11.5C12.8978 18 13.5967 18 14.1481 17.7716C14.8831 17.4672 15.4672 16.8831 15.7716 16.1481C16 15.5967 16 14.8978 16 13.5C16 12.1022 16 11.4033 15.7716 10.8519C15.4672 10.1169 14.8831 9.53284 14.1481 9.22836C13.5967 9 12.8978 9 11.5 9Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10.8333 13.5C10.8333 13.9142 10.4975 14.25 10.0833 14.25C9.6691 14.25 9.33331 13.9142 9.33331 13.5C9.33331 13.0858 9.6691 12.75 10.0833 12.75C10.4975 12.75 10.8333 13.0858 10.8333 13.5Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const Yr = /* @__PURE__ */ se(W9, [["render", q9]]), Z9 = {}, G9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function X9(e, t) {
  return i(), g("svg", G9, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M6.66669 8.66668V5.66668C6.66669 4.78262 7.01788 3.93478 7.643 3.30965C8.26812 2.68453 9.11597 2.33334 10 2.33334C10.8841 2.33334 11.7319 2.68453 12.357 3.30965C12.6977 3.65035 12.9571 4.0572 13.1225 4.50001",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M11.5 9H8.5C7.10218 9 6.40326 9 5.85195 9.22836C5.11687 9.53284 4.53284 10.1169 4.22836 10.8519C4 11.4033 4 12.1022 4 13.5C4 14.8978 4 15.5967 4.22836 16.1481C4.53284 16.8831 5.11687 17.4672 5.85195 17.7716C6.40326 18 7.10218 18 8.5 18H11.5C12.8978 18 13.5967 18 14.1481 17.7716C14.8831 17.4672 15.4672 16.8831 15.7716 16.1481C16 15.5967 16 14.8978 16 13.5C16 12.1022 16 11.4033 15.7716 10.8519C15.4672 10.1169 14.8831 9.53284 14.1481 9.22836C13.5967 9 12.8978 9 11.5 9Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10.0833 14.25C10.4975 14.25 10.8333 13.9142 10.8333 13.5C10.8333 13.0858 10.4975 12.75 10.0833 12.75C9.6691 12.75 9.33331 13.0858 9.33331 13.5C9.33331 13.9142 9.6691 14.25 10.0833 14.25Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const CB = /* @__PURE__ */ se(Z9, [["render", X9]]), Q9 = {}, J9 = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function ex(e, t) {
  return i(), g("svg", J9, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M17.5 9.58334V10C17.5 13.2875 17.5 14.9312 16.592 16.0376C16.4258 16.2401 16.2401 16.4258 16.0376 16.5921C14.9312 17.5 13.2875 17.5 10 17.5C6.71252 17.5 5.06878 17.5 3.96243 16.5921C3.75989 16.4258 3.57418 16.2401 3.40796 16.0376C2.5 14.9312 2.5 13.2875 2.5 10V9.58334",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M3.64357 2.5H16.3564C16.5182 2.5 16.6661 2.59145 16.7384 2.73621L19.1223 6.67322C19.1619 6.75236 19.1768 6.84135 19.1596 6.92816C18.4702 10.3971 14.617 10.0386 13.3819 7.2711C13.152 8.8154 11.8211 10 10.2136 10C10.1418 10 10.0706 9.99765 9.99999 9.99301C9.9294 9.99765 9.85818 10 9.78643 10C8.17893 10 6.84803 8.8154 6.6181 7.2711C5.38298 10.0386 1.52975 10.3971 0.840415 6.92816C0.828736 6.86931 0.831812 6.80943 0.84735 6.75236C0.854702 6.72523 0.864921 6.69873 0.877643 6.67322L3.26154 2.73621C3.33386 2.59145 3.48178 2.5 3.64357 2.5Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M6.66667 17.5V15.9849C6.66667 14.9209 6.66667 14.3889 6.98768 14.0067C7.12665 13.8413 7.30522 13.6992 7.5132 13.5887C7.99362 13.3333 8.66242 13.3333 10 13.3333C11.3376 13.3333 12.0064 13.3333 12.4868 13.5887C12.6948 13.6992 12.8734 13.8413 13.0123 14.0067C13.3333 14.3889 13.3333 14.9209 13.3333 15.9849V17.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const xB = /* @__PURE__ */ se(Q9, [["render", ex]]), tx = {}, ax = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function nx(e, t) {
  return i(), g("svg", ax, [...t[0] || (t[0] = [
    C("path", {
      d: "M3.5 5H16.5M3.5 10H16.5M3.5 15H16.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const $B = /* @__PURE__ */ se(tx, [["render", nx]]), ox = {}, lx = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function rx(e, t) {
  return i(), g("svg", lx, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M17.3 9.56627C17.3029 10.6662 17.0459 11.7512 16.55 12.7329C15.9621 13.9094 15.0582 14.8989 13.9396 15.5907C12.821 16.2824 11.5319 16.6491 10.2167 16.6496C9.11682 16.6525 8.03181 16.3955 7.05005 15.8996L4.19741 16.8505C3.41565 17.1111 2.67192 16.3673 2.9325 15.5856L3.88338 12.7329C3.38749 11.7512 3.13051 10.6662 3.13338 9.56627C3.13389 8.25106 3.50056 6.96198 4.19231 5.84339C4.88407 4.72481 5.87359 3.82091 7.05005 3.23293C8.03181 2.73704 9.11682 2.48007 10.2167 2.48293H10.6334C12.3703 2.57876 14.0109 3.3119 15.241 4.54198C16.4711 5.77206 17.2042 7.41264 17.3 9.1496V9.56627Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M8 6.48291H10.8235",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M8 9.48291H13.1765",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M8 12.4829H11.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const SB = /* @__PURE__ */ se(ox, [["render", rx]]), sx = {}, ix = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function cx(e, t) {
  return i(), g("svg", ix, [...t[0] || (t[0] = [
    C("path", {
      d: "M17.4192 11.4083C17.2517 13.22 16.3717 14.9258 14.8817 16.1408C11.7692 18.6783 7.19004 18.2058 4.65254 15.0933C2.11504 11.9808 2.5867 7.40169 5.6992 4.86419C6.90504 3.88085 8.31337 3.30419 9.75087 3.11169C9.29587 4.32419 9.18337 5.65085 9.44087 6.94502C9.7092 8.28502 10.3617 9.55419 11.4067 10.5583C12.4517 11.5625 13.7292 12.1567 15.0517 12.3517C15.8442 12.4683 16.6484 12.4467 17.4192 11.4083Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const MB = /* @__PURE__ */ se(sx, [["render", cx]]), ux = {}, dx = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function px(e, t) {
  return i(), g("svg", dx, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M6.25 10H13.75",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const DB = /* @__PURE__ */ se(ux, [["render", px]]), fx = {}, hx = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function vx(e, t) {
  return i(), g("svg", hx, [...t[0] || (t[0] = [
    C("path", {
      d: "M5 7H15M5 13H15M13 3L7 17",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const TB = /* @__PURE__ */ se(fx, [["render", vx]]), mx = {}, gx = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function yx(e, t) {
  return i(), g("svg", gx, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M14.5956 2.4964L3.59562 4.76737C2.66651 4.95918 2 5.77736 2 6.72606V14.6475C2 15.6725 2.775 16.5316 3.79464 16.6369L14.7946 17.7724C15.9742 17.8941 17 16.9687 17 15.7829V4.45509C17 3.18794 15.8366 2.2402 14.5956 2.4964Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M9.17391 4V10.0104M9.17391 10.0104L9.17391 17M9.17391 10.0104L2 10.24M9.17391 10.0104L17 9.76",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const BB = /* @__PURE__ */ se(mx, [["render", yx]]), wx = {}, bx = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function kx(e, t) {
  return i(), g("svg", bx, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M8.28571 14.962C8.28571 15.5233 7.82279 15.984 7.2637 15.9342C6.46686 15.8633 5.90222 15.7117 5.4389 15.3865C5.1165 15.1603 4.83598 14.8792 4.61021 14.5561C3.99971 13.6836 4 12.4508 4 9.98577C4 7.52078 3.99971 6.28868 4.61021 5.41542C4.83598 5.09237 5.1165 4.81128 5.4389 4.58505C5.90188 4.25979 6.46661 4.10779 7.26371 4.03664C7.82279 3.98673 8.28571 4.44735 8.28571 5.00865V14.962Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M11.7143 5.00865C11.7143 4.44735 12.1772 3.98673 12.7363 4.03666C13.5331 4.10782 14.0978 4.25983 14.5611 4.58505C14.8835 4.81128 15.164 5.09237 15.3898 5.41542C16.0003 6.28793 16 7.52078 16 9.98577C16 12.4508 16.0003 13.6828 15.3898 14.5561C15.164 14.8792 14.8835 15.1603 14.5611 15.3865C14.0981 15.7117 13.5334 15.8633 12.7363 15.9342C12.1772 15.9839 11.7143 15.5233 11.7143 14.962V5.00865Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const zB = /* @__PURE__ */ se(wx, [["render", kx]]), _x = {}, Cx = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function xx(e, t) {
  return i(), g("svg", Cx, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M11.5 5L15.5 9",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M3.39603 13.7439C3.31966 14.8458 3.28147 15.3967 3.44921 15.8193C3.65251 16.3315 4.0581 16.7371 4.57026 16.9404C4.99284 17.1081 5.54378 17.0699 6.64564 16.9935C7.031 16.9668 7.22367 16.9535 7.40541 16.9058C7.62618 16.8479 7.83541 16.7526 8.02404 16.6241C8.17931 16.5183 8.31588 16.3818 8.58902 16.1086L16.2355 8.46215C16.9252 7.77248 17.27 7.42765 17.4224 7.0398C17.6073 6.56953 17.6073 6.04671 17.4224 5.57644C17.27 5.18859 16.9252 4.84375 16.2355 4.15409C15.5458 3.46443 15.201 3.1196 14.8131 2.96714C14.3429 2.78228 13.8201 2.78228 13.3498 2.96714C12.9619 3.1196 12.6171 3.46443 11.9274 4.15409L4.28097 11.8006C4.00783 12.0737 3.87126 12.2103 3.76547 12.3655C3.63696 12.5542 3.54168 12.7634 3.48377 12.9842C3.4361 13.1659 3.42274 13.3586 3.39603 13.7439ZM3.39603 13.7439C5.16381 14.8046 5.80571 15.0155 6.51281 16.4298",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const AB = /* @__PURE__ */ se(_x, [["render", xx]]), $x = {}, Sx = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Mx(e, t) {
  return i(), g("svg", Sx, [...t[0] || (t[0] = [
    Nt('<path class="hp-icon" d="M10.7414 6.29395L7.55406 3.1066C7.2193 2.77345 6.76623 2.58643 6.29395 2.58643C5.82166 2.58643 5.3686 2.77345 5.03383 3.1066L3.1066 5.03383C2.77345 5.3686 2.58643 5.82166 2.58643 6.29395C2.58643 6.76623 2.77345 7.2193 3.1066 7.55406L6.29395 10.7414" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M7.03522 5.55268L8.51771 4.07019" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M14.4476 12.9652L15.9301 11.4827" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M13.7064 9.25891L16.8937 12.4463C17.5905 13.143 17.5905 14.2697 16.8937 14.9665L14.9665 16.8937C14.2697 17.5905 13.143 17.5905 12.4463 16.8937L9.25891 13.7064" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M16.8003 6.15455C17.1922 5.76275 17.4124 5.23131 17.4125 4.67714C17.4126 4.12298 17.1925 3.59148 16.8007 3.19958C16.4089 2.80768 15.8775 2.58747 15.3233 2.5874C14.7691 2.58733 14.2376 2.80741 13.8457 3.19921L3.95309 13.0941C3.78099 13.2657 3.65371 13.477 3.58247 13.7093L2.60329 16.9352C2.58413 16.9993 2.58268 17.0674 2.5991 17.1323C2.61552 17.1971 2.64918 17.2563 2.69653 17.3036C2.74388 17.3509 2.80314 17.3844 2.86803 17.4008C2.93291 17.4171 3.00101 17.4155 3.06508 17.3963L6.29172 16.4178C6.52385 16.3472 6.73511 16.2207 6.90695 16.0494L16.8003 6.15455Z" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M12.2239 4.81146L15.1889 7.77644" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path>', 6)
  ])]);
}
const LB = /* @__PURE__ */ se($x, [["render", Mx]]), Dx = {}, Tx = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Bx(e, t) {
  return i(), g("svg", Tx, [...t[0] || (t[0] = [
    C("circle", {
      cx: "8",
      cy: "8",
      r: "7",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)"
    }, null, -1),
    C("circle", {
      cx: "8",
      cy: "8",
      r: "2",
      fill: "var(--icon-fill, var(--icon-color, currentColor))"
    }, null, -1)
  ])]);
}
const EB = /* @__PURE__ */ se(Dx, [["render", Bx]]), zx = {}, Ax = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Lx(e, t) {
  return i(), g("svg", Ax, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M11.3603 17.2529C10.8651 16.7576 10.8651 15.9547 11.3603 15.4595L15.4595 11.3603C15.9547 10.8651 16.7576 10.8651 17.2529 11.3603C17.7481 11.8555 17.7481 12.6585 17.2529 13.1537L13.1537 17.2529C12.6585 17.7481 11.8555 17.7481 11.3603 17.2529Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M3.34936 3.34936C4.10622 2.59249 5.43666 2.85858 8.09754 3.39076L10.6015 3.89154C11.5424 4.07973 12.0129 4.17382 12.4206 4.35577C13.2347 4.71906 13.9041 5.34391 14.3226 6.1311C14.5322 6.52535 14.6584 6.98823 14.9109 7.91398C15.1488 8.78626 15.2677 9.2224 15.291 9.64569C15.3376 10.4905 15.1151 11.3282 14.6556 12.0386C14.4253 12.3945 13.9928 12.827 13.3535 13.4663C12.7142 14.1056 12.3945 14.4253 12.0386 14.6556C11.3282 15.1151 10.4905 15.3376 9.64569 15.291C9.2224 15.2677 8.78626 15.1488 7.91398 14.9109C6.98824 14.6584 6.52535 14.5322 6.1311 14.3226C5.34391 13.9041 4.71906 13.2347 4.35577 12.4206C4.17382 12.0129 4.07973 11.5424 3.89154 10.6015L3.39076 8.09755C2.85858 5.43666 2.59249 4.10622 3.34936 3.34936ZM3.34936 3.34936L8.69587 8.69587M8.69587 8.69587C8.045 9.34675 8.045 10.402 8.69587 11.0529C9.34675 11.7038 10.402 11.7038 11.0529 11.0529C11.7038 10.402 11.7038 9.34675 11.0529 8.69587C10.402 8.045 9.34675 8.045 8.69587 8.69587Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const IB = /* @__PURE__ */ se(zx, [["render", Lx]]), Ex = {}, Ix = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Rx(e, t) {
  return i(), g("svg", Ix, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M6.35623 8.01248C7.27096 8.01248 8.01249 7.27095 8.01249 6.35622C8.01249 5.44149 7.27096 4.69995 6.35623 4.69995C5.4415 4.69995 4.69996 5.44149 4.69996 6.35622C4.69996 7.27095 5.4415 8.01248 6.35623 8.01248Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M13.6438 15.3C14.5585 15.3 15.3 14.5585 15.3 13.6438C15.3 12.7291 14.5585 11.9875 13.6438 11.9875C12.7291 11.9875 11.9875 12.7291 11.9875 13.6438C11.9875 14.5585 12.7291 15.3 13.6438 15.3Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M14.7 4.75879L4.69995 14.7588",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const RB = /* @__PURE__ */ se(Ex, [["render", Rx]]), Px = {}, Ox = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Vx(e, t) {
  return i(), g("svg", Ox, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M5.83386 5.33364C5.8338 5.09905 5.89176 4.8686 6.0019 4.66554C6.11204 4.46249 6.27046 4.29404 6.46116 4.17718C6.65186 4.06033 6.86808 3.99921 7.08801 4.00001C7.30793 4.0008 7.52377 4.06348 7.71372 4.18172L15.2113 8.84674C15.4005 8.96385 15.5576 9.13189 15.6668 9.33405C15.7761 9.53621 15.8337 9.76541 15.8339 9.99876C15.8341 10.2321 15.7768 10.4614 15.6679 10.6638C15.559 10.8661 15.4022 11.0345 15.2131 11.1519L7.71372 15.8183C7.52377 15.9365 7.30793 15.9992 7.08801 16C6.86808 16.0008 6.65186 15.9397 6.46116 15.8228C6.27046 15.706 6.11204 15.5375 6.0019 15.3345C5.89176 15.1314 5.8338 14.9009 5.83386 14.6664V5.33364Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const PB = /* @__PURE__ */ se(Px, [["render", Vx]]), Hx = {}, Nx = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Fx(e, t) {
  return i(), g("svg", Nx, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M2.5 10C2.5 11.4834 2.93987 12.9334 3.76398 14.1668C4.58809 15.4001 5.75943 16.3614 7.12987 16.9291C8.50032 17.4968 10.0083 17.6453 11.4632 17.3559C12.918 17.0665 14.2544 16.3522 15.3033 15.3033C16.3522 14.2544 17.0665 12.918 17.3559 11.4632C17.6453 10.0083 17.4968 8.50032 16.9291 7.12987C16.3614 5.75943 15.4001 4.58809 14.1668 3.76398C12.9334 2.93987 11.4834 2.5 10 2.5C7.90329 2.50789 5.89081 3.32602 4.38333 4.78333L2.5 6.66667M6.66667 6.66667H2.5V2.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const OB = /* @__PURE__ */ se(Hx, [["render", Fx]]), Kx = {}, Yx = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function jx(e, t) {
  return i(), g("svg", Yx, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M11 5.18158C11 4.35315 10.3284 3.68158 9.5 3.68158C8.67157 3.68158 8 4.35315 8 5.18158C8 6.01001 8.67157 6.68158 9.5 6.68158C10.3284 6.68158 11 6.01001 11 5.18158ZM11 5.18158L14 5.18158C15.1046 5.18158 16 6.07701 16 7.18158L16 9.18158",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M14.5 8.68159L15.3674 9.54891C15.7168 9.89833 16.2833 9.89833 16.6327 9.54891L17.5 8.68159",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10.0731 16.55L7.8581 14.3348L7.18144 15.011C6.4896 15.704 6.14312 16.0499 5.77076 15.9684C5.39841 15.8868 5.2291 15.4267 4.8905 14.5081L3.76161 11.4423C3.08609 9.60909 2.74748 8.69274 3.21995 8.22023C3.69243 7.74771 4.60926 8.08522 6.44292 8.76137L9.50839 9.88978C10.4269 10.2284 10.8864 10.3977 10.9686 10.7701C11.0507 11.1425 10.7042 11.4885 10.0112 12.1809L9.33515 12.8576L11.5502 15.0728C11.7797 15.3023 11.8944 15.4171 11.9473 15.5453C12.0176 15.7158 12.0176 15.907 11.9473 16.0781C11.8944 16.2057 11.7797 16.3205 11.5502 16.55C11.3207 16.7795 11.2059 16.8943 11.0777 16.9471C10.9071 17.0176 10.7156 17.0176 10.545 16.9471C10.4173 16.8943 10.3032 16.7795 10.0731 16.55Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const VB = /* @__PURE__ */ se(Kx, [["render", jx]]), Wx = {}, Ux = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function qx(e, t) {
  return i(), g("svg", Ux, [...t[0] || (t[0] = [
    Nt('<path class="hp-icon" fill-rule="evenodd" clip-rule="evenodd" d="M16.5 16.3889C16.5 16.0821 16.213 15.8333 15.859 15.8333H8.8077C8.45367 15.8333 8.16667 16.0821 8.16667 16.3889V17.3333C8.16667 17.8856 8.61439 18.3333 9.16667 18.3333H15.5C16.0523 18.3333 16.5 17.8856 16.5 17.3333V16.3889Z" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M10.5697 8.94114C11.1434 9.51481 11.1434 10.4449 10.5697 11.0186L9.01859 12.5697C8.44492 13.1434 7.51481 13.1434 6.94114 12.5697L3.43026 9.05886C2.85658 8.48519 2.85658 7.55509 3.43026 6.98141L4.98141 5.43025C5.55508 4.85658 6.48519 4.85658 7.05886 5.43025L10.5697 8.94114Z" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M5 11L1 15" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M17.3333 18.3333L7.33334 18.3333" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M15 8V2" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M18 5L12 5" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path>', 6)
  ])]);
}
const HB = /* @__PURE__ */ se(Wx, [["render", qx]]), Zx = {}, Gx = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Xx(e, t) {
  return i(), g("svg", Gx, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M12.4889 3C12.8992 3.00584 13.2906 3.17358 13.5778 3.46667L16.5333 6.42222C16.8264 6.70943 16.9942 7.1008 17 7.51111V15.4444C17 15.857 16.8361 16.2527 16.5444 16.5444C16.2527 16.8361 15.857 17 15.4444 17H4.55556C4.143 17 3.74733 16.8361 3.45561 16.5444C3.16389 16.2527 3 15.857 3 15.4444V4.55556C3 4.143 3.16389 3.74733 3.45561 3.45561C3.74733 3.16389 4.143 3 4.55556 3H12.4889Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M13.8889 17V11.5555C13.8889 11.3493 13.8069 11.1514 13.6611 11.0056C13.5152 10.8597 13.3174 10.7778 13.1111 10.7778H6.88886C6.68258 10.7778 6.48475 10.8597 6.33889 11.0056C6.19303 11.1514 6.11108 11.3493 6.11108 11.5555V17",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M6.11108 3V6.11111C6.11108 6.31739 6.19303 6.51522 6.33889 6.66108C6.48475 6.80694 6.68258 6.88889 6.88886 6.88889H12.3333",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const NB = /* @__PURE__ */ se(Zx, [["render", Xx]]), Qx = {}, Jx = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function e$(e, t) {
  return i(), g("svg", Jx, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M7.5 3H12.4889C12.8992 3.00584 13.2906 3.17358 13.5778 3.46667L16.5333 6.42222C16.8264 6.70942 16.9942 7.1008 17 7.51111V13",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M16.5444 16.5444C16.2527 16.8361 15.857 17 15.4444 17H13.8889M13.8889 17H6.11111M13.8889 17V14.2778M6.11111 17H4.55556C4.143 17 3.74733 16.8361 3.45561 16.5444C3.16389 16.2527 3 15.857 3 15.4444V4.55554C3 4.14298 3.16389 3.74732 3.45561 3.4556M6.11111 17V11.5555C6.11111 11.3493 6.19306 11.1514 6.33892 11.0056C6.48478 10.8597 6.68261 10.7778 6.88889 10.7778H10.5056",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M10.8889 6.88889H12.3334",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M2 2L18 18",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const FB = /* @__PURE__ */ se(Qx, [["render", e$]]), t$ = {}, a$ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function n$(e, t) {
  return i(), g("svg", a$, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M13.5 13.5L16.5 16.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const KB = /* @__PURE__ */ se(t$, [["render", n$]]), o$ = {}, l$ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function r$(e, t) {
  return i(), g("svg", l$, [...t[0] || (t[0] = [
    Nt('<path class="hp-icon" d="M8 14L8 14.5C8 16.3856 8 16.8284 8.58579 17.4142C9.17157 18 10.1144 18 12 18H13C14.8856 18 15.8284 18 16.4142 17.4142C17 16.8284 17 16.8856 17 15" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M11 7.5V6C11 4.11438 11 3.17157 10.4142 2.58579C9.82843 2 8.88562 2 7 2L5.5 2C3.61438 2 3.17157 2 2.58579 2.58579C2 3.17157 2 4.11438 2 6L2 10C2 11.8856 2 12.8284 2.58579 13.4142C3.17157 14 3.61438 14 5.5 14" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M7.91421 5.55054L5.49939 6.19758C4.96593 6.34053 4.64935 6.88886 4.79229 7.42233C4.93523 7.9558 5.48357 8.27238 6.01703 8.12944L6.98296 7.87062C7.51642 7.72768 8.06476 8.04426 8.2077 8.57772C8.35064 9.11119 8.03406 9.65953 7.5006 9.80247L5.08578 10.4495" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M6.5 4.5V11.5" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M15.5 6C16.3284 6 17 5.32843 17 4.5C17 3.67157 16.3284 3 15.5 3C14.6716 3 14 3.67157 14 4.5C14 5.32843 14.6716 6 15.5 6ZM15.5 6V11C15.5 12.1046 14.6046 13 13.5 13H11.5" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M12 11.5L11.1327 12.3673C10.7833 12.7167 10.7833 13.2833 11.1327 13.6327L12 14.5" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path>', 6)
  ])]);
}
const YB = /* @__PURE__ */ se(o$, [["render", r$]]), s$ = {}, i$ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function c$(e, t) {
  return i(), g("svg", i$, [...t[0] || (t[0] = [
    C("g", { transform: "translate(0.5 0)" }, [
      C("path", {
        d: "M7.68364 6.26227C8.39304 4.07897 8.74774 2.98732 9.38693 2.91459C9.46206 2.90604 9.53793 2.90604 9.61306 2.91459C10.2523 2.98732 10.607 4.07897 11.3164 6.26227C11.5131 6.86772 11.6114 7.17045 11.839 7.35637C11.8683 7.38027 11.8989 7.4025 11.9306 7.42294C12.1778 7.58194 12.4961 7.58193 13.1327 7.58193C15.4284 7.58193 16.5762 7.58194 16.8429 8.16737C16.8742 8.23618 16.8977 8.30833 16.9128 8.38243C17.0411 9.01282 16.1125 9.6875 14.2553 11.0368C13.7403 11.411 13.4827 11.5981 13.3762 11.872C13.3626 11.9072 13.3509 11.9432 13.3413 11.9797C13.2664 12.2639 13.3648 12.5667 13.5615 13.1721C14.2709 15.3554 14.6256 16.4471 14.1512 16.8816C14.0955 16.9327 14.0341 16.9773 13.9683 17.0145C13.4084 17.3314 12.4798 16.6567 10.6226 15.3074C10.1075 14.9332 9.85003 14.7461 9.55662 14.7294C9.5189 14.7273 9.48109 14.7273 9.44337 14.7294C9.14996 14.7461 8.89245 14.9332 8.37743 15.3074C6.5202 16.6567 5.59159 17.3314 5.03172 17.0145C4.9659 16.9773 4.90453 16.9327 4.84877 16.8816C4.3744 16.4471 4.7291 15.3554 5.4385 13.1721C5.63522 12.5667 5.73358 12.2639 5.65874 11.9797C5.64912 11.9432 5.63744 11.9072 5.62375 11.872C5.51725 11.5981 5.25974 11.411 4.74471 11.0368C2.88749 9.6875 1.95887 9.01282 2.08722 8.38243C2.1023 8.30833 2.12575 8.23618 2.1571 8.16737C2.4238 7.58194 3.57163 7.58193 5.86728 7.58193C6.50389 7.58193 6.82219 7.58194 7.06935 7.42294C7.10112 7.4025 7.13171 7.38027 7.16097 7.35637C7.38856 7.17045 7.48692 6.86772 7.68364 6.26227Z",
        stroke: "var(--icon-color, currentColor)",
        "stroke-width": "var(--icon-stroke)",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])]);
}
const jB = /* @__PURE__ */ se(s$, [["render", c$]]), u$ = {}, d$ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function p$(e, t) {
  return i(), g("svg", d$, [...t[0] || (t[0] = [
    C("g", { transform: "translate(0.5 0)" }, [
      C("path", {
        d: "M7.68364 6.26227C8.39304 4.07897 8.74774 2.98732 9.38693 2.91459C9.46206 2.90604 9.53793 2.90604 9.61306 2.91459C10.2523 2.98732 10.607 4.07897 11.3164 6.26227C11.5131 6.86772 11.6114 7.17045 11.839 7.35637C11.8683 7.38027 11.8989 7.4025 11.9306 7.42294C12.1778 7.58194 12.4961 7.58193 13.1327 7.58193C15.4284 7.58193 16.5762 7.58194 16.8429 8.16737C16.8742 8.23618 16.8977 8.30833 16.9128 8.38243C17.0411 9.01282 16.1125 9.6875 14.2553 11.0368C13.7403 11.411 13.4827 11.5981 13.3762 11.872C13.3626 11.9072 13.3509 11.9432 13.3413 11.9797C13.2664 12.2639 13.3648 12.5667 13.5615 13.1721C14.2709 15.3554 14.6256 16.4471 14.1512 16.8816C14.0955 16.9327 14.0341 16.9773 13.9683 17.0145C13.4084 17.3314 12.4798 16.6567 10.6226 15.3074C10.1075 14.9332 9.85003 14.7461 9.55662 14.7294C9.5189 14.7273 9.48109 14.7273 9.44337 14.7294C9.14996 14.7461 8.89245 14.9332 8.37743 15.3074C6.5202 16.6567 5.59159 17.3314 5.03172 17.0145C4.9659 16.9773 4.90453 16.9327 4.84877 16.8816C4.3744 16.4471 4.7291 15.3554 5.4385 13.1721C5.63522 12.5667 5.73358 12.2639 5.65874 11.9797C5.64912 11.9432 5.63744 11.9072 5.62375 11.872C5.51725 11.5981 5.25974 11.411 4.74471 11.0368C2.88749 9.6875 1.95887 9.01282 2.08722 8.38243C2.1023 8.30833 2.12575 8.23618 2.1571 8.16737C2.4238 7.58194 3.57163 7.58193 5.86728 7.58193C6.50389 7.58193 6.82219 7.58194 7.06935 7.42294C7.10112 7.4025 7.13171 7.38027 7.16097 7.35637C7.38856 7.17045 7.48692 6.86772 7.68364 6.26227Z",
        fill: "var(--icon-fill, var(--icon-color, currentColor))",
        stroke: "var(--icon-color, currentColor)",
        "stroke-width": "var(--icon-stroke)",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      })
    ], -1)
  ])]);
}
const WB = /* @__PURE__ */ se(u$, [["render", p$]]), f$ = {}, h$ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function v$(e, t) {
  return i(), g("svg", h$, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M2.91669 8.33332L8.66609 4.95132C9.30709 4.57426 9.6276 4.38573 9.96657 4.42896C10.3055 4.47218 10.5685 4.73511 11.0943 5.26098L11.4419 5.60849C11.9514 6.11805 12.2062 6.37283 12.5355 6.42025C12.8648 6.46768 13.1811 6.29514 13.8138 5.95007L17.0834 4.16666",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M9 10.4166C9 10.1843 9 10.0681 9.01922 9.97154C9.09812 9.57485 9.40822 9.26475 9.80491 9.18584C9.90151 9.16663 10.0177 9.16663 10.25 9.16663C10.4823 9.16663 10.5985 9.16663 10.6951 9.18584C11.0918 9.26475 11.4019 9.57485 11.4808 9.97154C11.5 10.0681 11.5 10.1843 11.5 10.4166V15.4166C11.5 15.649 11.5 15.7651 11.4808 15.8617C11.4019 16.2584 11.0918 16.5685 10.6951 16.6474C10.5985 16.6666 10.4823 16.6666 10.25 16.6666C10.0177 16.6666 9.90151 16.6666 9.80491 16.6474C9.40822 16.5685 9.09812 16.2584 9.01922 15.8617C9 15.7651 9 15.649 9 15.4166V10.4166Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M4 13.75C4 13.5177 4 13.4015 4.01921 13.3049C4.09812 12.9082 4.40822 12.5981 4.80491 12.5192C4.90151 12.5 5.01767 12.5 5.25 12.5C5.48233 12.5 5.59849 12.5 5.69509 12.5192C6.09178 12.5981 6.40188 12.9082 6.48079 13.3049C6.5 13.4015 6.5 13.5177 6.5 13.75V15.4167C6.5 15.649 6.5 15.7652 6.48079 15.8618C6.40188 16.2584 6.09178 16.5685 5.69509 16.6475C5.59849 16.6667 5.48233 16.6667 5.25 16.6667C5.01767 16.6667 4.90151 16.6667 4.80491 16.6475C4.40822 16.5685 4.09812 16.2584 4.01921 15.8618C4 15.7652 4 15.649 4 15.4167V13.75Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M14 12.0834C14 11.851 14 11.7349 14.0192 11.6383C14.0981 11.2416 14.4082 10.9315 14.8049 10.8526C14.9015 10.8334 15.0177 10.8334 15.25 10.8334C15.4823 10.8334 15.5985 10.8334 15.6951 10.8526C16.0918 10.9315 16.4019 11.2416 16.4808 11.6383C16.5 11.7349 16.5 11.851 16.5 12.0834V15.4167C16.5 15.649 16.5 15.7652 16.4808 15.8618C16.4019 16.2585 16.0918 16.5686 15.6951 16.6475C15.5985 16.6667 15.4823 16.6667 15.25 16.6667C15.0177 16.6667 14.9015 16.6667 14.8049 16.6475C14.4082 16.5686 14.0981 16.2585 14.0192 15.8618C14 15.7652 14 15.649 14 15.4167V12.0834Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const UB = /* @__PURE__ */ se(f$, [["render", v$]]), m$ = {}, g$ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function y$(e, t) {
  return i(), g("svg", g$, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M4 10C4 7.54 4 6.31075 4.6105 5.43925C4.8363 5.11678 5.11678 4.8363 5.43925 4.6105C6.31 4 7.54 4 10 4C12.46 4 13.6892 4 14.5607 4.6105C14.8832 4.8363 15.1637 5.11678 15.3895 5.43925C16 6.31 16 7.54 16 10C16 12.46 16 13.6892 15.3895 14.5607C15.1637 14.8832 14.8832 15.1637 14.5607 15.3895C13.69 16 12.46 16 10 16C7.54 16 6.31075 16 5.43925 15.3895C5.11678 15.1637 4.8363 14.8832 4.6105 14.5607C4 13.69 4 12.46 4 10Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const qB = /* @__PURE__ */ se(m$, [["render", y$]]), w$ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 47 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, b$ = ["mask"], di = "sub-table-bottom-mask", ZB = /* @__PURE__ */ Y({
  __name: "SubTableBottom",
  setup(e) {
    return (t, n) => (i(), g("svg", w$, [
      C("mask", {
        id: di,
        fill: "white"
      }, [...n[0] || (n[0] = [
        C("path", { d: "M0 0H47V48H0V0Z" }, null, -1)
      ])]),
      C("path", {
        d: "M0 0V1H47V0V-1H0V0Z",
        fill: "var(--icon-fill, var(--icon-color, currentColor))",
        mask: `url(#${di})`
      }, null, 8, b$),
      n[1] || (n[1] = C("path", {
        d: "M24 0V24",
        stroke: "var(--icon-color, currentColor)",
        "stroke-width": "var(--icon-stroke)",
        "stroke-dasharray": "2 2"
      }, null, -1)),
      n[2] || (n[2] = C("path", {
        d: "M42.5 24H25.5",
        stroke: "var(--icon-color, currentColor)",
        "stroke-width": "var(--icon-stroke)",
        "stroke-dasharray": "2 2"
      }, null, -1))
    ]));
  }
}), k$ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 47 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, _$ = ["clip-path"], C$ = ["mask"], pi = "sub-table-top-clip", fi = "sub-table-top-mask", GB = /* @__PURE__ */ Y({
  __name: "SubTableTop",
  setup(e) {
    return (t, n) => (i(), g("svg", k$, [
      C("g", {
        "clip-path": `url(#${pi})`
      }, [
        C("mask", {
          id: fi,
          fill: "white"
        }, [...n[0] || (n[0] = [
          C("path", { d: "M0 0H47V48H0V0Z" }, null, -1)
        ])]),
        n[1] || (n[1] = C("path", {
          d: "M24 0V70",
          stroke: "var(--icon-color, currentColor)",
          "stroke-width": "var(--icon-stroke)",
          "stroke-dasharray": "2 2"
        }, null, -1)),
        n[2] || (n[2] = C("path", {
          d: "M42.5 24H25.5",
          stroke: "var(--icon-color, currentColor)",
          "stroke-width": "var(--icon-stroke)",
          "stroke-dasharray": "2 2"
        }, null, -1))
      ], 8, _$),
      C("path", {
        d: "M0 0V1H47V0V-1H0V0Z",
        fill: "var(--icon-fill, var(--icon-color, currentColor))",
        mask: `url(#${fi})`
      }, null, 8, C$),
      C("defs", null, [
        C("clipPath", { id: pi }, [...n[3] || (n[3] = [
          C("path", {
            d: "M0 0H47V48H0V0Z",
            fill: "white"
          }, null, -1)
        ])])
      ])
    ]));
  }
}), x$ = {}, $$ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function S$(e, t) {
  return i(), g("svg", $$, [...t[0] || (t[0] = [
    C("path", {
      d: "M10 1.66669V3.33335M10 16.6667V18.3334M3.33335 10H1.66669M5.34169 5.34169L4.16252 4.16252M14.6584 5.34169L15.8375 4.16252M5.34169 14.6625L4.16252 15.8375M14.6584 14.6625L15.8375 15.8375M18.3334 10H16.6667M14.1667 10C14.1667 12.3012 12.3012 14.1667 10 14.1667C7.69885 14.1667 5.83335 12.3012 5.83335 10C5.83335 7.69885 7.69885 5.83335 10 5.83335C12.3012 5.83335 14.1667 7.69885 14.1667 10Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const XB = /* @__PURE__ */ se(x$, [["render", S$]]), M$ = {}, D$ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function T$(e, t) {
  return i(), g("svg", D$, [...t[0] || (t[0] = [
    Nt('<path class="hp-icon" d="M6 12H2" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M6 15H2" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M6 3L6 17M6 3H18M6 3C4.11438 3 3.17157 3 2.58579 3.58579C2 4.17157 2 5.11438 2 7V17" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M10 3V6H2" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M14 3V4" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M6 9H2" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M12.8061 7.60806C13.065 6.33076 14.8904 6.33076 15.1493 7.60806C15.3634 8.66467 16.4548 9.2948 17.4769 8.95193C18.7125 8.53745 19.6253 10.1184 18.6485 10.9812C17.8405 11.6949 17.8405 12.9552 18.6485 13.6689C19.6253 14.5317 18.7125 16.1126 17.4769 15.6982C16.4548 15.3553 15.3634 15.9854 15.1493 17.042C14.8904 18.3193 13.065 18.3193 12.8061 17.042C12.592 15.9854 11.5006 15.3553 10.4785 15.6982C9.24287 16.1126 8.33013 14.5317 9.30689 13.6689C10.1149 12.9552 10.1149 11.6949 9.30689 10.9812C8.33013 10.1184 9.24287 8.53745 10.4785 8.95193C11.5006 9.2948 12.592 8.66467 12.8061 7.60806Z" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M15.6966 12.3178C15.6966 13.2568 14.9354 14.018 13.9963 14.018C13.0573 14.018 12.2961 13.2568 12.2961 12.3178C12.2961 11.3787 13.0573 10.6175 13.9963 10.6175C14.9354 10.6175 15.6966 11.3787 15.6966 12.3178Z" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path>', 8)
  ])]);
}
const QB = /* @__PURE__ */ se(M$, [["render", T$]]), B$ = {}, z$ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function A$(e, t) {
  return i(), g("svg", z$, [...t[0] || (t[0] = [
    Nt('<g clip-path="url(#clip0_3275_25914)"><path class="hp-icon" d="M9.99998 16.6667C13.6819 16.6667 16.6666 13.6819 16.6666 10C16.6666 6.31811 13.6819 3.33334 9.99998 3.33334C6.31808 3.33334 3.33331 6.31811 3.33331 10C3.33331 13.6819 6.31808 16.6667 9.99998 16.6667Z" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M10 1.66666V5.37878" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M10 14.6212V18.3333" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M18.3333 10H14.6212" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M5.37881 10H1.66669" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M9.99998 11.6667C10.9205 11.6667 11.6666 10.9205 11.6666 10C11.6666 9.07954 10.9205 8.33334 9.99998 8.33334C9.0795 8.33334 8.33331 9.07954 8.33331 10C8.33331 10.9205 9.0795 11.6667 9.99998 11.6667Z" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_3275_25914"><rect width="20" height="20" fill="white"></rect></clipPath></defs>', 2)
  ])]);
}
const JB = /* @__PURE__ */ se(B$, [["render", A$]]), L$ = {}, E$ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function I$(e, t) {
  return i(), g("svg", E$, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M9.99999 2.5V12.5M5.83333 6.66667L9.99999 2.5L14.1667 6.66667",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const ez = /* @__PURE__ */ se(L$, [["render", I$]]), R$ = {}, P$ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function O$(e, t) {
  return i(), g("svg", P$, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M10 7.5C11.3807 7.5 12.5 6.38071 12.5 5C12.5 3.61929 11.3807 2.5 10 2.5C8.61929 2.5 7.5 3.61929 7.5 5C7.5 6.38071 8.61929 7.5 10 7.5Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M5 16.6667V15C5 12.2386 7.23858 10 10 10C12.7614 10 15 12.2386 15 15V16.6667",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const tz = /* @__PURE__ */ se(R$, [["render", O$]]), V$ = {}, H$ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function N$(e, t) {
  return i(), g("svg", H$, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M7.5 7.5C8.88071 7.5 10 6.38071 10 5C10 3.61929 8.88071 2.5 7.5 2.5C6.11929 2.5 5 3.61929 5 5C5 6.38071 6.11929 7.5 7.5 7.5Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M2.5 16.6667V15C2.5 12.2386 4.73858 10 7.5 10C10.2614 10 12.5 12.2386 12.5 15V16.6667",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M12.5 2.5C13.8807 2.5 15 3.61929 15 5C15 6.38071 13.8807 7.5 12.5 7.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M14.1667 10.2845C16.1087 10.9709 17.5 12.823 17.5 15V16.6667",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const az = /* @__PURE__ */ se(V$, [["render", N$]]), F$ = {}, K$ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Y$(e, t) {
  return i(), g("svg", K$, [...t[0] || (t[0] = [
    Nt('<path class="hp-icon" d="M4.83331 3.08643V17.0864" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M15.1667 3.08643V17.0864" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M1.80005 6.25H4.83333" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M1.80005 13.75H4.83333" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M15.1667 6.25H17.8001" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M15.1667 13.75H17.8001" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path><path class="hp-icon" d="M1.30005 10L18.3 10M1.30005 10C1.30005 13.2875 1.30005 15.0176 2.20801 16.124C2.37422 16.3265 2.55994 16.5123 2.76248 16.6785C3.86883 17.5864 5.51257 17.5864 8.80005 17.5864H10.8C14.0875 17.5864 15.7313 17.5864 16.8376 16.6785C17.0402 16.5123 17.2259 16.3265 17.3921 16.124C18.3 15.0176 18.3 13.2875 18.3 10M1.30005 10C1.30005 6.71252 1.30005 5.1552 2.20801 4.04885C2.37422 3.84632 2.55994 3.6606 2.76248 3.49438C3.86883 2.58643 5.51257 2.58643 8.80005 2.58643H10.8C14.0875 2.58643 15.7313 2.58643 16.8376 3.49438C17.0402 3.6606 17.2259 3.84632 17.3921 4.04885C18.3 5.1552 18.3 6.71252 18.3 10" stroke="var(--icon-color, currentColor)" stroke-width="var(--icon-stroke)" stroke-linecap="round" stroke-linejoin="round"></path>', 7)
  ])]);
}
const nz = /* @__PURE__ */ se(F$, [["render", Y$]]), j$ = {}, W$ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function U$(e, t) {
  return i(), g("svg", W$, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M2.5 7.5H17.5",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    C("path", {
      class: "hp-icon",
      d: "M2.5 10.8333V9.16667C2.5 6.02397 2.5 4.45262 3.47631 3.47631C4.45262 2.5 6.02397 2.5 9.16666 2.5H10.8333C13.976 2.5 15.5474 2.5 16.5237 3.47631C17.5 4.45262 17.5 6.02397 17.5 9.16667V10.8333C17.5 13.976 17.5 15.5474 16.5237 16.5237C15.5474 17.5 13.976 17.5 10.8333 17.5H9.16666M2.5 10.8333C3.05317 10.3794 3.77292 10.8333 5.41666 10.8333C7.06041 10.8333 8.15951 11.1106 8.71269 11.5645C9.16666 12.1177 9.16666 12.5229 9.16666 14.1667M2.5 10.8333C2.39873 10.9164 2.20375 11.4633 2.12064 11.5645C1.66666 12.1177 1.66666 12.9396 1.66666 14.5833C1.66666 16.2271 1.66666 17.0489 2.12064 17.6021C2.67382 18.0561 3.77292 18.3333 5.41666 18.3333C7.06041 18.3333 7.88228 18.3333 8.43545 17.8794C8.53672 17.7962 9.08355 17.6013 9.16666 17.5M9.16666 17.5C9.62064 16.9468 9.16666 15.8104 9.16666 14.1667M2.5 14.1667H9.16666",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const oz = /* @__PURE__ */ se(j$, [["render", U$]]), q$ = {}, Z$ = {
  width: "100%",
  height: "100%",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function G$(e, t) {
  return i(), g("svg", Z$, [...t[0] || (t[0] = [
    C("path", {
      class: "hp-icon",
      d: "M10.5016 4.19422C10.6264 3.20546 9.38622 2.66252 8.74442 3.42498L4.43432 8.54537C3.33936 9.84619 4.2641 11.8333 5.96441 11.8333H10L9.49844 15.8058C9.3736 16.7945 10.6138 17.3375 11.2556 16.575L15.5657 11.4546C16.6607 10.1538 15.7359 8.16666 14.0356 8.16666H10L10.5016 4.19422Z",
      stroke: "var(--icon-color, currentColor)",
      "stroke-width": "var(--icon-stroke)",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])]);
}
const lz = /* @__PURE__ */ se(q$, [["render", G$]]), X$ = (e) => {
  const t = /* @__PURE__ */ new Set();
  return e.filter((n) => t.has(n.key) ? !1 : (t.add(n.key), !0));
}, Lo = (e) => e.reorderable !== !1 && e.sticky === void 0, Q$ = (e) => {
  if (e === null)
    return null;
  try {
    const t = JSON.parse(e);
    if (typeof t != "object" || t === null)
      return null;
    const n = t;
    return n.version !== 1 || !Array.isArray(n.orderKeys) || !n.orderKeys.every((a) => typeof a == "string") || new Set(n.orderKeys).size !== n.orderKeys.length ? null : n.orderKeys;
  } catch {
    return null;
  }
}, J$ = (e, t) => {
  const n = [...e];
  for (let a = 0; a < t.length; a += 1) {
    const o = t[a];
    if (o === void 0 || n.includes(o))
      continue;
    const l = t.slice(a + 1).find((c) => n.includes(c));
    if (l !== void 0) {
      n.splice(n.indexOf(l), 0, o);
      continue;
    }
    const r = [...t.slice(0, a)].reverse().find((c) => n.includes(c));
    if (r !== void 0) {
      n.splice(n.indexOf(r) + 1, 0, o);
      continue;
    }
    n.push(o);
  }
  return n;
}, wl = (e, t) => {
  const n = new Set(t.map((r) => r.key)), a = e.filter((r, c) => n.has(r) && e.indexOf(r) === c), o = [];
  let l = 0;
  for (; l < t.length; ) {
    const r = t[l];
    if (r === void 0) {
      l += 1;
      continue;
    }
    if (!Lo(r)) {
      o.push(r.key), l += 1;
      continue;
    }
    const c = [];
    let s = l;
    for (; s < t.length; ) {
      const f = t[s];
      if (f === void 0 || !Lo(f))
        break;
      c.push(f.key), s += 1;
    }
    const p = new Set(c), d = a.filter((f) => p.has(f));
    o.push(...J$(d, c)), l = s;
  }
  return o;
}, rz = (e) => {
  const t = m(() => X$(Ne(e.columns))), n = m(() => Ne(e.storageKey)), a = () => {
    const b = n.value;
    if (b === void 0 || typeof globalThis.localStorage > "u")
      return null;
    try {
      return Q$(globalThis.localStorage.getItem(b));
    } catch {
      return null;
    }
  }, o = a() ?? t.value.map((b) => b.key), l = N(o), r = N(wl(o, t.value)), c = () => {
    const b = n.value;
    if (!(b === void 0 || typeof globalThis.localStorage > "u"))
      try {
        const k = { version: 1, orderKeys: r.value };
        globalThis.localStorage.setItem(b, JSON.stringify(k));
      } catch {
      }
  };
  Se(
    [t, n],
    ([b, k], [, _]) => {
      k !== _ && (l.value = a() ?? b.map((T) => T.key)), r.value = wl(l.value, b);
    },
    { deep: !0 }
  );
  const s = () => new Map(t.value.map((b) => [b.key, b])), p = (b, k, _) => {
    let T = b, S = T + k;
    for (; S >= 0 && S < r.value.length; ) {
      const M = _.get(r.value[S] ?? "");
      if (M === void 0 || !Lo(M))
        break;
      T = S, S += k;
    }
    return T;
  }, d = (b) => {
    const k = s(), _ = k.get(b);
    if (_ === void 0 || !Lo(_))
      return [];
    const T = r.value.indexOf(b);
    if (T < 0)
      return [];
    const S = p(T, -1, k), M = p(T, 1, k);
    return r.value.slice(S, M + 1);
  }, f = (b) => {
    const k = new Map(b.map((S) => [S.key, S])), _ = r.value.flatMap((S) => {
      const M = k.get(S);
      return M === void 0 ? [] : [M];
    }), T = new Set(r.value);
    return [..._, ...b.filter((S) => !T.has(S.key))];
  }, h = (b, k) => {
    const _ = d(b), T = _.indexOf(b);
    return T >= 0 && T + k >= 0 && T + k < _.length;
  }, $ = (b) => {
    const k = new Set(b), _ = l.value.filter((T) => !k.has(T));
    l.value = [...b, ..._];
  }, y = (b) => {
    const k = wl(b, t.value);
    r.value = k, $(k), c();
  }, w = (b, k, _) => {
    if (b === k || !d(b).includes(k))
      return;
    const S = [...r.value], M = S.indexOf(b);
    if (M < 0)
      return;
    S.splice(M, 1);
    const E = S.indexOf(k);
    E < 0 || (S.splice(E + (_ === "after" ? 1 : 0), 0, b), r.value = S, $(S), c());
  }, v = (b, k) => {
    const _ = d(b), T = _.indexOf(b), S = _[T + k];
    T < 0 || S === void 0 || w(b, S, k < 0 ? "before" : "after");
  }, x = () => {
    r.value = t.value.map((k) => k.key);
    const b = new Set(r.value);
    l.value = l.value.filter((k) => !b.has(k)), c();
  };
  return {
    orderKeys: Kl(r),
    order: f,
    canMove: h,
    setOrder: y,
    move: w,
    moveBy: v,
    reset: x
  };
}, eS = (e) => {
  if (typeof e != "object" || e === null)
    return null;
  const t = {};
  for (const [n, a] of Object.entries(e)) {
    if (typeof a != "number" || !Number.isFinite(a) || a <= 0)
      return null;
    t[n] = a;
  }
  return t;
}, tS = (e) => {
  if (e === null)
    return null;
  try {
    const t = JSON.parse(e);
    if (typeof t != "object" || t === null)
      return null;
    const { version: n, widths: a } = t;
    return n === 1 ? eS(a) : null;
  } catch {
    return null;
  }
}, sz = (e = {}) => {
  const t = m(() => Ne(e.storageKey)), n = () => {
    const l = t.value;
    if (l === void 0 || typeof globalThis.localStorage > "u")
      return null;
    try {
      return tS(globalThis.localStorage.getItem(l));
    } catch {
      return null;
    }
  }, a = N(n() ?? {});
  Se(t, () => {
    a.value = n() ?? {};
  });
  const o = (l) => {
    a.value = l;
    const r = t.value;
    if (!(r === void 0 || typeof globalThis.localStorage > "u"))
      try {
        const c = { version: 1, widths: l };
        globalThis.localStorage.setItem(r, JSON.stringify(c));
      } catch {
      }
  };
  return { widths: Kl(a), remember: o };
}, aS = 5, yo = 12, iz = (e) => {
  const t = N(!1), n = N(null), a = N("before");
  let o = null, l = null, r = !1, c = !1, s = null, p = null;
  const d = (ee) => e.canMove(ee), f = () => {
    document.removeEventListener("pointermove", E), document.removeEventListener("pointerup", F), document.removeEventListener("pointercancel", H), s = null, c = !1;
  }, h = () => {
    f(), p?.cancel(), p = null, l?.remove(), l = null, o = null, r = !1, t.value = !1, n.value = null;
  }, $ = (ee, O, z) => {
    const D = ee.closest(e.itemSelector), P = D instanceof HTMLElement ? D : ee, Z = document.createElement("div");
    Z.className = "hp-reorder-drag-preview", z && Z.classList.add("hp-reorder-drag-preview--pointer");
    const J = P.getBoundingClientRect();
    J.width > 0 && (Z.style.width = `${J.width}px`);
    const re = P.cloneNode(!0);
    if (re instanceof HTMLElement) {
      re.classList.add("hp-reorder-drag-preview__item"), re.setAttribute("aria-hidden", "true"), re.removeAttribute("id"), re.querySelectorAll("[id]").forEach((K) => K.removeAttribute("id")), re.querySelectorAll("a, button, input, select, textarea, [tabindex]").forEach((K) => K.setAttribute("tabindex", "-1"));
      const U = P.querySelectorAll("svg"), ge = re.querySelectorAll("svg");
      U.forEach((K, pe) => {
        const ae = ge[pe];
        if (ae === void 0)
          return;
        const Ce = K.getBoundingClientRect();
        Ce.width > 0 && ae.setAttribute("width", String(Ce.width)), Ce.height > 0 && ae.setAttribute("height", String(Ce.height)), ae.setAttribute("aria-hidden", "true");
      }), Z.append(re);
    } else {
      const U = document.createElement("span");
      U.textContent = e.labelFor(O), Z.append(U);
    }
    return document.body.append(Z), Z;
  }, y = (ee) => e.axis === "x" ? ee.clientX : ee.clientY, w = (ee) => e.axis === "x" ? ee.left + ee.width / 2 : ee.top + ee.height / 2, v = (ee, O) => y(ee) < w(O.getBoundingClientRect()) ? "before" : "after", x = (ee, O) => {
    const z = ee.currentTarget;
    if (!d(O) || ee.dataTransfer === null || !(z instanceof HTMLElement)) {
      ee.preventDefault();
      return;
    }
    h(), o = O, r = !0, t.value = !0, ee.dataTransfer.effectAllowed = "move", ee.dataTransfer.setData("text/plain", O), l = $(z, O, !1), ee.dataTransfer.setDragImage(l, yo, yo), ee.stopPropagation();
  }, b = (ee, O) => {
    const z = ee.currentTarget;
    !t.value || !d(O) || !(z instanceof HTMLElement) || (n.value = O, a.value = v(ee, z), ee.dataTransfer !== null && (ee.dataTransfer.dropEffect = "move"), ee.preventDefault());
  }, k = () => {
    const ee = o, O = n.value, z = a.value;
    h(), ee !== null && O !== null && ee !== O && e.onMove(ee, O, z);
  }, _ = (ee, O) => {
    b(ee, O), k(), ee.preventDefault(), ee.stopPropagation();
  }, T = (ee, O, z) => ee.width > 0 && ee.height > 0 && O >= ee.left && O <= ee.right && z >= ee.top && z <= ee.bottom, S = (ee, O) => {
    const z = e.rootRef.value;
    if (z === null)
      return null;
    for (const D of Array.from(z.querySelectorAll(e.itemSelector))) {
      const P = D.dataset.reorderKey;
      if (P === void 0 || !d(P))
        continue;
      const Z = D.getBoundingClientRect();
      if (T(Z, ee, O))
        return { key: P, placement: y({ clientX: ee, clientY: O }) < w(Z) ? "before" : "after" };
    }
    return null;
  }, M = (ee, O) => {
    l === null || typeof l.animate != "function" || (p?.cancel(), p = l.animate(
      [{ transform: `translate3d(${ee + yo}px, ${O + yo}px, 0)` }],
      { duration: 0, fill: "forwards" }
    ));
  }, E = (ee) => {
    const O = s;
    if (O === null || ee.pointerId !== O.pointerId || r || !c && Math.hypot(ee.clientX - O.startX, ee.clientY - O.startY) < aS)
      return;
    c || (c = !0, o = O.key, t.value = !0, l = $(O.source, O.key, !0)), M(ee.clientX, ee.clientY);
    const z = S(ee.clientX, ee.clientY);
    n.value = z?.key ?? null, a.value = z?.placement ?? "before", ee.preventDefault(), ee.stopPropagation();
  }, F = (ee) => {
    s === null || ee.pointerId !== s.pointerId || (c ? k() : h());
  }, H = (ee) => {
    s !== null && ee.pointerId === s.pointerId && h();
  }, te = (ee, O) => {
    const z = ee.currentTarget;
    ee.button !== 0 || !(z instanceof HTMLElement) || !d(O) || (h(), s = {
      key: O,
      source: z,
      pointerId: ee.pointerId,
      startX: ee.clientX,
      startY: ee.clientY
    }, document.addEventListener("pointermove", E, { passive: !1 }), document.addEventListener("pointerup", F), document.addEventListener("pointercancel", H));
  }, ie = (ee) => {
    if (!t.value || n.value !== ee)
      return "";
    const O = a.value === "before" ? "hp-reorder-drop-before" : "hp-reorder-drop-after";
    return `${O} ${O}--${e.axis}`;
  };
  return ct(h), {
    dragging: t,
    getDropClass: ie,
    onDragStart: x,
    onDragOver: b,
    onDrop: _,
    /**
     * `dragend` fires for a cancel as well as for a drop — Escape, or a release outside any drop
     * zone — and the two are told apart only by `dropEffect`. Committing unconditionally moved
     * the item on a cancelled drag and persisted it.
     */
    onDragEnd: (ee) => {
      if (r) {
        if (ee?.dataTransfer?.dropEffect === "none") {
          h();
          return;
        }
        k();
      }
    },
    onPointerDown: te
  };
}, nS = (e) => {
  if (e === null)
    return null;
  try {
    const t = JSON.parse(e);
    if (typeof t != "object" || t === null)
      return null;
    const n = t;
    return n.version !== 1 || !Array.isArray(n.hiddenKeys) || !n.hiddenKeys.every((a) => typeof a == "string") || new Set(n.hiddenKeys).size !== n.hiddenKeys.length ? null : n.hiddenKeys;
  } catch {
    return null;
  }
}, oS = (e) => {
  const t = [], n = /* @__PURE__ */ new Set();
  for (const a of e) {
    if (n.has(a.key))
      throw new Error(`Duplicate section visibility key: ${a.key}`);
    n.add(a.key), t.push(a.key);
  }
  return t;
}, cz = (e) => {
  const t = m(() => oS(Ne(e.sections))), n = m(() => Ne(e.storageKey)), a = () => {
    const h = n.value;
    if (h === void 0 || typeof globalThis.localStorage > "u")
      return [];
    try {
      return nS(globalThis.localStorage.getItem(h)) ?? [];
    } catch {
      return [];
    }
  }, o = N(a()), l = m(() => {
    const h = new Set(o.value);
    return t.value.filter(($) => h.has($));
  }), r = m(() => l.value.length), c = () => {
    const h = n.value;
    if (!(h === void 0 || typeof globalThis.localStorage > "u"))
      try {
        const $ = {
          version: 1,
          hiddenKeys: o.value
        };
        globalThis.localStorage.setItem(h, JSON.stringify($));
      } catch {
      }
  };
  Se(
    [t, n],
    ([, h], [, $]) => {
      if (h !== $) {
        o.value = a();
        return;
      }
      o.value = [.../* @__PURE__ */ new Set([...o.value, ...a()])];
    },
    { deep: !0 }
  );
  const s = (h) => t.value.includes(h);
  return {
    registeredKeys: t,
    hiddenKeys: l,
    hiddenCount: r,
    isRegistered: s,
    isVisible: (h) => s(h) && !o.value.includes(h),
    setVisible: (h, $) => {
      if (!s(h))
        return;
      const y = o.value.includes(h);
      $ !== !y && (o.value = $ ? o.value.filter((w) => w !== h) : [...o.value, h], c());
    },
    reset: () => {
      const h = new Set(t.value);
      o.value = o.value.filter(($) => !h.has($)), c();
    }
  };
}, lS = "hp-resizable-active", rS = "hp-resizable-active--col", sS = "hp-resizable-active--row", iS = 100, cS = 100, Lu = Vo(lS), Eu = Vo(rS), Iu = Vo(sS), uS = (e) => {
  Lu.lock(), e === "left" || e === "right" ? Eu.lock() : Iu.lock();
}, dS = (e) => {
  Lu.unlock(), e === "left" || e === "right" ? Eu.unlock() : Iu.unlock();
}, pS = (e, t, n) => {
  t === "left" || t === "right" ? e.style.width = `${n}px` : e.style.height = `${n}px`;
}, fS = ({ el: e, handle: t, edge: n, options: a, event: o }) => {
  const { min: l = iS, max: r = "parent", container: c, onResize: s } = a, p = n === "left" || n === "right", d = n === "left" || n === "top", f = c ? e.closest(c) : e.parentElement, h = p ? o.clientX : o.clientY, $ = e.getBoundingClientRect(), y = p ? $.width : $.height, w = (() => {
    if (typeof r == "number")
      return r;
    if (f === null)
      return 1 / 0;
    const v = f.getBoundingClientRect();
    return (p ? v.width : v.height) - cS;
  })();
  return uS(n), t.classList.add("hp-resize-handle--active"), mr({
    label: "v-resizable",
    onMove: (v) => {
      const x = p ? v.clientX : v.clientY, b = d ? h - x : x - h, k = y + b, _ = Math.max(l, Math.min(w, k));
      pS(e, n, _), s?.(_);
    },
    onCleanup: () => {
      t.classList.remove("hp-resize-handle--active"), dS(n);
    }
  });
}, Wn = "__vResizable__", hS = (e) => {
  const t = document.createElement("div");
  t.className = "hp-resize-handle";
  const n = e === "left" || e === "right";
  return t.classList.add(n ? "hp-resize-handle--horizontal" : "hp-resize-handle--vertical"), e === "left" ? t.style.cssText = "left: -3px; top: 0; bottom: 0; width: 6px;" : e === "right" ? t.style.cssText = "right: -3px; top: 0; bottom: 0; width: 6px;" : e === "top" ? t.style.cssText = "top: -3px; left: 0; right: 0; height: 6px;" : t.style.cssText = "bottom: -3px; left: 0; right: 0; height: 6px;", t;
}, hi = (e, t) => {
  getComputedStyle(e).position === "static" && (e.style.position = "relative");
  const a = hS(t.edge), o = (l) => {
    l.preventDefault(), l.stopPropagation();
    const r = e[Wn];
    if (!r)
      return;
    r.cleanupDrag?.();
    const c = fS({
      el: e,
      handle: a,
      edge: r.edge,
      options: t,
      event: l
    });
    r.cleanupDrag = c;
  };
  a.addEventListener("mousedown", o), e.appendChild(a), e[Wn] = {
    handle: a,
    edge: t.edge,
    cleanupDrag: null,
    onMouseDown: o
  };
}, vi = (e) => {
  const t = e[Wn];
  t && (t.cleanupDrag?.(), t.handle.removeEventListener("mousedown", t.onMouseDown), t.handle.remove(), delete e[Wn]);
}, uz = {
  mounted(e, t) {
    hi(e, t.value);
  },
  updated(e, t) {
    const n = e[Wn];
    n && (n.cleanupDrag || n.edge !== t.value.edge && (vi(e), hi(e, t.value)));
  },
  beforeUnmount(e) {
    vi(e);
  }
}, vS = (e, t, n) => Uu(
  Y({
    name: "BulkDialogBodyShim",
    setup() {
      return () => na(e, { ref: n, ...t });
    }
  })
), mS = async (e, t) => {
  const n = typeof t.title == "function" ? t.title(t.count) : t.title, a = N(), o = t.body ? vS(t.body, t.bodyProps ?? {}, a) : void 0;
  let l;
  const r = t.actions.map((f, h) => /* @__PURE__ */ Symbol(`bulk-action-${String(h)}`)), c = t.actions.map((f, h) => {
    const $ = r[h];
    return f.role === "cancel" ? {
      text: f.label,
      color: f.color,
      variant: f.variant ?? "outline",
      action: $
    } : {
      text: f.label,
      color: f.color,
      variant: f.variant,
      action: $,
      onAction: async () => {
        const w = a.value;
        if (w?.validate && !w.validate())
          throw new Ol();
        let v;
        if (t.getResult ? v = await t.getResult() : w?.getResult ? v = await w.getResult() : v = void 0, f.handler) {
          let x = !1;
          const b = {
            close: () => {
            },
            keepOpen: () => {
              x = !0;
            }
          };
          if (await f.handler(v, b), x)
            throw new Ol();
        }
        l = v;
      }
    };
  }), s = await e({
    title: n,
    size: t.size,
    body: o,
    // When we have a shim, don't pass bodyProps separately — the shim already has them
    bodyProps: o ? void 0 : t.bodyProps,
    bodyPadded: t.bodyPadded,
    expandable: t.expandable,
    actions: c
  });
  if (s === null)
    return null;
  const p = r.findIndex((f) => f === s);
  return p === -1 || t.actions[p].role === "cancel" ? null : l;
}, Ru = (e) => (t) => mS(e, t), dz = () => {
  const e = Yo();
  return Ru(e);
}, gS = (e, t = (n, a) => a) => async (n) => await e({
  title: n.count > 1 ? n.pluralTitle(n.count) : n.singularTitle,
  count: n.count,
  body: n.body,
  bodyProps: n.bodyProps,
  actions: [
    { label: t("ui.common.cancel", "Cancel"), role: "cancel" },
    {
      label: t("ui.composables.delete", "Delete"),
      role: "submit",
      color: "red",
      variant: "filled"
    }
  ],
  getResult: () => !0
}) === !0, pz = () => {
  const e = Le(), t = Yo(), n = Ru(t);
  return gS(n, e);
}, fz = (e, t, n, a) => {
  const o = (s) => {
    (s.key === " " || s.key === "Enter") && (s.preventDefault(), a.onOpen());
  }, l = (s) => {
    if (s.key === "Escape") {
      if (s.preventDefault(), s.stopPropagation(), a.onBeforeClose?.() === !1)
        return;
      a.onClose();
    } else s.key === "Enter" && a.onSubmit && (s.preventDefault(), a.onSubmit());
  }, r = Se(
    e,
    (s, p) => {
      p?.removeEventListener("keydown", o), s?.addEventListener("keydown", o);
    },
    { immediate: !0 }
  ), c = Se(n, async (s) => {
    s ? (await Ye(), t.value?.addEventListener("keydown", l)) : t.value?.removeEventListener("keydown", l);
  });
  ct(() => {
    r(), c(), e.value?.removeEventListener("keydown", o), t.value?.removeEventListener("keydown", l);
  });
}, Pn = 40, yS = 15, wS = 30, bS = 120, hz = ({ getListEl: e, totalItems: t }) => {
  const n = N(0), a = N(400), o = N(!1);
  let l = null, r = null, c = !1;
  const s = m(() => {
    const w = t.value, v = n.value, x = a.value, b = Math.ceil(x / Pn) || 10, k = Math.max(0, Math.floor(v / Pn) - yS), _ = Math.min(w, k + b + wS);
    return { startIndex: k, endIndex: _, total: w };
  }), p = m(() => `${s.value.total * Pn}px`), d = m(() => ({ height: p.value })), f = m(() => `translateY(${s.value.startIndex * Pn}px)`);
  return {
    scrollTopRef: n,
    listClientHeightRef: a,
    isListScrolling: o,
    windowRange: s,
    listInnerHeightPx: p,
    listViewportStyle: d,
    listContentTransform: f,
    handleScroll: () => {
      if (o.value = !0, c = !1, r !== null && clearTimeout(r), r = setTimeout(() => {
        const v = e();
        v && (n.value = v.scrollTop, a.value = v.clientHeight), o.value = !1, c = !0, r = null;
      }, bS), l !== null)
        return;
      const w = () => {
        l = null;
        const v = e();
        v && (n.value = v.scrollTop, a.value = v.clientHeight), c || (l = requestAnimationFrame(w));
      };
      l = requestAnimationFrame(w);
    },
    resetScroll: () => {
      n.value = 0;
      const w = e();
      w ? (w.scrollTop = 0, a.value = w.clientHeight) : a.value = 400;
    },
    cleanup: () => {
      c = !0, l !== null && (cancelAnimationFrame(l), l = null);
    },
    ITEM_HEIGHT: Pn
  };
}, kS = (e) => {
  const {
    rowId: t,
    colId: n,
    rootRef: a,
    disabled: o,
    state: l,
    provider: r,
    enterEditing: c,
    commitDraft: s,
    revertDraft: p,
    clearValue: d,
    setState: f
  } = e, h = m(() => {
    if (!r)
      return l.value !== "idle";
    const S = r.activeCell.value;
    return S ? S.rowKey === t.value && S.colKey === n.value : !1;
  }), $ = () => {
    if (!o.value) {
      if (r) {
        r.setActive({ rowKey: t.value, colKey: n.value });
        return;
      }
      f("focused"), a.value?.focus();
    }
  }, y = (S) => {
    if (S.stopPropagation(), !o.value) {
      if (l.value === "idle") {
        $();
        return;
      }
      l.value === "focused" && c({ selectAll: !0 });
    }
  }, w = () => {
    o.value || h.value || $();
  }, v = (S) => {
    const M = S.relatedTarget;
    M && a.value?.contains(M) || Ir(M) || (l.value === "editing" && s(), !r && l.value !== "idle" && f("idle"));
  }, x = (S, M) => ru.has(S) ? !0 : !M && su.has(S), b = (S) => {
    const M = S.key;
    if (M === "Enter") {
      S.preventDefault(), s(), r?.moveActive(S.shiftKey ? -1 : 1, 0);
      return;
    }
    M === "Escape" && (S.preventDefault(), p());
  }, k = (S) => !S.ctrlKey && !S.metaKey && !S.altKey && S.key.length === 1, _ = (S) => {
    const M = S.key;
    if (M === "Enter") {
      S.preventDefault(), c({ selectAll: !0 });
      return;
    }
    if (M === "F2" || M === " ") {
      S.preventDefault(), c();
      return;
    }
    if (M === "Delete" || M === "Backspace") {
      S.preventDefault(), d();
      return;
    }
    k(S) && (S.preventDefault(), c({ initialChar: M }));
  }, T = (S) => {
    if (o.value || S.isComposing || Rr(S))
      return;
    const M = l.value === "editing";
    if (x(S.key, M)) {
      M && s();
      return;
    }
    if (M) {
      b(S);
      return;
    }
    _(S);
  };
  return r && Se(h, (S) => {
    if (!S && l.value !== "idle") {
      l.value === "editing" && s(), f("idle");
      return;
    }
    S && l.value === "idle" && f("focused");
  }), {
    isActive: h,
    activate: $,
    handleClick: y,
    handleFocusIn: w,
    handleFocusOut: v,
    handleKeydown: T
  };
}, _S = ["data-state", "data-active-input", "data-active-cell", "data-smart-cell-error", "data-smart-cell-trigger", "data-editable-cell", "data-row", "data-col", "tabindex", "aria-readonly", "aria-disabled", "aria-invalid"], CS = ["inputmode", "placeholder", "value", "readonly", "disabled", "data-theme"], xS = {
  key: 0,
  class: "hp-smart-cell-editable__divider"
}, $S = ["inputmode", "placeholder", "value", "readonly", "disabled", "data-theme"], SS = /* @__PURE__ */ new Set(["", "-", "–", "—"]), vz = /* @__PURE__ */ Y({
  name: "SmartCellEditable",
  __ownsGridNav: !0,
  __name: "SmartCellEditable",
  props: {
    rowId: {},
    colId: {},
    modelValue: { default: null },
    displayValue: { default: void 0 },
    placeholder: { default: void 0 },
    numeric: { type: Boolean, default: !1 },
    inputmode: { default: void 0 },
    secondary: { default: void 0 },
    secondaryDisplayValue: { default: void 0 },
    secondaryPlaceholder: { default: void 0 },
    secondaryNumeric: { type: Boolean, default: !1 },
    secondaryInputmode: { default: void 0 },
    secondaryWidth: { default: void 0 },
    showDivider: { type: Boolean, default: !1 },
    showToggle: { type: Boolean, default: !1 },
    toggle: { type: Boolean, default: void 0 },
    toggleLabel: { default: void 0 },
    toggleColor: { default: void 0 },
    toggleAriaLabel: { default: void 0 },
    showClear: { type: Boolean, default: !1 },
    clearAriaLabel: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    invalid: { type: Boolean, default: !1 },
    editable: { type: Boolean, default: !0 },
    mode: { default: void 0 },
    align: { default: "left" },
    gridNav: { type: Boolean, default: !0 },
    class: { default: void 0 },
    onEdit: {}
  },
  emits: ["update:modelValue", "commit", "clear", "revert", "update:toggle"],
  setup(e, { expose: t, emit: n }) {
    const a = Le(), o = e, l = n, r = ze("hp-smart-cell-editable", {
      variants: {
        align: {
          left: "hp-smart-cell-editable--align-left",
          center: "hp-smart-cell-editable--align-center",
          right: "hp-smart-cell-editable--align-right"
        },
        invalid: {
          true: "hp-smart-cell-editable--invalid",
          false: ""
        },
        disabled: {
          true: "hp-smart-cell-editable--disabled",
          false: ""
        }
      },
      defaultVariants: {
        align: "left",
        invalid: !1,
        disabled: !1
      }
    }), c = Lr(), s = N(null), p = N(null), d = N(null), f = N("idle"), h = N(""), $ = m(() => o.gridNav), y = m(() => o.disabled), w = o.class, v = m(
      () => r({
        align: o.align ?? "left",
        invalid: o.invalid,
        disabled: o.disabled
      })
    ), x = m(() => o.rowId), b = m(() => o.colId), k = m(() => o.modelValue ?? null), _ = (Q) => Q == null || Q === "", T = (Q) => Q === void 0 || SS.has(Q.trim()), S = m(
      () => o.placeholder ?? (_(o.modelValue) ? a("ui.smartCell.notSet", "Not set") : void 0)
    ), M = m(() => {
      if (_(o.modelValue) && T(o.displayValue))
        return "";
      if (o.displayValue !== void 0)
        return o.displayValue;
      const Q = o.modelValue;
      return Q == null || Q === "" ? "" : String(Q);
    }), E = m(
      () => M.value === "" && S.value !== void 0
    ), F = m(
      () => o.secondary !== void 0 || o.secondaryDisplayValue !== void 0
    ), H = m(() => o.secondaryPlaceholder), te = m(() => {
      if (_(o.secondary) && T(o.secondaryDisplayValue))
        return "";
      if (o.secondaryDisplayValue !== void 0)
        return o.secondaryDisplayValue;
      const Q = o.secondary;
      return Q == null || Q === "" ? "" : String(Q);
    }), ie = m(() => ({
      width: o.secondaryWidth ?? "7ch"
    })), ee = m(() => o.invalid ? "red" : o.toggleColor !== void 0 ? o.toggleColor : o.toggle ? "default" : "blue"), O = m(() => {
      const Q = {};
      return o.toggle && (Q.fontWeight = "var(--font-weight-bold)"), (F.value || E.value) && (Q.textAlign = "left"), Q;
    }), z = m(() => o.showDivider && F.value), D = m(() => o.mode !== void 0 ? o.mode : f.value === "editing" ? "edit" : "display"), P = m(() => {
      const Q = D.value;
      return f.value === "editing" && (Q === "edit" || Q === "edit-primary");
    }), Z = m(() => {
      const Q = D.value;
      return f.value === "editing" && Q === "edit-secondary";
    }), J = m(
      () => o.mode === "edit-secondary" ? "secondary" : "primary"
    ), re = m(
      () => J.value === "secondary" ? o.secondary ?? null : k.value
    ), U = (Q) => Q == null ? "" : String(Q), ge = (Q) => {
      o.disabled && Q !== "idle" || (f.value = Q);
    }, K = (Q) => {
      !o.editable || o.disabled || (h.value = Q?.initialChar ?? U(re.value), f.value = "editing");
    }, pe = () => {
      if (f.value !== "editing")
        return;
      const Q = U(re.value);
      if (f.value = "focused", h.value === Q)
        return;
      const G = h.value === "" ? null : h.value;
      l("update:modelValue", G), l("commit", G), o.onEdit?.(o.rowId, o.colId, G), c?.notifyCommit({
        rowKey: o.rowId,
        colKey: o.colId,
        value: G
      });
    }, ae = () => {
      f.value === "editing" && (f.value = "focused");
    }, Ce = () => {
      h.value = U(k.value), ae(), l("revert");
    }, q = () => {
      h.value = "", ae();
    }, I = (Q = !1) => !o.editable || o.disabled || !Q && (o.modelValue === null || o.modelValue === void 0 || o.modelValue === "") ? !1 : (l("update:modelValue", null), l("commit", null), l("clear"), o.onEdit?.(o.rowId, o.colId, null), c?.notifyCommit({
      rowKey: o.rowId,
      colKey: o.colId,
      value: null
    }), q(), !0), oe = (Q) => {
      if (Q.length === 0)
        return !0;
      let G = Q[0] === "-" ? 1 : 0, fe = !1;
      for (; G < Q.length; G += 1) {
        const ke = Q[G];
        if (ke === ".") {
          if (fe)
            return !1;
          fe = !0;
          continue;
        }
        if (ke === void 0 || ke < "0" || ke > "9")
          return !1;
      }
      return !0;
    }, be = (Q, G) => {
      if (!G || f.value !== "editing")
        return;
      const fe = Q.data;
      if (fe == null)
        return;
      const ke = Q.target, Re = ke.selectionStart ?? ke.value.length, xt = ke.selectionEnd ?? ke.value.length, ot = ke.value.slice(0, Re) + fe + ke.value.slice(xt);
      oe(ot) || Q.preventDefault();
    }, de = (Q) => be(Q, o.numeric), X = (Q) => be(Q, o.secondaryNumeric), ne = (Q) => {
      P.value || (Q.preventDefault(), s.value?.focus());
    }, ve = (Q) => {
      Z.value || (Q.preventDefault(), s.value?.focus());
    }, V = (Q) => {
      if (f.value !== "editing")
        return;
      const G = Q.target;
      h.value = G.value;
    }, xe = (Q) => {
      Q.preventDefault(), Q.stopPropagation(), !o.disabled && l("update:toggle", !(o.toggle ?? !1));
    }, ce = (Q) => {
      Q.preventDefault(), Q.stopPropagation(), I(!0);
    };
    Se(
      () => k.value,
      () => {
        f.value !== "editing" && (h.value = U(k.value));
      },
      { immediate: !0 }
    ), Se([P, Z], ([Q, G]) => {
      !Q && !G || Ye(() => {
        const fe = Q ? p.value : d.value;
        if (fe) {
          fe.focus();
          try {
            fe.select();
          } catch {
          }
        }
      });
    }), iu({
      provider: c,
      rowKey: x,
      colKey: b,
      gridNav: $,
      entry: {
        state: f,
        value: k,
        displayValue: M,
        draft: h
      }
    });
    const {
      isActive: Te,
      handleClick: $e,
      handleFocusIn: Be,
      handleFocusOut: Ue,
      handleKeydown: qe
    } = kS({
      rowId: x,
      colId: b,
      rootRef: s,
      disabled: y,
      state: f,
      provider: c,
      enterEditing: K,
      commitDraft: pe,
      revertDraft: Ce,
      clearValue: I,
      setState: ge
    });
    return t({
      resetEdit: q
    }), (Q, G) => (i(), g("div", {
      ref_key: "rootRef",
      ref: s,
      class: W([v.value, u(w)]),
      "data-hp-flush-content": "true",
      "data-state": f.value,
      "data-active-input": J.value,
      "data-active-cell": u(Te) ? "" : void 0,
      "data-smart-cell-error": e.invalid ? "true" : void 0,
      "data-smart-cell-trigger": e.editable && !e.disabled ? "true" : void 0,
      "data-editable-cell": e.gridNav ? "" : void 0,
      "data-row": e.gridNav ? String(e.rowId) : void 0,
      "data-col": e.gridNav ? String(e.colId) : void 0,
      tabindex: e.disabled ? -1 : 0,
      role: "gridcell",
      "aria-readonly": !e.editable || void 0,
      "aria-disabled": e.disabled || void 0,
      "aria-invalid": e.invalid || void 0,
      onClick: G[2] || (G[2] = //@ts-ignore
      (...fe) => u($e) && u($e)(...fe)),
      onFocusin: G[3] || (G[3] = //@ts-ignore
      (...fe) => u(Be) && u(Be)(...fe)),
      onFocusout: G[4] || (G[4] = //@ts-ignore
      (...fe) => u(Ue) && u(Ue)(...fe)),
      onKeydown: G[5] || (G[5] = //@ts-ignore
      (...fe) => u(qe) && u(qe)(...fe))
    }, [
      L(Q.$slots, "left"),
      C("input", {
        ref_key: "primaryInputRef",
        ref: p,
        class: "hp-smart-cell-editable__primary",
        type: "text",
        inputmode: e.inputmode ?? "text",
        placeholder: S.value,
        value: P.value ? h.value : M.value,
        readonly: !P.value,
        disabled: e.disabled,
        style: Ie(O.value),
        "data-theme": J.value === "secondary" ? "blue" : void 0,
        tabindex: "-1",
        autocomplete: "off",
        spellcheck: "false",
        onMousedown: ne,
        onBeforeinput: de,
        onInput: V
      }, null, 44, CS),
      z.value ? (i(), g("span", xS, "—")) : A("", !0),
      F.value ? (i(), g("input", {
        key: 1,
        ref_key: "secondaryInputRef",
        ref: d,
        class: "hp-smart-cell-editable__secondary",
        style: Ie(ie.value),
        type: "text",
        inputmode: e.secondaryInputmode ?? "text",
        placeholder: H.value,
        value: Z.value ? h.value : te.value,
        readonly: !Z.value,
        disabled: e.disabled,
        "data-theme": J.value === "primary" ? "blue" : void 0,
        tabindex: "-1",
        autocomplete: "off",
        spellcheck: "false",
        onMousedown: ve,
        onBeforeinput: X,
        onInput: V
      }, null, 44, $S)) : A("", !0),
      e.showToggle ? (i(), R(u(Ht), {
        key: 2,
        class: "hp-smart-cell-editable__toggle",
        size: "2",
        "icon-size": "1",
        variant: "soft",
        color: ee.value,
        square: "",
        radius: "full",
        clickable: "",
        disabled: e.disabled,
        icon: e.toggle ? u(Yr) : void 0,
        "aria-pressed": e.toggle ?? !1,
        "aria-label": e.toggleAriaLabel,
        onMousedown: G[0] || (G[0] = Fe(() => {
        }, ["prevent", "stop"])),
        onClick: Fe(xe, ["stop"])
      }, {
        default: B(() => [
          me(le(e.toggle ? "" : e.toggleLabel ?? "A"), 1)
        ]),
        _: 1
      }, 8, ["color", "disabled", "icon", "aria-pressed", "aria-label"])) : A("", !0),
      e.showClear ? (i(), R(u(Ht), {
        key: 3,
        class: "hp-smart-cell-editable__clear",
        size: "2",
        "icon-size": "2",
        variant: "soft",
        color: "default",
        square: "",
        radius: "full",
        clickable: "",
        disabled: e.disabled,
        icon: u(zt),
        "aria-label": e.clearAriaLabel ?? u(a)("ui.smartCell.clearValue", "Clear value"),
        onMousedown: G[1] || (G[1] = Fe(() => {
        }, ["prevent", "stop"])),
        onClick: Fe(ce, ["stop"])
      }, null, 8, ["disabled", "icon", "aria-label"])) : A("", !0),
      L(Q.$slots, "right")
    ], 42, _S));
  }
}), MS = (e) => e.inputmode === "numeric" || e.inputmode === "decimal", DS = (e) => Number.parseFloat(e), TS = (e, t) => {
  const n = t.trim();
  if (e.required === !0 && n === "")
    return "Required";
  if (!MS(e) || n === "")
    return;
  const a = DS(n);
  if (!Number.isFinite(a))
    return "Must be a number";
  if (e.min !== void 0 && a < e.min)
    return `Must be >= ${e.min}`;
}, BS = (e, t) => {
  const n = { ...e };
  for (const [a, o] of Object.entries(t))
    o !== void 0 && (n[a] = o);
  return n;
}, zS = (e) => {
  const t = N({}), n = (l) => {
    const r = {};
    for (const c of e.fields())
      r[c.key] = l[c.key] ?? "";
    return r;
  };
  Se(e.open, (l) => {
    l && (t.value = n(e.toDraftValue(e.modelValue())));
  });
  const a = m(() => {
    const l = {};
    for (const c of e.fields())
      l[c.key] = TS(c, t.value[c.key] ?? "");
    const r = e.validateDraft?.(t.value) ?? {};
    return BS(l, r);
  }), o = m(() => Object.values(a.value).every((l) => l === void 0));
  return { draft: t, fieldErrors: a, canApply: o };
}, AS = ["data-row", "data-col"], LS = ["disabled", "data-invalid", "data-locked", "data-open", "onClick"], ES = ["data-muted"], IS = { class: "hp-smart-cell-object__form" }, RS = { class: "hp-smart-cell-object__field" }, PS = { class: "hp-smart-cell-object__actions" }, OS = /* @__PURE__ */ Y({
  inheritAttrs: !1,
  __name: "SmartCellObject",
  props: {
    rowId: {},
    colId: {},
    modelValue: {},
    displayValue: {},
    fields: {},
    toDraftValue: {},
    fromDraftValue: {},
    validateDraft: { type: Function, default: void 0 },
    emptyValue: {},
    emptyLabel: { default: void 0 },
    anchorAttrs: { default: void 0 },
    invalid: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    showToggle: { type: Boolean, default: !1 },
    toggle: { type: Boolean, default: void 0 },
    toggleLabel: { default: void 0 },
    toggleAriaLabel: { default: void 0 }
  },
  emits: ["commit", "update:toggle"],
  setup(e, { emit: t }) {
    const n = Le(), a = e, o = t, l = m(() => a.emptyLabel ?? n("ui.smartCell.empty", "Empty")), r = N(!1), c = /* @__PURE__ */ new Set(["—", "Not set"]), s = (w) => c.has(w) || w === n("ui.smartCell.notSet", "Not set"), { draft: p, fieldErrors: d, canApply: f } = zS({
      open: r,
      modelValue: () => a.modelValue,
      fields: () => a.fields,
      toDraftValue: (w) => a.toDraftValue(w),
      validateDraft: (w) => a.validateDraft?.(w) ?? {}
    }), h = () => {
      f.value && (o("commit", a.fromDraftValue(p.value)), r.value = !1);
    }, $ = () => {
      o("commit", a.emptyValue === void 0 ? null : a.emptyValue), r.value = !1;
    }, y = (w) => {
      w.preventDefault(), w.stopPropagation(), !a.disabled && o("update:toggle", !(a.toggle ?? !1));
    };
    return (w, v) => (i(), R(u(Xt), {
      open: r.value,
      "onUpdate:open": v[2] || (v[2] = (x) => r.value = x),
      type: "popover",
      placement: "bottom-start",
      "close-on-click-outside": "",
      "close-on-escape": ""
    }, {
      default: B(() => [
        j(u(Jt), null, {
          default: B(({ toggle: x, isOpen: b }) => [
            C("div", Ke(e.anchorAttrs, {
              class: "hp-smart-cell-object",
              "data-hp-flush-content": "true",
              "data-row": e.rowId,
              "data-col": e.colId
            }), [
              C("button", {
                type: "button",
                disabled: e.disabled,
                class: "hp-smart-cell-object__trigger",
                "data-invalid": e.invalid ? "true" : void 0,
                "data-locked": e.toggle ? "true" : void 0,
                "data-open": b ? "true" : void 0,
                onClick: Fe((k) => !e.disabled && x(), ["stop"])
              }, [
                C("span", {
                  class: "hp-smart-cell-object__value",
                  "data-muted": s(e.displayValue) ? "true" : void 0
                }, le(e.displayValue), 9, ES)
              ], 8, LS),
              e.showToggle ? (i(), R(u(Ht), {
                key: 0,
                class: "hp-smart-cell-object__toggle",
                size: "2",
                "icon-size": "1",
                variant: "soft",
                color: e.invalid ? "red" : e.toggle ? "default" : "blue",
                square: "",
                radius: "full",
                clickable: "",
                disabled: e.disabled,
                icon: e.toggle ? Yr : void 0,
                "aria-pressed": e.toggle ?? !1,
                "aria-label": e.toggleAriaLabel,
                onMousedown: v[0] || (v[0] = Fe(() => {
                }, ["prevent", "stop"])),
                onClick: y
              }, {
                default: B(() => [
                  me(le(e.toggle ? "" : e.toggleLabel ?? "A"), 1)
                ]),
                _: 1
              }, 8, ["color", "disabled", "icon", "aria-pressed", "aria-label"])) : A("", !0)
            ], 16, AS)
          ]),
          _: 1
        }),
        j(u(Qt), {
          class: "hp-smart-cell-object__popover",
          display: "flex"
        }, {
          default: B(() => [
            C("form", {
              class: "hp-smart-cell-object__body",
              onSubmit: Fe(h, ["prevent"])
            }, [
              C("div", IS, [
                (i(!0), g(he, null, De(e.fields, (x, b) => (i(), g("div", {
                  key: x.key,
                  class: "hp-smart-cell-object__row"
                }, [
                  j(u(Zn), { class: "hp-smart-cell-object__label" }, {
                    default: B(() => [
                      me(le(x.label), 1)
                    ]),
                    _: 2
                  }, 1024),
                  C("div", RS, [
                    j(u(tn), {
                      modelValue: u(p)[x.key],
                      "onUpdate:modelValue": (k) => u(p)[x.key] = k,
                      "data-autofocus": b === 0 ? "" : void 0,
                      class: "hp-smart-cell-object__input",
                      type: "text",
                      inputmode: x.inputmode ?? "text",
                      size: "2",
                      align: "right",
                      placeholder: x.placeholder,
                      color: u(d)[x.key] === void 0 ? void 0 : "red"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "data-autofocus", "inputmode", "placeholder", "color"]),
                    u(d)[x.key] !== void 0 ? (i(), R(u(at), {
                      key: 0,
                      size: "1",
                      color: "red",
                      class: "hp-smart-cell-object__error"
                    }, {
                      default: B(() => [
                        me(le(u(d)[x.key]), 1)
                      ]),
                      _: 2
                    }, 1024)) : A("", !0)
                  ])
                ]))), 128))
              ]),
              C("div", PS, [
                j(u(Ae), {
                  variant: "outline",
                  size: "2",
                  onClick: $
                }, {
                  default: B(() => [
                    me(le(l.value), 1)
                  ]),
                  _: 1
                }),
                j(u(Ae), {
                  variant: "outline",
                  size: "2",
                  onClick: v[1] || (v[1] = (x) => r.value = !1)
                }, {
                  default: B(() => [
                    me(le(u(n)("ui.common.cancel", "Cancel")), 1)
                  ]),
                  _: 1
                }),
                j(u(Ae), {
                  variant: "filled",
                  size: "2",
                  type: "submit",
                  disabled: !u(f)
                }, {
                  default: B(() => [
                    me(le(u(n)("ui.common.apply", "Apply")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ], 32)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]));
  }
}), mz = /* @__PURE__ */ se(OS, [["__scopeId", "data-v-72acaa69"]]), VS = ["data-row", "data-col", "data-locked", "data-invalid"], HS = /* @__PURE__ */ Y({
  inheritAttrs: !1,
  __name: "SmartCellSelect",
  props: {
    rowId: {},
    colId: {},
    modelValue: {},
    options: {},
    anchorAttrs: { default: void 0 },
    invalid: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    showToggle: { type: Boolean, default: !1 },
    toggle: { type: Boolean, default: void 0 },
    toggleLabel: { default: void 0 },
    toggleAriaLabel: { default: void 0 }
  },
  emits: ["commit", "update:toggle"],
  setup(e, { emit: t }) {
    const n = e, a = t, o = m(() => n.modelValue ?? void 0), l = (c) => {
      c === void 0 || Array.isArray(c) || a("commit", c);
    }, r = (c) => {
      c.preventDefault(), c.stopPropagation(), !n.disabled && a("update:toggle", !(n.toggle ?? !1));
    };
    return (c, s) => (i(), g("div", Ke(e.anchorAttrs, {
      class: "hp-smart-cell-select",
      "data-hp-flush-content": "true",
      "data-row": e.rowId,
      "data-col": e.colId,
      "data-locked": e.toggle ? "true" : void 0,
      "data-invalid": e.invalid ? "true" : void 0
    }), [
      j(u(Hr), {
        "model-value": o.value,
        options: [...e.options],
        clearable: !1,
        disabled: e.disabled,
        color: e.invalid ? "red" : void 0,
        size: "2",
        variant: "cell",
        width: "100%",
        "min-width": 0,
        class: "hp-smart-cell-select__select",
        "onUpdate:modelValue": l
      }, null, 8, ["model-value", "options", "disabled", "color"]),
      e.showToggle ? (i(), R(u(Ht), {
        key: 0,
        class: "hp-smart-cell-select__toggle",
        size: "2",
        "icon-size": "1",
        variant: "soft",
        color: e.invalid ? "red" : e.toggle ? "default" : "blue",
        square: "",
        radius: "full",
        clickable: "",
        disabled: e.disabled,
        icon: e.toggle ? Yr : void 0,
        "aria-pressed": e.toggle ?? !1,
        "aria-label": e.toggleAriaLabel,
        onMousedown: s[0] || (s[0] = Fe(() => {
        }, ["prevent", "stop"])),
        onClick: r
      }, {
        default: B(() => [
          me(le(e.toggle ? "" : e.toggleLabel ?? "A"), 1)
        ]),
        _: 1
      }, 8, ["color", "disabled", "icon", "aria-pressed", "aria-label"])) : A("", !0)
    ], 16, VS));
  }
}), gz = /* @__PURE__ */ se(HS, [["__scopeId", "data-v-821bfdcf"]]), yz = "green", wz = "red", bz = "yellow", kz = "purple", NS = ["aria-label"], FS = /* @__PURE__ */ Y({
  __name: "TabGroup",
  props: {
    label: {}
  },
  setup(e) {
    const t = ["ArrowRight", "ArrowDown", "ArrowLeft", "ArrowUp", "Home", "End"], n = ["ArrowLeft", "ArrowUp"], a = N(), o = () => Array.from(a.value?.querySelectorAll('[role="tab"]') ?? []).filter(
      (c) => !c.disabled && c.getAttribute("aria-disabled") !== "true"
    ), l = (c, s, p) => {
      if (c === "Home")
        return 0;
      if (c === "End")
        return p - 1;
      const d = n.includes(c) ? -1 : 1;
      return (Math.max(s, 0) + d + p) % p;
    }, r = (c) => {
      if (c.altKey || c.ctrlKey || c.metaKey || !t.includes(c.key))
        return;
      const s = o();
      if (!s.length)
        return;
      const p = s.findIndex((f) => f.getAttribute("aria-selected") === "true"), d = s[l(c.key, p, s.length)];
      c.preventDefault(), d?.click(), d?.focus();
    };
    return (c, s) => (i(), g("div", {
      ref_key: "root",
      ref: a,
      class: "hp-tab-group",
      role: "tablist",
      "aria-label": e.label,
      onKeydown: r
    }, [
      L(c.$slots, "default", {}, void 0, !0)
    ], 40, NS));
  }
}), _z = /* @__PURE__ */ se(FS, [["__scopeId", "data-v-4856fa02"]]);
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
const Pu = /* @__PURE__ */ Symbol(process.env.NODE_ENV !== "production" ? "router" : "");
process.env.NODE_ENV;
process.env.NODE_ENV;
function KS() {
  return pt(Pu);
}
const YS = "You have unsaved changes. Leave anyway?", Cz = (e, t) => {
  const n = t?.scope ?? "both", a = typeof window > "u", o = m(() => Ne(e.isDirty));
  let l;
  pt(Pu, null) !== null && (l = KS());
  const r = (s) => {
    Ne(e.isDirty) && s.preventDefault();
  };
  let c;
  return tt(() => {
    a || ((n === "beforeunload" || n === "both") && window.addEventListener("beforeunload", r), (n === "router" || n === "both") && (l ? c = l.beforeEach(async () => Ne(e.isDirty) ? e.onConfirm ? e.onConfirm() : window.confirm(t?.message ?? YS) : !0) : n === "router" && console.warn("[DirtyGuard] useRouter() returned undefined — router guard skipped.")));
  }), Fa(() => {
    a || ((n === "beforeunload" || n === "both") && window.removeEventListener("beforeunload", r), c?.());
  }), { isDirty: o };
}, jS = "soft", xz = /* @__PURE__ */ Y({
  name: "SmartAlert",
  __name: "SmartAlert",
  props: {
    api: {}
  },
  setup(e, { expose: t }) {
    const n = e;
    t({});
    const a = {
      error: "red",
      warning: "yellow",
      info: "blue",
      success: "green"
    }, o = {
      error: zu,
      warning: Au,
      info: IC,
      success: Bu
    }, l = m(() => n.api.visible.value), r = m(() => n.api.alert.value), c = m(() => a[r.value?.severity ?? "info"]), s = m(() => {
      const f = r.value?.icon;
      if (f === null)
        return;
      if (f !== void 0)
        return f;
      const h = r.value?.severity;
      return h ? o[h] : o.info;
    }), p = m(() => r.value?.icon !== null), d = m(() => !!r.value?.onClose);
    return (f, h) => l.value && r.value ? (i(), R(u(qn), {
      key: 0,
      variant: jS,
      color: c.value,
      icon: s.value,
      "show-icon": p.value,
      "show-close": d.value,
      title: r.value.title,
      description: r.value.description,
      size: "3",
      onClose: e.api.close
    }, {
      default: B(() => [
        L(f.$slots, "default")
      ]),
      _: 3
    }, 8, ["color", "icon", "show-icon", "show-close", "title", "description", "onClose"])) : A("", !0);
  }
}), $z = (e) => {
  const t = m(() => Ne(e.alert) ?? null), n = m(() => t.value !== null);
  return { alert: t, visible: n, close: () => {
    t.value?.onClose?.();
  } };
}, Sz = /* @__PURE__ */ Y({
  name: "SmartFormActions",
  __name: "SmartFormActions",
  props: {
    api: {}
  },
  setup(e, { expose: t }) {
    const n = {
      left: ["d-flex gap-2 justify-start"],
      right: ["d-flex gap-2 justify-end"],
      between: ["d-flex gap-2 justify-between"]
    }, a = e;
    t({});
    const o = m(() => a.api.submitButton.value), l = m(() => a.api.cancelButton.value), r = m(() => {
      const { label: p, visible: d, ...f } = o.value;
      return f;
    }), c = m(() => {
      const { label: p, visible: d, ...f } = l.value;
      return f;
    }), s = m(() => n[a.api.layout.value]);
    return (p, d) => (i(), g("div", {
      class: W(s.value)
    }, [
      l.value.visible ? (i(), R(u(Ae), Ke({
        key: 0,
        type: "button"
      }, c.value, {
        onClick: d[0] || (d[0] = (f) => a.api.cancel())
      }), {
        default: B(() => [
          me(le(l.value.label), 1)
        ]),
        _: 1
      }, 16)) : A("", !0),
      o.value.visible ? (i(), R(u(Ae), Ke({
        key: 1,
        type: "submit"
      }, r.value), {
        default: B(() => [
          me(le(o.value.label), 1)
        ]),
        _: 1
      }, 16)) : A("", !0)
    ], 2));
  }
}), WS = "right", US = (e) => e !== void 0 && e !== !1 && typeof e != "string", mi = (e, t, n) => m(() => {
  const a = e(), o = a !== !1;
  return US(a) ? {
    label: a.label ?? t.label,
    visible: o,
    variant: a.variant ?? t.variant,
    color: a.color,
    size: a.size,
    square: a.square,
    radius: a.radius,
    disabled: a.disabled === !0 || n?.extraDisabled?.() === !0
  } : {
    label: typeof a == "string" ? a : t.label,
    visible: o,
    variant: t.variant,
    disabled: n?.extraDisabled?.() === !0
  };
}), Mz = (e, t) => {
  const n = Le(), a = m(() => Ne(t)), o = mi(
    () => a.value.submit,
    // Getter: `defaults.label` is read inside `buildButtonState`'s computed, so resolving it
    // here as a value would pin the Save button to the locale the form was opened in.
    {
      get label() {
        return n("ui.features.save", "Save");
      },
      variant: "filled"
    },
    { extraDisabled: () => Ne(e.isSubmitting) }
  ), l = mi(() => a.value.cancel, {
    get label() {
      return n("ui.common.cancel", "Cancel");
    },
    variant: "outline"
  }), r = m(() => a.value.layout ?? WS);
  return { submitButton: o, cancelButton: l, layout: r, submit: e.onSubmit, cancel: e.onCancel };
}, qS = { class: "m-0 pl-4" }, Dz = /* @__PURE__ */ Y({
  name: "SmartFormErrorsBanner",
  __name: "SmartFormErrorsBanner",
  props: {
    api: {}
  },
  setup(e, { expose: t }) {
    const n = e;
    return t({}), (a, o) => n.api.visible.value ? (i(), R(u(qn), {
      key: 0,
      variant: "soft",
      color: "red",
      size: "3",
      "show-icon": !1,
      "show-close": !1,
      class: "mb-3"
    }, {
      default: B(() => [
        C("ul", qS, [
          (i(!0), g(he, null, De(n.api.errors.value, (l, r) => (i(), g("li", { key: r }, le(l), 1))), 128))
        ])
      ]),
      _: 1
    })) : A("", !0);
  }
}), Tz = (e) => {
  const t = m(() => Ne(e.errors)), n = m(() => t.value.length > 0);
  return { errors: t, visible: n };
}, ZS = () => ({
  anchor: null,
  focus: null,
  ranges: [],
  copiedRanges: []
}), Ou = (e, t) => e.rowKeys.includes(t.rowKey) && e.columnKeys.includes(t.columnKey), gi = (e, t, n) => {
  const a = e.indexOf(t), o = e.indexOf(n);
  return a < 0 || o < 0 ? [] : e.slice(Math.min(a, o), Math.max(a, o) + 1);
}, yi = (e, t, n) => ({
  rowKeys: gi(e.rowKeys, t.rowKey, n.rowKey),
  columnKeys: gi(e.columnKeys, t.columnKey, n.columnKey)
}), GS = (e, t) => {
  if (!Ou(e, t))
    return [e];
  const n = e.rowKeys.indexOf(t.rowKey), a = e.columnKeys.indexOf(t.columnKey);
  return [
    { rowKeys: e.rowKeys.slice(0, n), columnKeys: e.columnKeys },
    { rowKeys: e.rowKeys.slice(n + 1), columnKeys: e.columnKeys },
    { rowKeys: [t.rowKey], columnKeys: e.columnKeys.slice(0, a) },
    { rowKeys: [t.rowKey], columnKeys: e.columnKeys.slice(a + 1) }
  ].filter((o) => o.rowKeys.length && o.columnKeys.length);
}, XS = (e) => e.map((t) => t.map((n) => /[\t\r\n"]/.test(n) ? `"${n.replaceAll('"', '""')}"` : n).join("	")).join(`
`), wi = (e) => e.map((t) => ({ rows: new Set(t.rowKeys), columns: new Set(t.columnKeys) })), bl = (e, t) => e.some((n) => n.rows.has(t.rowKey) && n.columns.has(t.columnKey)), kl = (e, t) => {
  let n = 0;
  for (const a of e)
    t.has(a) && n++;
  return n;
}, QS = (e, t, n) => {
  if (e.length === 1)
    return kl(e[0].rows, t) * kl(e[0].columns, n);
  const a = new Set(e.flatMap((r) => [...r.rows])), o = /* @__PURE__ */ new Map();
  let l = 0;
  for (const r of a) {
    if (!t.has(r))
      continue;
    const c = e.flatMap((d, f) => d.rows.has(r) ? [f] : []), s = c.join(",");
    let p = o.get(s);
    if (p === void 0) {
      const d = new Set(c.flatMap((f) => [...e[f].columns]));
      p = kl(d, n), o.set(s, p);
    }
    l += p;
  }
  return l;
}, Bz = (e, t = !1, n = !1) => {
  const a = m(() => Ne(e.state)), o = m(() => Ne(e.surface)), l = m(() => Ne(t) !== !1), r = m(() => {
    const z = Ne(t);
    return typeof z == "object" ? z : {};
  }), c = m(() => l.value && Ne(n) !== !1), s = m(() => new Map(o.value.rowKeys.map((z, D) => [z, D]))), p = m(() => new Map(o.value.columnKeys.map((z, D) => [z, D]))), d = m(() => o.value.visualColumnKeys ?? o.value.columnKeys), f = m(() => new Map(d.value.map((z, D) => [z, D]))), h = m(() => a.value.ranges), $ = m(() => a.value.copiedRanges), y = m(() => wi(h.value)), w = m(() => wi($.value)), v = (z) => bl(y.value, z), x = (z) => s.value.has(z.rowKey) && p.value.has(z.columnKey), b = (z, D) => {
    const P = a.value.anchor;
    return D && P && x(P) ? P : z;
  }, k = (z) => !!(z.additive && r.value.multiple !== !1), _ = (z, D) => {
    if (D.extend) {
      const P = a.value.ranges.at(-1), Z = a.value.anchor;
      return [...P && Z && Ou(P, Z) ? a.value.ranges.slice(0, -1) : a.value.ranges, z];
    }
    return k(D) ? [...a.value.ranges, z] : [z];
  }, T = (z, D = {}) => {
    if (!l.value || !x(z))
      return;
    const P = b(z, D.extend), Z = yi(o.value, P, z), re = k(D) && D.toggle && !D.extend && v(z) ? a.value.ranges.flatMap((U) => GS(U, z)) : _(Z, D);
    e.onChange({ anchor: P, focus: z, ranges: re, copiedRanges: [] });
  }, S = (z, D) => D === "row" ? { rowKey: z, columnKey: o.value.columnKeys[0] ?? "" } : { rowKey: o.value.rowKeys[0] ?? "", columnKey: z }, M = (z, D, P) => ({
    rowKeys: P === "row" ? z.rowKeys.filter((Z) => Z !== D.rowKey) : z.rowKeys,
    columnKeys: P === "column" ? z.columnKeys.filter((Z) => Z !== D.columnKey) : z.columnKeys
  }), E = (z, D, P, Z) => {
    const J = z.rowKeys.every(
      (re) => z.columnKeys.every((U) => v({ rowKey: re, columnKey: U }))
    );
    return k(Z) && Z.toggle && !Z.extend && J ? a.value.ranges.map((re) => M(re, D, P)).filter((re) => re.rowKeys.length && re.columnKeys.length) : _(z, Z);
  }, F = (z, D, P) => {
    const Z = D === "row" ? r.value.rows : r.value.columns;
    if (!l.value || Z === !1)
      return;
    const J = S(z, D);
    if (!x(J))
      return;
    const re = b(J, P.extend), U = yi(o.value, re, J), ge = D === "row" ? { rowKeys: U.rowKeys, columnKeys: o.value.columnKeys } : { rowKeys: o.value.rowKeys, columnKeys: U.columnKeys }, K = E(ge, J, D, P);
    e.onChange({ anchor: re, focus: J, ranges: K, copiedRanges: [] });
  }, H = () => e.onChange(ZS()), te = (z, D = !1) => {
    const P = D ? w.value : y.value;
    if (!bl(P, z))
      return "";
    const Z = o.value, J = s.value.get(z.rowKey) ?? -1, re = f.value.get(z.columnKey) ?? -1, U = (ge, K) => bl(P, { rowKey: Z.rowKeys[ge] ?? "", columnKey: d.value[K] ?? "" });
    return [
      !U(J - 1, re) && "top",
      !U(J + 1, re) && "bottom",
      !U(J, re - 1) && "left",
      !U(J, re + 1) && "right"
    ].filter(Boolean).join(" ");
  }, ie = (z) => o.value.columnKeys.filter((D) => v({ rowKey: z, columnKey: D })), ee = m(() => QS(y.value, s.value, p.value));
  return {
    state: a,
    surface: o,
    enabled: l,
    options: r,
    clipboardEnabled: c,
    count: ee,
    select: T,
    isSelected: v,
    hasCell: x,
    cellEdges: te,
    serialize: () => {
      if (!c.value)
        return { ok: !1, reason: "disabled" };
      const z = o.value.rowKeys.filter((U) => ie(U).length), D = z[0];
      if (D === void 0)
        return { ok: !1, reason: "empty" };
      const P = ie(D);
      if (z.some((U) => JSON.stringify(ie(U)) !== JSON.stringify(P)))
        return { ok: !1, reason: "disjoint" };
      const Z = Ne(n), J = typeof Z == "object" ? Z : {}, re = z.map(
        (U) => P.map((ge) => o.value.getText({ rowKey: U, columnKey: ge }, J.valueMode ?? "display"))
      );
      return J.includeHeaders && re.unshift(P.map((U) => o.value.getColumnLabel?.(U) ?? U)), { ok: !0, text: XS(re) };
    },
    clear: H,
    selectRow: (z, D = {}) => F(z, "row", D),
    selectColumn: (z, D = {}) => F(z, "column", D),
    selectAll: () => {
      const z = o.value;
      if (!l.value || !z.rowKeys.length || !z.columnKeys.length)
        return;
      const D = { rowKey: z.rowKeys[0], columnKey: z.columnKeys[0] };
      e.onChange({
        anchor: D,
        focus: D,
        ranges: [{ rowKeys: z.rowKeys, columnKeys: z.columnKeys }],
        copiedRanges: []
      });
    },
    clearCopied: () => e.onChange({ ...a.value, copiedRanges: [] }),
    markCopied: () => e.onChange({ ...a.value, copiedRanges: a.value.ranges })
  };
};
export {
  XT as AdIcon,
  DT as AdSpotBlockIcon,
  MT as AdSpotIcon,
  qn as Alert,
  L1 as AlertAction,
  x1 as AlertDescription,
  Mi as AlertTitle,
  aM as AlphabetIndex,
  Xt as Anchor,
  Qt as AnchorContent,
  Jt as AnchorTrigger,
  T0 as AreaChartIcon,
  TT as ArrowDownIcon,
  u4 as ArrowLeftIcon,
  BT as ArrowRightIcon,
  Sy as ArrowUpIcon,
  zT as AsteriscIcon,
  J1 as Avatar,
  q1 as AvatarImage,
  Aa as BREAKPOINTS,
  B8 as BUILTIN_SMART_LAYOUT_NODE_REGISTRY,
  Rt as Badge,
  ep as BadgePrefix,
  tp as BadgeSuffix,
  nM as BadgeText,
  Ol as BailOutError,
  pc as BarChartIcon,
  AT as BellIcon,
  LT as BoxIcon,
  oM as Breadcrumbs,
  ET as BrowserIcon,
  IT as BulsyeyIcon,
  Ae as Button,
  So as ButtonMenu,
  Pa as ButtonPrefix,
  w1 as ButtonSpinner,
  b1 as ButtonSuffix,
  $a as ButtonText,
  ur as CalendarIcon,
  RT as CalendarTimeIcon,
  PT as CampaignIcon,
  s0 as Card,
  i0 as CardBody,
  pM as CardDescription,
  c0 as CardEmpty,
  u0 as CardFooter,
  fM as CardGrid,
  f0 as CardHeader,
  h0 as CardHeaderActions,
  hM as CardHeaderContent,
  ms as CardHeaderIcon,
  vM as CardHeaderSecondary,
  m0 as CardLoader,
  mM as CardSeparator,
  b0 as CardTitle,
  gM as CenteredContent,
  yM as ChartCard,
  wM as ChartColorSwatches,
  bM as ChartKeyEventsOverlay,
  kM as ChartLegend,
  _M as ChartLegendItem,
  CM as ChartSeriesEditorLayout,
  Z0 as ChartViewSelector,
  Bu as CheckCircleIcon,
  eo as CheckIcon,
  ln as Checkbox,
  en as ChevronDownIcon,
  Sn as ChevronDownSmall,
  Oo as ChevronLeftIcon,
  Ka as ChevronRightIcon,
  Tl as ChevronUpIcon,
  Ht as Chip,
  xM as ChipList,
  yp as ChipPrefix,
  wp as ChipSuffix,
  lM as ChipText,
  $M as ChipWrap,
  OT as CircleCheckIcon,
  VT as CircleCrossIcon,
  HT as CircleQuestionIcon,
  NT as ClickIcon,
  FT as ClockIcon,
  zt as CloseIcon,
  KT as CodeIcon,
  YT as CogIcon,
  m6 as CopyIcon,
  jT as CourtIcon,
  oB as CreativeIcon,
  WT as CursorIcon,
  js as DEFAULT_LAYOUT_PRESETS,
  kz as DEFAULT_LEAF_EXCLUDE_COLOR,
  bz as DEFAULT_LEAF_INCLUDE_COLOR,
  wz as DEFAULT_ROOT_EXCLUDE_COLOR,
  yz as DEFAULT_ROOT_INCLUDE_COLOR,
  TM as DataTable,
  SM as DataTableActions,
  By as DataTableHeaderLabel,
  MM as DataTableHeaderMenu,
  _y as DataTableSelection,
  DM as DataTableSummaryRow,
  Ri as DateActions,
  Sl as DateCalendar,
  yv as DateCalendarCell,
  nc as DateDropdown,
  Dl as DateField,
  BM as DatePicker,
  wm as DatePresets,
  sM as DateRangePicker,
  iM as DateSinglePicker,
  Vm as DateSummary,
  zl as DateTimeSpinner,
  cM as DateTrigger,
  uM as DateZone,
  UT as DesktopPcIcon,
  qT as DevicesIcon,
  Yc as Dialog,
  C5 as DialogBody,
  x5 as DialogClose,
  D5 as DialogControls,
  T5 as DialogDescription,
  O5 as DialogExpand,
  F5 as DialogFooter,
  zM as DialogFooterActions,
  AM as DialogFooterInfo,
  Z5 as DialogHeader,
  G5 as DialogLoader,
  RM as DialogProvider,
  a6 as DialogResizeHandle,
  n6 as DialogTitle,
  vr as Divider,
  ZT as DocumentIcon,
  GT as DocumentTextIcon,
  QT as DownloadIcon,
  Jl as DragHandleIcon,
  Li as DropdownMenu,
  Ei as DropdownMenuDivider,
  hp as DropdownMenuHeader,
  Lp as DropdownMenuIcon,
  Oa as DropdownMenuItem,
  E6 as DropdownMenuPrefix,
  UM as DropdownMenuSuffix,
  PM as EditRowDialogFooter,
  eD as EditableCell,
  ZM as EditableCellAffix,
  GM as EditableCellBadge,
  HM as EditableCellBulkCopyButton,
  XM as EditableCellDivider,
  NM as EditableCellInput,
  FM as EditableCellLeft,
  KM as EditableCellMultiSelect,
  YM as EditableCellPopover,
  jM as EditableCellPopoverTrigger,
  QM as EditableCellPrimary,
  WM as EditableCellRight,
  JM as EditableCellSecondary,
  qM as EditableCellSelect,
  tu as EditableCellSide,
  tD as EditableHeading,
  oD as EditableLayout,
  lD as EditableLayoutPresets,
  JT as EqualIcon,
  L7 as ErrorCircleIcon,
  eB as ExclamationIcon,
  zu as ExplanationCircleIcon,
  IC as ExplanationIcon,
  tB as EyeIcon,
  Zn as FieldLabel,
  aB as FilterIcon,
  nB as FlagIcon,
  lB as GeolocationIcon,
  rB as GitPullRequestIcon,
  sB as GraphIcon,
  iB as GreaterThanIcon,
  cB as GreaterThanOrEqualIcon,
  uB as HamburgerIcon,
  dB as HammerIcon,
  pB as HashtagIcon,
  $n as Heading,
  sc as HintContent,
  fB as HomeIcon,
  Mn as HorizontalLoader,
  pr as HoverCard,
  fr as HoverCardContent,
  hr as HoverCardTrigger,
  hB as ImageSquaredIcon,
  sD as IncludeExcludeSwitch,
  Bl as InfoBadge,
  tn as Input,
  ds as InputGroup,
  rM as InputGroupError,
  ps as InputGroupLabel,
  zo as InputPrefix,
  Pl as InputSpinner,
  da as InputSuffix,
  vB as InterfaceIcon,
  Nn as LabelBadgeChip,
  mB as LanguageIcon,
  yB as LayoutFocusIcon,
  iD as LayoutGrid,
  gB as LayoutIcon,
  cD as LayoutItem,
  wB as LayoutStackIcon,
  bB as LessThanIcon,
  kB as LessThanOrEqualIcon,
  fc as LineChartIcon,
  _B as LinkIcon,
  uD as List,
  dD as ListDivider,
  Co as ListEmpty,
  pD as ListGroup,
  fD as ListHeader,
  hD as ListItem,
  vD as ListItemCheckbox,
  mD as ListItemIcon,
  gD as ListItemRight,
  yD as ListItemText,
  kD as ListItemTree,
  _D as ListLoader,
  Yr as LockIcon,
  CB as LockOpenIcon,
  xB as MarketplaceIcon,
  cT as MenuAction,
  $B as MenuBarsIcon,
  CD as MenuChipItem,
  uT as MenuDivider,
  dT as MenuEnd,
  Ws as MenuIcon,
  pT as MenuItem,
  fT as MenuLabel,
  jw as MenuSubItem,
  SB as MessageTextIcon,
  MB as MoonIcon,
  Vb as MoreVerticalIcon,
  xD as NavigationBrand,
  $D as NavigationDrawer,
  DB as NoEntryIcon,
  TB as NotEqualIcon,
  BB as OsIcon,
  SD as PageContent,
  MD as PageContentAlerts,
  DD as PageContentBody,
  TD as PageContentHeader,
  BD as PageHeader,
  zD as PageHeaderLeft,
  AD as PageHeaderRight,
  LD as PageShell,
  ED as PageShellContent,
  ID as PageShellHeader,
  RD as PageShellHeaderLeft,
  PD as PageShellHeaderRight,
  OD as PageShellPanel,
  ob as PageShellSidebar,
  Bk as Pagination,
  zB as PauseIcon,
  IB as PenToolIcon,
  AB as PencilIcon,
  LB as PencilRulerIcon,
  EB as PendingCircleIcon,
  RB as PercentIcon,
  ND as PickerActions,
  FD as PickerAnchor,
  KD as PickerBody,
  YD as PickerDialog,
  jD as PickerFooter,
  WD as PickerLoader,
  UD as PickerPagination,
  qD as PickerSidebar,
  Qw as PinIcon,
  ab as PinOffIcon,
  ZD as PixelAvatar,
  PB as PlayIcon,
  qb as PlusIcon,
  GD as Popover,
  Lm as QuestionIcon,
  XD as RadioGroup,
  OB as ReloadRoundIcon,
  VB as ResponseIcon,
  VD as ResponsiveHeaderActions,
  HD as ResponsiveHeaderItem,
  HB as RtbAddIcon,
  FB as SaveCrossedIcon,
  NB as SaveIcon,
  rc as Scroller,
  KB as SearchIcon,
  Hr as Select,
  L5 as ShrinkIcon,
  hT as SideMenu,
  Us as SideMenuNew,
  QD as Sidebar,
  JD as SidebarBack,
  eT as SidebarBody,
  tT as SidebarClose,
  aT as SidebarControls,
  nT as SidebarDescription,
  oT as SidebarFooter,
  lT as SidebarHeader,
  rT as SidebarLoader,
  sT as SidebarMenu,
  iT as SidebarTitle,
  Xl as Skeleton,
  vT as SkeletonGrid,
  xz as SmartAlert,
  vz as SmartCellEditable,
  mz as SmartCellObject,
  gz as SmartCellSelect,
  Sz as SmartFormActions,
  Dz as SmartFormErrorsBanner,
  i8 as SmartLayout,
  mT as SmartLayoutAlerts,
  Uo as SmartLayoutBarZones,
  ni as SmartLayoutBody,
  b8 as SmartLayoutBottomBar,
  k8 as SmartLayoutFooter,
  S8 as SmartLayoutHeader,
  _8 as SmartLayoutHeaderIcon,
  C8 as SmartLayoutHeaderTitle,
  M8 as SmartLayoutLoader,
  gl as SmartLayoutNodeRenderer,
  F8 as SmartLayoutResizer,
  gT as SmartLayoutSchemaRenderer,
  xu as SmartLayoutSectionPart,
  K8 as SmartLayoutToolbar,
  hc as SmoothLineChartIcon,
  T8 as Spacer,
  cu as SpanFullIcon,
  uu as SpanHalfIcon,
  du as SpanQuarterIcon,
  pu as SpanThirdIcon,
  Io as SpinningLoader,
  YB as SspFeedIcon,
  WB as StarFilledIcon,
  jB as StarIcon,
  UB as StatisticsIcon,
  yT as StatusChanger,
  qB as StopIcon,
  P5 as StretchIcon,
  ZB as SubTableBottomIcon,
  GB as SubTableTopIcon,
  XB as SunIcon,
  $o as Switch,
  _z as TabGroup,
  QB as TableConfigIcon,
  kT as TableGridProvider,
  _T as TagsInput,
  JB as TargetIcon,
  at as Text,
  CT as Textarea,
  K7 as Toast,
  xT as ToastContainer,
  $T as Toolbar,
  Ro as Tooltip,
  U0 as TrashIcon,
  I4 as TreeBottom,
  Vl as TreeConnector,
  bD as TreePadding,
  V4 as TreeTop,
  eM as UI_MESSAGES,
  ez as UploadIcon,
  tz as UserIcon,
  az as UsersIcon,
  nz as VideoFilmIcon,
  Au as WarningIcon,
  ST as WeekScheduler,
  oz as WindowIcon,
  lz as ZapIcon,
  Ys as applyLayoutPreset,
  gS as buildBulkDeleteConfirmFn,
  Ru as buildBulkDialogFn,
  VM as buildSubmitDialogFn,
  LM as createToastProvider,
  fp as dropdownMenuHeaderVariants,
  Ii as dropdownMenuItemVariants,
  X6 as editableCellVariants,
  ZS as emptyTableRangeState,
  Kr as findCellElement,
  wT as findFirstCell,
  Y1 as getInitials,
  j1 as getNameColor,
  bT as getTableRangeCellAttrs,
  Fs as moveItem,
  EM as provideToast,
  aD as removeItem,
  Ks as resizeItem,
  _w as resolveItems,
  kw as scaleItems,
  fu as scaleSpan,
  Gc as serializeRowToTSV,
  Os as serializeRowsToTSV,
  tM as setUiTextHost,
  $w as spanClasses,
  Cw as syncItems,
  nD as toggleBreak,
  $z as useAlert,
  L6 as useAnchorTeleport,
  qw as useBreakpoints,
  pz as useBulkDeleteConfirm,
  dz as useBulkDialog,
  rz as useColumnOrder,
  ay as useColumnResize,
  sz as useColumnWidths,
  IM as useConfirm,
  oy as useDataTableSelection,
  dv as useDateCalendarGrid,
  vv as useDateCalendarNav,
  Im as useDateCalendarRange,
  Zv as useDateFieldInput,
  dM as useDateFieldOutput,
  Yo as useDialog,
  oo as useDialogContext,
  Cz as useDirtyGuard,
  lo as useEditableCellContext,
  K6 as useEditableCellState,
  rD as useEditableLayoutState,
  Zl as useFocusReturn,
  Gl as useFocusTrap,
  Mz as useFormActions,
  Tz as useFormErrorsBanner,
  fz as useKeyboardToggle,
  d6 as useLoadableDialog,
  W1 as useNameInitials,
  wu as usePicker,
  yu as usePickerContext,
  iz as useReorderDrag,
  _6 as useRequiredTableGridContext,
  cz as useSectionVisibility,
  Wo as useSidebarContext,
  OM as useSubmitDialog,
  Ar as useTableGridClipboard,
  Lr as useTableGridContext,
  Bz as useTableRangeSelection,
  r6 as useToast,
  wD as useTreeSelection,
  Le as useUiText,
  hz as useVirtualScroll,
  uz as vResizable
};
//# sourceMappingURL=hp-ui.es.js.map
